import { SvgIcon, makeStyles, Collapse, Fade, Typography as Typography$1, Divider, Grid as Grid$1, withStyles as withStyles$1, Card as Card$1, CardContent as CardContent$1, CircularProgress, Button as Button$1, fade, Box, CardMedia as CardMedia$1, CardActions, Menu as Menu$1, MenuItem as MenuItem$1, Paper, List, ListItemText, alpha, IconButton as IconButton$1, Avatar, Drawer, ListItem, Modal as Modal$1, AppBar, Toolbar, Popover as Popover$1, ButtonGroup, Slide, isWidthUp, withWidth, createTheme, ThemeProvider, Link as Link$1 } from '@material-ui/core';
import * as React from 'react';
import React__default, { useContext, createContext, useEffect, useMemo, useState, useRef, useImperativeHandle, Fragment as Fragment$1 } from 'react';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Grid from '@material-ui/core/Grid';
import LinearProgress from '@material-ui/core/LinearProgress';
import Typography from '@material-ui/core/Typography';
import { makeStyles as makeStyles$1, withStyles, createStyles, alpha as alpha$1, useTheme } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogActions from '@material-ui/core/DialogActions';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import { Link, useLocation, Route, Switch, Redirect, withRouter, BrowserRouter } from 'react-router-dom';
import Popover from '@material-ui/core/Popover';
import Modal from '@material-ui/core/Modal';
import useSWR, { useSWRConfig } from 'swr';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { ToastContainer, toast } from 'material-react-toastify';
import { useControlled, createSvgIcon, capitalize } from '@material-ui/core/utils';
import ButtonBase from '@material-ui/core/ButtonBase';

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$1 = "/****** import \"../../node_modules/react-grid-layout/css/styles.css\"; ******/\r\n.react-grid-layout {\r\n  position: relative;\r\n  transition: height 200ms ease;\r\n}\r\n\r\n.react-grid-item {\r\n  transition: all 200ms ease;\r\n  transition-property: left, top;\r\n}\r\n\r\n.react-grid-item img {\r\n  pointer-events: none;\r\n  user-select: none;\r\n}\r\n\r\n.react-grid-item.cssTransforms {\r\n  transition-property: transform;\r\n}\r\n\r\n.react-grid-item.resizing {\r\n  z-index: 1;\r\n  will-change: width, height;\r\n}\r\n\r\n.react-grid-item.react-draggable-dragging {\r\n  transition: none;\r\n  z-index: 3;\r\n  will-change: transform;\r\n}\r\n\r\n.react-grid-item.dropping {\r\n  visibility: hidden;\r\n}\r\n\r\n.react-grid-item.react-grid-placeholder {\r\n  background: red;\r\n  opacity: 0.2;\r\n  transition-duration: 100ms;\r\n  z-index: 2;\r\n  -webkit-user-select: none;\r\n  -moz-user-select: none;\r\n  -ms-user-select: none;\r\n  -o-user-select: none;\r\n  user-select: none;\r\n}\r\n\r\n.react-grid-item>.react-resizable-handle {\r\n  position: absolute;\r\n  width: 20px;\r\n  height: 20px;\r\n}\r\n\r\n.react-grid-item>.react-resizable-handle::after {\r\n  content: \"\";\r\n  position: absolute;\r\n  right: 3px;\r\n  bottom: 3px;\r\n  width: 5px;\r\n  height: 5px;\r\n  border-right: 2px solid rgba(0, 0, 0, 0.4);\r\n  border-bottom: 2px solid rgba(0, 0, 0, 0.4);\r\n}\r\n\r\n.react-resizable-hide>.react-resizable-handle {\r\n  display: none;\r\n}\r\n\r\n.react-grid-item>.react-resizable-handle.react-resizable-handle-sw {\r\n  bottom: 0;\r\n  left: 0;\r\n  cursor: sw-resize;\r\n  transform: rotate(90deg);\r\n}\r\n\r\n.react-grid-item>.react-resizable-handle.react-resizable-handle-se {\r\n  bottom: 0;\r\n  right: 0;\r\n  cursor: se-resize;\r\n}\r\n\r\n.react-grid-item>.react-resizable-handle.react-resizable-handle-nw {\r\n  top: 0;\r\n  left: 0;\r\n  cursor: nw-resize;\r\n  transform: rotate(180deg);\r\n}\r\n\r\n.react-grid-item>.react-resizable-handle.react-resizable-handle-ne {\r\n  top: 0;\r\n  right: 0;\r\n  cursor: ne-resize;\r\n  transform: rotate(270deg);\r\n}\r\n\r\n.react-grid-item>.react-resizable-handle.react-resizable-handle-w,\r\n.react-grid-item>.react-resizable-handle.react-resizable-handle-e {\r\n  top: 50%;\r\n  margin-top: -10px;\r\n  cursor: ew-resize;\r\n}\r\n\r\n.react-grid-item>.react-resizable-handle.react-resizable-handle-w {\r\n  left: 0;\r\n  transform: rotate(135deg);\r\n}\r\n\r\n.react-grid-item>.react-resizable-handle.react-resizable-handle-e {\r\n  right: 0;\r\n  transform: rotate(315deg);\r\n}\r\n\r\n.react-grid-item>.react-resizable-handle.react-resizable-handle-n,\r\n.react-grid-item>.react-resizable-handle.react-resizable-handle-s {\r\n  left: 50%;\r\n  margin-left: -10px;\r\n  cursor: ns-resize;\r\n}\r\n\r\n.react-grid-item>.react-resizable-handle.react-resizable-handle-n {\r\n  top: 0;\r\n  transform: rotate(225deg);\r\n}\r\n\r\n.react-grid-item>.react-resizable-handle.react-resizable-handle-s {\r\n  bottom: 0;\r\n  transform: rotate(45deg);\r\n}\r\n\r\n/****** import \"../../node_modules/react-resizable/css/styles.css\"; ******/\r\n\r\n.react-resizable {\r\n  position: relative;\r\n}\r\n\r\n.react-resizable-handle {\r\n  position: absolute;\r\n  width: 20px;\r\n  height: 20px;\r\n  background-repeat: no-repeat;\r\n  background-origin: content-box;\r\n  box-sizing: border-box;\r\n  background-image: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2IDYiIHN0eWxlPSJiYWNrZ3JvdW5kLWNvbG9yOiNmZmZmZmYwMCIgeD0iMHB4IiB5PSIwcHgiIHdpZHRoPSI2cHgiIGhlaWdodD0iNnB4Ij48ZyBvcGFjaXR5PSIwLjMwMiI+PHBhdGggZD0iTSA2IDYgTCAwIDYgTCAwIDQuMiBMIDQgNC4yIEwgNC4yIDQuMiBMIDQuMiAwIEwgNiAwIEwgNiA2IEwgNiA2IFoiIGZpbGw9IiMwMDAwMDAiLz48L2c+PC9zdmc+');\r\n  background-position: bottom right;\r\n  padding: 0 3px 3px 0;\r\n}\r\n\r\n.react-resizable-handle-sw {\r\n  bottom: 0;\r\n  left: 0;\r\n  cursor: sw-resize;\r\n  transform: rotate(90deg);\r\n}\r\n\r\n.react-resizable-handle-se {\r\n  bottom: 0;\r\n  right: 0;\r\n  cursor: se-resize;\r\n}\r\n\r\n.react-resizable-handle-nw {\r\n  top: 0;\r\n  left: 0;\r\n  cursor: nw-resize;\r\n  transform: rotate(180deg);\r\n}\r\n\r\n.react-resizable-handle-ne {\r\n  top: 0;\r\n  right: 0;\r\n  cursor: ne-resize;\r\n  transform: rotate(270deg);\r\n}\r\n\r\n.react-resizable-handle-w,\r\n.react-resizable-handle-e {\r\n  top: 50%;\r\n  margin-top: -10px;\r\n  cursor: ew-resize;\r\n}\r\n\r\n.react-resizable-handle-w {\r\n  left: 0;\r\n  transform: rotate(135deg);\r\n}\r\n\r\n.react-resizable-handle-e {\r\n  right: 0;\r\n  transform: rotate(315deg);\r\n}\r\n\r\n.react-resizable-handle-n,\r\n.react-resizable-handle-s {\r\n  left: 50%;\r\n  margin-left: -10px;\r\n  cursor: ns-resize;\r\n}\r\n\r\n.react-resizable-handle-n {\r\n  top: 0;\r\n  transform: rotate(225deg);\r\n}\r\n\r\n.react-resizable-handle-s {\r\n  bottom: 0;\r\n  transform: rotate(45deg);\r\n}\r\n\r\n/*************************************************************************/\r\n\r\nhtml {\r\n  overscroll-behavior-y: contain;\r\n}\r\n\r\nbody {\r\n  margin: 0;\r\n  font-family: Catalana-sans, Arial, sans-serif !important;\r\n  -webkit-font-smoothing: antialiased;\r\n  -moz-osx-font-smoothing: grayscale;\r\n  background-color: #f0f0f0;\r\n}\r\n\r\ncode {\r\n  font-family: source-code-pro, Menlo, Monaco, Consolas, \"Courier New\",\r\n    monospace;\r\n}\r\n\r\na {\r\n  text-decoration: none;\r\n  color: #505050;\r\n}\r\n\r\n/* width */\r\n::-webkit-scrollbar {\r\n  width: 3px;\r\n}\r\n\r\n/* Track */\r\n::-webkit-scrollbar-track {\r\n  background: #f1f1f1;\r\n}\r\n\r\n/* Handle */\r\n::-webkit-scrollbar-thumb {\r\n  background: #888;\r\n}\r\n\r\n/* Handle on hover */\r\n::-webkit-scrollbar-thumb:hover {\r\n  background: #555;\r\n}\r\n\r\n.site-layout-content-iframe {\r\n  min-height: calc(100vh - 52px);\r\n  display: block;\r\n  background-color: #ffffff;\r\n}";
styleInject(css_248z$1);

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics$2 = function(d, b) {
    extendStatics$2 = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics$2(d, b);
};

function __extends$2(d, b) {
    extendStatics$2(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign$2 = function() {
    __assign$2 = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign$2.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter$2(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator$2(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function IconBuscar(props) {
    return (React__default.createElement(SvgIcon, __assign$2({}, props, { viewBox: "0 0 1024 1024" }),
        React__default.createElement("g", { transform: "scale(0.75 0.75)" },
            React__default.createElement("path", { d: "M1010.069 939.652l-275.915-275.915c53.751-69.357 85.86-156.287 85.86-250.627 0-105.663-40.092-206-112.886-282.541-18.112-19.037-48.244-19.8-67.287-1.683-19.047 18.117-19.8 48.244-1.688 67.291 55.889 58.758 86.672 135.8 86.672 216.932 0 81.764-31.35 156.332-82.64 212.361-2.649 1.746-5.163 3.783-7.496 6.115-2.495 2.493-4.594 5.22-6.42 8.072-56.642 54.588-133.569 88.268-218.261 88.268-173.592 0-314.819-141.229-314.819-314.815s141.229-314.815 314.819-314.815c21.417 0 42.778 2.147 63.484 6.395 25.73 5.308 50.903-11.322 56.179-37.071s-11.322-50.903-37.077-56.183c-26.98-5.522-54.766-8.329-82.588-8.329-226.079 0-410.006 183.923-410.006 410.002s183.927 410.002 410.006 410.002c97.507 0 187.127-34.273 257.578-91.328l275.167 275.167c9.296 9.296 21.473 13.943 33.654 13.943s24.358-4.648 33.654-13.943c18.588-18.582 18.588-48.718 0-67.3z" }))));
}
function IconAlertas(props) {
    return (React__default.createElement(SvgIcon, __assign$2({}, props, { viewBox: "0 0 1024 1024" }),
        React__default.createElement("g", { transform: "scale(1 1)" },
            React__default.createElement("path", { d: "M238.519 622.981c-0.001 0-0.004 0-0.005 0-19.191 0-34.761-15.506-34.863-34.673-0.31-53.396-0.619-106.783 1.424-160.169 5.812-165.402 141.297-297.28 307.583-297.28 100.676 0 190.060 48.34 246.21 123.076 4.984 6.574 7.643 13.901 7.643 21.85 0 19.265-15.617 34.882-34.882 34.882-11.316 0-21.374-5.389-27.747-13.74-43.906-58.746-113.175-96.313-191.22-96.313-128.693 0-233.527 102.151-237.843 229.794-2.055 52.729-1.744 105.124-1.436 157.519 0 0.057 0 0.124 0 0.191 0 19.189-15.504 34.758-34.67 34.863zM856.239 915.183h-686.776c-0.016 0-0.036 0-0.055 0-19.243 0-34.841-15.598-34.841-34.841 0-5.921 1.476-11.497 4.083-16.38l8.331-15.603c5.512-10.343 10.962-20.5 15.855-30.905 14.236-28.995 25.794-62.69 32.977-97.976 3.709-18.914 17.807-30.937 34.713-30.937 19.272 0 34.896 15.623 34.896 34.896 0 2.366-0.235 4.678-0.685 6.912-8.704 43.327-21.825 81.914-39.212 118.061l572.618-2.964c-28.111-57.587-45.050-125.146-46.258-196.535-0.562-37.882-0.562-75.288-0.5-112.697 0-29.728 0-59.394-0.248-89.122-0.063-9.042-0.495-18.023-1.301-27.003-0.092-0.951-0.145-2.055-0.145-3.172 0-19.262 15.615-34.877 34.877-34.877 18.242 0 33.213 14.006 34.747 31.85 0.938 10.968 1.495 21.807 1.557 32.645 0.31 29.852 0.248 59.765 0.248 89.679 0 37.1-0.063 74.134 0.495 111.232 1.579 76.256 23.532 147.067 60.61 207.613-0.783-1.438 2.314 4.198 2.5 4.631 2.963 5.353 4.707 11.739 4.707 18.53 0 6.56-1.628 12.741-4.5 18.159-5.481 10.495-16.13 17.886-28.578 18.795zM512.883 200.354c-0.009 0-0.020 0-0.031 0-55.326 0-100.177-44.851-100.177-100.177s44.851-100.177 100.177-100.177c55.315 0 100.159 44.833 100.177 100.145-0.072 55.294-44.858 100.102-100.136 100.209zM512.883 69.737c-0.010 0-0.021 0-0.032 0-16.812 0-30.441 13.629-30.441 30.441s13.629 30.441 30.441 30.441c16.812 0 30.441-13.629 30.441-30.441 0-0.011 0-0.022 0-0.035-0.036-16.779-13.629-30.372-30.405-30.41zM513.007 1023.999h-0.495c-0.137 0-0.302 0.001-0.466 0.001-64.423 0-118.733-43.295-135.424-102.375-0.796-3.326-1.115-6.006-1.115-8.761 0-19.275 15.624-34.899 34.899-34.899 16.451 0 30.243 11.383 33.931 26.702 9.943 29.066 36.752 49.446 68.342 49.598h0.328c31.935-0.053 58.995-20.863 68.415-49.655 3.868-15.715 17.377-26.819 33.481-26.819 3.234 0 6.363 0.448 9.33 1.284 14.932 3.915 25.946 17.504 25.946 33.664 0 3.092-0.404 6.090-1.159 8.944-17.714 59.286-71.832 101.996-135.975 102.313z" }))));
}
function IconFlechaDerecha(props) {
    return (React__default.createElement(SvgIcon, __assign$2({}, props, { viewBox: "0 0 1024 1024" }),
        React__default.createElement("g", { transform: "scale(1 1)" },
            React__default.createElement("path", { d: "M292.522 1023.999c-40.428-0.013-73.193-32.789-73.193-73.219 0-20.213 8.191-38.514 21.433-51.763l387.099-387.17-387.099-387.159c-13.086-13.218-21.167-31.41-21.167-51.488 0-40.428 32.773-73.201 73.201-73.201 20.077 0 38.269 8.084 51.495 21.175l438.92 438.92c13.257 13.242 21.459 31.543 21.459 51.761s-8.201 38.519-21.459 51.761l-438.925 438.925c-13.198 13.255-31.46 21.459-51.638 21.459-0.044 0-0.086 0-0.13 0z" }))));
}
function IconMenu(props) {
    return (React__default.createElement(SvgIcon, __assign$2({}, props, { viewBox: "0 0 1024 1024" }),
        React__default.createElement("g", { transform: "scale(1 1)" },
            React__default.createElement("path", { d: "M980.761 200.611h-937.521c-23.878 0-43.239 19.36-43.239 43.239s19.36 43.239 43.239 43.239h937.523c23.878 0 43.239-19.36 43.239-43.239s-19.365-43.239-43.24-43.239zM980.761 468.761h-937.521c-23.878 0-43.239 19.36-43.239 43.239s19.36 43.239 43.239 43.239h937.523c23.878 0 43.239-19.36 43.239-43.239s-19.365-43.239-43.24-43.239zM980.761 736.908h-937.521c-23.878 0-43.239 19.36-43.239 43.239s19.36 43.239 43.239 43.239h937.523c23.878 0 43.239-19.36 43.239-43.239s-19.365-43.239-43.24-43.239z" }))));
}
function IconActualizar(props) {
    return (React__default.createElement(SvgIcon, __assign$2({}, props, { viewBox: "0 0 1024 1024" }),
        React__default.createElement("g", { transform: "scale(1 1)" },
            React__default.createElement("path", { d: "M941.409 500.889c-20.346 0.779-36.545 17.461-36.545 37.926 0 0.5 0.009 0.997 0.028 1.493 0.181 4.414 0.284 9.678 0.284 14.967 0 217.607-176.405 394.011-394.011 394.011s-394.011-176.405-394.011-394.011c0-217.607 176.405-394.011 394.011-394.011 47.652 0 93.329 8.46 135.61 23.959l-79.304 22.987c-15.585 4.956-26.679 19.299-26.679 36.235 0 20.957 16.99 37.946 37.946 37.946 0.019 0 0.038 0 0.055 0 4.036-0.003 7.93-0.619 11.593-1.759l166.68-52.007c2.457-1.113 4.563-2.347 6.525-3.768 1.701-0.8 3.229-1.695 4.681-2.692 2.426-1.927 4.64-4.183 6.54-6.689 0.862-1.077 1.966-1.671 2.673-2.753 0.488-0.759 0.519-1.633 0.947-2.408 0.803-1.003 1.601-2.128 2.334-3.299 0.429-1.492 0.717-3.126 0.895-4.794 0.879-3.221 1.376-6.734 1.376-10.362 0-1.552-0.092-3.084-0.268-4.59-0.462-3.084-1.292-6.027-2.452-8.799-0.252-1.38-0.633-2.74-1.089-4.063l-81.518-154.447c-6.541-11.974-19.044-19.961-33.413-19.961-20.957 0-37.946 16.99-37.946 37.946 0 6.376 1.573 12.386 4.352 17.662l28.434 53.899c-43.92-15.009-94.516-23.673-147.137-23.673-259.067 0-469.083 210.016-469.083 469.083s210.016 469.083 469.083 469.083c259.067 0 469.083-210.016 469.083-469.083 0-6.158-0.119-12.288-0.354-18.388-1.034-19.515-17.828-35.65-38.391-35.65-0.326 0-0.652 0.004-0.977 0.012z" }))));
}
function IconEnlaceExt(props) {
    return (React__default.createElement(SvgIcon, __assign$2({}, props, { viewBox: "0 0 1024 1024" }),
        React__default.createElement("g", { transform: "scale(1 1)" },
            React__default.createElement("path", { d: "M1020.712 26.134c-2.144-4.96-5.009-9.203-8.519-12.821l0.011 0.011-0.63-0.949c-0.522-0.522-1.227-0.681-1.768-1.17-6.954-6.766-16.458-10.942-26.939-10.953h-0.002l-1.227-0.248h-213.684c-23.387 0-42.345 18.958-42.345 42.345s18.958 42.345 42.345 42.345v0h111.472l-369.606 369.639c-7.756 7.676-12.558 18.324-12.558 30.093 0 23.381 18.954 42.335 42.335 42.335 11.769 0 22.417-4.802 30.089-12.555l369.604-369.637v111.5c0 23.387 18.958 42.345 42.345 42.345s42.345-18.958 42.345-42.345v0-213.719c-0.018-5.856-1.218-11.426-3.376-16.493l0.105 0.278zM981.637 504.912c-0.002 0-0.003 0-0.006 0-23.384 0-42.339 18.955-42.339 42.339 0 0.002 0 0.005 0 0.006v0 392.054h-854.582v-854.621h375.621c23.387 0 42.345-18.958 42.345-42.345s-18.958-42.345-42.345-42.345v0h-417.968c-0.002 0-0.003 0-0.006 0-23.384 0-42.339 18.955-42.339 42.339 0 0.002 0 0.005 0 0.006v0 939.31c0 0.002 0 0.003 0 0.006 0 23.384 18.955 42.339 42.339 42.339 0.002 0 0.005 0 0.006 0h939.272c0.002 0 0.003 0 0.006 0 23.384 0 42.339-18.955 42.339-42.339 0-0.002 0-0.005 0-0.006v0-434.398c0-0.002 0-0.005 0-0.006 0-23.384-18.955-42.339-42.339-42.339-0.002 0-0.005 0-0.006 0v0z" }))));
}
function IconAvisoInfo(props) {
    return (React__default.createElement(SvgIcon, __assign$2({}, props, { viewBox: "0 0 1024 1024" }),
        React__default.createElement("g", { transform: "scale(1 1)" },
            React__default.createElement("path", { d: "M511.984 1024c-282.762-0.009-511.984-229.235-511.984-512 0-282.77 229.23-512 512-512 282.752 0 511.972 229.203 512 511.95v0.004c-0.307 282.661-229.357 511.722-511.984 512.046h-0.031zM511.984 70.507c-243.824 0.009-441.478 197.669-441.478 441.494 0 243.83 197.663 441.494 441.494 441.494s441.494-197.663 441.494-441.494c0-0.016 0-0.033 0-0.050v0.003c-0.299-243.705-197.798-441.182-441.484-441.445h-0.025zM504.031 321.726c-0.001 0-0.004 0-0.006 0-19.467 0-35.249-15.782-35.249-35.249 0-0.001 0-0.003 0-0.004v0c0-0.040 0-0.089 0-0.137 0-19.628 15.692-35.59 35.214-36.026l0.040-0.001c0.222-0.005 0.482-0.008 0.743-0.008 19.015 0 34.438 15.379 34.51 34.378v1.791c0 0.003 0 0.005 0 0.008 0 19.467-15.781 35.248-35.248 35.248-0.001 0-0.004 0-0.005 0v0zM582.114 730.893h-140.258c-19.42-0.065-35.139-15.823-35.139-35.253 0-19.407 15.682-35.152 35.065-35.253h0.010l34.752-0.064v-184.53h-11.523c-19.47 0-35.253-15.783-35.253-35.253s15.783-35.253 35.253-35.253v0h46.775c0.001 0 0.003 0 0.005 0 19.467 0 35.248 15.781 35.248 35.248 0 0.001 0 0.004 0 0.005v0 219.846h35.065c19.47 0 35.253 15.783 35.253 35.253s-15.783 35.253-35.253 35.253v0z" }))));
}
function IconExclamation(props) {
    return React__default.createElement(SvgIcon, __assign$2({}, props, { viewBox: "0 0 1024 1024" }),
        React__default.createElement("g", { transform: "scale(1 1)" },
            React__default.createElement("path", { d: "M512 784.485c26.632 0 48.226-21.593 48.226-48.226v-688.033c0-26.632-21.593-48.226-48.226-48.226s-48.226 21.593-48.226 48.226v688.031c0 26.631 21.597 48.227 48.226 48.227zM570.808 965.597c0 32.255-26.328 58.403-58.808 58.403s-58.808-26.147-58.808-58.403c0-32.255 26.328-58.403 58.808-58.403s58.808 26.147 58.808 58.403z" })));
}
function IconMensaje(props) {
    return React__default.createElement(SvgIcon, __assign$2({}, props, { viewBox: "0 0 1024 1024" }),
        React__default.createElement("g", { transform: "scale(1 1)" },
            React__default.createElement("path", { d: "M690.283 788.589h-649.145c-18.305 0-33.14-14.839-33.14-33.14v-486.897c0-18.301 14.835-33.14 33.14-33.14h163.513c18.305 0 33.14 14.839 33.14 33.14s-14.835 33.14-33.14 33.14h-130.373v420.617h616.005c18.305 0 33.14 14.839 33.14 33.14s-14.835 33.14-33.14 33.14zM1014.862 788.589h-160.477c-18.305 0-33.14-14.839-33.14-33.14s14.835-33.14 33.14-33.14h127.337v-420.617h-618.355c-18.305 0-33.14-14.839-33.14-33.14s14.835-33.14 33.14-33.14h651.495c18.305 0 33.14 14.839 33.14 33.14v486.897c0 18.301-14.835 33.14-33.14 33.14zM527.994 589.781c-5.217 0-10.44-1.234-15.211-3.696l-324.566-167.632c-16.259-8.399-22.635-28.389-14.233-44.652 8.395-16.262 28.376-22.628 44.655-14.237l309.452 159.83 309.427-157.746c16.298-8.304 36.266-1.829 44.571 14.473 8.317 16.309 1.838 36.263-14.473 44.577l-324.573 165.468c-4.725 2.412-9.89 3.614-15.049 3.614zM231.435 678.135c-8.544 0-17.081-3.282-23.567-9.838-12.868-13.014-12.751-33.997 0.265-46.865l148.419-146.759c13.010-12.87 33.988-12.758 46.869 0.261 12.868 13.014 12.751 33.997-0.265 46.865l-148.419 146.759c-6.46 6.389-14.881 9.577-23.302 9.577zM834.462 678.135c-8 0-16.026-2.876-22.389-8.708l-160.108-146.759c-13.489-12.369-14.402-33.332-2.032-46.823 12.363-13.492 33.334-14.406 46.823-2.039l160.108 146.759c13.489 12.369 14.402 33.332 2.032 46.823-6.531 7.129-15.47 10.747-24.434 10.747z" })));
}
function IconCerrar(props) {
    return React__default.createElement(SvgIcon, __assign$2({}, props, { viewBox: "0 0 1024 1024" }),
        React__default.createElement("g", { transform: "scale(1 1)" },
            React__default.createElement("path", { d: "M13.949 1010.1c9.265 9.274 21.419 13.905 33.567 13.905s24.302-4.637 33.575-13.905l430.909-430.948 430.909 430.945c9.274 9.269 21.419 13.905 33.575 13.905 12.148 0 24.302-4.637 33.567-13.905 18.545-18.537 18.545-48.6 0.008-67.142l-430.919-430.95 430.915-430.952c18.537-18.542 18.537-48.605-0.008-67.142-18.531-18.545-48.597-18.537-67.142 0l-430.905 430.945-430.909-430.945c-18.537-18.531-48.605-18.545-67.142 0-18.545 18.537-18.545 48.6-0.008 67.142l430.915 430.952-430.915 430.952c-18.537 18.544-18.537 48.605 0.008 67.144z" })));
}
function IconReloj(props) {
    return React__default.createElement(SvgIcon, __assign$2({}, props, { viewBox: "0 0 1024 1024" }),
        React__default.createElement("g", { transform: "scale(1 1)" },
            React__default.createElement("path", { d: "M887.517 838.271c-21.178-0.023-38.337-17.196-38.337-38.378 0-8.836 2.987-16.974 8.004-23.461 55.956-72.399 89.73-164.562 89.73-264.614 0-240.27-194.778-435.048-435.048-435.048-103.439 0-198.447 36.1-273.112 96.389-5.706 4.674-14.132 7.898-23.311 7.898-21.19 0-38.368-17.178-38.368-38.368 0-12.082 5.585-22.86 14.313-29.892 86.957-70.286 198.775-112.797 320.522-112.797 282.651 0 511.784 229.133 511.784 511.784 0 117.744-39.761 226.201-106.591 312.676-6.171 7.972-17.135 13.813-29.463 13.813-0.044 0-0.089 0-0.132 0zM472.849 589.088c-0.001 0-0.003 0-0.005 0-21.19 0-38.367-17.177-38.367-38.367 0-0.001 0-0.004 0-0.005v-326.915c0-21.193 17.18-38.372 38.372-38.372s38.372 17.18 38.372 38.372v326.915c0 0.001 0 0.004 0 0.005 0 21.19-17.177 38.367-38.367 38.367-0.001 0-0.004 0-0.005 0zM512.073 1023.999c-282.715-0.346-511.767-229.612-511.767-512.375 0-101.598 29.569-196.288 80.573-275.935 5.692-8.723 17.615-15.759 31.18-15.759 21.204 0 38.393 17.189 38.393 38.393 0 7.638-2.23 14.755-6.076 20.736-42.268 65.792-67.436 146.285-67.436 232.655 0 240.289 194.793 435.082 435.082 435.082 91.285 0 176.006-28.113 245.973-76.155 4.573-3.206 12.061-5.694 20.128-5.694 21.215 0 38.413 17.199 38.413 38.413 0 13.147-6.604 24.752-16.678 31.677-80.649 55.69-180.334 88.919-287.778 88.961zM791.688 589.088h-318.839c-21.193 0-38.372-17.18-38.372-38.372s17.18-38.372 38.372-38.372h318.839c21.193 0 38.372 17.18 38.372 38.372s-17.18 38.372-38.372 38.372z" })));
}
function IconEstrella(props) {
    return React__default.createElement(SvgIcon, __assign$2({}, props, { viewBox: "0 0 1024 1024" }),
        React__default.createElement("g", { transform: "scale(1 1)" },
            React__default.createElement("path", { d: "M1017.872 356.197c-6.131-13.785-19.803-22.672-34.893-22.672h-329.751c-21.089 0-38.183 17.097-38.183 38.183s17.094 38.183 38.183 38.183h243.851l-184.91 204.862c-8.477 9.396-11.751 22.379-8.74 34.672l62.838 256.551-235.504-132.865c-11.646-6.575-25.878-6.575-37.525 0l-235.503 132.862 62.803-256.407c0.004-0.021 0.009-0.044 0.009-0.044l0.025-0.1c0.563-2.297 0.874-4.592 1.008-6.871 0.007-0.128 0.028-0.251 0.035-0.382 0.114-2.321-0.004-4.615-0.306-6.868-0.021-0.168-0.031-0.335-0.056-0.503-0.327-2.232-0.867-4.409-1.575-6.522-0.080-0.242-0.144-0.484-0.229-0.723-0.761-2.132-1.72-4.18-2.838-6.138-0.117-0.202-0.214-0.414-0.335-0.616-1.269-2.128-2.74-4.139-4.401-5.987-0.017-0.019-0.028-0.044-0.045-0.063l-0.061-0.068c-0.011-0.012-0.021-0.025-0.033-0.037l-184.816-204.757h243.851c15.325 0 29.166-9.161 35.151-23.268l106.080-250.003 43.168 101.741c8.235 19.415 30.651 28.47 50.066 20.235 19.412-8.235 28.473-30.651 20.235-50.066l-78.318-184.578c-5.985-14.107-19.826-23.268-35.151-23.268s-29.166 9.161-35.151 23.268l-131.355 309.575h-304.475c-15.090 0-28.762 8.887-34.893 22.672-6.127 13.79-3.562 29.893 6.547 41.098l228.91 253.614-79.011 322.591c-3.623 14.792 1.886 30.315 14.020 39.513s28.573 10.31 41.828 2.827l293.578-165.634 293.578 165.635c5.848 3.3 12.314 4.929 18.759 4.929 8.163 0 16.289-2.616 23.069-7.756 12.134-9.198 17.643-24.722 14.020-39.513l-79.011-322.595 228.91-253.611c10.11-11.206 12.674-27.308 6.546-41.1z" })));
}
function IconEditar(props) {
    return React__default.createElement(SvgIcon, __assign$2({}, props, { viewBox: "0 0 1024 1024" }),
        React__default.createElement("g", { transform: "scale(1 1)" },
            React__default.createElement("path", { d: "M642.422 520.445c-8.231-0.002-15.929-2.288-22.493-6.257l-143.71-85.195c-12.955-7.784-21.49-21.763-21.49-37.735 0-8.245 2.274-15.958 6.229-22.549l145.353-245.080c7.76-13.036 21.778-21.635 37.805-21.635 24.216 0 43.848 19.632 43.848 43.848 0 8.323-2.319 16.104-6.346 22.734l-123.017 207.381 68.49 40.588 123.087-207.571c7.76-13.036 21.778-21.635 37.805-21.635 24.216 0 43.848 19.632 43.848 43.848 0 8.323-2.319 16.104-6.346 22.734l-145.315 245.049c-7.792 12.949-21.772 21.479-37.743 21.479-0.002 0-0.003 0-0.005 0zM787.846 275.204c-24.199-0.034-43.802-19.658-43.802-43.862 0-8.253 2.28-15.975 6.243-22.569 3.386-5.604 5.454-12.608 5.454-20.097 0-21.976-17.815-39.79-39.79-39.79-14.487 0-27.166 7.742-34.125 19.316-7.861 13.217-21.878 21.816-37.906 21.816-24.216 0-43.848-19.632-43.848-43.848 0-8.323 2.319-16.104 6.346-22.734 22.497-37.501 63.143-62.341 109.59-62.341 70.408 0 127.485 57.077 127.485 127.485 0 24.040-6.654 46.525-18.22 65.716-7.462 12.378-21.436 20.91-37.403 20.91-0.008 0-0.016 0-0.025 0zM268.724 1024c-10.16-0.011-20.089-0.96-29.72-2.763-19.691-3.622-35.17-21.51-35.17-43.013 0-24.216 19.63-43.846 43.846-43.846 2.761 0 5.464 0.255 8.083 0.744 59.074 10.309 100.401-61.644 100.83-62.383l174.999-295.168c7.76-13.036 21.778-21.635 37.805-21.635 24.216 0 43.848 19.632 43.848 43.848 0 8.323-2.319 16.104-6.346 22.734l-174.229 293.809c-33.124 59.648-93.070 100.92-163.104 107.608zM247.788 1022.054c-0.039 0-0.084 0-0.131 0-13.721 0-25.965-6.328-33.973-16.223-20.812-31.023-33.177-69.1-33.177-110.065 0-41.335 12.59-79.73 34.144-111.559l173.074-291.937c7.76-13.036 21.778-21.635 37.805-21.635 24.216 0 43.848 19.632 43.848 43.848 0 8.323-2.319 16.104-6.346 22.734l-174.229 293.767c-1.167 1.829-44.83 72.654-6.927 119.741 6.052 7.451 9.716 17.056 9.716 27.514 0 24.196-19.611 43.81-43.806 43.815zM407.611 275.671c-24.199-0.034-43.802-19.658-43.802-43.862 0-8.253 2.28-15.975 6.243-22.569l111.268-187.605c7.76-13.036 21.778-21.635 37.805-21.635 24.216 0 43.848 19.632 43.848 43.848 0 8.323-2.319 16.104-6.346 22.734l-111.268 187.608c-7.791 12.951-21.772 21.481-37.744 21.481-0.002 0-0.002 0-0.003 0z" })));
}
function IconError(props) {
    return React__default.createElement(SvgIcon, __assign$2({}, props, { viewBox: "0 0 1024 1024" }),
        React__default.createElement("g", { transform: "scale(1 1)" },
            React__default.createElement("path", { d: "M854.484 131.133c-169.608-152.527-422.704-174.198-615.479-52.672-13.453 8.482-17.486 26.26-9.005 39.714 8.476 13.459 26.266 17.492 39.714 9.005 171.093-107.836 395.713-88.595 546.26 46.778 159.136 143.101 196.791 381.084 89.545 565.872-7.987 13.757-3.307 31.378 10.45 39.359 4.55 2.643 9.522 3.898 14.426 3.898 9.933 0 19.59-5.141 24.933-14.348 120.856-208.231 78.443-476.383-100.845-637.605zM729.73 911.232c-168.894 92.121-378.559 67.532-521.71-61.187-150.311-135.165-193.337-356.247-104.624-537.621 6.991-14.291 1.074-31.536-13.212-38.521-14.291-6.991-31.536-1.080-38.521 13.212-99.962 204.378-51.497 453.475 117.853 605.755 96.205 86.514 219.086 131.273 342.979 131.273 83.786 0 168.039-20.473 244.817-62.346 13.96-7.615 19.106-25.107 11.491-39.072-7.61-13.954-25.085-19.095-39.072-11.491zM483.203 773.221c0 15.906 12.891 28.797 28.797 28.797s28.797-12.891 28.797-28.797v-0.906c0-15.906-12.891-28.797-28.797-28.797s-28.797 12.891-28.797 28.797v0.906zM512 676.386c15.906 0 28.797-12.891 28.797-28.797v-396.815c0-15.906-12.891-28.797-28.797-28.797s-28.797 12.891-28.797 28.797v396.815c0 15.906 12.891 28.797 28.797 28.797z" })));
}
function IconCaja(props) {
    return React__default.createElement(SvgIcon, __assign$2({}, props, { viewBox: "0 0 1024 1024" }),
        React__default.createElement("g", { transform: "scale(1 1)" },
            React__default.createElement("path", { d: "M990.86 259.682c-1.711-8.498-6.75-15.955-13.993-20.714l-353.986-232.547c-7.265-4.77-16.135-6.422-24.643-4.606-8.5 1.833-15.91 6.993-20.569 14.334l-66.145 104.192-52.745-96.719c-0.109-0.201-0.241-0.377-0.352-0.575-0.121-0.209-0.215-0.425-0.34-0.634-0.167-0.28-0.364-0.528-0.54-0.802-0.303-0.47-0.611-0.937-0.935-1.389-0.313-0.436-0.636-0.856-0.967-1.27-0.345-0.436-0.694-0.863-1.059-1.276-0.352-0.399-0.713-0.782-1.082-1.16-0.377-0.388-0.76-0.766-1.153-1.132-0.387-0.359-0.783-0.702-1.186-1.041-0.407-0.344-0.816-0.678-1.239-0.998-0.418-0.316-0.845-0.62-1.277-0.917-0.434-0.298-0.873-0.589-1.319-0.863-0.439-0.269-0.884-0.526-1.333-0.774-0.471-0.259-0.943-0.51-1.425-0.747-0.446-0.217-0.896-0.42-1.352-0.618-0.507-0.219-1.017-0.431-1.534-0.623-0.442-0.166-0.889-0.32-1.339-0.465-0.548-0.18-1.097-0.346-1.654-0.496-0.434-0.116-0.87-0.219-1.309-0.316-0.583-0.132-1.169-0.249-1.76-0.348-0.425-0.071-0.85-0.13-1.278-0.185-0.607-0.077-1.217-0.14-1.83-0.182-0.423-0.029-0.845-0.045-1.269-0.058-0.62-0.018-1.24-0.024-1.863-0.008-0.423 0.010-0.845 0.037-1.269 0.063-0.619 0.042-1.238 0.095-1.858 0.174-0.436 0.053-0.87 0.121-1.305 0.196-0.597 0.097-1.19 0.211-1.783 0.344-0.462 0.105-0.921 0.225-1.381 0.348-0.559 0.154-1.117 0.316-1.674 0.502-0.484 0.158-0.961 0.338-1.441 0.52-0.526 0.203-1.047 0.411-1.568 0.644-0.493 0.219-0.98 0.46-1.466 0.705-0.294 0.15-0.596 0.269-0.887 0.427-0.209 0.113-0.396 0.251-0.602 0.37-0.199 0.113-0.407 0.203-0.605 0.322l-361.927 217.981c-15.112 9.105-20.186 28.615-11.413 43.925l74.83 130.631-60.708 126.834c-7.062 14.756-2.036 32.465 11.725 41.306l52.613 33.818v159.853c0 17.92 14.529 32.449 32.449 32.449s32.449-14.529 32.449-32.449v-118.14l98.541 63.335c5.43 3.491 11.506 5.159 17.513 5.159 10.674 0 21.128-5.266 27.329-14.91 9.688-15.078 5.323-35.153-9.752-44.84l-191.967-123.385 39.704-82.947 301.947 185.952-55.988 124.927c-7.331 16.357-0.014 35.555 16.341 42.885 4.31 1.928 8.815 2.847 13.251 2.847 12.395 0 24.231-7.145 29.629-19.188l38.838-86.66 40.676 86.475c3.98 8.461 11.413 14.794 20.397 17.376 2.944 0.845 5.96 1.262 8.963 1.262 6.161 0 12.261-1.753 17.548-5.149l237.398-152.581v110.529l-325.675 194.743-228.717-146.354c-15.096-9.66-35.164-5.25-44.821 9.84-9.66 15.1-5.252 35.164 9.842 44.824l245.629 157.175c5.327 3.407 11.405 5.118 17.489 5.118 5.756 0 11.522-1.531 16.653-4.6l358.703-214.49c9.8-5.857 15.797-16.436 15.797-27.849v-170.649l54.605-35.095c13.964-8.979 18.902-27.041 11.448-41.872l-61.534-122.418 82.621-122.831c4.839-7.193 6.596-16.019 4.887-24.516zM508.135 585.114l-293.557-180.784 163.83-94.596c15.523-8.963 20.838-28.811 11.875-44.328s-28.813-20.83-44.324-11.878l-182.050 105.117-51.608-90.090 305.719-184.13 62.846 115.249c3.984 7.309 10.389 12.409 17.661 14.986l304.749 188.698-295.141 181.755zM592.595 726.090l-42.589-90.539 302.071-186.029 41.713 82.982-301.195 193.585zM856.704 360.103l-301.863-186.91 59.951-94.432 299.022 196.438-57.109 84.904z" })));
}
function IconArriba(props) {
    return React__default.createElement(SvgIcon, __assign$2({}, props, { viewBox: "0 0 1024 1024" }),
        React__default.createElement("g", { transform: "scale(1 1)" },
            React__default.createElement("path", { d: "M950.802 804.691c-0.036 0-0.081 0-0.122 0-20.179 0-38.442-8.204-51.637-21.457l-387.177-387.177-387.174 387.174c-13.219 13.086-31.411 21.168-51.489 21.168-40.429 0-73.203-32.774-73.203-73.203 0-20.078 8.084-38.27 21.176-51.497l438.931-438.931c13.242-13.258 31.544-21.459 51.762-21.459s38.52 8.201 51.762 21.459l438.936 438.936c13.242 13.25 21.433 31.549 21.433 51.762 0 40.429-32.769 73.205-73.195 73.221z" })));
}
function IconAbajo(props) {
    return React__default.createElement(SvgIcon, __assign$2({}, props, { viewBox: "0 0 1024 1024" }),
        React__default.createElement("g", { transform: "scale(1 1)" },
            React__default.createElement("path", { d: "M511.998 804.617c-0.036 0-0.081 0-0.122 0-20.185 0-38.452-8.206-51.65-21.462l-439.053-439.053c-13.090-13.222-21.173-31.419-21.173-51.502 0-40.439 32.782-73.222 73.222-73.222 20.083 0 38.28 8.086 51.51 21.181l387.269 387.269 387.275-387.275c13.222-13.090 31.419-21.173 51.502-21.173 40.439 0 73.222 32.782 73.222 73.222 0 20.083-8.086 38.28-21.181 51.51l-439.045 439.045c-13.201 13.259-31.469 21.465-51.653 21.465-0.042 0-0.086 0-0.127 0z" })));
}
function IconIzquierda(props) {
    return React__default.createElement(SvgIcon, __assign$2({}, props, { viewBox: "0 0 1024 1024" }),
        React__default.createElement("g", { transform: "scale(1 1)" },
            React__default.createElement("path", { d: "M731.471 1024c-0.036 0-0.081 0-0.122 0-20.179 0-38.441-8.204-51.636-21.456l-438.923-438.931c-13.257-13.242-21.459-31.543-21.459-51.761s8.201-38.519 21.459-51.761l438.923-438.923c13.218-13.086 31.41-21.167 51.486-21.167 40.428 0 73.201 32.773 73.201 73.201 0 20.077-8.084 38.269-21.175 51.495l-387.087 387.16 387.098 387.163c13.242 13.25 21.432 31.548 21.432 51.761 0 40.428-32.768 73.203-73.193 73.219z" })));
}
function IconDerecha(props) {
    return React__default.createElement(SvgIcon, __assign$2({}, props, { viewBox: "0 0 1024 1024" }),
        React__default.createElement("g", { transform: "scale(1 1)" },
            React__default.createElement("path", { d: "M292.522 1023.999c-40.428-0.013-73.193-32.789-73.193-73.219 0-20.213 8.191-38.514 21.433-51.763l387.099-387.17-387.099-387.159c-13.086-13.218-21.167-31.41-21.167-51.488 0-40.428 32.773-73.201 73.201-73.201 20.077 0 38.269 8.084 51.495 21.175l438.92 438.92c13.257 13.242 21.459 31.543 21.459 51.761s-8.201 38.519-21.459 51.761l-438.925 438.925c-13.198 13.255-31.46 21.459-51.638 21.459-0.044 0-0.086 0-0.13 0z" })));
}
function IconNovedad(props) {
    return React__default.createElement(SvgIcon, __assign$2({}, props, { viewBox: "0 0 200 200" }),
        React__default.createElement("g", { transform: "scale(1 1)" },
            React__default.createElement("path", { d: "M78.3,67.7a4.9,4.9,0,0,1-2.4-9.3L118,34.9a5,5,0,0,1,4.9,8.8L80.7,67.1A5.3,5.3,0,0,1,78.3,67.7Z" }),
            React__default.createElement("path", { d: "M120.5,165.7a5.4,5.4,0,0,1-2.5-.6L75.9,141.6a5,5,0,0,1-2-6.8,5,5,0,0,1,6.8-1.9l42.2,23.4a5,5,0,0,1,1.9,6.8A4.9,4.9,0,0,1,120.5,165.7Z" }),
            React__default.createElement("path", { d: "M124.1,105H75.9a5,5,0,0,1,0-10h48.2a5,5,0,0,1,0,10Z" })));
}
function IconOpciones(props) {
    return React__default.createElement(SvgIcon, __assign$2({}, props, { viewBox: "0 0 1024 1024" }),
        React__default.createElement("g", { transform: "scale(1 1)" },
            React__default.createElement("path", { d: "M613.157 101.157c0 55.868-45.289 101.157-101.157 101.157s-101.157-45.289-101.157-101.157c0-55.868 45.289-101.157 101.157-101.157s101.157 45.289 101.157 101.157zM613.16 512.001c0 55.868-45.291 101.16-101.16 101.16s-101.16-45.291-101.16-101.16c0-55.868 45.291-101.16 101.16-101.16s101.16 45.291 101.16 101.16zM613.157 922.843c0 55.868-45.289 101.157-101.157 101.157s-101.157-45.289-101.157-101.157c0-55.868 45.289-101.157 101.157-101.157s101.157 45.289 101.157 101.157z" })));
}
function IconPin(props) {
    return React__default.createElement(SvgIcon, __assign$2({}, props, { viewBox: "0 0 1024 1024" }),
        React__default.createElement("g", { transform: "scale(1 1)" },
            React__default.createElement("path", { d: "M933.558 190.844l-311.692-185.12c-5.954-3.595-13.146-5.723-20.833-5.723-13.75 0-25.909 6.805-33.297 17.228l-0.086 0.127-49.186 70.047c-4.649 6.537-7.433 14.682-7.433 23.475 0 22.53 18.264 40.795 40.795 40.795 13.764 0 25.936-6.817 33.324-17.259l0.086-0.127 27.466-39.115 246.697 146.523-163.591 330.385c-2.674 5.28-4.241 11.509-4.241 18.105 0 1.425 0.073 2.832 0.215 4.22l-0.014-0.174 19.593 196.371-509.816-302.792 181.798-76.756c7.194-3.088 13.13-7.936 17.445-14.017l0.086-0.126 97.911-139.472c4.653-6.539 7.441-14.688 7.441-23.488 0-22.532-18.266-40.798-40.798-40.798-13.772 0-25.95 6.824-33.336 17.275l-0.086 0.127-91.186 129.886-245.414 103.616c-14.774 6.352-24.93 20.782-24.93 37.583 0 14.844 7.93 27.837 19.783 34.975l0.183 0.102 224.889 133.567-107.050 319.979c-1.337 3.861-2.108 8.312-2.108 12.943 0 22.529 18.264 40.793 40.793 40.793 11.455 0 21.808-4.722 29.217-12.326l0.008-0.010 181.495-186.419 55.36-57.535 226.093 134.283c5.955 3.594 13.146 5.721 20.835 5.721 22.533 0 40.799-18.267 40.799-40.799 0-1.425-0.073-2.832-0.215-4.218l0.014 0.174-26.446-265.079 175.16-353.771c2.672-5.28 4.239-11.509 4.239-18.105 0-14.844-7.93-27.835-19.783-34.972l-0.183-0.102zM399.065 768.499l-56.756 58.294 44.788-133.883 53.9 32.012z" })));
}
function IconUnpin(props) {
    return React__default.createElement(SvgIcon, __assign$2({}, props, { viewBox: "0 0 1024 1024" }),
        React__default.createElement("g", { transform: "scale(1 1)" },
            React__default.createElement("path", { d: "M675.632 78.289c-1.433-6.674-5.504-12.199-11.044-15.534l-0.107-0.061-95.922-56.971c-5.954-3.595-13.146-5.723-20.833-5.723-13.75 0-25.909 6.805-33.297 17.228l-0.086 0.127-48.012 68.375c-5.076 6.881-8.123 15.528-8.123 24.887 0 12.413 5.361 23.573 13.891 31.292l0.037 0.032c7.066 6.035 16.309 9.707 26.409 9.707 13.751 0 25.912-6.806 33.298-17.235l0.086-0.127 27.305-38.886 0.392-0.092 120.056 64.463c1.061 0.582 2.325 0.923 3.67 0.923 4.284 0 7.758-3.472 7.758-7.758 0-0.564-0.061-1.112-0.174-1.641l0.010 0.051zM642.502 572.081c-2.674 5.28-4.241 11.509-4.241 18.105 0 1.425 0.073 2.833 0.215 4.22l-0.014-0.174 19.536 195.803c0.002 0.008 0.002 0.019 0.002 0.029 0 0.159-0.129 0.288-0.288 0.288-0.054 0-0.105-0.014-0.148-0.041h0.002l-508.834-302.209c-0.084-0.051-0.142-0.143-0.142-0.249 0-0.12 0.072-0.222 0.175-0.266h0.002l181.212-76.509c7.238-3.108 13.211-7.987 17.55-14.108l0.086-0.127 97.863-139.404c4.621-6.524 7.386-14.645 7.386-23.413 0-22.534-18.267-40.801-40.801-40.801-13.742 0-25.896 6.794-33.289 17.205l-0.084 0.126-91.13 129.818c-0.032 0.045-0.073 0.078-0.123 0.099h-0.002l-245.338 103.584c-14.774 6.352-24.93 20.782-24.93 37.584 0 14.844 7.93 27.837 19.783 34.975l0.183 0.102 224.688 133.448c0.084 0.051 0.142 0.143 0.142 0.249 0 0.033-0.005 0.064-0.016 0.094v-0.002l-106.399 318.029c-1.562 4.234-2.465 9.123-2.465 14.223 0 12.497 5.425 23.727 14.046 31.464l0.040 0.035c7.080 6.057 16.344 9.743 26.471 9.743 11.461 0 21.818-4.722 29.233-12.327l0.008-0.008 181.495-186.42 55.206-57.367c0.053-0.054 0.126-0.089 0.209-0.089 0.054 0 0.105 0.014 0.148 0.041h-0.002l225.893 134.164c5.955 3.594 13.146 5.721 20.835 5.721 22.534 0 40.799-18.267 40.799-40.799 0-1.425-0.073-2.83-0.215-4.217l0.014 0.174-26.438-264.997c-0.002-0.008-0.002-0.019-0.002-0.029 0-0.046 0.011-0.091 0.030-0.129v0.002l39.343-79.462c2.288-4.521 3.627-9.855 3.627-15.503 0-2.537-0.271-5.012-0.784-7.396l0.041 0.229-19.077-91.033c-0.915-4.257-4.647-7.399-9.112-7.399-3.637 0-6.786 2.084-8.319 5.125l-0.024 0.054zM345.757 768.501l-55.873 57.387c-0.053 0.054-0.126 0.088-0.207 0.088-0.159 0-0.288-0.129-0.288-0.288 0-0.033 0.005-0.064 0.016-0.094v0.002l44.273-132.344c0.040-0.116 0.147-0.198 0.274-0.198 0.054 0 0.105 0.014 0.148 0.041h-0.002l53.282 31.646c0.086 0.051 0.142 0.143 0.142 0.249 0 0.078-0.030 0.148-0.081 0.201v0zM1006.682 210.228c-2.413-20.44-19.636-36.143-40.527-36.143-2.969 0-5.863 0.317-8.652 0.92l0.268-0.048-110.829 23.235c-0.018 0.003-0.038 0.006-0.059 0.006-0.139 0-0.255-0.097-0.282-0.228v-0.002l-23.225-110.827c-4.010-18.652-20.36-32.428-39.928-32.428-22.53 0-40.795 18.264-40.795 40.795 0 2.963 0.316 5.852 0.916 8.634l-0.048-0.268 23.227 110.835c0.003 0.018 0.006 0.038 0.006 0.059 0 0.139-0.097 0.255-0.228 0.282h-0.002l-108.886 22.827c-19.622 3.849-34.223 20.908-34.223 41.379 0 1.74 0.105 3.455 0.311 5.141l-0.021-0.202c2.998 19.813 19.909 34.823 40.325 34.823 2.977 0 5.88-0.319 8.676-0.926l-0.269 0.049 110.821-23.233c0.018-0.003 0.038-0.006 0.059-0.006 0.139 0 0.255 0.097 0.282 0.228v0.002l23.225 110.834c3.99 18.653 20.334 32.438 39.897 32.438 3.334 0 6.575-0.4 9.678-1.155l-0.279 0.057c18.111-5.028 31.182-21.369 31.182-40.761 0-3.351-0.39-6.612-1.128-9.737l0.057 0.287-22.779-108.701c-0.003-0.018-0.006-0.038-0.006-0.059 0-0.139 0.097-0.255 0.228-0.282h0.002l108.894-22.828c19.643-3.837 34.262-20.91 34.262-41.397 0-1.265-0.056-2.518-0.166-3.756l0.011 0.159z" })));
}
function IconPapelera(props) {
    return React__default.createElement(SvgIcon, __assign$2({}, props, { viewBox: "0 0 1024 1024" }),
        React__default.createElement("g", { transform: "scale(1 1)" },
            React__default.createElement("path", { d: "M750.141 773.329c16.514 0.885 30.357-11.806 31.173-28.203l20.035-400.931c0.407-8.133-2.54-16.073-8.148-21.976-5.613-5.898-13.397-9.237-21.541-9.237h-527.663c-8.143 0-15.924 3.338-21.536 9.237s-8.559 13.837-8.153 21.972l32.437 651.563c0.784 15.821 13.848 28.246 29.689 28.246h462.791c15.841 0 28.905-12.425 29.689-28.246l3.997-80.279c0.818-16.397-11.811-30.351-28.208-31.164-16.523-0.866-30.357 11.82-31.169 28.208l-2.594 52.028h-406.22l-29.481-592.108h465.171l-18.473 369.718c-0.822 16.399 11.807 30.357 28.202 31.173zM417.356 477.102c-16.397 0.88-28.972 14.887-28.087 31.28l16.219 301.269c0.851 15.85 13.973 28.13 29.66 28.13 0.537 0 1.079-0.014 1.62-0.043 16.397-0.88 28.972-14.887 28.087-31.28l-16.219-301.269c-0.88-16.394-14.912-28.967-31.28-28.087zM561.798 505.189l-16.219 301.269c-0.885 16.393 11.69 30.4 28.087 31.28 0.542 0.029 1.084 0.043 1.62 0.043 15.687 0 28.808-12.28 29.66-28.13l16.219-301.269c0.885-16.393-11.69-30.4-28.087-31.28-16.402-0.871-30.403 11.692-31.28 28.087zM138.078 201.674c0 16.417 13.31 29.727 29.727 29.727h240.712c0.119 0 0.235-0.017 0.353-0.019 0.119 0.002 0.235 0.019 0.353 0.019h446.973c16.417 0 29.727-13.31 29.727-29.727s-13.31-29.727-29.727-29.727h-197.321v-142.22c0-16.417-13.31-29.727-29.727-29.727h-219.926c-16.417 0-29.727 13.31-29.727 29.727v51.34c0 16.417 13.31 29.727 29.727 29.727s29.727-13.31 29.727-29.727v-21.613h160.471v112.494h-190.199c-0.119 0-0.235 0.017-0.353 0.019-0.119-0.002-0.235-0.019-0.353-0.019h-240.711c-16.417 0-29.727 13.31-29.727 29.727z" })));
}
function IconAdd(props) {
    return React__default.createElement(SvgIcon, __assign$2({}, props, { viewBox: "0 0 1024 1024" }),
        React__default.createElement("g", { transform: "scale(1 1)" },
            React__default.createElement("path", { d: "M979.709 467.748h-423.452l0.035-423.496c0-24.44-19.812-44.252-44.252-44.252s-44.252 19.812-44.252 44.252l-0.035 423.496h-423.463c-24.44 0-44.252 19.812-44.252 44.252s19.812 44.252 44.252 44.252h423.454l-0.035 423.496c0 24.44 19.812 44.252 44.252 44.252s44.252-19.812 44.252-44.252l0.035-423.496h423.462c24.44 0 44.252-19.812 44.252-44.252s-19.812-44.252-44.252-44.252z" })));
}
function IconLlaveInglesa(props) {
    return React__default.createElement(SvgIcon, __assign$2({}, props, { viewBox: "0 0 1024 1024" }),
        React__default.createElement("g", { transform: "scale(1 1)" },
            React__default.createElement("path", { d: "M429.946 488.327c-18.948 0-34.31 15.363-34.31 34.31v389.869c0 1.186 0.061 2.357 0.178 3.511 1.877 59.844 51.021 107.982 111.312 107.982 60.293 0 109.44-48.137 111.318-107.982 0.117-1.154 0.178-2.326 0.178-3.511v-523.363c67.166-38.105 109.519-109.461 109.519-187.898 0-82.674-48.185-159.206-122.759-194.974-10.585-5.077-23.036-4.389-32.998 1.824-9.962 6.216-16.056 17.094-16.15 28.838l-1.086 135.93h-84.922v-136.81c0-11.7-5.961-22.595-15.818-28.899-9.851-6.31-22.246-7.154-32.867-2.256-76.348 35.227-125.68 112.296-125.68 196.348 0 82.649 48.168 159.173 122.715 194.952 17.088 8.203 37.584 0.997 45.778-16.086 8.201-17.082 0.997-37.578-16.086-45.778-50.897-24.429-83.786-76.67-83.786-133.087 0-36.581 13.687-71.223 37.122-97.763v103.691c0 18.948 15.363 34.31 34.31 34.31h153.269c18.841 0 34.16-15.195 34.31-34.037l0.813-101.687c22.248 26.281 35.213 60.057 35.213 95.485 0 58.955-34.978 112.146-89.11 135.514-14.389 6.211-22.327 21.096-20.408 35.9v539.847c0 23.638-19.232 42.872-42.874 42.872-23.638 0-42.868-19.232-42.868-42.872v-389.869c-0.002-18.951-15.364-34.31-34.31-34.31z" })));
}
function IconAlertSuccess(props) {
    return React__default.createElement(SvgIcon, __assign$2({}, props, { viewBox: "0 0 1024 1024" }),
        React__default.createElement("g", { transform: "scale(1 1)" },
            React__default.createElement("path", { d: "M438.43 711.769c-0.326 0-0.652-0.006-0.979-0.017-9.038-0.309-17.407-4.843-22.604-12.25l-129.175-184.277c-9.128-13.026-5.967-30.979 7.053-40.113 13.020-9.111 30.979-5.967 40.113 7.053l107.217 152.96 252.388-312.479c9.995-12.379 28.122-14.308 40.495-4.308 12.374 9.995 14.303 28.122 4.308 40.495l-276.415 342.232c-5.478 6.783-13.718 10.703-22.402 10.703zM930.45 782.945c-4.904 0-9.876-1.254-14.427-3.898-13.757-7.981-18.437-25.602-10.45-39.359 107.245-184.789 69.59-422.773-89.546-565.873-150.547-135.379-375.179-154.608-546.267-46.778-13.459 8.493-31.238 4.454-39.714-9.005-8.482-13.453-4.449-31.238 9.005-39.714 192.764-121.526 445.866-99.849 615.486 52.672 179.288 161.223 221.701 429.376 100.845 637.606-5.343 9.207-15 14.348-24.933 14.348zM512.542 1024c-123.894 0-246.769-44.759-342.98-131.273-169.344-152.28-217.809-401.377-117.847-605.756 6.98-14.292 24.23-20.203 38.521-13.212 14.286 6.985 20.203 24.23 13.212 38.521-88.713 181.375-45.687 402.457 104.624 537.622 143.146 128.719 352.817 153.303 521.711 61.188 13.988-7.604 31.463-2.463 39.072 11.491 7.615 13.965 2.469 31.457-11.491 39.072-76.784 41.873-161.037 62.346-244.823 62.346z" })));
}
function IconAlertInfo(props) {
    return React__default.createElement(SvgIcon, __assign$2({}, props, { viewBox: "0 0 1024 1024" }),
        React__default.createElement("g", { transform: "scale(1 1)" },
            React__default.createElement("path", { d: "M502.137 316.228c-15.906 0-28.797-12.891-28.797-28.797v-2.227c0-15.906 12.891-28.797 28.797-28.797s28.797 12.891 28.797 28.797v2.227c0 15.906-12.891 28.797-28.797 28.797zM599.619 767.309h-175.132c-15.9 0-28.791-12.885-28.797-28.786-0.006-15.894 12.874-28.791 28.769-28.808l58.55-0.051v-259.531h-29.579c-15.906 0-28.797-12.891-28.797-28.797s12.891-28.797 28.797-28.797h58.375c15.906 0 28.797 12.891 28.797 28.797v288.379h59.017c15.906 0 28.797 12.891 28.797 28.797s-12.891 28.797-28.797 28.797zM930.451 782.944c-4.904 0-9.876-1.254-14.427-3.898-13.757-7.981-18.437-25.602-10.45-39.359 107.246-184.789 69.59-422.773-89.546-565.875-150.542-135.373-375.169-154.614-546.262-46.778-13.448 8.493-31.238 4.455-39.714-9.005-8.482-13.454-4.449-31.232 9.005-39.714 192.781-121.52 445.873-99.85 615.482 52.672 179.288 161.223 221.702 429.376 100.845 637.608-5.343 9.207-15 14.348-24.933 14.348zM512.548 1024c-123.894 0-246.775-44.759-342.98-131.273-169.35-152.28-217.815-401.378-117.853-605.757 6.98-14.292 24.224-20.203 38.521-13.212 14.286 6.985 20.203 24.23 13.212 38.521-88.713 181.375-45.687 402.458 104.625 537.623 143.152 128.725 352.812 153.315 521.712 61.188 13.988-7.604 31.468-2.463 39.073 11.491 7.615 13.965 2.469 31.457-11.491 39.073-76.778 41.874-161.032 62.346-244.818 62.346z" })));
}
function IconAlertWarning(props) {
    return React__default.createElement(SvgIcon, __assign$2({}, props, { viewBox: "0 0 1024 1024" }),
        React__default.createElement("g", { transform: "scale(1 1)" },
            React__default.createElement("path", { d: "M854.484 131.133c-169.608-152.527-422.704-174.198-615.479-52.672-13.453 8.482-17.486 26.26-9.005 39.714 8.476 13.459 26.266 17.492 39.714 9.005 171.093-107.836 395.713-88.595 546.26 46.778 159.136 143.101 196.791 381.084 89.545 565.872-7.987 13.757-3.307 31.378 10.45 39.359 4.55 2.643 9.522 3.898 14.426 3.898 9.933 0 19.59-5.141 24.933-14.348 120.856-208.231 78.443-476.383-100.845-637.605zM729.73 911.232c-168.894 92.121-378.559 67.532-521.71-61.187-150.311-135.165-193.337-356.247-104.624-537.621 6.991-14.291 1.074-31.536-13.212-38.521-14.291-6.991-31.536-1.080-38.521 13.212-99.962 204.378-51.497 453.475 117.853 605.755 96.205 86.514 219.086 131.273 342.979 131.273 83.786 0 168.039-20.473 244.817-62.346 13.96-7.615 19.106-25.107 11.491-39.072-7.61-13.954-25.085-19.095-39.072-11.491zM483.203 773.221c0 15.906 12.891 28.797 28.797 28.797s28.797-12.891 28.797-28.797v-0.906c0-15.906-12.891-28.797-28.797-28.797s-28.797 12.891-28.797 28.797v0.906zM512 676.386c15.906 0 28.797-12.891 28.797-28.797v-396.815c0-15.906-12.891-28.797-28.797-28.797s-28.797 12.891-28.797 28.797v396.815c0 15.906 12.891 28.797 28.797 28.797z" })));
}
function IconAlertError(props) {
    return React__default.createElement(SvgIcon, __assign$2({}, props, { viewBox: "0 0 1024 1024" }),
        React__default.createElement("g", { transform: "scale(1 1)" },
            React__default.createElement("path", { d: "M320.588 703.331c5.624 5.624 12.992 8.437 20.36 8.437s14.742-2.812 20.36-8.437l150.745-150.751 150.745 150.751c5.619 5.624 12.992 8.437 20.36 8.437s14.742-2.812 20.36-8.437c11.249-11.243 11.249-29.477 0.006-40.721l-150.749-150.756 150.749-150.756c11.243-11.243 11.243-29.477-0.006-40.721-11.249-11.249-29.483-11.249-40.721 0l-150.745 150.751-150.745-150.751c-11.238-11.249-29.483-11.249-40.721 0-11.249 11.243-11.249 29.477-0.006 40.721l150.749 150.756-150.749 150.756c-11.243 11.243-11.243 29.477 0.006 40.721zM854.538 130.989c-169.609-152.522-422.706-174.193-615.482-52.672-13.454 8.482-17.486 26.26-9.005 39.714 8.476 13.459 26.271 17.497 39.714 9.005 171.094-107.842 395.72-88.595 546.262 46.778 159.136 143.101 196.791 381.086 89.546 565.875-7.987 13.757-3.307 31.378 10.45 39.359 4.55 2.643 9.522 3.898 14.427 3.898 9.933 0 19.59-5.141 24.933-14.348 120.857-208.231 78.443-476.385-100.845-637.608zM729.784 911.090c-168.889 92.122-378.56 67.538-521.712-61.188-150.312-135.165-193.338-356.248-104.625-537.623 6.991-14.292 1.074-31.536-13.212-38.521-14.292-6.997-31.536-1.074-38.521 13.212-99.962 204.379-51.497 453.477 117.853 605.757 96.205 86.514 219.087 131.273 342.98 131.273 83.786 0 168.040-20.473 244.818-62.346 13.96-7.615 19.106-25.107 11.491-39.073-7.615-13.954-25.085-19.095-39.073-11.491z" })));
}
function IconEnlace(props) {
    return React__default.createElement(SvgIcon, __assign$2({}, props, { viewBox: "280 20 1024 1024" }),
        React__default.createElement("g", { transform: "scale(1.5 1.5)" },
            React__default.createElement("path", { d: "M212.34 489.582c0.734-0.966 1.481-1.822 2.281-2.626l101.464-101.917c4.636-4.656 11.052-7.537 18.14-7.537 14.138 0 25.599 11.461 25.599 25.599 0 7.050-2.85 13.434-7.46 18.063l-100.179 100.627c-15.818 21.202-25.326 47.921-25.326 76.86 0 0.146 0 0.292 0.001 0.438v-0.023c0.086 72.057 58.477 130.448 130.527 130.532h0.008c0.143 0.001 0.313 0.001 0.483 0.001 30.065 0 57.731-10.275 79.677-27.505l-0.279 0.211 105.225-103.375c4.616-4.537 10.951-7.338 17.94-7.338 14.139 0 25.6 11.462 25.6 25.6 0 7.149-2.931 13.614-7.656 18.259l-0.004 0.004-106.245 104.38c-0.635 0.625-1.306 1.219-2.008 1.775l-0.052 0.040c-30.436 24.394-69.514 39.149-112.038 39.149-0.226 0-0.451 0-0.677-0.001h0.035c0 0 0 0 0 0-100.369 0-181.734-81.365-181.734-181.734 0-41.312 13.785-79.405 37.006-109.93l-0.326 0.447zM551.865 156.164c0.634-0.623 1.304-1.217 2.003-1.775l0.052-0.040c30.436-24.396 69.514-39.151 112.038-39.151 0.228 0 0.455 0 0.682 0.001h-0.035c100.37 0.001 181.735 81.366 181.735 181.736 0 41.313-13.785 79.406-37.006 109.931l0.326-0.447c-0.734 0.966-1.481 1.822-2.281 2.626l-101.464 101.917c-4.636 4.656-11.052 7.537-18.14 7.537-14.138 0-25.599-11.461-25.599-25.599 0-7.050 2.85-13.434 7.46-18.063l100.179-100.627c15.818-21.203 25.326-47.922 25.326-76.862 0-0.146 0-0.292-0.001-0.438v0.023c-0.086-72.057-58.477-130.448-130.527-130.532h-0.008c-0.145-0.001-0.315-0.001-0.486-0.001-30.064 0-57.729 10.275-79.673 27.505l0.279-0.211-105.225 103.378c-4.616 4.537-10.951 7.338-17.94 7.338-14.139 0-25.6-11.462-25.6-25.6 0-7.149 2.931-13.614 7.656-18.259l0.004-0.004zM408.405 555.999c-4.634-4.632-7.5-11.033-7.5-18.102s2.866-13.47 7.5-18.102l142.81-142.813c4.632-4.632 11.032-7.497 18.1-7.497 14.138 0 25.599 11.461 25.599 25.599 0 7.070-2.866 13.47-7.499 18.102l-142.81 142.812c-4.632 4.632-11.032 7.496-18.1 7.496s-13.468-2.865-18.1-7.496v0z" })));
}
function IconMenuCompleto(props) {
    return React__default.createElement(SvgIcon, __assign$2({}, props, { viewBox: "180 20 1024 1024" }),
        React__default.createElement("g", { transform: "scale(1.25 1.25)" },
            React__default.createElement("path", { d: "M200.69 509.394h224.315c14.138 0.001 25.599 11.462 25.6 25.6v0 220.205c-0.001 14.138-11.462 25.599-25.6 25.6h-224.315c-14.138-0.001-25.599-11.462-25.6-25.6v0-220.205c0.001-14.138 11.462-25.599 25.6-25.6v0zM226.29 729.599h173.115v-169.005h-173.115zM598.997 509.394h224.312c14.138 0.001 25.599 11.462 25.6 25.6v0 220.205c-0.001 14.138-11.462 25.599-25.6 25.6h-224.312c-14.138-0.001-25.599-11.462-25.6-25.6v0-220.205c0.001-14.138 11.462-25.599 25.6-25.6v0zM624.597 729.599h173.112v-169.005h-173.112zM175.090 140.799c0.001-14.138 11.462-25.599 25.6-25.6h224.315c14.138 0.001 25.599 11.462 25.6 25.6v0 220.208c-0.001 14.138-11.462 25.599-25.6 25.6h-224.315c-14.138-0.001-25.599-11.462-25.6-25.6v0zM226.29 335.407h173.115v-169.008h-173.115zM573.397 140.799c0.001-14.138 11.462-25.599 25.6-25.6h224.312c14.138 0.001 25.599 11.462 25.6 25.6v0 220.208c-0.001 14.138-11.462 25.599-25.6 25.6h-224.312c-14.138-0.001-25.599-11.462-25.6-25.6v0zM624.597 335.407h173.112v-169.008h-173.112z" })));
}
function IconMenuReducido(props) {
    return React__default.createElement(SvgIcon, __assign$2({}, props, { viewBox: "180 20 1024 1024" }),
        React__default.createElement("g", { transform: "scale(1.25 1.25)" },
            React__default.createElement("path", { d: "M 200.69 509.394 L 425.005 509.394 C 439.143 509.395 450.604 520.856 450.605 534.994 L 450.605 755.199 C 450.604 769.337 439.143 780.798 425.005 780.799 L 200.69 780.799 C 186.552 780.798 175.091 769.337 175.09 755.199 L 175.09 534.994 C 175.091 520.856 186.552 509.395 200.69 509.394 Z M 598.997 509.394 L 823.309 509.394 C 837.447 509.395 848.908 520.856 848.909 534.994 L 848.909 755.199 C 848.908 769.337 837.447 780.798 823.309 780.799 L 598.997 780.799 C 584.859 780.798 573.398 769.337 573.397 755.199 L 573.397 534.994 C 573.398 520.856 584.859 509.395 598.997 509.394 Z M 175.09 140.799 C 175.091 126.661 186.552 115.2 200.69 115.199 L 425.005 115.199 C 439.143 115.2 450.604 126.661 450.605 140.799 L 450.605 361.007 C 450.604 375.145 439.143 386.606 425.005 386.607 L 200.69 386.607 C 186.552 386.606 175.091 375.145 175.09 361.007 L 175.09 140.799 Z M 573.397 140.799 C 573.398 126.661 584.859 115.2 598.997 115.199 L 823.309 115.199 C 837.447 115.2 848.908 126.661 848.909 140.799 L 848.909 361.007 C 848.908 375.145 837.447 386.606 823.309 386.607 L 598.997 386.607 C 584.859 386.606 573.398 375.145 573.397 361.007 L 573.397 140.799 Z" })));
}
function IconBombilla(props) {
    return React__default.createElement(SvgIcon, __assign$2({}, props, { viewBox: "0 0 1024 1024", transform: "matrix(-1,0,0,-1,0,0)" }),
        React__default.createElement("g", { transform: "scale(1 1)" },
            React__default.createElement("path", { d: "M302.831 297.884c-1.838-0.381-3.448-0.893-4.981-1.549l0.169 0.064c-1.688-0.695-3.137-1.485-4.488-2.409l0.083 0.053c-1.463-0.958-2.736-2.005-3.887-3.172l-0.003-0.003c-4.628-4.646-7.499-11.046-7.527-18.117v-0.006c0.020-1.769 0.206-3.483 0.542-5.142l-0.030 0.175c0.385-1.84 0.897-3.45 1.55-4.985l-0.065 0.172c0.709-1.698 1.481-3.145 2.37-4.509l-0.065 0.107c0.995-1.455 2.055-2.727 3.224-3.892l0.001-0.001c1.154-1.168 2.428-2.215 3.802-3.12l0.088-0.055c1.267-0.868 2.716-1.657 4.244-2.296l0.161-0.060c1.363-0.589 2.973-1.101 4.641-1.454l0.172-0.031c1.484-0.306 3.197-0.491 4.95-0.51h0.015c7.077 0.027 13.478 2.897 18.126 7.526l-0.001-0.001c1.169 1.155 2.215 2.429 3.12 3.804l0.054 0.088c0.841 1.26 1.629 2.706 2.286 4.223l0.069 0.18c0.575 1.365 1.071 2.977 1.407 4.646l0.028 0.166c0.324 1.462 0.51 3.14 0.51 4.862 0 0.037 0 0.074 0 0.111v-0.006c0 0.016 0 0.035 0 0.054 0 14.125-11.45 25.575-25.575 25.575-1.766 0-3.49-0.179-5.155-0.52l0.165 0.028zM246.819 486.762c-0.714 1.713-1.503 3.178-2.416 4.553l0.061-0.098c-1.884 2.827-4.239 5.181-6.977 7.008l-0.091 0.057c-1.26 0.841-2.706 1.629-4.222 2.286l-0.18 0.070c-1.36 0.567-2.971 1.062-4.638 1.403l-0.174 0.030c-1.501 0.318-3.225 0.501-4.992 0.501s-3.492-0.182-5.156-0.529l0.163 0.028c-1.835-0.362-3.447-0.857-4.984-1.496l0.171 0.063c-1.697-0.727-3.143-1.515-4.505-2.419l0.103 0.064c-1.463-0.961-2.737-2.007-3.89-3.173l-0.002-0.002c-1.154-1.161-2.198-2.433-3.114-3.798l-0.058-0.092c-0.883-1.283-1.674-2.75-2.3-4.301l-0.055-0.154c-0.62-1.365-1.134-2.96-1.462-4.622l-0.023-0.141c-0.31-1.501-0.495-3.232-0.512-5.004v-0.014c0.023-1.789 0.208-3.52 0.542-5.198l-0.030 0.18c0.361-1.806 0.874-3.399 1.543-4.907l-0.058 0.147c0.695-1.688 1.485-3.137 2.408-4.488l-0.053 0.083c0.959-1.463 2.004-2.736 3.17-3.888l0.002-0.002c1.166-1.168 2.438-2.229 3.802-3.166l0.091-0.059c1.259-0.841 2.706-1.629 4.222-2.286l0.18-0.070c1.365-0.575 2.976-1.071 4.646-1.407l0.167-0.028c1.501-0.326 3.225-0.513 4.992-0.513s3.492 0.187 5.154 0.541l-0.161-0.029c1.843 0.374 3.454 0.869 4.994 1.501l-0.182-0.066c1.697 0.727 3.143 1.515 4.505 2.419l-0.103-0.064c1.45 1.012 2.721 2.072 3.896 3.229l-0.004-0.004c1.168 1.154 2.215 2.428 3.12 3.802l0.055 0.088c0.838 1.259 1.626 2.707 2.285 4.223l0.070 0.182c0.546 1.314 1.056 2.904 1.441 4.541l0.043 0.219c0.288 1.506 0.455 3.241 0.46 5.014v0.004c0 0.003 0 0.007 0 0.010 0 1.77-0.167 3.502-0.487 5.179l0.027-0.172c-0.418 1.847-0.928 3.437-1.559 4.965l0.074-0.203zM293.614 659.869c1.26-0.841 2.708-1.629 4.225-2.286l0.18-0.069c1.365-0.576 2.977-1.072 4.647-1.407l0.166-0.028c1.465-0.326 3.147-0.513 4.873-0.513 0.032 0 0.064 0 0.097 0h-0.005c14.085 0.055 25.481 11.486 25.481 25.579 0 14.127-11.452 25.579-25.579 25.579-3.49 0-6.818-0.699-9.849-1.965l0.169 0.063c-1.697-0.726-3.145-1.514-4.507-2.419l0.102 0.064c-1.456-0.98-2.728-2.024-3.892-3.177l0.002 0.002c-4.65-4.633-7.527-11.042-7.527-18.124s2.877-13.491 7.527-18.123l0.001-0.001c1.154-1.169 2.427-2.215 3.802-3.12l0.088-0.054zM488.329 756.022c0.697-1.688 1.487-3.136 2.409-4.486l-0.054 0.084c0.961-1.463 2.007-2.737 3.173-3.89l0.002-0.002c1.163-1.172 2.435-2.233 3.801-3.167l0.089-0.058c1.259-0.839 2.705-1.627 4.221-2.285l0.181-0.070c1.36-0.566 2.972-1.060 4.639-1.402l0.176-0.030c1.5-0.326 3.224-0.513 4.991-0.513s3.491 0.187 5.152 0.541l-0.161-0.029c1.836 0.363 3.447 0.858 4.985 1.496l-0.172-0.063c1.698 0.727 3.145 1.515 4.508 2.42l-0.103-0.065c2.813 1.92 5.163 4.287 7.006 7.025l0.059 0.093c0.867 1.266 1.656 2.715 2.295 4.241l0.060 0.161c0.588 1.349 1.1 2.942 1.454 4.592l0.031 0.17c0.307 1.499 0.493 3.23 0.512 5.001v0.016c-0.029 7.077-2.9 13.478-7.528 18.126l0.001-0.001c-1.154 1.168-2.428 2.215-3.802 3.12l-0.088 0.055c-1.259 0.838-2.706 1.626-4.223 2.285l-0.182 0.070c-1.364 0.573-2.976 1.068-4.645 1.404l-0.168 0.028c-1.501 0.317-3.225 0.499-4.991 0.499s-3.491-0.182-5.155-0.527l0.164 0.028c-1.844-0.374-3.456-0.868-4.998-1.499l0.183 0.066c-1.698-0.73-3.144-1.518-4.507-2.421l0.105 0.065c-6.89-4.617-11.366-12.373-11.366-21.174 0-0.044 0-0.088 0-0.133v0.007c0.001-1.774 0.168-3.509 0.487-5.19l-0.027 0.173c0.384-1.82 0.895-3.412 1.549-4.929l-0.064 0.167zM739.976 691c-0.697 1.688-1.487 3.136-2.409 4.486l0.054-0.084c-4.636 6.913-12.42 11.402-21.253 11.402-1.774 0-3.505-0.181-5.177-0.526l0.165 0.028c-1.839-0.383-3.449-0.895-4.983-1.549l0.17 0.065c-1.688-0.697-3.137-1.486-4.488-2.409l0.083 0.054c-1.463-0.959-2.736-2.006-3.888-3.172l-0.002-0.003c-1.154-1.161-2.199-2.433-3.117-3.798l-0.058-0.092c-0.868-1.267-1.658-2.715-2.296-4.242l-0.059-0.16c-1.263-2.882-1.997-6.241-1.997-9.771 0-1.779 0.187-3.515 0.541-5.189l-0.029 0.163c0.383-1.839 0.895-3.449 1.55-4.983l-0.065 0.171c0.696-1.687 1.486-3.136 2.409-4.485l-0.053 0.083c0.976-1.458 2.021-2.731 3.176-3.894l-0.001 0.001c1.154-1.168 2.428-2.215 3.802-3.12l0.088-0.055c1.267-0.868 2.716-1.657 4.244-2.296l0.161-0.060c1.363-0.589 2.973-1.101 4.641-1.454l0.172-0.031c1.483-0.307 3.196-0.492 4.949-0.512h0.016c0.006 0 0.013 0 0.020 0 8.844 0 16.639 4.496 21.222 11.328l0.058 0.092c0.87 1.267 1.659 2.715 2.296 4.243l0.059 0.159c0.59 1.364 1.102 2.973 1.455 4.642l0.030 0.171c0.293 1.501 0.46 3.227 0.46 4.992s-0.167 3.491-0.487 5.163l0.027-0.171c-0.393 1.846-0.905 3.455-1.552 4.993l0.067-0.181zM825.941 481.999c-0.382 1.819-0.894 3.412-1.549 4.929l0.064-0.166c-0.683 1.705-1.473 3.172-2.406 4.534l0.051-0.079c-1.884 2.827-4.238 5.181-6.974 7.008l-0.091 0.057c-1.26 0.841-2.708 1.629-4.225 2.286l-0.18 0.069c-1.36 0.568-2.972 1.063-4.639 1.403l-0.173 0.030c-1.501 0.318-3.225 0.501-4.991 0.501s-3.491-0.182-5.154-0.529l0.163 0.028c-1.834-0.361-3.446-0.856-4.983-1.495l0.17 0.063c-1.697-0.726-3.145-1.514-4.507-2.419l0.102 0.064c-1.462-0.96-2.736-2.007-3.888-3.173l-0.002-0.002c-1.154-1.161-2.199-2.433-3.117-3.798l-0.058-0.092c-0.882-1.283-1.673-2.75-2.3-4.3l-0.055-0.155c-0.59-1.351-1.102-2.943-1.455-4.595l-0.030-0.168c-0.31-1.501-0.495-3.232-0.512-5.004v-0.014c0.023-1.789 0.208-3.52 0.542-5.198l-0.030 0.18c0.393-1.825 0.904-3.416 1.551-4.936l-0.066 0.176c0.697-1.688 1.486-3.138 2.409-4.488l-0.054 0.083c0.96-1.462 2.007-2.736 3.173-3.888l0.002-0.002c1.165-1.169 2.436-2.23 3.8-3.166l0.090-0.059c1.26-0.841 2.708-1.629 4.225-2.286l0.18-0.069c1.365-0.576 2.977-1.072 4.646-1.407l0.166-0.028c1.5-0.326 3.224-0.513 4.991-0.513s3.491 0.187 5.152 0.541l-0.161-0.029c1.842 0.373 3.453 0.868 4.993 1.501l-0.181-0.066c1.697 0.726 3.145 1.514 4.507 2.419l-0.102-0.064c1.449 1.012 2.719 2.071 3.894 3.229l-0.004-0.004c1.168 1.154 2.215 2.428 3.12 3.802l0.055 0.088c0.869 1.267 1.659 2.717 2.296 4.245l0.059 0.16c0.581 1.344 1.092 2.935 1.452 4.582l0.033 0.178c0.29 1.507 0.457 3.242 0.46 5.015v0.003c0 0.009 0 0.019 0 0.030 0 1.764-0.167 3.488-0.487 5.158l0.027-0.171zM711.304 297.884c-1.818-0.381-3.409-0.893-4.925-1.548l0.165 0.063c-1.708-0.696-3.174-1.486-4.542-2.41l0.087 0.055c-1.458-0.974-2.731-2.019-3.893-3.176l0.001 0.001c-4.604-4.637-7.455-11.020-7.475-18.069v-0.004c0-0.038 0-0.084 0-0.129 0-1.731 0.187-3.419 0.541-5.044l-0.028 0.156c0.364-1.837 0.859-3.448 1.496-4.986l-0.064 0.174c0.728-1.697 1.517-3.143 2.422-4.506l-0.064 0.103c1.882-2.83 4.236-5.185 6.974-7.011l0.091-0.057c1.28-0.867 2.746-1.656 4.29-2.295l0.165-0.060c1.349-0.589 2.94-1.1 4.59-1.454l0.17-0.030c1.501-0.309 3.233-0.494 5.005-0.51h0.013c7.061 0.028 13.446 2.898 18.075 7.525v0c1.172 1.164 2.233 2.437 3.167 3.803l0.058 0.090c0.841 1.26 1.629 2.706 2.286 4.223l0.069 0.18c0.576 1.366 1.071 2.978 1.405 4.648l0.027 0.165c0.326 1.465 0.513 3.147 0.513 4.872 0 0.051 0 0.102 0 0.153v-0.008c-0.014 7.063-2.888 13.451-7.524 18.072l-0.001 0.001c-4.671 4.625-11.1 7.483-18.196 7.483-1.732 0-3.424-0.17-5.061-0.495l0.165 0.027zM560.909 216.022h-98.983c-14.138 0-25.6-11.462-25.6-25.6s11.462-25.6 25.6-25.6v0h98.983c14.138 0 25.6 11.462 25.6 25.6s-11.462 25.6-25.6 25.6v0zM560.909 155.797h-98.983c-14.138 0-25.6-11.462-25.6-25.6s11.462-25.6 25.6-25.6v0h98.983c14.138 0 25.6 11.462 25.6 25.6s-11.462 25.6-25.6 25.6v0zM503.364 541.509c-0.559 13.676-11.781 24.551-25.543 24.551-0.381 0-0.761-0.008-1.138-0.025l0.054 0.002c-40.576-0.439-73.427-32.9-74.493-73.28l-0.002-0.099c-0.006-0.214-0.010-0.466-0.010-0.719 0-13.885 11.055-25.189 24.843-25.59l0.037-0.001c0.245-0.007 0.49-0.010 0.732-0.010 13.88 0.007 25.176 11.059 25.577 24.843l0.001 0.037c0.62 22.010 22.88 23.56 25.415 23.665 13.679 0.578 24.549 11.807 24.549 25.576 0 0.37-0.008 0.738-0.023 1.104l0.002-0.052zM511.966 670.737c-108.763-0.009-196.93-88.181-196.93-196.946 0-42.794 13.649-82.4 36.83-114.702l-0.403 0.59c27.042-37.543 46.882-79.718 54.435-115.715 2.519-11.701 12.778-20.343 25.055-20.343 14.139 0 25.601 11.462 25.601 25.601 0 1.862-0.199 3.677-0.576 5.426l0.030-0.168c-8.967 42.74-31.93 91.99-63.035 135.165-16.726 23.406-26.744 52.604-26.744 84.141 0 80.486 65.247 145.733 145.733 145.733s145.733-65.247 145.733-145.733c0-31.555-10.029-60.767-27.073-84.624l0.3 0.443c-31.075-43.143-54.040-92.395-63.003-135.128-0.347-1.58-0.545-3.394-0.545-5.255 0-14.139 11.462-25.6 25.6-25.6 12.278 0 22.537 8.643 25.025 20.177l0.030 0.168c7.547 35.988 27.39 78.162 54.693 116.072 22.623 31.64 36.172 71.114 36.172 113.752 0 108.765-88.167 196.937-196.929 196.945h-0.001z" })));
}

function createCommonjsModule(fn, basedir, module) {
	return module = {
		path: basedir,
		exports: {},
		require: function (path, base) {
			return commonjsRequire(path, (base === undefined || base === null) ? module.path : base);
		}
	}, fn(module, module.exports), module.exports;
}

function commonjsRequire () {
	throw new Error('Dynamic requires are not currently supported by @rollup/plugin-commonjs');
}

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h$1=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v$1=b?Symbol.for("react.block"):60121,w$1=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h$1:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}var AsyncMode=l;var ConcurrentMode=m;var ContextConsumer=k;var ContextProvider=h$1;var Element=c;var ForwardRef=n;var Fragment=e;var Lazy=t;var Memo=r;var Portal$1=d;
var Profiler=g;var StrictMode=f;var Suspense=p;var isAsyncMode=function(a){return A(a)||z(a)===l};var isConcurrentMode=A;var isContextConsumer=function(a){return z(a)===k};var isContextProvider=function(a){return z(a)===h$1};var isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c};var isForwardRef=function(a){return z(a)===n};var isFragment=function(a){return z(a)===e};var isLazy=function(a){return z(a)===t};
var isMemo=function(a){return z(a)===r};var isPortal=function(a){return z(a)===d};var isProfiler=function(a){return z(a)===g};var isStrictMode=function(a){return z(a)===f};var isSuspense=function(a){return z(a)===p};
var isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h$1||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w$1||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v$1)};var typeOf=z;

var reactIs_production_min = {
	AsyncMode: AsyncMode,
	ConcurrentMode: ConcurrentMode,
	ContextConsumer: ContextConsumer,
	ContextProvider: ContextProvider,
	Element: Element,
	ForwardRef: ForwardRef,
	Fragment: Fragment,
	Lazy: Lazy,
	Memo: Memo,
	Portal: Portal$1,
	Profiler: Profiler,
	StrictMode: StrictMode,
	Suspense: Suspense,
	isAsyncMode: isAsyncMode,
	isConcurrentMode: isConcurrentMode,
	isContextConsumer: isContextConsumer,
	isContextProvider: isContextProvider,
	isElement: isElement,
	isForwardRef: isForwardRef,
	isFragment: isFragment,
	isLazy: isLazy,
	isMemo: isMemo,
	isPortal: isPortal,
	isProfiler: isProfiler,
	isStrictMode: isStrictMode,
	isSuspense: isSuspense,
	isValidElementType: isValidElementType,
	typeOf: typeOf
};

var reactIs_development = createCommonjsModule(function (module, exports) {



if (process.env.NODE_ENV !== "production") {
  (function() {

// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var hasSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
// (unstable) APIs that have been removed. Can we remove the symbols?

var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

function isValidElementType(type) {
  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
}

function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;

    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;

        switch (type) {
          case REACT_ASYNC_MODE_TYPE:
          case REACT_CONCURRENT_MODE_TYPE:
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
            return type;

          default:
            var $$typeofType = type && type.$$typeof;

            switch ($$typeofType) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_LAZY_TYPE:
              case REACT_MEMO_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;

              default:
                return $$typeof;
            }

        }

      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }

  return undefined;
} // AsyncMode is deprecated along with isAsyncMode

var AsyncMode = REACT_ASYNC_MODE_TYPE;
var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;
var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
    }
  }

  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
}
function isConcurrentMode(object) {
  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}

exports.AsyncMode = AsyncMode;
exports.ConcurrentMode = ConcurrentMode;
exports.ContextConsumer = ContextConsumer;
exports.ContextProvider = ContextProvider;
exports.Element = Element;
exports.ForwardRef = ForwardRef;
exports.Fragment = Fragment;
exports.Lazy = Lazy;
exports.Memo = Memo;
exports.Portal = Portal;
exports.Profiler = Profiler;
exports.StrictMode = StrictMode;
exports.Suspense = Suspense;
exports.isAsyncMode = isAsyncMode;
exports.isConcurrentMode = isConcurrentMode;
exports.isContextConsumer = isContextConsumer;
exports.isContextProvider = isContextProvider;
exports.isElement = isElement;
exports.isForwardRef = isForwardRef;
exports.isFragment = isFragment;
exports.isLazy = isLazy;
exports.isMemo = isMemo;
exports.isPortal = isPortal;
exports.isProfiler = isProfiler;
exports.isStrictMode = isStrictMode;
exports.isSuspense = isSuspense;
exports.isValidElementType = isValidElementType;
exports.typeOf = typeOf;
  })();
}
});

var reactIs = createCommonjsModule(function (module) {

if (process.env.NODE_ENV === 'production') {
  module.exports = reactIs_production_min;
} else {
  module.exports = reactIs_development;
}
});

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret$1 = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

var ReactPropTypesSecret_1 = ReactPropTypesSecret$1;

var printWarning$1 = function() {};

if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret = ReactPropTypesSecret_1;
  var loggedTypeFailures = {};
  var has$1 = Function.call.bind(Object.prototype.hasOwnProperty);

  printWarning$1 = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has$1(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error(
              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.'
            );
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning$1(
            (componentName || 'React class') + ': type specification of ' +
            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
            'You may have forgotten to pass an argument to the type checker ' +
            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
            'shape all require an argument).'
          );
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          printWarning$1(
            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
          );
        }
      }
    }
  }
}

/**
 * Resets warning cache when testing.
 *
 * @private
 */
checkPropTypes.resetWarningCache = function() {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures = {};
  }
};

var checkPropTypes_1 = checkPropTypes;

var has = Function.call.bind(Object.prototype.hasOwnProperty);
var printWarning = function() {};

if (process.env.NODE_ENV !== 'production') {
  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

var factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret_1) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error(
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            printWarning(
              'You are manually calling a React.PropTypes validation ' +
              'function for the `' + propFullName + '` prop on `' + componentName  + '`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret_1);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!reactIs.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (process.env.NODE_ENV !== 'production') {
        if (arguments.length > 1) {
          printWarning(
            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
          );
        } else {
          printWarning('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning(
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
        );
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret_1) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from
      // props.
      var allKeys = objectAssign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // falsy value can't be a Symbol
    if (!propValue) {
      return false;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes_1;
  ReactPropTypes.resetWarningCache = checkPropTypes_1.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

var factoryWithThrowingShims = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret_1) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  }  shim.isRequired = shim;
  function getShim() {
    return shim;
  }  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

var propTypes = createCommonjsModule(function (module) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== 'production') {
  var ReactIs = reactIs;

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = factoryWithTypeCheckers(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = factoryWithThrowingShims();
}
});

var useStyles$i = makeStyles({
    container: {
        display: 'flex',
    },
    containerText: {
        display: 'flex',
        flexDirection: 'column',
        paddingLeft: '10px',
    },
    titulo: {
        fontSize: '12px',
        fontWeight: 'bold',
    },
    mensaje: {
        fontSize: '12px',
    },
    alertContainer: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        marginBottom: '15px',
        padding: '10px',
        '&.gco-success': {
            backgroundColor: '#e6efd8',
            borderLeft: '5px solid #088600',
            color: '#088600',
        },
        '&.gco-warning': {
            backgroundColor: '#ffe7ca',
            borderLeft: '5px solid #aa4813',
            color: '#aa4813',
        },
        '&.gco-info': {
            backgroundColor: '#e0dfce',
            borderLeft: '5px solid #5b5c43',
            color: '#5b5c43',
        },
        '&.gco-error': {
            backgroundColor: '#f1d4d4',
            borderLeft: '5px solid #b91e1e',
            color: '#b91e1e',
        },
        '& .MuiSvgIcon-root': {
            width: '20px'
        }
    },
    iconAlert: {
        display: 'contents',
    }
});
var Alert = function (props) {
    var clases = useStyles$i();
    return (React__default.createElement("div", { className: clases.alertContainer + ' gco-' + props.severity },
        React__default.createElement("div", { className: clases.iconAlert },
            props.severity === 'error' && React__default.createElement(IconAlertError, null),
            props.severity === 'info' && React__default.createElement(IconAlertInfo, null),
            props.severity === 'success' && React__default.createElement(IconAlertSuccess, null),
            props.severity === 'warning' && React__default.createElement(IconAlertWarning, null)),
        React__default.createElement("div", { className: clases.containerText },
            React__default.createElement("div", { className: clases.titulo }, props.titulo),
            React__default.createElement("span", { className: clases.mensaje }, props.message))));
};
Alert.propTypes = {
    titulo: propTypes.string,
    message: propTypes.string,
    severity: propTypes.string.isRequired
};

/*! @azure/msal-browser v2.15.0 2021-06-29 */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics$1 = function(d, b) {
    extendStatics$1 = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics$1(d, b);
};

function __extends$1(d, b) {
    extendStatics$1(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign$1 = function() {
    __assign$1 = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign$1.apply(this, arguments);
};

function __awaiter$1(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator$1(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

/*! @azure/msal-common v4.4.0 2021-06-29 */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

/*! @azure/msal-common v4.4.0 2021-06-29 */

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
var Constants = {
    LIBRARY_NAME: "MSAL.JS",
    SKU: "msal.js.common",
    // Prefix for all library cache entries
    CACHE_PREFIX: "msal",
    // default authority
    DEFAULT_AUTHORITY: "https://login.microsoftonline.com/common/",
    DEFAULT_AUTHORITY_HOST: "login.microsoftonline.com",
    // ADFS String
    ADFS: "adfs",
    // Default AAD Instance Discovery Endpoint
    AAD_INSTANCE_DISCOVERY_ENDPT: "https://login.microsoftonline.com/common/discovery/instance?api-version=1.1&authorization_endpoint=",
    // Resource delimiter - used for certain cache entries
    RESOURCE_DELIM: "|",
    // Placeholder for non-existent account ids/objects
    NO_ACCOUNT: "NO_ACCOUNT",
    // Claims
    CLAIMS: "claims",
    // Consumer UTID
    CONSUMER_UTID: "9188040d-6c67-4c5b-b112-36a304b66dad",
    // Default scopes
    OPENID_SCOPE: "openid",
    PROFILE_SCOPE: "profile",
    OFFLINE_ACCESS_SCOPE: "offline_access",
    EMAIL_SCOPE: "email",
    // Default response type for authorization code flow
    CODE_RESPONSE_TYPE: "code",
    CODE_GRANT_TYPE: "authorization_code",
    RT_GRANT_TYPE: "refresh_token",
    FRAGMENT_RESPONSE_MODE: "fragment",
    S256_CODE_CHALLENGE_METHOD: "S256",
    URL_FORM_CONTENT_TYPE: "application/x-www-form-urlencoded;charset=utf-8",
    AUTHORIZATION_PENDING: "authorization_pending",
    NOT_DEFINED: "not_defined",
    EMPTY_STRING: "",
    FORWARD_SLASH: "/",
    IMDS_ENDPOINT: "http://169.254.169.254/metadata/instance/compute/location",
    IMDS_VERSION: "2020-06-01",
    IMDS_TIMEOUT: 2000,
    AZURE_REGION_AUTO_DISCOVER_FLAG: "AUTO_DISCOVER",
    REGIONAL_AUTH_PUBLIC_CLOUD_SUFFIX: "login.microsoft.com",
    KNOWN_PUBLIC_CLOUDS: ["login.microsoftonline.com", "login.windows.net", "login.microsoft.com", "sts.windows.net"]
};
var OIDC_DEFAULT_SCOPES = [
    Constants.OPENID_SCOPE,
    Constants.PROFILE_SCOPE,
    Constants.OFFLINE_ACCESS_SCOPE
];
var OIDC_SCOPES = __spreadArrays(OIDC_DEFAULT_SCOPES, [
    Constants.EMAIL_SCOPE
]);
/**
 * Request header names
 */
var HeaderNames;
(function (HeaderNames) {
    HeaderNames["CONTENT_TYPE"] = "Content-Type";
    HeaderNames["RETRY_AFTER"] = "Retry-After";
    HeaderNames["CCS_HEADER"] = "X-AnchorMailbox";
})(HeaderNames || (HeaderNames = {}));
/**
 * Persistent cache keys MSAL which stay while user is logged in.
 */
var PersistentCacheKeys;
(function (PersistentCacheKeys) {
    PersistentCacheKeys["ID_TOKEN"] = "idtoken";
    PersistentCacheKeys["CLIENT_INFO"] = "client.info";
    PersistentCacheKeys["ADAL_ID_TOKEN"] = "adal.idtoken";
    PersistentCacheKeys["ERROR"] = "error";
    PersistentCacheKeys["ERROR_DESC"] = "error.description";
})(PersistentCacheKeys || (PersistentCacheKeys = {}));
/**
 * String constants related to AAD Authority
 */
var AADAuthorityConstants;
(function (AADAuthorityConstants) {
    AADAuthorityConstants["COMMON"] = "common";
    AADAuthorityConstants["ORGANIZATIONS"] = "organizations";
    AADAuthorityConstants["CONSUMERS"] = "consumers";
})(AADAuthorityConstants || (AADAuthorityConstants = {}));
/**
 * Keys in the hashParams sent by AAD Server
 */
var AADServerParamKeys;
(function (AADServerParamKeys) {
    AADServerParamKeys["CLIENT_ID"] = "client_id";
    AADServerParamKeys["REDIRECT_URI"] = "redirect_uri";
    AADServerParamKeys["RESPONSE_TYPE"] = "response_type";
    AADServerParamKeys["RESPONSE_MODE"] = "response_mode";
    AADServerParamKeys["GRANT_TYPE"] = "grant_type";
    AADServerParamKeys["CLAIMS"] = "claims";
    AADServerParamKeys["SCOPE"] = "scope";
    AADServerParamKeys["ERROR"] = "error";
    AADServerParamKeys["ERROR_DESCRIPTION"] = "error_description";
    AADServerParamKeys["ACCESS_TOKEN"] = "access_token";
    AADServerParamKeys["ID_TOKEN"] = "id_token";
    AADServerParamKeys["REFRESH_TOKEN"] = "refresh_token";
    AADServerParamKeys["EXPIRES_IN"] = "expires_in";
    AADServerParamKeys["STATE"] = "state";
    AADServerParamKeys["NONCE"] = "nonce";
    AADServerParamKeys["PROMPT"] = "prompt";
    AADServerParamKeys["SESSION_STATE"] = "session_state";
    AADServerParamKeys["CLIENT_INFO"] = "client_info";
    AADServerParamKeys["CODE"] = "code";
    AADServerParamKeys["CODE_CHALLENGE"] = "code_challenge";
    AADServerParamKeys["CODE_CHALLENGE_METHOD"] = "code_challenge_method";
    AADServerParamKeys["CODE_VERIFIER"] = "code_verifier";
    AADServerParamKeys["CLIENT_REQUEST_ID"] = "client-request-id";
    AADServerParamKeys["X_CLIENT_SKU"] = "x-client-SKU";
    AADServerParamKeys["X_CLIENT_VER"] = "x-client-VER";
    AADServerParamKeys["X_CLIENT_OS"] = "x-client-OS";
    AADServerParamKeys["X_CLIENT_CPU"] = "x-client-CPU";
    AADServerParamKeys["X_CLIENT_CURR_TELEM"] = "x-client-current-telemetry";
    AADServerParamKeys["X_CLIENT_LAST_TELEM"] = "x-client-last-telemetry";
    AADServerParamKeys["X_MS_LIB_CAPABILITY"] = "x-ms-lib-capability";
    AADServerParamKeys["POST_LOGOUT_URI"] = "post_logout_redirect_uri";
    AADServerParamKeys["ID_TOKEN_HINT"] = "id_token_hint";
    AADServerParamKeys["DEVICE_CODE"] = "device_code";
    AADServerParamKeys["CLIENT_SECRET"] = "client_secret";
    AADServerParamKeys["CLIENT_ASSERTION"] = "client_assertion";
    AADServerParamKeys["CLIENT_ASSERTION_TYPE"] = "client_assertion_type";
    AADServerParamKeys["TOKEN_TYPE"] = "token_type";
    AADServerParamKeys["REQ_CNF"] = "req_cnf";
    AADServerParamKeys["OBO_ASSERTION"] = "assertion";
    AADServerParamKeys["REQUESTED_TOKEN_USE"] = "requested_token_use";
    AADServerParamKeys["ON_BEHALF_OF"] = "on_behalf_of";
    AADServerParamKeys["FOCI"] = "foci";
    AADServerParamKeys["CCS_HEADER"] = "X-AnchorMailbox";
})(AADServerParamKeys || (AADServerParamKeys = {}));
/**
 * Claims request keys
 */
var ClaimsRequestKeys;
(function (ClaimsRequestKeys) {
    ClaimsRequestKeys["ACCESS_TOKEN"] = "access_token";
    ClaimsRequestKeys["XMS_CC"] = "xms_cc";
})(ClaimsRequestKeys || (ClaimsRequestKeys = {}));
/**
 * we considered making this "enum" in the request instead of string, however it looks like the allowed list of
 * prompt values kept changing over past couple of years. There are some undocumented prompt values for some
 * internal partners too, hence the choice of generic "string" type instead of the "enum"
 */
var PromptValue = {
    LOGIN: "login",
    SELECT_ACCOUNT: "select_account",
    CONSENT: "consent",
    NONE: "none",
};
/**
 * SSO Types - generated to populate hints
 */
var SSOTypes;
(function (SSOTypes) {
    SSOTypes["ACCOUNT"] = "account";
    SSOTypes["SID"] = "sid";
    SSOTypes["LOGIN_HINT"] = "login_hint";
    SSOTypes["ID_TOKEN"] = "id_token";
    SSOTypes["DOMAIN_HINT"] = "domain_hint";
    SSOTypes["ORGANIZATIONS"] = "organizations";
    SSOTypes["CONSUMERS"] = "consumers";
    SSOTypes["ACCOUNT_ID"] = "accountIdentifier";
    SSOTypes["HOMEACCOUNT_ID"] = "homeAccountIdentifier";
})(SSOTypes || (SSOTypes = {}));
/**
 * allowed values for codeVerifier
 */
var CodeChallengeMethodValues = {
    PLAIN: "plain",
    S256: "S256"
};
/**
 * allowed values for response_mode
 */
var ResponseMode;
(function (ResponseMode) {
    ResponseMode["QUERY"] = "query";
    ResponseMode["FRAGMENT"] = "fragment";
    ResponseMode["FORM_POST"] = "form_post";
})(ResponseMode || (ResponseMode = {}));
/**
 * allowed grant_type
 */
var GrantType;
(function (GrantType) {
    GrantType["IMPLICIT_GRANT"] = "implicit";
    GrantType["AUTHORIZATION_CODE_GRANT"] = "authorization_code";
    GrantType["CLIENT_CREDENTIALS_GRANT"] = "client_credentials";
    GrantType["RESOURCE_OWNER_PASSWORD_GRANT"] = "password";
    GrantType["REFRESH_TOKEN_GRANT"] = "refresh_token";
    GrantType["DEVICE_CODE_GRANT"] = "device_code";
    GrantType["JWT_BEARER"] = "urn:ietf:params:oauth:grant-type:jwt-bearer";
})(GrantType || (GrantType = {}));
/**
 * Account types in Cache
 */
var CacheAccountType;
(function (CacheAccountType) {
    CacheAccountType["MSSTS_ACCOUNT_TYPE"] = "MSSTS";
    CacheAccountType["ADFS_ACCOUNT_TYPE"] = "ADFS";
    CacheAccountType["MSAV1_ACCOUNT_TYPE"] = "MSA";
    CacheAccountType["GENERIC_ACCOUNT_TYPE"] = "Generic"; // NTLM, Kerberos, FBA, Basic etc
})(CacheAccountType || (CacheAccountType = {}));
/**
 * Separators used in cache
 */
var Separators;
(function (Separators) {
    Separators["CACHE_KEY_SEPARATOR"] = "-";
    Separators["CLIENT_INFO_SEPARATOR"] = ".";
})(Separators || (Separators = {}));
/**
 * Credential Type stored in the cache
 */
var CredentialType;
(function (CredentialType) {
    CredentialType["ID_TOKEN"] = "IdToken";
    CredentialType["ACCESS_TOKEN"] = "AccessToken";
    CredentialType["ACCESS_TOKEN_WITH_AUTH_SCHEME"] = "AccessToken_With_AuthScheme";
    CredentialType["REFRESH_TOKEN"] = "RefreshToken";
})(CredentialType || (CredentialType = {}));
/**
 * Credential Type stored in the cache
 */
var CacheSchemaType;
(function (CacheSchemaType) {
    CacheSchemaType["ACCOUNT"] = "Account";
    CacheSchemaType["CREDENTIAL"] = "Credential";
    CacheSchemaType["ID_TOKEN"] = "IdToken";
    CacheSchemaType["ACCESS_TOKEN"] = "AccessToken";
    CacheSchemaType["REFRESH_TOKEN"] = "RefreshToken";
    CacheSchemaType["APP_METADATA"] = "AppMetadata";
    CacheSchemaType["TEMPORARY"] = "TempCache";
    CacheSchemaType["TELEMETRY"] = "Telemetry";
    CacheSchemaType["UNDEFINED"] = "Undefined";
    CacheSchemaType["THROTTLING"] = "Throttling";
})(CacheSchemaType || (CacheSchemaType = {}));
/**
 * Combine all cache types
 */
var CacheType;
(function (CacheType) {
    CacheType[CacheType["ADFS"] = 1001] = "ADFS";
    CacheType[CacheType["MSA"] = 1002] = "MSA";
    CacheType[CacheType["MSSTS"] = 1003] = "MSSTS";
    CacheType[CacheType["GENERIC"] = 1004] = "GENERIC";
    CacheType[CacheType["ACCESS_TOKEN"] = 2001] = "ACCESS_TOKEN";
    CacheType[CacheType["REFRESH_TOKEN"] = 2002] = "REFRESH_TOKEN";
    CacheType[CacheType["ID_TOKEN"] = 2003] = "ID_TOKEN";
    CacheType[CacheType["APP_METADATA"] = 3001] = "APP_METADATA";
    CacheType[CacheType["UNDEFINED"] = 9999] = "UNDEFINED";
})(CacheType || (CacheType = {}));
/**
 * More Cache related constants
 */
var APP_METADATA = "appmetadata";
var CLIENT_INFO = "client_info";
var THE_FAMILY_ID = "1";
var AUTHORITY_METADATA_CONSTANTS = {
    CACHE_KEY: "authority-metadata",
    REFRESH_TIME_SECONDS: 3600 * 24 // 24 Hours
};
var AuthorityMetadataSource;
(function (AuthorityMetadataSource) {
    AuthorityMetadataSource["CONFIG"] = "config";
    AuthorityMetadataSource["CACHE"] = "cache";
    AuthorityMetadataSource["NETWORK"] = "network";
})(AuthorityMetadataSource || (AuthorityMetadataSource = {}));
var SERVER_TELEM_CONSTANTS = {
    SCHEMA_VERSION: 2,
    MAX_CUR_HEADER_BYTES: 80,
    MAX_LAST_HEADER_BYTES: 330,
    MAX_CACHED_ERRORS: 50,
    CACHE_KEY: "server-telemetry",
    CATEGORY_SEPARATOR: "|",
    VALUE_SEPARATOR: ",",
    OVERFLOW_TRUE: "1",
    OVERFLOW_FALSE: "0",
    UNKNOWN_ERROR: "unknown_error"
};
/**
 * Type of the authentication request
 */
var AuthenticationScheme;
(function (AuthenticationScheme) {
    AuthenticationScheme["POP"] = "pop";
    AuthenticationScheme["BEARER"] = "Bearer";
})(AuthenticationScheme || (AuthenticationScheme = {}));
/**
 * Constants related to throttling
 */
var ThrottlingConstants = {
    // Default time to throttle RequestThumbprint in seconds
    DEFAULT_THROTTLE_TIME_SECONDS: 60,
    // Default maximum time to throttle in seconds, overrides what the server sends back
    DEFAULT_MAX_THROTTLE_TIME_SECONDS: 3600,
    // Prefix for storing throttling entries
    THROTTLING_PREFIX: "throttling",
    // Value assigned to the x-ms-lib-capability header to indicate to the server the library supports throttling
    X_MS_LIB_CAPABILITY_VALUE: "retry-after, h429"
};
var Errors = {
    INVALID_GRANT_ERROR: "invalid_grant",
    CLIENT_MISMATCH_ERROR: "client_mismatch",
};
/**
 * Password grant parameters
 */
var PasswordGrantConstants;
(function (PasswordGrantConstants) {
    PasswordGrantConstants["username"] = "username";
    PasswordGrantConstants["password"] = "password";
})(PasswordGrantConstants || (PasswordGrantConstants = {}));
/**
 * Response codes
 */
var ResponseCodes;
(function (ResponseCodes) {
    ResponseCodes[ResponseCodes["httpSuccess"] = 200] = "httpSuccess";
    ResponseCodes[ResponseCodes["httpBadRequest"] = 400] = "httpBadRequest";
})(ResponseCodes || (ResponseCodes = {}));

/*! @azure/msal-common v4.4.0 2021-06-29 */

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * AuthErrorMessage class containing string constants used by error codes and messages.
 */
var AuthErrorMessage = {
    unexpectedError: {
        code: "unexpected_error",
        desc: "Unexpected error in authentication."
    }
};
/**
 * General error class thrown by the MSAL.js library.
 */
var AuthError = /** @class */ (function (_super) {
    __extends(AuthError, _super);
    function AuthError(errorCode, errorMessage, suberror) {
        var _this = this;
        var errorString = errorMessage ? errorCode + ": " + errorMessage : errorCode;
        _this = _super.call(this, errorString) || this;
        Object.setPrototypeOf(_this, AuthError.prototype);
        _this.errorCode = errorCode || Constants.EMPTY_STRING;
        _this.errorMessage = errorMessage || "";
        _this.subError = suberror || "";
        _this.name = "AuthError";
        return _this;
    }
    /**
     * Creates an error that is thrown when something unexpected happens in the library.
     * @param errDesc
     */
    AuthError.createUnexpectedError = function (errDesc) {
        return new AuthError(AuthErrorMessage.unexpectedError.code, AuthErrorMessage.unexpectedError.desc + ": " + errDesc);
    };
    return AuthError;
}(Error));

/*! @azure/msal-common v4.4.0 2021-06-29 */

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
var DEFAULT_CRYPTO_IMPLEMENTATION = {
    createNewGuid: function () {
        var notImplErr = "Crypto interface - createNewGuid() has not been implemented";
        throw AuthError.createUnexpectedError(notImplErr);
    },
    base64Decode: function () {
        var notImplErr = "Crypto interface - base64Decode() has not been implemented";
        throw AuthError.createUnexpectedError(notImplErr);
    },
    base64Encode: function () {
        var notImplErr = "Crypto interface - base64Encode() has not been implemented";
        throw AuthError.createUnexpectedError(notImplErr);
    },
    generatePkceCodes: function () {
        return __awaiter(this, void 0, void 0, function () {
            var notImplErr;
            return __generator(this, function (_a) {
                notImplErr = "Crypto interface - generatePkceCodes() has not been implemented";
                throw AuthError.createUnexpectedError(notImplErr);
            });
        });
    },
    getPublicKeyThumbprint: function () {
        return __awaiter(this, void 0, void 0, function () {
            var notImplErr;
            return __generator(this, function (_a) {
                notImplErr = "Crypto interface - getPublicKeyThumbprint() has not been implemented";
                throw AuthError.createUnexpectedError(notImplErr);
            });
        });
    },
    signJwt: function () {
        return __awaiter(this, void 0, void 0, function () {
            var notImplErr;
            return __generator(this, function (_a) {
                notImplErr = "Crypto interface - signJwt() has not been implemented";
                throw AuthError.createUnexpectedError(notImplErr);
            });
        });
    }
};

/*! @azure/msal-common v4.4.0 2021-06-29 */

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * ClientAuthErrorMessage class containing string constants used by error codes and messages.
 */
var ClientAuthErrorMessage = {
    clientInfoDecodingError: {
        code: "client_info_decoding_error",
        desc: "The client info could not be parsed/decoded correctly. Please review the trace to determine the root cause."
    },
    clientInfoEmptyError: {
        code: "client_info_empty_error",
        desc: "The client info was empty. Please review the trace to determine the root cause."
    },
    tokenParsingError: {
        code: "token_parsing_error",
        desc: "Token cannot be parsed. Please review stack trace to determine root cause."
    },
    nullOrEmptyToken: {
        code: "null_or_empty_token",
        desc: "The token is null or empty. Please review the trace to determine the root cause."
    },
    endpointResolutionError: {
        code: "endpoints_resolution_error",
        desc: "Error: could not resolve endpoints. Please check network and try again."
    },
    networkError: {
        code: "network_error",
        desc: "Network request failed. Please check network trace to determine root cause."
    },
    unableToGetOpenidConfigError: {
        code: "openid_config_error",
        desc: "Could not retrieve endpoints. Check your authority and verify the .well-known/openid-configuration endpoint returns the required endpoints."
    },
    hashNotDeserialized: {
        code: "hash_not_deserialized",
        desc: "The hash parameters could not be deserialized. Please review the trace to determine the root cause."
    },
    blankGuidGenerated: {
        code: "blank_guid_generated",
        desc: "The guid generated was blank. Please review the trace to determine the root cause."
    },
    invalidStateError: {
        code: "invalid_state",
        desc: "State was not the expected format. Please check the logs to determine whether the request was sent using ProtocolUtils.setRequestState()."
    },
    stateMismatchError: {
        code: "state_mismatch",
        desc: "State mismatch error. Please check your network. Continued requests may cause cache overflow."
    },
    stateNotFoundError: {
        code: "state_not_found",
        desc: "State not found"
    },
    nonceMismatchError: {
        code: "nonce_mismatch",
        desc: "Nonce mismatch error. This may be caused by a race condition in concurrent requests."
    },
    nonceNotFoundError: {
        code: "nonce_not_found",
        desc: "nonce not found"
    },
    noTokensFoundError: {
        code: "no_tokens_found",
        desc: "No tokens were found for the given scopes, and no authorization code was passed to acquireToken. You must retrieve an authorization code before making a call to acquireToken()."
    },
    multipleMatchingTokens: {
        code: "multiple_matching_tokens",
        desc: "The cache contains multiple tokens satisfying the requirements. " +
            "Call AcquireToken again providing more requirements such as authority or account."
    },
    multipleMatchingAccounts: {
        code: "multiple_matching_accounts",
        desc: "The cache contains multiple accounts satisfying the given parameters. Please pass more info to obtain the correct account"
    },
    multipleMatchingAppMetadata: {
        code: "multiple_matching_appMetadata",
        desc: "The cache contains multiple appMetadata satisfying the given parameters. Please pass more info to obtain the correct appMetadata"
    },
    tokenRequestCannotBeMade: {
        code: "request_cannot_be_made",
        desc: "Token request cannot be made without authorization code or refresh token."
    },
    appendEmptyScopeError: {
        code: "cannot_append_empty_scope",
        desc: "Cannot append null or empty scope to ScopeSet. Please check the stack trace for more info."
    },
    removeEmptyScopeError: {
        code: "cannot_remove_empty_scope",
        desc: "Cannot remove null or empty scope from ScopeSet. Please check the stack trace for more info."
    },
    appendScopeSetError: {
        code: "cannot_append_scopeset",
        desc: "Cannot append ScopeSet due to error."
    },
    emptyInputScopeSetError: {
        code: "empty_input_scopeset",
        desc: "Empty input ScopeSet cannot be processed."
    },
    DeviceCodePollingCancelled: {
        code: "device_code_polling_cancelled",
        desc: "Caller has cancelled token endpoint polling during device code flow by setting DeviceCodeRequest.cancel = true."
    },
    DeviceCodeExpired: {
        code: "device_code_expired",
        desc: "Device code is expired."
    },
    DeviceCodeUnknownError: {
        code: "device_code_unknown_error",
        desc: "Device code stopped polling for unknown reasons."
    },
    NoAccountInSilentRequest: {
        code: "no_account_in_silent_request",
        desc: "Please pass an account object, silent flow is not supported without account information"
    },
    invalidCacheRecord: {
        code: "invalid_cache_record",
        desc: "Cache record object was null or undefined."
    },
    invalidCacheEnvironment: {
        code: "invalid_cache_environment",
        desc: "Invalid environment when attempting to create cache entry"
    },
    noAccountFound: {
        code: "no_account_found",
        desc: "No account found in cache for given key."
    },
    CachePluginError: {
        code: "no cache plugin set on CacheManager",
        desc: "ICachePlugin needs to be set before using readFromStorage or writeFromStorage"
    },
    noCryptoObj: {
        code: "no_crypto_object",
        desc: "No crypto object detected. This is required for the following operation: "
    },
    invalidCacheType: {
        code: "invalid_cache_type",
        desc: "Invalid cache type"
    },
    unexpectedAccountType: {
        code: "unexpected_account_type",
        desc: "Unexpected account type."
    },
    unexpectedCredentialType: {
        code: "unexpected_credential_type",
        desc: "Unexpected credential type."
    },
    invalidAssertion: {
        code: "invalid_assertion",
        desc: "Client assertion must meet requirements described in https://tools.ietf.org/html/rfc7515"
    },
    invalidClientCredential: {
        code: "invalid_client_credential",
        desc: "Client credential (secret, certificate, or assertion) must not be empty when creating a confidential client. An application should at most have one credential"
    },
    tokenRefreshRequired: {
        code: "token_refresh_required",
        desc: "Cannot return token from cache because it must be refreshed. This may be due to one of the following reasons: forceRefresh parameter is set to true, claims have been requested, there is no cached access token or it is expired."
    },
    userTimeoutReached: {
        code: "user_timeout_reached",
        desc: "User defined timeout for device code polling reached",
    },
    tokenClaimsRequired: {
        code: "token_claims_cnf_required_for_signedjwt",
        desc: "Cannot generate a POP jwt if the token_claims are not populated"
    },
    noAuthorizationCodeFromServer: {
        code: "authorization_code_missing_from_server_response",
        desc: "Server response does not contain an authorization code to proceed"
    },
    noAzureRegionDetected: {
        code: "no_azure_region_detected",
        desc: "No azure region was detected and no fallback was made available"
    },
    accessTokenEntityNullError: {
        code: "access_token_entity_null",
        desc: "Access token entity is null, please check logs and cache to ensure a valid access token is present."
    }
};
/**
 * Error thrown when there is an error in the client code running on the browser.
 */
var ClientAuthError = /** @class */ (function (_super) {
    __extends(ClientAuthError, _super);
    function ClientAuthError(errorCode, errorMessage) {
        var _this = _super.call(this, errorCode, errorMessage) || this;
        _this.name = "ClientAuthError";
        Object.setPrototypeOf(_this, ClientAuthError.prototype);
        return _this;
    }
    /**
     * Creates an error thrown when client info object doesn't decode correctly.
     * @param caughtError
     */
    ClientAuthError.createClientInfoDecodingError = function (caughtError) {
        return new ClientAuthError(ClientAuthErrorMessage.clientInfoDecodingError.code, ClientAuthErrorMessage.clientInfoDecodingError.desc + " Failed with error: " + caughtError);
    };
    /**
     * Creates an error thrown if the client info is empty.
     * @param rawClientInfo
     */
    ClientAuthError.createClientInfoEmptyError = function () {
        return new ClientAuthError(ClientAuthErrorMessage.clientInfoEmptyError.code, "" + ClientAuthErrorMessage.clientInfoEmptyError.desc);
    };
    /**
     * Creates an error thrown when the id token extraction errors out.
     * @param err
     */
    ClientAuthError.createTokenParsingError = function (caughtExtractionError) {
        return new ClientAuthError(ClientAuthErrorMessage.tokenParsingError.code, ClientAuthErrorMessage.tokenParsingError.desc + " Failed with error: " + caughtExtractionError);
    };
    /**
     * Creates an error thrown when the id token string is null or empty.
     * @param invalidRawTokenString
     */
    ClientAuthError.createTokenNullOrEmptyError = function (invalidRawTokenString) {
        return new ClientAuthError(ClientAuthErrorMessage.nullOrEmptyToken.code, ClientAuthErrorMessage.nullOrEmptyToken.desc + " Raw Token Value: " + invalidRawTokenString);
    };
    /**
     * Creates an error thrown when the endpoint discovery doesn't complete correctly.
     */
    ClientAuthError.createEndpointDiscoveryIncompleteError = function (errDetail) {
        return new ClientAuthError(ClientAuthErrorMessage.endpointResolutionError.code, ClientAuthErrorMessage.endpointResolutionError.desc + " Detail: " + errDetail);
    };
    /**
     * Creates an error thrown when the fetch client throws
     */
    ClientAuthError.createNetworkError = function (endpoint, errDetail) {
        return new ClientAuthError(ClientAuthErrorMessage.networkError.code, ClientAuthErrorMessage.networkError.desc + " | Fetch client threw: " + errDetail + " | Attempted to reach: " + endpoint.split("?")[0]);
    };
    /**
     * Creates an error thrown when the openid-configuration endpoint cannot be reached or does not contain the required data
     */
    ClientAuthError.createUnableToGetOpenidConfigError = function (errDetail) {
        return new ClientAuthError(ClientAuthErrorMessage.unableToGetOpenidConfigError.code, ClientAuthErrorMessage.unableToGetOpenidConfigError.desc + " Attempted to retrieve endpoints from: " + errDetail);
    };
    /**
     * Creates an error thrown when the hash cannot be deserialized.
     * @param hashParamObj
     */
    ClientAuthError.createHashNotDeserializedError = function (hashParamObj) {
        return new ClientAuthError(ClientAuthErrorMessage.hashNotDeserialized.code, ClientAuthErrorMessage.hashNotDeserialized.desc + " Given Object: " + hashParamObj);
    };
    /**
     * Creates an error thrown when the state cannot be parsed.
     * @param invalidState
     */
    ClientAuthError.createInvalidStateError = function (invalidState, errorString) {
        return new ClientAuthError(ClientAuthErrorMessage.invalidStateError.code, ClientAuthErrorMessage.invalidStateError.desc + " Invalid State: " + invalidState + ", Root Err: " + errorString);
    };
    /**
     * Creates an error thrown when two states do not match.
     */
    ClientAuthError.createStateMismatchError = function () {
        return new ClientAuthError(ClientAuthErrorMessage.stateMismatchError.code, ClientAuthErrorMessage.stateMismatchError.desc);
    };
    /**
     * Creates an error thrown when the state is not present
     * @param missingState
     */
    ClientAuthError.createStateNotFoundError = function (missingState) {
        return new ClientAuthError(ClientAuthErrorMessage.stateNotFoundError.code, ClientAuthErrorMessage.stateNotFoundError.desc + ":  " + missingState);
    };
    /**
     * Creates an error thrown when the nonce does not match.
     */
    ClientAuthError.createNonceMismatchError = function () {
        return new ClientAuthError(ClientAuthErrorMessage.nonceMismatchError.code, ClientAuthErrorMessage.nonceMismatchError.desc);
    };
    /**
     * Creates an error thrown when the mnonce is not present
     * @param missingNonce
     */
    ClientAuthError.createNonceNotFoundError = function (missingNonce) {
        return new ClientAuthError(ClientAuthErrorMessage.nonceNotFoundError.code, ClientAuthErrorMessage.nonceNotFoundError.desc + ":  " + missingNonce);
    };
    /**
     * Creates an error thrown when the authorization code required for a token request is null or empty.
     */
    ClientAuthError.createNoTokensFoundError = function () {
        return new ClientAuthError(ClientAuthErrorMessage.noTokensFoundError.code, ClientAuthErrorMessage.noTokensFoundError.desc);
    };
    /**
     * Throws error when multiple tokens are in cache.
     */
    ClientAuthError.createMultipleMatchingTokensInCacheError = function () {
        return new ClientAuthError(ClientAuthErrorMessage.multipleMatchingTokens.code, ClientAuthErrorMessage.multipleMatchingTokens.desc + ".");
    };
    /**
     * Throws error when multiple accounts are in cache for the given params
     */
    ClientAuthError.createMultipleMatchingAccountsInCacheError = function () {
        return new ClientAuthError(ClientAuthErrorMessage.multipleMatchingAccounts.code, ClientAuthErrorMessage.multipleMatchingAccounts.desc);
    };
    /**
     * Throws error when multiple appMetada are in cache for the given clientId.
     */
    ClientAuthError.createMultipleMatchingAppMetadataInCacheError = function () {
        return new ClientAuthError(ClientAuthErrorMessage.multipleMatchingAppMetadata.code, ClientAuthErrorMessage.multipleMatchingAppMetadata.desc);
    };
    /**
     * Throws error when no auth code or refresh token is given to ServerTokenRequestParameters.
     */
    ClientAuthError.createTokenRequestCannotBeMadeError = function () {
        return new ClientAuthError(ClientAuthErrorMessage.tokenRequestCannotBeMade.code, ClientAuthErrorMessage.tokenRequestCannotBeMade.desc);
    };
    /**
     * Throws error when attempting to append a null, undefined or empty scope to a set
     * @param givenScope
     */
    ClientAuthError.createAppendEmptyScopeToSetError = function (givenScope) {
        return new ClientAuthError(ClientAuthErrorMessage.appendEmptyScopeError.code, ClientAuthErrorMessage.appendEmptyScopeError.desc + " Given Scope: " + givenScope);
    };
    /**
     * Throws error when attempting to append a null, undefined or empty scope to a set
     * @param givenScope
     */
    ClientAuthError.createRemoveEmptyScopeFromSetError = function (givenScope) {
        return new ClientAuthError(ClientAuthErrorMessage.removeEmptyScopeError.code, ClientAuthErrorMessage.removeEmptyScopeError.desc + " Given Scope: " + givenScope);
    };
    /**
     * Throws error when attempting to append null or empty ScopeSet.
     * @param appendError
     */
    ClientAuthError.createAppendScopeSetError = function (appendError) {
        return new ClientAuthError(ClientAuthErrorMessage.appendScopeSetError.code, ClientAuthErrorMessage.appendScopeSetError.desc + " Detail Error: " + appendError);
    };
    /**
     * Throws error if ScopeSet is null or undefined.
     * @param givenScopeSet
     */
    ClientAuthError.createEmptyInputScopeSetError = function () {
        return new ClientAuthError(ClientAuthErrorMessage.emptyInputScopeSetError.code, "" + ClientAuthErrorMessage.emptyInputScopeSetError.desc);
    };
    /**
     * Throws error if user sets CancellationToken.cancel = true during polling of token endpoint during device code flow
     */
    ClientAuthError.createDeviceCodeCancelledError = function () {
        return new ClientAuthError(ClientAuthErrorMessage.DeviceCodePollingCancelled.code, "" + ClientAuthErrorMessage.DeviceCodePollingCancelled.desc);
    };
    /**
     * Throws error if device code is expired
     */
    ClientAuthError.createDeviceCodeExpiredError = function () {
        return new ClientAuthError(ClientAuthErrorMessage.DeviceCodeExpired.code, "" + ClientAuthErrorMessage.DeviceCodeExpired.desc);
    };
    /**
     * Throws error if device code is expired
     */
    ClientAuthError.createDeviceCodeUnknownError = function () {
        return new ClientAuthError(ClientAuthErrorMessage.DeviceCodeUnknownError.code, "" + ClientAuthErrorMessage.DeviceCodeUnknownError.desc);
    };
    /**
     * Throws error when silent requests are made without an account object
     */
    ClientAuthError.createNoAccountInSilentRequestError = function () {
        return new ClientAuthError(ClientAuthErrorMessage.NoAccountInSilentRequest.code, "" + ClientAuthErrorMessage.NoAccountInSilentRequest.desc);
    };
    /**
     * Throws error when cache record is null or undefined.
     */
    ClientAuthError.createNullOrUndefinedCacheRecord = function () {
        return new ClientAuthError(ClientAuthErrorMessage.invalidCacheRecord.code, ClientAuthErrorMessage.invalidCacheRecord.desc);
    };
    /**
     * Throws error when provided environment is not part of the CloudDiscoveryMetadata object
     */
    ClientAuthError.createInvalidCacheEnvironmentError = function () {
        return new ClientAuthError(ClientAuthErrorMessage.invalidCacheEnvironment.code, ClientAuthErrorMessage.invalidCacheEnvironment.desc);
    };
    /**
     * Throws error when account is not found in cache.
     */
    ClientAuthError.createNoAccountFoundError = function () {
        return new ClientAuthError(ClientAuthErrorMessage.noAccountFound.code, ClientAuthErrorMessage.noAccountFound.desc);
    };
    /**
     * Throws error if ICachePlugin not set on CacheManager.
     */
    ClientAuthError.createCachePluginError = function () {
        return new ClientAuthError(ClientAuthErrorMessage.CachePluginError.code, "" + ClientAuthErrorMessage.CachePluginError.desc);
    };
    /**
     * Throws error if crypto object not found.
     * @param operationName
     */
    ClientAuthError.createNoCryptoObjectError = function (operationName) {
        return new ClientAuthError(ClientAuthErrorMessage.noCryptoObj.code, "" + ClientAuthErrorMessage.noCryptoObj.desc + operationName);
    };
    /**
     * Throws error if cache type is invalid.
     */
    ClientAuthError.createInvalidCacheTypeError = function () {
        return new ClientAuthError(ClientAuthErrorMessage.invalidCacheType.code, "" + ClientAuthErrorMessage.invalidCacheType.desc);
    };
    /**
     * Throws error if unexpected account type.
     */
    ClientAuthError.createUnexpectedAccountTypeError = function () {
        return new ClientAuthError(ClientAuthErrorMessage.unexpectedAccountType.code, "" + ClientAuthErrorMessage.unexpectedAccountType.desc);
    };
    /**
     * Throws error if unexpected credential type.
     */
    ClientAuthError.createUnexpectedCredentialTypeError = function () {
        return new ClientAuthError(ClientAuthErrorMessage.unexpectedCredentialType.code, "" + ClientAuthErrorMessage.unexpectedCredentialType.desc);
    };
    /**
     * Throws error if client assertion is not valid.
     */
    ClientAuthError.createInvalidAssertionError = function () {
        return new ClientAuthError(ClientAuthErrorMessage.invalidAssertion.code, "" + ClientAuthErrorMessage.invalidAssertion.desc);
    };
    /**
     * Throws error if client assertion is not valid.
     */
    ClientAuthError.createInvalidCredentialError = function () {
        return new ClientAuthError(ClientAuthErrorMessage.invalidClientCredential.code, "" + ClientAuthErrorMessage.invalidClientCredential.desc);
    };
    /**
     * Throws error if token cannot be retrieved from cache due to refresh being required.
     */
    ClientAuthError.createRefreshRequiredError = function () {
        return new ClientAuthError(ClientAuthErrorMessage.tokenRefreshRequired.code, ClientAuthErrorMessage.tokenRefreshRequired.desc);
    };
    /**
     * Throws error if the user defined timeout is reached.
     */
    ClientAuthError.createUserTimeoutReachedError = function () {
        return new ClientAuthError(ClientAuthErrorMessage.userTimeoutReached.code, ClientAuthErrorMessage.userTimeoutReached.desc);
    };
    /*
     * Throws error if token claims are not populated for a signed jwt generation
     */
    ClientAuthError.createTokenClaimsRequiredError = function () {
        return new ClientAuthError(ClientAuthErrorMessage.tokenClaimsRequired.code, ClientAuthErrorMessage.tokenClaimsRequired.desc);
    };
    /**
     * Throws error when the authorization code is missing from the server response
     */
    ClientAuthError.createNoAuthCodeInServerResponseError = function () {
        return new ClientAuthError(ClientAuthErrorMessage.noAuthorizationCodeFromServer.code, ClientAuthErrorMessage.noAuthorizationCodeFromServer.desc);
    };
    return ClientAuthError;
}(AuthError));

/*! @azure/msal-common v4.4.0 2021-06-29 */

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * @hidden
 */
var StringUtils = /** @class */ (function () {
    function StringUtils() {
    }
    /**
     * decode a JWT
     *
     * @param authToken
     */
    StringUtils.decodeAuthToken = function (authToken) {
        if (StringUtils.isEmpty(authToken)) {
            throw ClientAuthError.createTokenNullOrEmptyError(authToken);
        }
        var tokenPartsRegex = /^([^\.\s]*)\.([^\.\s]+)\.([^\.\s]*)$/;
        var matches = tokenPartsRegex.exec(authToken);
        if (!matches || matches.length < 4) {
            throw ClientAuthError.createTokenParsingError("Given token is malformed: " + JSON.stringify(authToken));
        }
        var crackedToken = {
            header: matches[1],
            JWSPayload: matches[2],
            JWSSig: matches[3]
        };
        return crackedToken;
    };
    /**
     * Check if a string is empty.
     *
     * @param str
     */
    StringUtils.isEmpty = function (str) {
        return (typeof str === "undefined" || !str || 0 === str.length);
    };
    /**
     * Check if stringified object is empty
     * @param strObj
     */
    StringUtils.isEmptyObj = function (strObj) {
        if (strObj && !StringUtils.isEmpty(strObj)) {
            try {
                var obj = JSON.parse(strObj);
                return Object.keys(obj).length === 0;
            }
            catch (e) { }
        }
        return true;
    };
    StringUtils.startsWith = function (str, search) {
        return str.indexOf(search) === 0;
    };
    StringUtils.endsWith = function (str, search) {
        return (str.length >= search.length) && (str.lastIndexOf(search) === (str.length - search.length));
    };
    /**
     * Parses string into an object.
     *
     * @param query
     */
    StringUtils.queryStringToObject = function (query) {
        var match; // Regex for replacing addition symbol with a space
        var pl = /\+/g;
        var search = /([^&=]+)=([^&]*)/g;
        var decode = function (s) { return decodeURIComponent(decodeURIComponent(s.replace(pl, " "))); };
        var obj = {};
        match = search.exec(query);
        while (match) {
            obj[decode(match[1])] = decode(match[2]);
            match = search.exec(query);
        }
        return obj;
    };
    /**
     * Trims entries in an array.
     *
     * @param arr
     */
    StringUtils.trimArrayEntries = function (arr) {
        return arr.map(function (entry) { return entry.trim(); });
    };
    /**
     * Removes empty strings from array
     * @param arr
     */
    StringUtils.removeEmptyStringsFromArray = function (arr) {
        return arr.filter(function (entry) {
            return !StringUtils.isEmpty(entry);
        });
    };
    /**
     * Attempts to parse a string into JSON
     * @param str
     */
    StringUtils.jsonParseHelper = function (str) {
        try {
            return JSON.parse(str);
        }
        catch (e) {
            return null;
        }
    };
    /**
     * Tests if a given string matches a given pattern, with support for wildcards and queries.
     * @param pattern Wildcard pattern to string match. Supports "*" for wildcards and "?" for queries
     * @param input String to match against
     */
    StringUtils.matchPattern = function (pattern, input) {
        /**
         * Wildcard support: https://stackoverflow.com/a/3117248/4888559
         * Queries: replaces "?" in string with escaped "\?" for regex test
         */
        var regex = new RegExp(pattern.replace(/\*/g, "[^ ]*").replace(/\?/g, "\\\?"));
        return regex.test(input);
    };
    return StringUtils;
}());

/*! @azure/msal-common v4.4.0 2021-06-29 */

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * Log message level.
 */
var LogLevel$1;
(function (LogLevel) {
    LogLevel[LogLevel["Error"] = 0] = "Error";
    LogLevel[LogLevel["Warning"] = 1] = "Warning";
    LogLevel[LogLevel["Info"] = 2] = "Info";
    LogLevel[LogLevel["Verbose"] = 3] = "Verbose";
    LogLevel[LogLevel["Trace"] = 4] = "Trace";
})(LogLevel$1 || (LogLevel$1 = {}));
/**
 * Class which facilitates logging of messages to a specific place.
 */
var Logger$1 = /** @class */ (function () {
    function Logger(loggerOptions, packageName, packageVersion) {
        // Current log level, defaults to info.
        this.level = LogLevel$1.Info;
        var defaultLoggerCallback = function () { };
        this.localCallback = loggerOptions.loggerCallback || defaultLoggerCallback;
        this.piiLoggingEnabled = loggerOptions.piiLoggingEnabled || false;
        this.level = loggerOptions.logLevel || LogLevel$1.Info;
        this.correlationId = loggerOptions.correlationId || "";
        this.packageName = packageName || Constants.EMPTY_STRING;
        this.packageVersion = packageVersion || Constants.EMPTY_STRING;
    }
    /**
     * Create new Logger with existing configurations.
     */
    Logger.prototype.clone = function (packageName, packageVersion, correlationId) {
        return new Logger({ loggerCallback: this.localCallback, piiLoggingEnabled: this.piiLoggingEnabled, logLevel: this.level, correlationId: correlationId || this.correlationId }, packageName, packageVersion);
    };
    /**
     * Log message with required options.
     */
    Logger.prototype.logMessage = function (logMessage, options) {
        if ((options.logLevel > this.level) || (!this.piiLoggingEnabled && options.containsPii)) {
            return;
        }
        var timestamp = new Date().toUTCString();
        // Add correlationId to logs if set, correlationId provided on log messages take precedence
        var logHeader;
        if (!StringUtils.isEmpty(options.correlationId)) {
            logHeader = "[" + timestamp + "] : [" + options.correlationId + "]";
        }
        else if (!StringUtils.isEmpty(this.correlationId)) {
            logHeader = "[" + timestamp + "] : [" + this.correlationId + "]";
        }
        else {
            logHeader = "[" + timestamp + "]";
        }
        var log = logHeader + " : " + this.packageName + "@" + this.packageVersion + " : " + LogLevel$1[options.logLevel] + " - " + logMessage;
        // debug(`msal:${LogLevel[options.logLevel]}${options.containsPii ? "-Pii": ""}${options.context ? `:${options.context}` : ""}`)(logMessage);
        this.executeCallback(options.logLevel, log, options.containsPii || false);
    };
    /**
     * Execute callback with message.
     */
    Logger.prototype.executeCallback = function (level, message, containsPii) {
        if (this.localCallback) {
            this.localCallback(level, message, containsPii);
        }
    };
    /**
     * Logs error messages.
     */
    Logger.prototype.error = function (message, correlationId) {
        this.logMessage(message, {
            logLevel: LogLevel$1.Error,
            containsPii: false,
            correlationId: correlationId || ""
        });
    };
    /**
     * Logs error messages with PII.
     */
    Logger.prototype.errorPii = function (message, correlationId) {
        this.logMessage(message, {
            logLevel: LogLevel$1.Error,
            containsPii: true,
            correlationId: correlationId || ""
        });
    };
    /**
     * Logs warning messages.
     */
    Logger.prototype.warning = function (message, correlationId) {
        this.logMessage(message, {
            logLevel: LogLevel$1.Warning,
            containsPii: false,
            correlationId: correlationId || ""
        });
    };
    /**
     * Logs warning messages with PII.
     */
    Logger.prototype.warningPii = function (message, correlationId) {
        this.logMessage(message, {
            logLevel: LogLevel$1.Warning,
            containsPii: true,
            correlationId: correlationId || ""
        });
    };
    /**
     * Logs info messages.
     */
    Logger.prototype.info = function (message, correlationId) {
        this.logMessage(message, {
            logLevel: LogLevel$1.Info,
            containsPii: false,
            correlationId: correlationId || ""
        });
    };
    /**
     * Logs info messages with PII.
     */
    Logger.prototype.infoPii = function (message, correlationId) {
        this.logMessage(message, {
            logLevel: LogLevel$1.Info,
            containsPii: true,
            correlationId: correlationId || ""
        });
    };
    /**
     * Logs verbose messages.
     */
    Logger.prototype.verbose = function (message, correlationId) {
        this.logMessage(message, {
            logLevel: LogLevel$1.Verbose,
            containsPii: false,
            correlationId: correlationId || ""
        });
    };
    /**
     * Logs verbose messages with PII.
     */
    Logger.prototype.verbosePii = function (message, correlationId) {
        this.logMessage(message, {
            logLevel: LogLevel$1.Verbose,
            containsPii: true,
            correlationId: correlationId || ""
        });
    };
    /**
     * Logs trace messages.
     */
    Logger.prototype.trace = function (message, correlationId) {
        this.logMessage(message, {
            logLevel: LogLevel$1.Trace,
            containsPii: false,
            correlationId: correlationId || ""
        });
    };
    /**
     * Logs trace messages with PII.
     */
    Logger.prototype.tracePii = function (message, correlationId) {
        this.logMessage(message, {
            logLevel: LogLevel$1.Trace,
            containsPii: true,
            correlationId: correlationId || ""
        });
    };
    /**
     * Returns whether PII Logging is enabled or not.
     */
    Logger.prototype.isPiiLoggingEnabled = function () {
        return this.piiLoggingEnabled || false;
    };
    return Logger;
}());

/*! @azure/msal-common v4.4.0 2021-06-29 */
/* eslint-disable header/header */
var name$t = "@azure/msal-common";
var version$5 = "4.4.0";

/*! @azure/msal-common v4.4.0 2021-06-29 */

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * Base type for credentials to be stored in the cache: eg: ACCESS_TOKEN, ID_TOKEN etc
 *
 * Key:Value Schema:
 *
 * Key: <home_account_id*>-<environment>-<credential_type>-<client_id>-<realm*>-<target*>
 *
 * Value Schema:
 * {
 *      homeAccountId: home account identifier for the auth scheme,
 *      environment: entity that issued the token, represented as a full host
 *      credentialType: Type of credential as a string, can be one of the following: RefreshToken, AccessToken, IdToken, Password, Cookie, Certificate, Other
 *      clientId: client ID of the application
 *      secret: Actual credential as a string
 *      familyId: Family ID identifier, usually only used for refresh tokens
 *      realm: Full tenant or organizational identifier that the account belongs to
 *      target: Permissions that are included in the token, or for refresh tokens, the resource identifier.
 *      oboAssertion: access token passed in as part of OBO request
 * }
 */
var CredentialEntity = /** @class */ (function () {
    function CredentialEntity() {
    }
    /**
     * Generate Account Id key component as per the schema: <home_account_id>-<environment>
     */
    CredentialEntity.prototype.generateAccountId = function () {
        return CredentialEntity.generateAccountIdForCacheKey(this.homeAccountId, this.environment);
    };
    /**
     * Generate Credential Id key component as per the schema: <credential_type>-<client_id>-<realm>
     */
    CredentialEntity.prototype.generateCredentialId = function () {
        return CredentialEntity.generateCredentialIdForCacheKey(this.credentialType, this.clientId, this.realm, this.familyId);
    };
    /**
     * Generate target key component as per schema: <target>
     */
    CredentialEntity.prototype.generateTarget = function () {
        return CredentialEntity.generateTargetForCacheKey(this.target);
    };
    /**
     * generates credential key
     */
    CredentialEntity.prototype.generateCredentialKey = function () {
        return CredentialEntity.generateCredentialCacheKey(this.homeAccountId, this.environment, this.credentialType, this.clientId, this.realm, this.target, this.familyId);
    };
    /**
     * returns the type of the cache (in this case credential)
     */
    CredentialEntity.prototype.generateType = function () {
        switch (this.credentialType) {
            case CredentialType.ID_TOKEN:
                return CacheType.ID_TOKEN;
            case CredentialType.ACCESS_TOKEN:
                return CacheType.ACCESS_TOKEN;
            case CredentialType.REFRESH_TOKEN:
                return CacheType.REFRESH_TOKEN;
            default: {
                throw ClientAuthError.createUnexpectedCredentialTypeError();
            }
        }
    };
    /**
     * helper function to return `CredentialType`
     * @param key
     */
    CredentialEntity.getCredentialType = function (key) {
        // First keyword search will match all "AccessToken" and "AccessToken_With_AuthScheme" credentials
        if (key.indexOf(CredentialType.ACCESS_TOKEN.toLowerCase()) !== -1) {
            // Perform second search to differentiate between "AccessToken" and "AccessToken_With_AuthScheme" credential types
            if (key.indexOf(CredentialType.ACCESS_TOKEN_WITH_AUTH_SCHEME.toLowerCase()) !== -1) {
                return CredentialType.ACCESS_TOKEN_WITH_AUTH_SCHEME;
            }
            return CredentialType.ACCESS_TOKEN;
        }
        else if (key.indexOf(CredentialType.ID_TOKEN.toLowerCase()) !== -1) {
            return CredentialType.ID_TOKEN;
        }
        else if (key.indexOf(CredentialType.REFRESH_TOKEN.toLowerCase()) !== -1) {
            return CredentialType.REFRESH_TOKEN;
        }
        return Constants.NOT_DEFINED;
    };
    /**
     * generates credential key
     */
    CredentialEntity.generateCredentialCacheKey = function (homeAccountId, environment, credentialType, clientId, realm, target, familyId) {
        var credentialKey = [
            this.generateAccountIdForCacheKey(homeAccountId, environment),
            this.generateCredentialIdForCacheKey(credentialType, clientId, realm, familyId),
            this.generateTargetForCacheKey(target),
        ];
        return credentialKey.join(Separators.CACHE_KEY_SEPARATOR).toLowerCase();
    };
    /**
     * generates Account Id for keys
     * @param homeAccountId
     * @param environment
     */
    CredentialEntity.generateAccountIdForCacheKey = function (homeAccountId, environment) {
        var accountId = [homeAccountId, environment];
        return accountId.join(Separators.CACHE_KEY_SEPARATOR).toLowerCase();
    };
    /**
     * Generates Credential Id for keys
     * @param credentialType
     * @param realm
     * @param clientId
     * @param familyId
     */
    CredentialEntity.generateCredentialIdForCacheKey = function (credentialType, clientId, realm, familyId) {
        var clientOrFamilyId = credentialType === CredentialType.REFRESH_TOKEN
            ? familyId || clientId
            : clientId;
        var credentialId = [
            credentialType,
            clientOrFamilyId,
            realm || "",
        ];
        return credentialId.join(Separators.CACHE_KEY_SEPARATOR).toLowerCase();
    };
    /**
     * Generate target key component as per schema: <target>
     */
    CredentialEntity.generateTargetForCacheKey = function (scopes) {
        return (scopes || "").toLowerCase();
    };
    return CredentialEntity;
}());

/*! @azure/msal-common v4.4.0 2021-06-29 */

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * ClientConfigurationErrorMessage class containing string constants used by error codes and messages.
 */
var ClientConfigurationErrorMessage = {
    redirectUriNotSet: {
        code: "redirect_uri_empty",
        desc: "A redirect URI is required for all calls, and none has been set."
    },
    postLogoutUriNotSet: {
        code: "post_logout_uri_empty",
        desc: "A post logout redirect has not been set."
    },
    claimsRequestParsingError: {
        code: "claims_request_parsing_error",
        desc: "Could not parse the given claims request object."
    },
    authorityUriInsecure: {
        code: "authority_uri_insecure",
        desc: "Authority URIs must use https.  Please see here for valid authority configuration options: https://docs.microsoft.com/en-us/azure/active-directory/develop/msal-js-initializing-client-applications#configuration-options"
    },
    urlParseError: {
        code: "url_parse_error",
        desc: "URL could not be parsed into appropriate segments."
    },
    urlEmptyError: {
        code: "empty_url_error",
        desc: "URL was empty or null."
    },
    emptyScopesError: {
        code: "empty_input_scopes_error",
        desc: "Scopes cannot be passed as null, undefined or empty array because they are required to obtain an access token."
    },
    nonArrayScopesError: {
        code: "nonarray_input_scopes_error",
        desc: "Scopes cannot be passed as non-array."
    },
    clientIdSingleScopeError: {
        code: "clientid_input_scopes_error",
        desc: "Client ID can only be provided as a single scope."
    },
    invalidPrompt: {
        code: "invalid_prompt_value",
        desc: "Supported prompt values are 'login', 'select_account', 'consent' and 'none'.  Please see here for valid configuration options: https://docs.microsoft.com/en-us/azure/active-directory/develop/msal-js-initializing-client-applications#configuration-options",
    },
    invalidClaimsRequest: {
        code: "invalid_claims",
        desc: "Given claims parameter must be a stringified JSON object."
    },
    tokenRequestEmptyError: {
        code: "token_request_empty",
        desc: "Token request was empty and not found in cache."
    },
    logoutRequestEmptyError: {
        code: "logout_request_empty",
        desc: "The logout request was null or undefined."
    },
    invalidCodeChallengeMethod: {
        code: "invalid_code_challenge_method",
        desc: "code_challenge_method passed is invalid. Valid values are \"plain\" and \"S256\"."
    },
    invalidCodeChallengeParams: {
        code: "pkce_params_missing",
        desc: "Both params: code_challenge and code_challenge_method are to be passed if to be sent in the request"
    },
    invalidCloudDiscoveryMetadata: {
        code: "invalid_cloud_discovery_metadata",
        desc: "Invalid cloudDiscoveryMetadata provided. Must be a JSON object containing tenant_discovery_endpoint and metadata fields"
    },
    invalidAuthorityMetadata: {
        code: "invalid_authority_metadata",
        desc: "Invalid authorityMetadata provided. Must by a JSON object containing authorization_endpoint, token_endpoint, end_session_endpoint, issuer fields."
    },
    untrustedAuthority: {
        code: "untrusted_authority",
        desc: "The provided authority is not a trusted authority. Please include this authority in the knownAuthorities config parameter."
    }
};
/**
 * Error thrown when there is an error in configuration of the MSAL.js library.
 */
var ClientConfigurationError = /** @class */ (function (_super) {
    __extends(ClientConfigurationError, _super);
    function ClientConfigurationError(errorCode, errorMessage) {
        var _this = _super.call(this, errorCode, errorMessage) || this;
        _this.name = "ClientConfigurationError";
        Object.setPrototypeOf(_this, ClientConfigurationError.prototype);
        return _this;
    }
    /**
     * Creates an error thrown when the redirect uri is empty (not set by caller)
     */
    ClientConfigurationError.createRedirectUriEmptyError = function () {
        return new ClientConfigurationError(ClientConfigurationErrorMessage.redirectUriNotSet.code, ClientConfigurationErrorMessage.redirectUriNotSet.desc);
    };
    /**
     * Creates an error thrown when the post-logout redirect uri is empty (not set by caller)
     */
    ClientConfigurationError.createPostLogoutRedirectUriEmptyError = function () {
        return new ClientConfigurationError(ClientConfigurationErrorMessage.postLogoutUriNotSet.code, ClientConfigurationErrorMessage.postLogoutUriNotSet.desc);
    };
    /**
     * Creates an error thrown when the claims request could not be successfully parsed
     */
    ClientConfigurationError.createClaimsRequestParsingError = function (claimsRequestParseError) {
        return new ClientConfigurationError(ClientConfigurationErrorMessage.claimsRequestParsingError.code, ClientConfigurationErrorMessage.claimsRequestParsingError.desc + " Given value: " + claimsRequestParseError);
    };
    /**
     * Creates an error thrown if authority uri is given an insecure protocol.
     * @param urlString
     */
    ClientConfigurationError.createInsecureAuthorityUriError = function (urlString) {
        return new ClientConfigurationError(ClientConfigurationErrorMessage.authorityUriInsecure.code, ClientConfigurationErrorMessage.authorityUriInsecure.desc + " Given URI: " + urlString);
    };
    /**
     * Creates an error thrown if URL string does not parse into separate segments.
     * @param urlString
     */
    ClientConfigurationError.createUrlParseError = function (urlParseError) {
        return new ClientConfigurationError(ClientConfigurationErrorMessage.urlParseError.code, ClientConfigurationErrorMessage.urlParseError.desc + " Given Error: " + urlParseError);
    };
    /**
     * Creates an error thrown if URL string is empty or null.
     * @param urlString
     */
    ClientConfigurationError.createUrlEmptyError = function () {
        return new ClientConfigurationError(ClientConfigurationErrorMessage.urlEmptyError.code, ClientConfigurationErrorMessage.urlEmptyError.desc);
    };
    /**
     * Error thrown when scopes are empty.
     * @param scopesValue
     */
    ClientConfigurationError.createEmptyScopesArrayError = function () {
        return new ClientConfigurationError(ClientConfigurationErrorMessage.emptyScopesError.code, "" + ClientConfigurationErrorMessage.emptyScopesError.desc);
    };
    /**
     * Error thrown when client id scope is not provided as single scope.
     * @param inputScopes
     */
    ClientConfigurationError.createClientIdSingleScopeError = function (inputScopes) {
        return new ClientConfigurationError(ClientConfigurationErrorMessage.clientIdSingleScopeError.code, ClientConfigurationErrorMessage.clientIdSingleScopeError.desc + " Given Scopes: " + inputScopes);
    };
    /**
     * Error thrown when prompt is not an allowed type.
     * @param promptValue
     */
    ClientConfigurationError.createInvalidPromptError = function (promptValue) {
        return new ClientConfigurationError(ClientConfigurationErrorMessage.invalidPrompt.code, ClientConfigurationErrorMessage.invalidPrompt.desc + " Given value: " + promptValue);
    };
    /**
     * Creates error thrown when claims parameter is not a stringified JSON object
     */
    ClientConfigurationError.createInvalidClaimsRequestError = function () {
        return new ClientConfigurationError(ClientConfigurationErrorMessage.invalidClaimsRequest.code, ClientConfigurationErrorMessage.invalidClaimsRequest.desc);
    };
    /**
     * Throws error when token request is empty and nothing cached in storage.
     */
    ClientConfigurationError.createEmptyLogoutRequestError = function () {
        return new ClientConfigurationError(ClientConfigurationErrorMessage.logoutRequestEmptyError.code, ClientConfigurationErrorMessage.logoutRequestEmptyError.desc);
    };
    /**
     * Throws error when token request is empty and nothing cached in storage.
     */
    ClientConfigurationError.createEmptyTokenRequestError = function () {
        return new ClientConfigurationError(ClientConfigurationErrorMessage.tokenRequestEmptyError.code, ClientConfigurationErrorMessage.tokenRequestEmptyError.desc);
    };
    /**
     * Throws error when an invalid code_challenge_method is passed by the user
     */
    ClientConfigurationError.createInvalidCodeChallengeMethodError = function () {
        return new ClientConfigurationError(ClientConfigurationErrorMessage.invalidCodeChallengeMethod.code, ClientConfigurationErrorMessage.invalidCodeChallengeMethod.desc);
    };
    /**
     * Throws error when both params: code_challenge and code_challenge_method are not passed together
     */
    ClientConfigurationError.createInvalidCodeChallengeParamsError = function () {
        return new ClientConfigurationError(ClientConfigurationErrorMessage.invalidCodeChallengeParams.code, ClientConfigurationErrorMessage.invalidCodeChallengeParams.desc);
    };
    /**
     * Throws an error when the user passes invalid cloudDiscoveryMetadata
     */
    ClientConfigurationError.createInvalidCloudDiscoveryMetadataError = function () {
        return new ClientConfigurationError(ClientConfigurationErrorMessage.invalidCloudDiscoveryMetadata.code, ClientConfigurationErrorMessage.invalidCloudDiscoveryMetadata.desc);
    };
    /**
     * Throws an error when the user passes invalid cloudDiscoveryMetadata
     */
    ClientConfigurationError.createInvalidAuthorityMetadataError = function () {
        return new ClientConfigurationError(ClientConfigurationErrorMessage.invalidAuthorityMetadata.code, ClientConfigurationErrorMessage.invalidAuthorityMetadata.desc);
    };
    /**
     * Throws error when provided authority is not a member of the trusted host list
     */
    ClientConfigurationError.createUntrustedAuthorityError = function () {
        return new ClientConfigurationError(ClientConfigurationErrorMessage.untrustedAuthority.code, ClientConfigurationErrorMessage.untrustedAuthority.desc);
    };
    return ClientConfigurationError;
}(ClientAuthError));

/*! @azure/msal-common v4.4.0 2021-06-29 */

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * The ScopeSet class creates a set of scopes. Scopes are case-insensitive, unique values, so the Set object in JS makes
 * the most sense to implement for this class. All scopes are trimmed and converted to lower case strings in intersection and union functions
 * to ensure uniqueness of strings.
 */
var ScopeSet = /** @class */ (function () {
    function ScopeSet(inputScopes) {
        var _this = this;
        // Filter empty string and null/undefined array items
        var scopeArr = inputScopes ? StringUtils.trimArrayEntries(__spreadArrays(inputScopes)) : [];
        var filteredInput = scopeArr ? StringUtils.removeEmptyStringsFromArray(scopeArr) : [];
        // Validate and filter scopes (validate function throws if validation fails)
        this.validateInputScopes(filteredInput);
        this.scopes = new Set(); // Iterator in constructor not supported by IE11
        filteredInput.forEach(function (scope) { return _this.scopes.add(scope); });
    }
    /**
     * Factory method to create ScopeSet from space-delimited string
     * @param inputScopeString
     * @param appClientId
     * @param scopesRequired
     */
    ScopeSet.fromString = function (inputScopeString) {
        var scopeString = inputScopeString || "";
        var inputScopes = scopeString.split(" ");
        return new ScopeSet(inputScopes);
    };
    /**
     * Used to validate the scopes input parameter requested  by the developer.
     * @param {Array<string>} inputScopes - Developer requested permissions. Not all scopes are guaranteed to be included in the access token returned.
     * @param {boolean} scopesRequired - Boolean indicating whether the scopes array is required or not
     */
    ScopeSet.prototype.validateInputScopes = function (inputScopes) {
        // Check if scopes are required but not given or is an empty array
        if (!inputScopes || inputScopes.length < 1) {
            throw ClientConfigurationError.createEmptyScopesArrayError();
        }
    };
    /**
     * Check if a given scope is present in this set of scopes.
     * @param scope
     */
    ScopeSet.prototype.containsScope = function (scope) {
        var lowerCaseScopes = this.printScopesLowerCase().split(" ");
        var lowerCaseScopesSet = new ScopeSet(lowerCaseScopes);
        // compare lowercase scopes
        return !StringUtils.isEmpty(scope) ? lowerCaseScopesSet.scopes.has(scope.toLowerCase()) : false;
    };
    /**
     * Check if a set of scopes is present in this set of scopes.
     * @param scopeSet
     */
    ScopeSet.prototype.containsScopeSet = function (scopeSet) {
        var _this = this;
        if (!scopeSet || scopeSet.scopes.size <= 0) {
            return false;
        }
        return (this.scopes.size >= scopeSet.scopes.size && scopeSet.asArray().every(function (scope) { return _this.containsScope(scope); }));
    };
    /**
     * Check if set of scopes contains only the defaults
     */
    ScopeSet.prototype.containsOnlyOIDCScopes = function () {
        var _this = this;
        var defaultScopeCount = 0;
        OIDC_SCOPES.forEach(function (defaultScope) {
            if (_this.containsScope(defaultScope)) {
                defaultScopeCount += 1;
            }
        });
        return this.scopes.size === defaultScopeCount;
    };
    /**
     * Appends single scope if passed
     * @param newScope
     */
    ScopeSet.prototype.appendScope = function (newScope) {
        if (!StringUtils.isEmpty(newScope)) {
            this.scopes.add(newScope.trim());
        }
    };
    /**
     * Appends multiple scopes if passed
     * @param newScopes
     */
    ScopeSet.prototype.appendScopes = function (newScopes) {
        var _this = this;
        try {
            newScopes.forEach(function (newScope) { return _this.appendScope(newScope); });
        }
        catch (e) {
            throw ClientAuthError.createAppendScopeSetError(e);
        }
    };
    /**
     * Removes element from set of scopes.
     * @param scope
     */
    ScopeSet.prototype.removeScope = function (scope) {
        if (StringUtils.isEmpty(scope)) {
            throw ClientAuthError.createRemoveEmptyScopeFromSetError(scope);
        }
        this.scopes.delete(scope.trim());
    };
    /**
     * Removes default scopes from set of scopes
     * Primarily used to prevent cache misses if the default scopes are not returned from the server
     */
    ScopeSet.prototype.removeOIDCScopes = function () {
        var _this = this;
        OIDC_SCOPES.forEach(function (defaultScope) {
            _this.scopes.delete(defaultScope);
        });
    };
    /**
     * Combines an array of scopes with the current set of scopes.
     * @param otherScopes
     */
    ScopeSet.prototype.unionScopeSets = function (otherScopes) {
        if (!otherScopes) {
            throw ClientAuthError.createEmptyInputScopeSetError();
        }
        var unionScopes = new Set(); // Iterator in constructor not supported in IE11
        otherScopes.scopes.forEach(function (scope) { return unionScopes.add(scope.toLowerCase()); });
        this.scopes.forEach(function (scope) { return unionScopes.add(scope.toLowerCase()); });
        return unionScopes;
    };
    /**
     * Check if scopes intersect between this set and another.
     * @param otherScopes
     */
    ScopeSet.prototype.intersectingScopeSets = function (otherScopes) {
        if (!otherScopes) {
            throw ClientAuthError.createEmptyInputScopeSetError();
        }
        // Do not allow OIDC scopes to be the only intersecting scopes
        if (!otherScopes.containsOnlyOIDCScopes()) {
            otherScopes.removeOIDCScopes();
        }
        var unionScopes = this.unionScopeSets(otherScopes);
        var sizeOtherScopes = otherScopes.getScopeCount();
        var sizeThisScopes = this.getScopeCount();
        var sizeUnionScopes = unionScopes.size;
        return sizeUnionScopes < (sizeThisScopes + sizeOtherScopes);
    };
    /**
     * Returns size of set of scopes.
     */
    ScopeSet.prototype.getScopeCount = function () {
        return this.scopes.size;
    };
    /**
     * Returns the scopes as an array of string values
     */
    ScopeSet.prototype.asArray = function () {
        var array = [];
        this.scopes.forEach(function (val) { return array.push(val); });
        return array;
    };
    /**
     * Prints scopes into a space-delimited string
     */
    ScopeSet.prototype.printScopes = function () {
        if (this.scopes) {
            var scopeArr = this.asArray();
            return scopeArr.join(" ");
        }
        return "";
    };
    /**
     * Prints scopes into a space-delimited lower-case string (used for caching)
     */
    ScopeSet.prototype.printScopesLowerCase = function () {
        return this.printScopes().toLowerCase();
    };
    return ScopeSet;
}());

/*! @azure/msal-common v4.4.0 2021-06-29 */

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * Function to build a client info object from server clientInfo string
 * @param rawClientInfo
 * @param crypto
 */
function buildClientInfo(rawClientInfo, crypto) {
    if (StringUtils.isEmpty(rawClientInfo)) {
        throw ClientAuthError.createClientInfoEmptyError();
    }
    try {
        var decodedClientInfo = crypto.base64Decode(rawClientInfo);
        return JSON.parse(decodedClientInfo);
    }
    catch (e) {
        throw ClientAuthError.createClientInfoDecodingError(e);
    }
}
/**
 * Function to build a client info object from cached homeAccountId string
 * @param homeAccountId
 */
function buildClientInfoFromHomeAccountId(homeAccountId) {
    if (StringUtils.isEmpty(homeAccountId)) {
        throw ClientAuthError.createClientInfoDecodingError("Home account ID was empty.");
    }
    var clientInfoParts = homeAccountId.split(Separators.CLIENT_INFO_SEPARATOR, 2);
    return {
        uid: clientInfoParts[0],
        utid: clientInfoParts.length < 2 ? Constants.EMPTY_STRING : clientInfoParts[1]
    };
}

/*! @azure/msal-common v4.4.0 2021-06-29 */
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * Authority types supported by MSAL.
 */
var AuthorityType;
(function (AuthorityType) {
    AuthorityType[AuthorityType["Default"] = 0] = "Default";
    AuthorityType[AuthorityType["Adfs"] = 1] = "Adfs";
})(AuthorityType || (AuthorityType = {}));

/*! @azure/msal-common v4.4.0 2021-06-29 */

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * Type that defines required and optional parameters for an Account field (based on universal cache schema implemented by all MSALs).
 *
 * Key : Value Schema
 *
 * Key: <home_account_id>-<environment>-<realm*>
 *
 * Value Schema:
 * {
 *      homeAccountId: home account identifier for the auth scheme,
 *      environment: entity that issued the token, represented as a full host
 *      realm: Full tenant or organizational identifier that the account belongs to
 *      localAccountId: Original tenant-specific accountID, usually used for legacy cases
 *      username: primary username that represents the user, usually corresponds to preferred_username in the v2 endpt
 *      authorityType: Accounts authority type as a string
 *      name: Full name for the account, including given name and family name,
 *      clientInfo: Full base64 encoded client info received from ESTS
 *      lastModificationTime: last time this entity was modified in the cache
 *      lastModificationApp:
 *      oboAssertion: access token passed in as part of OBO request
 *      idTokenClaims: Object containing claims parsed from ID token
 * }
 */
var AccountEntity = /** @class */ (function () {
    function AccountEntity() {
    }
    /**
     * Generate Account Id key component as per the schema: <home_account_id>-<environment>
     */
    AccountEntity.prototype.generateAccountId = function () {
        var accountId = [this.homeAccountId, this.environment];
        return accountId.join(Separators.CACHE_KEY_SEPARATOR).toLowerCase();
    };
    /**
     * Generate Account Cache Key as per the schema: <home_account_id>-<environment>-<realm*>
     */
    AccountEntity.prototype.generateAccountKey = function () {
        return AccountEntity.generateAccountCacheKey({
            homeAccountId: this.homeAccountId,
            environment: this.environment,
            tenantId: this.realm,
            username: this.username,
            localAccountId: this.localAccountId
        });
    };
    /**
     * returns the type of the cache (in this case account)
     */
    AccountEntity.prototype.generateType = function () {
        switch (this.authorityType) {
            case CacheAccountType.ADFS_ACCOUNT_TYPE:
                return CacheType.ADFS;
            case CacheAccountType.MSAV1_ACCOUNT_TYPE:
                return CacheType.MSA;
            case CacheAccountType.MSSTS_ACCOUNT_TYPE:
                return CacheType.MSSTS;
            case CacheAccountType.GENERIC_ACCOUNT_TYPE:
                return CacheType.GENERIC;
            default: {
                throw ClientAuthError.createUnexpectedAccountTypeError();
            }
        }
    };
    /**
     * Returns the AccountInfo interface for this account.
     */
    AccountEntity.prototype.getAccountInfo = function () {
        return {
            homeAccountId: this.homeAccountId,
            environment: this.environment,
            tenantId: this.realm,
            username: this.username,
            localAccountId: this.localAccountId,
            name: this.name,
            idTokenClaims: this.idTokenClaims
        };
    };
    /**
     * Generates account key from interface
     * @param accountInterface
     */
    AccountEntity.generateAccountCacheKey = function (accountInterface) {
        var accountKey = [
            accountInterface.homeAccountId,
            accountInterface.environment || "",
            accountInterface.tenantId || "",
        ];
        return accountKey.join(Separators.CACHE_KEY_SEPARATOR).toLowerCase();
    };
    /**
     * Build Account cache from IdToken, clientInfo and authority/policy. Associated with AAD.
     * @param clientInfo
     * @param authority
     * @param idToken
     * @param policy
     */
    AccountEntity.createAccount = function (clientInfo, homeAccountId, authority, idToken, oboAssertion, cloudGraphHostName, msGraphHost) {
        var _a, _b, _c, _d, _e, _f;
        var account = new AccountEntity();
        account.authorityType = CacheAccountType.MSSTS_ACCOUNT_TYPE;
        account.clientInfo = clientInfo;
        account.homeAccountId = homeAccountId;
        var env = authority.getPreferredCache();
        if (StringUtils.isEmpty(env)) {
            throw ClientAuthError.createInvalidCacheEnvironmentError();
        }
        account.environment = env;
        // non AAD scenarios can have empty realm
        account.realm = ((_a = idToken === null || idToken === void 0 ? void 0 : idToken.claims) === null || _a === void 0 ? void 0 : _a.tid) || "";
        account.oboAssertion = oboAssertion;
        if (idToken) {
            account.idTokenClaims = idToken.claims;
            // How do you account for MSA CID here?
            account.localAccountId = ((_b = idToken === null || idToken === void 0 ? void 0 : idToken.claims) === null || _b === void 0 ? void 0 : _b.oid) || ((_c = idToken === null || idToken === void 0 ? void 0 : idToken.claims) === null || _c === void 0 ? void 0 : _c.sub) || "";
            /*
             * In B2C scenarios the emails claim is used instead of preferred_username and it is an array. In most cases it will contain a single email.
             * This field should not be relied upon if a custom policy is configured to return more than 1 email.
             */
            account.username = ((_d = idToken === null || idToken === void 0 ? void 0 : idToken.claims) === null || _d === void 0 ? void 0 : _d.preferred_username) || (((_e = idToken === null || idToken === void 0 ? void 0 : idToken.claims) === null || _e === void 0 ? void 0 : _e.emails) ? idToken.claims.emails[0] : "");
            account.name = (_f = idToken === null || idToken === void 0 ? void 0 : idToken.claims) === null || _f === void 0 ? void 0 : _f.name;
        }
        account.cloudGraphHostName = cloudGraphHostName;
        account.msGraphHost = msGraphHost;
        return account;
    };
    /**
     * Builds non-AAD/ADFS account.
     * @param authority
     * @param idToken
     */
    AccountEntity.createGenericAccount = function (authority, homeAccountId, idToken, oboAssertion, cloudGraphHostName, msGraphHost) {
        var _a, _b, _c, _d;
        var account = new AccountEntity();
        account.authorityType = (authority.authorityType === AuthorityType.Adfs) ? CacheAccountType.ADFS_ACCOUNT_TYPE : CacheAccountType.GENERIC_ACCOUNT_TYPE;
        account.homeAccountId = homeAccountId;
        // non AAD scenarios can have empty realm
        account.realm = "";
        account.oboAssertion = oboAssertion;
        var env = authority.getPreferredCache();
        if (StringUtils.isEmpty(env)) {
            throw ClientAuthError.createInvalidCacheEnvironmentError();
        }
        if (idToken) {
            // How do you account for MSA CID here?
            account.localAccountId = ((_a = idToken === null || idToken === void 0 ? void 0 : idToken.claims) === null || _a === void 0 ? void 0 : _a.oid) || ((_b = idToken === null || idToken === void 0 ? void 0 : idToken.claims) === null || _b === void 0 ? void 0 : _b.sub) || "";
            // upn claim for most ADFS scenarios
            account.username = ((_c = idToken === null || idToken === void 0 ? void 0 : idToken.claims) === null || _c === void 0 ? void 0 : _c.upn) || "";
            account.name = ((_d = idToken === null || idToken === void 0 ? void 0 : idToken.claims) === null || _d === void 0 ? void 0 : _d.name) || "";
            account.idTokenClaims = idToken === null || idToken === void 0 ? void 0 : idToken.claims;
        }
        account.environment = env;
        account.cloudGraphHostName = cloudGraphHostName;
        account.msGraphHost = msGraphHost;
        /*
         * add uniqueName to claims
         * account.name = idToken.claims.uniqueName;
         */
        return account;
    };
    /**
     * Generate HomeAccountId from server response
     * @param serverClientInfo
     * @param authType
     */
    AccountEntity.generateHomeAccountId = function (serverClientInfo, authType, logger, cryptoObj, idToken) {
        var _a;
        var accountId = ((_a = idToken === null || idToken === void 0 ? void 0 : idToken.claims) === null || _a === void 0 ? void 0 : _a.sub) ? idToken.claims.sub : Constants.EMPTY_STRING;
        // since ADFS does not have tid and does not set client_info
        if (authType === AuthorityType.Adfs) {
            return accountId;
        }
        // for cases where there is clientInfo
        if (serverClientInfo) {
            try {
                var clientInfo = buildClientInfo(serverClientInfo, cryptoObj);
                if (!StringUtils.isEmpty(clientInfo.uid) && !StringUtils.isEmpty(clientInfo.utid)) {
                    return "" + clientInfo.uid + Separators.CLIENT_INFO_SEPARATOR + clientInfo.utid;
                }
            }
            catch (e) { }
        }
        // default to "sub" claim
        logger.verbose("No client info in response");
        return accountId;
    };
    /**
     * Validates an entity: checks for all expected params
     * @param entity
     */
    AccountEntity.isAccountEntity = function (entity) {
        if (!entity) {
            return false;
        }
        return (entity.hasOwnProperty("homeAccountId") &&
            entity.hasOwnProperty("environment") &&
            entity.hasOwnProperty("realm") &&
            entity.hasOwnProperty("localAccountId") &&
            entity.hasOwnProperty("username") &&
            entity.hasOwnProperty("authorityType"));
    };
    /**
     * Helper function to determine whether 2 accountInfo objects represent the same account
     * @param accountA
     * @param accountB
     * @param compareClaims - If set to true idTokenClaims will also be compared to determine account equality
     */
    AccountEntity.accountInfoIsEqual = function (accountA, accountB, compareClaims) {
        if (!accountA || !accountB) {
            return false;
        }
        var claimsMatch = true; // default to true so as to not fail comparison below if compareClaims: false
        if (compareClaims) {
            var accountAClaims = (accountA.idTokenClaims || {});
            var accountBClaims = (accountB.idTokenClaims || {});
            // issued at timestamp and nonce are expected to change each time a new id token is acquired
            claimsMatch = (accountAClaims.iat === accountBClaims.iat) &&
                (accountAClaims.nonce === accountBClaims.nonce);
        }
        return (accountA.homeAccountId === accountB.homeAccountId) &&
            (accountA.localAccountId === accountB.localAccountId) &&
            (accountA.username === accountB.username) &&
            (accountA.tenantId === accountB.tenantId) &&
            (accountA.environment === accountB.environment) &&
            claimsMatch;
    };
    return AccountEntity;
}());

/*! @azure/msal-common v4.4.0 2021-06-29 */

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * JWT Token representation class. Parses token string and generates claims object.
 */
var AuthToken = /** @class */ (function () {
    function AuthToken(rawToken, crypto) {
        if (StringUtils.isEmpty(rawToken)) {
            throw ClientAuthError.createTokenNullOrEmptyError(rawToken);
        }
        this.rawToken = rawToken;
        this.claims = AuthToken.extractTokenClaims(rawToken, crypto);
    }
    /**
     * Extract token by decoding the rawToken
     *
     * @param encodedToken
     */
    AuthToken.extractTokenClaims = function (encodedToken, crypto) {
        var decodedToken = StringUtils.decodeAuthToken(encodedToken);
        // token will be decoded to get the username
        try {
            var base64TokenPayload = decodedToken.JWSPayload;
            // base64Decode() should throw an error if there is an issue
            var base64Decoded = crypto.base64Decode(base64TokenPayload);
            return JSON.parse(base64Decoded);
        }
        catch (err) {
            throw ClientAuthError.createTokenParsingError(err);
        }
    };
    return AuthToken;
}());

/*! @azure/msal-common v4.4.0 2021-06-29 */

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * Interface class which implement cache storage functions used by MSAL to perform validity checks, and store tokens.
 */
var CacheManager = /** @class */ (function () {
    function CacheManager(clientId, cryptoImpl) {
        this.clientId = clientId;
        this.cryptoImpl = cryptoImpl;
    }
    /**
     * Returns all accounts in cache
     */
    CacheManager.prototype.getAllAccounts = function () {
        var _this = this;
        var currentAccounts = this.getAccountsFilteredBy();
        var accountValues = Object.keys(currentAccounts).map(function (accountKey) { return currentAccounts[accountKey]; });
        var numAccounts = accountValues.length;
        if (numAccounts < 1) {
            return [];
        }
        else {
            var allAccounts = accountValues.map(function (value) {
                var accountEntity = CacheManager.toObject(new AccountEntity(), value);
                var accountInfo = accountEntity.getAccountInfo();
                var idToken = _this.readIdTokenFromCache(_this.clientId, accountInfo);
                if (idToken && !accountInfo.idTokenClaims) {
                    accountInfo.idTokenClaims = new AuthToken(idToken.secret, _this.cryptoImpl).claims;
                }
                return accountInfo;
            });
            return allAccounts;
        }
    };
    /**
     * saves a cache record
     * @param cacheRecord
     */
    CacheManager.prototype.saveCacheRecord = function (cacheRecord) {
        if (!cacheRecord) {
            throw ClientAuthError.createNullOrUndefinedCacheRecord();
        }
        if (!!cacheRecord.account) {
            this.setAccount(cacheRecord.account);
        }
        if (!!cacheRecord.idToken) {
            this.setIdTokenCredential(cacheRecord.idToken);
        }
        if (!!cacheRecord.accessToken) {
            this.saveAccessToken(cacheRecord.accessToken);
        }
        if (!!cacheRecord.refreshToken) {
            this.setRefreshTokenCredential(cacheRecord.refreshToken);
        }
        if (!!cacheRecord.appMetadata) {
            this.setAppMetadata(cacheRecord.appMetadata);
        }
    };
    /**
     * saves access token credential
     * @param credential
     */
    CacheManager.prototype.saveAccessToken = function (credential) {
        var _this = this;
        var currentTokenCache = this.getCredentialsFilteredBy({
            clientId: credential.clientId,
            credentialType: credential.credentialType,
            environment: credential.environment,
            homeAccountId: credential.homeAccountId,
            realm: credential.realm,
        });
        var currentScopes = ScopeSet.fromString(credential.target);
        var currentAccessTokens = Object.keys(currentTokenCache.accessTokens).map(function (key) { return currentTokenCache.accessTokens[key]; });
        if (currentAccessTokens) {
            currentAccessTokens.forEach(function (tokenEntity) {
                var tokenScopeSet = ScopeSet.fromString(tokenEntity.target);
                if (tokenScopeSet.intersectingScopeSets(currentScopes)) {
                    _this.removeCredential(tokenEntity);
                }
            });
        }
        this.setAccessTokenCredential(credential);
    };
    /**
     * retrieve accounts matching all provided filters; if no filter is set, get all accounts
     * not checking for casing as keys are all generated in lower case, remember to convert to lower case if object properties are compared
     * @param homeAccountId
     * @param environment
     * @param realm
     */
    CacheManager.prototype.getAccountsFilteredBy = function (accountFilter) {
        return this.getAccountsFilteredByInternal(accountFilter ? accountFilter.homeAccountId : "", accountFilter ? accountFilter.environment : "", accountFilter ? accountFilter.realm : "");
    };
    /**
     * retrieve accounts matching all provided filters; if no filter is set, get all accounts
     * not checking for casing as keys are all generated in lower case, remember to convert to lower case if object properties are compared
     * @param homeAccountId
     * @param environment
     * @param realm
     */
    CacheManager.prototype.getAccountsFilteredByInternal = function (homeAccountId, environment, realm) {
        var _this = this;
        var allCacheKeys = this.getKeys();
        var matchingAccounts = {};
        allCacheKeys.forEach(function (cacheKey) {
            var entity = _this.getAccount(cacheKey);
            if (!entity) {
                return;
            }
            if (!!homeAccountId && !_this.matchHomeAccountId(entity, homeAccountId)) {
                return;
            }
            if (!!environment && !_this.matchEnvironment(entity, environment)) {
                return;
            }
            if (!!realm && !_this.matchRealm(entity, realm)) {
                return;
            }
            matchingAccounts[cacheKey] = entity;
        });
        return matchingAccounts;
    };
    /**
     * retrieve credentails matching all provided filters; if no filter is set, get all credentials
     * @param homeAccountId
     * @param environment
     * @param credentialType
     * @param clientId
     * @param realm
     * @param target
     */
    CacheManager.prototype.getCredentialsFilteredBy = function (filter) {
        return this.getCredentialsFilteredByInternal(filter.homeAccountId, filter.environment, filter.credentialType, filter.clientId, filter.familyId, filter.realm, filter.target, filter.oboAssertion);
    };
    /**
     * Support function to help match credentials
     * @param homeAccountId
     * @param environment
     * @param credentialType
     * @param clientId
     * @param realm
     * @param target
     */
    CacheManager.prototype.getCredentialsFilteredByInternal = function (homeAccountId, environment, credentialType, clientId, familyId, realm, target, oboAssertion) {
        var _this = this;
        var allCacheKeys = this.getKeys();
        var matchingCredentials = {
            idTokens: {},
            accessTokens: {},
            refreshTokens: {},
        };
        allCacheKeys.forEach(function (cacheKey) {
            // don't parse any non-credential type cache entities
            var credType = CredentialEntity.getCredentialType(cacheKey);
            if (credType === Constants.NOT_DEFINED) {
                return;
            }
            // Attempt retrieval
            var entity = _this.getSpecificCredential(cacheKey, credType);
            if (!entity) {
                return;
            }
            if (!!oboAssertion && !_this.matchOboAssertion(entity, oboAssertion)) {
                return;
            }
            if (!!homeAccountId && !_this.matchHomeAccountId(entity, homeAccountId)) {
                return;
            }
            if (!!environment && !_this.matchEnvironment(entity, environment)) {
                return;
            }
            if (!!realm && !_this.matchRealm(entity, realm)) {
                return;
            }
            if (!!credentialType && !_this.matchCredentialType(entity, credentialType)) {
                return;
            }
            if (!!clientId && !_this.matchClientId(entity, clientId)) {
                return;
            }
            if (!!familyId && !_this.matchFamilyId(entity, familyId)) {
                return;
            }
            /*
             * idTokens do not have "target", target specific refreshTokens do exist for some types of authentication
             * Resource specific refresh tokens case will be added when the support is deemed necessary
             */
            if (!!target && !_this.matchTarget(entity, target)) {
                return;
            }
            switch (credType) {
                case CredentialType.ID_TOKEN:
                    matchingCredentials.idTokens[cacheKey] = entity;
                    break;
                case CredentialType.ACCESS_TOKEN:
                case CredentialType.ACCESS_TOKEN_WITH_AUTH_SCHEME:
                    matchingCredentials.accessTokens[cacheKey] = entity;
                    break;
                case CredentialType.REFRESH_TOKEN:
                    matchingCredentials.refreshTokens[cacheKey] = entity;
                    break;
            }
        });
        return matchingCredentials;
    };
    /**
     * retrieve appMetadata matching all provided filters; if no filter is set, get all appMetadata
     * @param filter
     */
    CacheManager.prototype.getAppMetadataFilteredBy = function (filter) {
        return this.getAppMetadataFilteredByInternal(filter.environment, filter.clientId);
    };
    /**
     * Support function to help match appMetadata
     * @param environment
     * @param clientId
     */
    CacheManager.prototype.getAppMetadataFilteredByInternal = function (environment, clientId) {
        var _this = this;
        var allCacheKeys = this.getKeys();
        var matchingAppMetadata = {};
        allCacheKeys.forEach(function (cacheKey) {
            // don't parse any non-appMetadata type cache entities
            if (!_this.isAppMetadata(cacheKey)) {
                return;
            }
            // Attempt retrieval
            var entity = _this.getAppMetadata(cacheKey);
            if (!entity) {
                return;
            }
            if (!!environment && !_this.matchEnvironment(entity, environment)) {
                return;
            }
            if (!!clientId && !_this.matchClientId(entity, clientId)) {
                return;
            }
            matchingAppMetadata[cacheKey] = entity;
        });
        return matchingAppMetadata;
    };
    /**
     * retrieve authorityMetadata that contains a matching alias
     * @param filter
     */
    CacheManager.prototype.getAuthorityMetadataByAlias = function (host) {
        var _this = this;
        var allCacheKeys = this.getAuthorityMetadataKeys();
        var matchedEntity = null;
        allCacheKeys.forEach(function (cacheKey) {
            // don't parse any non-authorityMetadata type cache entities
            if (!_this.isAuthorityMetadata(cacheKey) || cacheKey.indexOf(_this.clientId) === -1) {
                return;
            }
            // Attempt retrieval
            var entity = _this.getAuthorityMetadata(cacheKey);
            if (!entity) {
                return;
            }
            if (entity.aliases.indexOf(host) === -1) {
                return;
            }
            matchedEntity = entity;
        });
        return matchedEntity;
    };
    /**
     * Removes all accounts and related tokens from cache.
     */
    CacheManager.prototype.removeAllAccounts = function () {
        var _this = this;
        var allCacheKeys = this.getKeys();
        allCacheKeys.forEach(function (cacheKey) {
            var entity = _this.getAccount(cacheKey);
            if (!entity) {
                return;
            }
            _this.removeAccount(cacheKey);
        });
        return true;
    };
    /**
     * returns a boolean if the given account is removed
     * @param account
     */
    CacheManager.prototype.removeAccount = function (accountKey) {
        var account = this.getAccount(accountKey);
        if (!account) {
            throw ClientAuthError.createNoAccountFoundError();
        }
        return (this.removeAccountContext(account) && this.removeItem(accountKey, CacheSchemaType.ACCOUNT));
    };
    /**
     * returns a boolean if the given account is removed
     * @param account
     */
    CacheManager.prototype.removeAccountContext = function (account) {
        var _this = this;
        var allCacheKeys = this.getKeys();
        var accountId = account.generateAccountId();
        allCacheKeys.forEach(function (cacheKey) {
            // don't parse any non-credential type cache entities
            var credType = CredentialEntity.getCredentialType(cacheKey);
            if (credType === Constants.NOT_DEFINED) {
                return;
            }
            var cacheEntity = _this.getSpecificCredential(cacheKey, credType);
            if (!!cacheEntity && accountId === cacheEntity.generateAccountId()) {
                _this.removeCredential(cacheEntity);
            }
        });
        return true;
    };
    /**
     * returns a boolean if the given credential is removed
     * @param credential
     */
    CacheManager.prototype.removeCredential = function (credential) {
        var key = credential.generateCredentialKey();
        return this.removeItem(key, CacheSchemaType.CREDENTIAL);
    };
    /**
     * Removes all app metadata objects from cache.
     */
    CacheManager.prototype.removeAppMetadata = function () {
        var _this = this;
        var allCacheKeys = this.getKeys();
        allCacheKeys.forEach(function (cacheKey) {
            if (_this.isAppMetadata(cacheKey)) {
                _this.removeItem(cacheKey, CacheSchemaType.APP_METADATA);
            }
        });
        return true;
    };
    /**
     * Retrieve the cached credentials into a cacherecord
     * @param account
     * @param clientId
     * @param scopes
     * @param environment
     * @param authScheme
     */
    CacheManager.prototype.readCacheRecord = function (account, clientId, scopes, environment, authScheme) {
        var cachedAccount = this.readAccountFromCache(account);
        var cachedIdToken = this.readIdTokenFromCache(clientId, account);
        var cachedAccessToken = this.readAccessTokenFromCache(clientId, account, scopes, authScheme);
        var cachedRefreshToken = this.readRefreshTokenFromCache(clientId, account, false);
        var cachedAppMetadata = this.readAppMetadataFromCache(environment, clientId);
        if (cachedAccount && cachedIdToken) {
            cachedAccount.idTokenClaims = new AuthToken(cachedIdToken.secret, this.cryptoImpl).claims;
        }
        return {
            account: cachedAccount,
            idToken: cachedIdToken,
            accessToken: cachedAccessToken,
            refreshToken: cachedRefreshToken,
            appMetadata: cachedAppMetadata,
        };
    };
    /**
     * Retrieve AccountEntity from cache
     * @param account
     */
    CacheManager.prototype.readAccountFromCache = function (account) {
        var accountKey = AccountEntity.generateAccountCacheKey(account);
        return this.getAccount(accountKey);
    };
    /**
     * Retrieve IdTokenEntity from cache
     * @param clientId
     * @param account
     * @param inputRealm
     */
    CacheManager.prototype.readIdTokenFromCache = function (clientId, account) {
        var idTokenFilter = {
            homeAccountId: account.homeAccountId,
            environment: account.environment,
            credentialType: CredentialType.ID_TOKEN,
            clientId: clientId,
            realm: account.tenantId,
        };
        var credentialCache = this.getCredentialsFilteredBy(idTokenFilter);
        var idTokens = Object.keys(credentialCache.idTokens).map(function (key) { return credentialCache.idTokens[key]; });
        var numIdTokens = idTokens.length;
        if (numIdTokens < 1) {
            return null;
        }
        else if (numIdTokens > 1) {
            throw ClientAuthError.createMultipleMatchingTokensInCacheError();
        }
        return idTokens[0];
    };
    /**
     * Retrieve AccessTokenEntity from cache
     * @param clientId
     * @param account
     * @param scopes
     * @param authScheme
     */
    CacheManager.prototype.readAccessTokenFromCache = function (clientId, account, scopes, authScheme) {
        var credentialType = (authScheme === AuthenticationScheme.POP) ? CredentialType.ACCESS_TOKEN_WITH_AUTH_SCHEME : CredentialType.ACCESS_TOKEN;
        var accessTokenFilter = {
            homeAccountId: account.homeAccountId,
            environment: account.environment,
            credentialType: credentialType,
            clientId: clientId,
            realm: account.tenantId,
            target: scopes.printScopesLowerCase(),
        };
        var credentialCache = this.getCredentialsFilteredBy(accessTokenFilter);
        var accessTokens = Object.keys(credentialCache.accessTokens).map(function (key) { return credentialCache.accessTokens[key]; });
        var numAccessTokens = accessTokens.length;
        if (numAccessTokens < 1) {
            return null;
        }
        else if (numAccessTokens > 1) {
            throw ClientAuthError.createMultipleMatchingTokensInCacheError();
        }
        return accessTokens[0];
    };
    /**
     * Helper to retrieve the appropriate refresh token from cache
     * @param clientId
     * @param account
     * @param familyRT
     */
    CacheManager.prototype.readRefreshTokenFromCache = function (clientId, account, familyRT) {
        var id = familyRT ? THE_FAMILY_ID : undefined;
        var refreshTokenFilter = {
            homeAccountId: account.homeAccountId,
            environment: account.environment,
            credentialType: CredentialType.REFRESH_TOKEN,
            clientId: clientId,
            familyId: id
        };
        var credentialCache = this.getCredentialsFilteredBy(refreshTokenFilter);
        var refreshTokens = Object.keys(credentialCache.refreshTokens).map(function (key) { return credentialCache.refreshTokens[key]; });
        var numRefreshTokens = refreshTokens.length;
        if (numRefreshTokens < 1) {
            return null;
        }
        // address the else case after remove functions address environment aliases
        return refreshTokens[0];
    };
    /**
     * Retrieve AppMetadataEntity from cache
     */
    CacheManager.prototype.readAppMetadataFromCache = function (environment, clientId) {
        var appMetadataFilter = {
            environment: environment,
            clientId: clientId,
        };
        var appMetadata = this.getAppMetadataFilteredBy(appMetadataFilter);
        var appMetadataEntries = Object.keys(appMetadata).map(function (key) { return appMetadata[key]; });
        var numAppMetadata = appMetadataEntries.length;
        if (numAppMetadata < 1) {
            return null;
        }
        else if (numAppMetadata > 1) {
            throw ClientAuthError.createMultipleMatchingAppMetadataInCacheError();
        }
        return appMetadataEntries[0];
    };
    /**
     * Return the family_id value associated  with FOCI
     * @param environment
     * @param clientId
     */
    CacheManager.prototype.isAppMetadataFOCI = function (environment, clientId) {
        var appMetadata = this.readAppMetadataFromCache(environment, clientId);
        return !!(appMetadata && appMetadata.familyId === THE_FAMILY_ID);
    };
    /**
     * helper to match account ids
     * @param value
     * @param homeAccountId
     */
    CacheManager.prototype.matchHomeAccountId = function (entity, homeAccountId) {
        return !!(entity.homeAccountId && homeAccountId === entity.homeAccountId);
    };
    /**
     * helper to match assertion
     * @param value
     * @param oboAssertion
     */
    CacheManager.prototype.matchOboAssertion = function (entity, oboAssertion) {
        return !!(entity.oboAssertion && oboAssertion === entity.oboAssertion);
    };
    /**
     * helper to match environment
     * @param value
     * @param environment
     */
    CacheManager.prototype.matchEnvironment = function (entity, environment) {
        var cloudMetadata = this.getAuthorityMetadataByAlias(environment);
        if (cloudMetadata && cloudMetadata.aliases.indexOf(entity.environment) > -1) {
            return true;
        }
        return false;
    };
    /**
     * helper to match credential type
     * @param entity
     * @param credentialType
     */
    CacheManager.prototype.matchCredentialType = function (entity, credentialType) {
        return (entity.credentialType && credentialType.toLowerCase() === entity.credentialType.toLowerCase());
    };
    /**
     * helper to match client ids
     * @param entity
     * @param clientId
     */
    CacheManager.prototype.matchClientId = function (entity, clientId) {
        return !!(entity.clientId && clientId === entity.clientId);
    };
    /**
     * helper to match family ids
     * @param entity
     * @param familyId
     */
    CacheManager.prototype.matchFamilyId = function (entity, familyId) {
        return !!(entity.familyId && familyId === entity.familyId);
    };
    /**
     * helper to match realm
     * @param entity
     * @param realm
     */
    CacheManager.prototype.matchRealm = function (entity, realm) {
        return !!(entity.realm && realm === entity.realm);
    };
    /**
     * Returns true if the target scopes are a subset of the current entity's scopes, false otherwise.
     * @param entity
     * @param target
     */
    CacheManager.prototype.matchTarget = function (entity, target) {
        var isNotAccessTokenCredential = (entity.credentialType !== CredentialType.ACCESS_TOKEN && entity.credentialType !== CredentialType.ACCESS_TOKEN_WITH_AUTH_SCHEME);
        if (isNotAccessTokenCredential || !entity.target) {
            return false;
        }
        var entityScopeSet = ScopeSet.fromString(entity.target);
        var requestTargetScopeSet = ScopeSet.fromString(target);
        if (!requestTargetScopeSet.containsOnlyOIDCScopes()) {
            requestTargetScopeSet.removeOIDCScopes(); // ignore OIDC scopes
        }
        else {
            requestTargetScopeSet.removeScope(Constants.OFFLINE_ACCESS_SCOPE);
        }
        return entityScopeSet.containsScopeSet(requestTargetScopeSet);
    };
    /**
     * returns if a given cache entity is of the type appmetadata
     * @param key
     */
    CacheManager.prototype.isAppMetadata = function (key) {
        return key.indexOf(APP_METADATA) !== -1;
    };
    /**
     * returns if a given cache entity is of the type authoritymetadata
     * @param key
     */
    CacheManager.prototype.isAuthorityMetadata = function (key) {
        return key.indexOf(AUTHORITY_METADATA_CONSTANTS.CACHE_KEY) !== -1;
    };
    /**
     * returns cache key used for cloud instance metadata
     */
    CacheManager.prototype.generateAuthorityMetadataCacheKey = function (authority) {
        return AUTHORITY_METADATA_CONSTANTS.CACHE_KEY + "-" + this.clientId + "-" + authority;
    };
    /**
     * Returns the specific credential (IdToken/AccessToken/RefreshToken) from the cache
     * @param key
     * @param credType
     */
    CacheManager.prototype.getSpecificCredential = function (key, credType) {
        switch (credType) {
            case CredentialType.ID_TOKEN: {
                return this.getIdTokenCredential(key);
            }
            case CredentialType.ACCESS_TOKEN:
            case CredentialType.ACCESS_TOKEN_WITH_AUTH_SCHEME: {
                return this.getAccessTokenCredential(key);
            }
            case CredentialType.REFRESH_TOKEN: {
                return this.getRefreshTokenCredential(key);
            }
            default:
                return null;
        }
    };
    /**
     * Helper to convert serialized data to object
     * @param obj
     * @param json
     */
    CacheManager.toObject = function (obj, json) {
        for (var propertyName in json) {
            obj[propertyName] = json[propertyName];
        }
        return obj;
    };
    return CacheManager;
}());
var DefaultStorageClass = /** @class */ (function (_super) {
    __extends(DefaultStorageClass, _super);
    function DefaultStorageClass() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DefaultStorageClass.prototype.setAccount = function () {
        var notImplErr = "Storage interface - setAccount() has not been implemented for the cacheStorage interface.";
        throw AuthError.createUnexpectedError(notImplErr);
    };
    DefaultStorageClass.prototype.getAccount = function () {
        var notImplErr = "Storage interface - getAccount() has not been implemented for the cacheStorage interface.";
        throw AuthError.createUnexpectedError(notImplErr);
    };
    DefaultStorageClass.prototype.setIdTokenCredential = function () {
        var notImplErr = "Storage interface - setIdTokenCredential() has not been implemented for the cacheStorage interface.";
        throw AuthError.createUnexpectedError(notImplErr);
    };
    DefaultStorageClass.prototype.getIdTokenCredential = function () {
        var notImplErr = "Storage interface - getIdTokenCredential() has not been implemented for the cacheStorage interface.";
        throw AuthError.createUnexpectedError(notImplErr);
    };
    DefaultStorageClass.prototype.setAccessTokenCredential = function () {
        var notImplErr = "Storage interface - setAccessTokenCredential() has not been implemented for the cacheStorage interface.";
        throw AuthError.createUnexpectedError(notImplErr);
    };
    DefaultStorageClass.prototype.getAccessTokenCredential = function () {
        var notImplErr = "Storage interface - getAccessTokenCredential() has not been implemented for the cacheStorage interface.";
        throw AuthError.createUnexpectedError(notImplErr);
    };
    DefaultStorageClass.prototype.setRefreshTokenCredential = function () {
        var notImplErr = "Storage interface - setRefreshTokenCredential() has not been implemented for the cacheStorage interface.";
        throw AuthError.createUnexpectedError(notImplErr);
    };
    DefaultStorageClass.prototype.getRefreshTokenCredential = function () {
        var notImplErr = "Storage interface - getRefreshTokenCredential() has not been implemented for the cacheStorage interface.";
        throw AuthError.createUnexpectedError(notImplErr);
    };
    DefaultStorageClass.prototype.setAppMetadata = function () {
        var notImplErr = "Storage interface - setAppMetadata() has not been implemented for the cacheStorage interface.";
        throw AuthError.createUnexpectedError(notImplErr);
    };
    DefaultStorageClass.prototype.getAppMetadata = function () {
        var notImplErr = "Storage interface - getAppMetadata() has not been implemented for the cacheStorage interface.";
        throw AuthError.createUnexpectedError(notImplErr);
    };
    DefaultStorageClass.prototype.setServerTelemetry = function () {
        var notImplErr = "Storage interface - setServerTelemetry() has not been implemented for the cacheStorage interface.";
        throw AuthError.createUnexpectedError(notImplErr);
    };
    DefaultStorageClass.prototype.getServerTelemetry = function () {
        var notImplErr = "Storage interface - getServerTelemetry() has not been implemented for the cacheStorage interface.";
        throw AuthError.createUnexpectedError(notImplErr);
    };
    DefaultStorageClass.prototype.setAuthorityMetadata = function () {
        var notImplErr = "Storage interface - setAuthorityMetadata() has not been implemented for the cacheStorage interface.";
        throw AuthError.createUnexpectedError(notImplErr);
    };
    DefaultStorageClass.prototype.getAuthorityMetadata = function () {
        var notImplErr = "Storage interface - getAuthorityMetadata() has not been implemented for the cacheStorage interface.";
        throw AuthError.createUnexpectedError(notImplErr);
    };
    DefaultStorageClass.prototype.getAuthorityMetadataKeys = function () {
        var notImplErr = "Storage interface - getAuthorityMetadataKeys() has not been implemented for the cacheStorage interface.";
        throw AuthError.createUnexpectedError(notImplErr);
    };
    DefaultStorageClass.prototype.setThrottlingCache = function () {
        var notImplErr = "Storage interface - setThrottlingCache() has not been implemented for the cacheStorage interface.";
        throw AuthError.createUnexpectedError(notImplErr);
    };
    DefaultStorageClass.prototype.getThrottlingCache = function () {
        var notImplErr = "Storage interface - getThrottlingCache() has not been implemented for the cacheStorage interface.";
        throw AuthError.createUnexpectedError(notImplErr);
    };
    DefaultStorageClass.prototype.removeItem = function () {
        var notImplErr = "Storage interface - removeItem() has not been implemented for the cacheStorage interface.";
        throw AuthError.createUnexpectedError(notImplErr);
    };
    DefaultStorageClass.prototype.containsKey = function () {
        var notImplErr = "Storage interface - containsKey() has not been implemented for the cacheStorage interface.";
        throw AuthError.createUnexpectedError(notImplErr);
    };
    DefaultStorageClass.prototype.getKeys = function () {
        var notImplErr = "Storage interface - getKeys() has not been implemented for the cacheStorage interface.";
        throw AuthError.createUnexpectedError(notImplErr);
    };
    DefaultStorageClass.prototype.clear = function () {
        var notImplErr = "Storage interface - clear() has not been implemented for the cacheStorage interface.";
        throw AuthError.createUnexpectedError(notImplErr);
    };
    return DefaultStorageClass;
}(CacheManager));

/*! @azure/msal-common v4.4.0 2021-06-29 */

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
// Token renewal offset default in seconds
var DEFAULT_TOKEN_RENEWAL_OFFSET_SEC = 300;
var DEFAULT_SYSTEM_OPTIONS = {
    tokenRenewalOffsetSeconds: DEFAULT_TOKEN_RENEWAL_OFFSET_SEC,
    preventCorsPreflight: false
};
var DEFAULT_LOGGER_IMPLEMENTATION = {
    loggerCallback: function () {
        // allow users to not set loggerCallback
    },
    piiLoggingEnabled: false,
    logLevel: LogLevel$1.Info,
    correlationId: ""
};
var DEFAULT_NETWORK_IMPLEMENTATION = {
    sendGetRequestAsync: function () {
        return __awaiter(this, void 0, void 0, function () {
            var notImplErr;
            return __generator(this, function (_a) {
                notImplErr = "Network interface - sendGetRequestAsync() has not been implemented";
                throw AuthError.createUnexpectedError(notImplErr);
            });
        });
    },
    sendPostRequestAsync: function () {
        return __awaiter(this, void 0, void 0, function () {
            var notImplErr;
            return __generator(this, function (_a) {
                notImplErr = "Network interface - sendPostRequestAsync() has not been implemented";
                throw AuthError.createUnexpectedError(notImplErr);
            });
        });
    }
};
var DEFAULT_LIBRARY_INFO = {
    sku: Constants.SKU,
    version: version$5,
    cpu: "",
    os: ""
};
var DEFAULT_CLIENT_CREDENTIALS = {
    clientSecret: "",
    clientAssertion: undefined
};
/**
 * Function that sets the default options when not explicitly configured from app developer
 *
 * @param Configuration
 *
 * @returns Configuration
 */
function buildClientConfiguration(_a) {
    var userAuthOptions = _a.authOptions, userSystemOptions = _a.systemOptions, userLoggerOption = _a.loggerOptions, storageImplementation = _a.storageInterface, networkImplementation = _a.networkInterface, cryptoImplementation = _a.cryptoInterface, clientCredentials = _a.clientCredentials, libraryInfo = _a.libraryInfo, serverTelemetryManager = _a.serverTelemetryManager, persistencePlugin = _a.persistencePlugin, serializableCache = _a.serializableCache;
    return {
        authOptions: buildAuthOptions(userAuthOptions),
        systemOptions: __assign(__assign({}, DEFAULT_SYSTEM_OPTIONS), userSystemOptions),
        loggerOptions: __assign(__assign({}, DEFAULT_LOGGER_IMPLEMENTATION), userLoggerOption),
        storageInterface: storageImplementation || new DefaultStorageClass(userAuthOptions.clientId, DEFAULT_CRYPTO_IMPLEMENTATION),
        networkInterface: networkImplementation || DEFAULT_NETWORK_IMPLEMENTATION,
        cryptoInterface: cryptoImplementation || DEFAULT_CRYPTO_IMPLEMENTATION,
        clientCredentials: clientCredentials || DEFAULT_CLIENT_CREDENTIALS,
        libraryInfo: __assign(__assign({}, DEFAULT_LIBRARY_INFO), libraryInfo),
        serverTelemetryManager: serverTelemetryManager || null,
        persistencePlugin: persistencePlugin || null,
        serializableCache: serializableCache || null
    };
}
/**
 * Construct authoptions from the client and platform passed values
 * @param authOptions
 */
function buildAuthOptions(authOptions) {
    return __assign({ clientCapabilities: [] }, authOptions);
}

/*! @azure/msal-common v4.4.0 2021-06-29 */

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * Error thrown when there is an error with the server code, for example, unavailability.
 */
var ServerError = /** @class */ (function (_super) {
    __extends(ServerError, _super);
    function ServerError(errorCode, errorMessage, subError) {
        var _this = _super.call(this, errorCode, errorMessage, subError) || this;
        _this.name = "ServerError";
        Object.setPrototypeOf(_this, ServerError.prototype);
        return _this;
    }
    return ServerError;
}(AuthError));

/*! @azure/msal-common v4.4.0 2021-06-29 */

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
var ThrottlingUtils = /** @class */ (function () {
    function ThrottlingUtils() {
    }
    /**
     * Prepares a RequestThumbprint to be stored as a key.
     * @param thumbprint
     */
    ThrottlingUtils.generateThrottlingStorageKey = function (thumbprint) {
        return ThrottlingConstants.THROTTLING_PREFIX + "." + JSON.stringify(thumbprint);
    };
    /**
     * Performs necessary throttling checks before a network request.
     * @param cacheManager
     * @param thumbprint
     */
    ThrottlingUtils.preProcess = function (cacheManager, thumbprint) {
        var _a;
        var key = ThrottlingUtils.generateThrottlingStorageKey(thumbprint);
        var value = cacheManager.getThrottlingCache(key);
        if (value) {
            if (value.throttleTime < Date.now()) {
                cacheManager.removeItem(key, CacheSchemaType.THROTTLING);
                return;
            }
            throw new ServerError(((_a = value.errorCodes) === null || _a === void 0 ? void 0 : _a.join(" ")) || Constants.EMPTY_STRING, value.errorMessage, value.subError);
        }
    };
    /**
     * Performs necessary throttling checks after a network request.
     * @param cacheManager
     * @param thumbprint
     * @param response
     */
    ThrottlingUtils.postProcess = function (cacheManager, thumbprint, response) {
        if (ThrottlingUtils.checkResponseStatus(response) || ThrottlingUtils.checkResponseForRetryAfter(response)) {
            var thumbprintValue = {
                throttleTime: ThrottlingUtils.calculateThrottleTime(parseInt(response.headers[HeaderNames.RETRY_AFTER])),
                error: response.body.error,
                errorCodes: response.body.error_codes,
                errorMessage: response.body.error_description,
                subError: response.body.suberror
            };
            cacheManager.setThrottlingCache(ThrottlingUtils.generateThrottlingStorageKey(thumbprint), thumbprintValue);
        }
    };
    /**
     * Checks a NetworkResponse object's status codes against 429 or 5xx
     * @param response
     */
    ThrottlingUtils.checkResponseStatus = function (response) {
        return response.status === 429 || response.status >= 500 && response.status < 600;
    };
    /**
     * Checks a NetworkResponse object's RetryAfter header
     * @param response
     */
    ThrottlingUtils.checkResponseForRetryAfter = function (response) {
        if (response.headers) {
            return response.headers.hasOwnProperty(HeaderNames.RETRY_AFTER) && (response.status < 200 || response.status >= 300);
        }
        return false;
    };
    /**
     * Calculates the Unix-time value for a throttle to expire given throttleTime in seconds.
     * @param throttleTime
     */
    ThrottlingUtils.calculateThrottleTime = function (throttleTime) {
        var time = throttleTime <= 0 ? 0 : throttleTime;
        var currentSeconds = Date.now() / 1000;
        return Math.floor(Math.min(currentSeconds + (time || ThrottlingConstants.DEFAULT_THROTTLE_TIME_SECONDS), currentSeconds + ThrottlingConstants.DEFAULT_MAX_THROTTLE_TIME_SECONDS) * 1000);
    };
    ThrottlingUtils.removeThrottle = function (cacheManager, clientId, authority, scopes, homeAccountIdentifier) {
        var thumbprint = {
            clientId: clientId,
            authority: authority,
            scopes: scopes,
            homeAccountIdentifier: homeAccountIdentifier
        };
        var key = this.generateThrottlingStorageKey(thumbprint);
        return cacheManager.removeItem(key, CacheSchemaType.THROTTLING);
    };
    return ThrottlingUtils;
}());

/*! @azure/msal-common v4.4.0 2021-06-29 */

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
var NetworkManager = /** @class */ (function () {
    function NetworkManager(networkClient, cacheManager) {
        this.networkClient = networkClient;
        this.cacheManager = cacheManager;
    }
    /**
     * Wraps sendPostRequestAsync with necessary preflight and postflight logic
     * @param thumbprint
     * @param tokenEndpoint
     * @param options
     */
    NetworkManager.prototype.sendPostRequest = function (thumbprint, tokenEndpoint, options) {
        return __awaiter(this, void 0, void 0, function () {
            var response, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        ThrottlingUtils.preProcess(this.cacheManager, thumbprint);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.networkClient.sendPostRequestAsync(tokenEndpoint, options)];
                    case 2:
                        response = _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        if (e_1 instanceof AuthError) {
                            throw e_1;
                        }
                        else {
                            throw ClientAuthError.createNetworkError(tokenEndpoint, e_1);
                        }
                    case 4:
                        ThrottlingUtils.postProcess(this.cacheManager, thumbprint, response);
                        return [2 /*return*/, response];
                }
            });
        });
    };
    return NetworkManager;
}());

/*! @azure/msal-common v4.4.0 2021-06-29 */
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
var CcsCredentialType;
(function (CcsCredentialType) {
    CcsCredentialType["HOME_ACCOUNT_ID"] = "home_account_id";
    CcsCredentialType["UPN"] = "UPN";
})(CcsCredentialType || (CcsCredentialType = {}));

/*! @azure/msal-common v4.4.0 2021-06-29 */

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * Base application class which will construct requests to send to and handle responses from the Microsoft STS using the authorization code flow.
 */
var BaseClient = /** @class */ (function () {
    function BaseClient(configuration) {
        // Set the configuration
        this.config = buildClientConfiguration(configuration);
        // Initialize the logger
        this.logger = new Logger$1(this.config.loggerOptions, name$t, version$5);
        // Initialize crypto
        this.cryptoUtils = this.config.cryptoInterface;
        // Initialize storage interface
        this.cacheManager = this.config.storageInterface;
        // Set the network interface
        this.networkClient = this.config.networkInterface;
        // Set the NetworkManager
        this.networkManager = new NetworkManager(this.networkClient, this.cacheManager);
        // Set TelemetryManager
        this.serverTelemetryManager = this.config.serverTelemetryManager;
        // set Authority
        this.authority = this.config.authOptions.authority;
    }
    /**
     * Creates default headers for requests to token endpoint
     */
    BaseClient.prototype.createTokenRequestHeaders = function (ccsCred) {
        var headers = {};
        headers[HeaderNames.CONTENT_TYPE] = Constants.URL_FORM_CONTENT_TYPE;
        if (!this.config.systemOptions.preventCorsPreflight && ccsCred) {
            switch (ccsCred.type) {
                case CcsCredentialType.HOME_ACCOUNT_ID:
                    try {
                        var clientInfo = buildClientInfoFromHomeAccountId(ccsCred.credential);
                        headers[HeaderNames.CCS_HEADER] = "Oid:" + clientInfo.uid + "@" + clientInfo.utid;
                    }
                    catch (e) {
                        this.logger.verbose("Could not parse home account ID for CCS Header: " + e);
                    }
                    break;
                case CcsCredentialType.UPN:
                    headers[HeaderNames.CCS_HEADER] = "UPN: " + ccsCred.credential;
                    break;
            }
        }
        return headers;
    };
    /**
     * Http post to token endpoint
     * @param tokenEndpoint
     * @param queryString
     * @param headers
     * @param thumbprint
     */
    BaseClient.prototype.executePostToTokenEndpoint = function (tokenEndpoint, queryString, headers, thumbprint) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.networkManager.sendPostRequest(thumbprint, tokenEndpoint, { body: queryString, headers: headers })];
                    case 1:
                        response = _a.sent();
                        if (this.config.serverTelemetryManager && response.status < 500 && response.status !== 429) {
                            // Telemetry data successfully logged by server, clear Telemetry cache
                            this.config.serverTelemetryManager.clearTelemetryCache();
                        }
                        return [2 /*return*/, response];
                }
            });
        });
    };
    /**
     * Updates the authority object of the client. Endpoint discovery must be completed.
     * @param updatedAuthority
     */
    BaseClient.prototype.updateAuthority = function (updatedAuthority) {
        if (!updatedAuthority.discoveryComplete()) {
            throw ClientAuthError.createEndpointDiscoveryIncompleteError("Updated authority has not completed endpoint discovery.");
        }
        this.authority = updatedAuthority;
    };
    return BaseClient;
}());

/*! @azure/msal-common v4.4.0 2021-06-29 */

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * Validates server consumable params from the "request" objects
 */
var RequestValidator = /** @class */ (function () {
    function RequestValidator() {
    }
    /**
     * Utility to check if the `redirectUri` in the request is a non-null value
     * @param redirectUri
     */
    RequestValidator.validateRedirectUri = function (redirectUri) {
        if (StringUtils.isEmpty(redirectUri)) {
            throw ClientConfigurationError.createRedirectUriEmptyError();
        }
    };
    /**
     * Utility to validate prompt sent by the user in the request
     * @param prompt
     */
    RequestValidator.validatePrompt = function (prompt) {
        if ([
            PromptValue.LOGIN,
            PromptValue.SELECT_ACCOUNT,
            PromptValue.CONSENT,
            PromptValue.NONE
        ].indexOf(prompt) < 0) {
            throw ClientConfigurationError.createInvalidPromptError(prompt);
        }
    };
    RequestValidator.validateClaims = function (claims) {
        try {
            JSON.parse(claims);
        }
        catch (e) {
            throw ClientConfigurationError.createInvalidClaimsRequestError();
        }
    };
    /**
     * Utility to validate code_challenge and code_challenge_method
     * @param codeChallenge
     * @param codeChallengeMethod
     */
    RequestValidator.validateCodeChallengeParams = function (codeChallenge, codeChallengeMethod) {
        if (StringUtils.isEmpty(codeChallenge) || StringUtils.isEmpty(codeChallengeMethod)) {
            throw ClientConfigurationError.createInvalidCodeChallengeParamsError();
        }
        else {
            this.validateCodeChallengeMethod(codeChallengeMethod);
        }
    };
    /**
     * Utility to validate code_challenge_method
     * @param codeChallengeMethod
     */
    RequestValidator.validateCodeChallengeMethod = function (codeChallengeMethod) {
        if ([
            CodeChallengeMethodValues.PLAIN,
            CodeChallengeMethodValues.S256
        ].indexOf(codeChallengeMethod) < 0) {
            throw ClientConfigurationError.createInvalidCodeChallengeMethodError();
        }
    };
    /**
     * Removes unnecessary or duplicate query parameters from extraQueryParameters
     * @param request
     */
    RequestValidator.sanitizeEQParams = function (eQParams, queryParams) {
        if (!eQParams) {
            return {};
        }
        // Remove any query parameters already included in SSO params
        queryParams.forEach(function (value, key) {
            if (eQParams[key]) {
                delete eQParams[key];
            }
        });
        return eQParams;
    };
    return RequestValidator;
}());

/*! @azure/msal-common v4.4.0 2021-06-29 */

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
var RequestParameterBuilder = /** @class */ (function () {
    function RequestParameterBuilder() {
        this.parameters = new Map();
    }
    /**
     * add response_type = code
     */
    RequestParameterBuilder.prototype.addResponseTypeCode = function () {
        this.parameters.set(AADServerParamKeys.RESPONSE_TYPE, encodeURIComponent(Constants.CODE_RESPONSE_TYPE));
    };
    /**
     * add response_mode. defaults to query.
     * @param responseMode
     */
    RequestParameterBuilder.prototype.addResponseMode = function (responseMode) {
        this.parameters.set(AADServerParamKeys.RESPONSE_MODE, encodeURIComponent((responseMode) ? responseMode : ResponseMode.QUERY));
    };
    /**
     * add scopes. set addOidcScopes to false to prevent default scopes in non-user scenarios
     * @param scopeSet
     * @param addOidcScopes
     */
    RequestParameterBuilder.prototype.addScopes = function (scopes, addOidcScopes) {
        if (addOidcScopes === void 0) { addOidcScopes = true; }
        var requestScopes = addOidcScopes ? __spreadArrays(scopes || [], OIDC_DEFAULT_SCOPES) : scopes || [];
        var scopeSet = new ScopeSet(requestScopes);
        this.parameters.set(AADServerParamKeys.SCOPE, encodeURIComponent(scopeSet.printScopes()));
    };
    /**
     * add clientId
     * @param clientId
     */
    RequestParameterBuilder.prototype.addClientId = function (clientId) {
        this.parameters.set(AADServerParamKeys.CLIENT_ID, encodeURIComponent(clientId));
    };
    /**
     * add redirect_uri
     * @param redirectUri
     */
    RequestParameterBuilder.prototype.addRedirectUri = function (redirectUri) {
        RequestValidator.validateRedirectUri(redirectUri);
        this.parameters.set(AADServerParamKeys.REDIRECT_URI, encodeURIComponent(redirectUri));
    };
    /**
     * add post logout redirectUri
     * @param redirectUri
     */
    RequestParameterBuilder.prototype.addPostLogoutRedirectUri = function (redirectUri) {
        RequestValidator.validateRedirectUri(redirectUri);
        this.parameters.set(AADServerParamKeys.POST_LOGOUT_URI, encodeURIComponent(redirectUri));
    };
    /**
     * add id_token_hint to logout request
     * @param idTokenHint
     */
    RequestParameterBuilder.prototype.addIdTokenHint = function (idTokenHint) {
        this.parameters.set(AADServerParamKeys.ID_TOKEN_HINT, encodeURIComponent(idTokenHint));
    };
    /**
     * add domain_hint
     * @param domainHint
     */
    RequestParameterBuilder.prototype.addDomainHint = function (domainHint) {
        this.parameters.set(SSOTypes.DOMAIN_HINT, encodeURIComponent(domainHint));
    };
    /**
     * add login_hint
     * @param loginHint
     */
    RequestParameterBuilder.prototype.addLoginHint = function (loginHint) {
        this.parameters.set(SSOTypes.LOGIN_HINT, encodeURIComponent(loginHint));
    };
    /**
     * Adds the CCS (Cache Credential Service) query parameter for login_hint
     * @param loginHint
     */
    RequestParameterBuilder.prototype.addCcsUpn = function (loginHint) {
        this.parameters.set(HeaderNames.CCS_HEADER, encodeURIComponent("UPN:" + loginHint));
    };
    /**
     * Adds the CCS (Cache Credential Service) query parameter for account object
     * @param loginHint
     */
    RequestParameterBuilder.prototype.addCcsOid = function (clientInfo) {
        this.parameters.set(HeaderNames.CCS_HEADER, encodeURIComponent("Oid:" + clientInfo.uid + "@" + clientInfo.utid));
    };
    /**
     * add sid
     * @param sid
     */
    RequestParameterBuilder.prototype.addSid = function (sid) {
        this.parameters.set(SSOTypes.SID, encodeURIComponent(sid));
    };
    /**
     * add claims
     * @param claims
     */
    RequestParameterBuilder.prototype.addClaims = function (claims, clientCapabilities) {
        var mergedClaims = this.addClientCapabilitiesToClaims(claims, clientCapabilities);
        RequestValidator.validateClaims(mergedClaims);
        this.parameters.set(AADServerParamKeys.CLAIMS, encodeURIComponent(mergedClaims));
    };
    /**
     * add correlationId
     * @param correlationId
     */
    RequestParameterBuilder.prototype.addCorrelationId = function (correlationId) {
        this.parameters.set(AADServerParamKeys.CLIENT_REQUEST_ID, encodeURIComponent(correlationId));
    };
    /**
     * add library info query params
     * @param libraryInfo
     */
    RequestParameterBuilder.prototype.addLibraryInfo = function (libraryInfo) {
        // Telemetry Info
        this.parameters.set(AADServerParamKeys.X_CLIENT_SKU, libraryInfo.sku);
        this.parameters.set(AADServerParamKeys.X_CLIENT_VER, libraryInfo.version);
        this.parameters.set(AADServerParamKeys.X_CLIENT_OS, libraryInfo.os);
        this.parameters.set(AADServerParamKeys.X_CLIENT_CPU, libraryInfo.cpu);
    };
    /**
     * add prompt
     * @param prompt
     */
    RequestParameterBuilder.prototype.addPrompt = function (prompt) {
        RequestValidator.validatePrompt(prompt);
        this.parameters.set("" + AADServerParamKeys.PROMPT, encodeURIComponent(prompt));
    };
    /**
     * add state
     * @param state
     */
    RequestParameterBuilder.prototype.addState = function (state) {
        if (!StringUtils.isEmpty(state)) {
            this.parameters.set(AADServerParamKeys.STATE, encodeURIComponent(state));
        }
    };
    /**
     * add nonce
     * @param nonce
     */
    RequestParameterBuilder.prototype.addNonce = function (nonce) {
        this.parameters.set(AADServerParamKeys.NONCE, encodeURIComponent(nonce));
    };
    /**
     * add code_challenge and code_challenge_method
     * - throw if either of them are not passed
     * @param codeChallenge
     * @param codeChallengeMethod
     */
    RequestParameterBuilder.prototype.addCodeChallengeParams = function (codeChallenge, codeChallengeMethod) {
        RequestValidator.validateCodeChallengeParams(codeChallenge, codeChallengeMethod);
        if (codeChallenge && codeChallengeMethod) {
            this.parameters.set(AADServerParamKeys.CODE_CHALLENGE, encodeURIComponent(codeChallenge));
            this.parameters.set(AADServerParamKeys.CODE_CHALLENGE_METHOD, encodeURIComponent(codeChallengeMethod));
        }
        else {
            throw ClientConfigurationError.createInvalidCodeChallengeParamsError();
        }
    };
    /**
     * add the `authorization_code` passed by the user to exchange for a token
     * @param code
     */
    RequestParameterBuilder.prototype.addAuthorizationCode = function (code) {
        this.parameters.set(AADServerParamKeys.CODE, encodeURIComponent(code));
    };
    /**
     * add the `authorization_code` passed by the user to exchange for a token
     * @param code
     */
    RequestParameterBuilder.prototype.addDeviceCode = function (code) {
        this.parameters.set(AADServerParamKeys.DEVICE_CODE, encodeURIComponent(code));
    };
    /**
     * add the `refreshToken` passed by the user
     * @param refreshToken
     */
    RequestParameterBuilder.prototype.addRefreshToken = function (refreshToken) {
        this.parameters.set(AADServerParamKeys.REFRESH_TOKEN, encodeURIComponent(refreshToken));
    };
    /**
     * add the `code_verifier` passed by the user to exchange for a token
     * @param codeVerifier
     */
    RequestParameterBuilder.prototype.addCodeVerifier = function (codeVerifier) {
        this.parameters.set(AADServerParamKeys.CODE_VERIFIER, encodeURIComponent(codeVerifier));
    };
    /**
     * add client_secret
     * @param clientSecret
     */
    RequestParameterBuilder.prototype.addClientSecret = function (clientSecret) {
        this.parameters.set(AADServerParamKeys.CLIENT_SECRET, encodeURIComponent(clientSecret));
    };
    /**
     * add clientAssertion for confidential client flows
     * @param clientAssertion
     */
    RequestParameterBuilder.prototype.addClientAssertion = function (clientAssertion) {
        this.parameters.set(AADServerParamKeys.CLIENT_ASSERTION, encodeURIComponent(clientAssertion));
    };
    /**
     * add clientAssertionType for confidential client flows
     * @param clientAssertionType
     */
    RequestParameterBuilder.prototype.addClientAssertionType = function (clientAssertionType) {
        this.parameters.set(AADServerParamKeys.CLIENT_ASSERTION_TYPE, encodeURIComponent(clientAssertionType));
    };
    /**
     * add OBO assertion for confidential client flows
     * @param clientAssertion
     */
    RequestParameterBuilder.prototype.addOboAssertion = function (oboAssertion) {
        this.parameters.set(AADServerParamKeys.OBO_ASSERTION, encodeURIComponent(oboAssertion));
    };
    /**
     * add grant type
     * @param grantType
     */
    RequestParameterBuilder.prototype.addRequestTokenUse = function (tokenUse) {
        this.parameters.set(AADServerParamKeys.REQUESTED_TOKEN_USE, encodeURIComponent(tokenUse));
    };
    /**
     * add grant type
     * @param grantType
     */
    RequestParameterBuilder.prototype.addGrantType = function (grantType) {
        this.parameters.set(AADServerParamKeys.GRANT_TYPE, encodeURIComponent(grantType));
    };
    /**
     * add client info
     *
     */
    RequestParameterBuilder.prototype.addClientInfo = function () {
        this.parameters.set(CLIENT_INFO, "1");
    };
    /**
     * add extraQueryParams
     * @param eQparams
     */
    RequestParameterBuilder.prototype.addExtraQueryParameters = function (eQparams) {
        var _this = this;
        RequestValidator.sanitizeEQParams(eQparams, this.parameters);
        Object.keys(eQparams).forEach(function (key) {
            _this.parameters.set(key, eQparams[key]);
        });
    };
    RequestParameterBuilder.prototype.addClientCapabilitiesToClaims = function (claims, clientCapabilities) {
        var mergedClaims;
        // Parse provided claims into JSON object or initialize empty object
        if (!claims) {
            mergedClaims = {};
        }
        else {
            try {
                mergedClaims = JSON.parse(claims);
            }
            catch (e) {
                throw ClientConfigurationError.createInvalidClaimsRequestError();
            }
        }
        if (clientCapabilities && clientCapabilities.length > 0) {
            if (!mergedClaims.hasOwnProperty(ClaimsRequestKeys.ACCESS_TOKEN)) {
                // Add access_token key to claims object
                mergedClaims[ClaimsRequestKeys.ACCESS_TOKEN] = {};
            }
            // Add xms_cc claim with provided clientCapabilities to access_token key
            mergedClaims[ClaimsRequestKeys.ACCESS_TOKEN][ClaimsRequestKeys.XMS_CC] = {
                values: clientCapabilities
            };
        }
        return JSON.stringify(mergedClaims);
    };
    /**
     * adds `username` for Password Grant flow
     * @param username
     */
    RequestParameterBuilder.prototype.addUsername = function (username) {
        this.parameters.set(PasswordGrantConstants.username, username);
    };
    /**
     * adds `password` for Password Grant flow
     * @param password
     */
    RequestParameterBuilder.prototype.addPassword = function (password) {
        this.parameters.set(PasswordGrantConstants.password, password);
    };
    /**
     * add pop_jwk to query params
     * @param cnfString
     */
    RequestParameterBuilder.prototype.addPopToken = function (cnfString) {
        if (!StringUtils.isEmpty(cnfString)) {
            this.parameters.set(AADServerParamKeys.TOKEN_TYPE, AuthenticationScheme.POP);
            this.parameters.set(AADServerParamKeys.REQ_CNF, encodeURIComponent(cnfString));
        }
    };
    /**
     * add server telemetry fields
     * @param serverTelemetryManager
     */
    RequestParameterBuilder.prototype.addServerTelemetry = function (serverTelemetryManager) {
        this.parameters.set(AADServerParamKeys.X_CLIENT_CURR_TELEM, serverTelemetryManager.generateCurrentRequestHeaderValue());
        this.parameters.set(AADServerParamKeys.X_CLIENT_LAST_TELEM, serverTelemetryManager.generateLastRequestHeaderValue());
    };
    /**
     * Adds parameter that indicates to the server that throttling is supported
     */
    RequestParameterBuilder.prototype.addThrottling = function () {
        this.parameters.set(AADServerParamKeys.X_MS_LIB_CAPABILITY, ThrottlingConstants.X_MS_LIB_CAPABILITY_VALUE);
    };
    /**
     * Utility to create a URL from the params map
     */
    RequestParameterBuilder.prototype.createQueryString = function () {
        var queryParameterArray = new Array();
        this.parameters.forEach(function (value, key) {
            queryParameterArray.push(key + "=" + value);
        });
        return queryParameterArray.join("&");
    };
    return RequestParameterBuilder;
}());

/*! @azure/msal-common v4.4.0 2021-06-29 */

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * ID_TOKEN Cache
 *
 * Key:Value Schema:
 *
 * Key Example: uid.utid-login.microsoftonline.com-idtoken-clientId-contoso.com-
 *
 * Value Schema:
 * {
 *      homeAccountId: home account identifier for the auth scheme,
 *      environment: entity that issued the token, represented as a full host
 *      credentialType: Type of credential as a string, can be one of the following: RefreshToken, AccessToken, IdToken, Password, Cookie, Certificate, Other
 *      clientId: client ID of the application
 *      secret: Actual credential as a string
 *      realm: Full tenant or organizational identifier that the account belongs to
 * }
 */
var IdTokenEntity = /** @class */ (function (_super) {
    __extends(IdTokenEntity, _super);
    function IdTokenEntity() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create IdTokenEntity
     * @param homeAccountId
     * @param authenticationResult
     * @param clientId
     * @param authority
     */
    IdTokenEntity.createIdTokenEntity = function (homeAccountId, environment, idToken, clientId, tenantId, oboAssertion) {
        var idTokenEntity = new IdTokenEntity();
        idTokenEntity.credentialType = CredentialType.ID_TOKEN;
        idTokenEntity.homeAccountId = homeAccountId;
        idTokenEntity.environment = environment;
        idTokenEntity.clientId = clientId;
        idTokenEntity.secret = idToken;
        idTokenEntity.realm = tenantId;
        idTokenEntity.oboAssertion = oboAssertion;
        return idTokenEntity;
    };
    /**
     * Validates an entity: checks for all expected params
     * @param entity
     */
    IdTokenEntity.isIdTokenEntity = function (entity) {
        if (!entity) {
            return false;
        }
        return (entity.hasOwnProperty("homeAccountId") &&
            entity.hasOwnProperty("environment") &&
            entity.hasOwnProperty("credentialType") &&
            entity.hasOwnProperty("realm") &&
            entity.hasOwnProperty("clientId") &&
            entity.hasOwnProperty("secret") &&
            entity["credentialType"] === CredentialType.ID_TOKEN);
    };
    return IdTokenEntity;
}(CredentialEntity));

/*! @azure/msal-common v4.4.0 2021-06-29 */
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * Utility class which exposes functions for managing date and time operations.
 */
var TimeUtils = /** @class */ (function () {
    function TimeUtils() {
    }
    /**
     * return the current time in Unix time (seconds).
     */
    TimeUtils.nowSeconds = function () {
        // Date.getTime() returns in milliseconds.
        return Math.round(new Date().getTime() / 1000.0);
    };
    /**
     * check if a token is expired based on given UTC time in seconds.
     * @param expiresOn
     */
    TimeUtils.isTokenExpired = function (expiresOn, offset) {
        // check for access token expiry
        var expirationSec = Number(expiresOn) || 0;
        var offsetCurrentTimeSec = TimeUtils.nowSeconds() + offset;
        // If current time + offset is greater than token expiration time, then token is expired.
        return (offsetCurrentTimeSec > expirationSec);
    };
    /**
     * If the current time is earlier than the time that a token was cached at, we must discard the token
     * i.e. The system clock was turned back after acquiring the cached token
     * @param cachedAt
     * @param offset
     */
    TimeUtils.wasClockTurnedBack = function (cachedAt) {
        var cachedAtSec = Number(cachedAt);
        return cachedAtSec > TimeUtils.nowSeconds();
    };
    /**
     * Waits for t number of milliseconds
     * @param t number
     * @param value T
     */
    TimeUtils.delay = function (t, value) {
        return new Promise(function (resolve) { return setTimeout(function () { return resolve(value); }, t); });
    };
    return TimeUtils;
}());

/*! @azure/msal-common v4.4.0 2021-06-29 */

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * ACCESS_TOKEN Credential Type
 *
 * Key:Value Schema:
 *
 * Key Example: uid.utid-login.microsoftonline.com-accesstoken-clientId-contoso.com-user.read
 *
 * Value Schema:
 * {
 *      homeAccountId: home account identifier for the auth scheme,
 *      environment: entity that issued the token, represented as a full host
 *      credentialType: Type of credential as a string, can be one of the following: RefreshToken, AccessToken, IdToken, Password, Cookie, Certificate, Other
 *      clientId: client ID of the application
 *      secret: Actual credential as a string
 *      familyId: Family ID identifier, usually only used for refresh tokens
 *      realm: Full tenant or organizational identifier that the account belongs to
 *      target: Permissions that are included in the token, or for refresh tokens, the resource identifier.
 *      cachedAt: Absolute device time when entry was created in the cache.
 *      expiresOn: Token expiry time, calculated based on current UTC time in seconds. Represented as a string.
 *      extendedExpiresOn: Additional extended expiry time until when token is valid in case of server-side outage. Represented as string in UTC seconds.
 *      keyId: used for POP and SSH tokenTypes
 *      tokenType: Type of the token issued. Usually "Bearer"
 * }
 */
var AccessTokenEntity = /** @class */ (function (_super) {
    __extends(AccessTokenEntity, _super);
    function AccessTokenEntity() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create AccessTokenEntity
     * @param homeAccountId
     * @param environment
     * @param accessToken
     * @param clientId
     * @param tenantId
     * @param scopes
     * @param expiresOn
     * @param extExpiresOn
     */
    AccessTokenEntity.createAccessTokenEntity = function (homeAccountId, environment, accessToken, clientId, tenantId, scopes, expiresOn, extExpiresOn, cryptoUtils, refreshOn, tokenType, oboAssertion) {
        var _a;
        var atEntity = new AccessTokenEntity();
        atEntity.homeAccountId = homeAccountId;
        atEntity.credentialType = CredentialType.ACCESS_TOKEN;
        atEntity.secret = accessToken;
        var currentTime = TimeUtils.nowSeconds();
        atEntity.cachedAt = currentTime.toString();
        /*
         * Token expiry time.
         * This value should be  calculated based on the current UTC time measured locally and the value  expires_in Represented as a string in JSON.
         */
        atEntity.expiresOn = expiresOn.toString();
        atEntity.extendedExpiresOn = extExpiresOn.toString();
        if (refreshOn) {
            atEntity.refreshOn = refreshOn.toString();
        }
        atEntity.environment = environment;
        atEntity.clientId = clientId;
        atEntity.realm = tenantId;
        atEntity.target = scopes;
        atEntity.oboAssertion = oboAssertion;
        atEntity.tokenType = StringUtils.isEmpty(tokenType) ? AuthenticationScheme.BEARER : tokenType;
        // Create Access Token With AuthScheme instead of regular access token
        if (atEntity.tokenType === AuthenticationScheme.POP) {
            atEntity.credentialType = CredentialType.ACCESS_TOKEN_WITH_AUTH_SCHEME;
            // Make sure keyId is present and add it to credential
            var tokenClaims = AuthToken.extractTokenClaims(accessToken, cryptoUtils);
            if (!((_a = tokenClaims === null || tokenClaims === void 0 ? void 0 : tokenClaims.cnf) === null || _a === void 0 ? void 0 : _a.kid)) {
                throw ClientAuthError.createTokenClaimsRequiredError();
            }
            atEntity.keyId = tokenClaims.cnf.kid;
        }
        return atEntity;
    };
    /**
     * Validates an entity: checks for all expected params
     * @param entity
     */
    AccessTokenEntity.isAccessTokenEntity = function (entity) {
        if (!entity) {
            return false;
        }
        return (entity.hasOwnProperty("homeAccountId") &&
            entity.hasOwnProperty("environment") &&
            entity.hasOwnProperty("credentialType") &&
            entity.hasOwnProperty("realm") &&
            entity.hasOwnProperty("clientId") &&
            entity.hasOwnProperty("secret") &&
            entity.hasOwnProperty("target") &&
            (entity["credentialType"] === CredentialType.ACCESS_TOKEN || entity["credentialType"] === CredentialType.ACCESS_TOKEN_WITH_AUTH_SCHEME));
    };
    return AccessTokenEntity;
}(CredentialEntity));

/*! @azure/msal-common v4.4.0 2021-06-29 */

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * REFRESH_TOKEN Cache
 *
 * Key:Value Schema:
 *
 * Key Example: uid.utid-login.microsoftonline.com-refreshtoken-clientId--
 *
 * Value:
 * {
 *      homeAccountId: home account identifier for the auth scheme,
 *      environment: entity that issued the token, represented as a full host
 *      credentialType: Type of credential as a string, can be one of the following: RefreshToken, AccessToken, IdToken, Password, Cookie, Certificate, Other
 *      clientId: client ID of the application
 *      secret: Actual credential as a string
 *      familyId: Family ID identifier, '1' represents Microsoft Family
 *      realm: Full tenant or organizational identifier that the account belongs to
 *      target: Permissions that are included in the token, or for refresh tokens, the resource identifier.
 * }
 */
var RefreshTokenEntity = /** @class */ (function (_super) {
    __extends(RefreshTokenEntity, _super);
    function RefreshTokenEntity() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create RefreshTokenEntity
     * @param homeAccountId
     * @param authenticationResult
     * @param clientId
     * @param authority
     */
    RefreshTokenEntity.createRefreshTokenEntity = function (homeAccountId, environment, refreshToken, clientId, familyId, oboAssertion) {
        var rtEntity = new RefreshTokenEntity();
        rtEntity.clientId = clientId;
        rtEntity.credentialType = CredentialType.REFRESH_TOKEN;
        rtEntity.environment = environment;
        rtEntity.homeAccountId = homeAccountId;
        rtEntity.secret = refreshToken;
        rtEntity.oboAssertion = oboAssertion;
        if (familyId)
            rtEntity.familyId = familyId;
        return rtEntity;
    };
    /**
     * Validates an entity: checks for all expected params
     * @param entity
     */
    RefreshTokenEntity.isRefreshTokenEntity = function (entity) {
        if (!entity) {
            return false;
        }
        return (entity.hasOwnProperty("homeAccountId") &&
            entity.hasOwnProperty("environment") &&
            entity.hasOwnProperty("credentialType") &&
            entity.hasOwnProperty("clientId") &&
            entity.hasOwnProperty("secret") &&
            entity["credentialType"] === CredentialType.REFRESH_TOKEN);
    };
    return RefreshTokenEntity;
}(CredentialEntity));

/*! @azure/msal-common v4.4.0 2021-06-29 */

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * InteractionRequiredAuthErrorMessage class containing string constants used by error codes and messages.
 */
var InteractionRequiredAuthErrorMessage = [
    "interaction_required",
    "consent_required",
    "login_required"
];
var InteractionRequiredAuthSubErrorMessage = [
    "message_only",
    "additional_action",
    "basic_action",
    "user_password_expired",
    "consent_required"
];
/**
 * Error thrown when user interaction is required at the auth server.
 */
var InteractionRequiredAuthError = /** @class */ (function (_super) {
    __extends(InteractionRequiredAuthError, _super);
    function InteractionRequiredAuthError(errorCode, errorMessage, subError) {
        var _this = _super.call(this, errorCode, errorMessage, subError) || this;
        _this.name = "InteractionRequiredAuthError";
        Object.setPrototypeOf(_this, InteractionRequiredAuthError.prototype);
        return _this;
    }
    InteractionRequiredAuthError.isInteractionRequiredError = function (errorCode, errorString, subError) {
        var isInteractionRequiredErrorCode = !!errorCode && InteractionRequiredAuthErrorMessage.indexOf(errorCode) > -1;
        var isInteractionRequiredSubError = !!subError && InteractionRequiredAuthSubErrorMessage.indexOf(subError) > -1;
        var isInteractionRequiredErrorDesc = !!errorString && InteractionRequiredAuthErrorMessage.some(function (irErrorCode) {
            return errorString.indexOf(irErrorCode) > -1;
        });
        return isInteractionRequiredErrorCode || isInteractionRequiredErrorDesc || isInteractionRequiredSubError;
    };
    return InteractionRequiredAuthError;
}(ServerError));

/*! @azure/msal-common v4.4.0 2021-06-29 */
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
var CacheRecord = /** @class */ (function () {
    function CacheRecord(accountEntity, idTokenEntity, accessTokenEntity, refreshTokenEntity, appMetadataEntity) {
        this.account = accountEntity || null;
        this.idToken = idTokenEntity || null;
        this.accessToken = accessTokenEntity || null;
        this.refreshToken = refreshTokenEntity || null;
        this.appMetadata = appMetadataEntity || null;
    }
    return CacheRecord;
}());

/*! @azure/msal-common v4.4.0 2021-06-29 */

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * Class which provides helpers for OAuth 2.0 protocol specific values
 */
var ProtocolUtils = /** @class */ (function () {
    function ProtocolUtils() {
    }
    /**
     * Appends user state with random guid, or returns random guid.
     * @param userState
     * @param randomGuid
     */
    ProtocolUtils.setRequestState = function (cryptoObj, userState, meta) {
        var libraryState = ProtocolUtils.generateLibraryState(cryptoObj, meta);
        return !StringUtils.isEmpty(userState) ? "" + libraryState + Constants.RESOURCE_DELIM + userState : libraryState;
    };
    /**
     * Generates the state value used by the common library.
     * @param randomGuid
     * @param cryptoObj
     */
    ProtocolUtils.generateLibraryState = function (cryptoObj, meta) {
        if (!cryptoObj) {
            throw ClientAuthError.createNoCryptoObjectError("generateLibraryState");
        }
        // Create a state object containing a unique id and the timestamp of the request creation
        var stateObj = {
            id: cryptoObj.createNewGuid()
        };
        if (meta) {
            stateObj.meta = meta;
        }
        var stateString = JSON.stringify(stateObj);
        return cryptoObj.base64Encode(stateString);
    };
    /**
     * Parses the state into the RequestStateObject, which contains the LibraryState info and the state passed by the user.
     * @param state
     * @param cryptoObj
     */
    ProtocolUtils.parseRequestState = function (cryptoObj, state) {
        if (!cryptoObj) {
            throw ClientAuthError.createNoCryptoObjectError("parseRequestState");
        }
        if (StringUtils.isEmpty(state)) {
            throw ClientAuthError.createInvalidStateError(state, "Null, undefined or empty state");
        }
        try {
            // Split the state between library state and user passed state and decode them separately
            var splitState = decodeURIComponent(state).split(Constants.RESOURCE_DELIM);
            var libraryState = splitState[0];
            var userState = splitState.length > 1 ? splitState.slice(1).join(Constants.RESOURCE_DELIM) : "";
            var libraryStateString = cryptoObj.base64Decode(libraryState);
            var libraryStateObj = JSON.parse(libraryStateString);
            return {
                userRequestState: !StringUtils.isEmpty(userState) ? userState : "",
                libraryState: libraryStateObj
            };
        }
        catch (e) {
            throw ClientAuthError.createInvalidStateError(state, e);
        }
    };
    return ProtocolUtils;
}());

/*! @azure/msal-common v4.4.0 2021-06-29 */

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * Url object class which can perform various transformations on url strings.
 */
var UrlString = /** @class */ (function () {
    function UrlString(url) {
        this._urlString = url;
        if (StringUtils.isEmpty(this._urlString)) {
            // Throws error if url is empty
            throw ClientConfigurationError.createUrlEmptyError();
        }
        if (StringUtils.isEmpty(this.getHash())) {
            this._urlString = UrlString.canonicalizeUri(url);
        }
    }
    Object.defineProperty(UrlString.prototype, "urlString", {
        get: function () {
            return this._urlString;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Ensure urls are lower case and end with a / character.
     * @param url
     */
    UrlString.canonicalizeUri = function (url) {
        if (url) {
            var lowerCaseUrl = url.toLowerCase();
            if (StringUtils.endsWith(lowerCaseUrl, "?")) {
                lowerCaseUrl = lowerCaseUrl.slice(0, -1);
            }
            else if (StringUtils.endsWith(lowerCaseUrl, "?/")) {
                lowerCaseUrl = lowerCaseUrl.slice(0, -2);
            }
            if (!StringUtils.endsWith(lowerCaseUrl, "/")) {
                lowerCaseUrl += "/";
            }
            return lowerCaseUrl;
        }
        return url;
    };
    /**
     * Throws if urlString passed is not a valid authority URI string.
     */
    UrlString.prototype.validateAsUri = function () {
        // Attempts to parse url for uri components
        var components;
        try {
            components = this.getUrlComponents();
        }
        catch (e) {
            throw ClientConfigurationError.createUrlParseError(e);
        }
        // Throw error if URI or path segments are not parseable.
        if (!components.HostNameAndPort || !components.PathSegments) {
            throw ClientConfigurationError.createUrlParseError("Given url string: " + this.urlString);
        }
        // Throw error if uri is insecure.
        if (!components.Protocol || components.Protocol.toLowerCase() !== "https:") {
            throw ClientConfigurationError.createInsecureAuthorityUriError(this.urlString);
        }
    };
    /**
     * Function to remove query string params from url. Returns the new url.
     * @param url
     * @param name
     */
    UrlString.prototype.urlRemoveQueryStringParameter = function (name) {
        var regex = new RegExp("(\\&" + name + "=)[^\&]+");
        this._urlString = this.urlString.replace(regex, "");
        // name=value&
        regex = new RegExp("(" + name + "=)[^\&]+&");
        this._urlString = this.urlString.replace(regex, "");
        // name=value
        regex = new RegExp("(" + name + "=)[^\&]+");
        this._urlString = this.urlString.replace(regex, "");
        return this.urlString;
    };
    /**
     * Given a url and a query string return the url with provided query string appended
     * @param url
     * @param queryString
     */
    UrlString.appendQueryString = function (url, queryString) {
        if (StringUtils.isEmpty(queryString)) {
            return url;
        }
        return url.indexOf("?") < 0 ? url + "?" + queryString : url + "&" + queryString;
    };
    /**
     * Returns a url with the hash removed
     * @param url
     */
    UrlString.removeHashFromUrl = function (url) {
        return UrlString.canonicalizeUri(url.split("#")[0]);
    };
    /**
     * Given a url like https://a:b/common/d?e=f#g, and a tenantId, returns https://a:b/tenantId/d
     * @param href The url
     * @param tenantId The tenant id to replace
     */
    UrlString.prototype.replaceTenantPath = function (tenantId) {
        var urlObject = this.getUrlComponents();
        var pathArray = urlObject.PathSegments;
        if (tenantId && (pathArray.length !== 0 && (pathArray[0] === AADAuthorityConstants.COMMON || pathArray[0] === AADAuthorityConstants.ORGANIZATIONS))) {
            pathArray[0] = tenantId;
        }
        return UrlString.constructAuthorityUriFromObject(urlObject);
    };
    /**
     * Returns the anchor part(#) of the URL
     */
    UrlString.prototype.getHash = function () {
        return UrlString.parseHash(this.urlString);
    };
    /**
     * Parses out the components from a url string.
     * @returns An object with the various components. Please cache this value insted of calling this multiple times on the same url.
     */
    UrlString.prototype.getUrlComponents = function () {
        // https://gist.github.com/curtisz/11139b2cfcaef4a261e0
        var regEx = RegExp("^(([^:/?#]+):)?(//([^/?#]*))?([^?#]*)(\\?([^#]*))?(#(.*))?");
        // If url string does not match regEx, we throw an error
        var match = this.urlString.match(regEx);
        if (!match) {
            throw ClientConfigurationError.createUrlParseError("Given url string: " + this.urlString);
        }
        // Url component object
        var urlComponents = {
            Protocol: match[1],
            HostNameAndPort: match[4],
            AbsolutePath: match[5],
            QueryString: match[7]
        };
        var pathSegments = urlComponents.AbsolutePath.split("/");
        pathSegments = pathSegments.filter(function (val) { return val && val.length > 0; }); // remove empty elements
        urlComponents.PathSegments = pathSegments;
        if (!StringUtils.isEmpty(urlComponents.QueryString) && urlComponents.QueryString.endsWith("/")) {
            urlComponents.QueryString = urlComponents.QueryString.substring(0, urlComponents.QueryString.length - 1);
        }
        return urlComponents;
    };
    UrlString.getDomainFromUrl = function (url) {
        var regEx = RegExp("^([^:/?#]+://)?([^/?#]*)");
        var match = url.match(regEx);
        if (!match) {
            throw ClientConfigurationError.createUrlParseError("Given url string: " + url);
        }
        return match[2];
    };
    UrlString.getAbsoluteUrl = function (relativeUrl, baseUrl) {
        if (relativeUrl[0] === Constants.FORWARD_SLASH) {
            var url = new UrlString(baseUrl);
            var baseComponents = url.getUrlComponents();
            return baseComponents.Protocol + "//" + baseComponents.HostNameAndPort + relativeUrl;
        }
        return relativeUrl;
    };
    /**
     * Parses hash string from given string. Returns empty string if no hash symbol is found.
     * @param hashString
     */
    UrlString.parseHash = function (hashString) {
        var hashIndex1 = hashString.indexOf("#");
        var hashIndex2 = hashString.indexOf("#/");
        if (hashIndex2 > -1) {
            return hashString.substring(hashIndex2 + 2);
        }
        else if (hashIndex1 > -1) {
            return hashString.substring(hashIndex1 + 1);
        }
        return "";
    };
    UrlString.constructAuthorityUriFromObject = function (urlObject) {
        return new UrlString(urlObject.Protocol + "//" + urlObject.HostNameAndPort + "/" + urlObject.PathSegments.join("/"));
    };
    /**
     * Returns URL hash as server auth code response object.
     */
    UrlString.getDeserializedHash = function (hash) {
        // Check if given hash is empty
        if (StringUtils.isEmpty(hash)) {
            return {};
        }
        // Strip the # symbol if present
        var parsedHash = UrlString.parseHash(hash);
        // If # symbol was not present, above will return empty string, so give original hash value
        var deserializedHash = StringUtils.queryStringToObject(StringUtils.isEmpty(parsedHash) ? hash : parsedHash);
        // Check if deserialization didn't work
        if (!deserializedHash) {
            throw ClientAuthError.createHashNotDeserializedError(JSON.stringify(deserializedHash));
        }
        return deserializedHash;
    };
    /**
     * Check if the hash of the URL string contains known properties
     */
    UrlString.hashContainsKnownProperties = function (hash) {
        if (StringUtils.isEmpty(hash)) {
            return false;
        }
        var parameters = UrlString.getDeserializedHash(hash);
        return !!(parameters.code ||
            parameters.error_description ||
            parameters.error ||
            parameters.state);
    };
    return UrlString;
}());

/*! @azure/msal-common v4.4.0 2021-06-29 */

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
var KeyLocation;
(function (KeyLocation) {
    KeyLocation["SW"] = "sw";
    KeyLocation["UHW"] = "uhw";
})(KeyLocation || (KeyLocation = {}));
var PopTokenGenerator = /** @class */ (function () {
    function PopTokenGenerator(cryptoUtils) {
        this.cryptoUtils = cryptoUtils;
    }
    PopTokenGenerator.prototype.generateCnf = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            var kidThumbprint, reqCnf;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.cryptoUtils.getPublicKeyThumbprint(request)];
                    case 1:
                        kidThumbprint = _a.sent();
                        reqCnf = {
                            kid: kidThumbprint,
                            xms_ksl: KeyLocation.SW
                        };
                        return [2 /*return*/, this.cryptoUtils.base64Encode(JSON.stringify(reqCnf))];
                }
            });
        });
    };
    PopTokenGenerator.prototype.signPopToken = function (accessToken, request) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var tokenClaims, resourceRequestMethod, resourceRequestUri, shrClaims, resourceUrlString, resourceUrlComponents;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        tokenClaims = AuthToken.extractTokenClaims(accessToken, this.cryptoUtils);
                        resourceRequestMethod = request.resourceRequestMethod, resourceRequestUri = request.resourceRequestUri, shrClaims = request.shrClaims;
                        resourceUrlString = (resourceRequestUri) ? new UrlString(resourceRequestUri) : undefined;
                        resourceUrlComponents = resourceUrlString === null || resourceUrlString === void 0 ? void 0 : resourceUrlString.getUrlComponents();
                        if (!((_a = tokenClaims === null || tokenClaims === void 0 ? void 0 : tokenClaims.cnf) === null || _a === void 0 ? void 0 : _a.kid)) {
                            throw ClientAuthError.createTokenClaimsRequiredError();
                        }
                        return [4 /*yield*/, this.cryptoUtils.signJwt({
                                at: accessToken,
                                ts: TimeUtils.nowSeconds(),
                                m: resourceRequestMethod === null || resourceRequestMethod === void 0 ? void 0 : resourceRequestMethod.toUpperCase(),
                                u: resourceUrlComponents === null || resourceUrlComponents === void 0 ? void 0 : resourceUrlComponents.HostNameAndPort,
                                nonce: this.cryptoUtils.createNewGuid(),
                                p: resourceUrlComponents === null || resourceUrlComponents === void 0 ? void 0 : resourceUrlComponents.AbsolutePath,
                                q: (resourceUrlComponents === null || resourceUrlComponents === void 0 ? void 0 : resourceUrlComponents.QueryString) ? [[], resourceUrlComponents.QueryString] : undefined,
                                client_claims: shrClaims || undefined
                            }, tokenClaims.cnf.kid)];
                    case 1: return [2 /*return*/, _b.sent()];
                }
            });
        });
    };
    return PopTokenGenerator;
}());

/*! @azure/msal-common v4.4.0 2021-06-29 */

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * APP_METADATA Cache
 *
 * Key:Value Schema:
 *
 * Key: appmetadata-<environment>-<client_id>
 *
 * Value:
 * {
 *      clientId: client ID of the application
 *      environment: entity that issued the token, represented as a full host
 *      familyId: Family ID identifier, '1' represents Microsoft Family
 * }
 */
var AppMetadataEntity = /** @class */ (function () {
    function AppMetadataEntity() {
    }
    /**
     * Generate AppMetadata Cache Key as per the schema: appmetadata-<environment>-<client_id>
     */
    AppMetadataEntity.prototype.generateAppMetadataKey = function () {
        return AppMetadataEntity.generateAppMetadataCacheKey(this.environment, this.clientId);
    };
    /**
     * Generate AppMetadata Cache Key
     */
    AppMetadataEntity.generateAppMetadataCacheKey = function (environment, clientId) {
        var appMetaDataKeyArray = [
            APP_METADATA,
            environment,
            clientId,
        ];
        return appMetaDataKeyArray.join(Separators.CACHE_KEY_SEPARATOR).toLowerCase();
    };
    /**
     * Creates AppMetadataEntity
     * @param clientId
     * @param environment
     * @param familyId
     */
    AppMetadataEntity.createAppMetadataEntity = function (clientId, environment, familyId) {
        var appMetadata = new AppMetadataEntity();
        appMetadata.clientId = clientId;
        appMetadata.environment = environment;
        if (familyId) {
            appMetadata.familyId = familyId;
        }
        return appMetadata;
    };
    /**
     * Validates an entity: checks for all expected params
     * @param entity
     */
    AppMetadataEntity.isAppMetadataEntity = function (key, entity) {
        if (!entity) {
            return false;
        }
        return (key.indexOf(APP_METADATA) === 0 &&
            entity.hasOwnProperty("clientId") &&
            entity.hasOwnProperty("environment"));
    };
    return AppMetadataEntity;
}());

/*! @azure/msal-common v4.4.0 2021-06-29 */
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * This class instance helps track the memory changes facilitating
 * decisions to read from and write to the persistent cache
 */ var TokenCacheContext = /** @class */ (function () {
    function TokenCacheContext(tokenCache, hasChanged) {
        this.cache = tokenCache;
        this.hasChanged = hasChanged;
    }
    Object.defineProperty(TokenCacheContext.prototype, "cacheHasChanged", {
        /**
         * boolean which indicates the changes in cache
         */
        get: function () {
            return this.hasChanged;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TokenCacheContext.prototype, "tokenCache", {
        /**
         * function to retrieve the token cache
         */
        get: function () {
            return this.cache;
        },
        enumerable: false,
        configurable: true
    });
    return TokenCacheContext;
}());

/*! @azure/msal-common v4.4.0 2021-06-29 */

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * Class that handles response parsing.
 */
var ResponseHandler = /** @class */ (function () {
    function ResponseHandler(clientId, cacheStorage, cryptoObj, logger, serializableCache, persistencePlugin) {
        this.clientId = clientId;
        this.cacheStorage = cacheStorage;
        this.cryptoObj = cryptoObj;
        this.logger = logger;
        this.serializableCache = serializableCache;
        this.persistencePlugin = persistencePlugin;
    }
    /**
     * Function which validates server authorization code response.
     * @param serverResponseHash
     * @param cachedState
     * @param cryptoObj
     */
    ResponseHandler.prototype.validateServerAuthorizationCodeResponse = function (serverResponseHash, cachedState, cryptoObj) {
        if (!serverResponseHash.state || !cachedState) {
            throw !serverResponseHash.state ? ClientAuthError.createStateNotFoundError("Server State") : ClientAuthError.createStateNotFoundError("Cached State");
        }
        if (decodeURIComponent(serverResponseHash.state) !== decodeURIComponent(cachedState)) {
            throw ClientAuthError.createStateMismatchError();
        }
        // Check for error
        if (serverResponseHash.error || serverResponseHash.error_description || serverResponseHash.suberror) {
            if (InteractionRequiredAuthError.isInteractionRequiredError(serverResponseHash.error, serverResponseHash.error_description, serverResponseHash.suberror)) {
                throw new InteractionRequiredAuthError(serverResponseHash.error || Constants.EMPTY_STRING, serverResponseHash.error_description, serverResponseHash.suberror);
            }
            throw new ServerError(serverResponseHash.error || Constants.EMPTY_STRING, serverResponseHash.error_description, serverResponseHash.suberror);
        }
        if (serverResponseHash.client_info) {
            buildClientInfo(serverResponseHash.client_info, cryptoObj);
        }
    };
    /**
     * Function which validates server authorization token response.
     * @param serverResponse
     */
    ResponseHandler.prototype.validateTokenResponse = function (serverResponse) {
        // Check for error
        if (serverResponse.error || serverResponse.error_description || serverResponse.suberror) {
            if (InteractionRequiredAuthError.isInteractionRequiredError(serverResponse.error, serverResponse.error_description, serverResponse.suberror)) {
                throw new InteractionRequiredAuthError(serverResponse.error, serverResponse.error_description, serverResponse.suberror);
            }
            var errString = serverResponse.error_codes + " - [" + serverResponse.timestamp + "]: " + serverResponse.error_description + " - Correlation ID: " + serverResponse.correlation_id + " - Trace ID: " + serverResponse.trace_id;
            throw new ServerError(serverResponse.error, errString, serverResponse.suberror);
        }
    };
    /**
     * Returns a constructed token response based on given string. Also manages the cache updates and cleanups.
     * @param serverTokenResponse
     * @param authority
     */
    ResponseHandler.prototype.handleServerTokenResponse = function (serverTokenResponse, authority, reqTimestamp, request, authCodePayload, oboAssertion, handlingRefreshTokenResponse) {
        return __awaiter(this, void 0, void 0, function () {
            var idTokenObj, requestStateObj, cacheRecord, cacheContext, key, account;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (serverTokenResponse.id_token) {
                            idTokenObj = new AuthToken(serverTokenResponse.id_token || Constants.EMPTY_STRING, this.cryptoObj);
                            // token nonce check (TODO: Add a warning if no nonce is given?)
                            if (authCodePayload && !StringUtils.isEmpty(authCodePayload.nonce)) {
                                if (idTokenObj.claims.nonce !== authCodePayload.nonce) {
                                    throw ClientAuthError.createNonceMismatchError();
                                }
                            }
                        }
                        // generate homeAccountId
                        this.homeAccountIdentifier = AccountEntity.generateHomeAccountId(serverTokenResponse.client_info || Constants.EMPTY_STRING, authority.authorityType, this.logger, this.cryptoObj, idTokenObj);
                        if (!!authCodePayload && !!authCodePayload.state) {
                            requestStateObj = ProtocolUtils.parseRequestState(this.cryptoObj, authCodePayload.state);
                        }
                        cacheRecord = this.generateCacheRecord(serverTokenResponse, authority, reqTimestamp, idTokenObj, request.scopes, oboAssertion, authCodePayload);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, , 4, 7]);
                        if (!(this.persistencePlugin && this.serializableCache)) return [3 /*break*/, 3];
                        this.logger.verbose("Persistence enabled, calling beforeCacheAccess");
                        cacheContext = new TokenCacheContext(this.serializableCache, true);
                        return [4 /*yield*/, this.persistencePlugin.beforeCacheAccess(cacheContext)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        /*
                         * When saving a refreshed tokens to the cache, it is expected that the account that was used is present in the cache.
                         * If not present, we should return null, as it's the case that another application called removeAccount in between
                         * the calls to getAllAccounts and acquireTokenSilent. We should not overwrite that removal.
                         */
                        if (handlingRefreshTokenResponse && cacheRecord.account) {
                            key = cacheRecord.account.generateAccountKey();
                            account = this.cacheStorage.getAccount(key);
                            if (!account) {
                                this.logger.warning("Account used to refresh tokens not in persistence, refreshed tokens will not be stored in the cache");
                                return [2 /*return*/, ResponseHandler.generateAuthenticationResult(this.cryptoObj, authority, cacheRecord, false, request, idTokenObj, requestStateObj)];
                            }
                        }
                        this.cacheStorage.saveCacheRecord(cacheRecord);
                        return [3 /*break*/, 7];
                    case 4:
                        if (!(this.persistencePlugin && this.serializableCache && cacheContext)) return [3 /*break*/, 6];
                        this.logger.verbose("Persistence enabled, calling afterCacheAccess");
                        return [4 /*yield*/, this.persistencePlugin.afterCacheAccess(cacheContext)];
                    case 5:
                        _a.sent();
                        _a.label = 6;
                    case 6: return [7 /*endfinally*/];
                    case 7: return [2 /*return*/, ResponseHandler.generateAuthenticationResult(this.cryptoObj, authority, cacheRecord, false, request, idTokenObj, requestStateObj)];
                }
            });
        });
    };
    /**
     * Generates CacheRecord
     * @param serverTokenResponse
     * @param idTokenObj
     * @param authority
     */
    ResponseHandler.prototype.generateCacheRecord = function (serverTokenResponse, authority, reqTimestamp, idTokenObj, requestScopes, oboAssertion, authCodePayload) {
        var env = authority.getPreferredCache();
        if (StringUtils.isEmpty(env)) {
            throw ClientAuthError.createInvalidCacheEnvironmentError();
        }
        // IdToken: non AAD scenarios can have empty realm
        var cachedIdToken;
        var cachedAccount;
        if (!StringUtils.isEmpty(serverTokenResponse.id_token) && !!idTokenObj) {
            cachedIdToken = IdTokenEntity.createIdTokenEntity(this.homeAccountIdentifier, env, serverTokenResponse.id_token || Constants.EMPTY_STRING, this.clientId, idTokenObj.claims.tid || Constants.EMPTY_STRING, oboAssertion);
            cachedAccount = this.generateAccountEntity(serverTokenResponse, idTokenObj, authority, oboAssertion, authCodePayload);
        }
        // AccessToken
        var cachedAccessToken = null;
        if (!StringUtils.isEmpty(serverTokenResponse.access_token)) {
            // If scopes not returned in server response, use request scopes
            var responseScopes = serverTokenResponse.scope ? ScopeSet.fromString(serverTokenResponse.scope) : new ScopeSet(requestScopes || []);
            /*
             * Use timestamp calculated before request
             * Server may return timestamps as strings, parse to numbers if so.
             */
            var expiresIn = (typeof serverTokenResponse.expires_in === "string" ? parseInt(serverTokenResponse.expires_in, 10) : serverTokenResponse.expires_in) || 0;
            var extExpiresIn = (typeof serverTokenResponse.ext_expires_in === "string" ? parseInt(serverTokenResponse.ext_expires_in, 10) : serverTokenResponse.ext_expires_in) || 0;
            var refreshIn = (typeof serverTokenResponse.refresh_in === "string" ? parseInt(serverTokenResponse.refresh_in, 10) : serverTokenResponse.refresh_in) || undefined;
            var tokenExpirationSeconds = reqTimestamp + expiresIn;
            var extendedTokenExpirationSeconds = tokenExpirationSeconds + extExpiresIn;
            var refreshOnSeconds = refreshIn && refreshIn > 0 ? reqTimestamp + refreshIn : undefined;
            // non AAD scenarios can have empty realm
            cachedAccessToken = AccessTokenEntity.createAccessTokenEntity(this.homeAccountIdentifier, env, serverTokenResponse.access_token || Constants.EMPTY_STRING, this.clientId, idTokenObj ? idTokenObj.claims.tid || Constants.EMPTY_STRING : authority.tenant, responseScopes.printScopes(), tokenExpirationSeconds, extendedTokenExpirationSeconds, this.cryptoObj, refreshOnSeconds, serverTokenResponse.token_type, oboAssertion);
        }
        // refreshToken
        var cachedRefreshToken = null;
        if (!StringUtils.isEmpty(serverTokenResponse.refresh_token)) {
            cachedRefreshToken = RefreshTokenEntity.createRefreshTokenEntity(this.homeAccountIdentifier, env, serverTokenResponse.refresh_token || Constants.EMPTY_STRING, this.clientId, serverTokenResponse.foci, oboAssertion);
        }
        // appMetadata
        var cachedAppMetadata = null;
        if (!StringUtils.isEmpty(serverTokenResponse.foci)) {
            cachedAppMetadata = AppMetadataEntity.createAppMetadataEntity(this.clientId, env, serverTokenResponse.foci);
        }
        return new CacheRecord(cachedAccount, cachedIdToken, cachedAccessToken, cachedRefreshToken, cachedAppMetadata);
    };
    /**
     * Generate Account
     * @param serverTokenResponse
     * @param idToken
     * @param authority
     */
    ResponseHandler.prototype.generateAccountEntity = function (serverTokenResponse, idToken, authority, oboAssertion, authCodePayload) {
        var authorityType = authority.authorityType;
        var cloudGraphHostName = authCodePayload ? authCodePayload.cloud_graph_host_name : "";
        var msGraphhost = authCodePayload ? authCodePayload.msgraph_host : "";
        // ADFS does not require client_info in the response
        if (authorityType === AuthorityType.Adfs) {
            this.logger.verbose("Authority type is ADFS, creating ADFS account");
            return AccountEntity.createGenericAccount(authority, this.homeAccountIdentifier, idToken, oboAssertion, cloudGraphHostName, msGraphhost);
        }
        // This fallback applies to B2C as well as they fall under an AAD account type.
        if (StringUtils.isEmpty(serverTokenResponse.client_info) && authority.protocolMode === "AAD") {
            throw ClientAuthError.createClientInfoEmptyError();
        }
        return serverTokenResponse.client_info ?
            AccountEntity.createAccount(serverTokenResponse.client_info, this.homeAccountIdentifier, authority, idToken, oboAssertion, cloudGraphHostName, msGraphhost) :
            AccountEntity.createGenericAccount(authority, this.homeAccountIdentifier, idToken, oboAssertion, cloudGraphHostName, msGraphhost);
    };
    /**
     * Creates an @AuthenticationResult from @CacheRecord , @IdToken , and a boolean that states whether or not the result is from cache.
     *
     * Optionally takes a state string that is set as-is in the response.
     *
     * @param cacheRecord
     * @param idTokenObj
     * @param fromTokenCache
     * @param stateString
     */
    ResponseHandler.generateAuthenticationResult = function (cryptoObj, authority, cacheRecord, fromTokenCache, request, idTokenObj, requestState) {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function () {
            var accessToken, responseScopes, expiresOn, extExpiresOn, familyId, popTokenGenerator, uid, tid;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        accessToken = "";
                        responseScopes = [];
                        expiresOn = null;
                        familyId = Constants.EMPTY_STRING;
                        if (!cacheRecord.accessToken) return [3 /*break*/, 4];
                        if (!(cacheRecord.accessToken.tokenType === AuthenticationScheme.POP)) return [3 /*break*/, 2];
                        popTokenGenerator = new PopTokenGenerator(cryptoObj);
                        return [4 /*yield*/, popTokenGenerator.signPopToken(cacheRecord.accessToken.secret, request)];
                    case 1:
                        accessToken = _d.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        accessToken = cacheRecord.accessToken.secret;
                        _d.label = 3;
                    case 3:
                        responseScopes = ScopeSet.fromString(cacheRecord.accessToken.target).asArray();
                        expiresOn = new Date(Number(cacheRecord.accessToken.expiresOn) * 1000);
                        extExpiresOn = new Date(Number(cacheRecord.accessToken.extendedExpiresOn) * 1000);
                        _d.label = 4;
                    case 4:
                        if (cacheRecord.appMetadata) {
                            familyId = cacheRecord.appMetadata.familyId === THE_FAMILY_ID ? THE_FAMILY_ID : Constants.EMPTY_STRING;
                        }
                        uid = (idTokenObj === null || idTokenObj === void 0 ? void 0 : idTokenObj.claims.oid) || (idTokenObj === null || idTokenObj === void 0 ? void 0 : idTokenObj.claims.sub) || Constants.EMPTY_STRING;
                        tid = (idTokenObj === null || idTokenObj === void 0 ? void 0 : idTokenObj.claims.tid) || Constants.EMPTY_STRING;
                        return [2 /*return*/, {
                                authority: authority.canonicalAuthority,
                                uniqueId: uid,
                                tenantId: tid,
                                scopes: responseScopes,
                                account: cacheRecord.account ? cacheRecord.account.getAccountInfo() : null,
                                idToken: idTokenObj ? idTokenObj.rawToken : Constants.EMPTY_STRING,
                                idTokenClaims: idTokenObj ? idTokenObj.claims : {},
                                accessToken: accessToken,
                                fromCache: fromTokenCache,
                                expiresOn: expiresOn,
                                extExpiresOn: extExpiresOn,
                                familyId: familyId,
                                tokenType: ((_a = cacheRecord.accessToken) === null || _a === void 0 ? void 0 : _a.tokenType) || Constants.EMPTY_STRING,
                                state: requestState ? requestState.userRequestState : Constants.EMPTY_STRING,
                                cloudGraphHostName: ((_b = cacheRecord.account) === null || _b === void 0 ? void 0 : _b.cloudGraphHostName) || Constants.EMPTY_STRING,
                                msGraphHost: ((_c = cacheRecord.account) === null || _c === void 0 ? void 0 : _c.msGraphHost) || Constants.EMPTY_STRING
                            }];
                }
            });
        });
    };
    return ResponseHandler;
}());

/*! @azure/msal-common v4.4.0 2021-06-29 */

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * Oauth2.0 Authorization Code client
 */
var AuthorizationCodeClient = /** @class */ (function (_super) {
    __extends(AuthorizationCodeClient, _super);
    function AuthorizationCodeClient(configuration) {
        return _super.call(this, configuration) || this;
    }
    /**
     * Creates the URL of the authorization request letting the user input credentials and consent to the
     * application. The URL target the /authorize endpoint of the authority configured in the
     * application object.
     *
     * Once the user inputs their credentials and consents, the authority will send a response to the redirect URI
     * sent in the request and should contain an authorization code, which can then be used to acquire tokens via
     * acquireToken(AuthorizationCodeRequest)
     * @param request
     */
    AuthorizationCodeClient.prototype.getAuthCodeUrl = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            var queryString;
            return __generator(this, function (_a) {
                queryString = this.createAuthCodeUrlQueryString(request);
                return [2 /*return*/, UrlString.appendQueryString(this.authority.authorizationEndpoint, queryString)];
            });
        });
    };
    /**
     * API to acquire a token in exchange of 'authorization_code` acquired by the user in the first leg of the
     * authorization_code_grant
     * @param request
     */
    AuthorizationCodeClient.prototype.acquireToken = function (request, authCodePayload) {
        return __awaiter(this, void 0, void 0, function () {
            var reqTimestamp, response, responseHandler;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.logger.info("in acquireToken call");
                        if (!request || StringUtils.isEmpty(request.code)) {
                            throw ClientAuthError.createTokenRequestCannotBeMadeError();
                        }
                        reqTimestamp = TimeUtils.nowSeconds();
                        return [4 /*yield*/, this.executeTokenRequest(this.authority, request)];
                    case 1:
                        response = _a.sent();
                        responseHandler = new ResponseHandler(this.config.authOptions.clientId, this.cacheManager, this.cryptoUtils, this.logger, this.config.serializableCache, this.config.persistencePlugin);
                        // Validate response. This function throws a server error if an error is returned by the server.
                        responseHandler.validateTokenResponse(response.body);
                        return [4 /*yield*/, responseHandler.handleServerTokenResponse(response.body, this.authority, reqTimestamp, request, authCodePayload)];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Handles the hash fragment response from public client code request. Returns a code response used by
     * the client to exchange for a token in acquireToken.
     * @param hashFragment
     */
    AuthorizationCodeClient.prototype.handleFragmentResponse = function (hashFragment, cachedState) {
        // Handle responses.
        var responseHandler = new ResponseHandler(this.config.authOptions.clientId, this.cacheManager, this.cryptoUtils, this.logger, null, null);
        // Deserialize hash fragment response parameters.
        var hashUrlString = new UrlString(hashFragment);
        // Deserialize hash fragment response parameters.
        var serverParams = UrlString.getDeserializedHash(hashUrlString.getHash());
        // Get code response
        responseHandler.validateServerAuthorizationCodeResponse(serverParams, cachedState, this.cryptoUtils);
        // throw when there is no auth code in the response
        if (!serverParams.code) {
            throw ClientAuthError.createNoAuthCodeInServerResponseError();
        }
        return __assign(__assign({}, serverParams), { 
            // Code param is optional in ServerAuthorizationCodeResponse but required in AuthorizationCodePaylod
            code: serverParams.code });
    };
    /**
     * Use to log out the current user, and redirect the user to the postLogoutRedirectUri.
     * Default behaviour is to redirect the user to `window.location.href`.
     * @param authorityUri
     */
    AuthorizationCodeClient.prototype.getLogoutUri = function (logoutRequest) {
        // Throw error if logoutRequest is null/undefined
        if (!logoutRequest) {
            throw ClientConfigurationError.createEmptyLogoutRequestError();
        }
        if (logoutRequest.account) {
            // Clear given account.
            this.cacheManager.removeAccount(AccountEntity.generateAccountCacheKey(logoutRequest.account));
        }
        else {
            // Clear all accounts and tokens
            this.cacheManager.clear();
        }
        var queryString = this.createLogoutUrlQueryString(logoutRequest);
        // Construct logout URI.
        return StringUtils.isEmpty(queryString) ? this.authority.endSessionEndpoint : this.authority.endSessionEndpoint + "?" + queryString;
    };
    /**
     * Executes POST request to token endpoint
     * @param authority
     * @param request
     */
    AuthorizationCodeClient.prototype.executeTokenRequest = function (authority, request) {
        return __awaiter(this, void 0, void 0, function () {
            var thumbprint, requestBody, queryParameters, ccsCredential, clientInfo, headers, endpoint;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        thumbprint = {
                            clientId: this.config.authOptions.clientId,
                            authority: authority.canonicalAuthority,
                            scopes: request.scopes
                        };
                        return [4 /*yield*/, this.createTokenRequestBody(request)];
                    case 1:
                        requestBody = _a.sent();
                        queryParameters = this.createTokenQueryParameters(request);
                        ccsCredential = undefined;
                        if (request.clientInfo) {
                            try {
                                clientInfo = buildClientInfo(request.clientInfo, this.cryptoUtils);
                                ccsCredential = {
                                    credential: "" + clientInfo.uid + Separators.CLIENT_INFO_SEPARATOR + clientInfo.utid,
                                    type: CcsCredentialType.HOME_ACCOUNT_ID
                                };
                            }
                            catch (e) {
                                this.logger.verbose("Could not parse client info for CCS Header: " + e);
                            }
                        }
                        headers = this.createTokenRequestHeaders(ccsCredential || request.ccsCredential);
                        endpoint = StringUtils.isEmpty(queryParameters) ? authority.tokenEndpoint : authority.tokenEndpoint + "?" + queryParameters;
                        return [2 /*return*/, this.executePostToTokenEndpoint(endpoint, requestBody, headers, thumbprint)];
                }
            });
        });
    };
    /**
     * Creates query string for the /token request
     * @param request
     */
    AuthorizationCodeClient.prototype.createTokenQueryParameters = function (request) {
        var parameterBuilder = new RequestParameterBuilder();
        if (request.tokenQueryParameters) {
            parameterBuilder.addExtraQueryParameters(request.tokenQueryParameters);
        }
        return parameterBuilder.createQueryString();
    };
    /**
     * Generates a map for all the params to be sent to the service
     * @param request
     */
    AuthorizationCodeClient.prototype.createTokenRequestBody = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            var parameterBuilder, clientAssertion, popTokenGenerator, cnfString, correlationId, ccsCred, clientInfo, clientInfo;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        parameterBuilder = new RequestParameterBuilder();
                        parameterBuilder.addClientId(this.config.authOptions.clientId);
                        // validate the redirectUri (to be a non null value)
                        parameterBuilder.addRedirectUri(request.redirectUri);
                        // Add scope array, parameter builder will add default scopes and dedupe
                        parameterBuilder.addScopes(request.scopes);
                        // add code: user set, not validated
                        parameterBuilder.addAuthorizationCode(request.code);
                        // Add library metadata
                        parameterBuilder.addLibraryInfo(this.config.libraryInfo);
                        parameterBuilder.addThrottling();
                        if (this.serverTelemetryManager) {
                            parameterBuilder.addServerTelemetry(this.serverTelemetryManager);
                        }
                        // add code_verifier if passed
                        if (request.codeVerifier) {
                            parameterBuilder.addCodeVerifier(request.codeVerifier);
                        }
                        if (this.config.clientCredentials.clientSecret) {
                            parameterBuilder.addClientSecret(this.config.clientCredentials.clientSecret);
                        }
                        if (this.config.clientCredentials.clientAssertion) {
                            clientAssertion = this.config.clientCredentials.clientAssertion;
                            parameterBuilder.addClientAssertion(clientAssertion.assertion);
                            parameterBuilder.addClientAssertionType(clientAssertion.assertionType);
                        }
                        parameterBuilder.addGrantType(GrantType.AUTHORIZATION_CODE_GRANT);
                        parameterBuilder.addClientInfo();
                        if (!(request.authenticationScheme === AuthenticationScheme.POP)) return [3 /*break*/, 2];
                        popTokenGenerator = new PopTokenGenerator(this.cryptoUtils);
                        return [4 /*yield*/, popTokenGenerator.generateCnf(request)];
                    case 1:
                        cnfString = _a.sent();
                        parameterBuilder.addPopToken(cnfString);
                        _a.label = 2;
                    case 2:
                        correlationId = request.correlationId || this.config.cryptoInterface.createNewGuid();
                        parameterBuilder.addCorrelationId(correlationId);
                        if (!StringUtils.isEmptyObj(request.claims) || this.config.authOptions.clientCapabilities && this.config.authOptions.clientCapabilities.length > 0) {
                            parameterBuilder.addClaims(request.claims, this.config.authOptions.clientCapabilities);
                        }
                        ccsCred = undefined;
                        if (request.clientInfo) {
                            try {
                                clientInfo = buildClientInfo(request.clientInfo, this.cryptoUtils);
                                ccsCred = {
                                    credential: "" + clientInfo.uid + Separators.CLIENT_INFO_SEPARATOR + clientInfo.utid,
                                    type: CcsCredentialType.HOME_ACCOUNT_ID
                                };
                            }
                            catch (e) {
                                this.logger.verbose("Could not parse client info for CCS Header: " + e);
                            }
                        }
                        else {
                            ccsCred = request.ccsCredential;
                        }
                        // Adds these as parameters in the request instead of headers to prevent CORS preflight request
                        if (this.config.systemOptions.preventCorsPreflight && ccsCred) {
                            switch (ccsCred.type) {
                                case CcsCredentialType.HOME_ACCOUNT_ID:
                                    try {
                                        clientInfo = buildClientInfoFromHomeAccountId(ccsCred.credential);
                                        parameterBuilder.addCcsOid(clientInfo);
                                    }
                                    catch (e) {
                                        this.logger.verbose("Could not parse home account ID for CCS Header: " + e);
                                    }
                                    break;
                                case CcsCredentialType.UPN:
                                    parameterBuilder.addCcsUpn(ccsCred.credential);
                                    break;
                            }
                        }
                        return [2 /*return*/, parameterBuilder.createQueryString()];
                }
            });
        });
    };
    /**
     * This API validates the `AuthorizationCodeUrlRequest` and creates a URL
     * @param request
     */
    AuthorizationCodeClient.prototype.createAuthCodeUrlQueryString = function (request) {
        var parameterBuilder = new RequestParameterBuilder();
        parameterBuilder.addClientId(this.config.authOptions.clientId);
        var requestScopes = __spreadArrays(request.scopes || [], request.extraScopesToConsent || []);
        parameterBuilder.addScopes(requestScopes);
        // validate the redirectUri (to be a non null value)
        parameterBuilder.addRedirectUri(request.redirectUri);
        // generate the correlationId if not set by the user and add
        var correlationId = request.correlationId || this.config.cryptoInterface.createNewGuid();
        parameterBuilder.addCorrelationId(correlationId);
        // add response_mode. If not passed in it defaults to query.
        parameterBuilder.addResponseMode(request.responseMode);
        // add response_type = code
        parameterBuilder.addResponseTypeCode();
        // add library info parameters
        parameterBuilder.addLibraryInfo(this.config.libraryInfo);
        // add client_info=1
        parameterBuilder.addClientInfo();
        if (request.codeChallenge && request.codeChallengeMethod) {
            parameterBuilder.addCodeChallengeParams(request.codeChallenge, request.codeChallengeMethod);
        }
        if (request.prompt) {
            parameterBuilder.addPrompt(request.prompt);
        }
        if (request.domainHint) {
            parameterBuilder.addDomainHint(request.domainHint);
        }
        // Add sid or loginHint with preference for sid -> loginHint -> username of AccountInfo object
        if (request.prompt !== PromptValue.SELECT_ACCOUNT) {
            // AAD will throw if prompt=select_account is passed with an account hint
            if (request.sid && request.prompt === PromptValue.NONE) {
                // SessionID is only used in silent calls
                this.logger.verbose("createAuthCodeUrlQueryString: Prompt is none, adding sid from request");
                parameterBuilder.addSid(request.sid);
            }
            else if (request.account) {
                var accountSid = this.extractAccountSid(request.account);
                // If account and loginHint are provided, we will check account first for sid before adding loginHint
                if (accountSid && request.prompt === PromptValue.NONE) {
                    // SessionId is only used in silent calls
                    this.logger.verbose("createAuthCodeUrlQueryString: Prompt is none, adding sid from account");
                    parameterBuilder.addSid(accountSid);
                    try {
                        var clientInfo = buildClientInfoFromHomeAccountId(request.account.homeAccountId);
                        parameterBuilder.addCcsOid(clientInfo);
                    }
                    catch (e) {
                        this.logger.verbose("Could not parse home account ID for CCS Header: " + e);
                    }
                }
                else if (request.loginHint) {
                    this.logger.verbose("createAuthCodeUrlQueryString: Adding login_hint from request");
                    parameterBuilder.addLoginHint(request.loginHint);
                    parameterBuilder.addCcsUpn(request.loginHint);
                }
                else if (request.account.username) {
                    // Fallback to account username if provided
                    this.logger.verbose("createAuthCodeUrlQueryString: Adding login_hint from account");
                    parameterBuilder.addLoginHint(request.account.username);
                    try {
                        var clientInfo = buildClientInfoFromHomeAccountId(request.account.homeAccountId);
                        parameterBuilder.addCcsOid(clientInfo);
                    }
                    catch (e) {
                        this.logger.verbose("Could not parse home account ID for CCS Header: " + e);
                    }
                }
            }
            else if (request.loginHint) {
                this.logger.verbose("createAuthCodeUrlQueryString: No account, adding login_hint from request");
                parameterBuilder.addLoginHint(request.loginHint);
                parameterBuilder.addCcsUpn(request.loginHint);
            }
        }
        else {
            this.logger.verbose("createAuthCodeUrlQueryString: Prompt is select_account, ignoring account hints");
        }
        if (request.nonce) {
            parameterBuilder.addNonce(request.nonce);
        }
        if (request.state) {
            parameterBuilder.addState(request.state);
        }
        if (!StringUtils.isEmpty(request.claims) || this.config.authOptions.clientCapabilities && this.config.authOptions.clientCapabilities.length > 0) {
            parameterBuilder.addClaims(request.claims, this.config.authOptions.clientCapabilities);
        }
        if (request.extraQueryParameters) {
            parameterBuilder.addExtraQueryParameters(request.extraQueryParameters);
        }
        return parameterBuilder.createQueryString();
    };
    /**
     * This API validates the `EndSessionRequest` and creates a URL
     * @param request
     */
    AuthorizationCodeClient.prototype.createLogoutUrlQueryString = function (request) {
        var parameterBuilder = new RequestParameterBuilder();
        if (request.postLogoutRedirectUri) {
            parameterBuilder.addPostLogoutRedirectUri(request.postLogoutRedirectUri);
        }
        if (request.correlationId) {
            parameterBuilder.addCorrelationId(request.correlationId);
        }
        if (request.idTokenHint) {
            parameterBuilder.addIdTokenHint(request.idTokenHint);
        }
        return parameterBuilder.createQueryString();
    };
    /**
     * Helper to get sid from account. Returns null if idTokenClaims are not present or sid is not present.
     * @param account
     */
    AuthorizationCodeClient.prototype.extractAccountSid = function (account) {
        if (account.idTokenClaims) {
            var tokenClaims = account.idTokenClaims;
            return tokenClaims.sid || null;
        }
        return null;
    };
    return AuthorizationCodeClient;
}(BaseClient));

/*! @azure/msal-common v4.4.0 2021-06-29 */

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * OAuth2.0 refresh token client
 */
var RefreshTokenClient = /** @class */ (function (_super) {
    __extends(RefreshTokenClient, _super);
    function RefreshTokenClient(configuration) {
        return _super.call(this, configuration) || this;
    }
    RefreshTokenClient.prototype.acquireToken = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            var reqTimestamp, response, responseHandler;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        reqTimestamp = TimeUtils.nowSeconds();
                        return [4 /*yield*/, this.executeTokenRequest(request, this.authority)];
                    case 1:
                        response = _a.sent();
                        responseHandler = new ResponseHandler(this.config.authOptions.clientId, this.cacheManager, this.cryptoUtils, this.logger, this.config.serializableCache, this.config.persistencePlugin);
                        responseHandler.validateTokenResponse(response.body);
                        return [2 /*return*/, responseHandler.handleServerTokenResponse(response.body, this.authority, reqTimestamp, request, undefined, undefined, true)];
                }
            });
        });
    };
    /**
     * Gets cached refresh token and attaches to request, then calls acquireToken API
     * @param request
     */
    RefreshTokenClient.prototype.acquireTokenByRefreshToken = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            var isFOCI, noFamilyRTInCache, clientMismatchErrorWithFamilyRT;
            return __generator(this, function (_a) {
                // Cannot renew token if no request object is given.
                if (!request) {
                    throw ClientConfigurationError.createEmptyTokenRequestError();
                }
                // We currently do not support silent flow for account === null use cases; This will be revisited for confidential flow usecases
                if (!request.account) {
                    throw ClientAuthError.createNoAccountInSilentRequestError();
                }
                isFOCI = this.cacheManager.isAppMetadataFOCI(request.account.environment, this.config.authOptions.clientId);
                // if the app is part of the family, retrive a Family refresh token if present and make a refreshTokenRequest
                if (isFOCI) {
                    try {
                        return [2 /*return*/, this.acquireTokenWithCachedRefreshToken(request, true)];
                    }
                    catch (e) {
                        noFamilyRTInCache = e instanceof ClientAuthError && e.errorCode === ClientAuthErrorMessage.noTokensFoundError.code;
                        clientMismatchErrorWithFamilyRT = e instanceof ServerError && e.errorCode === Errors.INVALID_GRANT_ERROR && e.subError === Errors.CLIENT_MISMATCH_ERROR;
                        // if family Refresh Token (FRT) cache acquisition fails or if client_mismatch error is seen with FRT, reattempt with application Refresh Token (ART)
                        if (noFamilyRTInCache || clientMismatchErrorWithFamilyRT) {
                            return [2 /*return*/, this.acquireTokenWithCachedRefreshToken(request, false)];
                            // throw in all other cases
                        }
                        else {
                            throw e;
                        }
                    }
                }
                // fall back to application refresh token acquisition
                return [2 /*return*/, this.acquireTokenWithCachedRefreshToken(request, false)];
            });
        });
    };
    /**
     * makes a network call to acquire tokens by exchanging RefreshToken available in userCache; throws if refresh token is not cached
     * @param request
     */
    RefreshTokenClient.prototype.acquireTokenWithCachedRefreshToken = function (request, foci) {
        return __awaiter(this, void 0, void 0, function () {
            var refreshToken, refreshTokenRequest;
            return __generator(this, function (_a) {
                refreshToken = this.cacheManager.readRefreshTokenFromCache(this.config.authOptions.clientId, request.account, foci);
                // no refresh Token
                if (!refreshToken) {
                    throw ClientAuthError.createNoTokensFoundError();
                }
                refreshTokenRequest = __assign(__assign({}, request), { refreshToken: refreshToken.secret, authenticationScheme: request.authenticationScheme || AuthenticationScheme.BEARER, ccsCredential: {
                        credential: request.account.homeAccountId,
                        type: CcsCredentialType.HOME_ACCOUNT_ID
                    } });
                return [2 /*return*/, this.acquireToken(refreshTokenRequest)];
            });
        });
    };
    /**
     * Constructs the network message and makes a NW call to the underlying secure token service
     * @param request
     * @param authority
     */
    RefreshTokenClient.prototype.executeTokenRequest = function (request, authority) {
        return __awaiter(this, void 0, void 0, function () {
            var requestBody, queryParameters, headers, thumbprint, endpoint;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createTokenRequestBody(request)];
                    case 1:
                        requestBody = _a.sent();
                        queryParameters = this.createTokenQueryParameters(request);
                        headers = this.createTokenRequestHeaders(request.ccsCredential);
                        thumbprint = {
                            clientId: this.config.authOptions.clientId,
                            authority: authority.canonicalAuthority,
                            scopes: request.scopes
                        };
                        endpoint = UrlString.appendQueryString(authority.tokenEndpoint, queryParameters);
                        return [2 /*return*/, this.executePostToTokenEndpoint(endpoint, requestBody, headers, thumbprint)];
                }
            });
        });
    };
    /**
     * Creates query string for the /token request
     * @param request
     */
    RefreshTokenClient.prototype.createTokenQueryParameters = function (request) {
        var parameterBuilder = new RequestParameterBuilder();
        if (request.tokenQueryParameters) {
            parameterBuilder.addExtraQueryParameters(request.tokenQueryParameters);
        }
        return parameterBuilder.createQueryString();
    };
    /**
     * Helper function to create the token request body
     * @param request
     */
    RefreshTokenClient.prototype.createTokenRequestBody = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            var parameterBuilder, correlationId, clientAssertion, popTokenGenerator, _a, _b, clientInfo;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        parameterBuilder = new RequestParameterBuilder();
                        parameterBuilder.addClientId(this.config.authOptions.clientId);
                        parameterBuilder.addScopes(request.scopes);
                        parameterBuilder.addGrantType(GrantType.REFRESH_TOKEN_GRANT);
                        parameterBuilder.addClientInfo();
                        parameterBuilder.addLibraryInfo(this.config.libraryInfo);
                        parameterBuilder.addThrottling();
                        if (this.serverTelemetryManager) {
                            parameterBuilder.addServerTelemetry(this.serverTelemetryManager);
                        }
                        correlationId = request.correlationId || this.config.cryptoInterface.createNewGuid();
                        parameterBuilder.addCorrelationId(correlationId);
                        parameterBuilder.addRefreshToken(request.refreshToken);
                        if (this.config.clientCredentials.clientSecret) {
                            parameterBuilder.addClientSecret(this.config.clientCredentials.clientSecret);
                        }
                        if (this.config.clientCredentials.clientAssertion) {
                            clientAssertion = this.config.clientCredentials.clientAssertion;
                            parameterBuilder.addClientAssertion(clientAssertion.assertion);
                            parameterBuilder.addClientAssertionType(clientAssertion.assertionType);
                        }
                        if (!(request.authenticationScheme === AuthenticationScheme.POP)) return [3 /*break*/, 2];
                        popTokenGenerator = new PopTokenGenerator(this.cryptoUtils);
                        _b = (_a = parameterBuilder).addPopToken;
                        return [4 /*yield*/, popTokenGenerator.generateCnf(request)];
                    case 1:
                        _b.apply(_a, [_c.sent()]);
                        _c.label = 2;
                    case 2:
                        if (!StringUtils.isEmptyObj(request.claims) || this.config.authOptions.clientCapabilities && this.config.authOptions.clientCapabilities.length > 0) {
                            parameterBuilder.addClaims(request.claims, this.config.authOptions.clientCapabilities);
                        }
                        if (this.config.systemOptions.preventCorsPreflight && request.ccsCredential) {
                            switch (request.ccsCredential.type) {
                                case CcsCredentialType.HOME_ACCOUNT_ID:
                                    try {
                                        clientInfo = buildClientInfoFromHomeAccountId(request.ccsCredential.credential);
                                        parameterBuilder.addCcsOid(clientInfo);
                                    }
                                    catch (e) {
                                        this.logger.verbose("Could not parse home account ID for CCS Header: " + e);
                                    }
                                    break;
                                case CcsCredentialType.UPN:
                                    parameterBuilder.addCcsUpn(request.ccsCredential.credential);
                                    break;
                            }
                        }
                        return [2 /*return*/, parameterBuilder.createQueryString()];
                }
            });
        });
    };
    return RefreshTokenClient;
}(BaseClient));

/*! @azure/msal-common v4.4.0 2021-06-29 */

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
var SilentFlowClient = /** @class */ (function (_super) {
    __extends(SilentFlowClient, _super);
    function SilentFlowClient(configuration) {
        return _super.call(this, configuration) || this;
    }
    /**
     * Retrieves a token from cache if it is still valid, or uses the cached refresh token to renew
     * the given token and returns the renewed token
     * @param request
     */
    SilentFlowClient.prototype.acquireToken = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            var e_1, refreshTokenClient;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.acquireCachedToken(request)];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        e_1 = _a.sent();
                        if (e_1 instanceof ClientAuthError && e_1.errorCode === ClientAuthErrorMessage.tokenRefreshRequired.code) {
                            refreshTokenClient = new RefreshTokenClient(this.config);
                            return [2 /*return*/, refreshTokenClient.acquireTokenByRefreshToken(request)];
                        }
                        else {
                            throw e_1;
                        }
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Retrieves token from cache or throws an error if it must be refreshed.
     * @param request
     */
    SilentFlowClient.prototype.acquireCachedToken = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            var requestScopes, environment, authScheme, cacheRecord;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // Cannot renew token if no request object is given.
                        if (!request) {
                            throw ClientConfigurationError.createEmptyTokenRequestError();
                        }
                        // We currently do not support silent flow for account === null use cases; This will be revisited for confidential flow usecases
                        if (!request.account) {
                            throw ClientAuthError.createNoAccountInSilentRequestError();
                        }
                        requestScopes = new ScopeSet(request.scopes || []);
                        environment = request.authority || this.authority.getPreferredCache();
                        authScheme = request.authenticationScheme || AuthenticationScheme.BEARER;
                        cacheRecord = this.cacheManager.readCacheRecord(request.account, this.config.authOptions.clientId, requestScopes, environment, authScheme);
                        if (request.forceRefresh ||
                            !StringUtils.isEmptyObj(request.claims) ||
                            !cacheRecord.accessToken ||
                            TimeUtils.isTokenExpired(cacheRecord.accessToken.expiresOn, this.config.systemOptions.tokenRenewalOffsetSeconds) ||
                            TimeUtils.wasClockTurnedBack(cacheRecord.accessToken.cachedAt) ||
                            (cacheRecord.accessToken.refreshOn && TimeUtils.isTokenExpired(cacheRecord.accessToken.refreshOn, 0))) {
                            // Must refresh due to request parameters, or expired or non-existent access_token
                            throw ClientAuthError.createRefreshRequiredError();
                        }
                        if (this.config.serverTelemetryManager) {
                            this.config.serverTelemetryManager.incrementCacheHits();
                        }
                        return [4 /*yield*/, this.generateResultFromCacheRecord(cacheRecord, request)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Helper function to build response object from the CacheRecord
     * @param cacheRecord
     */
    SilentFlowClient.prototype.generateResultFromCacheRecord = function (cacheRecord, request) {
        return __awaiter(this, void 0, void 0, function () {
            var idTokenObj;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (cacheRecord.idToken) {
                            idTokenObj = new AuthToken(cacheRecord.idToken.secret, this.config.cryptoInterface);
                        }
                        return [4 /*yield*/, ResponseHandler.generateAuthenticationResult(this.cryptoUtils, this.authority, cacheRecord, true, request, idTokenObj)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return SilentFlowClient;
}(BaseClient));

/*! @azure/msal-common v4.4.0 2021-06-29 */
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
function isOpenIdConfigResponse(response) {
    return (response.hasOwnProperty("authorization_endpoint") &&
        response.hasOwnProperty("token_endpoint") &&
        response.hasOwnProperty("end_session_endpoint") &&
        response.hasOwnProperty("issuer"));
}

/*! @azure/msal-common v4.4.0 2021-06-29 */
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * Protocol modes supported by MSAL.
 */
var ProtocolMode;
(function (ProtocolMode) {
    ProtocolMode["AAD"] = "AAD";
    ProtocolMode["OIDC"] = "OIDC";
})(ProtocolMode || (ProtocolMode = {}));

/*! @azure/msal-common v4.4.0 2021-06-29 */

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
var AuthorityMetadataEntity = /** @class */ (function () {
    function AuthorityMetadataEntity() {
        this.expiresAt = TimeUtils.nowSeconds() + AUTHORITY_METADATA_CONSTANTS.REFRESH_TIME_SECONDS;
    }
    /**
     * Update the entity with new aliases, preferred_cache and preferred_network values
     * @param metadata
     * @param fromNetwork
     */
    AuthorityMetadataEntity.prototype.updateCloudDiscoveryMetadata = function (metadata, fromNetwork) {
        this.aliases = metadata.aliases;
        this.preferred_cache = metadata.preferred_cache;
        this.preferred_network = metadata.preferred_network;
        this.aliasesFromNetwork = fromNetwork;
    };
    /**
     * Update the entity with new endpoints
     * @param metadata
     * @param fromNetwork
     */
    AuthorityMetadataEntity.prototype.updateEndpointMetadata = function (metadata, fromNetwork) {
        this.authorization_endpoint = metadata.authorization_endpoint;
        this.token_endpoint = metadata.token_endpoint;
        this.end_session_endpoint = metadata.end_session_endpoint;
        this.issuer = metadata.issuer;
        this.endpointsFromNetwork = fromNetwork;
    };
    /**
     * Save the authority that was used to create this cache entry
     * @param authority
     */
    AuthorityMetadataEntity.prototype.updateCanonicalAuthority = function (authority) {
        this.canonical_authority = authority;
    };
    /**
     * Reset the exiresAt value
     */
    AuthorityMetadataEntity.prototype.resetExpiresAt = function () {
        this.expiresAt = TimeUtils.nowSeconds() + AUTHORITY_METADATA_CONSTANTS.REFRESH_TIME_SECONDS;
    };
    /**
     * Returns whether or not the data needs to be refreshed
     */
    AuthorityMetadataEntity.prototype.isExpired = function () {
        return this.expiresAt <= TimeUtils.nowSeconds();
    };
    /**
     * Validates an entity: checks for all expected params
     * @param entity
     */
    AuthorityMetadataEntity.isAuthorityMetadataEntity = function (key, entity) {
        if (!entity) {
            return false;
        }
        return (key.indexOf(AUTHORITY_METADATA_CONSTANTS.CACHE_KEY) === 0 &&
            entity.hasOwnProperty("aliases") &&
            entity.hasOwnProperty("preferred_cache") &&
            entity.hasOwnProperty("preferred_network") &&
            entity.hasOwnProperty("canonical_authority") &&
            entity.hasOwnProperty("authorization_endpoint") &&
            entity.hasOwnProperty("token_endpoint") &&
            entity.hasOwnProperty("end_session_endpoint") &&
            entity.hasOwnProperty("issuer") &&
            entity.hasOwnProperty("aliasesFromNetwork") &&
            entity.hasOwnProperty("endpointsFromNetwork") &&
            entity.hasOwnProperty("expiresAt"));
    };
    return AuthorityMetadataEntity;
}());

/*! @azure/msal-common v4.4.0 2021-06-29 */
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
function isCloudInstanceDiscoveryResponse(response) {
    return (response.hasOwnProperty("tenant_discovery_endpoint") &&
        response.hasOwnProperty("metadata"));
}

/*! @azure/msal-common v4.4.0 2021-06-29 */

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
var RegionDiscovery = /** @class */ (function () {
    function RegionDiscovery(networkInterface) {
        this.networkInterface = networkInterface;
    }
    /**
     * Detect the region from the application's environment.
     *
     * @returns Promise<string | null>
     */
    RegionDiscovery.prototype.detectRegion = function (environmentRegion) {
        return __awaiter(this, void 0, void 0, function () {
            var autodetectedRegionName, response, latestIMDSVersion, response_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        autodetectedRegionName = environmentRegion;
                        if (!!autodetectedRegionName) return [3 /*break*/, 7];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 6, , 7]);
                        return [4 /*yield*/, this.getRegionFromIMDS(Constants.IMDS_VERSION)];
                    case 2:
                        response = _a.sent();
                        if (response.status === ResponseCodes.httpSuccess) {
                            autodetectedRegionName = response.body;
                        }
                        if (!(response.status === ResponseCodes.httpBadRequest)) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.getCurrentVersion()];
                    case 3:
                        latestIMDSVersion = _a.sent();
                        if (!latestIMDSVersion) {
                            return [2 /*return*/, null];
                        }
                        return [4 /*yield*/, this.getRegionFromIMDS(latestIMDSVersion)];
                    case 4:
                        response_1 = _a.sent();
                        if (response_1.status === ResponseCodes.httpSuccess) {
                            autodetectedRegionName = response_1.body;
                        }
                        _a.label = 5;
                    case 5: return [3 /*break*/, 7];
                    case 6:
                        _a.sent();
                        return [2 /*return*/, null];
                    case 7: return [2 /*return*/, autodetectedRegionName || null];
                }
            });
        });
    };
    /**
     * Make the call to the IMDS endpoint
     *
     * @param imdsEndpointUrl
     * @returns Promise<NetworkResponse<string>>
     */
    RegionDiscovery.prototype.getRegionFromIMDS = function (version) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.networkInterface.sendGetRequestAsync(Constants.IMDS_ENDPOINT + "?api-version=" + version + "&format=text", RegionDiscovery.IMDS_OPTIONS, Constants.IMDS_TIMEOUT)];
            });
        });
    };
    /**
     * Get the most recent version of the IMDS endpoint available
     *
     * @returns Promise<string | null>
     */
    RegionDiscovery.prototype.getCurrentVersion = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.networkInterface.sendGetRequestAsync(Constants.IMDS_ENDPOINT + "?format=json", RegionDiscovery.IMDS_OPTIONS)];
                    case 1:
                        response = _a.sent();
                        // When IMDS endpoint is called without the api version query param, bad request response comes back with latest version.
                        if (response.status === ResponseCodes.httpBadRequest && response.body && response.body["newest-versions"] && response.body["newest-versions"].length > 0) {
                            return [2 /*return*/, response.body["newest-versions"][0]];
                        }
                        return [2 /*return*/, null];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, null];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    // Options for the IMDS endpoint request
    RegionDiscovery.IMDS_OPTIONS = { headers: { "Metadata": "true" } };
    return RegionDiscovery;
}());

/*! @azure/msal-common v4.4.0 2021-06-29 */

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * The authority class validates the authority URIs used by the user, and retrieves the OpenID Configuration Data from the
 * endpoint. It will store the pertinent config data in this object for use during token calls.
 */
var Authority = /** @class */ (function () {
    function Authority(authority, networkInterface, cacheManager, authorityOptions) {
        this.canonicalAuthority = authority;
        this._canonicalAuthority.validateAsUri();
        this.networkInterface = networkInterface;
        this.cacheManager = cacheManager;
        this.authorityOptions = authorityOptions;
        this.regionDiscovery = new RegionDiscovery(networkInterface);
    }
    Object.defineProperty(Authority.prototype, "authorityType", {
        // See above for AuthorityType
        get: function () {
            var pathSegments = this.canonicalAuthorityUrlComponents.PathSegments;
            if (pathSegments.length && pathSegments[0].toLowerCase() === Constants.ADFS) {
                return AuthorityType.Adfs;
            }
            return AuthorityType.Default;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Authority.prototype, "protocolMode", {
        /**
         * ProtocolMode enum representing the way endpoints are constructed.
         */
        get: function () {
            return this.authorityOptions.protocolMode;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Authority.prototype, "options", {
        /**
         * Returns authorityOptions which can be used to reinstantiate a new authority instance
         */
        get: function () {
            return this.authorityOptions;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Authority.prototype, "canonicalAuthority", {
        /**
         * A URL that is the authority set by the developer
         */
        get: function () {
            return this._canonicalAuthority.urlString;
        },
        /**
         * Sets canonical authority.
         */
        set: function (url) {
            this._canonicalAuthority = new UrlString(url);
            this._canonicalAuthority.validateAsUri();
            this._canonicalAuthorityUrlComponents = null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Authority.prototype, "canonicalAuthorityUrlComponents", {
        /**
         * Get authority components.
         */
        get: function () {
            if (!this._canonicalAuthorityUrlComponents) {
                this._canonicalAuthorityUrlComponents = this._canonicalAuthority.getUrlComponents();
            }
            return this._canonicalAuthorityUrlComponents;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Authority.prototype, "hostnameAndPort", {
        /**
         * Get hostname and port i.e. login.microsoftonline.com
         */
        get: function () {
            return this.canonicalAuthorityUrlComponents.HostNameAndPort.toLowerCase();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Authority.prototype, "tenant", {
        /**
         * Get tenant for authority.
         */
        get: function () {
            return this.canonicalAuthorityUrlComponents.PathSegments[0];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Authority.prototype, "authorizationEndpoint", {
        /**
         * OAuth /authorize endpoint for requests
         */
        get: function () {
            if (this.discoveryComplete()) {
                var endpoint = this.replacePath(this.metadata.authorization_endpoint);
                return this.replaceTenant(endpoint);
            }
            else {
                throw ClientAuthError.createEndpointDiscoveryIncompleteError("Discovery incomplete.");
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Authority.prototype, "tokenEndpoint", {
        /**
         * OAuth /token endpoint for requests
         */
        get: function () {
            if (this.discoveryComplete()) {
                var endpoint = this.replacePath(this.metadata.token_endpoint);
                return this.replaceTenant(endpoint);
            }
            else {
                throw ClientAuthError.createEndpointDiscoveryIncompleteError("Discovery incomplete.");
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Authority.prototype, "deviceCodeEndpoint", {
        get: function () {
            if (this.discoveryComplete()) {
                var endpoint = this.replacePath(this.metadata.token_endpoint.replace("/token", "/devicecode"));
                return this.replaceTenant(endpoint);
            }
            else {
                throw ClientAuthError.createEndpointDiscoveryIncompleteError("Discovery incomplete.");
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Authority.prototype, "endSessionEndpoint", {
        /**
         * OAuth logout endpoint for requests
         */
        get: function () {
            if (this.discoveryComplete()) {
                var endpoint = this.replacePath(this.metadata.end_session_endpoint);
                return this.replaceTenant(endpoint);
            }
            else {
                throw ClientAuthError.createEndpointDiscoveryIncompleteError("Discovery incomplete.");
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Authority.prototype, "selfSignedJwtAudience", {
        /**
         * OAuth issuer for requests
         */
        get: function () {
            if (this.discoveryComplete()) {
                var endpoint = this.replacePath(this.metadata.issuer);
                return this.replaceTenant(endpoint);
            }
            else {
                throw ClientAuthError.createEndpointDiscoveryIncompleteError("Discovery incomplete.");
            }
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Replaces tenant in url path with current tenant. Defaults to common.
     * @param urlString
     */
    Authority.prototype.replaceTenant = function (urlString) {
        return urlString.replace(/{tenant}|{tenantid}/g, this.tenant);
    };
    /**
     * Replaces path such as tenant or policy with the current tenant or policy.
     * @param urlString
     */
    Authority.prototype.replacePath = function (urlString) {
        var endpoint = urlString;
        var cachedAuthorityUrl = new UrlString(this.metadata.canonical_authority);
        var cachedAuthorityParts = cachedAuthorityUrl.getUrlComponents().PathSegments;
        var currentAuthorityParts = this.canonicalAuthorityUrlComponents.PathSegments;
        currentAuthorityParts.forEach(function (currentPart, index) {
            var cachedPart = cachedAuthorityParts[index];
            if (currentPart !== cachedPart) {
                endpoint = endpoint.replace("/" + cachedPart + "/", "/" + currentPart + "/");
            }
        });
        return endpoint;
    };
    Object.defineProperty(Authority.prototype, "defaultOpenIdConfigurationEndpoint", {
        /**
         * The default open id configuration endpoint for any canonical authority.
         */
        get: function () {
            if (this.authorityType === AuthorityType.Adfs || this.protocolMode === ProtocolMode.OIDC) {
                return this.canonicalAuthority + ".well-known/openid-configuration";
            }
            return this.canonicalAuthority + "v2.0/.well-known/openid-configuration";
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Boolean that returns whethr or not tenant discovery has been completed.
     */
    Authority.prototype.discoveryComplete = function () {
        return !!this.metadata;
    };
    /**
     * Perform endpoint discovery to discover aliases, preferred_cache, preferred_network
     * and the /authorize, /token and logout endpoints.
     */
    Authority.prototype.resolveEndpointsAsync = function () {
        return __awaiter(this, void 0, void 0, function () {
            var metadataEntity, cloudDiscoverySource, endpointSource, cacheKey;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        metadataEntity = this.cacheManager.getAuthorityMetadataByAlias(this.hostnameAndPort);
                        if (!metadataEntity) {
                            metadataEntity = new AuthorityMetadataEntity();
                            metadataEntity.updateCanonicalAuthority(this.canonicalAuthority);
                        }
                        return [4 /*yield*/, this.updateCloudDiscoveryMetadata(metadataEntity)];
                    case 1:
                        cloudDiscoverySource = _a.sent();
                        this.canonicalAuthority = this.canonicalAuthority.replace(this.hostnameAndPort, metadataEntity.preferred_network);
                        return [4 /*yield*/, this.updateEndpointMetadata(metadataEntity)];
                    case 2:
                        endpointSource = _a.sent();
                        if (cloudDiscoverySource !== AuthorityMetadataSource.CACHE && endpointSource !== AuthorityMetadataSource.CACHE) {
                            // Reset the expiration time unless both values came from a successful cache lookup
                            metadataEntity.resetExpiresAt();
                            metadataEntity.updateCanonicalAuthority(this.canonicalAuthority);
                        }
                        cacheKey = this.cacheManager.generateAuthorityMetadataCacheKey(metadataEntity.preferred_cache);
                        this.cacheManager.setAuthorityMetadata(cacheKey, metadataEntity);
                        this.metadata = metadataEntity;
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Update AuthorityMetadataEntity with new endpoints and return where the information came from
     * @param metadataEntity
     */
    Authority.prototype.updateEndpointMetadata = function (metadataEntity) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var metadata, autodetectedRegionName, azureRegion;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        metadata = this.getEndpointMetadataFromConfig();
                        if (metadata) {
                            metadataEntity.updateEndpointMetadata(metadata, false);
                            return [2 /*return*/, AuthorityMetadataSource.CONFIG];
                        }
                        if (this.isAuthoritySameType(metadataEntity) && metadataEntity.endpointsFromNetwork && !metadataEntity.isExpired()) {
                            // No need to update
                            return [2 /*return*/, AuthorityMetadataSource.CACHE];
                        }
                        return [4 /*yield*/, this.getEndpointMetadataFromNetwork()];
                    case 1:
                        metadata = _b.sent();
                        if (!metadata) return [3 /*break*/, 4];
                        if (!((_a = this.authorityOptions.azureRegionConfiguration) === null || _a === void 0 ? void 0 : _a.azureRegion)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.regionDiscovery.detectRegion(this.authorityOptions.azureRegionConfiguration.environmentRegion)];
                    case 2:
                        autodetectedRegionName = _b.sent();
                        azureRegion = this.authorityOptions.azureRegionConfiguration.azureRegion === Constants.AZURE_REGION_AUTO_DISCOVER_FLAG
                            ? autodetectedRegionName
                            : this.authorityOptions.azureRegionConfiguration.azureRegion;
                        if (azureRegion) {
                            metadata = Authority.replaceWithRegionalInformation(metadata, azureRegion);
                        }
                        _b.label = 3;
                    case 3:
                        metadataEntity.updateEndpointMetadata(metadata, true);
                        return [2 /*return*/, AuthorityMetadataSource.NETWORK];
                    case 4: throw ClientAuthError.createUnableToGetOpenidConfigError(this.defaultOpenIdConfigurationEndpoint);
                }
            });
        });
    };
    /**
     * Compares the number of url components after the domain to determine if the cached authority metadata can be used for the requested authority
     * Protects against same domain different authority such as login.microsoftonline.com/tenant and login.microsoftonline.com/tfp/tenant/policy
     * @param metadataEntity
     */
    Authority.prototype.isAuthoritySameType = function (metadataEntity) {
        var cachedAuthorityUrl = new UrlString(metadataEntity.canonical_authority);
        var cachedParts = cachedAuthorityUrl.getUrlComponents().PathSegments;
        return cachedParts.length === this.canonicalAuthorityUrlComponents.PathSegments.length;
    };
    /**
     * Parse authorityMetadata config option
     */
    Authority.prototype.getEndpointMetadataFromConfig = function () {
        if (this.authorityOptions.authorityMetadata) {
            try {
                return JSON.parse(this.authorityOptions.authorityMetadata);
            }
            catch (e) {
                throw ClientConfigurationError.createInvalidAuthorityMetadataError();
            }
        }
        return null;
    };
    /**
     * Gets OAuth endpoints from the given OpenID configuration endpoint.
     */
    Authority.prototype.getEndpointMetadataFromNetwork = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.networkInterface.sendGetRequestAsync(this.defaultOpenIdConfigurationEndpoint)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, isOpenIdConfigResponse(response.body) ? response.body : null];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, null];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Updates the AuthorityMetadataEntity with new aliases, preferred_network and preferred_cache and returns where the information was retrived from
     * @param cachedMetadata
     * @param newMetadata
     */
    Authority.prototype.updateCloudDiscoveryMetadata = function (metadataEntity) {
        return __awaiter(this, void 0, void 0, function () {
            var metadata;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        metadata = this.getCloudDiscoveryMetadataFromConfig();
                        if (metadata) {
                            metadataEntity.updateCloudDiscoveryMetadata(metadata, false);
                            return [2 /*return*/, AuthorityMetadataSource.CONFIG];
                        }
                        // If The cached metadata came from config but that config was not passed to this instance, we must go to the network
                        if (this.isAuthoritySameType(metadataEntity) && metadataEntity.aliasesFromNetwork && !metadataEntity.isExpired()) {
                            // No need to update
                            return [2 /*return*/, AuthorityMetadataSource.CACHE];
                        }
                        return [4 /*yield*/, this.getCloudDiscoveryMetadataFromNetwork()];
                    case 1:
                        metadata = _a.sent();
                        if (metadata) {
                            metadataEntity.updateCloudDiscoveryMetadata(metadata, true);
                            return [2 /*return*/, AuthorityMetadataSource.NETWORK];
                        }
                        else {
                            // Metadata could not be obtained from config, cache or network
                            throw ClientConfigurationError.createUntrustedAuthorityError();
                        }
                }
            });
        });
    };
    /**
     * Parse cloudDiscoveryMetadata config or check knownAuthorities
     */
    Authority.prototype.getCloudDiscoveryMetadataFromConfig = function () {
        // Check if network response was provided in config
        if (this.authorityOptions.cloudDiscoveryMetadata) {
            try {
                var parsedResponse = JSON.parse(this.authorityOptions.cloudDiscoveryMetadata);
                var metadata = Authority.getCloudDiscoveryMetadataFromNetworkResponse(parsedResponse.metadata, this.hostnameAndPort);
                if (metadata) {
                    return metadata;
                }
            }
            catch (e) {
                throw ClientConfigurationError.createInvalidCloudDiscoveryMetadataError();
            }
        }
        // If cloudDiscoveryMetadata is empty or does not contain the host, check knownAuthorities
        if (this.isInKnownAuthorities()) {
            return Authority.createCloudDiscoveryMetadataFromHost(this.hostnameAndPort);
        }
        return null;
    };
    /**
     * Called to get metadata from network if CloudDiscoveryMetadata was not populated by config
     * @param networkInterface
     */
    Authority.prototype.getCloudDiscoveryMetadataFromNetwork = function () {
        return __awaiter(this, void 0, void 0, function () {
            var instanceDiscoveryEndpoint, match, response, metadata;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        instanceDiscoveryEndpoint = "" + Constants.AAD_INSTANCE_DISCOVERY_ENDPT + this.canonicalAuthority + "oauth2/v2.0/authorize";
                        match = null;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.networkInterface.sendGetRequestAsync(instanceDiscoveryEndpoint)];
                    case 2:
                        response = _a.sent();
                        metadata = isCloudInstanceDiscoveryResponse(response.body) ? response.body.metadata : [];
                        if (metadata.length === 0) {
                            // If no metadata is returned, authority is untrusted
                            return [2 /*return*/, null];
                        }
                        match = Authority.getCloudDiscoveryMetadataFromNetworkResponse(metadata, this.hostnameAndPort);
                        return [3 /*break*/, 4];
                    case 3:
                        _a.sent();
                        return [2 /*return*/, null];
                    case 4:
                        if (!match) {
                            // Custom Domain scenario, host is trusted because Instance Discovery call succeeded 
                            match = Authority.createCloudDiscoveryMetadataFromHost(this.hostnameAndPort);
                        }
                        return [2 /*return*/, match];
                }
            });
        });
    };
    /**
     * Helper function to determine if this host is included in the knownAuthorities config option
     */
    Authority.prototype.isInKnownAuthorities = function () {
        var _this = this;
        var matches = this.authorityOptions.knownAuthorities.filter(function (authority) {
            return UrlString.getDomainFromUrl(authority).toLowerCase() === _this.hostnameAndPort;
        });
        return matches.length > 0;
    };
    /**
     * Creates cloud discovery metadata object from a given host
     * @param host
     */
    Authority.createCloudDiscoveryMetadataFromHost = function (host) {
        return {
            preferred_network: host,
            preferred_cache: host,
            aliases: [host]
        };
    };
    /**
     * Searches instance discovery network response for the entry that contains the host in the aliases list
     * @param response
     * @param authority
     */
    Authority.getCloudDiscoveryMetadataFromNetworkResponse = function (response, authority) {
        for (var i = 0; i < response.length; i++) {
            var metadata = response[i];
            if (metadata.aliases.indexOf(authority) > -1) {
                return metadata;
            }
        }
        return null;
    };
    /**
     * helper function to generate environment from authority object
     */
    Authority.prototype.getPreferredCache = function () {
        if (this.discoveryComplete()) {
            return this.metadata.preferred_cache;
        }
        else {
            throw ClientAuthError.createEndpointDiscoveryIncompleteError("Discovery incomplete.");
        }
    };
    /**
     * Returns whether or not the provided host is an alias of this authority instance
     * @param host
     */
    Authority.prototype.isAlias = function (host) {
        return this.metadata.aliases.indexOf(host) > -1;
    };
    /**
     * Checks whether the provided host is that of a public cloud authority
     *
     * @param authority string
     * @returns bool
     */
    Authority.isPublicCloudAuthority = function (host) {
        return Constants.KNOWN_PUBLIC_CLOUDS.indexOf(host) >= 0;
    };
    /**
     * Rebuild the authority string with the region
     *
     * @param host string
     * @param region string
     */
    Authority.buildRegionalAuthorityString = function (host, region, queryString) {
        // Create and validate a Url string object with the initial authority string
        var authorityUrlInstance = new UrlString(host);
        authorityUrlInstance.validateAsUri();
        var authorityUrlParts = authorityUrlInstance.getUrlComponents();
        var hostNameAndPort = region + "." + authorityUrlParts.HostNameAndPort;
        if (this.isPublicCloudAuthority(authorityUrlParts.HostNameAndPort)) {
            hostNameAndPort = region + "." + Constants.REGIONAL_AUTH_PUBLIC_CLOUD_SUFFIX;
        }
        // Include the query string portion of the url
        var url = UrlString.constructAuthorityUriFromObject(__assign(__assign({}, authorityUrlInstance.getUrlComponents()), { HostNameAndPort: hostNameAndPort })).urlString;
        // Add the query string if a query string was provided
        if (queryString)
            return url + "?" + queryString;
        return url;
    };
    /**
     * Replace the endpoints in the metadata object with their regional equivalents.
     *
     * @param metadata OpenIdConfigResponse
     * @param azureRegion string
     */
    Authority.replaceWithRegionalInformation = function (metadata, azureRegion) {
        metadata.authorization_endpoint = Authority.buildRegionalAuthorityString(metadata.authorization_endpoint, azureRegion);
        // TODO: Enquire on whether we should leave the query string or remove it before releasing the feature
        metadata.token_endpoint = Authority.buildRegionalAuthorityString(metadata.token_endpoint, azureRegion, "allowestsrnonmsi=true");
        metadata.end_session_endpoint = Authority.buildRegionalAuthorityString(metadata.end_session_endpoint, azureRegion);
        return metadata;
    };
    return Authority;
}());

/*! @azure/msal-common v4.4.0 2021-06-29 */

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
var AuthorityFactory = /** @class */ (function () {
    function AuthorityFactory() {
    }
    /**
     * Create an authority object of the correct type based on the url
     * Performs basic authority validation - checks to see if the authority is of a valid type (i.e. aad, b2c, adfs)
     *
     * Also performs endpoint discovery.
     *
     * @param authorityUri
     * @param networkClient
     * @param protocolMode
     */
    AuthorityFactory.createDiscoveredInstance = function (authorityUri, networkClient, cacheManager, authorityOptions) {
        return __awaiter(this, void 0, void 0, function () {
            var acquireTokenAuthority, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        acquireTokenAuthority = AuthorityFactory.createInstance(authorityUri, networkClient, cacheManager, authorityOptions);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, acquireTokenAuthority.resolveEndpointsAsync()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, acquireTokenAuthority];
                    case 3:
                        e_1 = _a.sent();
                        throw ClientAuthError.createEndpointDiscoveryIncompleteError(e_1);
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Create an authority object of the correct type based on the url
     * Performs basic authority validation - checks to see if the authority is of a valid type (i.e. aad, b2c, adfs)
     *
     * Does not perform endpoint discovery.
     *
     * @param authorityUrl
     * @param networkInterface
     * @param protocolMode
     */
    AuthorityFactory.createInstance = function (authorityUrl, networkInterface, cacheManager, authorityOptions) {
        // Throw error if authority url is empty
        if (StringUtils.isEmpty(authorityUrl)) {
            throw ClientConfigurationError.createUrlEmptyError();
        }
        return new Authority(authorityUrl, networkInterface, cacheManager, authorityOptions);
    };
    return AuthorityFactory;
}());

/*! @azure/msal-common v4.4.0 2021-06-29 */

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
var ServerTelemetryEntity = /** @class */ (function () {
    function ServerTelemetryEntity() {
        this.failedRequests = [];
        this.errors = [];
        this.cacheHits = 0;
    }
    /**
     * validates if a given cache entry is "Telemetry", parses <key,value>
     * @param key
     * @param entity
     */
    ServerTelemetryEntity.isServerTelemetryEntity = function (key, entity) {
        var validateKey = key.indexOf(SERVER_TELEM_CONSTANTS.CACHE_KEY) === 0;
        var validateEntity = true;
        if (entity) {
            validateEntity =
                entity.hasOwnProperty("failedRequests") &&
                    entity.hasOwnProperty("errors") &&
                    entity.hasOwnProperty("cacheHits");
        }
        return validateKey && validateEntity;
    };
    return ServerTelemetryEntity;
}());

/*! @azure/msal-common v4.4.0 2021-06-29 */

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
var ThrottlingEntity = /** @class */ (function () {
    function ThrottlingEntity() {
    }
    /**
     * validates if a given cache entry is "Throttling", parses <key,value>
     * @param key
     * @param entity
     */
    ThrottlingEntity.isThrottlingEntity = function (key, entity) {
        var validateKey = false;
        if (key) {
            validateKey = key.indexOf(ThrottlingConstants.THROTTLING_PREFIX) === 0;
        }
        var validateEntity = true;
        if (entity) {
            validateEntity = entity.hasOwnProperty("throttleTime");
        }
        return validateKey && validateEntity;
    };
    return ThrottlingEntity;
}());

/*! @azure/msal-common v4.4.0 2021-06-29 */

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
var StubbedNetworkModule = {
    sendGetRequestAsync: function () {
        var notImplErr = "Network interface - sendGetRequestAsync() has not been implemented for the Network interface.";
        return Promise.reject(AuthError.createUnexpectedError(notImplErr));
    },
    sendPostRequestAsync: function () {
        var notImplErr = "Network interface - sendPostRequestAsync() has not been implemented for the Network interface.";
        return Promise.reject(AuthError.createUnexpectedError(notImplErr));
    }
};

/*! @azure/msal-common v4.4.0 2021-06-29 */

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
var ServerTelemetryManager = /** @class */ (function () {
    function ServerTelemetryManager(telemetryRequest, cacheManager) {
        this.cacheManager = cacheManager;
        this.apiId = telemetryRequest.apiId;
        this.correlationId = telemetryRequest.correlationId;
        this.forceRefresh = telemetryRequest.forceRefresh || false;
        this.wrapperSKU = telemetryRequest.wrapperSKU || Constants.EMPTY_STRING;
        this.wrapperVer = telemetryRequest.wrapperVer || Constants.EMPTY_STRING;
        this.telemetryCacheKey = SERVER_TELEM_CONSTANTS.CACHE_KEY + Separators.CACHE_KEY_SEPARATOR + telemetryRequest.clientId;
    }
    /**
     * API to add MSER Telemetry to request
     */
    ServerTelemetryManager.prototype.generateCurrentRequestHeaderValue = function () {
        var forceRefreshInt = this.forceRefresh ? 1 : 0;
        var request = "" + this.apiId + SERVER_TELEM_CONSTANTS.VALUE_SEPARATOR + forceRefreshInt;
        var platformFields = [this.wrapperSKU, this.wrapperVer].join(SERVER_TELEM_CONSTANTS.VALUE_SEPARATOR);
        return [SERVER_TELEM_CONSTANTS.SCHEMA_VERSION, request, platformFields].join(SERVER_TELEM_CONSTANTS.CATEGORY_SEPARATOR);
    };
    /**
     * API to add MSER Telemetry for the last failed request
     */
    ServerTelemetryManager.prototype.generateLastRequestHeaderValue = function () {
        var lastRequests = this.getLastRequests();
        var maxErrors = ServerTelemetryManager.maxErrorsToSend(lastRequests);
        var failedRequests = lastRequests.failedRequests.slice(0, 2 * maxErrors).join(SERVER_TELEM_CONSTANTS.VALUE_SEPARATOR);
        var errors = lastRequests.errors.slice(0, maxErrors).join(SERVER_TELEM_CONSTANTS.VALUE_SEPARATOR);
        var errorCount = lastRequests.errors.length;
        // Indicate whether this header contains all data or partial data
        var overflow = maxErrors < errorCount ? SERVER_TELEM_CONSTANTS.OVERFLOW_TRUE : SERVER_TELEM_CONSTANTS.OVERFLOW_FALSE;
        var platformFields = [errorCount, overflow].join(SERVER_TELEM_CONSTANTS.VALUE_SEPARATOR);
        return [SERVER_TELEM_CONSTANTS.SCHEMA_VERSION, lastRequests.cacheHits, failedRequests, errors, platformFields].join(SERVER_TELEM_CONSTANTS.CATEGORY_SEPARATOR);
    };
    /**
     * API to cache token failures for MSER data capture
     * @param error
     */
    ServerTelemetryManager.prototype.cacheFailedRequest = function (error) {
        var lastRequests = this.getLastRequests();
        if (lastRequests.errors.length >= SERVER_TELEM_CONSTANTS.MAX_CACHED_ERRORS) {
            // Remove a cached error to make room, first in first out
            lastRequests.failedRequests.shift(); // apiId
            lastRequests.failedRequests.shift(); // correlationId
            lastRequests.errors.shift();
        }
        lastRequests.failedRequests.push(this.apiId, this.correlationId);
        if (!StringUtils.isEmpty(error.subError)) {
            lastRequests.errors.push(error.subError);
        }
        else if (!StringUtils.isEmpty(error.errorCode)) {
            lastRequests.errors.push(error.errorCode);
        }
        else if (!!error && error.toString()) {
            lastRequests.errors.push(error.toString());
        }
        else {
            lastRequests.errors.push(SERVER_TELEM_CONSTANTS.UNKNOWN_ERROR);
        }
        this.cacheManager.setServerTelemetry(this.telemetryCacheKey, lastRequests);
        return;
    };
    /**
     * Update server telemetry cache entry by incrementing cache hit counter
     */
    ServerTelemetryManager.prototype.incrementCacheHits = function () {
        var lastRequests = this.getLastRequests();
        lastRequests.cacheHits += 1;
        this.cacheManager.setServerTelemetry(this.telemetryCacheKey, lastRequests);
        return lastRequests.cacheHits;
    };
    /**
     * Get the server telemetry entity from cache or initialize a new one
     */
    ServerTelemetryManager.prototype.getLastRequests = function () {
        var initialValue = new ServerTelemetryEntity();
        var lastRequests = this.cacheManager.getServerTelemetry(this.telemetryCacheKey);
        return lastRequests || initialValue;
    };
    /**
     * Remove server telemetry cache entry
     */
    ServerTelemetryManager.prototype.clearTelemetryCache = function () {
        var lastRequests = this.getLastRequests();
        var numErrorsFlushed = ServerTelemetryManager.maxErrorsToSend(lastRequests);
        var errorCount = lastRequests.errors.length;
        if (numErrorsFlushed === errorCount) {
            // All errors were sent on last request, clear Telemetry cache
            this.cacheManager.removeItem(this.telemetryCacheKey);
        }
        else {
            // Partial data was flushed to server, construct a new telemetry cache item with errors that were not flushed
            var serverTelemEntity = new ServerTelemetryEntity();
            serverTelemEntity.failedRequests = lastRequests.failedRequests.slice(numErrorsFlushed * 2); // failedRequests contains 2 items for each error
            serverTelemEntity.errors = lastRequests.errors.slice(numErrorsFlushed);
            this.cacheManager.setServerTelemetry(this.telemetryCacheKey, serverTelemEntity);
        }
    };
    /**
     * Returns the maximum number of errors that can be flushed to the server in the next network request
     * @param serverTelemetryEntity
     */
    ServerTelemetryManager.maxErrorsToSend = function (serverTelemetryEntity) {
        var i;
        var maxErrors = 0;
        var dataSize = 0;
        var errorCount = serverTelemetryEntity.errors.length;
        for (i = 0; i < errorCount; i++) {
            // failedRequests parameter contains pairs of apiId and correlationId, multiply index by 2 to preserve pairs
            var apiId = serverTelemetryEntity.failedRequests[2 * i] || Constants.EMPTY_STRING;
            var correlationId = serverTelemetryEntity.failedRequests[2 * i + 1] || Constants.EMPTY_STRING;
            var errorCode = serverTelemetryEntity.errors[i] || Constants.EMPTY_STRING;
            // Count number of characters that would be added to header, each character is 1 byte. Add 3 at the end to account for separators
            dataSize += apiId.toString().length + correlationId.toString().length + errorCode.length + 3;
            if (dataSize < SERVER_TELEM_CONSTANTS.MAX_LAST_HEADER_BYTES) {
                // Adding this entry to the header would still keep header size below the limit
                maxErrors += 1;
            }
            else {
                break;
            }
        }
        return maxErrors;
    };
    return ServerTelemetryManager;
}());

/*! @azure/msal-browser v2.15.0 2021-06-29 */

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * Constants
 */
var BrowserConstants = {
    /**
     * Interaction in progress cache value
     */
    INTERACTION_IN_PROGRESS_VALUE: "interaction_in_progress",
    /**
     * Invalid grant error code
     */
    INVALID_GRANT_ERROR: "invalid_grant",
    /**
     * Default popup window width
     */
    POPUP_WIDTH: 483,
    /**
     * Default popup window height
     */
    POPUP_HEIGHT: 600,
    /**
     * Name of the popup window starts with
     */
    POPUP_NAME_PREFIX: "msal",
    /**
     * Default popup monitor poll interval in milliseconds
     */
    POLL_INTERVAL_MS: 50,
    /**
     * Msal-browser SKU
     */
    MSAL_SKU: "msal.js.browser",
};
var BrowserCacheLocation;
(function (BrowserCacheLocation) {
    BrowserCacheLocation["LocalStorage"] = "localStorage";
    BrowserCacheLocation["SessionStorage"] = "sessionStorage";
    BrowserCacheLocation["MemoryStorage"] = "memoryStorage";
})(BrowserCacheLocation || (BrowserCacheLocation = {}));
/**
 * HTTP Request types supported by MSAL.
 */
var HTTP_REQUEST_TYPE;
(function (HTTP_REQUEST_TYPE) {
    HTTP_REQUEST_TYPE["GET"] = "GET";
    HTTP_REQUEST_TYPE["POST"] = "POST";
})(HTTP_REQUEST_TYPE || (HTTP_REQUEST_TYPE = {}));
/**
 * Temporary cache keys for MSAL, deleted after any request.
 */
var TemporaryCacheKeys;
(function (TemporaryCacheKeys) {
    TemporaryCacheKeys["AUTHORITY"] = "authority";
    TemporaryCacheKeys["ACQUIRE_TOKEN_ACCOUNT"] = "acquireToken.account";
    TemporaryCacheKeys["SESSION_STATE"] = "session.state";
    TemporaryCacheKeys["REQUEST_STATE"] = "request.state";
    TemporaryCacheKeys["NONCE_IDTOKEN"] = "nonce.id_token";
    TemporaryCacheKeys["ORIGIN_URI"] = "request.origin";
    TemporaryCacheKeys["RENEW_STATUS"] = "token.renew.status";
    TemporaryCacheKeys["URL_HASH"] = "urlHash";
    TemporaryCacheKeys["REQUEST_PARAMS"] = "request.params";
    TemporaryCacheKeys["SCOPES"] = "scopes";
    TemporaryCacheKeys["INTERACTION_STATUS_KEY"] = "interaction.status";
    TemporaryCacheKeys["CCS_CREDENTIAL"] = "ccs.credential";
})(TemporaryCacheKeys || (TemporaryCacheKeys = {}));
/**
 * API Codes for Telemetry purposes.
 * Before adding a new code you must claim it in the MSAL Telemetry tracker as these number spaces are shared across all MSALs
 * 0-99 Silent Flow
 * 800-899 Auth Code Flow
 */
var ApiId;
(function (ApiId) {
    ApiId[ApiId["acquireTokenRedirect"] = 861] = "acquireTokenRedirect";
    ApiId[ApiId["acquireTokenPopup"] = 862] = "acquireTokenPopup";
    ApiId[ApiId["ssoSilent"] = 863] = "ssoSilent";
    ApiId[ApiId["acquireTokenSilent_authCode"] = 864] = "acquireTokenSilent_authCode";
    ApiId[ApiId["handleRedirectPromise"] = 865] = "handleRedirectPromise";
    ApiId[ApiId["acquireTokenSilent_silentFlow"] = 61] = "acquireTokenSilent_silentFlow";
    ApiId[ApiId["logout"] = 961] = "logout";
    ApiId[ApiId["logoutPopup"] = 962] = "logoutPopup";
})(ApiId || (ApiId = {}));
/*
 * Interaction type of the API - used for state and telemetry
 */
var InteractionType;
(function (InteractionType) {
    InteractionType["Redirect"] = "redirect";
    InteractionType["Popup"] = "popup";
    InteractionType["Silent"] = "silent";
})(InteractionType || (InteractionType = {}));
/**
 * Types of interaction currently in progress.
 * Used in events in wrapper libraries to invoke functions when certain interaction is in progress or all interactions are complete.
 */
var InteractionStatus;
(function (InteractionStatus) {
    /**
     * Initial status before interaction occurs
     */
    InteractionStatus["Startup"] = "startup";
    /**
     * Status set when all login calls occuring
     */
    InteractionStatus["Login"] = "login";
    /**
     * Status set when logout call occuring
     */
    InteractionStatus["Logout"] = "logout";
    /**
     * Status set for acquireToken calls
     */
    InteractionStatus["AcquireToken"] = "acquireToken";
    /**
     * Status set for ssoSilent calls
     */
    InteractionStatus["SsoSilent"] = "ssoSilent";
    /**
     * Status set when handleRedirect in progress
     */
    InteractionStatus["HandleRedirect"] = "handleRedirect";
    /**
     * Status set when interaction is complete
     */
    InteractionStatus["None"] = "none";
})(InteractionStatus || (InteractionStatus = {}));
var DEFAULT_REQUEST = {
    scopes: OIDC_DEFAULT_SCOPES
};
/**
 * JWK Key Format string (Type MUST be defined for window crypto APIs)
 */
var KEY_FORMAT_JWK = "jwk";
// Supported wrapper SKUs
var WrapperSKU;
(function (WrapperSKU) {
    WrapperSKU["React"] = "@azure/msal-react";
    WrapperSKU["Angular"] = "@azure/msal-angular";
})(WrapperSKU || (WrapperSKU = {}));

/*! @azure/msal-browser v2.15.0 2021-06-29 */
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * Utility class for math specific functions in browser.
 */
var MathUtils = /** @class */ (function () {
    function MathUtils() {
    }
    /**
     * Decimal to Hex
     *
     * @param num
     */
    MathUtils.decimalToHex = function (num) {
        var hex = num.toString(16);
        while (hex.length < 2) {
            hex = "0" + hex;
        }
        return hex;
    };
    return MathUtils;
}());

/*! @azure/msal-browser v2.15.0 2021-06-29 */

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
var GuidGenerator = /** @class */ (function () {
    function GuidGenerator(cryptoObj) {
        this.cryptoObj = cryptoObj;
    }
    /*
     * RFC4122: The version 4 UUID is meant for generating UUIDs from truly-random or
     * pseudo-random numbers.
     * The algorithm is as follows:
     *     Set the two most significant bits (bits 6 and 7) of the
     *        clock_seq_hi_and_reserved to zero and one, respectively.
     *     Set the four most significant bits (bits 12 through 15) of the
     *        time_hi_and_version field to the 4-bit version number from
     *        Section 4.1.3. Version4
     *     Set all the other bits to randomly (or pseudo-randomly) chosen
     *     values.
     * UUID                   = time-low "-" time-mid "-"time-high-and-version "-"clock-seq-reserved and low(2hexOctet)"-" node
     * time-low               = 4hexOctet
     * time-mid               = 2hexOctet
     * time-high-and-version  = 2hexOctet
     * clock-seq-and-reserved = hexOctet:
     * clock-seq-low          = hexOctet
     * node                   = 6hexOctet
     * Format: xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx
     * y could be 1000, 1001, 1010, 1011 since most significant two bits needs to be 10
     * y values are 8, 9, A, B
     */
    GuidGenerator.prototype.generateGuid = function () {
        try {
            var buffer = new Uint8Array(16);
            this.cryptoObj.getRandomValues(buffer);
            // buffer[6] and buffer[7] represents the time_hi_and_version field. We will set the four most significant bits (4 through 7) of buffer[6] to represent decimal number 4 (UUID version number).
            buffer[6] |= 0x40; // buffer[6] | 01000000 will set the 6 bit to 1.
            buffer[6] &= 0x4f; // buffer[6] & 01001111 will set the 4, 5, and 7 bit to 0 such that bits 4-7 == 0100 = "4".
            // buffer[8] represents the clock_seq_hi_and_reserved field. We will set the two most significant bits (6 and 7) of the clock_seq_hi_and_reserved to zero and one, respectively.
            buffer[8] |= 0x80; // buffer[8] | 10000000 will set the 7 bit to 1.
            buffer[8] &= 0xbf; // buffer[8] & 10111111 will set the 6 bit to 0.
            return MathUtils.decimalToHex(buffer[0]) + MathUtils.decimalToHex(buffer[1])
                + MathUtils.decimalToHex(buffer[2]) + MathUtils.decimalToHex(buffer[3])
                + "-" + MathUtils.decimalToHex(buffer[4]) + MathUtils.decimalToHex(buffer[5])
                + "-" + MathUtils.decimalToHex(buffer[6]) + MathUtils.decimalToHex(buffer[7])
                + "-" + MathUtils.decimalToHex(buffer[8]) + MathUtils.decimalToHex(buffer[9])
                + "-" + MathUtils.decimalToHex(buffer[10]) + MathUtils.decimalToHex(buffer[11])
                + MathUtils.decimalToHex(buffer[12]) + MathUtils.decimalToHex(buffer[13])
                + MathUtils.decimalToHex(buffer[14]) + MathUtils.decimalToHex(buffer[15]);
        }
        catch (err) {
            var guidHolder = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx";
            var hex = "0123456789abcdef";
            var r = 0;
            var guidResponse = "";
            for (var i = 0; i < 36; i++) {
                if (guidHolder[i] !== "-" && guidHolder[i] !== "4") {
                    // each x and y needs to be random
                    r = Math.random() * 16 | 0;
                }
                if (guidHolder[i] === "x") {
                    guidResponse += hex[r];
                }
                else if (guidHolder[i] === "y") {
                    // clock-seq-and-reserved first hex is filtered and remaining hex values are random
                    r &= 0x3; // bit and with 0011 to set pos 2 to zero ?0??
                    r |= 0x8; // set pos 3 to 1 as 1???
                    guidResponse += hex[r];
                }
                else {
                    guidResponse += guidHolder[i];
                }
            }
            return guidResponse;
        }
    };
    /**
     * verifies if a string is  GUID
     * @param guid
     */
    GuidGenerator.isGuid = function (guid) {
        var regexGuid = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
        return regexGuid.test(guid);
    };
    return GuidGenerator;
}());

/*! @azure/msal-browser v2.15.0 2021-06-29 */
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * Utility functions for strings in a browser. See here for implementation details:
 * https://developer.mozilla.org/en-US/docs/Web/API/WindowBase64/Base64_encoding_and_decoding#Solution_2_%E2%80%93_JavaScript's_UTF-16_%3E_UTF-8_%3E_base64
 */
var BrowserStringUtils = /** @class */ (function () {
    function BrowserStringUtils() {
    }
    /**
     * Converts string to Uint8Array
     * @param sDOMStr
     */
    BrowserStringUtils.stringToUtf8Arr = function (sDOMStr) {
        var nChr;
        var nArrLen = 0;
        var nStrLen = sDOMStr.length;
        /* mapping... */
        for (var nMapIdx = 0; nMapIdx < nStrLen; nMapIdx++) {
            nChr = sDOMStr.charCodeAt(nMapIdx);
            nArrLen += nChr < 0x80 ? 1 : nChr < 0x800 ? 2 : nChr < 0x10000 ? 3 : nChr < 0x200000 ? 4 : nChr < 0x4000000 ? 5 : 6;
        }
        var aBytes = new Uint8Array(nArrLen);
        /* transcription... */
        for (var nIdx = 0, nChrIdx = 0; nIdx < nArrLen; nChrIdx++) {
            nChr = sDOMStr.charCodeAt(nChrIdx);
            if (nChr < 128) {
                /* one byte */
                aBytes[nIdx++] = nChr;
            }
            else if (nChr < 0x800) {
                /* two bytes */
                aBytes[nIdx++] = 192 + (nChr >>> 6);
                aBytes[nIdx++] = 128 + (nChr & 63);
            }
            else if (nChr < 0x10000) {
                /* three bytes */
                aBytes[nIdx++] = 224 + (nChr >>> 12);
                aBytes[nIdx++] = 128 + (nChr >>> 6 & 63);
                aBytes[nIdx++] = 128 + (nChr & 63);
            }
            else if (nChr < 0x200000) {
                /* four bytes */
                aBytes[nIdx++] = 240 + (nChr >>> 18);
                aBytes[nIdx++] = 128 + (nChr >>> 12 & 63);
                aBytes[nIdx++] = 128 + (nChr >>> 6 & 63);
                aBytes[nIdx++] = 128 + (nChr & 63);
            }
            else if (nChr < 0x4000000) {
                /* five bytes */
                aBytes[nIdx++] = 248 + (nChr >>> 24);
                aBytes[nIdx++] = 128 + (nChr >>> 18 & 63);
                aBytes[nIdx++] = 128 + (nChr >>> 12 & 63);
                aBytes[nIdx++] = 128 + (nChr >>> 6 & 63);
                aBytes[nIdx++] = 128 + (nChr & 63);
            }
            else /* if (nChr <= 0x7fffffff) */ {
                /* six bytes */
                aBytes[nIdx++] = 252 + (nChr >>> 30);
                aBytes[nIdx++] = 128 + (nChr >>> 24 & 63);
                aBytes[nIdx++] = 128 + (nChr >>> 18 & 63);
                aBytes[nIdx++] = 128 + (nChr >>> 12 & 63);
                aBytes[nIdx++] = 128 + (nChr >>> 6 & 63);
                aBytes[nIdx++] = 128 + (nChr & 63);
            }
        }
        return aBytes;
    };
    /**
     * Converst string to ArrayBuffer
     * @param dataString
     */
    BrowserStringUtils.stringToArrayBuffer = function (dataString) {
        var data = new ArrayBuffer(dataString.length);
        var dataView = new Uint8Array(data);
        for (var i = 0; i < dataString.length; i++) {
            dataView[i] = dataString.charCodeAt(i);
        }
        return data;
    };
    /**
     * Converts Uint8Array to a string
     * @param aBytes
     */
    BrowserStringUtils.utf8ArrToString = function (aBytes) {
        var sView = "";
        for (var nPart = void 0, nLen = aBytes.length, nIdx = 0; nIdx < nLen; nIdx++) {
            nPart = aBytes[nIdx];
            sView += String.fromCharCode(nPart > 251 && nPart < 254 && nIdx + 5 < nLen ? /* six bytes */
                /* (nPart - 252 << 30) may be not so safe in ECMAScript! So...: */
                (nPart - 252) * 1073741824 + (aBytes[++nIdx] - 128 << 24) + (aBytes[++nIdx] - 128 << 18) + (aBytes[++nIdx] - 128 << 12) + (aBytes[++nIdx] - 128 << 6) + aBytes[++nIdx] - 128
                : nPart > 247 && nPart < 252 && nIdx + 4 < nLen ? /* five bytes */
                    (nPart - 248 << 24) + (aBytes[++nIdx] - 128 << 18) + (aBytes[++nIdx] - 128 << 12) + (aBytes[++nIdx] - 128 << 6) + aBytes[++nIdx] - 128
                    : nPart > 239 && nPart < 248 && nIdx + 3 < nLen ? /* four bytes */
                        (nPart - 240 << 18) + (aBytes[++nIdx] - 128 << 12) + (aBytes[++nIdx] - 128 << 6) + aBytes[++nIdx] - 128
                        : nPart > 223 && nPart < 240 && nIdx + 2 < nLen ? /* three bytes */
                            (nPart - 224 << 12) + (aBytes[++nIdx] - 128 << 6) + aBytes[++nIdx] - 128
                            : nPart > 191 && nPart < 224 && nIdx + 1 < nLen ? /* two bytes */
                                (nPart - 192 << 6) + aBytes[++nIdx] - 128
                                : /* nPart < 127 ? */ /* one byte */
                                    nPart);
        }
        return sView;
    };
    return BrowserStringUtils;
}());

/*! @azure/msal-browser v2.15.0 2021-06-29 */

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * Class which exposes APIs to encode plaintext to base64 encoded string. See here for implementation details:
 * https://developer.mozilla.org/en-US/docs/Web/API/WindowBase64/Base64_encoding_and_decoding#Solution_2_%E2%80%93_JavaScript's_UTF-16_%3E_UTF-8_%3E_base64
 */
var Base64Encode = /** @class */ (function () {
    function Base64Encode() {
    }
    /**
     * Returns URL Safe b64 encoded string from a plaintext string.
     * @param input
     */
    Base64Encode.prototype.urlEncode = function (input) {
        return encodeURIComponent(this.encode(input)
            .replace(/=/g, "")
            .replace(/\+/g, "-")
            .replace(/\//g, "_"));
    };
    /**
     * Returns URL Safe b64 encoded string from an int8Array.
     * @param inputArr
     */
    Base64Encode.prototype.urlEncodeArr = function (inputArr) {
        return this.base64EncArr(inputArr)
            .replace(/=/g, "")
            .replace(/\+/g, "-")
            .replace(/\//g, "_");
    };
    /**
     * Returns b64 encoded string from plaintext string.
     * @param input
     */
    Base64Encode.prototype.encode = function (input) {
        var inputUtf8Arr = BrowserStringUtils.stringToUtf8Arr(input);
        return this.base64EncArr(inputUtf8Arr);
    };
    /**
     * Base64 encode byte array
     * @param aBytes
     */
    Base64Encode.prototype.base64EncArr = function (aBytes) {
        var eqLen = (3 - (aBytes.length % 3)) % 3;
        var sB64Enc = "";
        for (var nMod3 = void 0, nLen = aBytes.length, nUint24 = 0, nIdx = 0; nIdx < nLen; nIdx++) {
            nMod3 = nIdx % 3;
            /* Uncomment the following line in order to split the output in lines 76-character long: */
            /*
             *if (nIdx > 0 && (nIdx * 4 / 3) % 76 === 0) { sB64Enc += "\r\n"; }
             */
            nUint24 |= aBytes[nIdx] << (16 >>> nMod3 & 24);
            if (nMod3 === 2 || aBytes.length - nIdx === 1) {
                sB64Enc += String.fromCharCode(this.uint6ToB64(nUint24 >>> 18 & 63), this.uint6ToB64(nUint24 >>> 12 & 63), this.uint6ToB64(nUint24 >>> 6 & 63), this.uint6ToB64(nUint24 & 63));
                nUint24 = 0;
            }
        }
        return eqLen === 0 ? sB64Enc : sB64Enc.substring(0, sB64Enc.length - eqLen) + (eqLen === 1 ? "=" : "==");
    };
    /**
     * Base64 string to array encoding helper
     * @param nUint6
     */
    Base64Encode.prototype.uint6ToB64 = function (nUint6) {
        return nUint6 < 26 ?
            nUint6 + 65
            : nUint6 < 52 ?
                nUint6 + 71
                : nUint6 < 62 ?
                    nUint6 - 4
                    : nUint6 === 62 ?
                        43
                        : nUint6 === 63 ?
                            47
                            :
                                65;
    };
    return Base64Encode;
}());

/*! @azure/msal-browser v2.15.0 2021-06-29 */

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * Class which exposes APIs to decode base64 strings to plaintext. See here for implementation details:
 * https://developer.mozilla.org/en-US/docs/Web/API/WindowBase64/Base64_encoding_and_decoding#Solution_2_%E2%80%93_JavaScript's_UTF-16_%3E_UTF-8_%3E_base64
 */
var Base64Decode = /** @class */ (function () {
    function Base64Decode() {
    }
    /**
     * Returns a URL-safe plaintext decoded string from b64 encoded input.
     * @param input
     */
    Base64Decode.prototype.decode = function (input) {
        var encodedString = input.replace(/-/g, "+").replace(/_/g, "/");
        switch (encodedString.length % 4) {
            case 0:
                break;
            case 2:
                encodedString += "==";
                break;
            case 3:
                encodedString += "=";
                break;
            default:
                throw new Error("Invalid base64 string");
        }
        var inputUtf8Arr = this.base64DecToArr(encodedString);
        return BrowserStringUtils.utf8ArrToString(inputUtf8Arr);
    };
    /**
     * Decodes base64 into Uint8Array
     * @param base64String
     * @param nBlockSize
     */
    Base64Decode.prototype.base64DecToArr = function (base64String, nBlockSize) {
        var sB64Enc = base64String.replace(/[^A-Za-z0-9\+\/]/g, "");
        var nInLen = sB64Enc.length;
        var nOutLen = nBlockSize ? Math.ceil((nInLen * 3 + 1 >>> 2) / nBlockSize) * nBlockSize : nInLen * 3 + 1 >>> 2;
        var aBytes = new Uint8Array(nOutLen);
        for (var nMod3 = void 0, nMod4 = void 0, nUint24 = 0, nOutIdx = 0, nInIdx = 0; nInIdx < nInLen; nInIdx++) {
            nMod4 = nInIdx & 3;
            nUint24 |= this.b64ToUint6(sB64Enc.charCodeAt(nInIdx)) << 18 - 6 * nMod4;
            if (nMod4 === 3 || nInLen - nInIdx === 1) {
                for (nMod3 = 0; nMod3 < 3 && nOutIdx < nOutLen; nMod3++, nOutIdx++) {
                    aBytes[nOutIdx] = nUint24 >>> (16 >>> nMod3 & 24) & 255;
                }
                nUint24 = 0;
            }
        }
        return aBytes;
    };
    /**
     * Base64 string to array decoding helper
     * @param charNum
     */
    Base64Decode.prototype.b64ToUint6 = function (charNum) {
        return charNum > 64 && charNum < 91 ?
            charNum - 65
            : charNum > 96 && charNum < 123 ?
                charNum - 71
                : charNum > 47 && charNum < 58 ?
                    charNum + 4
                    : charNum === 43 ?
                        62
                        : charNum === 47 ?
                            63
                            :
                                0;
    };
    return Base64Decode;
}());

/*! @azure/msal-browser v2.15.0 2021-06-29 */

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * BrowserAuthErrorMessage class containing string constants used by error codes and messages.
 */
var BrowserAuthErrorMessage = {
    pkceNotGenerated: {
        code: "pkce_not_created",
        desc: "The PKCE code challenge and verifier could not be generated."
    },
    cryptoDoesNotExist: {
        code: "crypto_nonexistent",
        desc: "The crypto object or function is not available."
    },
    httpMethodNotImplementedError: {
        code: "http_method_not_implemented",
        desc: "The HTTP method given has not been implemented in this library."
    },
    emptyNavigateUriError: {
        code: "empty_navigate_uri",
        desc: "Navigation URI is empty. Please check stack trace for more info."
    },
    hashEmptyError: {
        code: "hash_empty_error",
        desc: "Hash value cannot be processed because it is empty. Please verify that your redirectUri is not clearing the hash."
    },
    hashDoesNotContainStateError: {
        code: "no_state_in_hash",
        desc: "Hash does not contain state. Please verify that the request originated from msal."
    },
    hashDoesNotContainKnownPropertiesError: {
        code: "hash_does_not_contain_known_properties",
        desc: "Hash does not contain known properites. Please verify that your redirectUri is not changing the hash."
    },
    unableToParseStateError: {
        code: "unable_to_parse_state",
        desc: "Unable to parse state. Please verify that the request originated from msal."
    },
    stateInteractionTypeMismatchError: {
        code: "state_interaction_type_mismatch",
        desc: "Hash contains state but the interaction type does not match the caller."
    },
    interactionInProgress: {
        code: "interaction_in_progress",
        desc: "Interaction is currently in progress. Please ensure that this interaction has been completed before calling an interactive API.  For more visit: aka.ms/msaljs/browser-errors."
    },
    popUpWindowError: {
        code: "popup_window_error",
        desc: "Error opening popup window. This can happen if you are using IE or if popups are blocked in the browser."
    },
    emptyWindowError: {
        code: "empty_window_error",
        desc: "window.open returned null or undefined window object."
    },
    userCancelledError: {
        code: "user_cancelled",
        desc: "User cancelled the flow."
    },
    monitorPopupTimeoutError: {
        code: "monitor_window_timeout",
        desc: "Token acquisition in popup failed due to timeout. For more visit: aka.ms/msaljs/browser-errors."
    },
    monitorIframeTimeoutError: {
        code: "monitor_window_timeout",
        desc: "Token acquisition in iframe failed due to timeout. For more visit: aka.ms/msaljs/browser-errors."
    },
    redirectInIframeError: {
        code: "redirect_in_iframe",
        desc: "Code flow is not supported inside an iframe. Please ensure you are using MSAL.js in a top frame of the window if using the redirect APIs, or use the popup APIs."
    },
    blockTokenRequestsInHiddenIframeError: {
        code: "block_iframe_reload",
        desc: "Request was blocked inside an iframe because MSAL detected an authentication response. For more visit: aka.ms/msaljs/browser-errors"
    },
    blockAcquireTokenInPopupsError: {
        code: "block_nested_popups",
        desc: "Request was blocked inside a popup because MSAL detected it was running in a popup."
    },
    iframeClosedPrematurelyError: {
        code: "iframe_closed_prematurely",
        desc: "The iframe being monitored was closed prematurely."
    },
    silentSSOInsufficientInfoError: {
        code: "silent_sso_error",
        desc: "Silent SSO could not be completed - insufficient information was provided. Please provide either a loginHint or sid."
    },
    noAccountError: {
        code: "no_account_error",
        desc: "No account object provided to acquireTokenSilent and no active account has been set. Please call setActiveAccount or provide an account on the request."
    },
    silentPromptValueError: {
        code: "silent_prompt_value_error",
        desc: "The value given for the prompt value is not valid for silent requests - must be set to 'none'."
    },
    noTokenRequestCacheError: {
        code: "no_token_request_cache_error",
        desc: "No token request in found in cache."
    },
    unableToParseTokenRequestCacheError: {
        code: "unable_to_parse_token_request_cache_error",
        desc: "The cached token request could not be parsed."
    },
    noCachedAuthorityError: {
        code: "no_cached_authority_error",
        desc: "No cached authority found."
    },
    authRequestNotSet: {
        code: "auth_request_not_set_error",
        desc: "Auth Request not set. Please ensure initiateAuthRequest was called from the InteractionHandler"
    },
    invalidCacheType: {
        code: "invalid_cache_type",
        desc: "Invalid cache type"
    },
    notInBrowserEnvironment: {
        code: "non_browser_environment",
        desc: "Login and token requests are not supported in non-browser environments."
    },
    databaseNotOpen: {
        code: "database_not_open",
        desc: "Database is not open!"
    },
    noNetworkConnectivity: {
        code: "no_network_connectivity",
        desc: "No network connectivity. Check your internet connection."
    },
    postRequestFailed: {
        code: "post_request_failed",
        desc: "Network request failed: If the browser threw a CORS error, check that the redirectUri is registered in the Azure App Portal as type 'SPA'"
    },
    getRequestFailed: {
        code: "get_request_failed",
        desc: "Network request failed. Please check the network trace to determine root cause."
    },
    failedToParseNetworkResponse: {
        code: "failed_to_parse_response",
        desc: "Failed to parse network response. Check network trace."
    }
};
/**
 * Browser library error class thrown by the MSAL.js library for SPAs
 */
var BrowserAuthError = /** @class */ (function (_super) {
    __extends$1(BrowserAuthError, _super);
    function BrowserAuthError(errorCode, errorMessage) {
        var _this = _super.call(this, errorCode, errorMessage) || this;
        Object.setPrototypeOf(_this, BrowserAuthError.prototype);
        _this.name = "BrowserAuthError";
        return _this;
    }
    /**
     * Creates an error thrown when PKCE is not implemented.
     * @param errDetail
     */
    BrowserAuthError.createPkceNotGeneratedError = function (errDetail) {
        return new BrowserAuthError(BrowserAuthErrorMessage.pkceNotGenerated.code, BrowserAuthErrorMessage.pkceNotGenerated.desc + " Detail:" + errDetail);
    };
    /**
     * Creates an error thrown when the crypto object is unavailable.
     * @param errDetail
     */
    BrowserAuthError.createCryptoNotAvailableError = function (errDetail) {
        return new BrowserAuthError(BrowserAuthErrorMessage.cryptoDoesNotExist.code, BrowserAuthErrorMessage.cryptoDoesNotExist.desc + " Detail:" + errDetail);
    };
    /**
     * Creates an error thrown when an HTTP method hasn't been implemented by the browser class.
     * @param method
     */
    BrowserAuthError.createHttpMethodNotImplementedError = function (method) {
        return new BrowserAuthError(BrowserAuthErrorMessage.httpMethodNotImplementedError.code, BrowserAuthErrorMessage.httpMethodNotImplementedError.desc + " Given Method: " + method);
    };
    /**
     * Creates an error thrown when the navigation URI is empty.
     */
    BrowserAuthError.createEmptyNavigationUriError = function () {
        return new BrowserAuthError(BrowserAuthErrorMessage.emptyNavigateUriError.code, BrowserAuthErrorMessage.emptyNavigateUriError.desc);
    };
    /**
     * Creates an error thrown when the hash string value is unexpectedly empty.
     * @param hashValue
     */
    BrowserAuthError.createEmptyHashError = function (hashValue) {
        return new BrowserAuthError(BrowserAuthErrorMessage.hashEmptyError.code, BrowserAuthErrorMessage.hashEmptyError.desc + " Given Url: " + hashValue);
    };
    /**
     * Creates an error thrown when the hash string value is unexpectedly empty.
     */
    BrowserAuthError.createHashDoesNotContainStateError = function () {
        return new BrowserAuthError(BrowserAuthErrorMessage.hashDoesNotContainStateError.code, BrowserAuthErrorMessage.hashDoesNotContainStateError.desc);
    };
    /**
     * Creates an error thrown when the hash string value does not contain known properties
     */
    BrowserAuthError.createHashDoesNotContainKnownPropertiesError = function () {
        return new BrowserAuthError(BrowserAuthErrorMessage.hashDoesNotContainKnownPropertiesError.code, BrowserAuthErrorMessage.hashDoesNotContainKnownPropertiesError.desc);
    };
    /**
     * Creates an error thrown when the hash string value is unexpectedly empty.
     */
    BrowserAuthError.createUnableToParseStateError = function () {
        return new BrowserAuthError(BrowserAuthErrorMessage.unableToParseStateError.code, BrowserAuthErrorMessage.unableToParseStateError.desc);
    };
    /**
     * Creates an error thrown when the state value in the hash does not match the interaction type of the API attempting to consume it.
     */
    BrowserAuthError.createStateInteractionTypeMismatchError = function () {
        return new BrowserAuthError(BrowserAuthErrorMessage.stateInteractionTypeMismatchError.code, BrowserAuthErrorMessage.stateInteractionTypeMismatchError.desc);
    };
    /**
     * Creates an error thrown when a browser interaction (redirect or popup) is in progress.
     */
    BrowserAuthError.createInteractionInProgressError = function () {
        return new BrowserAuthError(BrowserAuthErrorMessage.interactionInProgress.code, BrowserAuthErrorMessage.interactionInProgress.desc);
    };
    /**
     * Creates an error thrown when the popup window could not be opened.
     * @param errDetail
     */
    BrowserAuthError.createPopupWindowError = function (errDetail) {
        var errorMessage = BrowserAuthErrorMessage.popUpWindowError.desc;
        errorMessage = !StringUtils.isEmpty(errDetail) ? errorMessage + " Details: " + errDetail : errorMessage;
        return new BrowserAuthError(BrowserAuthErrorMessage.popUpWindowError.code, errorMessage);
    };
    /**
     * Creates an error thrown when window.open returns an empty window object.
     * @param errDetail
     */
    BrowserAuthError.createEmptyWindowCreatedError = function () {
        return new BrowserAuthError(BrowserAuthErrorMessage.emptyWindowError.code, BrowserAuthErrorMessage.emptyWindowError.desc);
    };
    /**
     * Creates an error thrown when the user closes a popup.
     */
    BrowserAuthError.createUserCancelledError = function () {
        return new BrowserAuthError(BrowserAuthErrorMessage.userCancelledError.code, BrowserAuthErrorMessage.userCancelledError.desc);
    };
    /**
     * Creates an error thrown when monitorPopupFromHash times out for a given popup.
     */
    BrowserAuthError.createMonitorPopupTimeoutError = function () {
        return new BrowserAuthError(BrowserAuthErrorMessage.monitorPopupTimeoutError.code, BrowserAuthErrorMessage.monitorPopupTimeoutError.desc);
    };
    /**
     * Creates an error thrown when monitorIframeFromHash times out for a given iframe.
     */
    BrowserAuthError.createMonitorIframeTimeoutError = function () {
        return new BrowserAuthError(BrowserAuthErrorMessage.monitorIframeTimeoutError.code, BrowserAuthErrorMessage.monitorIframeTimeoutError.desc);
    };
    /**
     * Creates an error thrown when navigateWindow is called inside an iframe.
     * @param windowParentCheck
     */
    BrowserAuthError.createRedirectInIframeError = function (windowParentCheck) {
        return new BrowserAuthError(BrowserAuthErrorMessage.redirectInIframeError.code, BrowserAuthErrorMessage.redirectInIframeError.desc + " (window.parent !== window) => " + windowParentCheck);
    };
    /**
     * Creates an error thrown when an auth reload is done inside an iframe.
     */
    BrowserAuthError.createBlockReloadInHiddenIframeError = function () {
        return new BrowserAuthError(BrowserAuthErrorMessage.blockTokenRequestsInHiddenIframeError.code, BrowserAuthErrorMessage.blockTokenRequestsInHiddenIframeError.desc);
    };
    /**
     * Creates an error thrown when a popup attempts to call an acquireToken API
     * @returns
     */
    BrowserAuthError.createBlockAcquireTokenInPopupsError = function () {
        return new BrowserAuthError(BrowserAuthErrorMessage.blockAcquireTokenInPopupsError.code, BrowserAuthErrorMessage.blockAcquireTokenInPopupsError.desc);
    };
    /**
     * Creates an error thrown when an iframe is found to be closed before the timeout is reached.
     */
    BrowserAuthError.createIframeClosedPrematurelyError = function () {
        return new BrowserAuthError(BrowserAuthErrorMessage.iframeClosedPrematurelyError.code, BrowserAuthErrorMessage.iframeClosedPrematurelyError.desc);
    };
    /**
     * Creates an error thrown when the login_hint, sid or account object is not provided in the ssoSilent API.
     */
    BrowserAuthError.createSilentSSOInsufficientInfoError = function () {
        return new BrowserAuthError(BrowserAuthErrorMessage.silentSSOInsufficientInfoError.code, BrowserAuthErrorMessage.silentSSOInsufficientInfoError.desc);
    };
    /**
     * Creates an error thrown when the account object is not provided in the acquireTokenSilent API.
     */
    BrowserAuthError.createNoAccountError = function () {
        return new BrowserAuthError(BrowserAuthErrorMessage.noAccountError.code, BrowserAuthErrorMessage.noAccountError.desc);
    };
    /**
     * Creates an error thrown when a given prompt value is invalid for silent requests.
     */
    BrowserAuthError.createSilentPromptValueError = function (givenPrompt) {
        return new BrowserAuthError(BrowserAuthErrorMessage.silentPromptValueError.code, BrowserAuthErrorMessage.silentPromptValueError.desc + " Given value: " + givenPrompt);
    };
    /**
     * Creates an error thrown when the cached token request could not be retrieved from the cache
     */
    BrowserAuthError.createUnableToParseTokenRequestCacheError = function () {
        return new BrowserAuthError(BrowserAuthErrorMessage.unableToParseTokenRequestCacheError.code, BrowserAuthErrorMessage.unableToParseTokenRequestCacheError.desc);
    };
    /**
     * Creates an error thrown when the token request could not be retrieved from the cache
     */
    BrowserAuthError.createNoTokenRequestCacheError = function () {
        return new BrowserAuthError(BrowserAuthErrorMessage.noTokenRequestCacheError.code, BrowserAuthErrorMessage.noTokenRequestCacheError.desc);
    };
    /**
     * Creates an error thrown when handleCodeResponse is called before initiateAuthRequest (InteractionHandler)
     */
    BrowserAuthError.createAuthRequestNotSetError = function () {
        return new BrowserAuthError(BrowserAuthErrorMessage.authRequestNotSet.code, BrowserAuthErrorMessage.authRequestNotSet.desc);
    };
    /**
     * Creates an error thrown when the authority could not be retrieved from the cache
     */
    BrowserAuthError.createNoCachedAuthorityError = function () {
        return new BrowserAuthError(BrowserAuthErrorMessage.noCachedAuthorityError.code, BrowserAuthErrorMessage.noCachedAuthorityError.desc);
    };
    /**
     * Creates an error thrown if cache type is invalid.
     */
    BrowserAuthError.createInvalidCacheTypeError = function () {
        return new BrowserAuthError(BrowserAuthErrorMessage.invalidCacheType.code, "" + BrowserAuthErrorMessage.invalidCacheType.desc);
    };
    /**
     * Create an error thrown when login and token requests are made from a non-browser environment
     */
    BrowserAuthError.createNonBrowserEnvironmentError = function () {
        return new BrowserAuthError(BrowserAuthErrorMessage.notInBrowserEnvironment.code, BrowserAuthErrorMessage.notInBrowserEnvironment.desc);
    };
    /**
     * Create an error thrown when indexDB database is not open
     */
    BrowserAuthError.createDatabaseNotOpenError = function () {
        return new BrowserAuthError(BrowserAuthErrorMessage.databaseNotOpen.code, BrowserAuthErrorMessage.databaseNotOpen.desc);
    };
    /**
     * Create an error thrown when token fetch fails due to no internet
     */
    BrowserAuthError.createNoNetworkConnectivityError = function () {
        return new BrowserAuthError(BrowserAuthErrorMessage.noNetworkConnectivity.code, BrowserAuthErrorMessage.noNetworkConnectivity.desc);
    };
    /**
     * Create an error thrown when token fetch fails due to reasons other than internet connectivity
     */
    BrowserAuthError.createPostRequestFailedError = function (errorDesc, endpoint) {
        return new BrowserAuthError(BrowserAuthErrorMessage.postRequestFailed.code, BrowserAuthErrorMessage.postRequestFailed.desc + " | Network client threw: " + errorDesc + " | Attempted to reach: " + endpoint.split("?")[0]);
    };
    /**
     * Create an error thrown when get request fails due to reasons other than internet connectivity
     */
    BrowserAuthError.createGetRequestFailedError = function (errorDesc, endpoint) {
        return new BrowserAuthError(BrowserAuthErrorMessage.getRequestFailed.code, BrowserAuthErrorMessage.getRequestFailed.desc + " | Network client threw: " + errorDesc + " | Attempted to reach: " + endpoint.split("?")[0]);
    };
    /**
     * Create an error thrown when network client fails to parse network response
     */
    BrowserAuthError.createFailedToParseNetworkResponseError = function (endpoint) {
        return new BrowserAuthError(BrowserAuthErrorMessage.failedToParseNetworkResponse.code, BrowserAuthErrorMessage.failedToParseNetworkResponse.desc + " | Attempted to reach: " + endpoint.split("?")[0]);
    };
    return BrowserAuthError;
}(AuthError));

/*! @azure/msal-browser v2.15.0 2021-06-29 */

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
// Constant byte array length
var RANDOM_BYTE_ARR_LENGTH = 32;
/**
 * Class which exposes APIs to generate PKCE codes and code verifiers.
 */
var PkceGenerator = /** @class */ (function () {
    function PkceGenerator(cryptoObj) {
        this.base64Encode = new Base64Encode();
        this.cryptoObj = cryptoObj;
    }
    /**
     * Generates PKCE Codes. See the RFC for more information: https://tools.ietf.org/html/rfc7636
     */
    PkceGenerator.prototype.generateCodes = function () {
        return __awaiter$1(this, void 0, void 0, function () {
            var codeVerifier, codeChallenge;
            return __generator$1(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        codeVerifier = this.generateCodeVerifier();
                        return [4 /*yield*/, this.generateCodeChallengeFromVerifier(codeVerifier)];
                    case 1:
                        codeChallenge = _a.sent();
                        return [2 /*return*/, {
                                verifier: codeVerifier,
                                challenge: codeChallenge
                            }];
                }
            });
        });
    };
    /**
     * Generates a random 32 byte buffer and returns the base64
     * encoded string to be used as a PKCE Code Verifier
     */
    PkceGenerator.prototype.generateCodeVerifier = function () {
        try {
            // Generate random values as utf-8
            var buffer = new Uint8Array(RANDOM_BYTE_ARR_LENGTH);
            this.cryptoObj.getRandomValues(buffer);
            // encode verifier as base64
            var pkceCodeVerifierB64 = this.base64Encode.urlEncodeArr(buffer);
            return pkceCodeVerifierB64;
        }
        catch (e) {
            throw BrowserAuthError.createPkceNotGeneratedError(e);
        }
    };
    /**
     * Creates a base64 encoded PKCE Code Challenge string from the
     * hash created from the PKCE Code Verifier supplied
     */
    PkceGenerator.prototype.generateCodeChallengeFromVerifier = function (pkceCodeVerifier) {
        return __awaiter$1(this, void 0, void 0, function () {
            var pkceHashedCodeVerifier, e_1;
            return __generator$1(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.cryptoObj.sha256Digest(pkceCodeVerifier)];
                    case 1:
                        pkceHashedCodeVerifier = _a.sent();
                        // encode hash as base64
                        return [2 /*return*/, this.base64Encode.urlEncodeArr(new Uint8Array(pkceHashedCodeVerifier))];
                    case 2:
                        e_1 = _a.sent();
                        throw BrowserAuthError.createPkceNotGeneratedError(e_1);
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    return PkceGenerator;
}());

/*! @azure/msal-browser v2.15.0 2021-06-29 */

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * See here for more info on RsaHashedKeyGenParams: https://developer.mozilla.org/en-US/docs/Web/API/RsaHashedKeyGenParams
 */
// RSA KeyGen Algorithm
var PKCS1_V15_KEYGEN_ALG = "RSASSA-PKCS1-v1_5";
// SHA-256 hashing algorithm
var S256_HASH_ALG = "SHA-256";
// MOD length for PoP tokens
var MODULUS_LENGTH = 2048;
// Public Exponent
var PUBLIC_EXPONENT = new Uint8Array([0x01, 0x00, 0x01]);
/**
 * This class implements functions used by the browser library to perform cryptography operations such as
 * hashing and encoding. It also has helper functions to validate the availability of specific APIs.
 */
var BrowserCrypto = /** @class */ (function () {
    function BrowserCrypto() {
        if (!(this.hasCryptoAPI())) {
            throw BrowserAuthError.createCryptoNotAvailableError("Browser crypto or msCrypto object not available.");
        }
        this._keygenAlgorithmOptions = {
            name: PKCS1_V15_KEYGEN_ALG,
            hash: S256_HASH_ALG,
            modulusLength: MODULUS_LENGTH,
            publicExponent: PUBLIC_EXPONENT
        };
    }
    /**
     * Returns a sha-256 hash of the given dataString as an ArrayBuffer.
     * @param dataString
     */
    BrowserCrypto.prototype.sha256Digest = function (dataString) {
        return __awaiter$1(this, void 0, void 0, function () {
            var data;
            return __generator$1(this, function (_a) {
                data = BrowserStringUtils.stringToUtf8Arr(dataString);
                return [2 /*return*/, this.hasIECrypto() ? this.getMSCryptoDigest(S256_HASH_ALG, data) : this.getSubtleCryptoDigest(S256_HASH_ALG, data)];
            });
        });
    };
    /**
     * Populates buffer with cryptographically random values.
     * @param dataBuffer
     */
    BrowserCrypto.prototype.getRandomValues = function (dataBuffer) {
        var cryptoObj = window["msCrypto"] || window.crypto;
        if (!cryptoObj.getRandomValues) {
            throw BrowserAuthError.createCryptoNotAvailableError("getRandomValues does not exist.");
        }
        cryptoObj.getRandomValues(dataBuffer);
    };
    /**
     * Generates a keypair based on current keygen algorithm config.
     * @param extractable
     * @param usages
     */
    BrowserCrypto.prototype.generateKeyPair = function (extractable, usages) {
        return __awaiter$1(this, void 0, void 0, function () {
            return __generator$1(this, function (_a) {
                return [2 /*return*/, (this.hasIECrypto() ?
                        this.msCryptoGenerateKey(extractable, usages)
                        : window.crypto.subtle.generateKey(this._keygenAlgorithmOptions, extractable, usages))];
            });
        });
    };
    /**
     * Export key as Json Web Key (JWK)
     * @param key
     * @param format
     */
    BrowserCrypto.prototype.exportJwk = function (key) {
        return __awaiter$1(this, void 0, void 0, function () {
            return __generator$1(this, function (_a) {
                return [2 /*return*/, this.hasIECrypto() ? this.msCryptoExportJwk(key) : window.crypto.subtle.exportKey(KEY_FORMAT_JWK, key)];
            });
        });
    };
    /**
     * Imports key as Json Web Key (JWK), can set extractable and usages.
     * @param key
     * @param format
     * @param extractable
     * @param usages
     */
    BrowserCrypto.prototype.importJwk = function (key, extractable, usages) {
        return __awaiter$1(this, void 0, void 0, function () {
            var keyString, keyBuffer;
            return __generator$1(this, function (_a) {
                keyString = BrowserCrypto.getJwkString(key);
                keyBuffer = BrowserStringUtils.stringToArrayBuffer(keyString);
                return [2 /*return*/, this.hasIECrypto() ?
                        this.msCryptoImportKey(keyBuffer, extractable, usages)
                        : window.crypto.subtle.importKey(KEY_FORMAT_JWK, key, this._keygenAlgorithmOptions, extractable, usages)];
            });
        });
    };
    /**
     * Signs given data with given key
     * @param key
     * @param data
     */
    BrowserCrypto.prototype.sign = function (key, data) {
        return __awaiter$1(this, void 0, void 0, function () {
            return __generator$1(this, function (_a) {
                return [2 /*return*/, this.hasIECrypto() ?
                        this.msCryptoSign(key, data)
                        : window.crypto.subtle.sign(this._keygenAlgorithmOptions, key, data)];
            });
        });
    };
    /**
     * Check whether IE crypto or other browser cryptography is available.
     */
    BrowserCrypto.prototype.hasCryptoAPI = function () {
        return this.hasIECrypto() || this.hasBrowserCrypto();
    };
    /**
     * Checks whether IE crypto (AKA msCrypto) is available.
     */
    BrowserCrypto.prototype.hasIECrypto = function () {
        return "msCrypto" in window;
    };
    /**
     * Check whether browser crypto is available.
     */
    BrowserCrypto.prototype.hasBrowserCrypto = function () {
        return "crypto" in window;
    };
    /**
     * Helper function for SHA digest.
     * @param algorithm
     * @param data
     */
    BrowserCrypto.prototype.getSubtleCryptoDigest = function (algorithm, data) {
        return __awaiter$1(this, void 0, void 0, function () {
            return __generator$1(this, function (_a) {
                return [2 /*return*/, window.crypto.subtle.digest(algorithm, data)];
            });
        });
    };
    /**
     * IE Helper function for SHA digest.
     * @param algorithm
     * @param data
     */
    BrowserCrypto.prototype.getMSCryptoDigest = function (algorithm, data) {
        return __awaiter$1(this, void 0, void 0, function () {
            return __generator$1(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        var digestOperation = window["msCrypto"].subtle.digest(algorithm, data.buffer);
                        digestOperation.addEventListener("complete", function (e) {
                            resolve(e.target.result);
                        });
                        digestOperation.addEventListener("error", function (error) {
                            reject(error);
                        });
                    })];
            });
        });
    };
    /**
     * IE Helper function for generating a keypair
     * @param extractable
     * @param usages
     */
    BrowserCrypto.prototype.msCryptoGenerateKey = function (extractable, usages) {
        return __awaiter$1(this, void 0, void 0, function () {
            var _this = this;
            return __generator$1(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        var msGenerateKey = window["msCrypto"].subtle.generateKey(_this._keygenAlgorithmOptions, extractable, usages);
                        msGenerateKey.addEventListener("complete", function (e) {
                            resolve(e.target.result);
                        });
                        msGenerateKey.addEventListener("error", function (error) {
                            reject(error);
                        });
                    })];
            });
        });
    };
    /**
     * IE Helper function for exportKey
     * @param key
     * @param format
     */
    BrowserCrypto.prototype.msCryptoExportJwk = function (key) {
        return __awaiter$1(this, void 0, void 0, function () {
            return __generator$1(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        var msExportKey = window["msCrypto"].subtle.exportKey(KEY_FORMAT_JWK, key);
                        msExportKey.addEventListener("complete", function (e) {
                            var resultBuffer = e.target.result;
                            var resultString = BrowserStringUtils.utf8ArrToString(new Uint8Array(resultBuffer))
                                .replace(/\r/g, "")
                                .replace(/\n/g, "")
                                .replace(/\t/g, "")
                                .split(" ").join("")
                                .replace("\u0000", "");
                            try {
                                resolve(JSON.parse(resultString));
                            }
                            catch (e) {
                                reject(e);
                            }
                        });
                        msExportKey.addEventListener("error", function (error) {
                            reject(error);
                        });
                    })];
            });
        });
    };
    /**
     * IE Helper function for importKey
     * @param key
     * @param format
     * @param extractable
     * @param usages
     */
    BrowserCrypto.prototype.msCryptoImportKey = function (keyBuffer, extractable, usages) {
        return __awaiter$1(this, void 0, void 0, function () {
            var _this = this;
            return __generator$1(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        var msImportKey = window["msCrypto"].subtle.importKey(KEY_FORMAT_JWK, keyBuffer, _this._keygenAlgorithmOptions, extractable, usages);
                        msImportKey.addEventListener("complete", function (e) {
                            resolve(e.target.result);
                        });
                        msImportKey.addEventListener("error", function (error) {
                            reject(error);
                        });
                    })];
            });
        });
    };
    /**
     * IE Helper function for sign JWT
     * @param key
     * @param data
     */
    BrowserCrypto.prototype.msCryptoSign = function (key, data) {
        return __awaiter$1(this, void 0, void 0, function () {
            var _this = this;
            return __generator$1(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        var msSign = window["msCrypto"].subtle.sign(_this._keygenAlgorithmOptions, key, data);
                        msSign.addEventListener("complete", function (e) {
                            resolve(e.target.result);
                        });
                        msSign.addEventListener("error", function (error) {
                            reject(error);
                        });
                    })];
            });
        });
    };
    /**
     * Returns stringified jwk.
     * @param jwk
     */
    BrowserCrypto.getJwkString = function (jwk) {
        return JSON.stringify(jwk, Object.keys(jwk).sort());
    };
    return BrowserCrypto;
}());

/*! @azure/msal-browser v2.15.0 2021-06-29 */

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * Storage wrapper for IndexedDB storage in browsers: https://developer.mozilla.org/en-US/docs/Web/API/IndexedDB_API
 */
var DatabaseStorage = /** @class */ (function () {
    function DatabaseStorage(dbName, tableName, version) {
        this.dbName = dbName;
        this.tableName = tableName;
        this.version = version;
        this.dbOpen = false;
    }
    /**
     * Opens IndexedDB instance.
     */
    DatabaseStorage.prototype.open = function () {
        return __awaiter$1(this, void 0, void 0, function () {
            var _this = this;
            return __generator$1(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        // TODO: Add timeouts?
                        var openDB = window.indexedDB.open(_this.dbName, _this.version);
                        openDB.addEventListener("upgradeneeded", function (e) {
                            var event = e;
                            event.target.result.createObjectStore(_this.tableName);
                        });
                        openDB.addEventListener("success", function (e) {
                            var event = e;
                            _this.db = event.target.result;
                            _this.dbOpen = true;
                            resolve();
                        });
                        openDB.addEventListener("error", function (error) { return reject(error); });
                    })];
            });
        });
    };
    /**
     * Retrieves item from IndexedDB instance.
     * @param key
     */
    DatabaseStorage.prototype.get = function (key) {
        return __awaiter$1(this, void 0, void 0, function () {
            var _this = this;
            return __generator$1(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this.dbOpen) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.open()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/, new Promise(function (resolve, reject) {
                            // TODO: Add timeouts?
                            if (!_this.db) {
                                return reject(BrowserAuthError.createDatabaseNotOpenError());
                            }
                            var transaction = _this.db.transaction([_this.tableName], "readonly");
                            var objectStore = transaction.objectStore(_this.tableName);
                            var dbGet = objectStore.get(key);
                            dbGet.addEventListener("success", function (e) {
                                var event = e;
                                resolve(event.target.result);
                            });
                            dbGet.addEventListener("error", function (e) { return reject(e); });
                        })];
                }
            });
        });
    };
    /**
     * Adds item to IndexedDB under given key
     * @param key
     * @param payload
     */
    DatabaseStorage.prototype.put = function (key, payload) {
        return __awaiter$1(this, void 0, void 0, function () {
            var _this = this;
            return __generator$1(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this.dbOpen) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.open()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/, new Promise(function (resolve, reject) {
                            // TODO: Add timeouts?
                            if (!_this.db) {
                                return reject(BrowserAuthError.createDatabaseNotOpenError());
                            }
                            var transaction = _this.db.transaction([_this.tableName], "readwrite");
                            var objectStore = transaction.objectStore(_this.tableName);
                            var dbPut = objectStore.put(payload, key);
                            dbPut.addEventListener("success", function (e) {
                                var event = e;
                                resolve(event.target.result);
                            });
                            dbPut.addEventListener("error", function (e) { return reject(e); });
                        })];
                }
            });
        });
    };
    return DatabaseStorage;
}());

/*! @azure/msal-browser v2.15.0 2021-06-29 */

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * This class implements MSAL's crypto interface, which allows it to perform base64 encoding and decoding, generating cryptographically random GUIDs and
 * implementing Proof Key for Code Exchange specs for the OAuth Authorization Code Flow using PKCE (rfc here: https://tools.ietf.org/html/rfc7636).
 */
var CryptoOps = /** @class */ (function () {
    function CryptoOps() {
        // Browser crypto needs to be validated first before any other classes can be set.
        this.browserCrypto = new BrowserCrypto();
        this.b64Encode = new Base64Encode();
        this.b64Decode = new Base64Decode();
        this.guidGenerator = new GuidGenerator(this.browserCrypto);
        this.pkceGenerator = new PkceGenerator(this.browserCrypto);
        this.cache = new DatabaseStorage(CryptoOps.DB_NAME, CryptoOps.TABLE_NAME, CryptoOps.DB_VERSION);
    }
    /**
     * Creates a new random GUID - used to populate state and nonce.
     * @returns string (GUID)
     */
    CryptoOps.prototype.createNewGuid = function () {
        return this.guidGenerator.generateGuid();
    };
    /**
     * Encodes input string to base64.
     * @param input
     */
    CryptoOps.prototype.base64Encode = function (input) {
        return this.b64Encode.encode(input);
    };
    /**
     * Decodes input string from base64.
     * @param input
     */
    CryptoOps.prototype.base64Decode = function (input) {
        return this.b64Decode.decode(input);
    };
    /**
     * Generates PKCE codes used in Authorization Code Flow.
     */
    CryptoOps.prototype.generatePkceCodes = function () {
        return __awaiter$1(this, void 0, void 0, function () {
            return __generator$1(this, function (_a) {
                return [2 /*return*/, this.pkceGenerator.generateCodes()];
            });
        });
    };
    /**
     * Generates a keypair, stores it and returns a thumbprint
     * @param request
     */
    CryptoOps.prototype.getPublicKeyThumbprint = function (request) {
        return __awaiter$1(this, void 0, void 0, function () {
            var keyPair, publicKeyJwk, pubKeyThumprintObj, publicJwkString, publicJwkBuffer, publicJwkHash, privateKeyJwk, unextractablePrivateKey;
            return __generator$1(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.browserCrypto.generateKeyPair(CryptoOps.EXTRACTABLE, CryptoOps.POP_KEY_USAGES)];
                    case 1:
                        keyPair = _a.sent();
                        return [4 /*yield*/, this.browserCrypto.exportJwk(keyPair.publicKey)];
                    case 2:
                        publicKeyJwk = _a.sent();
                        pubKeyThumprintObj = {
                            e: publicKeyJwk.e,
                            kty: publicKeyJwk.kty,
                            n: publicKeyJwk.n
                        };
                        publicJwkString = BrowserCrypto.getJwkString(pubKeyThumprintObj);
                        return [4 /*yield*/, this.browserCrypto.sha256Digest(publicJwkString)];
                    case 3:
                        publicJwkBuffer = _a.sent();
                        publicJwkHash = this.b64Encode.urlEncodeArr(new Uint8Array(publicJwkBuffer));
                        return [4 /*yield*/, this.browserCrypto.exportJwk(keyPair.privateKey)];
                    case 4:
                        privateKeyJwk = _a.sent();
                        return [4 /*yield*/, this.browserCrypto.importJwk(privateKeyJwk, false, ["sign"])];
                    case 5:
                        unextractablePrivateKey = _a.sent();
                        // Store Keypair data in keystore
                        this.cache.put(publicJwkHash, {
                            privateKey: unextractablePrivateKey,
                            publicKey: keyPair.publicKey,
                            requestMethod: request.resourceRequestMethod,
                            requestUri: request.resourceRequestUri
                        });
                        return [2 /*return*/, publicJwkHash];
                }
            });
        });
    };
    /**
     * Signs the given object as a jwt payload with private key retrieved by given kid.
     * @param payload
     * @param kid
     */
    CryptoOps.prototype.signJwt = function (payload, kid) {
        return __awaiter$1(this, void 0, void 0, function () {
            var cachedKeyPair, publicKeyJwk, publicKeyJwkString, header, encodedHeader, encodedPayload, tokenString, tokenBuffer, signatureBuffer, encodedSignature;
            return __generator$1(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.cache.get(kid)];
                    case 1:
                        cachedKeyPair = _a.sent();
                        return [4 /*yield*/, this.browserCrypto.exportJwk(cachedKeyPair.publicKey)];
                    case 2:
                        publicKeyJwk = _a.sent();
                        publicKeyJwkString = BrowserCrypto.getJwkString(publicKeyJwk);
                        header = {
                            alg: publicKeyJwk.alg,
                            type: KEY_FORMAT_JWK
                        };
                        encodedHeader = this.b64Encode.urlEncode(JSON.stringify(header));
                        // Generate payload
                        payload.cnf = {
                            jwk: JSON.parse(publicKeyJwkString)
                        };
                        encodedPayload = this.b64Encode.urlEncode(JSON.stringify(payload));
                        tokenString = encodedHeader + "." + encodedPayload;
                        tokenBuffer = BrowserStringUtils.stringToArrayBuffer(tokenString);
                        return [4 /*yield*/, this.browserCrypto.sign(cachedKeyPair.privateKey, tokenBuffer)];
                    case 3:
                        signatureBuffer = _a.sent();
                        encodedSignature = this.b64Encode.urlEncodeArr(new Uint8Array(signatureBuffer));
                        return [2 /*return*/, tokenString + "." + encodedSignature];
                }
            });
        });
    };
    CryptoOps.POP_KEY_USAGES = ["sign", "verify"];
    CryptoOps.EXTRACTABLE = true;
    CryptoOps.DB_VERSION = 1;
    CryptoOps.DB_NAME = "msal.db";
    CryptoOps.TABLE_NAME = CryptoOps.DB_NAME + ".keys";
    return CryptoOps;
}());

/*! @azure/msal-browser v2.15.0 2021-06-29 */

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * BrowserAuthErrorMessage class containing string constants used by error codes and messages.
 */
var BrowserConfigurationAuthErrorMessage = {
    redirectUriNotSet: {
        code: "redirect_uri_empty",
        desc: "A redirect URI is required for all calls, and none has been set."
    },
    postLogoutUriNotSet: {
        code: "post_logout_uri_empty",
        desc: "A post logout redirect has not been set."
    },
    storageNotSupportedError: {
        code: "storage_not_supported",
        desc: "Given storage configuration option was not supported."
    },
    noRedirectCallbacksSet: {
        code: "no_redirect_callbacks",
        desc: "No redirect callbacks have been set. Please call setRedirectCallbacks() with the appropriate function arguments before continuing. " +
            "More information is available here: https://github.com/AzureAD/microsoft-authentication-library-for-js/wiki/MSAL-basics."
    },
    invalidCallbackObject: {
        code: "invalid_callback_object",
        desc: "The object passed for the callback was invalid. " +
            "More information is available here: https://github.com/AzureAD/microsoft-authentication-library-for-js/wiki/MSAL-basics."
    },
    stubPcaInstanceCalled: {
        code: "stubbed_public_client_application_called",
        desc: "Stub instance of Public Client Application was called. If using msal-react, please ensure context is not used without a provider. For more visit: aka.ms/msaljs/browser-errors"
    },
    inMemRedirectUnavailable: {
        code: "in_mem_redirect_unavailable",
        desc: "Redirect cannot be supported. In-memory storage was selected and storeAuthStateInCookie=false, which would cause the library to be unable to handle the incoming hash. If you would like to use the redirect API, please use session/localStorage or set storeAuthStateInCookie=true."
    }
};
/**
 * Browser library error class thrown by the MSAL.js library for SPAs
 */
var BrowserConfigurationAuthError = /** @class */ (function (_super) {
    __extends$1(BrowserConfigurationAuthError, _super);
    function BrowserConfigurationAuthError(errorCode, errorMessage) {
        var _this = _super.call(this, errorCode, errorMessage) || this;
        _this.name = "BrowserConfigurationAuthError";
        Object.setPrototypeOf(_this, BrowserConfigurationAuthError.prototype);
        return _this;
    }
    /**
     * Creates an error thrown when the redirect uri is empty (not set by caller)
     */
    BrowserConfigurationAuthError.createRedirectUriEmptyError = function () {
        return new BrowserConfigurationAuthError(BrowserConfigurationAuthErrorMessage.redirectUriNotSet.code, BrowserConfigurationAuthErrorMessage.redirectUriNotSet.desc);
    };
    /**
     * Creates an error thrown when the post-logout redirect uri is empty (not set by caller)
     */
    BrowserConfigurationAuthError.createPostLogoutRedirectUriEmptyError = function () {
        return new BrowserConfigurationAuthError(BrowserConfigurationAuthErrorMessage.postLogoutUriNotSet.code, BrowserConfigurationAuthErrorMessage.postLogoutUriNotSet.desc);
    };
    /**
     * Creates error thrown when given storage location is not supported.
     * @param givenStorageLocation
     */
    BrowserConfigurationAuthError.createStorageNotSupportedError = function (givenStorageLocation) {
        return new BrowserConfigurationAuthError(BrowserConfigurationAuthErrorMessage.storageNotSupportedError.code, BrowserConfigurationAuthErrorMessage.storageNotSupportedError.desc + " Given Location: " + givenStorageLocation);
    };
    /**
     * Creates error thrown when redirect callbacks are not set before calling loginRedirect() or acquireTokenRedirect().
     */
    BrowserConfigurationAuthError.createRedirectCallbacksNotSetError = function () {
        return new BrowserConfigurationAuthError(BrowserConfigurationAuthErrorMessage.noRedirectCallbacksSet.code, BrowserConfigurationAuthErrorMessage.noRedirectCallbacksSet.desc);
    };
    /**
     * Creates error thrown when the stub instance of PublicClientApplication is called.
     */
    BrowserConfigurationAuthError.createStubPcaInstanceCalledError = function () {
        return new BrowserConfigurationAuthError(BrowserConfigurationAuthErrorMessage.stubPcaInstanceCalled.code, BrowserConfigurationAuthErrorMessage.stubPcaInstanceCalled.desc);
    };
    /*
     * Create an error thrown when in-memory storage is used and storeAuthStateInCookie=false.
     */
    BrowserConfigurationAuthError.createInMemoryRedirectUnavailableError = function () {
        return new BrowserConfigurationAuthError(BrowserConfigurationAuthErrorMessage.inMemRedirectUnavailable.code, BrowserConfigurationAuthErrorMessage.inMemRedirectUnavailable.desc);
    };
    return BrowserConfigurationAuthError;
}(AuthError));

/*! @azure/msal-browser v2.15.0 2021-06-29 */

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
var BrowserStorage = /** @class */ (function () {
    function BrowserStorage(cacheLocation) {
        this.validateWindowStorage(cacheLocation);
        this.windowStorage = window[cacheLocation];
    }
    BrowserStorage.prototype.validateWindowStorage = function (cacheLocation) {
        if (cacheLocation !== BrowserCacheLocation.LocalStorage && cacheLocation !== BrowserCacheLocation.SessionStorage) {
            throw BrowserConfigurationAuthError.createStorageNotSupportedError(cacheLocation);
        }
        var storageSupported = !!window[cacheLocation];
        if (!storageSupported) {
            throw BrowserConfigurationAuthError.createStorageNotSupportedError(cacheLocation);
        }
    };
    BrowserStorage.prototype.getItem = function (key) {
        return this.windowStorage.getItem(key);
    };
    BrowserStorage.prototype.setItem = function (key, value) {
        this.windowStorage.setItem(key, value);
    };
    BrowserStorage.prototype.removeItem = function (key) {
        this.windowStorage.removeItem(key);
    };
    BrowserStorage.prototype.getKeys = function () {
        return Object.keys(this.windowStorage);
    };
    BrowserStorage.prototype.containsKey = function (key) {
        return this.windowStorage.hasOwnProperty(key);
    };
    return BrowserStorage;
}());

/*! @azure/msal-browser v2.15.0 2021-06-29 */
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
var MemoryStorage = /** @class */ (function () {
    function MemoryStorage() {
        this.cache = new Map();
    }
    MemoryStorage.prototype.getItem = function (key) {
        return this.cache.get(key) || null;
    };
    MemoryStorage.prototype.setItem = function (key, value) {
        this.cache.set(key, value);
    };
    MemoryStorage.prototype.removeItem = function (key) {
        this.cache.delete(key);
    };
    MemoryStorage.prototype.getKeys = function () {
        var cacheKeys = [];
        this.cache.forEach(function (value, key) {
            cacheKeys.push(key);
        });
        return cacheKeys;
    };
    MemoryStorage.prototype.containsKey = function (key) {
        return this.cache.has(key);
    };
    MemoryStorage.prototype.clear = function () {
        this.cache.clear();
    };
    return MemoryStorage;
}());

/*! @azure/msal-browser v2.15.0 2021-06-29 */

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
var BrowserProtocolUtils = /** @class */ (function () {
    function BrowserProtocolUtils() {
    }
    /**
     * Extracts the BrowserStateObject from the state string.
     * @param browserCrypto
     * @param state
     */
    BrowserProtocolUtils.extractBrowserRequestState = function (browserCrypto, state) {
        if (StringUtils.isEmpty(state)) {
            return null;
        }
        try {
            var requestStateObj = ProtocolUtils.parseRequestState(browserCrypto, state);
            return requestStateObj.libraryState.meta;
        }
        catch (e) {
            throw ClientAuthError.createInvalidStateError(state, e);
        }
    };
    /**
     * Parses properties of server response from url hash
     * @param locationHash Hash from url
     */
    BrowserProtocolUtils.parseServerResponseFromHash = function (locationHash) {
        if (!locationHash) {
            return {};
        }
        var hashUrlString = new UrlString(locationHash);
        return UrlString.getDeserializedHash(hashUrlString.getHash());
    };
    return BrowserProtocolUtils;
}());

/*! @azure/msal-browser v2.15.0 2021-06-29 */

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * This class implements the cache storage interface for MSAL through browser local or session storage.
 * Cookies are only used if storeAuthStateInCookie is true, and are only used for
 * parameters such as state and nonce, generally.
 */
var BrowserCacheManager = /** @class */ (function (_super) {
    __extends$1(BrowserCacheManager, _super);
    function BrowserCacheManager(clientId, cacheConfig, cryptoImpl, logger) {
        var _this = _super.call(this, clientId, cryptoImpl) || this;
        // Cookie life calculation (hours * minutes * seconds * ms)
        _this.COOKIE_LIFE_MULTIPLIER = 24 * 60 * 60 * 1000;
        _this.cacheConfig = cacheConfig;
        _this.logger = logger;
        _this.internalStorage = new MemoryStorage();
        _this.browserStorage = _this.setupBrowserStorage(_this.cacheConfig.cacheLocation);
        _this.temporaryCacheStorage = _this.setupTemporaryCacheStorage(_this.cacheConfig.cacheLocation);
        // Migrate any cache entries from older versions of MSAL.
        _this.migrateCacheEntries();
        return _this;
    }
    /**
     * Returns a window storage class implementing the IWindowStorage interface that corresponds to the configured cacheLocation.
     * @param cacheLocation
     */
    BrowserCacheManager.prototype.setupBrowserStorage = function (cacheLocation) {
        switch (cacheLocation) {
            case BrowserCacheLocation.LocalStorage:
            case BrowserCacheLocation.SessionStorage:
                try {
                    // Temporary cache items will always be stored in session storage to mitigate problems caused by multiple tabs
                    return new BrowserStorage(cacheLocation);
                }
                catch (e) {
                    this.logger.verbose(e);
                    break;
                }
        }
        this.cacheConfig.cacheLocation = BrowserCacheLocation.MemoryStorage;
        return new MemoryStorage();
    };
    /**
     *
     * @param cacheLocation
     */
    BrowserCacheManager.prototype.setupTemporaryCacheStorage = function (cacheLocation) {
        switch (cacheLocation) {
            case BrowserCacheLocation.LocalStorage:
            case BrowserCacheLocation.SessionStorage:
                try {
                    // Temporary cache items will always be stored in session storage to mitigate problems caused by multiple tabs
                    return new BrowserStorage(BrowserCacheLocation.SessionStorage);
                }
                catch (e) {
                    this.logger.verbose(e);
                    return this.internalStorage;
                }
            case BrowserCacheLocation.MemoryStorage:
            default:
                return this.internalStorage;
        }
    };
    /**
     * Migrate all old cache entries to new schema. No rollback supported.
     * @param storeAuthStateInCookie
     */
    BrowserCacheManager.prototype.migrateCacheEntries = function () {
        var _this = this;
        var idTokenKey = Constants.CACHE_PREFIX + "." + PersistentCacheKeys.ID_TOKEN;
        var clientInfoKey = Constants.CACHE_PREFIX + "." + PersistentCacheKeys.CLIENT_INFO;
        var errorKey = Constants.CACHE_PREFIX + "." + PersistentCacheKeys.ERROR;
        var errorDescKey = Constants.CACHE_PREFIX + "." + PersistentCacheKeys.ERROR_DESC;
        var idTokenValue = this.browserStorage.getItem(idTokenKey);
        var clientInfoValue = this.browserStorage.getItem(clientInfoKey);
        var errorValue = this.browserStorage.getItem(errorKey);
        var errorDescValue = this.browserStorage.getItem(errorDescKey);
        var values = [idTokenValue, clientInfoValue, errorValue, errorDescValue];
        var keysToMigrate = [PersistentCacheKeys.ID_TOKEN, PersistentCacheKeys.CLIENT_INFO, PersistentCacheKeys.ERROR, PersistentCacheKeys.ERROR_DESC];
        keysToMigrate.forEach(function (cacheKey, index) { return _this.migrateCacheEntry(cacheKey, values[index]); });
    };
    /**
     * Utility function to help with migration.
     * @param newKey
     * @param value
     * @param storeAuthStateInCookie
     */
    BrowserCacheManager.prototype.migrateCacheEntry = function (newKey, value) {
        if (value) {
            this.setTemporaryCache(newKey, value, true);
        }
    };
    /**
     * Parses passed value as JSON object, JSON.parse() will throw an error.
     * @param input
     */
    BrowserCacheManager.prototype.validateAndParseJson = function (jsonValue) {
        try {
            var parsedJson = JSON.parse(jsonValue);
            /**
             * There are edge cases in which JSON.parse will successfully parse a non-valid JSON object
             * (e.g. JSON.parse will parse an escaped string into an unescaped string), so adding a type check
             * of the parsed value is necessary in order to be certain that the string represents a valid JSON object.
             *
             */
            return (parsedJson && typeof parsedJson === "object") ? parsedJson : null;
        }
        catch (error) {
            return null;
        }
    };
    /**
     * fetches the entry from the browser storage based off the key
     * @param key
     */
    BrowserCacheManager.prototype.getItem = function (key) {
        return this.browserStorage.getItem(key);
    };
    /**
     * sets the entry in the browser storage
     * @param key
     * @param value
     */
    BrowserCacheManager.prototype.setItem = function (key, value) {
        this.browserStorage.setItem(key, value);
    };
    /**
     * fetch the account entity from the platform cache
     * @param accountKey
     */
    BrowserCacheManager.prototype.getAccount = function (accountKey) {
        var account = this.getItem(accountKey);
        if (!account) {
            return null;
        }
        var parsedAccount = this.validateAndParseJson(account);
        if (!parsedAccount || !AccountEntity.isAccountEntity(parsedAccount)) {
            return null;
        }
        return CacheManager.toObject(new AccountEntity(), parsedAccount);
    };
    /**
     * set account entity in the platform cache
     * @param key
     * @param value
     */
    BrowserCacheManager.prototype.setAccount = function (account) {
        this.logger.trace("BrowserCacheManager.setAccount called");
        var key = account.generateAccountKey();
        this.setItem(key, JSON.stringify(account));
    };
    /**
     * generates idToken entity from a string
     * @param idTokenKey
     */
    BrowserCacheManager.prototype.getIdTokenCredential = function (idTokenKey) {
        var value = this.getItem(idTokenKey);
        if (!value) {
            this.logger.trace("BrowserCacheManager.getIdTokenCredential: called, no cache hit");
            return null;
        }
        var parsedIdToken = this.validateAndParseJson(value);
        if (!parsedIdToken || !IdTokenEntity.isIdTokenEntity(parsedIdToken)) {
            this.logger.trace("BrowserCacheManager.getIdTokenCredential: called, no cache hit");
            return null;
        }
        this.logger.trace("BrowserCacheManager.getIdTokenCredential: cache hit");
        return CacheManager.toObject(new IdTokenEntity(), parsedIdToken);
    };
    /**
     * set IdToken credential to the platform cache
     * @param idToken
     */
    BrowserCacheManager.prototype.setIdTokenCredential = function (idToken) {
        this.logger.trace("BrowserCacheManager.setIdTokenCredential called");
        var idTokenKey = idToken.generateCredentialKey();
        this.setItem(idTokenKey, JSON.stringify(idToken));
    };
    /**
     * generates accessToken entity from a string
     * @param key
     */
    BrowserCacheManager.prototype.getAccessTokenCredential = function (accessTokenKey) {
        var value = this.getItem(accessTokenKey);
        if (!value) {
            this.logger.trace("BrowserCacheManager.getAccessTokenCredential: called, no cache hit");
            return null;
        }
        var parsedAccessToken = this.validateAndParseJson(value);
        if (!parsedAccessToken || !AccessTokenEntity.isAccessTokenEntity(parsedAccessToken)) {
            this.logger.trace("BrowserCacheManager.getAccessTokenCredential: called, no cache hit");
            return null;
        }
        this.logger.trace("BrowserCacheManager.getAccessTokenCredential: cache hit");
        return CacheManager.toObject(new AccessTokenEntity(), parsedAccessToken);
    };
    /**
     * set accessToken credential to the platform cache
     * @param accessToken
     */
    BrowserCacheManager.prototype.setAccessTokenCredential = function (accessToken) {
        this.logger.trace("BrowserCacheManager.setAccessTokenCredential called");
        var accessTokenKey = accessToken.generateCredentialKey();
        this.setItem(accessTokenKey, JSON.stringify(accessToken));
    };
    /**
     * generates refreshToken entity from a string
     * @param refreshTokenKey
     */
    BrowserCacheManager.prototype.getRefreshTokenCredential = function (refreshTokenKey) {
        var value = this.getItem(refreshTokenKey);
        if (!value) {
            this.logger.trace("BrowserCacheManager.getRefreshTokenCredential: called, no cache hit");
            return null;
        }
        var parsedRefreshToken = this.validateAndParseJson(value);
        if (!parsedRefreshToken || !RefreshTokenEntity.isRefreshTokenEntity(parsedRefreshToken)) {
            this.logger.trace("BrowserCacheManager.getRefreshTokenCredential: called, no cache hit");
            return null;
        }
        this.logger.trace("BrowserCacheManager.getRefreshTokenCredential: cache hit");
        return CacheManager.toObject(new RefreshTokenEntity(), parsedRefreshToken);
    };
    /**
     * set refreshToken credential to the platform cache
     * @param refreshToken
     */
    BrowserCacheManager.prototype.setRefreshTokenCredential = function (refreshToken) {
        this.logger.trace("BrowserCacheManager.setRefreshTokenCredential called");
        var refreshTokenKey = refreshToken.generateCredentialKey();
        this.setItem(refreshTokenKey, JSON.stringify(refreshToken));
    };
    /**
     * fetch appMetadata entity from the platform cache
     * @param appMetadataKey
     */
    BrowserCacheManager.prototype.getAppMetadata = function (appMetadataKey) {
        var value = this.getItem(appMetadataKey);
        if (!value) {
            this.logger.trace("BrowserCacheManager.getAppMetadata: called, no cache hit");
            return null;
        }
        var parsedMetadata = this.validateAndParseJson(value);
        if (!parsedMetadata || !AppMetadataEntity.isAppMetadataEntity(appMetadataKey, parsedMetadata)) {
            this.logger.trace("BrowserCacheManager.getAppMetadata: called, no cache hit");
            return null;
        }
        this.logger.trace("BrowserCacheManager.getAppMetadata: cache hit");
        return CacheManager.toObject(new AppMetadataEntity(), parsedMetadata);
    };
    /**
     * set appMetadata entity to the platform cache
     * @param appMetadata
     */
    BrowserCacheManager.prototype.setAppMetadata = function (appMetadata) {
        this.logger.trace("BrowserCacheManager.setAppMetadata called");
        var appMetadataKey = appMetadata.generateAppMetadataKey();
        this.setItem(appMetadataKey, JSON.stringify(appMetadata));
    };
    /**
     * fetch server telemetry entity from the platform cache
     * @param serverTelemetryKey
     */
    BrowserCacheManager.prototype.getServerTelemetry = function (serverTelemetryKey) {
        var value = this.getItem(serverTelemetryKey);
        if (!value) {
            this.logger.trace("BrowserCacheManager.getServerTelemetry: called, no cache hit");
            return null;
        }
        var parsedMetadata = this.validateAndParseJson(value);
        if (!parsedMetadata || !ServerTelemetryEntity.isServerTelemetryEntity(serverTelemetryKey, parsedMetadata)) {
            this.logger.trace("BrowserCacheManager.getServerTelemetry: called, no cache hit");
            return null;
        }
        this.logger.trace("BrowserCacheManager.getServerTelemetry: cache hit");
        return CacheManager.toObject(new ServerTelemetryEntity(), parsedMetadata);
    };
    /**
     * set server telemetry entity to the platform cache
     * @param serverTelemetryKey
     * @param serverTelemetry
     */
    BrowserCacheManager.prototype.setServerTelemetry = function (serverTelemetryKey, serverTelemetry) {
        this.logger.trace("BrowserCacheManager.setServerTelemetry called");
        this.setItem(serverTelemetryKey, JSON.stringify(serverTelemetry));
    };
    /**
     *
     */
    BrowserCacheManager.prototype.getAuthorityMetadata = function (key) {
        var value = this.internalStorage.getItem(key);
        if (!value) {
            this.logger.trace("BrowserCacheManager.getAuthorityMetadata: called, no cache hit");
            return null;
        }
        var parsedMetadata = this.validateAndParseJson(value);
        if (parsedMetadata && AuthorityMetadataEntity.isAuthorityMetadataEntity(key, parsedMetadata)) {
            this.logger.trace("BrowserCacheManager.getAuthorityMetadata: cache hit");
            return CacheManager.toObject(new AuthorityMetadataEntity(), parsedMetadata);
        }
        return null;
    };
    /**
     *
     */
    BrowserCacheManager.prototype.getAuthorityMetadataKeys = function () {
        var _this = this;
        var allKeys = this.internalStorage.getKeys();
        return allKeys.filter(function (key) {
            return _this.isAuthorityMetadata(key);
        });
    };
    /**
     *
     * @param entity
     */
    BrowserCacheManager.prototype.setAuthorityMetadata = function (key, entity) {
        this.logger.trace("BrowserCacheManager.setAuthorityMetadata called");
        this.internalStorage.setItem(key, JSON.stringify(entity));
    };
    /**
     * fetch throttling entity from the platform cache
     * @param throttlingCacheKey
     */
    BrowserCacheManager.prototype.getThrottlingCache = function (throttlingCacheKey) {
        var value = this.getItem(throttlingCacheKey);
        if (!value) {
            this.logger.trace("BrowserCacheManager.getThrottlingCache: called, no cache hit");
            return null;
        }
        var parsedThrottlingCache = this.validateAndParseJson(value);
        if (!parsedThrottlingCache || !ThrottlingEntity.isThrottlingEntity(throttlingCacheKey, parsedThrottlingCache)) {
            this.logger.trace("BrowserCacheManager.getThrottlingCache: called, no cache hit");
            return null;
        }
        this.logger.trace("BrowserCacheManager.getThrottlingCache: cache hit");
        return CacheManager.toObject(new ThrottlingEntity(), parsedThrottlingCache);
    };
    /**
     * set throttling entity to the platform cache
     * @param throttlingCacheKey
     * @param throttlingCache
     */
    BrowserCacheManager.prototype.setThrottlingCache = function (throttlingCacheKey, throttlingCache) {
        this.logger.trace("BrowserCacheManager.setThrottlingCache called");
        this.setItem(throttlingCacheKey, JSON.stringify(throttlingCache));
    };
    /**
     * Gets cache item with given key.
     * Will retrieve from cookies if storeAuthStateInCookie is set to true.
     * @param key
     */
    BrowserCacheManager.prototype.getTemporaryCache = function (cacheKey, generateKey) {
        var key = generateKey ? this.generateCacheKey(cacheKey) : cacheKey;
        if (this.cacheConfig.storeAuthStateInCookie) {
            var itemCookie = this.getItemCookie(key);
            if (itemCookie) {
                this.logger.trace("BrowserCacheManager.getTemporaryCache: storeAuthStateInCookies set to true, retrieving from cookies");
                return itemCookie;
            }
        }
        var value = this.temporaryCacheStorage.getItem(key);
        if (!value) {
            // If temp cache item not found in session/memory, check local storage for items set by old versions
            if (this.cacheConfig.cacheLocation === BrowserCacheLocation.LocalStorage) {
                var item = this.browserStorage.getItem(key);
                if (item) {
                    this.logger.trace("BrowserCacheManager.getTemporaryCache: Temporary cache item found in local storage");
                    return item;
                }
            }
            this.logger.trace("BrowserCacheManager.getTemporaryCache: No cache item found in local storage");
            return null;
        }
        this.logger.trace("BrowserCacheManager.getTemporaryCache: Temporary cache item returned");
        return value;
    };
    /**
     * Sets the cache item with the key and value given.
     * Stores in cookie if storeAuthStateInCookie is set to true.
     * This can cause cookie overflow if used incorrectly.
     * @param key
     * @param value
     */
    BrowserCacheManager.prototype.setTemporaryCache = function (cacheKey, value, generateKey) {
        var key = generateKey ? this.generateCacheKey(cacheKey) : cacheKey;
        this.temporaryCacheStorage.setItem(key, value);
        if (this.cacheConfig.storeAuthStateInCookie) {
            this.logger.trace("BrowserCacheManager.setTemporaryCache: storeAuthStateInCookie set to true, setting item cookie");
            this.setItemCookie(key, value);
        }
    };
    /**
     * Removes the cache item with the given key.
     * Will also clear the cookie item if storeAuthStateInCookie is set to true.
     * @param key
     */
    BrowserCacheManager.prototype.removeItem = function (key) {
        this.browserStorage.removeItem(key);
        this.temporaryCacheStorage.removeItem(key);
        if (this.cacheConfig.storeAuthStateInCookie) {
            this.logger.trace("BrowserCacheManager.removeItem: storeAuthStateInCookie is true, clearing item cookie");
            this.clearItemCookie(key);
        }
        return true;
    };
    /**
     * Checks whether key is in cache.
     * @param key
     */
    BrowserCacheManager.prototype.containsKey = function (key) {
        return this.browserStorage.containsKey(key) || this.temporaryCacheStorage.containsKey(key);
    };
    /**
     * Gets all keys in window.
     */
    BrowserCacheManager.prototype.getKeys = function () {
        return __spread(this.browserStorage.getKeys(), this.temporaryCacheStorage.getKeys());
    };
    /**
     * Clears all cache entries created by MSAL (except tokens).
     */
    BrowserCacheManager.prototype.clear = function () {
        var _this = this;
        this.removeAllAccounts();
        this.removeAppMetadata();
        this.getKeys().forEach(function (cacheKey) {
            // Check if key contains msal prefix; For now, we are clearing all the cache items created by MSAL.js
            if ((_this.browserStorage.containsKey(cacheKey) || _this.temporaryCacheStorage.containsKey(cacheKey)) && ((cacheKey.indexOf(Constants.CACHE_PREFIX) !== -1) || (cacheKey.indexOf(_this.clientId) !== -1))) {
                _this.removeItem(cacheKey);
            }
        });
        this.internalStorage.clear();
    };
    /**
     * Add value to cookies
     * @param cookieName
     * @param cookieValue
     * @param expires
     */
    BrowserCacheManager.prototype.setItemCookie = function (cookieName, cookieValue, expires) {
        var cookieStr = encodeURIComponent(cookieName) + "=" + encodeURIComponent(cookieValue) + ";path=/;";
        if (expires) {
            var expireTime = this.getCookieExpirationTime(expires);
            cookieStr += "expires=" + expireTime + ";";
        }
        if (this.cacheConfig.secureCookies) {
            cookieStr += "Secure;";
        }
        document.cookie = cookieStr;
    };
    /**
     * Get one item by key from cookies
     * @param cookieName
     */
    BrowserCacheManager.prototype.getItemCookie = function (cookieName) {
        var name = encodeURIComponent(cookieName) + "=";
        var cookieList = document.cookie.split(";");
        for (var i = 0; i < cookieList.length; i++) {
            var cookie = cookieList[i];
            while (cookie.charAt(0) === " ") {
                cookie = cookie.substring(1);
            }
            if (cookie.indexOf(name) === 0) {
                return decodeURIComponent(cookie.substring(name.length, cookie.length));
            }
        }
        return "";
    };
    /**
     * Clear all msal-related cookies currently set in the browser. Should only be used to clear temporary cache items.
     */
    BrowserCacheManager.prototype.clearMsalCookies = function () {
        var _this = this;
        var cookiePrefix = Constants.CACHE_PREFIX + "." + this.clientId;
        var cookieList = document.cookie.split(";");
        cookieList.forEach(function (cookie) {
            while (cookie.charAt(0) === " ") {
                // eslint-disable-next-line no-param-reassign
                cookie = cookie.substring(1);
            }
            if (cookie.indexOf(cookiePrefix) === 0) {
                var cookieKey = cookie.split("=")[0];
                _this.clearItemCookie(cookieKey);
            }
        });
    };
    /**
     * Clear an item in the cookies by key
     * @param cookieName
     */
    BrowserCacheManager.prototype.clearItemCookie = function (cookieName) {
        this.setItemCookie(cookieName, "", -1);
    };
    /**
     * Get cookie expiration time
     * @param cookieLifeDays
     */
    BrowserCacheManager.prototype.getCookieExpirationTime = function (cookieLifeDays) {
        var today = new Date();
        var expr = new Date(today.getTime() + cookieLifeDays * this.COOKIE_LIFE_MULTIPLIER);
        return expr.toUTCString();
    };
    /**
     * Gets the cache object referenced by the browser
     */
    BrowserCacheManager.prototype.getCache = function () {
        return this.browserStorage;
    };
    /**
     * interface compat, we cannot overwrite browser cache; Functionality is supported by individual entities in browser
     */
    BrowserCacheManager.prototype.setCache = function () {
        // sets nothing
    };
    /**
     * Prepend msal.<client-id> to each key; Skip for any JSON object as Key (defined schemas do not need the key appended: AccessToken Keys or the upcoming schema)
     * @param key
     * @param addInstanceId
     */
    BrowserCacheManager.prototype.generateCacheKey = function (key) {
        var generatedKey = this.validateAndParseJson(key);
        if (!generatedKey) {
            if (StringUtils.startsWith(key, Constants.CACHE_PREFIX) || StringUtils.startsWith(key, PersistentCacheKeys.ADAL_ID_TOKEN)) {
                return key;
            }
            return Constants.CACHE_PREFIX + "." + this.clientId + "." + key;
        }
        return JSON.stringify(key);
    };
    /**
     * Create authorityKey to cache authority
     * @param state
     */
    BrowserCacheManager.prototype.generateAuthorityKey = function (stateString) {
        var stateId = ProtocolUtils.parseRequestState(this.cryptoImpl, stateString).libraryState.id;
        return this.generateCacheKey(TemporaryCacheKeys.AUTHORITY + "." + stateId);
    };
    /**
     * Create Nonce key to cache nonce
     * @param state
     */
    BrowserCacheManager.prototype.generateNonceKey = function (stateString) {
        var stateId = ProtocolUtils.parseRequestState(this.cryptoImpl, stateString).libraryState.id;
        return this.generateCacheKey(TemporaryCacheKeys.NONCE_IDTOKEN + "." + stateId);
    };
    /**
     * Creates full cache key for the request state
     * @param stateString State string for the request
     */
    BrowserCacheManager.prototype.generateStateKey = function (stateString) {
        // Use the library state id to key temp storage for uniqueness for multiple concurrent requests
        var stateId = ProtocolUtils.parseRequestState(this.cryptoImpl, stateString).libraryState.id;
        return this.generateCacheKey(TemporaryCacheKeys.REQUEST_STATE + "." + stateId);
    };
    /**
     * Gets the cached authority based on the cached state. Returns empty if no cached state found.
     */
    BrowserCacheManager.prototype.getCachedAuthority = function (cachedState) {
        var stateCacheKey = this.generateStateKey(cachedState);
        var state = this.getTemporaryCache(stateCacheKey);
        if (!state) {
            return null;
        }
        var authorityCacheKey = this.generateAuthorityKey(state);
        return this.getTemporaryCache(authorityCacheKey);
    };
    /**
     * Updates account, authority, and state in cache
     * @param serverAuthenticationRequest
     * @param account
     */
    BrowserCacheManager.prototype.updateCacheEntries = function (state, nonce, authorityInstance, loginHint, account) {
        this.logger.trace("BrowserCacheManager.updateCacheEntries called");
        // Cache the request state
        var stateCacheKey = this.generateStateKey(state);
        this.setTemporaryCache(stateCacheKey, state, false);
        // Cache the nonce
        var nonceCacheKey = this.generateNonceKey(state);
        this.setTemporaryCache(nonceCacheKey, nonce, false);
        // Cache authorityKey
        var authorityCacheKey = this.generateAuthorityKey(state);
        this.setTemporaryCache(authorityCacheKey, authorityInstance, false);
        if (account) {
            var ccsCredential = {
                credential: account.homeAccountId,
                type: CcsCredentialType.HOME_ACCOUNT_ID
            };
            this.setTemporaryCache(TemporaryCacheKeys.CCS_CREDENTIAL, JSON.stringify(ccsCredential), true);
        }
        else if (!StringUtils.isEmpty(loginHint)) {
            var ccsCredential = {
                credential: loginHint,
                type: CcsCredentialType.UPN
            };
            this.setTemporaryCache(TemporaryCacheKeys.CCS_CREDENTIAL, JSON.stringify(ccsCredential), true);
        }
    };
    /**
     * Reset all temporary cache items
     * @param state
     */
    BrowserCacheManager.prototype.resetRequestCache = function (state) {
        var _this = this;
        this.logger.trace("BrowserCacheManager.resetRequestCache called");
        // check state and remove associated cache items
        if (!StringUtils.isEmpty(state)) {
            this.getKeys().forEach(function (key) {
                if (key.indexOf(state) !== -1) {
                    _this.removeItem(key);
                }
            });
        }
        // delete generic interactive request parameters
        if (state) {
            this.removeItem(this.generateStateKey(state));
            this.removeItem(this.generateNonceKey(state));
            this.removeItem(this.generateAuthorityKey(state));
        }
        this.removeItem(this.generateCacheKey(TemporaryCacheKeys.REQUEST_PARAMS));
        this.removeItem(this.generateCacheKey(TemporaryCacheKeys.ORIGIN_URI));
        this.removeItem(this.generateCacheKey(TemporaryCacheKeys.URL_HASH));
        this.removeItem(this.generateCacheKey(TemporaryCacheKeys.INTERACTION_STATUS_KEY));
        this.removeItem(this.generateCacheKey(TemporaryCacheKeys.CCS_CREDENTIAL));
    };
    /**
     * Removes temporary cache for the provided state
     * @param stateString
     */
    BrowserCacheManager.prototype.cleanRequestByState = function (stateString) {
        this.logger.trace("BrowserCacheManager.cleanRequestByState called");
        // Interaction is completed - remove interaction status.
        if (stateString) {
            var stateKey = this.generateStateKey(stateString);
            var cachedState = this.temporaryCacheStorage.getItem(stateKey);
            this.logger.infoPii("BrowserCacheManager.cleanRequestByState: Removing temporary cache items for state: " + cachedState);
            this.resetRequestCache(cachedState || "");
        }
        this.clearMsalCookies();
    };
    /**
     * Looks in temporary cache for any state values with the provided interactionType and removes all temporary cache items for that state
     * Used in scenarios where temp cache needs to be cleaned but state is not known, such as clicking browser back button.
     * @param interactionType
     */
    BrowserCacheManager.prototype.cleanRequestByInteractionType = function (interactionType) {
        var _this = this;
        this.logger.trace("BrowserCacheManager.cleanRequestByInteractionType called");
        // Loop through all keys to find state key
        this.getKeys().forEach(function (key) {
            // If this key is not the state key, move on
            if (key.indexOf(TemporaryCacheKeys.REQUEST_STATE) === -1) {
                return;
            }
            // Retrieve state value, return if not a valid value
            var stateValue = _this.temporaryCacheStorage.getItem(key);
            if (!stateValue) {
                return;
            }
            // Extract state and ensure it matches given InteractionType, then clean request cache
            var parsedState = BrowserProtocolUtils.extractBrowserRequestState(_this.cryptoImpl, stateValue);
            if (parsedState && parsedState.interactionType === interactionType) {
                _this.logger.infoPii("BrowserCacheManager.cleanRequestByInteractionType: Removing temporary cache items for state: " + stateValue);
                _this.resetRequestCache(stateValue);
            }
        });
        this.clearMsalCookies();
    };
    BrowserCacheManager.prototype.cacheCodeRequest = function (authCodeRequest, browserCrypto) {
        this.logger.trace("BrowserCacheManager.cacheCodeRequest called");
        var encodedValue = browserCrypto.base64Encode(JSON.stringify(authCodeRequest));
        this.setTemporaryCache(TemporaryCacheKeys.REQUEST_PARAMS, encodedValue, true);
    };
    /**
     * Gets the token exchange parameters from the cache. Throws an error if nothing is found.
     */
    BrowserCacheManager.prototype.getCachedRequest = function (state, browserCrypto) {
        this.logger.trace("BrowserCacheManager.getCachedRequest called");
        // Get token request from cache and parse as TokenExchangeParameters.
        var encodedTokenRequest = this.getTemporaryCache(TemporaryCacheKeys.REQUEST_PARAMS, true);
        if (!encodedTokenRequest) {
            throw BrowserAuthError.createNoTokenRequestCacheError();
        }
        var parsedRequest = this.validateAndParseJson(browserCrypto.base64Decode(encodedTokenRequest));
        if (!parsedRequest) {
            throw BrowserAuthError.createUnableToParseTokenRequestCacheError();
        }
        this.removeItem(this.generateCacheKey(TemporaryCacheKeys.REQUEST_PARAMS));
        // Get cached authority and use if no authority is cached with request.
        if (StringUtils.isEmpty(parsedRequest.authority)) {
            var authorityCacheKey = this.generateAuthorityKey(state);
            var cachedAuthority = this.getTemporaryCache(authorityCacheKey);
            if (!cachedAuthority) {
                throw BrowserAuthError.createNoCachedAuthorityError();
            }
            parsedRequest.authority = cachedAuthority;
        }
        return parsedRequest;
    };
    return BrowserCacheManager;
}(CacheManager));
var DEFAULT_BROWSER_CACHE_MANAGER = function (clientId, logger) {
    var cacheOptions = {
        cacheLocation: BrowserCacheLocation.MemoryStorage,
        storeAuthStateInCookie: false,
        secureCookies: false
    };
    return new BrowserCacheManager(clientId, cacheOptions, DEFAULT_CRYPTO_IMPLEMENTATION, logger);
};

/*! @azure/msal-browser v2.15.0 2021-06-29 */

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * This class implements the Fetch API for GET and POST requests. See more here: https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API
 */
var FetchClient = /** @class */ (function () {
    function FetchClient() {
    }
    /**
     * Fetch Client for REST endpoints - Get request
     * @param url
     * @param headers
     * @param body
     */
    FetchClient.prototype.sendGetRequestAsync = function (url, options) {
        return __awaiter$1(this, void 0, void 0, function () {
            var response, e_1, _a;
            return __generator$1(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, fetch(url, {
                                method: HTTP_REQUEST_TYPE.GET,
                                headers: this.getFetchHeaders(options)
                            })];
                    case 1:
                        response = _b.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _b.sent();
                        if (window.navigator.onLine) {
                            throw BrowserAuthError.createGetRequestFailedError(e_1, url);
                        }
                        else {
                            throw BrowserAuthError.createNoNetworkConnectivityError();
                        }
                    case 3:
                        _b.trys.push([3, 5, , 6]);
                        _a = {
                            headers: this.getHeaderDict(response.headers)
                        };
                        return [4 /*yield*/, response.json()];
                    case 4: return [2 /*return*/, (_a.body = (_b.sent()),
                            _a.status = response.status,
                            _a)];
                    case 5:
                        _b.sent();
                        throw BrowserAuthError.createFailedToParseNetworkResponseError(url);
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Fetch Client for REST endpoints - Post request
     * @param url
     * @param headers
     * @param body
     */
    FetchClient.prototype.sendPostRequestAsync = function (url, options) {
        return __awaiter$1(this, void 0, void 0, function () {
            var reqBody, response, e_3, _a;
            return __generator$1(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        reqBody = (options && options.body) || "";
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, fetch(url, {
                                method: HTTP_REQUEST_TYPE.POST,
                                headers: this.getFetchHeaders(options),
                                body: reqBody
                            })];
                    case 2:
                        response = _b.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_3 = _b.sent();
                        if (window.navigator.onLine) {
                            throw BrowserAuthError.createPostRequestFailedError(e_3, url);
                        }
                        else {
                            throw BrowserAuthError.createNoNetworkConnectivityError();
                        }
                    case 4:
                        _b.trys.push([4, 6, , 7]);
                        _a = {
                            headers: this.getHeaderDict(response.headers)
                        };
                        return [4 /*yield*/, response.json()];
                    case 5: return [2 /*return*/, (_a.body = (_b.sent()),
                            _a.status = response.status,
                            _a)];
                    case 6:
                        _b.sent();
                        throw BrowserAuthError.createFailedToParseNetworkResponseError(url);
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Get Fetch API Headers object from string map
     * @param inputHeaders
     */
    FetchClient.prototype.getFetchHeaders = function (options) {
        var headers = new Headers();
        if (!(options && options.headers)) {
            return headers;
        }
        var optionsHeaders = options.headers;
        Object.keys(optionsHeaders).forEach(function (key) {
            headers.append(key, optionsHeaders[key]);
        });
        return headers;
    };
    FetchClient.prototype.getHeaderDict = function (headers) {
        var headerDict = {};
        headers.forEach(function (value, key) {
            headerDict[key] = value;
        });
        return headerDict;
    };
    return FetchClient;
}());

/*! @azure/msal-browser v2.15.0 2021-06-29 */

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * This client implements the XMLHttpRequest class to send GET and POST requests.
 */
var XhrClient = /** @class */ (function () {
    function XhrClient() {
    }
    /**
     * XhrClient for REST endpoints - Get request
     * @param url
     * @param headers
     * @param body
     */
    XhrClient.prototype.sendGetRequestAsync = function (url, options) {
        return __awaiter$1(this, void 0, void 0, function () {
            return __generator$1(this, function (_a) {
                return [2 /*return*/, this.sendRequestAsync(url, HTTP_REQUEST_TYPE.GET, options)];
            });
        });
    };
    /**
     * XhrClient for REST endpoints - Post request
     * @param url
     * @param headers
     * @param body
     */
    XhrClient.prototype.sendPostRequestAsync = function (url, options) {
        return __awaiter$1(this, void 0, void 0, function () {
            return __generator$1(this, function (_a) {
                return [2 /*return*/, this.sendRequestAsync(url, HTTP_REQUEST_TYPE.POST, options)];
            });
        });
    };
    /**
     * Helper for XhrClient requests.
     * @param url
     * @param method
     * @param options
     */
    XhrClient.prototype.sendRequestAsync = function (url, method, options) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var xhr = new XMLHttpRequest();
            xhr.open(method, url, /* async: */ true);
            _this.setXhrHeaders(xhr, options);
            xhr.onload = function () {
                if (xhr.status < 200 || xhr.status >= 300) {
                    if (method === HTTP_REQUEST_TYPE.POST) {
                        reject(BrowserAuthError.createPostRequestFailedError("Failed with status " + xhr.status, url));
                    }
                    else {
                        reject(BrowserAuthError.createGetRequestFailedError("Failed with status " + xhr.status, url));
                    }
                }
                try {
                    var jsonResponse = JSON.parse(xhr.responseText);
                    var networkResponse = {
                        headers: _this.getHeaderDict(xhr),
                        body: jsonResponse,
                        status: xhr.status
                    };
                    resolve(networkResponse);
                }
                catch (e) {
                    reject(BrowserAuthError.createFailedToParseNetworkResponseError(url));
                }
            };
            xhr.onerror = function () {
                if (window.navigator.onLine) {
                    if (method === HTTP_REQUEST_TYPE.POST) {
                        reject(BrowserAuthError.createPostRequestFailedError("Failed with status " + xhr.status, url));
                    }
                    else {
                        reject(BrowserAuthError.createGetRequestFailedError("Failed with status " + xhr.status, url));
                    }
                }
                else {
                    reject(BrowserAuthError.createNoNetworkConnectivityError());
                }
            };
            if (method === HTTP_REQUEST_TYPE.POST && options && options.body) {
                xhr.send(options.body);
            }
            else if (method === HTTP_REQUEST_TYPE.GET) {
                xhr.send();
            }
            else {
                throw BrowserAuthError.createHttpMethodNotImplementedError(method);
            }
        });
    };
    /**
     * Helper to set XHR headers for request.
     * @param xhr
     * @param options
     */
    XhrClient.prototype.setXhrHeaders = function (xhr, options) {
        if (options && options.headers) {
            var headers_1 = options.headers;
            Object.keys(headers_1).forEach(function (key) {
                xhr.setRequestHeader(key, headers_1[key]);
            });
        }
    };
    /**
     * Gets a string map of the headers received in the response.
     *
     * Algorithm comes from https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/getAllResponseHeaders
     * @param xhr
     */
    XhrClient.prototype.getHeaderDict = function (xhr) {
        var headerString = xhr.getAllResponseHeaders();
        var headerArr = headerString.trim().split(/[\r\n]+/);
        var headerDict = {};
        headerArr.forEach(function (value) {
            var parts = value.split(": ");
            var headerName = parts.shift();
            var headerVal = parts.join(": ");
            if (headerName && headerVal) {
                headerDict[headerName] = headerVal;
            }
        });
        return headerDict;
    };
    return XhrClient;
}());

/*! @azure/msal-browser v2.15.0 2021-06-29 */

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * Utility class for browser specific functions
 */
var BrowserUtils = /** @class */ (function () {
    function BrowserUtils() {
    }
    // #region Window Navigation and URL management
    /**
     * Clears hash from window url.
     */
    BrowserUtils.clearHash = function (contentWindow) {
        // Office.js sets history.replaceState to null
        contentWindow.location.hash = Constants.EMPTY_STRING;
        if (typeof contentWindow.history.replaceState === "function") {
            // Full removes "#" from url
            contentWindow.history.replaceState(null, Constants.EMPTY_STRING, "" + contentWindow.location.pathname + contentWindow.location.search);
        }
    };
    /**
     * Replaces current hash with hash from provided url
     */
    BrowserUtils.replaceHash = function (url) {
        var urlParts = url.split("#");
        urlParts.shift(); // Remove part before the hash
        window.location.hash = urlParts.length > 0 ? urlParts.join("#") : "";
    };
    /**
     * Returns boolean of whether the current window is in an iframe or not.
     */
    BrowserUtils.isInIframe = function () {
        return window.parent !== window;
    };
    // #endregion
    /**
     * Returns current window URL as redirect uri
     */
    BrowserUtils.getCurrentUri = function () {
        return window.location.href.split("?")[0].split("#")[0];
    };
    /**
     * Gets the homepage url for the current window location.
     */
    BrowserUtils.getHomepage = function () {
        var currentUrl = new UrlString(window.location.href);
        var urlComponents = currentUrl.getUrlComponents();
        return urlComponents.Protocol + "//" + urlComponents.HostNameAndPort + "/";
    };
    /**
     * Returns best compatible network client object.
     */
    BrowserUtils.getBrowserNetworkClient = function () {
        if (window.fetch && window.Headers) {
            return new FetchClient();
        }
        else {
            return new XhrClient();
        }
    };
    /**
     * Throws error if we have completed an auth and are
     * attempting another auth request inside an iframe.
     */
    BrowserUtils.blockReloadInHiddenIframes = function () {
        var isResponseHash = UrlString.hashContainsKnownProperties(window.location.hash);
        // return an error if called from the hidden iframe created by the msal js silent calls
        if (isResponseHash && BrowserUtils.isInIframe()) {
            throw BrowserAuthError.createBlockReloadInHiddenIframeError();
        }
    };
    /**
     * Block redirect operations in iframes unless explicitly allowed
     * @param interactionType Interaction type for the request
     * @param allowRedirectInIframe Config value to allow redirects when app is inside an iframe
     */
    BrowserUtils.blockRedirectInIframe = function (interactionType, allowRedirectInIframe) {
        var isIframedApp = BrowserUtils.isInIframe();
        if (interactionType === InteractionType.Redirect && isIframedApp && !allowRedirectInIframe) {
            // If we are not in top frame, we shouldn't redirect. This is also handled by the service.
            throw BrowserAuthError.createRedirectInIframeError(isIframedApp);
        }
    };
    /**
     * Block redirectUri loaded in popup from calling AcquireToken APIs
     */
    BrowserUtils.blockAcquireTokenInPopups = function () {
        // Popups opened by msal popup APIs are given a name that starts with "msal."
        if (window.opener && window.opener !== window && typeof window.name === "string" && window.name.indexOf(BrowserConstants.POPUP_NAME_PREFIX + ".") === 0) {
            throw BrowserAuthError.createBlockAcquireTokenInPopupsError();
        }
    };
    /**
     * Throws error if token requests are made in non-browser environment
     * @param isBrowserEnvironment Flag indicating if environment is a browser.
     */
    BrowserUtils.blockNonBrowserEnvironment = function (isBrowserEnvironment) {
        if (!isBrowserEnvironment) {
            throw BrowserAuthError.createNonBrowserEnvironmentError();
        }
    };
    /**
     * Returns boolean of whether current browser is an Internet Explorer or Edge browser.
     */
    BrowserUtils.detectIEOrEdge = function () {
        var ua = window.navigator.userAgent;
        var msie = ua.indexOf("MSIE ");
        var msie11 = ua.indexOf("Trident/");
        var msedge = ua.indexOf("Edge/");
        var isIE = msie > 0 || msie11 > 0;
        var isEdge = msedge > 0;
        return isIE || isEdge;
    };
    return BrowserUtils;
}());

/*! @azure/msal-browser v2.15.0 2021-06-29 */
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
var NavigationClient = /** @class */ (function () {
    function NavigationClient() {
    }
    /**
     * Navigates to other pages within the same web application
     * @param url
     * @param options
     */
    NavigationClient.prototype.navigateInternal = function (url, options) {
        return NavigationClient.defaultNavigateWindow(url, options);
    };
    /**
     * Navigates to other pages outside the web application i.e. the Identity Provider
     * @param url
     * @param options
     */
    NavigationClient.prototype.navigateExternal = function (url, options) {
        return NavigationClient.defaultNavigateWindow(url, options);
    };
    /**
     * Default navigation implementation invoked by the internal and external functions
     * @param url
     * @param options
     */
    NavigationClient.defaultNavigateWindow = function (url, options) {
        if (options.noHistory) {
            window.location.replace(url);
        }
        else {
            window.location.assign(url);
        }
        return new Promise(function (resolve) {
            setTimeout(function () {
                resolve(true);
            }, options.timeout);
        });
    };
    return NavigationClient;
}());

/*! @azure/msal-browser v2.15.0 2021-06-29 */

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
// Default timeout for popup windows and iframes in milliseconds
var DEFAULT_POPUP_TIMEOUT_MS = 60000;
var DEFAULT_IFRAME_TIMEOUT_MS = 6000;
var DEFAULT_REDIRECT_TIMEOUT_MS = 30000;
/**
 * MSAL function that sets the default options when not explicitly configured from app developer
 *
 * @param auth
 * @param cache
 * @param system
 *
 * @returns Configuration object
 */
function buildConfiguration(_a, isBrowserEnvironment) {
    var userInputAuth = _a.auth, userInputCache = _a.cache, userInputSystem = _a.system;
    // Default auth options for browser
    var DEFAULT_AUTH_OPTIONS = {
        clientId: "",
        authority: "" + Constants.DEFAULT_AUTHORITY,
        knownAuthorities: [],
        cloudDiscoveryMetadata: "",
        authorityMetadata: "",
        redirectUri: "",
        postLogoutRedirectUri: "",
        navigateToLoginRequestUrl: true,
        clientCapabilities: [],
        protocolMode: ProtocolMode.AAD
    };
    // Default cache options for browser
    var DEFAULT_CACHE_OPTIONS = {
        cacheLocation: BrowserCacheLocation.SessionStorage,
        storeAuthStateInCookie: false,
        secureCookies: false
    };
    // Default logger options for browser
    var DEFAULT_LOGGER_OPTIONS = {
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        loggerCallback: function () { },
        logLevel: LogLevel$1.Info,
        piiLoggingEnabled: false
    };
    // Default system options for browser
    var DEFAULT_BROWSER_SYSTEM_OPTIONS = __assign$1(__assign$1({}, DEFAULT_SYSTEM_OPTIONS), { loggerOptions: DEFAULT_LOGGER_OPTIONS, networkClient: isBrowserEnvironment ? BrowserUtils.getBrowserNetworkClient() : StubbedNetworkModule, navigationClient: new NavigationClient(), loadFrameTimeout: 0, 
        // If loadFrameTimeout is provided, use that as default.
        windowHashTimeout: (userInputSystem && userInputSystem.loadFrameTimeout) || DEFAULT_POPUP_TIMEOUT_MS, iframeHashTimeout: (userInputSystem && userInputSystem.loadFrameTimeout) || DEFAULT_IFRAME_TIMEOUT_MS, navigateFrameWait: isBrowserEnvironment && BrowserUtils.detectIEOrEdge() ? 500 : 0, redirectNavigationTimeout: DEFAULT_REDIRECT_TIMEOUT_MS, asyncPopups: false, allowRedirectInIframe: false });
    var overlayedConfig = {
        auth: __assign$1(__assign$1({}, DEFAULT_AUTH_OPTIONS), userInputAuth),
        cache: __assign$1(__assign$1({}, DEFAULT_CACHE_OPTIONS), userInputCache),
        system: __assign$1(__assign$1({}, DEFAULT_BROWSER_SYSTEM_OPTIONS), userInputSystem)
    };
    return overlayedConfig;
}

/*! @azure/msal-browser v2.15.0 2021-06-29 */

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * Abstract class which defines operations for a browser interaction handling class.
 */
var InteractionHandler = /** @class */ (function () {
    function InteractionHandler(authCodeModule, storageImpl, authCodeRequest, browserRequestLogger) {
        this.authModule = authCodeModule;
        this.browserStorage = storageImpl;
        this.authCodeRequest = authCodeRequest;
        this.browserRequestLogger = browserRequestLogger;
    }
    /**
     * Function to handle response parameters from hash.
     * @param locationHash
     */
    InteractionHandler.prototype.handleCodeResponse = function (locationHash, state, authority, networkModule) {
        return __awaiter$1(this, void 0, void 0, function () {
            var stateKey, requestState, authCodeResponse, nonceKey, cachedNonce, cachedCcsCred, tokenResponse;
            return __generator$1(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.browserRequestLogger.verbose("InteractionHandler.handleCodeResponse called");
                        // Check that location hash isn't empty.
                        if (StringUtils.isEmpty(locationHash)) {
                            throw BrowserAuthError.createEmptyHashError(locationHash);
                        }
                        stateKey = this.browserStorage.generateStateKey(state);
                        requestState = this.browserStorage.getTemporaryCache(stateKey);
                        if (!requestState) {
                            throw ClientAuthError.createStateNotFoundError("Cached State");
                        }
                        authCodeResponse = this.authModule.handleFragmentResponse(locationHash, requestState);
                        nonceKey = this.browserStorage.generateNonceKey(requestState);
                        cachedNonce = this.browserStorage.getTemporaryCache(nonceKey);
                        // Assign code to request
                        this.authCodeRequest.code = authCodeResponse.code;
                        if (!authCodeResponse.cloud_instance_host_name) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.updateTokenEndpointAuthority(authCodeResponse.cloud_instance_host_name, authority, networkModule)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        authCodeResponse.nonce = cachedNonce || undefined;
                        authCodeResponse.state = requestState;
                        // Add CCS parameters if available
                        if (authCodeResponse.client_info) {
                            this.authCodeRequest.clientInfo = authCodeResponse.client_info;
                        }
                        else {
                            cachedCcsCred = this.checkCcsCredentials();
                            if (cachedCcsCred) {
                                this.authCodeRequest.ccsCredential = cachedCcsCred;
                            }
                        }
                        return [4 /*yield*/, this.authModule.acquireToken(this.authCodeRequest, authCodeResponse)];
                    case 3:
                        tokenResponse = _a.sent();
                        this.browserStorage.cleanRequestByState(state);
                        return [2 /*return*/, tokenResponse];
                }
            });
        });
    };
    /**
     * Updates authority based on cloudInstanceHostname
     * @param cloudInstanceHostname
     * @param authority
     * @param networkModule
     */
    InteractionHandler.prototype.updateTokenEndpointAuthority = function (cloudInstanceHostname, authority, networkModule) {
        return __awaiter$1(this, void 0, void 0, function () {
            var cloudInstanceAuthorityUri, cloudInstanceAuthority;
            return __generator$1(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        cloudInstanceAuthorityUri = "https://" + cloudInstanceHostname + "/" + authority.tenant + "/";
                        return [4 /*yield*/, AuthorityFactory.createDiscoveredInstance(cloudInstanceAuthorityUri, networkModule, this.browserStorage, authority.options)];
                    case 1:
                        cloudInstanceAuthority = _a.sent();
                        this.authModule.updateAuthority(cloudInstanceAuthority);
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Looks up ccs creds in the cache
     */
    InteractionHandler.prototype.checkCcsCredentials = function () {
        // Look up ccs credential in temp cache
        var cachedCcsCred = this.browserStorage.getTemporaryCache(TemporaryCacheKeys.CCS_CREDENTIAL, true);
        if (cachedCcsCred) {
            try {
                return JSON.parse(cachedCcsCred);
            }
            catch (e) {
                this.authModule.logger.error("Cache credential could not be parsed");
                this.authModule.logger.errorPii("Cache credential could not be parsed: " + cachedCcsCred);
            }
        }
        return null;
    };
    return InteractionHandler;
}());

/*! @azure/msal-browser v2.15.0 2021-06-29 */

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
var RedirectHandler = /** @class */ (function (_super) {
    __extends$1(RedirectHandler, _super);
    function RedirectHandler(authCodeModule, storageImpl, authCodeRequest, browserRequestLogger, browserCrypto) {
        var _this = _super.call(this, authCodeModule, storageImpl, authCodeRequest, browserRequestLogger) || this;
        _this.browserCrypto = browserCrypto;
        return _this;
    }
    /**
     * Redirects window to given URL.
     * @param urlNavigate
     */
    RedirectHandler.prototype.initiateAuthRequest = function (requestUrl, params) {
        return __awaiter$1(this, void 0, void 0, function () {
            var navigationOptions, navigate;
            return __generator$1(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.browserRequestLogger.verbose("RedirectHandler.initiateAuthRequest called");
                        if (!!StringUtils.isEmpty(requestUrl)) return [3 /*break*/, 7];
                        // Cache start page, returns to this page after redirectUri if navigateToLoginRequestUrl is true
                        if (params.redirectStartPage) {
                            this.browserRequestLogger.verbose("RedirectHandler.initiateAuthRequest: redirectStartPage set, caching start page");
                            this.browserStorage.setTemporaryCache(TemporaryCacheKeys.ORIGIN_URI, params.redirectStartPage, true);
                        }
                        // Set interaction status in the library.
                        this.browserStorage.setTemporaryCache(TemporaryCacheKeys.INTERACTION_STATUS_KEY, BrowserConstants.INTERACTION_IN_PROGRESS_VALUE, true);
                        this.browserStorage.cacheCodeRequest(this.authCodeRequest, this.browserCrypto);
                        this.browserRequestLogger.infoPii("RedirectHandler.initiateAuthRequest: Navigate to: " + requestUrl);
                        navigationOptions = {
                            apiId: ApiId.acquireTokenRedirect,
                            timeout: params.redirectTimeout,
                            noHistory: false
                        };
                        if (!(typeof params.onRedirectNavigate === "function")) return [3 /*break*/, 4];
                        this.browserRequestLogger.verbose("RedirectHandler.initiateAuthRequest: Invoking onRedirectNavigate callback");
                        navigate = params.onRedirectNavigate(requestUrl);
                        if (!(navigate !== false)) return [3 /*break*/, 2];
                        this.browserRequestLogger.verbose("RedirectHandler.initiateAuthRequest: onRedirectNavigate did not return false, navigating");
                        return [4 /*yield*/, params.navigationClient.navigateExternal(requestUrl, navigationOptions)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                    case 2:
                        this.browserRequestLogger.verbose("RedirectHandler.initiateAuthRequest: onRedirectNavigate returned false, stopping navigation");
                        return [2 /*return*/];
                    case 3: return [3 /*break*/, 6];
                    case 4:
                        // Navigate window to request URL
                        this.browserRequestLogger.verbose("RedirectHandler.initiateAuthRequest: Navigating window to navigate url");
                        return [4 /*yield*/, params.navigationClient.navigateExternal(requestUrl, navigationOptions)];
                    case 5:
                        _a.sent();
                        return [2 /*return*/];
                    case 6: return [3 /*break*/, 8];
                    case 7:
                        // Throw error if request URL is empty.
                        this.browserRequestLogger.info("RedirectHandler.initiateAuthRequest: Navigate url is empty");
                        throw BrowserAuthError.createEmptyNavigationUriError();
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Handle authorization code response in the window.
     * @param hash
     */
    RedirectHandler.prototype.handleCodeResponse = function (locationHash, state, authority, networkModule, clientId) {
        return __awaiter$1(this, void 0, void 0, function () {
            var stateKey, requestState, authCodeResponse, nonceKey, cachedNonce, cachedCcsCred, tokenResponse;
            return __generator$1(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.browserRequestLogger.verbose("RedirectHandler.handleCodeResponse called");
                        // Check that location hash isn't empty.
                        if (StringUtils.isEmpty(locationHash)) {
                            throw BrowserAuthError.createEmptyHashError(locationHash);
                        }
                        // Interaction is completed - remove interaction status.
                        this.browserStorage.removeItem(this.browserStorage.generateCacheKey(TemporaryCacheKeys.INTERACTION_STATUS_KEY));
                        stateKey = this.browserStorage.generateStateKey(state);
                        requestState = this.browserStorage.getTemporaryCache(stateKey);
                        if (!requestState) {
                            throw ClientAuthError.createStateNotFoundError("Cached State");
                        }
                        authCodeResponse = this.authModule.handleFragmentResponse(locationHash, requestState);
                        nonceKey = this.browserStorage.generateNonceKey(requestState);
                        cachedNonce = this.browserStorage.getTemporaryCache(nonceKey);
                        // Assign code to request
                        this.authCodeRequest.code = authCodeResponse.code;
                        if (!authCodeResponse.cloud_instance_host_name) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.updateTokenEndpointAuthority(authCodeResponse.cloud_instance_host_name, authority, networkModule)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        authCodeResponse.nonce = cachedNonce || undefined;
                        authCodeResponse.state = requestState;
                        // Add CCS parameters if available
                        if (authCodeResponse.client_info) {
                            this.authCodeRequest.clientInfo = authCodeResponse.client_info;
                        }
                        else {
                            cachedCcsCred = this.checkCcsCredentials();
                            if (cachedCcsCred) {
                                this.authCodeRequest.ccsCredential = cachedCcsCred;
                            }
                        }
                        // Remove throttle if it exists
                        if (clientId) {
                            ThrottlingUtils.removeThrottle(this.browserStorage, clientId, this.authCodeRequest.authority, this.authCodeRequest.scopes);
                        }
                        return [4 /*yield*/, this.authModule.acquireToken(this.authCodeRequest, authCodeResponse)];
                    case 3:
                        tokenResponse = _a.sent();
                        this.browserStorage.cleanRequestByState(state);
                        return [2 /*return*/, tokenResponse];
                }
            });
        });
    };
    return RedirectHandler;
}(InteractionHandler));

/*! @azure/msal-browser v2.15.0 2021-06-29 */

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
var PopupUtils = /** @class */ (function () {
    function PopupUtils(storageImpl, logger) {
        this.browserStorage = storageImpl;
        this.logger = logger;
        // Properly sets this reference for the unload event.
        this.unloadWindow = this.unloadWindow.bind(this);
    }
    /**
     * @hidden
     *
     * Configures popup window for login.
     *
     * @param urlNavigate
     * @param title
     * @param popUpWidth
     * @param popUpHeight
     * @ignore
     * @hidden
     */
    PopupUtils.prototype.openPopup = function (urlNavigate, popupName, popup) {
        try {
            var popupWindow = void 0;
            // Popup window passed in, setting url to navigate to
            if (popup) {
                popupWindow = popup;
                this.logger.verbosePii("Navigating popup window to: " + urlNavigate);
                popupWindow.location.assign(urlNavigate);
            }
            else if (typeof popup === "undefined") {
                // Popup will be undefined if it was not passed in
                this.logger.verbosePii("Opening popup window to: " + urlNavigate);
                popupWindow = PopupUtils.openSizedPopup(urlNavigate, popupName);
            }
            // Popup will be null if popups are blocked
            if (!popupWindow) {
                throw BrowserAuthError.createEmptyWindowCreatedError();
            }
            if (popupWindow.focus) {
                popupWindow.focus();
            }
            this.currentWindow = popupWindow;
            window.addEventListener("beforeunload", this.unloadWindow);
            return popupWindow;
        }
        catch (e) {
            this.logger.error("error opening popup " + e.message);
            this.browserStorage.removeItem(this.browserStorage.generateCacheKey(TemporaryCacheKeys.INTERACTION_STATUS_KEY));
            throw BrowserAuthError.createPopupWindowError(e.toString());
        }
    };
    PopupUtils.openSizedPopup = function (urlNavigate, popupName) {
        /**
         * adding winLeft and winTop to account for dual monitor
         * using screenLeft and screenTop for IE8 and earlier
         */
        var winLeft = window.screenLeft ? window.screenLeft : window.screenX;
        var winTop = window.screenTop ? window.screenTop : window.screenY;
        /**
         * window.innerWidth displays browser window"s height and width excluding toolbars
         * using document.documentElement.clientWidth for IE8 and earlier
         */
        var width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        var height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
        var left = Math.max(0, ((width / 2) - (BrowserConstants.POPUP_WIDTH / 2)) + winLeft);
        var top = Math.max(0, ((height / 2) - (BrowserConstants.POPUP_HEIGHT / 2)) + winTop);
        return window.open(urlNavigate, popupName, "width=" + BrowserConstants.POPUP_WIDTH + ", height=" + BrowserConstants.POPUP_HEIGHT + ", top=" + top + ", left=" + left + ", scrollbars=yes");
    };
    /**
     * Event callback to unload main window.
     */
    PopupUtils.prototype.unloadWindow = function (e) {
        this.browserStorage.cleanRequestByInteractionType(InteractionType.Popup);
        if (this.currentWindow) {
            this.currentWindow.close();
        }
        // Guarantees browser unload will happen, so no other errors will be thrown.
        e.preventDefault();
    };
    /**
     * Closes popup, removes any state vars created during popup calls.
     * @param popupWindow
     */
    PopupUtils.prototype.cleanPopup = function (popupWindow) {
        if (popupWindow) {
            // Close window.
            popupWindow.close();
        }
        // Remove window unload function
        window.removeEventListener("beforeunload", this.unloadWindow);
        // Interaction is completed - remove interaction status.
        this.browserStorage.removeItem(this.browserStorage.generateCacheKey(TemporaryCacheKeys.INTERACTION_STATUS_KEY));
    };
    /**
     * Monitors a window until it loads a url with the same origin.
     * @param popupWindow - window that is being monitored
     */
    PopupUtils.prototype.monitorPopupForSameOrigin = function (popupWindow) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var intervalId = setInterval(function () {
                if (popupWindow.closed) {
                    // Window is closed
                    _this.cleanPopup();
                    clearInterval(intervalId);
                    reject(BrowserAuthError.createUserCancelledError());
                    return;
                }
                var href = Constants.EMPTY_STRING;
                try {
                    /*
                     * Will throw if cross origin,
                     * which should be caught and ignored
                     * since we need the interval to keep running while on STS UI.
                     */
                    href = popupWindow.location.href;
                }
                catch (e) { }
                // Don't process blank pages or cross domain
                if (StringUtils.isEmpty(href) || href === "about:blank") {
                    return;
                }
                clearInterval(intervalId);
                resolve();
            }, BrowserConstants.POLL_INTERVAL_MS);
        });
    };
    /**
     * Generates the name for the popup based on the client id and request
     * @param clientId
     * @param request
     */
    PopupUtils.generatePopupName = function (clientId, request) {
        return BrowserConstants.POPUP_NAME_PREFIX + "." + clientId + "." + request.scopes.join("-") + "." + request.authority + "." + request.correlationId;
    };
    /**
     * Generates the name for the popup based on the client id and request for logouts
     * @param clientId
     * @param request
     */
    PopupUtils.generateLogoutPopupName = function (clientId, request) {
        var homeAccountId = request.account && request.account.homeAccountId;
        return BrowserConstants.POPUP_NAME_PREFIX + "." + clientId + "." + homeAccountId + "." + request.correlationId;
    };
    return PopupUtils;
}());

/*! @azure/msal-browser v2.15.0 2021-06-29 */

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * This class implements the interaction handler base class for browsers. It is written specifically for handling
 * popup window scenarios. It includes functions for monitoring the popup window for a hash.
 */
var PopupHandler = /** @class */ (function (_super) {
    __extends$1(PopupHandler, _super);
    function PopupHandler(authCodeModule, storageImpl, authCodeRequest, browserRequestLogger) {
        var _this = _super.call(this, authCodeModule, storageImpl, authCodeRequest, browserRequestLogger) || this;
        // Properly sets this reference for the unload event.
        _this.popupUtils = new PopupUtils(storageImpl, browserRequestLogger);
        return _this;
    }
    /**
     * Opens a popup window with given request Url.
     * @param requestUrl
     */
    PopupHandler.prototype.initiateAuthRequest = function (requestUrl, params) {
        // Check that request url is not empty.
        if (!StringUtils.isEmpty(requestUrl)) {
            // Set interaction status in the library.
            this.browserStorage.setTemporaryCache(TemporaryCacheKeys.INTERACTION_STATUS_KEY, BrowserConstants.INTERACTION_IN_PROGRESS_VALUE, true);
            this.browserRequestLogger.infoPii("Navigate to: " + requestUrl);
            // Open the popup window to requestUrl.
            return this.popupUtils.openPopup(requestUrl, params.popupName, params.popup);
        }
        else {
            // Throw error if request URL is empty.
            this.browserRequestLogger.error("Navigate url is empty");
            throw BrowserAuthError.createEmptyNavigationUriError();
        }
    };
    /**
     * Monitors a window until it loads a url with a known hash, or hits a specified timeout.
     * @param popupWindow - window that is being monitored
     * @param timeout - milliseconds until timeout
     */
    PopupHandler.prototype.monitorPopupForHash = function (popupWindow) {
        var _this = this;
        return this.popupUtils.monitorPopupForSameOrigin(popupWindow).then(function () {
            var contentHash = popupWindow.location.hash;
            BrowserUtils.clearHash(popupWindow);
            _this.popupUtils.cleanPopup(popupWindow);
            if (!contentHash) {
                throw BrowserAuthError.createEmptyHashError(popupWindow.location.href);
            }
            if (UrlString.hashContainsKnownProperties(contentHash)) {
                return contentHash;
            }
            else {
                throw BrowserAuthError.createHashDoesNotContainKnownPropertiesError();
            }
        });
    };
    return PopupHandler;
}(InteractionHandler));

/*! @azure/msal-browser v2.15.0 2021-06-29 */

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
var SilentHandler = /** @class */ (function (_super) {
    __extends$1(SilentHandler, _super);
    function SilentHandler(authCodeModule, storageImpl, authCodeRequest, browserRequestLogger, navigateFrameWait) {
        var _this = _super.call(this, authCodeModule, storageImpl, authCodeRequest, browserRequestLogger) || this;
        _this.navigateFrameWait = navigateFrameWait;
        return _this;
    }
    /**
     * Creates a hidden iframe to given URL using user-requested scopes as an id.
     * @param urlNavigate
     * @param userRequestScopes
     */
    SilentHandler.prototype.initiateAuthRequest = function (requestUrl) {
        return __awaiter$1(this, void 0, void 0, function () {
            var _a;
            return __generator$1(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (StringUtils.isEmpty(requestUrl)) {
                            // Throw error if request URL is empty.
                            this.browserRequestLogger.info("Navigate url is empty");
                            throw BrowserAuthError.createEmptyNavigationUriError();
                        }
                        if (!this.navigateFrameWait) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.loadFrame(requestUrl)];
                    case 1:
                        _a = _b.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        _a = this.loadFrameSync(requestUrl);
                        _b.label = 3;
                    case 3: return [2 /*return*/, _a];
                }
            });
        });
    };
    /**
     * Monitors an iframe content window until it loads a url with a known hash, or hits a specified timeout.
     * @param iframe
     * @param timeout
     */
    SilentHandler.prototype.monitorIframeForHash = function (iframe, timeout) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (timeout < DEFAULT_IFRAME_TIMEOUT_MS) {
                _this.browserRequestLogger.warning("system.loadFrameTimeout or system.iframeHashTimeout set to lower (" + timeout + "ms) than the default (" + DEFAULT_IFRAME_TIMEOUT_MS + "ms). This may result in timeouts.");
            }
            /*
             * Polling for iframes can be purely timing based,
             * since we don't need to account for interaction.
             */
            var nowMark = window.performance.now();
            var timeoutMark = nowMark + timeout;
            var intervalId = setInterval(function () {
                if (window.performance.now() > timeoutMark) {
                    _this.removeHiddenIframe(iframe);
                    clearInterval(intervalId);
                    reject(BrowserAuthError.createMonitorIframeTimeoutError());
                    return;
                }
                var href = Constants.EMPTY_STRING;
                var contentWindow = iframe.contentWindow;
                try {
                    /*
                     * Will throw if cross origin,
                     * which should be caught and ignored
                     * since we need the interval to keep running while on STS UI.
                     */
                    href = contentWindow ? contentWindow.location.href : Constants.EMPTY_STRING;
                }
                catch (e) { }
                if (StringUtils.isEmpty(href)) {
                    return;
                }
                var contentHash = contentWindow ? contentWindow.location.hash : Constants.EMPTY_STRING;
                if (UrlString.hashContainsKnownProperties(contentHash)) {
                    // Success case
                    _this.removeHiddenIframe(iframe);
                    clearInterval(intervalId);
                    resolve(contentHash);
                    return;
                }
            }, BrowserConstants.POLL_INTERVAL_MS);
        });
    };
    /**
     * @hidden
     * Loads iframe with authorization endpoint URL
     * @ignore
     */
    SilentHandler.prototype.loadFrame = function (urlNavigate) {
        /*
         * This trick overcomes iframe navigation in IE
         * IE does not load the page consistently in iframe
         */
        var _this = this;
        return new Promise(function (resolve, reject) {
            var frameHandle = _this.createHiddenIframe();
            setTimeout(function () {
                if (!frameHandle) {
                    reject("Unable to load iframe");
                    return;
                }
                frameHandle.src = urlNavigate;
                resolve(frameHandle);
            }, _this.navigateFrameWait);
        });
    };
    /**
     * @hidden
     * Loads the iframe synchronously when the navigateTimeFrame is set to `0`
     * @param urlNavigate
     * @param frameName
     * @param logger
     */
    SilentHandler.prototype.loadFrameSync = function (urlNavigate) {
        var frameHandle = this.createHiddenIframe();
        frameHandle.src = urlNavigate;
        return frameHandle;
    };
    /**
     * @hidden
     * Creates a new hidden iframe or gets an existing one for silent token renewal.
     * @ignore
     */
    SilentHandler.prototype.createHiddenIframe = function () {
        var authFrame = document.createElement("iframe");
        authFrame.style.visibility = "hidden";
        authFrame.style.position = "absolute";
        authFrame.style.width = authFrame.style.height = "0";
        authFrame.style.border = "0";
        authFrame.setAttribute("sandbox", "allow-scripts allow-same-origin allow-forms");
        document.getElementsByTagName("body")[0].appendChild(authFrame);
        return authFrame;
    };
    /**
     * @hidden
     * Removes a hidden iframe from the page.
     * @ignore
     */
    SilentHandler.prototype.removeHiddenIframe = function (iframe) {
        if (document.body === iframe.parentNode) {
            document.body.removeChild(iframe);
        }
    };
    return SilentHandler;
}(InteractionHandler));

/*! @azure/msal-browser v2.15.0 2021-06-29 */
/* eslint-disable header/header */
var name$s = "@azure/msal-browser";
var version$4 = "2.15.0";

/*! @azure/msal-browser v2.15.0 2021-06-29 */
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
var EventType;
(function (EventType) {
    EventType["LOGIN_START"] = "msal:loginStart";
    EventType["LOGIN_SUCCESS"] = "msal:loginSuccess";
    EventType["LOGIN_FAILURE"] = "msal:loginFailure";
    EventType["ACQUIRE_TOKEN_START"] = "msal:acquireTokenStart";
    EventType["ACQUIRE_TOKEN_SUCCESS"] = "msal:acquireTokenSuccess";
    EventType["ACQUIRE_TOKEN_FAILURE"] = "msal:acquireTokenFailure";
    EventType["ACQUIRE_TOKEN_NETWORK_START"] = "msal:acquireTokenFromNetworkStart";
    EventType["SSO_SILENT_START"] = "msal:ssoSilentStart";
    EventType["SSO_SILENT_SUCCESS"] = "msal:ssoSilentSuccess";
    EventType["SSO_SILENT_FAILURE"] = "msal:ssoSilentFailure";
    EventType["HANDLE_REDIRECT_START"] = "msal:handleRedirectStart";
    EventType["HANDLE_REDIRECT_END"] = "msal:handleRedirectEnd";
    EventType["POPUP_OPENED"] = "msal:popupOpened";
    EventType["LOGOUT_START"] = "msal:logoutStart";
    EventType["LOGOUT_SUCCESS"] = "msal:logoutSuccess";
    EventType["LOGOUT_FAILURE"] = "msal:logoutFailure";
    EventType["LOGOUT_END"] = "msal:logoutEnd";
})(EventType || (EventType = {}));

/*! @azure/msal-browser v2.15.0 2021-06-29 */
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
var EventHandler = /** @class */ (function () {
    function EventHandler(logger, browserCrypto) {
        this.eventCallbacks = new Map();
        this.logger = logger;
        this.browserCrypto = browserCrypto;
    }
    /**
     * Adds event callbacks to array
     * @param callback
     */
    EventHandler.prototype.addEventCallback = function (callback) {
        if (typeof window !== "undefined") {
            var callbackId = this.browserCrypto.createNewGuid();
            this.eventCallbacks.set(callbackId, callback);
            this.logger.verbose("Event callback registered with id: " + callbackId);
            return callbackId;
        }
        return null;
    };
    /**
     * Removes callback with provided id from callback array
     * @param callbackId
     */
    EventHandler.prototype.removeEventCallback = function (callbackId) {
        this.eventCallbacks.delete(callbackId);
        this.logger.verbose("Event callback " + callbackId + " removed.");
    };
    /**
     * Emits events by calling callback with event message
     * @param eventType
     * @param interactionType
     * @param payload
     * @param error
     */
    EventHandler.prototype.emitEvent = function (eventType, interactionType, payload, error) {
        var _this = this;
        if (typeof window !== "undefined") {
            var message_1 = {
                eventType: eventType,
                interactionType: interactionType || null,
                payload: payload || null,
                error: error || null,
                timestamp: Date.now()
            };
            this.logger.info("Emitting event: " + eventType);
            this.eventCallbacks.forEach(function (callback, callbackId) {
                _this.logger.verbose("Emitting event to callback " + callbackId + ": " + eventType);
                callback.apply(null, [message_1]);
            });
        }
    };
    return EventHandler;
}());

/*! @azure/msal-browser v2.15.0 2021-06-29 */

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
var ClientApplication = /** @class */ (function () {
    /**
     * @constructor
     * Constructor for the PublicClientApplication used to instantiate the PublicClientApplication object
     *
     * Important attributes in the Configuration object for auth are:
     * - clientID: the application ID of your application. You can obtain one by registering your application with our Application registration portal : https://portal.azure.com/#blade/Microsoft_AAD_IAM/ActiveDirectoryMenuBlade/RegisteredAppsPreview
     * - authority: the authority URL for your application.
     * - redirect_uri: the uri of your application registered in the portal.
     *
     * In Azure AD, authority is a URL indicating the Azure active directory that MSAL uses to obtain tokens.
     * It is of the form https://login.microsoftonline.com/{Enter_the_Tenant_Info_Here}
     * If your application supports Accounts in one organizational directory, replace "Enter_the_Tenant_Info_Here" value with the Tenant Id or Tenant name (for example, contoso.microsoft.com).
     * If your application supports Accounts in any organizational directory, replace "Enter_the_Tenant_Info_Here" value with organizations.
     * If your application supports Accounts in any organizational directory and personal Microsoft accounts, replace "Enter_the_Tenant_Info_Here" value with common.
     * To restrict support to Personal Microsoft accounts only, replace "Enter_the_Tenant_Info_Here" value with consumers.
     *
     * In Azure B2C, authority is of the form https://{instance}/tfp/{tenant}/{policyName}/
     * Full B2C functionality will be available in this library in future versions.
     *
     * @param configuration Object for the MSAL PublicClientApplication instance
     */
    function ClientApplication(configuration) {
        /*
         * If loaded in an environment where window is not available,
         * set internal flag to false so that further requests fail.
         * This is to support server-side rendering environments.
         */
        this.isBrowserEnvironment = typeof window !== "undefined";
        // Set the configuration.
        this.config = buildConfiguration(configuration, this.isBrowserEnvironment);
        this.activeLocalAccountId = null;
        // Initialize logger
        this.logger = new Logger$1(this.config.system.loggerOptions, name$s, version$4);
        // Initialize the network module class.
        this.networkClient = this.config.system.networkClient;
        // Initialize the navigation client class.
        this.navigationClient = this.config.system.navigationClient;
        // Initialize redirectResponse Map
        this.redirectResponse = new Map();
        // Initialize the crypto class.
        this.browserCrypto = this.isBrowserEnvironment ? new CryptoOps() : DEFAULT_CRYPTO_IMPLEMENTATION;
        this.eventHandler = new EventHandler(this.logger, this.browserCrypto);
        // Initialize the browser storage class.
        this.browserStorage = this.isBrowserEnvironment ?
            new BrowserCacheManager(this.config.auth.clientId, this.config.cache, this.browserCrypto, this.logger) :
            DEFAULT_BROWSER_CACHE_MANAGER(this.config.auth.clientId, this.logger);
    }
    // #region Redirect Flow
    /**
     * Event handler function which allows users to fire events after the PublicClientApplication object
     * has loaded during redirect flows. This should be invoked on all page loads involved in redirect
     * auth flows.
     * @param hash Hash to process. Defaults to the current value of window.location.hash. Only needs to be provided explicitly if the response to be handled is not contained in the current value.
     * @returns Token response or null. If the return value is null, then no auth redirect was detected.
     */
    ClientApplication.prototype.handleRedirectPromise = function (hash) {
        return __awaiter$1(this, void 0, void 0, function () {
            var loggedInAccounts, redirectResponseKey, response;
            var _this = this;
            return __generator$1(this, function (_a) {
                this.eventHandler.emitEvent(EventType.HANDLE_REDIRECT_START, InteractionType.Redirect);
                this.logger.verbose("handleRedirectPromise called");
                loggedInAccounts = this.getAllAccounts();
                if (this.isBrowserEnvironment) {
                    redirectResponseKey = hash || Constants.EMPTY_STRING;
                    response = this.redirectResponse.get(redirectResponseKey);
                    if (typeof response === "undefined") {
                        this.logger.verbose("handleRedirectPromise has been called for the first time, storing the promise");
                        response = this.handleRedirectResponse(hash)
                            .then(function (result) {
                            if (result) {
                                // Emit login event if number of accounts change
                                var isLoggingIn = loggedInAccounts.length < _this.getAllAccounts().length;
                                if (isLoggingIn) {
                                    _this.eventHandler.emitEvent(EventType.LOGIN_SUCCESS, InteractionType.Redirect, result);
                                    _this.logger.verbose("handleRedirectResponse returned result, login success");
                                }
                                else {
                                    _this.eventHandler.emitEvent(EventType.ACQUIRE_TOKEN_SUCCESS, InteractionType.Redirect, result);
                                    _this.logger.verbose("handleRedirectResponse returned result, acquire token success");
                                }
                            }
                            _this.eventHandler.emitEvent(EventType.HANDLE_REDIRECT_END, InteractionType.Redirect);
                            return result;
                        })
                            .catch(function (e) {
                            // Emit login event if there is an account
                            if (loggedInAccounts.length > 0) {
                                _this.eventHandler.emitEvent(EventType.ACQUIRE_TOKEN_FAILURE, InteractionType.Redirect, null, e);
                            }
                            else {
                                _this.eventHandler.emitEvent(EventType.LOGIN_FAILURE, InteractionType.Redirect, null, e);
                            }
                            _this.eventHandler.emitEvent(EventType.HANDLE_REDIRECT_END, InteractionType.Redirect);
                            throw e;
                        });
                        this.redirectResponse.set(redirectResponseKey, response);
                    }
                    else {
                        this.logger.verbose("handleRedirectPromise has been called previously, returning the result from the first call");
                    }
                    return [2 /*return*/, response];
                }
                this.logger.verbose("handleRedirectPromise returns null, not browser environment");
                return [2 /*return*/, null];
            });
        });
    };
    /**
     * Checks if navigateToLoginRequestUrl is set, and:
     * - if true, performs logic to cache and navigate
     * - if false, handles hash string and parses response
     * @param hash
     */
    ClientApplication.prototype.handleRedirectResponse = function (hash) {
        return __awaiter$1(this, void 0, void 0, function () {
            var responseHash, state, loginRequestUrl, loginRequestUrlNormalized, currentUrlNormalized, handleHashResult, navigationOptions, processHashOnRedirect, homepage;
            return __generator$1(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.interactionInProgress()) {
                            this.logger.info("handleRedirectPromise called but there is no interaction in progress, returning null.");
                            return [2 /*return*/, null];
                        }
                        responseHash = this.getRedirectResponseHash(hash || window.location.hash);
                        if (!responseHash) {
                            // Not a recognized server response hash or hash not associated with a redirect request
                            this.logger.info("handleRedirectPromise did not detect a response hash as a result of a redirect. Cleaning temporary cache.");
                            this.browserStorage.cleanRequestByInteractionType(InteractionType.Redirect);
                            return [2 /*return*/, null];
                        }
                        try {
                            state = this.validateAndExtractStateFromHash(responseHash, InteractionType.Redirect);
                            BrowserUtils.clearHash(window);
                            this.logger.verbose("State extracted from hash");
                        }
                        catch (e) {
                            this.logger.info("handleRedirectPromise was unable to extract state due to: " + e);
                            this.browserStorage.cleanRequestByInteractionType(InteractionType.Redirect);
                            return [2 /*return*/, null];
                        }
                        loginRequestUrl = this.browserStorage.getTemporaryCache(TemporaryCacheKeys.ORIGIN_URI, true) || "";
                        loginRequestUrlNormalized = UrlString.removeHashFromUrl(loginRequestUrl);
                        currentUrlNormalized = UrlString.removeHashFromUrl(window.location.href);
                        if (!(loginRequestUrlNormalized === currentUrlNormalized && this.config.auth.navigateToLoginRequestUrl)) return [3 /*break*/, 2];
                        // We are on the page we need to navigate to - handle hash
                        this.logger.verbose("Current page is loginRequestUrl, handling hash");
                        return [4 /*yield*/, this.handleHash(responseHash, state)];
                    case 1:
                        handleHashResult = _a.sent();
                        if (loginRequestUrl.indexOf("#") > -1) {
                            // Replace current hash with non-msal hash, if present
                            BrowserUtils.replaceHash(loginRequestUrl);
                        }
                        return [2 /*return*/, handleHashResult];
                    case 2:
                        if (!!this.config.auth.navigateToLoginRequestUrl) return [3 /*break*/, 3];
                        this.logger.verbose("NavigateToLoginRequestUrl set to false, handling hash");
                        return [2 /*return*/, this.handleHash(responseHash, state)];
                    case 3:
                        if (!!BrowserUtils.isInIframe()) return [3 /*break*/, 8];
                        /*
                         * Returned from authority using redirect - need to perform navigation before processing response
                         * Cache the hash to be retrieved after the next redirect
                         */
                        this.browserStorage.setTemporaryCache(TemporaryCacheKeys.URL_HASH, responseHash, true);
                        navigationOptions = {
                            apiId: ApiId.handleRedirectPromise,
                            timeout: this.config.system.redirectNavigationTimeout,
                            noHistory: true
                        };
                        processHashOnRedirect = true;
                        if (!(!loginRequestUrl || loginRequestUrl === "null")) return [3 /*break*/, 5];
                        homepage = BrowserUtils.getHomepage();
                        // Cache the homepage under ORIGIN_URI to ensure cached hash is processed on homepage
                        this.browserStorage.setTemporaryCache(TemporaryCacheKeys.ORIGIN_URI, homepage, true);
                        this.logger.warning("Unable to get valid login request url from cache, redirecting to home page");
                        return [4 /*yield*/, this.navigationClient.navigateInternal(homepage, navigationOptions)];
                    case 4:
                        processHashOnRedirect = _a.sent();
                        return [3 /*break*/, 7];
                    case 5:
                        // Navigate to page that initiated the redirect request
                        this.logger.verbose("Navigating to loginRequestUrl: " + loginRequestUrl);
                        return [4 /*yield*/, this.navigationClient.navigateInternal(loginRequestUrl, navigationOptions)];
                    case 6:
                        processHashOnRedirect = _a.sent();
                        _a.label = 7;
                    case 7:
                        // If navigateInternal implementation returns false, handle the hash now
                        if (!processHashOnRedirect) {
                            return [2 /*return*/, this.handleHash(responseHash, state)];
                        }
                        _a.label = 8;
                    case 8: return [2 /*return*/, null];
                }
            });
        });
    };
    /**
     * Gets the response hash for a redirect request
     * Returns null if interactionType in the state value is not "redirect" or the hash does not contain known properties
     * @param hash
     */
    ClientApplication.prototype.getRedirectResponseHash = function (hash) {
        this.logger.verbose("getRedirectResponseHash called");
        // Get current location hash from window or cache.
        var isResponseHash = UrlString.hashContainsKnownProperties(hash);
        var cachedHash = this.browserStorage.getTemporaryCache(TemporaryCacheKeys.URL_HASH, true);
        this.browserStorage.removeItem(this.browserStorage.generateCacheKey(TemporaryCacheKeys.URL_HASH));
        if (isResponseHash) {
            this.logger.verbose("Hash contains known properties, returning response hash");
            return hash;
        }
        this.logger.verbose("Hash does not contain known properties, returning cached hash");
        return cachedHash;
    };
    /**
     * @param hash
     * @param interactionType
     */
    ClientApplication.prototype.validateAndExtractStateFromHash = function (hash, interactionType, requestCorrelationId) {
        this.logger.verbose("validateAndExtractStateFromHash called", requestCorrelationId);
        // Deserialize hash fragment response parameters.
        var serverParams = UrlString.getDeserializedHash(hash);
        if (!serverParams.state) {
            throw BrowserAuthError.createHashDoesNotContainStateError();
        }
        var platformStateObj = BrowserProtocolUtils.extractBrowserRequestState(this.browserCrypto, serverParams.state);
        if (!platformStateObj) {
            throw BrowserAuthError.createUnableToParseStateError();
        }
        if (platformStateObj.interactionType !== interactionType) {
            throw BrowserAuthError.createStateInteractionTypeMismatchError();
        }
        this.logger.verbose("Returning state from hash", requestCorrelationId);
        return serverParams.state;
    };
    /**
     * Checks if hash exists and handles in window.
     * @param hash
     * @param state
     */
    ClientApplication.prototype.handleHash = function (hash, state) {
        return __awaiter$1(this, void 0, void 0, function () {
            var cachedRequest, browserRequestLogger, serverTelemetryManager, currentAuthority, authClient, interactionHandler, e_1;
            return __generator$1(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        cachedRequest = this.browserStorage.getCachedRequest(state, this.browserCrypto);
                        browserRequestLogger = this.logger.clone(name$s, version$4, cachedRequest.correlationId);
                        browserRequestLogger.verbose("handleHash called, retrieved cached request");
                        serverTelemetryManager = this.initializeServerTelemetryManager(ApiId.handleRedirectPromise, cachedRequest.correlationId);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        currentAuthority = this.browserStorage.getCachedAuthority(state);
                        if (!currentAuthority) {
                            throw BrowserAuthError.createNoCachedAuthorityError();
                        }
                        return [4 /*yield*/, this.createAuthCodeClient(serverTelemetryManager, currentAuthority, cachedRequest.correlationId)];
                    case 2:
                        authClient = _a.sent();
                        browserRequestLogger.verbose("Auth code client created");
                        interactionHandler = new RedirectHandler(authClient, this.browserStorage, cachedRequest, browserRequestLogger, this.browserCrypto);
                        return [4 /*yield*/, interactionHandler.handleCodeResponse(hash, state, authClient.authority, this.networkClient, this.config.auth.clientId)];
                    case 3: return [2 /*return*/, _a.sent()];
                    case 4:
                        e_1 = _a.sent();
                        serverTelemetryManager.cacheFailedRequest(e_1);
                        this.browserStorage.cleanRequestByInteractionType(InteractionType.Redirect);
                        throw e_1;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Use when you want to obtain an access_token for your API by redirecting the user's browser window to the authorization endpoint. This function redirects
     * the page, so any code that follows this function will not execute.
     *
     * IMPORTANT: It is NOT recommended to have code that is dependent on the resolution of the Promise. This function will navigate away from the current
     * browser window. It currently returns a Promise in order to reflect the asynchronous nature of the code running in this function.
     *
     * @param request
     */
    ClientApplication.prototype.acquireTokenRedirect = function (request) {
        return __awaiter$1(this, void 0, void 0, function () {
            var isLoggedIn, validRequest, browserRequestLogger, serverTelemetryManager, authCodeRequest, authClient, interactionHandler, navigateUrl, redirectStartPage, e_2;
            return __generator$1(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // Preflight request
                        this.preflightBrowserEnvironmentCheck(InteractionType.Redirect);
                        this.logger.verbose("acquireTokenRedirect called");
                        isLoggedIn = this.getAllAccounts().length > 0;
                        if (isLoggedIn) {
                            this.eventHandler.emitEvent(EventType.ACQUIRE_TOKEN_START, InteractionType.Redirect, request);
                        }
                        else {
                            this.eventHandler.emitEvent(EventType.LOGIN_START, InteractionType.Redirect, request);
                        }
                        validRequest = this.preflightInteractiveRequest(request, InteractionType.Redirect);
                        browserRequestLogger = this.logger.clone(name$s, version$4, validRequest.correlationId);
                        serverTelemetryManager = this.initializeServerTelemetryManager(ApiId.acquireTokenRedirect, validRequest.correlationId);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 5, , 6]);
                        return [4 /*yield*/, this.initializeAuthorizationCodeRequest(validRequest)];
                    case 2:
                        authCodeRequest = _a.sent();
                        return [4 /*yield*/, this.createAuthCodeClient(serverTelemetryManager, validRequest.authority, validRequest.correlationId)];
                    case 3:
                        authClient = _a.sent();
                        browserRequestLogger.verbose("Auth code client created");
                        interactionHandler = new RedirectHandler(authClient, this.browserStorage, authCodeRequest, browserRequestLogger, this.browserCrypto);
                        return [4 /*yield*/, authClient.getAuthCodeUrl(validRequest)];
                    case 4:
                        navigateUrl = _a.sent();
                        redirectStartPage = this.getRedirectStartPage(request.redirectStartPage);
                        browserRequestLogger.verbosePii("Redirect start page: " + redirectStartPage);
                        // Show the UI once the url has been created. Response will come back in the hash, which will be handled in the handleRedirectCallback function.
                        return [2 /*return*/, interactionHandler.initiateAuthRequest(navigateUrl, {
                                navigationClient: this.navigationClient,
                                redirectTimeout: this.config.system.redirectNavigationTimeout,
                                redirectStartPage: redirectStartPage,
                                onRedirectNavigate: request.onRedirectNavigate
                            })];
                    case 5:
                        e_2 = _a.sent();
                        // If logged in, emit acquire token events
                        if (isLoggedIn) {
                            this.eventHandler.emitEvent(EventType.ACQUIRE_TOKEN_FAILURE, InteractionType.Redirect, null, e_2);
                        }
                        else {
                            this.eventHandler.emitEvent(EventType.LOGIN_FAILURE, InteractionType.Redirect, null, e_2);
                        }
                        serverTelemetryManager.cacheFailedRequest(e_2);
                        this.browserStorage.cleanRequestByState(validRequest.state);
                        throw e_2;
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    // #endregion
    // #region Popup Flow
    /**
     * Use when you want to obtain an access_token for your API via opening a popup window in the user's browser
     *
     * @param request
     *
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */
    ClientApplication.prototype.acquireTokenPopup = function (request) {
        var validRequest;
        try {
            this.preflightBrowserEnvironmentCheck(InteractionType.Popup);
            this.logger.verbose("acquireTokenPopup called", request.correlationId);
            validRequest = this.preflightInteractiveRequest(request, InteractionType.Popup);
        }
        catch (e) {
            // Since this function is syncronous we need to reject
            return Promise.reject(e);
        }
        var popupName = PopupUtils.generatePopupName(this.config.auth.clientId, validRequest);
        // asyncPopups flag is true. Acquires token without first opening popup. Popup will be opened later asynchronously.
        if (this.config.system.asyncPopups) {
            this.logger.verbose("asyncPopups set to true, acquiring token", validRequest.correlationId);
            return this.acquireTokenPopupAsync(validRequest, popupName);
        }
        else {
            // asyncPopups flag is set to false. Opens popup before acquiring token.
            this.logger.verbose("asyncPopup set to false, opening popup before acquiring token", validRequest.correlationId);
            var popup = PopupUtils.openSizedPopup("about:blank", popupName);
            return this.acquireTokenPopupAsync(validRequest, popupName, popup);
        }
    };
    /**
     * Helper which obtains an access_token for your API via opening a popup window in the user's browser
     * @param validRequest
     * @param popupName
     * @param popup
     *
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */
    ClientApplication.prototype.acquireTokenPopupAsync = function (validRequest, popupName, popup) {
        return __awaiter$1(this, void 0, void 0, function () {
            var loggedInAccounts, browserRequestLogger, serverTelemetryManager, authCodeRequest, authClient, navigateUrl, interactionHandler, popupParameters, popupWindow, hash, state, result, isLoggingIn, e_3;
            return __generator$1(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.logger.verbose("acquireTokenPopupAsync called", validRequest.correlationId);
                        loggedInAccounts = this.getAllAccounts();
                        if (loggedInAccounts.length > 0) {
                            this.eventHandler.emitEvent(EventType.ACQUIRE_TOKEN_START, InteractionType.Popup, validRequest);
                        }
                        else {
                            this.eventHandler.emitEvent(EventType.LOGIN_START, InteractionType.Popup, validRequest);
                        }
                        browserRequestLogger = this.logger.clone(name$s, version$4, validRequest.correlationId);
                        serverTelemetryManager = this.initializeServerTelemetryManager(ApiId.acquireTokenPopup, validRequest.correlationId);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 7, , 8]);
                        return [4 /*yield*/, this.initializeAuthorizationCodeRequest(validRequest)];
                    case 2:
                        authCodeRequest = _a.sent();
                        return [4 /*yield*/, this.createAuthCodeClient(serverTelemetryManager, validRequest.authority, validRequest.correlationId)];
                    case 3:
                        authClient = _a.sent();
                        browserRequestLogger.verbose("Auth code client created");
                        return [4 /*yield*/, authClient.getAuthCodeUrl(validRequest)];
                    case 4:
                        navigateUrl = _a.sent();
                        interactionHandler = new PopupHandler(authClient, this.browserStorage, authCodeRequest, browserRequestLogger);
                        popupParameters = {
                            popup: popup,
                            popupName: popupName
                        };
                        popupWindow = interactionHandler.initiateAuthRequest(navigateUrl, popupParameters);
                        this.eventHandler.emitEvent(EventType.POPUP_OPENED, InteractionType.Popup, { popupWindow: popupWindow }, null);
                        return [4 /*yield*/, interactionHandler.monitorPopupForHash(popupWindow)];
                    case 5:
                        hash = _a.sent();
                        state = this.validateAndExtractStateFromHash(hash, InteractionType.Popup, validRequest.correlationId);
                        // Remove throttle if it exists
                        ThrottlingUtils.removeThrottle(this.browserStorage, this.config.auth.clientId, authCodeRequest.authority, authCodeRequest.scopes);
                        return [4 /*yield*/, interactionHandler.handleCodeResponse(hash, state, authClient.authority, this.networkClient)];
                    case 6:
                        result = _a.sent();
                        isLoggingIn = loggedInAccounts.length < this.getAllAccounts().length;
                        if (isLoggingIn) {
                            this.eventHandler.emitEvent(EventType.LOGIN_SUCCESS, InteractionType.Popup, result);
                        }
                        else {
                            this.eventHandler.emitEvent(EventType.ACQUIRE_TOKEN_SUCCESS, InteractionType.Popup, result);
                        }
                        return [2 /*return*/, result];
                    case 7:
                        e_3 = _a.sent();
                        if (loggedInAccounts.length > 0) {
                            this.eventHandler.emitEvent(EventType.ACQUIRE_TOKEN_FAILURE, InteractionType.Popup, null, e_3);
                        }
                        else {
                            this.eventHandler.emitEvent(EventType.LOGIN_FAILURE, InteractionType.Popup, null, e_3);
                        }
                        if (popup) {
                            // Close the synchronous popup if an error is thrown before the window unload event is registered
                            popup.close();
                        }
                        serverTelemetryManager.cacheFailedRequest(e_3);
                        this.browserStorage.cleanRequestByState(validRequest.state);
                        throw e_3;
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    // #endregion
    // #region Silent Flow
    /**
     * This function uses a hidden iframe to fetch an authorization code from the eSTS. There are cases where this may not work:
     * - Any browser using a form of Intelligent Tracking Prevention
     * - If there is not an established session with the service
     *
     * In these cases, the request must be done inside a popup or full frame redirect.
     *
     * For the cases where interaction is required, you cannot send a request with prompt=none.
     *
     * If your refresh token has expired, you can use this function to fetch a new set of tokens silently as long as
     * you session on the server still exists.
     * @param request {@link SsoSilentRequest}
     *
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */
    ClientApplication.prototype.ssoSilent = function (request) {
        return __awaiter$1(this, void 0, void 0, function () {
            var silentTokenResult, e_4;
            return __generator$1(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.preflightBrowserEnvironmentCheck(InteractionType.Silent);
                        this.logger.verbose("ssoSilent called", request.correlationId);
                        this.eventHandler.emitEvent(EventType.SSO_SILENT_START, InteractionType.Silent, request);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.acquireTokenByIframe(request, ApiId.ssoSilent)];
                    case 2:
                        silentTokenResult = _a.sent();
                        this.eventHandler.emitEvent(EventType.SSO_SILENT_SUCCESS, InteractionType.Silent, silentTokenResult);
                        return [2 /*return*/, silentTokenResult];
                    case 3:
                        e_4 = _a.sent();
                        this.eventHandler.emitEvent(EventType.SSO_SILENT_FAILURE, InteractionType.Silent, null, e_4);
                        throw e_4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * This function uses a hidden iframe to fetch an authorization code from the eSTS. To be used for silent refresh token acquisition and renewal.
     * @param request
     * @param apiId - ApiId of the calling function. Used for telemetry.
     */
    ClientApplication.prototype.acquireTokenByIframe = function (request, apiId) {
        return __awaiter$1(this, void 0, void 0, function () {
            var silentRequest, browserRequestLogger, serverTelemetryManager, authCodeRequest, authClient, navigateUrl, e_5;
            return __generator$1(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.logger.verbose("acquireTokenByIframe called", request.correlationId);
                        // Check that we have some SSO data
                        if (StringUtils.isEmpty(request.loginHint) && StringUtils.isEmpty(request.sid) && (!request.account || StringUtils.isEmpty(request.account.username))) {
                            throw BrowserAuthError.createSilentSSOInsufficientInfoError();
                        }
                        // Check that prompt is set to none, throw error if it is set to anything else.
                        if (request.prompt && request.prompt !== PromptValue.NONE) {
                            throw BrowserAuthError.createSilentPromptValueError(request.prompt);
                        }
                        silentRequest = this.initializeAuthorizationRequest(__assign$1(__assign$1({}, request), { prompt: PromptValue.NONE }), InteractionType.Silent);
                        browserRequestLogger = this.logger.clone(name$s, version$4, silentRequest.correlationId);
                        serverTelemetryManager = this.initializeServerTelemetryManager(apiId, silentRequest.correlationId);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 6, , 7]);
                        return [4 /*yield*/, this.initializeAuthorizationCodeRequest(silentRequest)];
                    case 2:
                        authCodeRequest = _a.sent();
                        return [4 /*yield*/, this.createAuthCodeClient(serverTelemetryManager, silentRequest.authority, silentRequest.correlationId)];
                    case 3:
                        authClient = _a.sent();
                        browserRequestLogger.verbose("Auth code client created");
                        return [4 /*yield*/, authClient.getAuthCodeUrl(silentRequest)];
                    case 4:
                        navigateUrl = _a.sent();
                        return [4 /*yield*/, this.silentTokenHelper(navigateUrl, authCodeRequest, authClient, browserRequestLogger)];
                    case 5: return [2 /*return*/, _a.sent()];
                    case 6:
                        e_5 = _a.sent();
                        serverTelemetryManager.cacheFailedRequest(e_5);
                        this.browserStorage.cleanRequestByState(silentRequest.state);
                        throw e_5;
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Use this function to obtain a token before every call to the API / resource provider
     *
     * MSAL return's a cached token when available
     * Or it send's a request to the STS to obtain a new token using a refresh token.
     *
     * @param {@link SilentRequest}
     *
     * To renew idToken, please pass clientId as the only scope in the Authentication Parameters
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */
    ClientApplication.prototype.acquireTokenByRefreshToken = function (request) {
        return __awaiter$1(this, void 0, void 0, function () {
            var silentRequest, browserRequestLogger, serverTelemetryManager, refreshTokenClient, e_6, isServerError, isInteractionRequiredError, isInvalidGrantError;
            return __generator$1(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.eventHandler.emitEvent(EventType.ACQUIRE_TOKEN_NETWORK_START, InteractionType.Silent, request);
                        // block the reload if it occurred inside a hidden iframe
                        BrowserUtils.blockReloadInHiddenIframes();
                        silentRequest = __assign$1(__assign$1({}, request), this.initializeBaseRequest(request));
                        browserRequestLogger = this.logger.clone(name$s, version$4, silentRequest.correlationId);
                        serverTelemetryManager = this.initializeServerTelemetryManager(ApiId.acquireTokenSilent_silentFlow, silentRequest.correlationId);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 7]);
                        return [4 /*yield*/, this.createRefreshTokenClient(serverTelemetryManager, silentRequest.authority, silentRequest.correlationId)];
                    case 2:
                        refreshTokenClient = _a.sent();
                        browserRequestLogger.verbose("Refresh token client created");
                        return [4 /*yield*/, refreshTokenClient.acquireTokenByRefreshToken(silentRequest)];
                    case 3: 
                    // Send request to renew token. Auth module will throw errors if token cannot be renewed.
                    return [2 /*return*/, _a.sent()];
                    case 4:
                        e_6 = _a.sent();
                        serverTelemetryManager.cacheFailedRequest(e_6);
                        isServerError = e_6 instanceof ServerError;
                        isInteractionRequiredError = e_6 instanceof InteractionRequiredAuthError;
                        isInvalidGrantError = (e_6.errorCode === BrowserConstants.INVALID_GRANT_ERROR);
                        if (!(isServerError && isInvalidGrantError && !isInteractionRequiredError)) return [3 /*break*/, 6];
                        browserRequestLogger.verbose("Refresh token expired or invalid, attempting acquire token by iframe");
                        return [4 /*yield*/, this.acquireTokenByIframe(request, ApiId.acquireTokenSilent_authCode)];
                    case 5: return [2 /*return*/, _a.sent()];
                    case 6: throw e_6;
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Helper which acquires an authorization code silently using a hidden iframe from given url
     * using the scopes requested as part of the id, and exchanges the code for a set of OAuth tokens.
     * @param navigateUrl
     * @param userRequestScopes
     */
    ClientApplication.prototype.silentTokenHelper = function (navigateUrl, authCodeRequest, authClient, browserRequestLogger) {
        return __awaiter$1(this, void 0, void 0, function () {
            var silentHandler, msalFrame, hash, state;
            return __generator$1(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        silentHandler = new SilentHandler(authClient, this.browserStorage, authCodeRequest, browserRequestLogger, this.config.system.navigateFrameWait);
                        return [4 /*yield*/, silentHandler.initiateAuthRequest(navigateUrl)];
                    case 1:
                        msalFrame = _a.sent();
                        return [4 /*yield*/, silentHandler.monitorIframeForHash(msalFrame, this.config.system.iframeHashTimeout)];
                    case 2:
                        hash = _a.sent();
                        state = this.validateAndExtractStateFromHash(hash, InteractionType.Silent, authCodeRequest.correlationId);
                        // Handle response from hash string
                        return [2 /*return*/, silentHandler.handleCodeResponse(hash, state, authClient.authority, this.networkClient)];
                }
            });
        });
    };
    // #endregion
    // #region Logout
    /**
     * Deprecated logout function. Use logoutRedirect or logoutPopup instead
     * @param logoutRequest
     * @deprecated
     */
    ClientApplication.prototype.logout = function (logoutRequest) {
        return __awaiter$1(this, void 0, void 0, function () {
            return __generator$1(this, function (_a) {
                this.logger.warning("logout API is deprecated and will be removed in msal-browser v3.0.0. Use logoutRedirect instead.");
                return [2 /*return*/, this.logoutRedirect(logoutRequest)];
            });
        });
    };
    /**
     * Use to log out the current user, and redirect the user to the postLogoutRedirectUri.
     * Default behaviour is to redirect the user to `window.location.href`.
     * @param logoutRequest
     */
    ClientApplication.prototype.logoutRedirect = function (logoutRequest) {
        return __awaiter$1(this, void 0, void 0, function () {
            var validLogoutRequest, browserRequestLogger, serverTelemetryManager, authClient, logoutUri, navigationOptions, navigate, e_7;
            return __generator$1(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.preflightBrowserEnvironmentCheck(InteractionType.Redirect);
                        this.logger.verbose("logoutRedirect called", logoutRequest === null || logoutRequest === void 0 ? void 0 : logoutRequest.correlationId);
                        validLogoutRequest = this.initializeLogoutRequest(logoutRequest);
                        browserRequestLogger = this.logger.clone(name$s, version$4, validLogoutRequest.correlationId);
                        serverTelemetryManager = this.initializeServerTelemetryManager(ApiId.logout, validLogoutRequest.correlationId);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 9, , 10]);
                        this.eventHandler.emitEvent(EventType.LOGOUT_START, InteractionType.Redirect, logoutRequest);
                        return [4 /*yield*/, this.createAuthCodeClient(serverTelemetryManager, logoutRequest && logoutRequest.authority, validLogoutRequest === null || validLogoutRequest === void 0 ? void 0 : validLogoutRequest.correlationId)];
                    case 2:
                        authClient = _a.sent();
                        browserRequestLogger.verbose("Auth code client created");
                        logoutUri = authClient.getLogoutUri(validLogoutRequest);
                        if (!validLogoutRequest.account || AccountEntity.accountInfoIsEqual(validLogoutRequest.account, this.getActiveAccount(), false)) {
                            browserRequestLogger.verbose("Setting active account to null");
                            this.setActiveAccount(null);
                        }
                        navigationOptions = {
                            apiId: ApiId.logout,
                            timeout: this.config.system.redirectNavigationTimeout,
                            noHistory: false
                        };
                        this.eventHandler.emitEvent(EventType.LOGOUT_SUCCESS, InteractionType.Redirect, validLogoutRequest);
                        if (!(logoutRequest && typeof logoutRequest.onRedirectNavigate === "function")) return [3 /*break*/, 6];
                        navigate = logoutRequest.onRedirectNavigate(logoutUri);
                        if (!(navigate !== false)) return [3 /*break*/, 4];
                        browserRequestLogger.verbose("Logout onRedirectNavigate did not return false, navigating");
                        return [4 /*yield*/, this.navigationClient.navigateExternal(logoutUri, navigationOptions)];
                    case 3:
                        _a.sent();
                        return [2 /*return*/];
                    case 4:
                        browserRequestLogger.verbose("Logout onRedirectNavigate returned false, stopping navigation");
                        _a.label = 5;
                    case 5: return [3 /*break*/, 8];
                    case 6: return [4 /*yield*/, this.navigationClient.navigateExternal(logoutUri, navigationOptions)];
                    case 7:
                        _a.sent();
                        return [2 /*return*/];
                    case 8: return [3 /*break*/, 10];
                    case 9:
                        e_7 = _a.sent();
                        serverTelemetryManager.cacheFailedRequest(e_7);
                        this.eventHandler.emitEvent(EventType.LOGOUT_FAILURE, InteractionType.Redirect, null, e_7);
                        throw e_7;
                    case 10:
                        this.eventHandler.emitEvent(EventType.LOGOUT_END, InteractionType.Redirect);
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Clears local cache for the current user then opens a popup window prompting the user to sign-out of the server
     * @param logoutRequest
     */
    ClientApplication.prototype.logoutPopup = function (logoutRequest) {
        var validLogoutRequest;
        try {
            this.preflightBrowserEnvironmentCheck(InteractionType.Popup);
            this.logger.verbose("logoutPopup called", logoutRequest === null || logoutRequest === void 0 ? void 0 : logoutRequest.correlationId);
            validLogoutRequest = this.initializeLogoutRequest(logoutRequest);
        }
        catch (e) {
            // Since this function is synchronous we need to reject
            return Promise.reject(e);
        }
        var popupName = PopupUtils.generateLogoutPopupName(this.config.auth.clientId, validLogoutRequest);
        var popup;
        // asyncPopups flag is true. Acquires token without first opening popup. Popup will be opened later asynchronously.
        if (this.config.system.asyncPopups) {
            this.logger.verbose("asyncPopups set to true", validLogoutRequest.correlationId);
        }
        else {
            // asyncPopups flag is set to false. Opens popup before logging out.
            this.logger.verbose("asyncPopup set to false, opening popup", validLogoutRequest.correlationId);
            popup = PopupUtils.openSizedPopup("about:blank", popupName);
        }
        var authority = logoutRequest && logoutRequest.authority;
        var mainWindowRedirectUri = logoutRequest && logoutRequest.mainWindowRedirectUri;
        return this.logoutPopupAsync(validLogoutRequest, popupName, authority, popup, mainWindowRedirectUri);
    };
    /**
     *
     * @param request
     * @param popupName
     * @param requestAuthority
     * @param popup
     */
    ClientApplication.prototype.logoutPopupAsync = function (validRequest, popupName, requestAuthority, popup, mainWindowRedirectUri) {
        return __awaiter$1(this, void 0, void 0, function () {
            var browserRequestLogger, serverTelemetryManager, authClient, logoutUri, popupUtils, popupWindow, e_8, navigationOptions, absoluteUrl, e_9;
            return __generator$1(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.logger.verbose("logoutPopupAsync called", validRequest.correlationId);
                        this.eventHandler.emitEvent(EventType.LOGOUT_START, InteractionType.Popup, validRequest);
                        browserRequestLogger = this.logger.clone(name$s, version$4, validRequest.correlationId);
                        serverTelemetryManager = this.initializeServerTelemetryManager(ApiId.logoutPopup, validRequest.correlationId);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 7, , 8]);
                        this.browserStorage.setTemporaryCache(TemporaryCacheKeys.INTERACTION_STATUS_KEY, BrowserConstants.INTERACTION_IN_PROGRESS_VALUE, true);
                        return [4 /*yield*/, this.createAuthCodeClient(serverTelemetryManager, requestAuthority, validRequest.correlationId)];
                    case 2:
                        authClient = _a.sent();
                        browserRequestLogger.verbose("Auth code client created");
                        logoutUri = authClient.getLogoutUri(validRequest);
                        if (!validRequest.account || AccountEntity.accountInfoIsEqual(validRequest.account, this.getActiveAccount(), false)) {
                            browserRequestLogger.verbose("Setting active account to null");
                            this.setActiveAccount(null);
                        }
                        this.eventHandler.emitEvent(EventType.LOGOUT_SUCCESS, InteractionType.Popup, validRequest);
                        popupUtils = new PopupUtils(this.browserStorage, this.logger);
                        popupWindow = popupUtils.openPopup(logoutUri, popupName, popup);
                        this.eventHandler.emitEvent(EventType.POPUP_OPENED, InteractionType.Popup, { popupWindow: popupWindow }, null);
                        _a.label = 3;
                    case 3:
                        _a.trys.push([3, 5, , 6]);
                        // Don't care if this throws an error (User Cancelled)
                        return [4 /*yield*/, popupUtils.monitorPopupForSameOrigin(popupWindow)];
                    case 4:
                        // Don't care if this throws an error (User Cancelled)
                        _a.sent();
                        browserRequestLogger.verbose("Popup successfully redirected to postLogoutRedirectUri");
                        return [3 /*break*/, 6];
                    case 5:
                        e_8 = _a.sent();
                        browserRequestLogger.verbose("Error occurred while monitoring popup for same origin. Session on server may remain active. Error: " + e_8);
                        return [3 /*break*/, 6];
                    case 6:
                        popupUtils.cleanPopup(popupWindow);
                        if (mainWindowRedirectUri) {
                            navigationOptions = {
                                apiId: ApiId.logoutPopup,
                                timeout: this.config.system.redirectNavigationTimeout,
                                noHistory: false
                            };
                            absoluteUrl = UrlString.getAbsoluteUrl(mainWindowRedirectUri, BrowserUtils.getCurrentUri());
                            browserRequestLogger.verbose("Redirecting main window to url specified in the request");
                            browserRequestLogger.verbosePii("Redirecing main window to: " + absoluteUrl);
                            this.navigationClient.navigateInternal(absoluteUrl, navigationOptions);
                        }
                        else {
                            browserRequestLogger.verbose("No main window navigation requested");
                        }
                        return [3 /*break*/, 8];
                    case 7:
                        e_9 = _a.sent();
                        if (popup) {
                            // Close the synchronous popup if an error is thrown before the window unload event is registered
                            popup.close();
                        }
                        this.browserStorage.removeItem(this.browserStorage.generateCacheKey(TemporaryCacheKeys.INTERACTION_STATUS_KEY));
                        this.eventHandler.emitEvent(EventType.LOGOUT_FAILURE, InteractionType.Popup, null, e_9);
                        serverTelemetryManager.cacheFailedRequest(e_9);
                        throw e_9;
                    case 8:
                        this.eventHandler.emitEvent(EventType.LOGOUT_END, InteractionType.Popup);
                        return [2 /*return*/];
                }
            });
        });
    };
    // #endregion
    // #region Account APIs
    /**
     * Returns all accounts that MSAL currently has data for.
     * (the account object is created at the time of successful login)
     * or empty array when no accounts are found
     * @returns Array of account objects in cache
     */
    ClientApplication.prototype.getAllAccounts = function () {
        this.logger.verbose("getAllAccounts called");
        return this.isBrowserEnvironment ? this.browserStorage.getAllAccounts() : [];
    };
    /**
     * Returns the signed in account matching username.
     * (the account object is created at the time of successful login)
     * or null when no matching account is found.
     * This API is provided for convenience but getAccountById should be used for best reliability
     * @param userName
     * @returns The account object stored in MSAL
     */
    ClientApplication.prototype.getAccountByUsername = function (userName) {
        var allAccounts = this.getAllAccounts();
        if (!StringUtils.isEmpty(userName) && allAccounts && allAccounts.length) {
            this.logger.verbose("Account matching username found, returning");
            this.logger.verbosePii("Returning signed-in accounts matching username: " + userName);
            return allAccounts.filter(function (accountObj) { return accountObj.username.toLowerCase() === userName.toLowerCase(); })[0] || null;
        }
        else {
            this.logger.verbose("getAccountByUsername: No matching account found, returning null");
            return null;
        }
    };
    /**
     * Returns the signed in account matching homeAccountId.
     * (the account object is created at the time of successful login)
     * or null when no matching account is found
     * @param homeAccountId
     * @returns The account object stored in MSAL
     */
    ClientApplication.prototype.getAccountByHomeId = function (homeAccountId) {
        var allAccounts = this.getAllAccounts();
        if (!StringUtils.isEmpty(homeAccountId) && allAccounts && allAccounts.length) {
            this.logger.verbose("Account matching homeAccountId found, returning");
            this.logger.verbosePii("Returning signed-in accounts matching homeAccountId: " + homeAccountId);
            return allAccounts.filter(function (accountObj) { return accountObj.homeAccountId === homeAccountId; })[0] || null;
        }
        else {
            this.logger.verbose("getAccountByHomeId: No matching account found, returning null");
            return null;
        }
    };
    /**
     * Returns the signed in account matching localAccountId.
     * (the account object is created at the time of successful login)
     * or null when no matching account is found
     * @param localAccountId
     * @returns The account object stored in MSAL
     */
    ClientApplication.prototype.getAccountByLocalId = function (localAccountId) {
        var allAccounts = this.getAllAccounts();
        if (!StringUtils.isEmpty(localAccountId) && allAccounts && allAccounts.length) {
            this.logger.verbose("Account matching localAccountId found, returning");
            this.logger.verbosePii("Returning signed-in accounts matching localAccountId: " + localAccountId);
            return allAccounts.filter(function (accountObj) { return accountObj.localAccountId === localAccountId; })[0] || null;
        }
        else {
            this.logger.verbose("getAccountByLocalId: No matching account found, returning null");
            return null;
        }
    };
    /**
     * Sets the account to use as the active account. If no account is passed to the acquireToken APIs, then MSAL will use this active account.
     * @param account
     */
    ClientApplication.prototype.setActiveAccount = function (account) {
        if (account) {
            this.logger.verbose("setActiveAccount: Active account set");
            this.activeLocalAccountId = account.localAccountId;
        }
        else {
            this.logger.verbose("setActiveAccount: No account passed, active account not set");
            this.activeLocalAccountId = null;
        }
    };
    /**
     * Gets the currently active account
     */
    ClientApplication.prototype.getActiveAccount = function () {
        if (!this.activeLocalAccountId) {
            this.logger.verbose("getActiveAccount: No active account");
            return null;
        }
        return this.getAccountByLocalId(this.activeLocalAccountId);
    };
    // #endregion
    // #region Helpers
    /**
     *
     * Use to get the redirect uri configured in MSAL or null.
     * @param requestRedirectUri
     * @returns Redirect URL
     *
     */
    ClientApplication.prototype.getRedirectUri = function (requestRedirectUri) {
        this.logger.verbose("getRedirectUri called");
        var redirectUri = requestRedirectUri || this.config.auth.redirectUri || BrowserUtils.getCurrentUri();
        return UrlString.getAbsoluteUrl(redirectUri, BrowserUtils.getCurrentUri());
    };
    /**
     * Use to get the redirectStartPage either from request or use current window
     * @param requestStartPage
     */
    ClientApplication.prototype.getRedirectStartPage = function (requestStartPage) {
        var redirectStartPage = requestStartPage || window.location.href;
        return UrlString.getAbsoluteUrl(redirectStartPage, BrowserUtils.getCurrentUri());
    };
    /**
     * Used to get a discovered version of the default authority.
     * @param requestAuthority
     * @param requestCorrelationId
     */
    ClientApplication.prototype.getDiscoveredAuthority = function (requestAuthority, requestCorrelationId) {
        return __awaiter$1(this, void 0, void 0, function () {
            var authorityOptions;
            return __generator$1(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.logger.verbose("getDiscoveredAuthority called", requestCorrelationId);
                        authorityOptions = {
                            protocolMode: this.config.auth.protocolMode,
                            knownAuthorities: this.config.auth.knownAuthorities,
                            cloudDiscoveryMetadata: this.config.auth.cloudDiscoveryMetadata,
                            authorityMetadata: this.config.auth.authorityMetadata
                        };
                        if (!requestAuthority) return [3 /*break*/, 2];
                        this.logger.verbose("Creating discovered authority with request authority", requestCorrelationId);
                        return [4 /*yield*/, AuthorityFactory.createDiscoveredInstance(requestAuthority, this.config.system.networkClient, this.browserStorage, authorityOptions)];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        this.logger.verbose("Creating discovered authority with configured authority", requestCorrelationId);
                        return [4 /*yield*/, AuthorityFactory.createDiscoveredInstance(this.config.auth.authority, this.config.system.networkClient, this.browserStorage, authorityOptions)];
                    case 3: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Helper to check whether interaction is in progress.
     */
    ClientApplication.prototype.interactionInProgress = function () {
        // Check whether value in cache is present and equal to expected value
        return (this.browserStorage.getTemporaryCache(TemporaryCacheKeys.INTERACTION_STATUS_KEY, true)) === BrowserConstants.INTERACTION_IN_PROGRESS_VALUE;
    };
    /**
     * Creates an Authorization Code Client with the given authority, or the default authority.
     * @param serverTelemetryManager
     * @param authorityUrl
     */
    ClientApplication.prototype.createAuthCodeClient = function (serverTelemetryManager, authorityUrl, correlationId) {
        return __awaiter$1(this, void 0, void 0, function () {
            var clientConfig;
            return __generator$1(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getClientConfiguration(serverTelemetryManager, authorityUrl, correlationId)];
                    case 1:
                        clientConfig = _a.sent();
                        return [2 /*return*/, new AuthorizationCodeClient(clientConfig)];
                }
            });
        });
    };
    /**
     * Creates an Silent Flow Client with the given authority, or the default authority.
     * @param serverTelemetryManager
     * @param authorityUrl
     */
    ClientApplication.prototype.createSilentFlowClient = function (serverTelemetryManager, authorityUrl, correlationId) {
        return __awaiter$1(this, void 0, void 0, function () {
            var clientConfig;
            return __generator$1(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getClientConfiguration(serverTelemetryManager, authorityUrl, correlationId)];
                    case 1:
                        clientConfig = _a.sent();
                        return [2 /*return*/, new SilentFlowClient(clientConfig)];
                }
            });
        });
    };
    /**
     * Creates a Refresh Client with the given authority, or the default authority.
     * @param serverTelemetryManager
     * @param authorityUrl
     */
    ClientApplication.prototype.createRefreshTokenClient = function (serverTelemetryManager, authorityUrl, correlationId) {
        return __awaiter$1(this, void 0, void 0, function () {
            var clientConfig;
            return __generator$1(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getClientConfiguration(serverTelemetryManager, authorityUrl, correlationId)];
                    case 1:
                        clientConfig = _a.sent();
                        return [2 /*return*/, new RefreshTokenClient(clientConfig)];
                }
            });
        });
    };
    /**
     * Creates a Client Configuration object with the given request authority, or the default authority.
     * @param serverTelemetryManager
     * @param requestAuthority
     * @param requestCorrelationId
     */
    ClientApplication.prototype.getClientConfiguration = function (serverTelemetryManager, requestAuthority, requestCorrelationId) {
        return __awaiter$1(this, void 0, void 0, function () {
            var discoveredAuthority;
            return __generator$1(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.logger.verbose("getClientConfiguration called", requestCorrelationId);
                        return [4 /*yield*/, this.getDiscoveredAuthority(requestAuthority, requestCorrelationId)];
                    case 1:
                        discoveredAuthority = _a.sent();
                        return [2 /*return*/, {
                                authOptions: {
                                    clientId: this.config.auth.clientId,
                                    authority: discoveredAuthority,
                                    clientCapabilities: this.config.auth.clientCapabilities
                                },
                                systemOptions: {
                                    tokenRenewalOffsetSeconds: this.config.system.tokenRenewalOffsetSeconds,
                                    preventCorsPreflight: true
                                },
                                loggerOptions: {
                                    loggerCallback: this.config.system.loggerOptions.loggerCallback,
                                    piiLoggingEnabled: this.config.system.loggerOptions.piiLoggingEnabled,
                                    logLevel: this.config.system.loggerOptions.logLevel,
                                    correlationId: requestCorrelationId
                                },
                                cryptoInterface: this.browserCrypto,
                                networkInterface: this.networkClient,
                                storageInterface: this.browserStorage,
                                serverTelemetryManager: serverTelemetryManager,
                                libraryInfo: {
                                    sku: BrowserConstants.MSAL_SKU,
                                    version: version$4,
                                    cpu: "",
                                    os: ""
                                }
                            }];
                }
            });
        });
    };
    /**
     * Helper to validate app environment before making a request.
     * @param request
     * @param interactionType
     */
    ClientApplication.prototype.preflightInteractiveRequest = function (request, interactionType) {
        this.logger.verbose("preflightInteractiveRequest called, validating app environment", request === null || request === void 0 ? void 0 : request.correlationId);
        // block the reload if it occurred inside a hidden iframe
        BrowserUtils.blockReloadInHiddenIframes();
        // Check if interaction is in progress. Throw error if true.
        if (this.interactionInProgress()) {
            throw BrowserAuthError.createInteractionInProgressError();
        }
        return this.initializeAuthorizationRequest(request, interactionType);
    };
    /**
     * Helper to validate app environment before making an auth request
     * * @param interactionType
     */
    ClientApplication.prototype.preflightBrowserEnvironmentCheck = function (interactionType) {
        this.logger.verbose("preflightBrowserEnvironmentCheck started");
        // Block request if not in browser environment
        BrowserUtils.blockNonBrowserEnvironment(this.isBrowserEnvironment);
        // Block redirects if in an iframe
        BrowserUtils.blockRedirectInIframe(interactionType, this.config.system.allowRedirectInIframe);
        // Block auth requests inside a hidden iframe
        BrowserUtils.blockReloadInHiddenIframes();
        // Block redirectUri opened in a popup from calling MSAL APIs
        BrowserUtils.blockAcquireTokenInPopups();
        // Block redirects if memory storage is enabled but storeAuthStateInCookie is not
        if (interactionType === InteractionType.Redirect &&
            this.config.cache.cacheLocation === BrowserCacheLocation.MemoryStorage &&
            !this.config.cache.storeAuthStateInCookie) {
            throw BrowserConfigurationAuthError.createInMemoryRedirectUnavailableError();
        }
    };
    /**
     * Initializer function for all request APIs
     * @param request
     */
    ClientApplication.prototype.initializeBaseRequest = function (request) {
        this.logger.verbose("Initializing BaseAuthRequest", request.correlationId);
        var authority = request.authority || this.config.auth.authority;
        var scopes = __spread(((request && request.scopes) || []));
        var correlationId = (request && request.correlationId) || this.browserCrypto.createNewGuid();
        // Set authenticationScheme to BEARER if not explicitly set in the request
        if (!request.authenticationScheme) {
            request.authenticationScheme = AuthenticationScheme.BEARER;
            this.logger.verbose("Authentication Scheme wasn't explicitly set in request, defaulting to \"Bearer\" request", request.correlationId);
        }
        else {
            this.logger.verbose("Authentication Scheme set to \"" + request.authenticationScheme + "\" as configured in Auth request", request.correlationId);
        }
        var validatedRequest = __assign$1(__assign$1({}, request), { correlationId: correlationId,
            authority: authority,
            scopes: scopes });
        return validatedRequest;
    };
    /**
     *
     * @param apiId
     * @param correlationId
     * @param forceRefresh
     */
    ClientApplication.prototype.initializeServerTelemetryManager = function (apiId, correlationId, forceRefresh) {
        this.logger.verbose("initializeServerTelemetryManager called", correlationId);
        var telemetryPayload = {
            clientId: this.config.auth.clientId,
            correlationId: correlationId,
            apiId: apiId,
            forceRefresh: forceRefresh || false,
            wrapperSKU: this.wrapperSKU,
            wrapperVer: this.wrapperVer
        };
        return new ServerTelemetryManager(telemetryPayload, this.browserStorage);
    };
    /**
     * Helper to initialize required request parameters for interactive APIs and ssoSilent()
     * @param request
     * @param interactionType
     */
    ClientApplication.prototype.initializeAuthorizationRequest = function (request, interactionType) {
        this.logger.verbose("initializeAuthorizationRequest called", request.correlationId);
        var redirectUri = this.getRedirectUri(request.redirectUri);
        var browserState = {
            interactionType: interactionType
        };
        var state = ProtocolUtils.setRequestState(this.browserCrypto, (request && request.state) || "", browserState);
        var validatedRequest = __assign$1(__assign$1({}, this.initializeBaseRequest(request)), { redirectUri: redirectUri, state: state, nonce: request.nonce || this.browserCrypto.createNewGuid(), responseMode: ResponseMode.FRAGMENT });
        var account = request.account || this.getActiveAccount();
        if (account) {
            this.logger.verbose("Setting validated request account");
            this.logger.verbosePii("Setting validated request account: " + account);
            validatedRequest.account = account;
        }
        // Check for ADAL SSO
        if (StringUtils.isEmpty(validatedRequest.loginHint)) {
            // Only check for adal token if no SSO params are being used
            var adalIdTokenString = this.browserStorage.getTemporaryCache(PersistentCacheKeys.ADAL_ID_TOKEN);
            if (adalIdTokenString) {
                var adalIdToken = new AuthToken(adalIdTokenString, this.browserCrypto);
                this.browserStorage.removeItem(PersistentCacheKeys.ADAL_ID_TOKEN);
                if (adalIdToken.claims && adalIdToken.claims.upn) {
                    this.logger.verbose("No SSO params used and ADAL token retrieved, setting ADAL upn as loginHint");
                    validatedRequest.loginHint = adalIdToken.claims.upn;
                }
            }
        }
        this.browserStorage.updateCacheEntries(validatedRequest.state, validatedRequest.nonce, validatedRequest.authority, validatedRequest.loginHint || "", validatedRequest.account || null);
        return validatedRequest;
    };
    /**
     * Generates an auth code request tied to the url request.
     * @param request
     */
    ClientApplication.prototype.initializeAuthorizationCodeRequest = function (request) {
        return __awaiter$1(this, void 0, void 0, function () {
            var generatedPkceParams, authCodeRequest;
            return __generator$1(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.logger.verbose("initializeAuthorizationRequest called", request.correlationId);
                        return [4 /*yield*/, this.browserCrypto.generatePkceCodes()];
                    case 1:
                        generatedPkceParams = _a.sent();
                        authCodeRequest = __assign$1(__assign$1({}, request), { redirectUri: request.redirectUri, code: "", codeVerifier: generatedPkceParams.verifier });
                        request.codeChallenge = generatedPkceParams.challenge;
                        request.codeChallengeMethod = Constants.S256_CODE_CHALLENGE_METHOD;
                        return [2 /*return*/, authCodeRequest];
                }
            });
        });
    };
    /**
     * Initializer for the logout request.
     * @param logoutRequest
     */
    ClientApplication.prototype.initializeLogoutRequest = function (logoutRequest) {
        this.logger.verbose("initializeLogoutRequest called", logoutRequest === null || logoutRequest === void 0 ? void 0 : logoutRequest.correlationId);
        // Check if interaction is in progress. Throw error if true.
        if (this.interactionInProgress()) {
            throw BrowserAuthError.createInteractionInProgressError();
        }
        var validLogoutRequest = __assign$1({ correlationId: this.browserCrypto.createNewGuid() }, logoutRequest);
        /*
         * Only set redirect uri if logout request isn't provided or the set uri isn't null.
         * Otherwise, use passed uri, config, or current page.
         */
        if (!logoutRequest || logoutRequest.postLogoutRedirectUri !== null) {
            if (logoutRequest && logoutRequest.postLogoutRedirectUri) {
                this.logger.verbose("Setting postLogoutRedirectUri to uri set on logout request", validLogoutRequest.correlationId);
                validLogoutRequest.postLogoutRedirectUri = UrlString.getAbsoluteUrl(logoutRequest.postLogoutRedirectUri, BrowserUtils.getCurrentUri());
            }
            else if (this.config.auth.postLogoutRedirectUri === null) {
                this.logger.verbose("postLogoutRedirectUri configured as null and no uri set on request, not passing post logout redirect", validLogoutRequest.correlationId);
            }
            else if (this.config.auth.postLogoutRedirectUri) {
                this.logger.verbose("Setting postLogoutRedirectUri to configured uri", validLogoutRequest.correlationId);
                validLogoutRequest.postLogoutRedirectUri = UrlString.getAbsoluteUrl(this.config.auth.postLogoutRedirectUri, BrowserUtils.getCurrentUri());
            }
            else {
                this.logger.verbose("Setting postLogoutRedirectUri to current page", validLogoutRequest.correlationId);
                validLogoutRequest.postLogoutRedirectUri = UrlString.getAbsoluteUrl(BrowserUtils.getCurrentUri(), BrowserUtils.getCurrentUri());
            }
        }
        else {
            this.logger.verbose("postLogoutRedirectUri passed as null, not setting post logout redirect uri", validLogoutRequest.correlationId);
        }
        return validLogoutRequest;
    };
    /**
     * Adds event callbacks to array
     * @param callback
     */
    ClientApplication.prototype.addEventCallback = function (callback) {
        return this.eventHandler.addEventCallback(callback);
    };
    /**
     * Removes callback with provided id from callback array
     * @param callbackId
     */
    ClientApplication.prototype.removeEventCallback = function (callbackId) {
        this.eventHandler.removeEventCallback(callbackId);
    };
    /**
     * Returns the logger instance
     */
    ClientApplication.prototype.getLogger = function () {
        return this.logger;
    };
    /**
     * Replaces the default logger set in configurations with new Logger with new configurations
     * @param logger Logger instance
     */
    ClientApplication.prototype.setLogger = function (logger) {
        this.logger = logger;
    };
    /**
     * Called by wrapper libraries (Angular & React) to set SKU and Version passed down to telemetry, logger, etc.
     * @param sku
     * @param version
     */
    ClientApplication.prototype.initializeWrapperLibrary = function (sku, version) {
        // Validate the SKU passed in is one we expect
        this.wrapperSKU = sku;
        this.wrapperVer = version;
    };
    /**
     * Sets navigation client
     * @param navigationClient
     */
    ClientApplication.prototype.setNavigationClient = function (navigationClient) {
        this.navigationClient = navigationClient;
    };
    return ClientApplication;
}());

/*! @azure/msal-browser v2.15.0 2021-06-29 */

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * The PublicClientApplication class is the object exposed by the library to perform authentication and authorization functions in Single Page Applications
 * to obtain JWT tokens as described in the OAuth 2.0 Authorization Code Flow with PKCE specification.
 */
var PublicClientApplication = /** @class */ (function (_super) {
    __extends$1(PublicClientApplication, _super);
    /**
     * @constructor
     * Constructor for the PublicClientApplication used to instantiate the PublicClientApplication object
     *
     * Important attributes in the Configuration object for auth are:
     * - clientID: the application ID of your application. You can obtain one by registering your application with our Application registration portal : https://portal.azure.com/#blade/Microsoft_AAD_IAM/ActiveDirectoryMenuBlade/RegisteredAppsPreview
     * - authority: the authority URL for your application.
     * - redirect_uri: the uri of your application registered in the portal.
     *
     * In Azure AD, authority is a URL indicating the Azure active directory that MSAL uses to obtain tokens.
     * It is of the form https://login.microsoftonline.com/{Enter_the_Tenant_Info_Here}
     * If your application supports Accounts in one organizational directory, replace "Enter_the_Tenant_Info_Here" value with the Tenant Id or Tenant name (for example, contoso.microsoft.com).
     * If your application supports Accounts in any organizational directory, replace "Enter_the_Tenant_Info_Here" value with organizations.
     * If your application supports Accounts in any organizational directory and personal Microsoft accounts, replace "Enter_the_Tenant_Info_Here" value with common.
     * To restrict support to Personal Microsoft accounts only, replace "Enter_the_Tenant_Info_Here" value with consumers.
     *
     * In Azure B2C, authority is of the form https://{instance}/tfp/{tenant}/{policyName}/
     * Full B2C functionality will be available in this library in future versions.
     *
     * @param configuration object for the MSAL PublicClientApplication instance
     */
    function PublicClientApplication(configuration) {
        return _super.call(this, configuration) || this;
    }
    /**
     * Use when initiating the login process by redirecting the user's browser to the authorization endpoint. This function redirects the page, so
     * any code that follows this function will not execute.
     *
     * IMPORTANT: It is NOT recommended to have code that is dependent on the resolution of the Promise. This function will navigate away from the current
     * browser window. It currently returns a Promise in order to reflect the asynchronous nature of the code running in this function.
     *
     * @param request
     */
    PublicClientApplication.prototype.loginRedirect = function (request) {
        return __awaiter$1(this, void 0, void 0, function () {
            return __generator$1(this, function (_a) {
                this.logger.verbose("loginRedirect called");
                return [2 /*return*/, this.acquireTokenRedirect(request || DEFAULT_REQUEST)];
            });
        });
    };
    /**
     * Use when initiating the login process via opening a popup window in the user's browser
     *
     * @param request
     *
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */
    PublicClientApplication.prototype.loginPopup = function (request) {
        this.logger.verbose("loginPopup called");
        return this.acquireTokenPopup(request || DEFAULT_REQUEST);
    };
    /**
     * Silently acquire an access token for a given set of scopes. Will use cached token if available, otherwise will attempt to acquire a new token from the network via refresh token.
     *
     * @param {@link (SilentRequest:type)}
     * @returns {Promise.<AuthenticationResult>} - a promise that is fulfilled when this function has completed, or rejected if an error was raised. Returns the {@link AuthResponse} object
     */
    PublicClientApplication.prototype.acquireTokenSilent = function (request) {
        return __awaiter$1(this, void 0, void 0, function () {
            var account, silentRequest, browserRequestLogger, serverTelemetryManager, silentAuthClient, cachedToken, tokenRenewalResult, tokenRenewalError_1;
            return __generator$1(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.preflightBrowserEnvironmentCheck(InteractionType.Silent);
                        this.logger.verbose("acquireTokenSilent called", request.correlationId);
                        account = request.account || this.getActiveAccount();
                        if (!account) {
                            throw BrowserAuthError.createNoAccountError();
                        }
                        silentRequest = __assign$1(__assign$1(__assign$1({}, request), this.initializeBaseRequest(request)), { account: account, forceRefresh: request.forceRefresh || false });
                        browserRequestLogger = this.logger.clone(name$s, version$4, silentRequest.correlationId);
                        this.eventHandler.emitEvent(EventType.ACQUIRE_TOKEN_START, InteractionType.Silent, request);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 9]);
                        serverTelemetryManager = this.initializeServerTelemetryManager(ApiId.acquireTokenSilent_silentFlow, silentRequest.correlationId);
                        return [4 /*yield*/, this.createSilentFlowClient(serverTelemetryManager, silentRequest.authority, silentRequest.correlationId)];
                    case 2:
                        silentAuthClient = _a.sent();
                        browserRequestLogger.verbose("Silent auth client created");
                        return [4 /*yield*/, silentAuthClient.acquireCachedToken(silentRequest)];
                    case 3:
                        cachedToken = _a.sent();
                        this.eventHandler.emitEvent(EventType.ACQUIRE_TOKEN_SUCCESS, InteractionType.Silent, cachedToken);
                        return [2 /*return*/, cachedToken];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5:
                        _a.trys.push([5, 7, , 8]);
                        return [4 /*yield*/, this.acquireTokenByRefreshToken(silentRequest)];
                    case 6:
                        tokenRenewalResult = _a.sent();
                        this.eventHandler.emitEvent(EventType.ACQUIRE_TOKEN_SUCCESS, InteractionType.Silent, tokenRenewalResult);
                        return [2 /*return*/, tokenRenewalResult];
                    case 7:
                        tokenRenewalError_1 = _a.sent();
                        this.eventHandler.emitEvent(EventType.ACQUIRE_TOKEN_FAILURE, InteractionType.Silent, null, tokenRenewalError_1);
                        throw tokenRenewalError_1;
                    case 8: return [3 /*break*/, 9];
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    return PublicClientApplication;
}(ClientApplication));

/*! @azure/msal-browser v2.15.0 2021-06-29 */

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
var stubbedPublicClientApplication = {
    acquireTokenPopup: function () {
        return Promise.reject(BrowserConfigurationAuthError.createStubPcaInstanceCalledError());
    },
    acquireTokenRedirect: function () {
        return Promise.reject(BrowserConfigurationAuthError.createStubPcaInstanceCalledError());
    },
    acquireTokenSilent: function () {
        return Promise.reject(BrowserConfigurationAuthError.createStubPcaInstanceCalledError());
    },
    getAllAccounts: function () {
        return [];
    },
    getAccountByHomeId: function () {
        return null;
    },
    getAccountByUsername: function () {
        return null;
    },
    getAccountByLocalId: function () {
        return null;
    },
    handleRedirectPromise: function () {
        return Promise.reject(BrowserConfigurationAuthError.createStubPcaInstanceCalledError());
    },
    loginPopup: function () {
        return Promise.reject(BrowserConfigurationAuthError.createStubPcaInstanceCalledError());
    },
    loginRedirect: function () {
        return Promise.reject(BrowserConfigurationAuthError.createStubPcaInstanceCalledError());
    },
    logout: function () {
        return Promise.reject(BrowserConfigurationAuthError.createStubPcaInstanceCalledError());
    },
    logoutRedirect: function () {
        return Promise.reject(BrowserConfigurationAuthError.createStubPcaInstanceCalledError());
    },
    logoutPopup: function () {
        return Promise.reject(BrowserConfigurationAuthError.createStubPcaInstanceCalledError());
    },
    ssoSilent: function () {
        return Promise.reject(BrowserConfigurationAuthError.createStubPcaInstanceCalledError());
    },
    addEventCallback: function () {
        return null;
    },
    removeEventCallback: function () {
        return;
    },
    getLogger: function () {
        throw BrowserConfigurationAuthError.createStubPcaInstanceCalledError();
    },
    setLogger: function () {
        return;
    },
    setActiveAccount: function () {
        return;
    },
    getActiveAccount: function () {
        return null;
    },
    initializeWrapperLibrary: function () {
        return;
    },
    setNavigationClient: function () {
        return;
    }
};

/*! @azure/msal-browser v2.15.0 2021-06-29 */

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
var EventMessageUtils = /** @class */ (function () {
    function EventMessageUtils() {
    }
    /**
     * Gets interaction status from event message
     * @param message
     */
    EventMessageUtils.getInteractionStatusFromEvent = function (message) {
        switch (message.eventType) {
            case EventType.LOGIN_START:
                return InteractionStatus.Login;
            case EventType.SSO_SILENT_START:
                return InteractionStatus.SsoSilent;
            case EventType.ACQUIRE_TOKEN_START:
                if (message.interactionType === InteractionType.Redirect || message.interactionType === InteractionType.Popup) {
                    return InteractionStatus.AcquireToken;
                }
                break;
            case EventType.HANDLE_REDIRECT_START:
                return InteractionStatus.HandleRedirect;
            case EventType.LOGOUT_START:
                return InteractionStatus.Logout;
            case EventType.LOGIN_SUCCESS:
            case EventType.SSO_SILENT_SUCCESS:
            case EventType.HANDLE_REDIRECT_END:
            case EventType.LOGIN_FAILURE:
            case EventType.SSO_SILENT_FAILURE:
            case EventType.LOGOUT_END:
                return InteractionStatus.None;
            case EventType.ACQUIRE_TOKEN_SUCCESS:
            case EventType.ACQUIRE_TOKEN_FAILURE:
                if (message.interactionType === InteractionType.Redirect || message.interactionType === InteractionType.Popup) {
                    return InteractionStatus.None;
                }
                break;
        }
        return null;
    };
    return EventMessageUtils;
}());

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/*
 * Stubbed context implementation
 * Only used when there is no provider, which is an unsupported scenario
 */

const defaultMsalContext = {
  instance: stubbedPublicClientApplication,
  inProgress: InteractionStatus.None,
  accounts: [],
  logger: /*#__PURE__*/new Logger$1({})
};
const MsalContext = /*#__PURE__*/createContext(defaultMsalContext);
MsalContext.Consumer;
/**
 * Helper function to determine whether 2 arrays are equal
 * Used to avoid unnecessary state updates
 * @param arrayA
 * @param arrayB
 */

function accountArraysAreEqual(arrayA, arrayB) {
  if (arrayA.length !== arrayB.length) {
    return false;
  }

  const comparisonArray = [...arrayB];
  return arrayA.every(elementA => {
    const elementB = comparisonArray.shift();

    if (!elementA || !elementB) {
      return false;
    }

    return elementA.homeAccountId === elementB.homeAccountId && elementA.localAccountId === elementB.localAccountId && elementA.username === elementB.username;
  });
}

/* eslint-disable header/header */
const name$r = "@azure/msal-react";
const version$3 = "1.0.1";

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
function MsalProvider({
  instance,
  children
}) {
  useEffect(() => {
    instance.initializeWrapperLibrary(WrapperSKU.React, version$3);
  }, [instance]); // Create a logger instance for msal-react with the same options as PublicClientApplication

  const logger = useMemo(() => {
    return instance.getLogger().clone(name$r, version$3);
  }, [instance]); // State hook to store accounts

  const [accounts, setAccounts] = useState([]); // State hook to store in progress value

  const [inProgress, setInProgress] = useState(InteractionStatus.Startup);
  useEffect(() => {
    const callbackId = instance.addEventCallback(message => {
      switch (message.eventType) {
        case EventType.LOGIN_SUCCESS:
        case EventType.SSO_SILENT_SUCCESS:
        case EventType.HANDLE_REDIRECT_END:
        case EventType.LOGIN_FAILURE:
        case EventType.SSO_SILENT_FAILURE:
        case EventType.LOGOUT_END:
        case EventType.ACQUIRE_TOKEN_SUCCESS:
        case EventType.ACQUIRE_TOKEN_FAILURE:
          const currentAccounts = instance.getAllAccounts();

          if (!accountArraysAreEqual(currentAccounts, accounts)) {
            logger.info("MsalProvider - updating account state");
            setAccounts(currentAccounts);
          } else {
            logger.info("MsalProvider - no account changes");
          }

          break;
      }
    });
    logger.verbose(`MsalProvider - Registered event callback with id: ${callbackId}`);
    return () => {
      // Remove callback when component unmounts or accounts change
      if (callbackId) {
        logger.verbose(`MsalProvider - Removing event callback ${callbackId}`);
        instance.removeEventCallback(callbackId);
      }
    };
  }, [instance, accounts, logger]);
  useEffect(() => {
    const callbackId = instance.addEventCallback(message => {
      const status = EventMessageUtils.getInteractionStatusFromEvent(message);

      if (status !== null) {
        logger.info(`MsalProvider - ${message.eventType} results in setting inProgress to ${status}`);
        setInProgress(status);
      }
    });
    logger.verbose(`MsalProvider - Registered event callback with id: ${callbackId}`);
    instance.handleRedirectPromise().catch(() => {
      // Errors should be handled by listening to the LOGIN_FAILURE event
      return;
    });
    return () => {
      if (callbackId) {
        logger.verbose(`MsalProvider - Removing event callback ${callbackId}`);
        instance.removeEventCallback(callbackId);
      }
    };
  }, [instance, logger]);
  const contextValue = {
    instance,
    inProgress,
    accounts,
    logger
  };
  return React__default.createElement(MsalContext.Provider, {
    value: contextValue
  }, children);
}

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * Returns Msal Context values
 */

const useMsal$1 = () => useContext(MsalContext);

// Config object to be passed to Msal on creation
var msalConfig = {
    alpha: {
        auth: {
            clientId: "a1100b66-002e-42ba-a18d-1bac956d7125",
            authority: "https://login.microsoftonline.com/a03f3f97-b4bb-4c4f-a25a-230231e3891f/",
            redirectUri: "/",
            postLogoutRedirectUri: "/",
        },
        system: {
            tokenRenewalOffsetSeconds: 300,
        }
    },
    dev: {
        auth: {
            clientId: "5193a09f-bb5b-4a73-92ca-e45897070440",
            authority: "https://login.microsoftonline.com/a03f3f97-b4bb-4c4f-a25a-230231e3891f/",
            redirectUri: "/",
            postLogoutRedirectUri: "/",
        },
        system: {
            tokenRenewalOffsetSeconds: 300,
        }
    },
    prod: {
        auth: {
            clientId: "0a91ba7d-c43f-4f76-926e-cf506b3bbd9d",
            authority: "https://login.microsoftonline.com/a03f3f97-b4bb-4c4f-a25a-230231e3891f/",
            redirectUri: "/",
            postLogoutRedirectUri: "/",
        },
        system: {
            tokenRenewalOffsetSeconds: 300,
        }
    }
};
// Add here scopes for id token to be used at MS Identity Platform endpoints.
var loginRequest = {
    scopes: ["User.Read", "AllSites.Read"],
};

var useMsal = function () {
    var instance = useMsal$1().instance;
    var user = useContext(PortalContext).user;
    return {
        getTokenSilent: function () { return __awaiter$2(void 0, void 0, void 0, function () {
            var account, domain, iarroba, silentRequest;
            return __generator$2(this, function (_a) {
                account = instance.getAllAccounts()[0];
                if (account) {
                    domain = "";
                    if ((user === null || user === void 0 ? void 0 : user.upn) != null) {
                        iarroba = user.upn.indexOf("@");
                        if (iarroba)
                            domain = user.upn.substring(iarroba + 1);
                    }
                    silentRequest = { account: account, scopes: loginRequest.scopes, loginHint: user === null || user === void 0 ? void 0 : user.upn, domainHint: domain };
                    return [2 /*return*/, instance.acquireTokenSilent(silentRequest).then(function (accessTokenResponse) {
                            var token = accessTokenResponse.accessToken;
                            //regeneramos la cookie para las imágenes del me interesa...
                            var cookie = "MSAL_TOK=" + token + "; domain=.gco.global; path=/MeInteresa";
                            document.cookie = cookie;
                            return token;
                        })];
                }
                else {
                    throw { message: "Usuario no verificado" };
                }
            });
        }); }
    };
};
var getMsalConfig = function () {
    if (window.location.hostname.startsWith("w") || window.location.hostname.startsWith("localhost")) {
        return msalConfig.alpha;
    }
    else if (window.location.hostname.startsWith("d")) {
        return msalConfig.dev;
        // return msalConfig.alpha;
    }
    else {
        return msalConfig.prod;
        //return msalConfig.alpha;
    }
};

var PortalContext = React__default.createContext({
    user: null,
    menu: null,
    cia: null,
    session: "",
    app: { name: "" },
    contexto: null,
    menuIds: null,
    mostrarMeInteresa: null,
    mostrarConfigurarMiEspacio: null,
    mostrarEventos: null,
    mostrarEnlacePortalAntiguo: null,
    mostrarResultadosFinancieros: null,
    mostrarGestionBuzon: null,
    mostrarUserCodeAppBarUser: null,
    ciaGestiona: ""
});

var logogestiona = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%3Csvg%20version%3D%221.1%22%20id%3D%22Layer_1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%20%20viewBox%3D%220%200%20418.4%20160.9%22%20style%3D%22enable-background%3Anew%200%200%20418.4%20160.9%3B%22%20xml%3Aspace%3D%22preserve%22%3E%3Cstyle%20type%3D%22text%2Fcss%22%3E%20.st0%7Bfill%3A%23FFFFFF%3B%7D%3C%2Fstyle%3E%3Cpath%20class%3D%22st0%22%20d%3D%22M62.4%2C80.5L62.4%2C80.5c0.1%2C8.7-6.7%2C17.6-8.8%2C21.2c-1.3%2C2.1-0.5%2C4.8%2C1.6%2C6s4.4%2C0.2%2C6-1.6%20c6.5-7.3%2C17.6-20.5%2C17.6-25.6S67.7%2C62.1%2C61.2%2C54.9c-1.6-1.8-3.9-2.8-6-1.6s-2.9%2C3.9-1.6%2C6C55.7%2C62.8%2C62.5%2C71.8%2C62.4%2C80.5L62.4%2C80.5%20L62.4%2C80.5z%22%2F%3E%3Cg%3E%20%3Cg%3E%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M131.1%2C86.2v18.3c-3.2%2C1.3-7.6%2C2.7-14%2C2.7c-14.3%2C0-22.5-8-22.5-26.3c0-17.7%2C9.1-26.3%2C23.3-26.3%20%20%20c6.4%2C0%2C11.6%2C1.2%2C12.9%2C1.9v11.2h-4.6v-6.5l-0.8-0.8c-2.1-0.7-4.5-1.2-7.5-1.2c-11%2C0-15.8%2C7.4-15.8%2C21.2c0%2C14.9%2C4.9%2C22.5%2C16.2%2C22.5%20%20%20c2.1%2C0%2C5.1-0.4%2C6.5-1V86.2l-1-1h-4.3v-3.8h16.3v3.8h-3.6L131.1%2C86.2z%22%2F%3E%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M170.1%2C89h-23.2c0.4%2C9.7%2C5.1%2C13.8%2C12.7%2C13.8c4.1%2C0%2C7.5-1%2C9.5-1.9v3.8c-2.5%2C1.4-6.1%2C2.5-11.6%2C2.5%20%20%20c-9.8%2C0-17.4-5.9-17.4-19.5c0-13.9%2C7.5-20.4%2C16.5-20.4c8%2C0%2C14.6%2C5.5%2C14.6%2C15.7v5L170.1%2C89z%20M146.9%2C84.7h17.5v-2.1%20%20%20c0-7.7-3.4-11.1-8-11.1C151%2C71.5%2C147.4%2C75.8%2C146.9%2C84.7z%22%2F%3E%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M188.4%2C107.2c-7.4%2C0-12-1.6-12-1.6v-9.1h4.3v5l1%2C1c1.6%2C0.3%2C3.9%2C0.6%2C7%2C0.6c5.1%2C0%2C8.5-2.4%2C8.5-6.6%20%20%20c0-3.6-2.1-5.4-9-7.1c-9.1-2.3-11.5-6.2-11.5-11.3c0-6.4%2C5.3-10.8%2C14.5-10.8c6.1%2C0%2C10.8%2C1.2%2C10.8%2C1.2v9.1h-4.3v-4.9l-0.9-0.8%20%20%20c-1.3-0.3-3.4-0.6-5.9-0.6c-5.2%2C0-8.1%2C2.3-8.1%2C5.8c0%2C3.1%2C1.3%2C5%2C8.1%2C6.7c9.1%2C2.3%2C12.6%2C5.5%2C12.6%2C11.3%20%20%20C203.4%2C102.8%2C197.1%2C107.2%2C188.4%2C107.2z%22%2F%3E%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M219.1%2C71.8v30l1%2C1.1h9.1v3.6c0%2C0-7.3%2C0.7-10.2%2C0.7c-4.3%2C0-6.6-1.7-6.6-6.4v-29h-5.3v-3.7h4.3l1-1l2.5-9.7%20%20%20h4.2v10.7h8.6v3.7C227.7%2C71.8%2C219.1%2C71.8%2C219.1%2C71.8z%22%2F%3E%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M241.9%2C68c2.3%2C0%2C3%2C1.2%2C3%2C2.9v30.9l1%2C1.1h4.9v3.6h-18.5v-3.6h4.9l1-1.1V72.9l-1-1.1h-4.9V68H241.9z%20%20%20%20M240.8%2C53.1c2.6%2C0%2C4.1%2C1.5%2C4.1%2C3.9c0%2C2.3-1.5%2C3.9-4.1%2C3.9c-2.7%2C0-4.1-1.6-4.1-3.9C236.7%2C54.6%2C238.1%2C53.1%2C240.8%2C53.1z%22%2F%3E%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M269.1%2C107.2c-8.9%2C0-16.6-6.4-16.6-20c0-13.5%2C7.7-20%2C16.6-20s16.7%2C6.4%2C16.7%2C20%20%20%20C285.8%2C100.9%2C278%2C107.2%2C269.1%2C107.2z%20M269.1%2C71.6c-6.1%2C0-9.7%2C5-9.7%2C15.7s3.5%2C15.7%2C9.7%2C15.7c6.1%2C0%2C9.7-5.1%2C9.7-15.7%20%20%20S275.2%2C71.6%2C269.1%2C71.6z%22%2F%3E%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M288.1%2C106.5v-3.6h4.8l1-1.1V72.9l-1-1.1h-4.8V68h9.1c2.4%2C0%2C3.1%2C1.2%2C3.1%2C2.9v2h0.1c2.2-2.4%2C6.4-5.7%2C11.9-5.7%20%20%20c8.3%2C0%2C11.3%2C5.3%2C11.3%2C11.7v22.8l1.1%2C1.1h4.8v3.6h-18v-3.6h4.4l1-1.1V79.9c0-3.8-1-7.5-6.3-7.5c-3.8%2C0-6.9%2C1.4-10.1%2C4.7v24.7%20%20%20l1.1%2C1.1h4.4v3.6L288.1%2C106.5L288.1%2C106.5z%22%2F%3E%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M367.6%2C106.5h-9.1c-2.4%2C0-3.1-1.2-3.1-2.9v-2.1h-0.2c-2%2C2.4-5.6%2C5.8-11.3%2C5.8c-7.5%2C0-11.3-5-11.3-11%20%20%20c0-7.3%2C5.3-11.3%2C12.1-11.3h10.4v-4.2c0-5-1.2-9.2-8.1-9.2c-2.3%2C0-4.5%2C0.6-6.2%2C1.1l-1%2C1v6.1H335V70c3.1-1.1%2C7.7-2.6%2C13.8-2.6%20%20%20c9.9%2C0%2C12.9%2C5.6%2C12.9%2C12.4v22l1%2C1.2h4.9L367.6%2C106.5L367.6%2C106.5z%20M355.1%2C97.6v-8.3h-8.7c-4.2%2C0-7%2C1.7-7%2C6.7%20%20%20c0%2C3.7%2C1.3%2C6.1%2C6.8%2C6.1C349.3%2C102.1%2C352.4%2C100.2%2C355.1%2C97.6z%22%2F%3E%20%3C%2Fg%3E%3C%2Fg%3E%3C%2Fsvg%3E";

var logogco = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%3Csvg%20version%3D%221.1%22%20id%3D%22Capa_1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%20%20width%3D%223124.4px%22%20height%3D%221429.1px%22%20viewBox%3D%220%200%203124.4%201429.1%22%20style%3D%22enable-background%3Anew%200%200%203124.4%201429.1%3B%22%20%20xml%3Aspace%3D%22preserve%22%3E%3Cstyle%20type%3D%22text%2Fcss%22%3E%20.st0%7Bfill%3A%23FFFFFF%3B%7D%3C%2Fstyle%3E%3Cg%3E%20%3Cg%3E%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M1710.9%2C820.5v182.1c-36.4%2C14.7-90.2%2C34.7-176.9%2C34.7c-178.6%2C0-286.2-91.1-286.2-312.2%20%20%20c0-211.6%2C120.5-312.2%2C301.8-312.2c88.4%2C0%2C157.8%2C18.2%2C157.8%2C18.2v164.8h-80.6v-77.2l-13.9-13c-18.2-3.5-39-6.1-63.3-6.1%20%20%20c-117.1%2C0-154.4%2C82.4-154.4%2C213.3c0%2C153.5%2C39%2C239.4%2C163%2C239.4h28.6V820.5l-15.6-15.6h-33v-73.7h212.5v73.7h-25.2L1710.9%2C820.5z%22%2F%3E%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M2247.7%2C1002.6c-35.5%2C15.6-87.6%2C34.7-171.7%2C34.7c-180.4%2C0-287.9-94.5-287.9-311.3%20%20%20c0-210.7%2C123.1-313%2C303.5-313c81.5%2C0%2C145.7%2C18.2%2C145.7%2C18.2v164.8h-84.1v-73.7l-14.7-14.7c-14.7-1.7-29.5-3.5-46.8-3.5%20%20%20c-117.1%2C0-156.1%2C87.6-156.1%2C213.3c0%2C145.7%2C39.9%2C225.5%2C163%2C225.5c18.2%2C0%2C33.8%2C0%2C49.4-1.7l15.6-15.6v-79.8h84.1V1002.6z%22%2F%3E%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M2552%2C412.9c150%2C0%2C260.2%2C100.6%2C260.2%2C312.2s-110.1%2C312.2-260.2%2C312.2c-150%2C0-260.2-100.6-260.2-312.2%20%20%20S2402%2C412.9%2C2552%2C412.9z%20M2552%2C944.5c83.2%2C0%2C112.7-70.2%2C112.7-219.4s-29.5-219.4-112.7-219.4c-83.2%2C0-112.7%2C70.2-112.7%2C219.4%20%20%20S2468.8%2C944.5%2C2552%2C944.5z%22%2F%3E%20%3C%2Fg%3E%20%3Cpath%20class%3D%22st0%22%20d%3D%22M662.3%2C766.7c92.9%2C90.1%2C129.1%2C241.8%2C145.2%2C301.6c9.3%2C35%2C45.3%2C55.8%2C80.3%2C46.4c35-9.4%2C55.8-45.4%2C46.4-80.4%20%20c-16-59.9-60.6-209.2-25.1-333.7c31.6-125.5%2C144.8-232.7%2C188.6-276.4c25.7-25.6%2C25.7-67.2%2C0-92.8c-25.6-25.6-67.2-25.6-92.8%2C0%20%20C961.1%2C375.2%2C854%2C488.4%2C728.5%2C520l0%2C0c-124.5%2C35.4-273.9-9.1-333.7-25.1c-35-9.4-71%2C11.4-80.3%2C46.4c-9.5%2C35%2C11.3%2C71%2C46.3%2C80.4%20%20C420.7%2C637.6%2C572.2%2C673.8%2C662.3%2C766.7L662.3%2C766.7z%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E";

var logo = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%3Csvg%20version%3D%221.1%22%20id%3D%22Capa_1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%20%20width%3D%22387px%22%20height%3D%2283px%22%20viewBox%3D%220%200%20387%2083%22%20style%3D%22enable-background%3Anew%200%200%20387%2083%3B%22%20xml%3Aspace%3D%22preserve%22%3E%3Cstyle%20type%3D%22text%2Fcss%22%3E%20.st0%7Bfill%3A%23FFFFFF%3B%7D%3C%2Fstyle%3E%3Cg%3E%20%3Cg%3E%20%20%3Cg%3E%20%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M65.4%2C63.2c-1.6%2C0-2.9-0.4-2.9-0.4v-2.7h1.3v1.4l0.2%2C0.2c0.4%2C0.1%2C0.8%2C0.1%2C1.4%2C0.1c1.1%2C0%2C1.5-0.5%2C1.5-1.3%20%20%20%20s-0.3-1.1-1.5-1.4c-2-0.5-2.9-1.2-2.9-3.1c0-1.9%2C1.5-2.8%2C3.6-2.8c1.5%2C0%2C2.6%2C0.4%2C2.6%2C0.4v2.6h-1.3v-1.3l-0.2-0.2%20%20%20%20c-0.3-0.1-0.7-0.1-1.1-0.1c-1%2C0-1.5%2C0.5-1.5%2C1.2s0.2%2C1%2C1.7%2C1.5c1.8%2C0.5%2C2.8%2C1.2%2C2.8%2C2.9C69.1%2C62.2%2C67.6%2C63.2%2C65.4%2C63.2z%22%2F%3E%20%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M76%2C59.7h-3.7c0.1%2C1.5%2C0.6%2C2.1%2C2%2C2.1c0.7%2C0%2C1.3-0.2%2C1.5-0.3v1.1c-0.4%2C0.2-1.1%2C0.5-2.3%2C0.5%20%20%20%20c-1.8%2C0-3.4-1-3.4-3.6c0-2.7%2C1.4-3.9%2C3.2-3.9c1.7%2C0%2C2.9%2C1.1%2C2.9%2C3v0.9L76%2C59.7z%20M72.3%2C58.8h1.9v-0.4c0-1.1-0.2-1.6-0.9-1.6%20%20%20%20C72.7%2C56.8%2C72.4%2C57.5%2C72.3%2C58.8z%22%2F%3E%20%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M80.2%2C60.3c-0.3%2C0-0.6%2C0-1-0.1c-0.2%2C0.1-0.3%2C0.3-0.3%2C0.5c0%2C0.3%2C0.2%2C0.4%2C0.6%2C0.4h2.1c1.3%2C0%2C2.3%2C0.4%2C2.3%2C1.9%20%20%20%20c0%2C1.8-1.8%2C2.6-3.9%2C2.6c-1.9%2C0-3-0.4-3-1.6c0-0.6%2C0.5-1%2C1-1.2c-0.5-0.2-0.9-0.7-0.9-1.3s0.3-1.2%2C1.1-1.7c-0.6-0.4-1-1-1-1.9%20%20%20%20c0-1.6%2C1.4-2.3%2C2.9-2.3c0.4%2C0%2C0.8%2C0%2C1.1%2C0.1H84v1h-1l-0.1%2C0.1c0.2%2C0.3%2C0.3%2C0.6%2C0.3%2C1.1C83.2%2C59.5%2C81.8%2C60.3%2C80.2%2C60.3z%20M79%2C62.9%20%20%20%20c-0.1%2C0.1-0.2%2C0.4-0.2%2C0.8c0%2C0.6%2C0.3%2C0.9%2C1.4%2C0.9s1.8-0.3%2C1.8-1.1c0-0.5-0.3-0.6-0.9-0.6H79L79%2C62.9z%20M80.2%2C56.7%20%20%20%20c-0.6%2C0-1%2C0.4-1%2C1.2s0.4%2C1.2%2C1%2C1.2c0.7%2C0%2C1-0.4%2C1-1.2C81.3%2C57.1%2C80.9%2C56.7%2C80.2%2C56.7z%22%2F%3E%20%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M90.9%2C55.7c0.6%2C0%2C0.6%2C0.3%2C0.6%2C0.6v5.5l0.2%2C0.3h0.6v1h-2.2c-0.6%2C0-0.6-0.3-0.6-0.6v-0.2h-0.1%20%20%20%20c-0.2%2C0.2-0.9%2C1-2%2C1c-1.6%2C0-2.1-1-2.1-2.2v-4l-0.2-0.2h-0.6v-1h2.3c0.6%2C0%2C0.6%2C0.3%2C0.6%2C0.6v4.3c0%2C0.4%2C0%2C1%2C0.8%2C1%20%20%20%20c0.5%2C0%2C0.9-0.2%2C1.1-0.4V57l-0.2-0.2h-0.6v-1L90.9%2C55.7L90.9%2C55.7z%22%2F%3E%20%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M96.3%2C62h0.8v1h-4v-1h0.6l0.2-0.3V57l-0.2-0.2h-0.6v-1h2.2c0.6%2C0%2C0.6%2C0.3%2C0.6%2C0.6v0.4H96%20%20%20%20c0.2-0.3%2C0.9-1.1%2C2-1.1c0.3%2C0%2C0.5%2C0%2C0.5%2C0v2.9h-1.2v-1l-0.2-0.2c-0.4%2C0.1-0.8%2C0.2-1%2C0.4v4.1L96.3%2C62z%22%2F%3E%20%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M102.6%2C63.2c-1.9%2C0-3.3-1.2-3.3-3.8s1.4-3.8%2C3.3-3.8s3.3%2C1.2%2C3.3%2C3.8S104.5%2C63.2%2C102.6%2C63.2z%20M102.6%2C56.9%20%20%20%20c-0.9%2C0-1.2%2C0.8-1.2%2C2.5s0.2%2C2.5%2C1.2%2C2.5c0.9%2C0%2C1.2-0.8%2C1.2-2.5C103.8%2C57.7%2C103.5%2C56.9%2C102.6%2C56.9z%22%2F%3E%20%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M109.3%2C63.2c-1.5%2C0-2.4-0.3-2.4-0.3v-2h1.1v0.9l0.2%2C0.2c0.3%2C0%2C0.6%2C0.1%2C1%2C0.1c0.8%2C0%2C1.1-0.4%2C1.1-0.9%20%20%20%20s-0.2-0.8-1.3-1c-1.7-0.3-2.1-1.3-2.1-2.2c0-1.5%2C1.1-2.3%2C2.9-2.3c1.2%2C0%2C2.1%2C0.2%2C2.1%2C0.2v2h-1.1V57l-0.2-0.2%20%20%20%20c-0.2%2C0-0.5-0.1-0.7-0.1c-0.7%2C0-1.1%2C0.3-1.1%2C0.7s0%2C0.8%2C1.1%2C1c1.8%2C0.4%2C2.5%2C1%2C2.5%2C2.1C112.4%2C62.3%2C111.1%2C63.2%2C109.3%2C63.2z%22%2F%3E%20%20%3C%2Fg%3E%20%20%3Cg%3E%20%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M73.2%2C48.3c-0.9%2C0.4-2.2%2C0.9-4.3%2C0.9c-4.6%2C0-7.5-2.6-7.5-8.3s3.1-8.3%2C8-8.3c2%2C0%2C3.6%2C0.5%2C3.6%2C0.5v4.4h-2.1%20%20%20%20v-2.1L70.5%2C35c-0.3%2C0-0.7-0.1-1.1-0.1c-3.2%2C0-4.1%2C2.1-4.1%2C5.7c0%2C4.1%2C1%2C6.2%2C4.3%2C6.2c0.4%2C0%2C0.8%2C0%2C1.1%2C0l0.4-0.4v-2.2h2.1V48.3z%22%2F%3E%20%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M85.9%2C49h-3.7c-0.9%2C0-1.1-0.5-1.1-1v-0.4H81c-0.4%2C0.4-1.5%2C1.6-3.3%2C1.6c-2.6%2C0-3.5-1.7-3.5-3.7%20%20%20%20c0-2.2%2C1.6-3.4%2C4.1-3.4H81V41c0-1.3-0.1-2.3-2-2.3c-0.3%2C0-0.7%2C0-1%2C0.1l-0.3%2C0.3v1.6h-2.1v-3.5c0%2C0%2C1.9-0.7%2C4.8-0.7%20%20%20%20c3.3%2C0%2C4.3%2C1.8%2C4.3%2C3.9v6.4l0.4%2C0.4h1L85.9%2C49L85.9%2C49z%20M81%2C46v-2h-1.6c-1.1%2C0-1.5%2C0.5-1.5%2C1.2c0%2C1%2C0.3%2C1.4%2C1.4%2C1.4%20%20%20%20C80%2C46.6%2C80.7%2C46.3%2C81%2C46z%22%2F%3E%20%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M91.4%2C38.5v8.4l0.4%2C0.4H94V49c0%2C0-1.5%2C0.2-3.1%2C0.2c-2%2C0-3-0.7-3-2.8v-7.8h-1.4v-1.7h1l0.4-0.4l1.3-2.9h2.2%20%20%20%20v3.3H94v1.7L91.4%2C38.5L91.4%2C38.5z%22%2F%3E%20%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M106.2%2C49h-3.7c-0.9%2C0-1.1-0.5-1.1-1v-0.4h-0.1c-0.4%2C0.4-1.5%2C1.6-3.3%2C1.6c-2.6%2C0-3.5-1.7-3.5-3.7%20%20%20%20c0-2.2%2C1.6-3.4%2C4.1-3.4h2.6V41c0-1.3-0.1-2.3-2-2.3c-0.3%2C0-0.7%2C0-1%2C0.1l-0.3%2C0.3v1.6h-2.1v-3.5c0%2C0%2C1.9-0.7%2C4.8-0.7%20%20%20%20c3.3%2C0%2C4.3%2C1.8%2C4.3%2C3.9v6.4l0.4%2C0.4h1L106.2%2C49L106.2%2C49z%20M101.3%2C46v-2h-1.6c-1.1%2C0-1.5%2C0.5-1.5%2C1.2c0%2C1%2C0.3%2C1.4%2C1.4%2C1.4%20%20%20%20C100.3%2C46.6%2C100.9%2C46.3%2C101.3%2C46z%22%2F%3E%20%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M110.7%2C32.2c0.9%2C0%2C1.1%2C0.5%2C1.1%2C1v13.7l0.4%2C0.4h1V49h-6.3v-1.7h1l0.4-0.4V34.3l-0.4-0.4h-1v-1.7%20%20%20%20C106.9%2C32.2%2C110.7%2C32.2%2C110.7%2C32.2z%22%2F%3E%20%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M125.5%2C49h-3.7c-0.9%2C0-1.1-0.5-1.1-1v-0.4h-0.1c-0.4%2C0.4-1.5%2C1.6-3.3%2C1.6c-2.6%2C0-3.5-1.7-3.5-3.7%20%20%20%20c0-2.2%2C1.6-3.4%2C4.1-3.4h2.6V41c0-1.3-0.1-2.3-2-2.3c-0.3%2C0-0.7%2C0-1%2C0.1l-0.3%2C0.3v1.6H115v-3.5c0%2C0%2C1.9-0.7%2C4.8-0.7%20%20%20%20c3.3%2C0%2C4.3%2C1.8%2C4.3%2C3.9v6.4l0.4%2C0.4h1L125.5%2C49L125.5%2C49z%20M120.6%2C46v-2H119c-1.1%2C0-1.5%2C0.5-1.5%2C1.2c0%2C1%2C0.3%2C1.4%2C1.4%2C1.4%20%20%20%20C119.6%2C46.6%2C120.2%2C46.3%2C120.6%2C46z%22%2F%3E%20%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M126.3%2C49v-1.7h1l0.4-0.4v-8l-0.4-0.4h-1v-1.7h3.7c0.9%2C0%2C1.1%2C0.5%2C1.1%2C1v0.4h0.1c0.4-0.4%2C1.6-1.6%2C3.4-1.6%20%20%20%20c2.7%2C0%2C3.5%2C1.7%2C3.5%2C3.7v6.6l0.4%2C0.4h1V49h-6.1v-1.7h0.8l0.4-0.4v-6.1c0-0.7-0.1-1.6-1.5-1.6c-0.8%2C0-1.5%2C0.4-1.8%2C0.6v7.1l0.4%2C0.4%20%20%20%20h0.8V49H126.3z%22%2F%3E%20%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M151.7%2C49H148c-0.9%2C0-1.1-0.5-1.1-1v-0.4h-0.1c-0.4%2C0.4-1.5%2C1.6-3.3%2C1.6c-2.6%2C0-3.5-1.7-3.5-3.7%20%20%20%20c0-2.2%2C1.6-3.4%2C4.1-3.4h2.6V41c0-1.3-0.1-2.3-2-2.3c-0.3%2C0-0.7%2C0-1%2C0.1l-0.3%2C0.3v1.6h-2.1v-3.5c0%2C0%2C1.9-0.7%2C4.8-0.7%20%20%20%20c3.3%2C0%2C4.3%2C1.8%2C4.3%2C3.9v6.4l0.4%2C0.4h1L151.7%2C49L151.7%2C49z%20M146.8%2C46v-2h-1.6c-1.1%2C0-1.5%2C0.5-1.5%2C1.2c0%2C1%2C0.3%2C1.4%2C1.4%2C1.4%20%20%20%20C145.8%2C46.6%2C146.5%2C46.3%2C146.8%2C46z%22%2F%3E%20%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M162.9%2C49.2c-4.2%2C0-6.9-2.6-6.9-8.3s2.7-8.3%2C6.9-8.3s6.8%2C2.6%2C6.8%2C8.3S167%2C49.2%2C162.9%2C49.2z%20M162.9%2C35.1%20%20%20%20c-2.3%2C0-3%2C1.9-3%2C5.9s0.7%2C5.9%2C3%2C5.9s3-1.9%2C3-5.9S165.2%2C35.1%2C162.9%2C35.1z%22%2F%3E%20%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M180.3%2C48.3c-0.6%2C0.6-2%2C0.9-3.4%2C0.9c-3.1%2C0-5.8-1.8-5.8-6.2s2.8-6.5%2C6.2-6.5c1.8%2C0%2C3.1%2C0.5%2C3.1%2C0.5v4h-2.1%20%20%20%20v-1.8l-0.4-0.4c-0.1%2C0-0.2%2C0-0.3%2C0c-2%2C0-2.9%2C1.5-2.9%2C4.2c0%2C3%2C1.1%2C4%2C3.2%2C4c1%2C0%2C2.1-0.3%2C2.4-0.4V48.3L180.3%2C48.3z%22%2F%3E%20%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M190.9%2C48.3c-0.6%2C0.6-2%2C0.9-3.4%2C0.9c-3.1%2C0-5.8-1.8-5.8-6.2s2.8-6.5%2C6.2-6.5c1.8%2C0%2C3.1%2C0.5%2C3.1%2C0.5v4h-2.1%20%20%20%20v-1.8l-0.4-0.4c-0.1%2C0-0.2%2C0-0.3%2C0c-2%2C0-2.9%2C1.5-2.9%2C4.2c0%2C3%2C1.1%2C4%2C3.2%2C4c1%2C0%2C2.1-0.3%2C2.4-0.4V48.3L190.9%2C48.3z%22%2F%3E%20%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M196%2C36.8c0.9%2C0%2C1.1%2C0.5%2C1.1%2C1v9.1l0.4%2C0.4h1V49h-6.3v-1.7h1l0.4-0.4v-8l-0.4-0.4h-1v-1.7%20%20%20%20C192.2%2C36.8%2C196%2C36.8%2C196%2C36.8z%20M195.1%2C31.9c1.3%2C0%2C2%2C0.7%2C2%2C1.8c0%2C1.1-0.6%2C1.8-2%2C1.8c-1.3%2C0-2-0.7-2-1.8%20%20%20%20C193.2%2C32.6%2C193.8%2C31.9%2C195.1%2C31.9z%22%2F%3E%20%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M208.2%2C49c-0.9%2C0-1.1-0.5-1.1-1v-0.4H207c-0.6%2C0.8-1.8%2C1.6-3.1%2C1.6c-2.4%2C0-4.4-1.8-4.4-6.2s2-6.4%2C4.4-6.4%20%20%20%20c1.1%2C0%2C2.4%2C0.7%2C3%2C1.4v-3.7l-0.4-0.4h-1v-1.7h3.9c0.9%2C0%2C1.1%2C0.5%2C1.1%2C1v13.7l0.4%2C0.4h1V49H208.2L208.2%2C49z%20M206.9%2C45.8v-6%20%20%20%20c-0.6-0.5-1.3-0.6-1.7-0.6c-1.5%2C0-2.1%2C1.1-2.1%2C3.7c0%2C2.6%2C0.5%2C3.7%2C2.1%2C3.7C205.7%2C46.6%2C206.3%2C46.3%2C206.9%2C45.8z%22%2F%3E%20%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M222.4%2C43.5h-6.1c0.1%2C2.6%2C1.1%2C3.5%2C3.3%2C3.5c1.2%2C0%2C2.2-0.4%2C2.6-0.5v1.8c-0.6%2C0.4-1.8%2C0.9-3.7%2C0.9%20%20%20%20c-3%2C0-5.6-1.7-5.6-6.1c0-4.5%2C2.4-6.6%2C5.3-6.6c2.8%2C0%2C4.8%2C1.9%2C4.8%2C4.9V43L222.4%2C43.5z%20M216.4%2C41.9h3.2v-0.6c0-1.8-0.4-2.6-1.4-2.6%20%20%20%20C217%2C38.7%2C216.5%2C39.8%2C216.4%2C41.9z%22%2F%3E%20%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M223.9%2C49v-1.7h1l0.4-0.4v-8l-0.4-0.4h-1v-1.7h3.7c0.9%2C0%2C1.1%2C0.5%2C1.1%2C1v0.4h0.1c0.4-0.4%2C1.6-1.6%2C3.4-1.6%20%20%20%20c2.7%2C0%2C3.5%2C1.7%2C3.5%2C3.7v6.6l0.4%2C0.4h1V49H231v-1.7h0.8l0.4-0.4v-6.1c0-0.7-0.1-1.6-1.5-1.6c-0.8%2C0-1.5%2C0.4-1.8%2C0.6v7.1l0.4%2C0.4%20%20%20%20h0.8V49H223.9z%22%2F%3E%20%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M242.7%2C38.5v8.4l0.4%2C0.4h2.2V49c0%2C0-1.5%2C0.2-3.1%2C0.2c-2%2C0-3-0.7-3-2.8v-7.8h-1.4v-1.7h1l0.4-0.4l1.3-2.9h2.2%20%20%20%20v3.3h2.6v1.7L242.7%2C38.5L242.7%2C38.5z%22%2F%3E%20%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M255.7%2C43.5h-6.1c0.1%2C2.6%2C1.1%2C3.5%2C3.3%2C3.5c1.2%2C0%2C2.2-0.4%2C2.5-0.5v1.8c-0.6%2C0.4-1.8%2C0.9-3.7%2C0.9%20%20%20%20c-3%2C0-5.6-1.7-5.6-6.1c0-4.5%2C2.4-6.6%2C5.3-6.6c2.8%2C0%2C4.8%2C1.9%2C4.8%2C4.9V43L255.7%2C43.5z%20M249.6%2C41.9h3.2v-0.6c0-1.8-0.4-2.6-1.4-2.6%20%20%20%20C250.3%2C38.7%2C249.7%2C39.8%2C249.6%2C41.9z%22%2F%3E%20%20%3C%2Fg%3E%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M33.9%2C48.8c4.6%2C4.5%2C6.4%2C12%2C7.2%2C14.9c0.5%2C1.7%2C2.2%2C2.8%2C4%2C2.3c1.7-0.5%2C2.8-2.2%2C2.3-4c-0.8-3-3-10.4-1.2-16.5%20%20%20c1.6-6.2%2C7.2-11.5%2C9.3-13.7c1.3-1.3%2C1.3-3.3%2C0-4.6c-1.3-1.3-3.3-1.3-4.6%2C0c-2.2%2C2.2-7.5%2C7.8-13.7%2C9.3l0%2C0%20%20%20C31%2C38.3%2C23.6%2C36%2C20.7%2C35.3c-1.7-0.5-3.5%2C0.6-4%2C2.3s0.6%2C3.5%2C2.3%2C4C21.9%2C42.4%2C29.4%2C44.2%2C33.9%2C48.8L33.9%2C48.8z%22%2F%3E%20%3C%2Fg%3E%20%3Cg%3E%20%20%3Cg%3E%20%20%20%3Cg%3E%20%20%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M276.8%2C28.8c-2.1%2C0-3.5-0.5-3.5-0.5v-2.8h1.1v1.7l0.3%2C0.3c0.5%2C0.1%2C1.2%2C0.2%2C2.2%2C0.2c1.8%2C0%2C2.8-0.8%2C2.8-2.2%20%20%20%20%20c0-1.2-0.7-1.8-2.7-2.4c-2.4-0.7-3.6-1.7-3.6-3.5c0-2.1%2C1.8-3.3%2C4.2-3.3c1.8%2C0%2C3.2%2C0.4%2C3.2%2C0.4v2.7h-1.1v-1.6l-0.3-0.3%20%20%20%20%20c-0.5-0.1-1.1-0.2-1.8-0.2c-1.7%2C0-2.7%2C0.7-2.7%2C1.9c0%2C1%2C0.4%2C1.7%2C2.7%2C2.4c2.3%2C0.7%2C3.6%2C1.5%2C3.6%2C3.5%20%20%20%20%20C281.2%2C27.6%2C279.4%2C28.8%2C276.8%2C28.8z%22%2F%3E%20%20%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M289.9%2C24.4h-5.5c0.1%2C2.3%2C1.2%2C3.3%2C3%2C3.3c1%2C0%2C1.8-0.2%2C2.3-0.5v0.9c-0.6%2C0.3-1.5%2C0.6-2.8%2C0.6%20%20%20%20%20c-2.3%2C0-4.1-1.4-4.1-4.6c0-3.3%2C1.8-4.9%2C3.9-4.9c1.9%2C0%2C3.5%2C1.3%2C3.5%2C3.7v1.2L289.9%2C24.4z%20M284.4%2C23.4h4.2v-0.5%20%20%20%20%20c0-1.8-0.8-2.6-1.9-2.6C285.4%2C20.3%2C284.5%2C21.3%2C284.4%2C23.4z%22%2F%3E%20%20%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M294.6%2C27.7h1.3v0.9h-4.6v-0.9h1.1l0.2-0.3v-6.9l-0.2-0.3h-1.1v-0.9h2.2c0.6%2C0%2C0.7%2C0.3%2C0.7%2C0.7v0.5l0%2C0%20%20%20%20%20c0.3-0.4%2C1.3-1.4%2C2.8-1.4c0.3%2C0%2C0.5%2C0%2C0.6%2C0.1v2.9h-1v-1.3l-0.3-0.2c-1%2C0.1-1.7%2C0.6-2.1%2C1v5.8L294.6%2C27.7z%22%2F%3E%20%20%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M306.1%2C24.4h-5.5c0.1%2C2.3%2C1.2%2C3.3%2C3%2C3.3c1%2C0%2C1.8-0.2%2C2.3-0.5v0.9c-0.6%2C0.3-1.5%2C0.6-2.8%2C0.6%20%20%20%20%20c-2.3%2C0-4.1-1.4-4.1-4.6c0-3.3%2C1.8-4.9%2C3.9-4.9c1.9%2C0%2C3.5%2C1.3%2C3.5%2C3.7v1.2L306.1%2C24.4z%20M300.5%2C23.4h4.2v-0.5%20%20%20%20%20c0-1.8-0.8-2.6-1.9-2.6C301.5%2C20.3%2C300.7%2C21.3%2C300.5%2C23.4z%22%2F%3E%20%20%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M307.5%2C28.6v-0.9h1.1l0.2-0.3v-6.9l-0.2-0.3h-1.1v-0.9h2.2c0.6%2C0%2C0.7%2C0.3%2C0.7%2C0.7v0.5l0%2C0%20%20%20%20%20c0.5-0.6%2C1.5-1.4%2C2.9-1.4c1.3%2C0%2C2%2C0.6%2C2.3%2C1.5c0.5-0.6%2C1.5-1.5%2C3-1.5c1.9%2C0%2C2.5%2C1.3%2C2.5%2C2.8v5.4l0.2%2C0.3h1.2v0.9h-4.3v-0.9h1%20%20%20%20%20l0.2-0.3v-5.2c0-0.9-0.2-1.8-1.4-1.8c-0.9%2C0-1.6%2C0.3-2.3%2C1.1c0%2C0.1%2C0%2C0.3%2C0%2C0.4v5.4l0.2%2C0.3h1.1v0.9h-4v-0.9h1l0.3-0.3V22%20%20%20%20%20c0-0.9-0.2-1.8-1.4-1.8c-0.8%2C0-1.6%2C0.3-2.3%2C1.1v5.8l0.3%2C0.3h1v0.9h-4.4V28.6z%22%2F%3E%20%20%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M327.5%2C28.8c-2.1%2C0-3.9-1.5-3.9-4.7s1.8-4.7%2C3.9-4.7s4%2C1.5%2C4%2C4.7S329.6%2C28.8%2C327.5%2C28.8z%20M327.5%2C20.3%20%20%20%20%20c-1.5%2C0-2.3%2C1.2-2.3%2C3.7s0.8%2C3.7%2C2.3%2C3.7s2.3-1.2%2C2.3-3.7S329%2C20.3%2C327.5%2C20.3z%22%2F%3E%20%20%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M335.9%2C28.8c-1.8%2C0-2.9-0.4-2.9-0.4v-2.2h1v1.2l0.2%2C0.2c0.4%2C0.1%2C0.9%2C0.1%2C1.7%2C0.1c1.2%2C0%2C2-0.6%2C2-1.6%20%20%20%20%20c0-0.9-0.5-1.3-2.1-1.7c-2.2-0.5-2.7-1.5-2.7-2.7c0-1.5%2C1.3-2.6%2C3.4-2.6c1.5%2C0%2C2.6%2C0.3%2C2.6%2C0.3v2.2h-1v-1.2l-0.2-0.2%20%20%20%20%20c-0.3-0.1-0.8-0.1-1.4-0.1c-1.2%2C0-1.9%2C0.6-1.9%2C1.4c0%2C0.7%2C0.3%2C1.2%2C1.9%2C1.6c2.2%2C0.5%2C3%2C1.3%2C3%2C2.7C339.5%2C27.7%2C337.9%2C28.8%2C335.9%2C28.8%20%20%20%20%20z%22%2F%3E%20%20%20%3C%2Fg%3E%20%20%20%3Cg%3E%20%20%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M279.2%2C32.7c4%2C0%2C6.9%2C2.7%2C6.9%2C8.3s-2.9%2C8.3-6.9%2C8.3s-6.9-2.7-6.9-8.3S275.3%2C32.7%2C279.2%2C32.7z%20M279.2%2C46.7%20%20%20%20%20c2.2%2C0%2C3-1.9%2C3-5.8s-0.8-5.8-3-5.8s-3%2C1.9-3%2C5.8S277%2C46.7%2C279.2%2C46.7z%22%2F%3E%20%20%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M296.4%2C48.3c-0.6%2C0.6-2%2C0.9-3.4%2C0.9c-3.1%2C0-5.9-2-5.9-6.2c0-4.3%2C2.8-6.5%2C6.2-6.5c1.8%2C0%2C3.1%2C0.5%2C3.1%2C0.5v4%20%20%20%20%20h-2.2v-1.9l-0.4-0.4c-0.1%2C0-0.2%2C0-0.3%2C0c-2%2C0-2.8%2C1.5-2.8%2C4.2s1.1%2C4%2C3.2%2C4c1%2C0%2C2.1-0.3%2C2.4-0.4L296.4%2C48.3L296.4%2C48.3z%22%2F%3E%20%20%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M306.6%2C48.3c-0.6%2C0.6-2%2C0.9-3.4%2C0.9c-3.1%2C0-5.9-2-5.9-6.2c0-4.3%2C2.8-6.5%2C6.2-6.5c1.8%2C0%2C3.1%2C0.5%2C3.1%2C0.5v4%20%20%20%20%20h-2.2v-1.9l-0.4-0.4c-0.1%2C0-0.2%2C0-0.3%2C0c-2%2C0-2.8%2C1.5-2.8%2C4.2s1.1%2C4%2C3.2%2C4c1%2C0%2C2.1-0.3%2C2.4-0.4L306.6%2C48.3L306.6%2C48.3z%22%2F%3E%20%20%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M311.4%2C36.8c0.9%2C0%2C1.1%2C0.5%2C1.1%2C1v8.9l0.4%2C0.4h1V49h-6.3v-1.8h1l0.4-0.4v-7.6l-0.4-0.4h-1v-2H311.4z%20%20%20%20%20%20M310.5%2C31.9c1.3%2C0%2C2%2C0.7%2C2%2C1.8c0%2C1.1-0.6%2C1.8-2%2C1.8c-1.3%2C0-2-0.7-2-1.8C308.5%2C32.6%2C309.2%2C31.9%2C310.5%2C31.9z%22%2F%3E%20%20%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M323.3%2C49c-0.9%2C0-1.1-0.5-1.1-1v-0.4h-0.1c-0.7%2C0.9-1.7%2C1.7-3.4%2C1.7c-2.5%2C0-4.4-2.1-4.4-6.2%20%20%20%20%20s2.2-6.5%2C4.9-6.5c1.1%2C0%2C2.1%2C0.6%2C2.7%2C1.2v-3.2l-0.4-0.4h-1v-2h3.9c0.9%2C0%2C1.1%2C0.5%2C1.1%2C1v13.5l0.4%2C0.4h1V49H323.3z%20M322%2C46.1v-6.2%20%20%20%20%20c-0.6-0.5-1.2-0.8-1.9-0.8c-1.4%2C0-2.1%2C1.1-2.1%2C3.9c0%2C2.9%2C0.7%2C3.7%2C2.1%2C3.7C320.7%2C46.7%2C321.4%2C46.5%2C322%2C46.1z%22%2F%3E%20%20%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M337.3%2C43.8h-6.2c0.3%2C2.3%2C1.5%2C3.1%2C3.3%2C3.1c1.3%2C0%2C2.3-0.4%2C2.7-0.5v1.9c-0.6%2C0.4-1.8%2C0.8-3.9%2C0.8%20%20%20%20%20c-3%2C0-5.7-1.8-5.7-6.1c0-4.2%2C2.2-6.5%2C5.3-6.5c3.1%2C0%2C4.8%2C2%2C4.8%2C4.9v1.9L337.3%2C43.8z%20M331.1%2C41.9h3.2v-0.8c0-1.5-0.3-2.3-1.5-2.3%20%20%20%20%20S331.3%2C39.8%2C331.1%2C41.9z%22%2F%3E%20%20%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M338.5%2C49v-1.8h1l0.4-0.4v-7.6l-0.4-0.4h-1v-2h3.7c0.9%2C0%2C1.1%2C0.5%2C1.1%2C1v0.4h0.1c0.4-0.5%2C1.6-1.7%2C3.4-1.7%20%20%20%20%20c2.7%2C0%2C3.5%2C1.7%2C3.5%2C3.7v6.5l0.4%2C0.4h1V49h-6.1v-1.8h0.8l0.4-0.4v-5.9c0-0.7-0.1-1.6-1.5-1.6c-0.8%2C0-1.5%2C0.4-1.8%2C0.6v6.9l0.4%2C0.4%20%20%20%20%20h0.8V49H338.5z%22%2F%3E%20%20%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M356.9%2C38.8v8l0.4%2C0.4h2.2V49c0%2C0-1.5%2C0.2-3.1%2C0.2c-2%2C0-3-0.7-3-2.8v-7.6H352v-1.9h1l0.4-0.4l1.3-2.8h2.2%20%20%20%20%20V37h2.6v1.9h-2.6V38.8z%22%2F%3E%20%20%20%3C%2Fg%3E%20%20%3C%2Fg%3E%20%3C%2Fg%3E%3C%2Fg%3E%3C%2Fsvg%3E";

var logonh = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%3Csvg%20version%3D%221.1%22%20id%3D%22Capa_1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%20%20width%3D%22336.9px%22%20height%3D%2283px%22%20viewBox%3D%220%200%20336.9%2083%22%20style%3D%22enable-background%3Anew%200%200%20336.9%2083%3B%22%20xml%3Aspace%3D%22preserve%22%3E%3Cstyle%20type%3D%22text%2Fcss%22%3E%20.st0%7Bfill%3A%23FFFFFF%3B%7D%3C%2Fstyle%3E%3Cg%3E%20%3Cg%3E%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M58.9%2C63.9c-1.7%2C0-3-0.4-3-0.4v-2.8h1.3v1.4l0.3%2C0.3c0.4%2C0.1%2C0.9%2C0.1%2C1.4%2C0.1c1.2%2C0%2C1.5-0.5%2C1.5-1.3%20%20%20s-0.3-1.2-1.5-1.5c-2-0.6-3-1.3-3-3.2s1.6-2.9%2C3.7-2.9c1.5%2C0%2C2.7%2C0.4%2C2.7%2C0.4v2.6H61v-1.3l-0.2-0.2C60.5%2C55%2C60.1%2C55%2C59.7%2C55%20%20%20c-1%2C0-1.6%2C0.5-1.6%2C1.2s0.2%2C1.1%2C1.7%2C1.5c1.9%2C0.5%2C2.9%2C1.3%2C2.9%2C3C62.7%2C62.9%2C61.2%2C63.9%2C58.9%2C63.9z%22%2F%3E%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M69.7%2C60.4H66c0.1%2C1.6%2C0.7%2C2.2%2C2%2C2.2c0.8%2C0%2C1.3-0.2%2C1.6-0.3v1.1c-0.4%2C0.3-1.1%2C0.5-2.3%2C0.5%20%20%20c-1.8%2C0-3.5-1.1-3.5-3.7c0-2.8%2C1.5-4.1%2C3.3-4.1c1.7%2C0%2C2.9%2C1.2%2C2.9%2C3.1v1L69.7%2C60.4z%20M66%2C59.4h2V59c0-1.1-0.2-1.6-0.9-1.6%20%20%20C66.4%2C57.4%2C66.1%2C58.1%2C66%2C59.4z%22%2F%3E%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M74.1%2C60.9c-0.3%2C0-0.7%2C0-1-0.1c-0.2%2C0.1-0.3%2C0.3-0.3%2C0.5c0%2C0.3%2C0.2%2C0.4%2C0.6%2C0.4h2.1c1.3%2C0%2C2.4%2C0.4%2C2.4%2C2%20%20%20c0%2C1.8-1.8%2C2.6-4%2C2.6c-1.9%2C0-3.1-0.4-3.1-1.6c0-0.6%2C0.5-1%2C1-1.2c-0.5-0.2-0.9-0.7-0.9-1.4c0-0.6%2C0.4-1.2%2C1.2-1.7%20%20%20c-0.6-0.4-1-1-1-1.9c0-1.6%2C1.4-2.4%2C3-2.4c0.4%2C0%2C0.8%2C0%2C1.2%2C0.1H78v1h-1l-0.1%2C0.1c0.2%2C0.3%2C0.3%2C0.7%2C0.3%2C1.1%20%20%20C77.2%2C60.1%2C75.8%2C60.9%2C74.1%2C60.9z%20M72.9%2C63.6c-0.1%2C0.1-0.2%2C0.4-0.2%2C0.8c0%2C0.6%2C0.4%2C0.9%2C1.4%2C0.9c1.1%2C0%2C1.8-0.3%2C1.8-1.1%20%20%20c0-0.5-0.3-0.6-0.9-0.6C75%2C63.6%2C72.9%2C63.6%2C72.9%2C63.6z%20M74.1%2C57.3c-0.7%2C0-1.1%2C0.4-1.1%2C1.2s0.4%2C1.2%2C1.1%2C1.2s1.1-0.4%2C1.1-1.2%20%20%20S74.8%2C57.3%2C74.1%2C57.3z%22%2F%3E%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M85.1%2C56.2c0.6%2C0%2C0.7%2C0.3%2C0.7%2C0.6v5.6l0.3%2C0.3h0.6v1h-2.3c-0.6%2C0-0.7-0.3-0.7-0.6v-0.2h-0.1%20%20%20c-0.2%2C0.3-0.9%2C1-2%2C1c-1.7%2C0-2.2-1-2.2-2.3v-4.1l-0.3-0.3h-0.6v-1h2.4c0.6%2C0%2C0.7%2C0.3%2C0.7%2C0.6v4.4c0%2C0.4%2C0%2C1%2C0.9%2C1%20%20%20c0.5%2C0%2C0.9-0.2%2C1.1-0.4v-4.4l-0.3-0.3h-0.6v-1h2.4V56.2z%22%2F%3E%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M90.7%2C62.7h0.8v1h-4.1v-1H88l0.3-0.3v-4.9L88%2C57.3h-0.6v-1h2.3c0.6%2C0%2C0.7%2C0.3%2C0.7%2C0.6v0.4h0.1%20%20%20c0.2-0.3%2C0.9-1.1%2C2-1.1c0.3%2C0%2C0.5%2C0%2C0.5%2C0v3h-1.3v-1L91.5%2C58c-0.4%2C0.1-0.8%2C0.3-1%2C0.4v4.2L90.7%2C62.7z%22%2F%3E%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M97.1%2C63.9c-1.9%2C0-3.4-1.2-3.4-3.9s1.5-3.9%2C3.4-3.9s3.4%2C1.2%2C3.4%2C3.9S99.1%2C63.9%2C97.1%2C63.9z%20M97.1%2C57.4%20%20%20c-1%2C0-1.2%2C0.8-1.2%2C2.6c0%2C1.7%2C0.2%2C2.6%2C1.2%2C2.6s1.2-0.8%2C1.2-2.6C98.3%2C58.3%2C98.1%2C57.4%2C97.1%2C57.4z%22%2F%3E%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M104.1%2C63.9c-1.5%2C0-2.4-0.3-2.4-0.3v-2.1h1.2v1l0.2%2C0.3c0.3%2C0%2C0.6%2C0.1%2C1%2C0.1c0.8%2C0%2C1.1-0.4%2C1.1-0.9%20%20%20c0-0.6-0.2-0.8-1.3-1.1c-1.8-0.4-2.1-1.3-2.1-2.3c0-1.5%2C1.1-2.4%2C3-2.4c1.2%2C0%2C2.2%2C0.2%2C2.2%2C0.2v2.1h-1.2v-0.9l-0.2-0.2%20%20%20c-0.2%2C0-0.5-0.1-0.7-0.1c-0.7%2C0-1.1%2C0.3-1.1%2C0.8s0%2C0.8%2C1.1%2C1c1.9%2C0.4%2C2.5%2C1.1%2C2.5%2C2.2C107.2%2C63%2C105.9%2C63.9%2C104.1%2C63.9z%22%2F%3E%20%3C%2Fg%3E%20%3Cg%3E%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M69.4%2C50.2h-2.8l-6.9-10.4V48l0.4%2C0.4h1.1v1.7h-5.9v-1.7h1l0.4-0.4V35.7l-0.4-0.4h-1v-1.7h4.9l6.3%2C9.5v-7.3%20%20%20L66%2C35.3h-1v-1.7h5.9v1.7h-1.1l-0.4%2C0.4V50.2z%22%2F%3E%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M77.4%2C50.4c-3.2%2C0-5.7-2-5.7-6.5s2.5-6.5%2C5.7-6.5s5.7%2C2%2C5.7%2C6.5C83%2C48.4%2C80.5%2C50.4%2C77.4%2C50.4z%20M77.4%2C39.6%20%20%20c-1.6%2C0-2%2C1.4-2%2C4.3c0%2C2.9%2C0.4%2C4.3%2C2%2C4.3s2-1.4%2C2-4.3C79.3%2C41%2C78.9%2C39.6%2C77.4%2C39.6z%22%2F%3E%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M89.7%2C48.4H91v1.7h-6.8v-1.7h1l0.4-0.4v-8.2l-0.4-0.4h-1v-1.7H88c0.9%2C0%2C1.1%2C0.5%2C1.1%2C1v0.6h0.1%20%20%20c0.4-0.5%2C1.6-1.9%2C3.4-1.9c0.5%2C0%2C0.9%2C0.1%2C0.9%2C0.1v4.9h-2.1v-1.7L91%2C40.3c-0.7%2C0.1-1.3%2C0.4-1.7%2C0.6v7L89.7%2C48.4z%22%2F%3E%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M99.3%2C39.4V48l0.4%2C0.4h2.3v1.7c0%2C0-1.5%2C0.2-3.2%2C0.2c-2.1%2C0-3.1-0.8-3.1-2.9v-8.1h-1.5v-1.7h1l0.4-0.4l1.3-2.9%20%20%20h2.2v3.4h2.6v1.7H99.3z%22%2F%3E%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M112.6%2C44.5h-6.3c0.1%2C2.6%2C1.1%2C3.6%2C3.4%2C3.6c1.3%2C0%2C2.2-0.4%2C2.6-0.5v1.9c-0.6%2C0.4-1.8%2C0.9-3.9%2C0.9%20%20%20c-3.1%2C0-5.8-1.8-5.8-6.2c0-4.6%2C2.5-6.8%2C5.4-6.8s4.9%2C1.9%2C4.9%2C5.1V44L112.6%2C44.5z%20M106.4%2C42.8h3.3v-0.6c0-1.8-0.4-2.7-1.5-2.7%20%20%20C107.1%2C39.5%2C106.5%2C40.7%2C106.4%2C42.8z%22%2F%3E%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M124.5%2C42.9h-5v5l0.4%2C0.4h1.1V50h-6.8v-1.7h1l0.4-0.4V35.7l-0.4-0.4h-1v-1.7h6.8v1.7h-1.1l-0.4%2C0.4v4.7h5%20%20%20v-4.7l-0.4-0.4h-1v-1.7h6.8v1.7h-1.1l-0.4%2C0.4V48l0.4%2C0.4h1.1v1.7H123v-1.7h1l0.4-0.4L124.5%2C42.9L124.5%2C42.9z%22%2F%3E%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M135.2%2C37.6c0.9%2C0%2C1.1%2C0.5%2C1.1%2C1V48l0.4%2C0.4h1.1v1.7h-6.5v-1.7h1l0.4-0.4v-8.2l-0.4-0.4h-1v-1.7L135.2%2C37.6%20%20%20L135.2%2C37.6z%20M134.3%2C32.5c1.3%2C0%2C2%2C0.7%2C2%2C1.9s-0.7%2C1.9-2%2C1.9s-2-0.7-2-1.9C132.2%2C33.2%2C132.9%2C32.5%2C134.3%2C32.5z%22%2F%3E%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M143%2C50.4c-2.5%2C0-4-0.5-4-0.5v-3.5h2V48l0.4%2C0.4c0.5%2C0.1%2C1%2C0.1%2C1.7%2C0.1c1.4%2C0%2C1.8-0.6%2C1.8-1.5%20%20%20s-0.3-1.4-2.2-1.8c-2.9-0.6-3.6-2.2-3.6-3.8c0-2.5%2C1.8-4%2C5-4c2%2C0%2C3.6%2C0.4%2C3.6%2C0.4v3.4h-2v-1.4l-0.4-0.4c-0.4%2C0-0.8-0.1-1.2-0.1%20%20%20c-1.2%2C0-1.9%2C0.5-1.9%2C1.3s0.1%2C1.3%2C1.8%2C1.7c3.1%2C0.6%2C4.2%2C1.8%2C4.2%2C3.7C148.2%2C48.9%2C146.1%2C50.4%2C143%2C50.4z%22%2F%3E%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M149.3%2C37.6h3.8c0.9%2C0%2C1.1%2C0.5%2C1.1%2C1V39h0.1c0.6-0.8%2C1.8-1.7%2C3.2-1.7c2.5%2C0%2C4.5%2C1.9%2C4.5%2C6.4s-2.1%2C6.6-4.5%2C6.6%20%20%20c-1.2%2C0-2.5-0.7-3.1-1.4V52l0.4%2C0.4h1.2v1.7h-6.7v-1.7h1l0.4-0.4V39.7l-0.4-0.4h-1V37.6z%20M156.1%2C40.1c-0.5%2C0-1.2%2C0.3-1.8%2C0.8v6.2%20%20%20c0.6%2C0.5%2C1.3%2C0.6%2C1.8%2C0.6c1.6%2C0%2C2.1-1.1%2C2.1-3.8C158.2%2C41.1%2C157.7%2C40.1%2C156.1%2C40.1z%22%2F%3E%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M174.9%2C50.1h-3.8c-0.9%2C0-1.1-0.5-1.1-1v-0.4h0c-0.4%2C0.4-1.5%2C1.7-3.4%2C1.7c-2.7%2C0-3.6-1.7-3.6-3.8%20%20%20c0-2.2%2C1.6-3.5%2C4.2-3.5h2.7V42c0-1.4-0.1-2.4-2.1-2.4c-0.3%2C0-0.7%2C0-1.1%2C0.1l-0.4%2C0.4v1.7h-2.2V38c0%2C0%2C2-0.7%2C4.9-0.7%20%20%20c3.4%2C0%2C4.4%2C1.8%2C4.4%2C4V48l0.4%2C0.4h1v1.7H174.9z%20M169.9%2C47.1V45h-1.7c-1.1%2C0-1.6%2C0.5-1.6%2C1.3c0%2C1%2C0.3%2C1.4%2C1.4%2C1.4%20%20%20C168.8%2C47.7%2C169.5%2C47.3%2C169.9%2C47.1z%22%2F%3E%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M175.7%2C50.1v-1.7h1l0.4-0.4v-8.2l-0.4-0.4h-1v-1.7h3.8c0.9%2C0%2C1.1%2C0.5%2C1.1%2C1V39h0.1c0.4-0.4%2C1.6-1.7%2C3.5-1.7%20%20%20c2.8%2C0%2C3.6%2C1.7%2C3.6%2C3.8V48l0.4%2C0.4h1v1.7H183v-1.7h0.8l0.4-0.4v-6.3c0-0.7-0.1-1.7-1.6-1.7c-0.8%2C0-1.5%2C0.4-1.9%2C0.6V48l0.4%2C0.4h0.8%20%20%20v1.7C181.9%2C50.1%2C175.7%2C50.1%2C175.7%2C50.1z%22%2F%3E%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M201.9%2C50.1h-3.8c-0.9%2C0-1.1-0.5-1.1-1v-0.4h0c-0.4%2C0.4-1.5%2C1.7-3.4%2C1.7c-2.7%2C0-3.6-1.7-3.6-3.8%20%20%20c0-2.2%2C1.6-3.5%2C4.2-3.5h2.7V42c0-1.4-0.1-2.4-2.1-2.4c-0.3%2C0-0.7%2C0-1.1%2C0.1l-0.4%2C0.4v1.7h-2.2V38c0%2C0%2C2-0.7%2C4.9-0.7%20%20%20c3.4%2C0%2C4.4%2C1.8%2C4.4%2C4V48l0.4%2C0.4h1v1.7H201.9z%20M196.9%2C47.1V45h-1.7c-1.1%2C0-1.6%2C0.5-1.6%2C1.3c0%2C1%2C0.3%2C1.4%2C1.4%2C1.4%20%20%20C195.8%2C47.7%2C196.5%2C47.3%2C196.9%2C47.1z%22%2F%3E%20%3C%2Fg%3E%20%3Cpath%20class%3D%22st0%22%20d%3D%22M30.2%2C50.5c3.6%2C3.5%2C5%2C9.4%2C5.6%2C11.7c0.4%2C1.4%2C1.8%2C2.2%2C3.1%2C1.8c1.4-0.4%2C2.2-1.8%2C1.8-3.1c-0.6-2.3-2.4-8.1-1-13%20%20c1.2-4.9%2C5.6-9.1%2C7.3-10.8c1-1%2C1-2.6%2C0-3.6s-2.6-1-3.6%2C0c-1.7%2C1.7-5.9%2C6.1-10.8%2C7.3l0%2C0c-4.8%2C1.4-10.7-0.4-13-1%20%20c-1.4-0.4-2.8%2C0.4-3.1%2C1.8c-0.4%2C1.4%2C0.4%2C2.8%2C1.8%2C3.1C20.8%2C45.5%2C26.7%2C46.9%2C30.2%2C50.5L30.2%2C50.5z%22%2F%3E%20%3Cg%3E%20%20%3Cg%3E%20%20%20%3Cg%3E%20%20%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M222.5%2C29.4c-2.2%2C0-3.7-0.5-3.7-0.5V26h1.1v1.8l0.3%2C0.3c0.5%2C0.1%2C1.2%2C0.2%2C2.2%2C0.2c1.9%2C0%2C2.9-0.8%2C2.9-2.3%20%20%20%20%20c0-1.2-0.8-1.9-2.8-2.5c-2.4-0.7-3.7-1.8-3.7-3.7c0-2.2%2C1.8-3.4%2C4.4-3.4c1.9%2C0%2C3.3%2C0.4%2C3.3%2C0.4v2.8h-1.1V18l-0.3-0.3%20%20%20%20%20c-0.5-0.1-1.1-0.2-1.9-0.2c-1.7%2C0-2.8%2C0.8-2.8%2C2c0%2C1%2C0.4%2C1.7%2C2.8%2C2.4c2.4%2C0.7%2C3.7%2C1.6%2C3.7%2C3.6C227.1%2C28.2%2C225.1%2C29.4%2C222.5%2C29.4%20%20%20%20%20z%22%2F%3E%20%20%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M236%2C25h-5.7c0.1%2C2.4%2C1.3%2C3.4%2C3.1%2C3.4c1%2C0%2C1.8-0.3%2C2.3-0.5v0.9c-0.6%2C0.3-1.5%2C0.6-2.8%2C0.6%20%20%20%20%20c-2.4%2C0-4.3-1.4-4.3-4.8s1.8-5%2C4-5c2%2C0%2C3.6%2C1.3%2C3.6%2C3.8v1.2L236%2C25z%20M230.3%2C23.9h4.3v-0.5c0-1.9-0.8-2.7-2-2.7%20%20%20%20%20C231.4%2C20.7%2C230.5%2C21.7%2C230.3%2C23.9z%22%2F%3E%20%20%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M240.8%2C28.4h1.4v0.9h-4.7v-0.9h1.2l0.3-0.3V21l-0.3-0.3h-1.2v-0.9h2.2c0.6%2C0%2C0.8%2C0.3%2C0.8%2C0.7v0.6l0%2C0%20%20%20%20%20c0.4-0.4%2C1.4-1.4%2C2.9-1.4c0.3%2C0%2C0.5%2C0%2C0.6%2C0.1v3h-1v-1.3l-0.3-0.3c-1%2C0.1-1.8%2C0.6-2.2%2C1.1v6L240.8%2C28.4z%22%2F%3E%20%20%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M252.6%2C25h-5.7c0.1%2C2.4%2C1.3%2C3.4%2C3.1%2C3.4c1%2C0%2C1.8-0.3%2C2.3-0.5v0.9c-0.6%2C0.3-1.5%2C0.6-2.8%2C0.6%20%20%20%20%20c-2.4%2C0-4.3-1.4-4.3-4.8s1.8-5%2C4-5c2%2C0%2C3.6%2C1.3%2C3.6%2C3.8v1.2L252.6%2C25z%20M246.9%2C23.9h4.3v-0.5c0-1.9-0.8-2.7-2-2.7%20%20%20%20%20C248%2C20.7%2C247.1%2C21.7%2C246.9%2C23.9z%22%2F%3E%20%20%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M254.1%2C29.2v-0.9h1.2l0.3-0.3v-7l-0.3-0.3h-1.2v-0.9h2.2c0.6%2C0%2C0.8%2C0.3%2C0.8%2C0.7V21l0%2C0%20%20%20%20%20c0.5-0.6%2C1.6-1.4%2C3-1.4c1.3%2C0%2C2.1%2C0.6%2C2.4%2C1.6c0.5-0.6%2C1.6-1.6%2C3.1-1.6c1.9%2C0%2C2.6%2C1.3%2C2.6%2C2.9v5.6l0.3%2C0.3h1.2v0.9h-4.4v-0.9%20%20%20%20%20h1.1l0.3-0.3v-5.3c0-0.9-0.2-1.8-1.5-1.8c-0.9%2C0-1.7%2C0.4-2.4%2C1.1c0%2C0.1%2C0%2C0.3%2C0%2C0.4v5.6l0.3%2C0.3h1.2v0.9h-4.4v-0.9h1.1l0.3-0.3%20%20%20%20%20v-5.3c0-0.9-0.2-1.8-1.5-1.8c-0.8%2C0-1.6%2C0.3-2.4%2C1.1v6l0.3%2C0.3h1.1v0.9L254.1%2C29.2L254.1%2C29.2z%22%2F%3E%20%20%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M274.7%2C29.4c-2.2%2C0-4.1-1.6-4.1-4.9s1.9-4.9%2C4.1-4.9s4.1%2C1.6%2C4.1%2C4.9C278.8%2C27.9%2C276.9%2C29.4%2C274.7%2C29.4z%20%20%20%20%20%20M274.7%2C20.7c-1.5%2C0-2.4%2C1.2-2.4%2C3.8s0.9%2C3.8%2C2.4%2C3.8s2.4-1.3%2C2.4-3.8S276.2%2C20.7%2C274.7%2C20.7z%22%2F%3E%20%20%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M283.3%2C29.4c-1.8%2C0-2.9-0.4-2.9-0.4v-2.2h1.1V28l0.2%2C0.3c0.4%2C0.1%2C0.9%2C0.1%2C1.7%2C0.1c1.3%2C0%2C2.1-0.6%2C2.1-1.6%20%20%20%20%20c0-0.9-0.5-1.3-2.2-1.7c-2.2-0.6-2.8-1.5-2.8-2.8c0-1.6%2C1.3-2.6%2C3.5-2.6c1.5%2C0%2C2.6%2C0.3%2C2.6%2C0.3v2.2h-1.1V21l-0.2-0.2%20%20%20%20%20c-0.3-0.1-0.8-0.1-1.4-0.1c-1.3%2C0-2%2C0.6-2%2C1.4s0.3%2C1.2%2C2%2C1.6c2.2%2C0.6%2C3.1%2C1.3%2C3.1%2C2.8C287%2C28.3%2C285.4%2C29.4%2C283.3%2C29.4z%22%2F%3E%20%20%20%3C%2Fg%3E%20%20%3C%2Fg%3E%20%20%3Cg%3E%20%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M225%2C33.3c4.1%2C0%2C7.1%2C2.8%2C7.1%2C8.5s-3%2C8.5-7.1%2C8.5s-7.1-2.8-7.1-8.5S220.9%2C33.3%2C225%2C33.3z%20M225%2C47.8%20%20%20%20c2.3%2C0%2C3.1-1.9%2C3.1-6s-0.8-6-3.1-6s-3.1%2C1.9-3.1%2C6S222.7%2C47.8%2C225%2C47.8z%22%2F%3E%20%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M242.8%2C49.4c-0.6%2C0.6-2.1%2C0.9-3.5%2C0.9c-3.2%2C0-6.1-2-6.1-6.4c0-4.5%2C2.9-6.7%2C6.4-6.7c1.9%2C0%2C3.2%2C0.5%2C3.2%2C0.5v4%20%20%20%20h-2.3V40l-0.4-0.4c-0.1%2C0-0.2%2C0-0.3%2C0c-2%2C0-2.9%2C1.5-2.9%2C4.3s1.2%2C4.2%2C3.3%2C4.2c1%2C0%2C2.2-0.3%2C2.5-0.5v1.8H242.8z%22%2F%3E%20%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M253.3%2C49.4c-0.6%2C0.6-2.1%2C0.9-3.5%2C0.9c-3.2%2C0-6.1-2-6.1-6.4c0-4.5%2C2.9-6.7%2C6.4-6.7c1.9%2C0%2C3.2%2C0.5%2C3.2%2C0.5v4%20%20%20%20H251V40l-0.4-0.4c-0.1%2C0-0.2%2C0-0.3%2C0c-2%2C0-2.9%2C1.5-2.9%2C4.3s1.2%2C4.2%2C3.3%2C4.2c1%2C0%2C2.2-0.3%2C2.5-0.5L253.3%2C49.4L253.3%2C49.4z%22%2F%3E%20%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M258.2%2C37.6c0.9%2C0%2C1.1%2C0.5%2C1.1%2C1v9.2l0.4%2C0.4h1.1v1.9h-6.5v-1.9h1l0.4-0.4V40l-0.4-0.4h-1v-2H258.2z%20%20%20%20%20M257.3%2C32.5c1.4%2C0%2C2%2C0.7%2C2%2C1.9s-0.7%2C1.9-2%2C1.9c-1.4%2C0-2-0.7-2-1.9C255.3%2C33.2%2C256%2C32.5%2C257.3%2C32.5z%22%2F%3E%20%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M270.6%2C50.1c-0.9%2C0-1.1-0.5-1.1-1v-0.5h-0.1c-0.7%2C0.9-1.8%2C1.8-3.5%2C1.8c-2.5%2C0-4.5-2.2-4.5-6.4s2.3-6.7%2C5-6.7%20%20%20%20c1.2%2C0%2C2.1%2C0.6%2C2.8%2C1.2v-3.3l-0.4-0.4h-1v-2h4c0.9%2C0%2C1.1%2C0.5%2C1.1%2C1v13.9l0.4%2C0.4h1V50L270.6%2C50.1L270.6%2C50.1z%20M269.3%2C47.1v-6.5%20%20%20%20c-0.6-0.5-1.2-0.8-1.9-0.8c-1.4%2C0-2.1%2C1.2-2.1%2C4.1c0%2C3%2C0.7%2C3.8%2C2.2%2C3.8C267.9%2C47.8%2C268.6%2C47.6%2C269.3%2C47.1z%22%2F%3E%20%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M285%2C44.8h-6.4c0.3%2C2.4%2C1.5%2C3.2%2C3.4%2C3.2c1.3%2C0%2C2.3-0.4%2C2.8-0.5v1.9c-0.6%2C0.4-1.9%2C0.9-4%2C0.9%20%20%20%20c-3.1%2C0-5.9-1.9-5.9-6.3s2.3-6.8%2C5.5-6.8s5%2C2%2C5%2C5.1v1.9L285%2C44.8z%20M278.6%2C42.8h3.3V42c0-1.6-0.4-2.4-1.5-2.4%20%20%20%20C279.2%2C39.6%2C278.8%2C40.7%2C278.6%2C42.8z%22%2F%3E%20%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M286.2%2C50.1v-1.9h1l0.4-0.4V40l-0.4-0.4h-1v-2h3.8c0.9%2C0%2C1.1%2C0.5%2C1.1%2C1V39h0.1c0.4-0.5%2C1.7-1.7%2C3.5-1.7%20%20%20%20c2.8%2C0%2C3.7%2C1.7%2C3.7%2C3.8v6.7l0.4%2C0.4h1v1.9h-6.3v-1.9h0.8l0.4-0.4v-6.1c0-0.7-0.1-1.7-1.6-1.7c-0.8%2C0-1.5%2C0.4-1.9%2C0.6v7.2l0.4%2C0.4%20%20%20%20h0.8v1.9C292.4%2C50.1%2C286.2%2C50.1%2C286.2%2C50.1z%22%2F%3E%20%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M305.3%2C39.6v8.2l0.4%2C0.4h2.3v1.9c0%2C0-1.5%2C0.2-3.2%2C0.2c-2.1%2C0-3.1-0.8-3.1-2.9v-7.9h-1.5v-2h1l0.4-0.4%20%20%20%20l1.4-2.9h2.3v3.4h2.7v2H305.3z%22%2F%3E%20%20%3C%2Fg%3E%20%3C%2Fg%3E%3C%2Fg%3E%3C%2Fsvg%3E";

var logoocc = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%3Csvg%20version%3D%221.1%22%20id%3D%22Capa_1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%20%20width%3D%22300px%22%20height%3D%22129px%22%20viewBox%3D%220%200%20300%20129%22%20style%3D%22enable-background%3Anew%200%200%20300%20129%3B%22%20xml%3Aspace%3D%22preserve%22%3E%3Cstyle%20type%3D%22text%2Fcss%22%3E%20.st0%7Bfill%3A%23FFFFFF%3B%7D%3C%2Fstyle%3E%3Cg%3E%20%3Cpath%20class%3D%22st0%22%20d%3D%22M99.1%2C47.8c8.3%2C0%2C14.4%2C5.6%2C14.4%2C17.3s-6.1%2C17.3-14.4%2C17.3s-14.4-5.6-14.4-17.3S90.8%2C47.8%2C99.1%2C47.8z%20%20%20M99.1%2C77.2c4.6%2C0%2C6.2-3.9%2C6.2-12.1s-1.6-12.1-6.2-12.1s-6.2%2C3.9-6.2%2C12.1S94.5%2C77.2%2C99.1%2C77.2z%22%2F%3E%20%3Cpath%20class%3D%22st0%22%20d%3D%22M135.1%2C80.4c-1.2%2C1.2-4.3%2C1.9-7.1%2C1.9c-6.5%2C0-12.3-4.1-12.3-12.9c0-9.1%2C5.9-13.5%2C12.9-13.5%20%20c3.8%2C0%2C6.6%2C1.1%2C6.6%2C1.1v8.2h-4.7v-3.9l-0.9-0.8c-0.2%2C0-0.3%2C0-0.5%2C0c-4.1%2C0-5.8%2C3.1-5.8%2C8.8c0%2C5.7%2C2.4%2C8.4%2C6.7%2C8.4%20%20c2.1%2C0%2C4.4-0.7%2C5.1-0.9V80.4z%22%2F%3E%20%3Cpath%20class%3D%22st0%22%20d%3D%22M156.3%2C80.4c-1.2%2C1.2-4.3%2C1.9-7.1%2C1.9c-6.5%2C0-12.3-4.1-12.3-12.9c0-9.1%2C5.9-13.5%2C12.9-13.5%20%20c3.8%2C0%2C6.6%2C1.1%2C6.6%2C1.1v8.2h-4.7v-3.9l-0.9-0.8c-0.2%2C0-0.3%2C0-0.5%2C0c-4.1%2C0-5.8%2C3.1-5.8%2C8.8c0%2C5.7%2C2.4%2C8.4%2C6.7%2C8.4%20%20c2.1%2C0%2C4.4-0.7%2C5.1-0.9V80.4z%22%2F%3E%20%3Cpath%20class%3D%22st0%22%20d%3D%22M166.3%2C56.4c1.9%2C0%2C2.2%2C1.1%2C2.2%2C2.1v18.6l0.8%2C0.9h2.2v3.8h-13.2V78h2.1l0.9-0.9V61.4l-0.9-0.9h-2.1v-4.1H166.3z%20%20%20M164.5%2C46.1c2.7%2C0%2C4.1%2C1.5%2C4.1%2C3.8c0%2C2.4-1.3%2C3.8-4.1%2C3.8c-2.7%2C0-4.1-1.5-4.1-3.8C160.4%2C47.6%2C161.7%2C46.1%2C164.5%2C46.1z%22%2F%3E%20%3Cpath%20class%3D%22st0%22%20d%3D%22M191.3%2C81.9c-1.9%2C0-2.2-1.1-2.2-2.1v-0.9h-0.1c-1.4%2C1.9-3.6%2C3.6-7%2C3.6c-5.1%2C0-9.1-4.4-9.1-12.9%20%20S177.5%2C56%2C183%2C56c2.4%2C0%2C4.3%2C1.2%2C5.7%2C2.5v-6.7l-0.9-0.9h-2.1v-4.1h8.1c1.9%2C0%2C2.2%2C1.1%2C2.2%2C2.1v28.2l0.9%2C0.9h2.1v3.8H191.3z%20%20%20M188.6%2C75.8V62.7c-1.2-1.1-2.4-1.6-3.9-1.6c-2.9%2C0-4.3%2C2.4-4.3%2C8.3c0%2C6%2C1.4%2C7.6%2C4.4%2C7.6C185.9%2C77%2C187.3%2C76.7%2C188.6%2C75.8z%22%2F%3E%20%3Cpath%20class%3D%22st0%22%20d%3D%22M220.5%2C71.1h-12.9c0.5%2C4.8%2C3.1%2C6.5%2C6.8%2C6.5c2.6%2C0%2C4.8-0.8%2C5.6-1v3.9c-1.3%2C0.9-3.8%2C1.8-8.1%2C1.8%20%20c-6.3%2C0-11.9-3.8-11.9-12.7c0-8.8%2C4.7-13.7%2C11.1-13.7c6.6%2C0%2C10.1%2C4.1%2C10.1%2C10.3v3.9L220.5%2C71.1z%20M207.6%2C67.1h6.6v-1.7%20%20c0-3.2-0.7-4.8-3.1-4.8S207.9%2C62.7%2C207.6%2C67.1z%22%2F%3E%20%3Cpath%20class%3D%22st0%22%20d%3D%22M222.9%2C81.9V78h2.1l0.9-0.9V61.4l-0.9-0.9h-2.1v-4.1h7.6c1.9%2C0%2C2.2%2C1.1%2C2.2%2C2.1v0.9h0.1c0.8-1%2C3.4-3.5%2C7.1-3.5%20%20c5.7%2C0%2C7.4%2C3.5%2C7.4%2C7.7v13.5l0.9%2C0.9h2.1v3.8h-12.7V78h1.6l0.8-0.9V64.8c0-1.4-0.1-3.4-3.2-3.4c-1.7%2C0-3.1%2C0.8-3.8%2C1.3v14.5L234%2C78%20%20h1.6v3.8H222.9z%22%2F%3E%20%3Cpath%20class%3D%22st0%22%20d%3D%22M261.5%2C60.5v16.7l0.9%2C0.9h4.7v3.8c0%2C0-3.1%2C0.5-6.5%2C0.5c-4.2%2C0-6.3-1.5-6.3-6V60.5h-3v-4h2.1l0.9-0.9l2.7-6h4.6%20%20v6.8h5.4v4H261.5z%22%2F%3E%20%3Cpath%20class%3D%22st0%22%20d%3D%22M52.4%2C67.4c5.1%2C5%2C7.1%2C13.4%2C8%2C16.7c0.5%2C1.9%2C2.5%2C3.1%2C4.4%2C2.6c1.9-0.5%2C3.1-2.5%2C2.6-4.4%20%20c-0.9-3.3-3.4-11.6-1.4-18.5c1.8-6.9%2C8-12.9%2C10.4-15.3c1.4-1.4%2C1.4-3.7%2C0-5.1c-1.4-1.4-3.7-1.4-5.1%2C0C68.9%2C45.7%2C63%2C52%2C56%2C53.7l0%2C0%20%20c-6.9%2C2-15.2-0.5-18.5-1.4c-1.9-0.5-3.9%2C0.6-4.4%2C2.6c-0.5%2C1.9%2C0.6%2C3.9%2C2.6%2C4.4C39%2C60.2%2C47.4%2C62.2%2C52.4%2C67.4L52.4%2C67.4z%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E";

var logospu = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%3Csvg%20version%3D%221.1%22%20id%3D%22Capa_1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%20%20width%3D%22290.2px%22%20height%3D%2283px%22%20viewBox%3D%220%200%20290.2%2083%22%20style%3D%22enable-background%3Anew%200%200%20290.2%2083%3B%22%20xml%3Aspace%3D%22preserve%22%3E%3Cstyle%20type%3D%22text%2Fcss%22%3E%20.st0%7Bfill%3A%23FFFFFF%3B%7D%3C%2Fstyle%3E%3Cg%3E%20%3Cg%3E%20%20%3Cg%3E%20%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M176.1%2C29.4c-2.2%2C0-3.6-0.5-3.6-0.5V26h1.1v1.8l0.3%2C0.3c0.5%2C0.1%2C1.2%2C0.2%2C2.2%2C0.2c1.9%2C0%2C2.9-0.8%2C2.9-2.3%20%20%20%20c0-1.2-0.8-1.9-2.8-2.4c-2.4-0.7-3.7-1.8-3.7-3.6c0-2.2%2C1.8-3.4%2C4.4-3.4c1.9%2C0%2C3.3%2C0.4%2C3.3%2C0.4v2.8h-1.1V18l-0.3-0.3%20%20%20%20c-0.5-0.1-1.1-0.2-1.9-0.2c-1.7%2C0-2.8%2C0.8-2.8%2C2c0%2C1%2C0.4%2C1.7%2C2.8%2C2.4c2.4%2C0.7%2C3.7%2C1.6%2C3.7%2C3.6C180.6%2C28.2%2C178.7%2C29.4%2C176.1%2C29.4z%20%20%20%20%22%2F%3E%20%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M189.6%2C24.9h-5.7c0.1%2C2.4%2C1.3%2C3.4%2C3.1%2C3.4c1%2C0%2C1.8-0.3%2C2.3-0.5v0.9c-0.6%2C0.3-1.5%2C0.6-2.8%2C0.6%20%20%20%20c-2.4%2C0-4.3-1.4-4.3-4.8s1.8-5%2C4-5c2%2C0%2C3.6%2C1.3%2C3.6%2C3.8v1.2L189.6%2C24.9z%20M183.9%2C23.9h4.3v-0.5c0-1.9-0.8-2.7-2-2.7%20%20%20%20C184.9%2C20.7%2C184%2C21.7%2C183.9%2C23.9z%22%2F%3E%20%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M194.4%2C28.3h1.4v0.9h-4.7v-0.9h1.2l0.3-0.3v-7l-0.3-0.3h-1.2v-0.9h2.2c0.6%2C0%2C0.8%2C0.3%2C0.8%2C0.7v0.6l0%2C0%20%20%20%20c0.4-0.4%2C1.4-1.4%2C2.9-1.4c0.3%2C0%2C0.5%2C0%2C0.6%2C0.1v3h-1v-1.3l-0.3-0.3c-1%2C0.1-1.8%2C0.6-2.2%2C1.1v6L194.4%2C28.3z%22%2F%3E%20%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M206.1%2C24.9h-5.7c0.1%2C2.4%2C1.3%2C3.4%2C3.1%2C3.4c1%2C0%2C1.8-0.3%2C2.3-0.5v0.9c-0.6%2C0.3-1.5%2C0.6-2.8%2C0.6%20%20%20%20c-2.4%2C0-4.3-1.4-4.3-4.8s1.8-5%2C4-5c2%2C0%2C3.6%2C1.3%2C3.6%2C3.8v1.2L206.1%2C24.9z%20M200.5%2C23.9h4.3v-0.5c0-1.9-0.8-2.7-2-2.7%20%20%20%20C201.5%2C20.7%2C200.6%2C21.7%2C200.5%2C23.9z%22%2F%3E%20%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M207.6%2C29.2v-0.9h1.2l0.3-0.3v-7l-0.3-0.3h-1.2v-0.9h2.2c0.6%2C0%2C0.8%2C0.3%2C0.8%2C0.7V21l0%2C0%20%20%20%20c0.5-0.6%2C1.6-1.4%2C3-1.4c1.3%2C0%2C2.1%2C0.6%2C2.4%2C1.6c0.5-0.6%2C1.6-1.6%2C3.1-1.6c1.9%2C0%2C2.6%2C1.3%2C2.6%2C2.9v5.6l0.3%2C0.3h1.2v0.9h-4.4v-0.9h1.1%20%20%20%20l0.3-0.3v-5.3c0-0.9-0.2-1.8-1.5-1.8c-0.9%2C0-1.7%2C0.4-2.4%2C1.1c0%2C0.1%2C0%2C0.3%2C0%2C0.4v5.6l0.3%2C0.3h1.2v0.9h-4.4v-0.9h1.1l0.3-0.3v-5.3%20%20%20%20c0-0.9-0.2-1.8-1.5-1.8c-0.8%2C0-1.6%2C0.3-2.4%2C1.1v6l0.3%2C0.3h1.1v0.9L207.6%2C29.2L207.6%2C29.2z%22%2F%3E%20%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M228.2%2C29.4c-2.2%2C0-4.1-1.6-4.1-4.9s1.9-4.9%2C4.1-4.9c2.2%2C0%2C4.1%2C1.6%2C4.1%2C4.9S230.4%2C29.4%2C228.2%2C29.4z%20%20%20%20%20M228.2%2C20.7c-1.5%2C0-2.4%2C1.2-2.4%2C3.8s0.9%2C3.8%2C2.4%2C3.8s2.4-1.3%2C2.4-3.8S229.7%2C20.7%2C228.2%2C20.7z%22%2F%3E%20%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M236.8%2C29.4c-1.8%2C0-2.9-0.4-2.9-0.4v-2.2h1.1V28l0.2%2C0.3c0.4%2C0.1%2C0.9%2C0.1%2C1.7%2C0.1c1.3%2C0%2C2.1-0.6%2C2.1-1.6%20%20%20%20c0-0.9-0.5-1.3-2.2-1.7c-2.2-0.6-2.8-1.5-2.8-2.8c0-1.6%2C1.3-2.6%2C3.5-2.6c1.5%2C0%2C2.6%2C0.3%2C2.6%2C0.3v2.2H239V21l-0.2-0.2%20%20%20%20c-0.3-0.1-0.8-0.1-1.4-0.1c-1.3%2C0-2%2C0.6-2%2C1.4s0.3%2C1.2%2C2%2C1.6c2.2%2C0.6%2C3.1%2C1.3%2C3.1%2C2.8C240.5%2C28.3%2C238.9%2C29.4%2C236.8%2C29.4z%22%2F%3E%20%20%3C%2Fg%3E%20%3C%2Fg%3E%20%3Cg%3E%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M59.5%2C63.9c-1.7%2C0-3-0.4-3-0.4v-2.8h1.3v1.4l0.3%2C0.3c0.4%2C0.1%2C0.9%2C0.1%2C1.4%2C0.1c1.2%2C0%2C1.5-0.5%2C1.5-1.3%20%20%20s-0.3-1.2-1.5-1.5c-2-0.6-3-1.3-3-3.2s1.6-2.9%2C3.7-2.9c1.5%2C0%2C2.7%2C0.4%2C2.7%2C0.4v2.6h-1.3v-1.3l-0.2-0.2C61.1%2C55%2C60.7%2C55%2C60.3%2C55%20%20%20c-1%2C0-1.6%2C0.5-1.6%2C1.2s0.2%2C1.1%2C1.7%2C1.5c1.9%2C0.5%2C2.9%2C1.3%2C2.9%2C3C63.3%2C62.9%2C61.8%2C63.9%2C59.5%2C63.9z%22%2F%3E%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M70.4%2C60.4h-3.8c0.1%2C1.6%2C0.7%2C2.2%2C2%2C2.2c0.8%2C0%2C1.4-0.2%2C1.6-0.3v1.1c-0.4%2C0.3-1.1%2C0.5-2.3%2C0.5%20%20%20c-1.8%2C0-3.5-1.1-3.5-3.8c0-2.8%2C1.5-4.1%2C3.3-4.1c1.7%2C0%2C2.9%2C1.2%2C2.9%2C3.1v1L70.4%2C60.4z%20M66.6%2C59.4h2V59c0-1.1-0.2-1.6-0.9-1.6%20%20%20C67%2C57.4%2C66.7%2C58.1%2C66.6%2C59.4z%22%2F%3E%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M74.8%2C60.9c-0.3%2C0-0.7%2C0-1-0.1c-0.2%2C0.1-0.3%2C0.3-0.3%2C0.5c0%2C0.3%2C0.2%2C0.4%2C0.6%2C0.4h2.1c1.3%2C0%2C2.4%2C0.4%2C2.4%2C2%20%20%20c0%2C1.8-1.8%2C2.6-4%2C2.6c-1.9%2C0-3.1-0.4-3.1-1.6c0-0.6%2C0.5-1%2C1-1.2c-0.5-0.2-0.9-0.7-0.9-1.4c0-0.6%2C0.4-1.2%2C1.2-1.7%20%20%20c-0.6-0.4-1-1-1-1.9c0-1.6%2C1.4-2.4%2C3-2.4c0.4%2C0%2C0.8%2C0%2C1.2%2C0.1h2.7v1h-1l-0.1%2C0.1c0.2%2C0.3%2C0.3%2C0.7%2C0.3%2C1.1%20%20%20C77.8%2C60.1%2C76.4%2C60.9%2C74.8%2C60.9z%20M73.5%2C63.6c-0.1%2C0.1-0.2%2C0.4-0.2%2C0.8c0%2C0.6%2C0.4%2C0.9%2C1.4%2C0.9c1.1%2C0%2C1.8-0.3%2C1.8-1.1%20%20%20c0-0.5-0.3-0.6-0.9-0.6C75.6%2C63.6%2C73.5%2C63.6%2C73.5%2C63.6z%20M74.8%2C57.2c-0.7%2C0-1.1%2C0.4-1.1%2C1.2s0.4%2C1.2%2C1.1%2C1.2s1.1-0.4%2C1.1-1.2%20%20%20C75.9%2C57.7%2C75.5%2C57.2%2C74.8%2C57.2z%22%2F%3E%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M85.7%2C56.2c0.6%2C0%2C0.7%2C0.3%2C0.7%2C0.6v5.6l0.3%2C0.3h0.6v1H85c-0.6%2C0-0.7-0.3-0.7-0.6v-0.2h-0.1c-0.2%2C0.3-0.9%2C1-2%2C1%20%20%20c-1.7%2C0-2.2-1-2.2-2.3v-4.1l-0.3-0.3h-0.6v-1h2.4c0.6%2C0%2C0.7%2C0.3%2C0.7%2C0.6v4.4c0%2C0.4%2C0%2C1%2C0.9%2C1c0.5%2C0%2C0.9-0.2%2C1.1-0.4v-4.4L84%2C57.3%20%20%20h-0.6v-1L85.7%2C56.2L85.7%2C56.2z%22%2F%3E%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M91.3%2C62.7h0.8v1H88v-1h0.6l0.3-0.3v-4.9l-0.3-0.3H88v-1h2.3c0.6%2C0%2C0.7%2C0.3%2C0.7%2C0.6v0.4h0%20%20%20c0.2-0.3%2C0.9-1.1%2C2-1.1c0.3%2C0%2C0.5%2C0%2C0.5%2C0v3h-1.3v-1L92%2C57.9c-0.4%2C0.1-0.8%2C0.3-1%2C0.4v4.2L91.3%2C62.7z%22%2F%3E%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M97.8%2C63.9c-1.9%2C0-3.4-1.2-3.4-3.9s1.5-3.9%2C3.4-3.9s3.4%2C1.2%2C3.4%2C3.9C101.2%2C62.7%2C99.7%2C63.9%2C97.8%2C63.9z%20%20%20%20M97.8%2C57.4c-1%2C0-1.2%2C0.8-1.2%2C2.6c0%2C1.7%2C0.2%2C2.6%2C1.2%2C2.6S99%2C61.8%2C99%2C60C99%2C58.3%2C98.8%2C57.4%2C97.8%2C57.4z%22%2F%3E%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M104.8%2C63.9c-1.5%2C0-2.4-0.3-2.4-0.3v-2.1h1.2v1l0.2%2C0.3c0.3%2C0%2C0.6%2C0.1%2C1%2C0.1c0.8%2C0%2C1.1-0.4%2C1.1-0.9%20%20%20c0-0.6-0.2-0.8-1.3-1.1c-1.8-0.4-2.1-1.3-2.1-2.3c0-1.5%2C1.1-2.4%2C3-2.4c1.2%2C0%2C2.2%2C0.2%2C2.2%2C0.2v2.1h-1.2v-0.9l-0.2-0.2%20%20%20c-0.2%2C0-0.5-0.1-0.7-0.1c-0.7%2C0-1.1%2C0.3-1.1%2C0.8s0%2C0.8%2C1.1%2C1c1.9%2C0.4%2C2.5%2C1.1%2C2.5%2C2.2C107.9%2C63%2C106.6%2C63.9%2C104.8%2C63.9z%22%2F%3E%20%3C%2Fg%3E%20%3Cg%3E%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M56.9%2C35.7l-0.4-0.4h-1v-1.7h7.1c4%2C0%2C6.6%2C1.6%2C6.6%2C5.3s-2.6%2C5.4-6.6%2C5.4h-1.8v3.8l0.4%2C0.4h1.3v1.7h-7v-1.7h1%20%20%20l0.4-0.4V35.7z%20M60.8%2C36v5.7h1.8c2%2C0%2C2.6-0.9%2C2.6-2.9c0-1.9-0.6-2.9-2.6-2.9h-1.8V36z%22%2F%3E%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M73.7%2C32.8c0.9%2C0%2C1.1%2C0.5%2C1.1%2C1v14.1l0.4%2C0.4h1.1V50h-6.5v-1.7h1l0.4-0.4V35l-0.4-0.4h-1v-1.7L73.7%2C32.8%20%20%20L73.7%2C32.8z%22%2F%3E%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M87.8%2C37.6c0.9%2C0%2C1.1%2C0.5%2C1.1%2C1V48l0.4%2C0.4h1v1.7h-3.8c-1%2C0-1.1-0.5-1.1-1v-0.4h-0.1%20%20%20c-0.4%2C0.4-1.5%2C1.7-3.4%2C1.7c-2.8%2C0-3.6-1.7-3.6-3.8v-6.8l-0.4-0.4h-1v-1.7h4c0.9%2C0%2C1.1%2C0.5%2C1.1%2C1V46c0%2C0.7%2C0.1%2C1.7%2C1.4%2C1.7%20%20%20c0.8%2C0%2C1.5-0.4%2C1.9-0.6v-7.3l-0.4-0.4h-1v-1.7h3.9V37.6z%22%2F%3E%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M95.6%2C50.3c-2.5%2C0-4-0.5-4-0.5v-3.5h2v1.6l0.4%2C0.4c0.5%2C0.1%2C1%2C0.1%2C1.7%2C0.1c1.4%2C0%2C1.8-0.6%2C1.8-1.5%20%20%20s-0.3-1.4-2.2-1.8c-2.9-0.6-3.6-2.2-3.6-3.8c0-2.5%2C1.8-4%2C5-4c2%2C0%2C3.6%2C0.4%2C3.6%2C0.4v3.4h-2v-1.4l-0.4-0.4c-0.4%2C0-0.8-0.1-1.2-0.1%20%20%20c-1.2%2C0-1.9%2C0.5-1.9%2C1.3s0.1%2C1.3%2C1.8%2C1.7c3.1%2C0.6%2C4.2%2C1.8%2C4.2%2C3.7C100.8%2C48.9%2C98.7%2C50.3%2C95.6%2C50.3z%22%2F%3E%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M111.8%2C35.7l-0.4-0.4h-1v-1.7h6.1v1.7h-1.1l-0.4%2C0.4v9c0%2C3.9-2.3%2C5.7-6%2C5.7c-3.6%2C0-6-1.8-6-5.7v-9l-0.4-0.4%20%20%20h-1v-1.7h6.8v1.7h-1.1l-0.4%2C0.4v9c0%2C2.1%2C0.7%2C3.2%2C2.5%2C3.2c2%2C0%2C2.5-1.1%2C2.5-3.2L111.8%2C35.7L111.8%2C35.7z%22%2F%3E%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M121.3%2C32.8c0.9%2C0%2C1.1%2C0.5%2C1.1%2C1v14.1l0.4%2C0.4h1.1V50h-6.5v-1.7h1l0.4-0.4V35l-0.4-0.4h-1v-1.7L121.3%2C32.8%20%20%20L121.3%2C32.8z%22%2F%3E%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M129.7%2C39.3v8.6l0.4%2C0.4h2.3V50c0%2C0-1.5%2C0.2-3.2%2C0.2c-2.1%2C0-3.1-0.8-3.1-2.9v-8.1h-1.5v-1.7h1l0.4-0.4%20%20%20l1.4-2.9h2.2v3.4h2.7v1.7C132.3%2C39.3%2C129.7%2C39.3%2C129.7%2C39.3z%22%2F%3E%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M138.6%2C48.4h1.3v1.7h-6.8v-1.7h1l0.4-0.4v-8.2l-0.4-0.4h-1v-1.7h3.8c0.9%2C0%2C1.1%2C0.5%2C1.1%2C1v0.6h0.1%20%20%20c0.4-0.5%2C1.6-1.9%2C3.4-1.9c0.5%2C0%2C0.9%2C0.1%2C0.9%2C0.1v5h-2.1v-1.7l-0.4-0.4c-0.7%2C0.1-1.3%2C0.4-1.7%2C0.6v7L138.6%2C48.4z%22%2F%3E%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M155%2C50.1h-3.8c-0.9%2C0-1.1-0.5-1.1-1v-0.4H150c-0.4%2C0.4-1.5%2C1.7-3.4%2C1.7c-2.7%2C0-3.6-1.7-3.6-3.8%20%20%20c0-2.2%2C1.6-3.5%2C4.2-3.5h2.7V42c0-1.4-0.1-2.4-2.1-2.4c-0.3%2C0-0.7%2C0-1.1%2C0.1l-0.4%2C0.4v1.7h-2.2V38c0%2C0%2C2-0.7%2C4.9-0.7%20%20%20c3.4%2C0%2C4.4%2C1.8%2C4.4%2C4v6.6l0.4%2C0.4h1v1.8H155z%20M149.9%2C47v-2h-1.7c-1.1%2C0-1.6%2C0.5-1.6%2C1.3c0%2C1%2C0.3%2C1.4%2C1.4%2C1.4%20%20%20C148.9%2C47.7%2C149.6%2C47.3%2C149.9%2C47z%22%2F%3E%20%3C%2Fg%3E%20%3Cpath%20class%3D%22st0%22%20d%3D%22M30.5%2C50.5c3.6%2C3.5%2C5%2C9.4%2C5.7%2C11.7c0.4%2C1.4%2C1.8%2C2.2%2C3.1%2C1.8c1.4-0.4%2C2.2-1.8%2C1.8-3.1c-0.6-2.3-2.4-8.2-1-13%20%20c1.2-4.9%2C5.6-9.1%2C7.3-10.8c1-1%2C1-2.6%2C0-3.6s-2.6-1-3.6%2C0c-1.7%2C1.7-5.9%2C6.1-10.8%2C7.3l0%2C0c-4.9%2C1.4-10.7-0.4-13-1%20%20c-1.4-0.4-2.8%2C0.4-3.1%2C1.8c-0.4%2C1.4%2C0.4%2C2.8%2C1.8%2C3.1C21.1%2C45.5%2C27%2C46.9%2C30.5%2C50.5L30.5%2C50.5z%22%2F%3E%20%3Cg%3E%20%20%3Cg%3E%20%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M178.6%2C33.3c4.1%2C0%2C7.1%2C2.7%2C7.1%2C8.5s-3%2C8.5-7.1%2C8.5s-7.1-2.7-7.1-8.5S174.5%2C33.3%2C178.6%2C33.3z%20M178.6%2C47.8%20%20%20%20c2.3%2C0%2C3.1-1.9%2C3.1-6s-0.8-6-3.1-6s-3.1%2C1.9-3.1%2C6S176.3%2C47.8%2C178.6%2C47.8z%22%2F%3E%20%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M196.3%2C49.4c-0.6%2C0.6-2.1%2C0.9-3.5%2C0.9c-3.2%2C0-6.1-2-6.1-6.3c0-4.5%2C2.9-6.7%2C6.3-6.7c1.9%2C0%2C3.2%2C0.5%2C3.2%2C0.5v4%20%20%20%20h-2.3v-1.9l-0.4-0.4c-0.1%2C0-0.2%2C0-0.3%2C0c-2%2C0-2.9%2C1.5-2.9%2C4.3s1.2%2C4.2%2C3.3%2C4.2c1%2C0%2C2.2-0.3%2C2.5-0.5v1.9H196.3z%22%2F%3E%20%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M206.8%2C49.4c-0.6%2C0.6-2.1%2C0.9-3.5%2C0.9c-3.2%2C0-6.1-2-6.1-6.3c0-4.5%2C2.9-6.7%2C6.3-6.7c1.9%2C0%2C3.2%2C0.5%2C3.2%2C0.5v4%20%20%20%20h-2.3v-1.9l-0.4-0.4c-0.1%2C0-0.2%2C0-0.3%2C0c-2%2C0-2.9%2C1.5-2.9%2C4.3s1.2%2C4.2%2C3.3%2C4.2c1%2C0%2C2.2-0.3%2C2.5-0.5v1.9H206.8z%22%2F%3E%20%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M211.7%2C37.5c0.9%2C0%2C1.1%2C0.5%2C1.1%2C1v9.2l0.4%2C0.4h1.1V50h-6.5v-1.9h1l0.4-0.4V40l-0.4-0.4h-1v-2L211.7%2C37.5%20%20%20%20L211.7%2C37.5z%20M210.8%2C32.5c1.3%2C0%2C2%2C0.7%2C2%2C1.9s-0.7%2C1.9-2%2C1.9c-1.4%2C0-2-0.7-2-1.9S209.5%2C32.5%2C210.8%2C32.5z%22%2F%3E%20%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M224.1%2C50.1c-0.9%2C0-1.1-0.5-1.1-1v-0.4h-0.1c-0.7%2C0.9-1.8%2C1.8-3.5%2C1.8c-2.5%2C0-4.5-2.2-4.5-6.4s2.3-6.7%2C5-6.7%20%20%20%20c1.2%2C0%2C2.1%2C0.6%2C2.8%2C1.2v-3.3l-0.4-0.4h-1v-2h4c0.9%2C0%2C1.1%2C0.5%2C1.1%2C1v13.9l0.4%2C0.4h1v1.9H224.1z%20M222.8%2C47.1v-6.4%20%20%20%20c-0.6-0.5-1.2-0.8-1.9-0.8c-1.4%2C0-2.1%2C1.2-2.1%2C4.1c0%2C3%2C0.7%2C3.8%2C2.2%2C3.8C221.4%2C47.7%2C222.1%2C47.6%2C222.8%2C47.1z%22%2F%3E%20%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M238.5%2C44.8h-6.3c0.3%2C2.4%2C1.5%2C3.2%2C3.4%2C3.2c1.3%2C0%2C2.3-0.4%2C2.7-0.5v1.9c-0.6%2C0.4-1.9%2C0.9-4%2C0.9%20%20%20%20c-3.1%2C0-5.8-1.9-5.8-6.3s2.3-6.7%2C5.5-6.7s5%2C2%2C5%2C5.1v1.9L238.5%2C44.8z%20M232.1%2C42.8h3.3V42c0-1.6-0.4-2.4-1.5-2.4%20%20%20%20C232.7%2C39.6%2C232.3%2C40.6%2C232.1%2C42.8z%22%2F%3E%20%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M239.7%2C50.1v-1.9h1l0.4-0.4V40l-0.4-0.4h-1v-2h3.8c0.9%2C0%2C1.1%2C0.5%2C1.1%2C1V39h0.1c0.4-0.5%2C1.7-1.7%2C3.5-1.7%20%20%20%20c2.8%2C0%2C3.6%2C1.7%2C3.6%2C3.8v6.7l0.4%2C0.4h1v1.9H247v-1.9h0.8l0.4-0.4v-6.1c0-0.7-0.1-1.7-1.6-1.7c-0.8%2C0-1.5%2C0.4-1.9%2C0.6v7.2l0.4%2C0.4%20%20%20%20h0.8v1.9C245.9%2C50.1%2C239.7%2C50.1%2C239.7%2C50.1z%22%2F%3E%20%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M258.7%2C39.6v8.2l0.4%2C0.4h2.3v1.9c0%2C0-1.5%2C0.2-3.2%2C0.2c-2.1%2C0-3.1-0.8-3.1-2.9v-7.8h-1.5v-2h1l0.4-0.4%20%20%20%20l1.4-2.9h2.2v3.4h2.7v2h-2.6V39.6z%22%2F%3E%20%20%3C%2Fg%3E%20%3C%2Fg%3E%3C%2Fg%3E%3C%2Fsvg%3E";

var logopre = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%3Csvg%20version%3D%221.1%22%20id%3D%22Capa_1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%20%20viewBox%3D%220%200%20146.75722%2062.90625%22%20style%3D%22enable-background%3Anew%200%200%20146.75722%2062.90625%3B%22%20xml%3Aspace%3D%22preserve%22%3E%3Cstyle%20type%3D%22text%2Fcss%22%3E%20.st0%7Bfill%3A%23FFFFFF%3B%7D%20.st1%7Bfill%3Anone%3Bstroke%3A%239B9E9E%3Bstroke-width%3A0.8%3Bstroke-miterlimit%3A10%3B%7D%20.st2%7Bfill%3A%23858585%3B%7D%20.st3%7Bfill%3A%23929291%3B%7D%20.st4%7Bfill%3A%23B61E3C%3B%7D%20.st5%7Bfill%3A%23C4007A%3B%7D%20.st6%7Bclip-path%3Aurl%28%23SVGID_2_%29%3Bfill%3Anone%3Bstroke%3A%239B9F9F%3Bstroke-width%3A0.394%3Bstroke-miterlimit%3A10%3B%7D%20.st7%7Bfill%3Anone%3Bstroke%3A%239B9F9F%3Bstroke-width%3A0.394%3Bstroke-miterlimit%3A10%3B%7D%20.st8%7Bclip-path%3Aurl%28%23SVGID_4_%29%3Bfill%3A%23BC122D%3B%7D%20.st9%7Bclip-path%3Aurl%28%23SVGID_4_%29%3Bfill%3A%23818282%3B%7D%20.st10%7Bfill%3A%23818282%3B%7D%20.st11%7Bclip-path%3Aurl%28%23SVGID_6_%29%3Bfill%3A%23818282%3B%7D%20.st12%7Bfill%3Anone%3Bstroke%3A%23818282%3Bstroke-width%3A0.449%3Bstroke-miterlimit%3A10%3B%7D%20.st13%7Bfill%3A%23818182%3B%7D%20.st14%7Bfill%3A%23BB132D%3B%7D%20.st15%7Bfill%3Anone%3B%7D%20.st16%7Bclip-path%3Aurl%28%23SVGID_8_%29%3Bfill%3A%23B01630%3B%7D%20.st17%7Bclip-path%3Aurl%28%23SVGID_8_%29%3Bfill%3Anone%3Bstroke%3A%23818282%3Bstroke-width%3A0.412%3Bstroke-miterlimit%3A10%3B%7D%20.st18%7Bfill%3Anone%3Bstroke%3A%23818282%3Bstroke-width%3A0.412%3Bstroke-miterlimit%3A10%3B%7D%20.st19%7Bfill%3A%23BC122D%3B%7D%20.st20%7Bfill%3Anone%3Bstroke%3A%23818282%3Bstroke-width%3A0.394%3Bstroke-miterlimit%3A10%3B%7D%20.st21%7Bclip-path%3Aurl%28%23SVGID_10_%29%3Bfill%3Anone%3Bstroke%3A%23818282%3Bstroke-width%3A0.394%3Bstroke-miterlimit%3A10%3B%7D%20.st22%7Bclip-path%3Aurl%28%23SVGID_10_%29%3Bfill%3A%23757679%3B%7D%20.st23%7Bclip-path%3Aurl%28%23SVGID_10_%29%3Bfill%3A%23B01630%3B%7D%20.st24%7Bclip-path%3Aurl%28%23SVGID_12_%29%3Bfill%3A%23B01630%3B%7D%20.st25%7Bclip-path%3Aurl%28%23SVGID_12_%29%3Bfill%3A%23818282%3B%7D%20.st26%7Bclip-path%3Aurl%28%23SVGID_12_%29%3Bfill%3Anone%3Bstroke%3A%23818282%3Bstroke-width%3A0.394%3Bstroke-miterlimit%3A10%3B%7D%20.st27%7Bfill%3A%23BC122E%3B%7D%20.st28%7Bfill%3Anone%3Bstroke%3A%239B9F9F%3Bstroke-width%3A0.182%3Bstroke-miterlimit%3A10%3B%7D%20.st29%7Bfill%3A%23B01630%3B%7D%20.st30%7Bopacity%3A0.2%3Bfill%3A%23B01630%3B%7D%3C%2Fstyle%3E%3Cg%3E%20%3Cg%3E%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M19.64154%2C25.01869l-0.45768-0.45768h-1.11919V22.7039h7.58058c4.29908%2C0%2C7.07231%2C1.70413%2C7.07231%2C5.64723%20%20%20c0%2C3.94302-2.77323%2C5.80056-7.07231%2C5.80056h-1.88241v4.04456l0.43229%2C0.45768h1.34892v1.85711h-7.47939v-1.85711h1.11919%20%20%20l0.45768-0.45768V25.01869z%20M23.76285%2C25.34987v6.15585h1.88241c2.16215%2C0%2C2.79811-0.99244%2C2.79811-3.07835%20%20%20c0-2.03539-0.63596-3.0775-2.79811-3.0775H23.76285z%22%2F%3E%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M39.61209%2C38.65392h1.42474v1.85711h-7.30119v-1.85711h1.11928l0.4581-0.45768v-8.85276l-0.4581-0.45768%20%20%20h-1.11928V27.0287h4.04464c1.01765%2C0%2C1.17064%2C0.58451%2C1.17064%2C1.11928v0.66117h0.12641%20%20%20c0.40751-0.50862%2C1.67934-2.03539%2C3.66329-2.03539c0.48374%2C0%2C0.96706%2C0.07675%2C0.96706%2C0.07675v5.31639h-2.28907v-1.78045%20%20%20l-0.43272-0.40708c-0.78844%2C0.15256-1.45004%2C0.4581-1.80651%2C0.6616v7.55528L39.61209%2C38.65392z%22%2F%3E%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M55.38511%2C34.43108h-6.74155c0.12726%2C2.84947%2C1.17064%2C3.892%2C3.63756%2C3.892%20%20%20c1.34841%2C0%2C2.41709-0.40665%2C2.82459-0.53392v2.0354c-0.66202%2C0.45768-1.9595%2C0.94099-4.14694%2C0.94099%20%20%20c-3.28151%2C0-6.20772-1.93335-6.20772-6.71625c0-4.93461%2C2.64597-7.27555%2C5.82628-7.27555%20%20%20c3.07835%2C0%2C5.26545%2C2.08642%2C5.26545%2C5.4698v1.72985L55.38511%2C34.43108z%20M48.66886%2C32.65063h3.51064v-0.6616%20%20%20c0-1.95865-0.40665-2.90006-1.57729-2.90006C49.4067%2C29.08897%2C48.82184%2C30.36072%2C48.66886%2C32.65063z%22%2F%3E%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M56.80984%2C27.0287h4.04507c1.01723%2C0%2C1.17021%2C0.58451%2C1.17021%2C1.11928v0.40708h0.07632%20%20%20c0.61058-0.83988%2C1.95907-1.7813%2C3.46004-1.7813c2.64521%2C0%2C4.8588%2C2.03539%2C4.8588%2C6.86847%20%20%20c0%2C4.83341-2.21359%2C7.12333-4.8588%2C7.12333c-1.29747%2C0-2.64597-0.73784-3.30714-1.55157v3.30672l0.43195%2C0.45844h1.2979v1.85669%20%20%20h-7.17435v-1.85669h1.1197l0.45768-0.45844V29.34349l-0.45768-0.45768h-1.1197V27.0287z%20M64.18736%2C29.6739%20%20%20c-0.55964%2C0-1.27184%2C0.30546-1.93301%2C0.8904v6.66531c0.66117%2C0.53391%2C1.39867%2C0.66075%2C1.93301%2C0.66075%20%20%20c1.70455%2C0%2C2.28949-1.19509%2C2.28949-4.12045S65.89191%2C29.6739%2C64.18736%2C29.6739z%22%2F%3E%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M82.47907%2C34.43108h-6.74112c0.12759%2C2.84947%2C1.17021%2C3.892%2C3.6379%2C3.892%20%20%20c1.34807%2C0%2C2.41632-0.40665%2C2.82382-0.53392v2.0354c-0.6616%2C0.45768-1.95907%2C0.94099-4.14703%2C0.94099%20%20%20c-3.28142%2C0-6.20721-1.93335-6.20721-6.71625c0-4.93461%2C2.64555-7.27555%2C5.82585-7.27555%20%20%20c3.07835%2C0%2C5.26622%2C2.08642%2C5.26622%2C5.4698v1.72985L82.47907%2C34.43108z%20M75.76359%2C32.65063h3.5103v-0.6616%20%20%20c0-1.95865-0.40707-2.90006-1.57729-2.90006C76.50066%2C29.08897%2C75.91573%2C30.36072%2C75.76359%2C32.65063z%22%2F%3E%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M90.0352%2C38.65392h1.42432v1.85711h-7.30034v-1.85711h1.11885l0.45844-0.45768v-8.85276l-0.45844-0.45768%20%20%20h-1.11885V27.0287h4.04456c1.01774%2C0%2C1.16987%2C0.58451%2C1.16987%2C1.11928v0.66117h0.12727%20%20%20c0.4075-0.50862%2C1.67925-2.03539%2C3.6632-2.03539c0.48373%2C0%2C0.96714%2C0.07675%2C0.96714%2C0.07675v5.31639h-2.28949v-1.78045%20%20%20l-0.43281-0.40708c-0.78843%2C0.15256-1.45003%2C0.4581-1.80608%2C0.6616v7.55528L90.0352%2C38.65392z%22%2F%3E%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M99.75348%2C40.76555c-2.69691%2C0-4.35052-0.58494-4.35052-0.58494v-3.76516h2.11163v1.70456l0.43281%2C0.45768%20%20%20c0.53391%2C0.07624%2C1.11885%2C0.10196%2C1.80608%2C0.10196c1.47533%2C0%2C1.95873-0.6616%2C1.95873-1.62831%20%20%20c0-0.99202-0.27939-1.47576-2.39145-1.90771c-3.15382-0.63587-3.84106-2.3147-3.84106-4.07028%20%20%20c0-2.69657%2C1.98438-4.29959%2C5.41835-4.29959c2.18787%2C0%2C3.86636%2C0.43323%2C3.86636%2C0.43323v3.68808h-2.11078v-1.55157%20%20%20l-0.4328-0.40708c-0.40665-0.0506-0.83946-0.10196-1.32278-0.10196c-1.27184%2C0-2.03497%2C0.56006-2.03497%2C1.3738%20%20%20c0%2C0.81407%2C0.07632%2C1.42473%2C1.98394%2C1.80609c3.33245%2C0.6869%2C4.52838%2C1.90813%2C4.52838%2C3.94302%20%20%20C105.37541%2C39.21398%2C103.03499%2C40.76555%2C99.75348%2C40.76555z%22%2F%3E%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M119.36798%2C40.51103h-4.04541c-1.01723%2C0-1.17021-0.58536-1.17021-1.11928v-0.40708h-0.12684%20%20%20c-0.40665%2C0.4581-1.65361%2C1.78088-3.61226%2C1.78088c-2.92579%2C0-3.86721-1.85754-3.86721-4.04498%20%20%20c0-2.39111%2C1.75516-3.79012%2C4.50308-3.79012h2.87443v-1.22166c0-1.47491-0.0759-2.54358-2.26376-2.54358%20%20%20c-0.33127%2C0-0.73792%2C0.02572-1.14458%2C0.07632l-0.3822%2C0.38178v1.78045h-2.36573v-3.89208%20%20%20c0%2C0.0253%2C2.13736-0.73792%2C5.26622-0.73792c3.63756%2C0%2C4.75675%2C1.95873%2C4.75675%2C4.32488v7.09761l0.4581%2C0.45768h1.11962V40.51103z%20%20%20%20M113.92356%2C37.20389v-2.21283h-1.80618c-1.16978%2C0-1.70412%2C0.50827-1.70412%2C1.3485c0%2C1.06825%2C0.35648%2C1.5508%2C1.55157%2C1.5508%20%20%20C112.80471%2C37.89036%2C113.51649%2C37.48413%2C113.92356%2C37.20389z%22%2F%3E%20%3C%2Fg%3E%20%3Cpath%20class%3D%22st0%22%20d%3D%22M122.528%2C23.84177c2.03081%2C1.96985%2C2.82051%2C5.28447%2C3.17122%2C6.59111%20%20c0.20477%2C0.76602%2C0.99075%2C1.21996%2C1.75592%2C1.01434c0.76526-0.20435%2C1.21877-0.99117%2C1.01434-1.75634%20%20c-0.35028-1.30749-1.32311-4.57193-0.54919-7.29329c0.6902-2.74343%2C3.16493-5.08428%2C4.12207-6.04107%20%20c0.56006-0.56083%2C0.56006-1.46863%2C0-2.02826c-0.56041-0.56006-1.46863-0.56006-2.02827%2C0%20%20c-0.95636%2C0.95712-3.29806%2C3.43228-6.04098%2C4.12249l0%2C0c-2.72102%2C0.774-5.98631-0.19934-7.29338-0.55005%20%20c-0.76475-0.20477-1.55157%2C0.24875-1.75634%2C1.01392c-0.20477%2C0.76526%2C0.24875%2C1.55165%2C1.01392%2C1.75685%20%20C117.24438%2C21.02176%2C120.55856%2C21.81223%2C122.528%2C23.84177L122.528%2C23.84177z%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E";

var logosb = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%3Csvg%20version%3D%221.1%22%20id%3D%22Capa_1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%20%20width%3D%22389.7px%22%20height%3D%2283px%22%20viewBox%3D%220%200%20389.7%2083%22%20style%3D%22enable-background%3Anew%200%200%20389.7%2083%3B%22%20xml%3Aspace%3D%22preserve%22%3E%3Cstyle%20type%3D%22text%2Fcss%22%3E%20.st0%7Bfill%3A%23FFFFFF%3B%7D%3C%2Fstyle%3E%3Cg%3E%20%3Cg%3E%20%20%3Cg%3E%20%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M259.8%2C34.1c-2.5%2C0-4.2-0.6-4.2-0.6v-3.3h1.3v2.1l0.3%2C0.3c0.6%2C0.1%2C1.4%2C0.2%2C2.5%2C0.2c2.1%2C0%2C3.3-1%2C3.3-2.6%20%20%20%20c0-1.4-0.9-2.2-3.2-2.8c-2.8-0.8-4.2-2.1-4.2-4.2c0-2.5%2C2.1-3.9%2C5-3.9c2.2%2C0%2C3.8%2C0.5%2C3.8%2C0.5V23h-1.3v-1.9l-0.3-0.3%20%20%20%20c-0.5-0.1-1.3-0.2-2.2-0.2c-2%2C0-3.2%2C0.9-3.2%2C2.3c0%2C1.2%2C0.5%2C2%2C3.2%2C2.8s4.3%2C1.8%2C4.3%2C4.1C265%2C32.7%2C262.8%2C34.1%2C259.8%2C34.1z%22%2F%3E%20%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M275.2%2C29h-6.5c0.1%2C2.7%2C1.4%2C3.9%2C3.6%2C3.9c1.1%2C0%2C2.1-0.3%2C2.7-0.5v1.1c-0.7%2C0.4-1.7%2C0.7-3.3%2C0.7%20%20%20%20c-2.8%2C0-4.9-1.6-4.9-5.5s2.1-5.7%2C4.6-5.7c2.3%2C0%2C4.1%2C1.5%2C4.1%2C4.4v1.4L275.2%2C29z%20M268.7%2C27.8h4.9v-0.6c0-2.2-0.9-3.1-2.3-3.1%20%20%20%20C269.9%2C24.1%2C268.9%2C25.3%2C268.7%2C27.8z%22%2F%3E%20%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M280.8%2C32.9h1.6v1H277v-1h1.4l0.3-0.3v-8.1l-0.3-0.3H277v-1.1h2.5c0.7%2C0%2C0.9%2C0.3%2C0.9%2C0.8v0.6l0%2C0%20%20%20%20c0.4-0.5%2C1.6-1.7%2C3.3-1.7c0.3%2C0%2C0.6%2C0%2C0.7%2C0.1v3.4h-1.2v-1.5l-0.3-0.3c-1.2%2C0.1-2%2C0.7-2.5%2C1.2v6.9L280.8%2C32.9z%22%2F%3E%20%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M294.3%2C29h-6.5c0.1%2C2.7%2C1.4%2C3.9%2C3.6%2C3.9c1.1%2C0%2C2.1-0.3%2C2.7-0.5v1.1c-0.7%2C0.4-1.7%2C0.7-3.3%2C0.7%20%20%20%20c-2.8%2C0-4.9-1.6-4.9-5.5s2.1-5.7%2C4.6-5.7c2.3%2C0%2C4.1%2C1.5%2C4.1%2C4.4v1.4L294.3%2C29z%20M287.8%2C27.8h4.9v-0.6c0-2.2-0.9-3.1-2.3-3.1%20%20%20%20C289%2C24.1%2C288%2C25.3%2C287.8%2C27.8z%22%2F%3E%20%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M296%2C33.9v-1h1.4l0.3-0.3v-8.1l-0.3-0.3H296v-1.1h2.5c0.7%2C0%2C0.9%2C0.3%2C0.9%2C0.8v0.6l0%2C0%20%20%20%20c0.6-0.7%2C1.8-1.6%2C3.4-1.6c1.5%2C0%2C2.4%2C0.7%2C2.8%2C1.8c0.6-0.7%2C1.8-1.8%2C3.6-1.8c2.2%2C0%2C3%2C1.5%2C3%2C3.3v6.4l0.3%2C0.3h1.4v1h-5.1v-1h1.2%20%20%20%20l0.3-0.3v-6.1c0-1.1-0.3-2.1-1.7-2.1c-1%2C0-1.9%2C0.4-2.8%2C1.3c0%2C0.2%2C0%2C0.3%2C0%2C0.5v6.4l0.3%2C0.3h1.4v1h-5v-1h1.2l0.3-0.3v-6.1%20%20%20%20c0-1-0.3-2.1-1.7-2.1c-1%2C0-1.9%2C0.4-2.8%2C1.3v6.9l0.3%2C0.3h1.2v1H296z%22%2F%3E%20%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M319.6%2C34.1c-2.5%2C0-4.7-1.8-4.7-5.6s2.2-5.6%2C4.7-5.6s4.7%2C1.8%2C4.7%2C5.6C324.3%2C32.3%2C322.2%2C34.1%2C319.6%2C34.1z%20%20%20%20%20M319.6%2C24.1c-1.7%2C0-2.7%2C1.4-2.7%2C4.4s1%2C4.4%2C2.7%2C4.4s2.7-1.4%2C2.7-4.4S321.4%2C24.1%2C319.6%2C24.1z%22%2F%3E%20%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M329.5%2C34.1c-2.1%2C0-3.4-0.5-3.4-0.5V31h1.2v1.4l0.3%2C0.3c0.5%2C0.1%2C1.1%2C0.2%2C2%2C0.2c1.4%2C0%2C2.4-0.7%2C2.4-1.8%20%20%20%20c0-1-0.6-1.5-2.5-2c-2.5-0.6-3.2-1.7-3.2-3.2c0-1.8%2C1.5-3%2C4.1-3c1.7%2C0%2C3%2C0.3%2C3%2C0.3v2.5h-1.2v-1.4l-0.2-0.2%20%20%20%20c-0.4-0.1-0.9-0.2-1.6-0.2c-1.5%2C0-2.3%2C0.7-2.3%2C1.6s0.4%2C1.4%2C2.3%2C1.9c2.5%2C0.6%2C3.5%2C1.5%2C3.5%2C3.2C333.8%2C32.9%2C332%2C34.1%2C329.5%2C34.1z%22%2F%3E%20%20%3C%2Fg%3E%20%20%3Cg%3E%20%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M262.6%2C38.7c4.7%2C0%2C8.1%2C3.1%2C8.1%2C9.8s-3.4%2C9.8-8.1%2C9.8s-8.1-3.1-8.1-9.8S257.9%2C38.7%2C262.6%2C38.7z%20M262.6%2C55.3%20%20%20%20c2.6%2C0%2C3.5-2.2%2C3.5-6.9s-0.9-6.9-3.5-6.9s-3.5%2C2.2-3.5%2C6.9S260%2C55.3%2C262.6%2C55.3z%22%2F%3E%20%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M282.9%2C57.2c-0.7%2C0.7-2.4%2C1.1-4%2C1.1c-3.7%2C0-6.9-2.3-6.9-7.3c0-5.1%2C3.3-7.6%2C7.3-7.6c2.1%2C0%2C3.7%2C0.6%2C3.7%2C0.6%20%20%20%20v4.6h-2.6v-2.2l-0.5-0.5c-0.1%2C0-0.2%2C0-0.3%2C0c-2.3%2C0-3.3%2C1.8-3.3%2C5s1.3%2C4.8%2C3.8%2C4.8c1.2%2C0%2C2.5-0.4%2C2.9-0.5v2H282.9z%22%2F%3E%20%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M294.9%2C57.2c-0.7%2C0.7-2.4%2C1.1-4%2C1.1c-3.7%2C0-6.9-2.3-6.9-7.3c0-5.1%2C3.3-7.6%2C7.3-7.6c2.1%2C0%2C3.7%2C0.6%2C3.7%2C0.6%20%20%20%20v4.6h-2.6v-2.2l-0.5-0.5c-0.1%2C0-0.2%2C0-0.3%2C0c-2.3%2C0-3.3%2C1.8-3.3%2C5s1.3%2C4.8%2C3.8%2C4.8c1.2%2C0%2C2.5-0.4%2C2.9-0.5v2H294.9z%22%2F%3E%20%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M300.6%2C43.6c1.1%2C0%2C1.2%2C0.6%2C1.2%2C1.2v10.5l0.5%2C0.5h1.2V58H296v-2.2h1.2l0.5-0.5v-8.9l-0.5-0.5H296v-2.3%20%20%20%20C296%2C43.6%2C300.6%2C43.6%2C300.6%2C43.6z%20M299.5%2C37.8c1.5%2C0%2C2.3%2C0.8%2C2.3%2C2.2s-0.8%2C2.2-2.3%2C2.2s-2.3-0.8-2.3-2.2S298%2C37.8%2C299.5%2C37.8z%22%2F%3E%20%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M314.7%2C58c-1.1%2C0-1.2-0.6-1.2-1.2v-0.5h-0.1c-0.8%2C1.1-2.1%2C2-4%2C2c-2.9%2C0-5.2-2.5-5.2-7.3s2.6-7.6%2C5.7-7.6%20%20%20%20c1.3%2C0%2C2.4%2C0.7%2C3.2%2C1.4V41l-0.5-0.5h-1.2v-2.3h4.6c1.1%2C0%2C1.2%2C0.6%2C1.2%2C1.2v15.9l0.5%2C0.5h1.2V58H314.7z%20M313.2%2C54.5v-7.4%20%20%20%20c-0.7-0.6-1.4-0.9-2.2-0.9c-1.6%2C0-2.4%2C1.4-2.4%2C4.7c0%2C3.4%2C0.8%2C4.3%2C2.5%2C4.3C311.6%2C55.2%2C312.4%2C55.1%2C313.2%2C54.5z%22%2F%3E%20%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M331.2%2C51.9h-7.3c0.3%2C2.7%2C1.8%2C3.7%2C3.9%2C3.7c1.5%2C0%2C2.7-0.4%2C3.1-0.6v2.2c-0.7%2C0.5-2.2%2C1-4.6%2C1%20%20%20%20c-3.6%2C0-6.7-2.1-6.7-7.2c0-5%2C2.6-7.7%2C6.3-7.7c3.7%2C0%2C5.7%2C2.3%2C5.7%2C5.8v2.2L331.2%2C51.9z%20M323.9%2C49.6h3.7v-0.9c0-1.8-0.4-2.7-1.7-2.7%20%20%20%20C324.6%2C45.9%2C324.1%2C47.1%2C323.9%2C49.6z%22%2F%3E%20%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M332.6%2C58v-2.2h1.2l0.5-0.5v-8.9l-0.5-0.5h-1.2v-2.3h4.3c1.1%2C0%2C1.2%2C0.6%2C1.2%2C1.2v0.5h0.1c0.5-0.5%2C1.9-2%2C4-2%20%20%20%20c3.2%2C0%2C4.2%2C2%2C4.2%2C4.3v7.6l0.5%2C0.5h1.2V58H341v-2.2h0.9l0.5-0.5v-7c0-0.8-0.1-1.9-1.8-1.9c-0.9%2C0-1.7%2C0.4-2.1%2C0.7v8.2l0.5%2C0.5h0.9%20%20%20%20V58H332.6z%22%2F%3E%20%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M354.4%2C45.9v9.4l0.5%2C0.5h2.6V58c0%2C0-1.7%2C0.3-3.7%2C0.3c-2.4%2C0-3.6-0.9-3.6-3.4v-9h-1.7v-2.3h1.2l0.5-0.5%20%20%20%20l1.5-3.4h2.6v3.9h3v2.3C357.3%2C45.9%2C354.4%2C45.9%2C354.4%2C45.9z%22%2F%3E%20%20%3C%2Fg%3E%20%3C%2Fg%3E%20%3Cg%3E%20%20%3Cg%3E%20%20%20%3Cg%3E%20%20%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M61%2C58.2c-3.2%2C0-5.7-0.7-5.7-0.7v-5.3h2.5V55l0.5%2C0.5c0.7%2C0.1%2C1.6%2C0.2%2C2.7%2C0.2c2.2%2C0%2C2.9-1%2C2.9-2.5%20%20%20%20%20c0-1.6-0.6-2.2-2.9-2.8c-3.9-1.1-5.7-2.4-5.7-6.1c0-3.7%2C3-5.6%2C7.1-5.6c2.9%2C0%2C5.1%2C0.7%2C5.1%2C0.7v5H65v-2.5l-0.5-0.5%20%20%20%20%20c-0.6-0.1-1.3-0.2-2.1-0.2c-1.9%2C0-3%2C0.9-3%2C2.3c0%2C1.4%2C0.3%2C2.1%2C3.3%2C2.9c3.6%2C1%2C5.6%2C2.4%2C5.6%2C5.7C68.2%2C56.3%2C65.3%2C58.2%2C61%2C58.2z%22%2F%3E%20%20%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M81.3%2C51.4h-7.2c0.1%2C3%2C1.3%2C4.2%2C3.9%2C4.2c1.4%2C0%2C2.6-0.4%2C3-0.6v2.2c-0.7%2C0.5-2.1%2C1-4.4%2C1%20%20%20%20%20c-3.5%2C0-6.6-2.1-6.6-7.2c0-5.3%2C2.8-7.8%2C6.2-7.8c3.3%2C0%2C5.6%2C2.2%2C5.6%2C5.8v2L81.3%2C51.4z%20M74.1%2C49.5h3.7v-0.7c0-2.1-0.4-3.1-1.7-3.1%20%20%20%20%20C74.9%2C45.7%2C74.3%2C47.1%2C74.1%2C49.5z%22%2F%3E%20%20%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M89.3%2C52.5c-0.7%2C0-1.3-0.1-1.9-0.2c-0.4%2C0.3-0.5%2C0.6-0.5%2C1c0%2C0.5%2C0.3%2C0.8%2C1.1%2C0.8h4.1%20%20%20%20%20c2.5%2C0%2C4.6%2C0.7%2C4.6%2C3.7c0%2C3.5-3.5%2C5.1-7.7%2C5.1c-3.6%2C0-6-0.7-6-3.1c0-1.2%2C0.9-1.9%2C1.9-2.3c-1-0.4-1.7-1.4-1.7-2.6%20%20%20%20%20c0-1.1%2C0.7-2.3%2C2.3-3.3c-1.2-0.8-2-2-2-3.7c0-3.2%2C2.7-4.6%2C5.8-4.6c0.8%2C0%2C1.5%2C0.1%2C2.2%2C0.3h5.1v2h-1.8l-0.2%2C0.2%20%20%20%20%20c0.3%2C0.6%2C0.5%2C1.3%2C0.5%2C2.1C95.1%2C51%2C92.4%2C52.5%2C89.3%2C52.5z%20M86.9%2C57.7c-0.2%2C0.3-0.5%2C0.8-0.5%2C1.6c0%2C1.1%2C0.7%2C1.8%2C2.7%2C1.8%20%20%20%20%20c2.1%2C0%2C3.5-0.7%2C3.5-2.1c0-1-0.6-1.2-1.7-1.2L86.9%2C57.7L86.9%2C57.7z%20M89.3%2C45.5c-1.3%2C0-2%2C0.8-2%2C2.4c0%2C1.6%2C0.7%2C2.4%2C2%2C2.4%20%20%20%20%20s2-0.8%2C2-2.4S90.6%2C45.5%2C89.3%2C45.5z%22%2F%3E%20%20%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M110%2C43.5c1.1%2C0%2C1.3%2C0.6%2C1.3%2C1.2v10.7l0.5%2C0.5h1.2v2h-4.3c-1.1%2C0-1.3-0.6-1.3-1.2v-0.4h-0.1%20%20%20%20%20c-0.4%2C0.5-1.8%2C1.9-3.9%2C1.9c-3.2%2C0-4.2-2-4.2-4.4V46l-0.5-0.5h-1.2v-2h4.6c1.1%2C0%2C1.2%2C0.6%2C1.2%2C1.2v8.5c0%2C0.8%2C0.1%2C1.9%2C1.7%2C1.9%20%20%20%20%20c1%2C0%2C1.7-0.4%2C2.1-0.7V46l-0.5-0.5h-1.2v-2H110L110%2C43.5z%22%2F%3E%20%20%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M120.3%2C56h1.5v2H114v-2h1.2l0.5-0.5V46l-0.5-0.5H114v-2h4.3c1.1%2C0%2C1.2%2C0.6%2C1.2%2C1.2v0.7h0.1%20%20%20%20%20c0.4-0.5%2C1.8-2.2%2C3.9-2.2c0.5%2C0%2C1%2C0.1%2C1%2C0.1V49h-2.4v-1.9l-0.5-0.4c-0.8%2C0.2-1.5%2C0.5-1.9%2C0.7v8.1L120.3%2C56z%22%2F%3E%20%20%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M132.3%2C58.2c-3.7%2C0-6.5-2.3-6.5-7.5s2.8-7.5%2C6.5-7.5s6.5%2C2.3%2C6.5%2C7.5S136%2C58.2%2C132.3%2C58.2z%20M132.3%2C45.8%20%20%20%20%20c-1.8%2C0-2.3%2C1.6-2.3%2C4.9c0%2C3.3%2C0.5%2C4.9%2C2.3%2C4.9s2.3-1.6%2C2.3-4.9C134.6%2C47.4%2C134.1%2C45.8%2C132.3%2C45.8z%22%2F%3E%20%20%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M145.2%2C58.2c-2.9%2C0-4.6-0.6-4.6-0.6v-4h2.3v1.8l0.5%2C0.5c0.6%2C0.1%2C1.2%2C0.1%2C1.9%2C0.1c1.6%2C0%2C2.1-0.7%2C2.1-1.7%20%20%20%20%20c0-1.1-0.3-1.6-2.6-2c-3.4-0.7-4.1-2.5-4.1-4.4c0-2.9%2C2.1-4.6%2C5.8-4.6c2.3%2C0%2C4.1%2C0.5%2C4.1%2C0.5v3.9h-2.3V46l-0.5-0.4%20%20%20%20%20c-0.4-0.1-0.9-0.1-1.4-0.1c-1.4%2C0-2.2%2C0.6-2.2%2C1.5s0.1%2C1.5%2C2.1%2C1.9c3.6%2C0.7%2C4.8%2C2%2C4.8%2C4.2C151.2%2C56.6%2C148.7%2C58.2%2C145.2%2C58.2z%22%2F%3E%20%20%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M157.9%2C56h1.2l0.5-0.5V41.4l-0.5-0.5h-1.2v-2h8.2c4.3%2C0%2C7%2C1.6%2C7%2C4.9c0%2C2.1-1.1%2C3.4-2.9%2C4.1V48%20%20%20%20%20c2.3%2C0.8%2C3.7%2C2.2%2C3.7%2C4.7c0%2C3.6-2.7%2C5.2-7%2C5.2h-9V56L157.9%2C56z%20M164%2C41.6v5.2h1.9c1.9%2C0%2C2.8-0.8%2C2.8-2.6s-0.9-2.6-2.8-2.6%20%20%20%20%20L164%2C41.6L164%2C41.6z%20M164%2C49.6v5.7h2.7c1.9%2C0%2C2.7-0.9%2C2.7-2.9c0-1.9-0.8-2.8-2.7-2.8H164L164%2C49.6z%22%2F%3E%20%20%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M180%2C43.5c1.1%2C0%2C1.2%2C0.6%2C1.2%2C1.2v10.7l0.5%2C0.5h1.2v2h-7.5v-2h1.2l0.5-0.5V46l-0.5-0.5h-1.2v-2H180z%20%20%20%20%20%20M178.9%2C37.7c1.5%2C0%2C2.3%2C0.8%2C2.3%2C2.2s-0.8%2C2.2-2.3%2C2.2s-2.3-0.8-2.3-2.2C176.6%2C38.5%2C177.4%2C37.7%2C178.9%2C37.7z%22%2F%3E%20%20%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M188.4%2C38.1c1.1%2C0%2C1.3%2C0.6%2C1.3%2C1.2v16.2l0.5%2C0.5h1.2v2h-7.5v-2h1.2l0.5-0.5V40.6l-0.5-0.5h-1.2v-2H188.4z%22%20%20%20%20%20%2F%3E%20%20%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M196.8%2C38.1c1.1%2C0%2C1.3%2C0.6%2C1.3%2C1.2V45c0.7-0.9%2C2.1-1.7%2C3.5-1.7c2.8%2C0%2C5.2%2C2.4%2C5.2%2C7.6s-2.4%2C7.3-5.2%2C7.3%20%20%20%20%20c-1.6%2C0-3-1-3.7-1.9h-0.1v0.4c0%2C0.6-0.2%2C1.2-1.3%2C1.2h-4.3v-2h1.2l0.5-0.5V40.6l-0.5-0.5h-1.2v-2H196.8z%20M200.1%2C46.3%20%20%20%20%20c-0.6%2C0-1.4%2C0.2-2.1%2C0.7v7.2c0.7%2C0.6%2C1.5%2C0.9%2C2.1%2C0.9c1.8%2C0%2C2.4-1.2%2C2.4-4.4C202.5%2C47.6%2C201.9%2C46.3%2C200.1%2C46.3z%22%2F%3E%20%20%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M221.7%2C57.9h-4.3c-1.1%2C0-1.2-0.6-1.2-1.2v-0.4H216c-0.4%2C0.5-1.8%2C1.9-3.9%2C1.9c-3.1%2C0-4.1-2-4.1-4.3%20%20%20%20%20c0-2.6%2C1.9-4.1%2C4.8-4.1h3.1v-1.3c0-1.6-0.1-2.7-2.4-2.7c-0.4%2C0-0.8%2C0-1.2%2C0.1l-0.4%2C0.4v1.9h-2.5V44c0%2C0%2C2.3-0.8%2C5.6-0.8%20%20%20%20%20c3.9%2C0%2C5.1%2C2.1%2C5.1%2C4.6v7.6l0.5%2C0.5h1.2L221.7%2C57.9L221.7%2C57.9z%20M215.9%2C54.4V52H214c-1.2%2C0-1.8%2C0.5-1.8%2C1.4%20%20%20%20%20c0%2C1.1%2C0.4%2C1.7%2C1.7%2C1.7C214.7%2C55.1%2C215.5%2C54.7%2C215.9%2C54.4z%22%2F%3E%20%20%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M229.2%2C58.2c-3.7%2C0-6.5-2.3-6.5-7.5s2.8-7.5%2C6.5-7.5s6.5%2C2.3%2C6.5%2C7.5S232.9%2C58.2%2C229.2%2C58.2z%20M229.2%2C45.8%20%20%20%20%20c-1.8%2C0-2.3%2C1.6-2.3%2C4.9c0%2C3.3%2C0.5%2C4.9%2C2.3%2C4.9s2.3-1.6%2C2.3-4.9C231.5%2C47.4%2C231%2C45.8%2C229.2%2C45.8z%22%2F%3E%20%20%20%3C%2Fg%3E%20%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M33.1%2C49.5c3.7%2C3.6%2C5.1%2C9.6%2C5.8%2C12c0.4%2C1.4%2C1.8%2C2.2%2C3.2%2C1.8s2.2-1.8%2C1.8-3.2c-0.6-2.4-2.4-8.3-1-13.3%20%20%20%20c1.3-5%2C5.8-9.2%2C7.5-11c1-1%2C1-2.7%2C0-3.7s-2.7-1-3.7%2C0c-1.7%2C1.7-6%2C6.2-11%2C7.5l0%2C0c-5%2C1.4-10.9-0.4-13.3-1c-1.4-0.4-2.8%2C0.5-3.2%2C1.8%20%20%20%20c-0.4%2C1.4%2C0.4%2C2.8%2C1.8%2C3.2C23.5%2C44.4%2C29.5%2C45.8%2C33.1%2C49.5L33.1%2C49.5z%22%2F%3E%20%20%3C%2Fg%3E%20%3C%2Fg%3E%3C%2Fg%3E%3C%2Fsvg%3E";

var cortes = "data:image/jpeg;base64,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";

var getxo = "data:image/jpeg;base64,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";

var nortehispana = "data:image/jpeg;base64,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";

var stqgat = "data:image/jpeg;base64,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";

var stqgatocc = "data:image/jpeg;base64,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";

function getCiaFromUrl() {
    var host = window.location.hostname.toLowerCase();
    switch (host) {
        case "wportal.gco.global":
        case "wgestiona.gco.global":
            return "W";
        case "dgestiona.gco.global":
        case "dgestionanuevo.gco.global":
        case "gestiona.gco.global":
        case "gestionanuevo.gco.global":
        case "dgestionatest.gco.global":
            return "GCO";
        case "dportaloccident.gco.global":
        case "portaloccident.gco.global":
            return "OCC";
        case "dportalsb.gco.global":
        case "portalsb.gco.global":
        case "portalsegurosbilbao.gco.global":
        case "dportalsegurosbilbao.gco.global":
        case "dportalsegurosbilbaoold.gco.global":
        case "portalsegurosbilbaoold.gco.global":
            return "SBI";
        case "dportalpu.gco.global":
        case "portalpu.gco.global":
        case "portalplusultra.gco.global":
        case "dportalplusultra.gco.global":
        case "dportalplusultraold.gco.global":
        case "portalplusultraold.gco.global":
            return "SPU";
        case "dportalnh.gco.global":
        case "portalnh.gco.global":
        case "portalnortehispana.gco.global":
        case "dportalnortehispana.gco.global":
        case "portalnortehispanaold.gco.global":
        case "dportalnortehispanaold.gco.global":
            return "NH";
        case "dportalpre.gco.global":
        case "portalpre.gco.global":
        case "portalprepersa.gco.global":
        case "dportalprepersa.gco.global":
        case "portalprepersaold.gco.global":
        case "dportalprepersaold.gco.global":
            return "PRE";
        case "dportaltec.gco.global":
        case "portaltec.gco.global":
        case "portalaie.gco.global":
        case "dportalaie.gco.global":
            return "AIE";
        case "localhost.gco.global":
            return window.location.port == "3000" ? "OCC" : "GCO";
        case "dportalsco.gco.global":
        case "portalsco.gco.global":
        case "portalcatalanaoccidente.gco.global":
        case "dportalcatalanaoccidente.gco.global":
        case "dportalcatalanaoccidenteold.gco.global":
        case "portalcatalanaoccidenteold.gco.global":
        default:
            return "SCO";
    }
}
function esGestiona() {
    var host = window.location.hostname.toLowerCase();
    return ((host.indexOf("gestiona") >= 0) || (window.location.port == "3001"));
}
function getAplicacionFromUrl() {
    if (esGestiona()) {
        return "Gestiona";
    }
    else {
        return "Portal";
    }
}
function getLogo() {
    if (esGestiona()) {
        return logogestiona;
    }
    else {
        return getLogoPortal();
    }
}
function getLogoPortal() {
    var cia = getCiaFromUrl();
    switch (cia) {
        case "SBI":
            return logosb;
        case "SPU":
            return logospu;
        case "NH":
            return logonh;
        case "PRE":
            return logopre;
        case "AIE":
            //return logoaie;
            return logogco;
        case "OCC":
            return logoocc;
        case "SCO":
        default:
            return logo;
    }
}
function getPortalTitle() {
    if (esGestiona())
        return "Gestiona";
    var cia = getCiaFromUrl();
    switch (cia) {
        case "SBI":
            return "Seguros Bilbao";
        case "SPU":
            return "Plus Ultra Seguros";
        case "NH":
            return "Nortehispana Seguros";
        case "PRE":
            return "Prepersa";
        case "AIE":
            return "GCO Tecnología y Servicios";
        case "OCC":
            return "Occident";
        case "SCO":
        default:
            return "Seguros Catalana Occidente";
    }
}
function getCiaBuilding() {
    if (esGestiona())
        return stqgatocc;
    var cia = getCiaFromUrl();
    switch (cia) {
        case "SBI":
            return getxo;
        case "SPU":
            return cortes;
        case "NH":
            return nortehispana;
        case "OCC":
        case "PRE":
        case "AIE":
            return stqgatocc;
        case "SCO":
        default:
            return stqgat;
    }
}
function getCiaTitle() {
    if (esGestiona())
        return "Gestiona";
    var cia = getCiaFromUrl();
    switch (cia) {
        case "SBI":
            return "SB";
        case "SPU":
            return "PU";
        case "PRE":
            return "PRS";
        default:
            return cia;
    }
}
function createCiaOrigenCookie(ciaGestiona) {
    var cia = getCiaFromUrl();
    if (cia == "AIE")
        cia = "GCO";
    if (esGestiona() && ciaGestiona)
        cia = ciaGestiona;
    if (cia == "OCC")
        cia = "SCO";
    document.cookie = "CiaOrigen=" + cia + ";Domain=.gco.global;Path=/";
    return cia;
}
function getBackendContext() {
    var cia = getCiaFromUrl();
    var app = getAplicacionFromUrl();
    return { "Propiedades": [{ "Nombre": "ciagrupo", "Valor": "" + cia + "" }, { "Nombre": "app", "Valor": "" + app + "" }] };
}

var useStyles$h = makeStyles$1(function (theme) { return ({
    root: {
        width: "360px",
        maxWidth: "90vw",
        textAlign: "start"
    },
    title: {
        fontFamily: "CO-Medium",
        color: theme.palette.secondary.main
    },
    content: {
        paddingBottom: "0px"
    },
    container: { height: "100vh", width: "100vw", position: "fixed", top: "0" }
}); });
function Splash(props) {
    var _a, _b, _c;
    var titulo = props.titulo;
    var classes = useStyles$h();
    var logo = getCiaBuilding();
    var portal = getPortalTitle();
    return (React__default.createElement("div", { className: classes.container },
        React__default.createElement(Grid, { container: true, spacing: 0, direction: "column", alignItems: "center", justify: "center", style: { minHeight: "100vh" } },
            React__default.createElement(Grid, { item: true, md: 3 },
                React__default.createElement(Card, { className: classes.root },
                    !props.mensaje && React__default.createElement(LinearProgress, { color: "primary" }),
                    React__default.createElement(CardContent, { className: classes.content },
                        React__default.createElement(Typography, { gutterBottom: true, variant: "h6", className: classes.title }, titulo),
                        React__default.createElement(Collapse, { "in": props.mensaje != null },
                            React__default.createElement(Alert, { severity: (_a = props.mensaje) === null || _a === void 0 ? void 0 : _a.tipo, titulo: (_b = props.mensaje) === null || _b === void 0 ? void 0 : _b.titulo, message: (_c = props.mensaje) === null || _c === void 0 ? void 0 : _c.subtitulo }))),
                    React__default.createElement(CardMedia, { component: "img", alt: portal, image: logo, title: portal }))))));
}

var App365Container = function (props) {
    var _a;
    var menuOption = props.menuOption;
    var _b = useState(false), isLoaded = _b[0], setIsLoaded = _b[1];
    var _c = useState(), tokenMsal = _c[0], setTokenMsal = _c[1];
    var desarrollo = window.location.hostname.startsWith("d") || window.location.hostname.startsWith("w") || window.location.hostname.startsWith("localhost");
    var url = menuOption.urlApp;
    var action;
    var menuUrl = (_a = menuOption.url) !== null && _a !== void 0 ? _a : window.location.pathname;
    var id = menuOption.id;
    var _d = useContext(PortalContext), menu = _d.menu, contexto = _d.contexto;
    var msal = useMsal();
    var operativa = "FE/ARQ.Portal.Homes.FE.InformacionProductoV3/";
    if (menuOption.tipo == "GCOAPP365")
        operativa = "FE/" + url;
    url = null;
    action = (desarrollo ? "https://grupodaplicaciones.gco.global/" : "https://grupoaplicaciones.gco.global/") + operativa;
    var ampliarCIA = function (ciaComp) {
        var ciaSimp = "";
        switch (ciaComp) {
            case "SB":
                ciaSimp = "SBI";
                break;
            case "PU":
                ciaSimp = "SPU";
                break;
            default:
                ciaSimp = ciaComp;
                break;
        }
        return ciaSimp;
    };
    var getCIAFromMaestro = function () {
        var _a;
        var ciaMaestro = undefined;
        var rootUrl = "/" + menuUrl.split("/")[1];
        (_a = menu === null || menu === void 0 ? void 0 : menu.enlaces) === null || _a === void 0 ? void 0 : _a.forEach(function (item) {
            var _a, _b;
            if (item.url === rootUrl) {
                ciaMaestro = ampliarCIA((_a = item.origen) === null || _a === void 0 ? void 0 : _a.toString());
            }
            else {
                (_b = item.enlaces) === null || _b === void 0 ? void 0 : _b.forEach(function (subItem) {
                    var _a;
                    if (subItem.url === rootUrl) {
                        ciaMaestro = ampliarCIA((_a = subItem.origen) === null || _a === void 0 ? void 0 : _a.toString());
                    }
                });
            }
        });
        return ciaMaestro;
    };
    useEffect(function () {
        if (!tokenMsal) {
            msal.getTokenSilent().then(function (token) { setTokenMsal(token); });
        }
        else if (action) {
            var form = void 0;
            form = document.getElementById("__FORM__");
            form === null || form === void 0 ? void 0 : form.submit();
        }
    }, [tokenMsal, action]);
    var cia = esGestiona() && menuOption.plantilla == "GCOPROD" ? "OCC" : getCIAFromMaestro() || getCiaFromUrl();
    if (tokenMsal) {
        return (React__default.createElement("div", null,
            React__default.createElement("form", { id: "__FORM__", target: "<__MAINFRAME__>", action: action, method: "POST" },
                React__default.createElement("input", { name: "AccessToken", type: "hidden", value: tokenMsal }),
                React__default.createElement("input", { name: "Menu", type: "hidden", value: menuUrl }),
                React__default.createElement("input", { name: "Identificador", type: "hidden", value: id }),
                React__default.createElement("input", { name: "Titulo", type: "hidden", value: menuOption.titulo }),
                React__default.createElement("input", { name: "_cia", type: "hidden", value: cia }),
                contexto.map(function (ctx) { return React__default.createElement("input", { name: ctx.Nombre, type: "hidden", value: ctx.Nombre == "app" && esGestiona() && menuOption.plantilla == "GCOPROD" ? "Portal" : ctx.Valor }); })),
            !isLoaded && React__default.createElement(Splash, { titulo: menuOption.titulo }),
            React__default.createElement(Fade, { "in": isLoaded, timeout: 1000 },
                React__default.createElement("iframe", { name: "<__MAINFRAME__>", className: "site-layout-content-iframe", allow: "camera;microphone", seamless: true, src: url !== null && url !== void 0 ? url : undefined, title: menuOption.titulo, style: {
                        width: "1px",
                        minWidth: "100%",
                        border: "0px",
                        display: isLoaded ? "block" : "none",
                        minHeight: "calc(100vh - 52px)",
                        backgroundColor: "#ffffff"
                    }, onLoad: function () {
                        setIsLoaded(true);
                    } }))));
    }
    else {
        return React__default.createElement("div", null);
    }
};

var apiServerDev = "https://dportalapi.gco.global";
var apiServerDevGes = "https://dgestionaapi.gco.global";
var apiServerAlpha = "https://wportalapi.gco.global";
var apiServerAlphaGes = "https://wgestionaapi.gco.global";
var apiServerProBcn = "https://portalapi1.gco.global";
var apiServerProMad = "https://portalapi2.gco.global";
var apiServerProGes = "https://gestionaapi.gco.global";
var contexto = { Propiedades: [] };
function post(url, input) {
    return __awaiter$2(this, void 0, void 0, function () {
        var request, response, json, error, error, error, e_1;
        return __generator$2(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 5, , 6]);
                    if (input) {
                        input.Contexto = contexto;
                    }
                    request = new Request(getApiServer() + url, {
                        method: 'POST',
                        mode: 'cors',
                        credentials: "include",
                        body: JSON.stringify(input)
                    });
                    return [4 /*yield*/, window.fetch(request)];
                case 1:
                    response = _a.sent();
                    if (!response.ok) return [3 /*break*/, 3];
                    return [4 /*yield*/, response.json()];
                case 2:
                    json = _a.sent();
                    if (response.ok) {
                        if (json) {
                            //data.fetchedAt = (new Date()).toLocaleTimeString();
                            //if (json.Contexto) contexto = json.Contexto;
                            return [2 /*return*/, json];
                        }
                        else {
                            return [2 /*return*/, null];
                        }
                    }
                    else {
                        if (json) {
                            error = new Error(json.mensaje);
                            return [2 /*return*/, Promise.reject(error)];
                        }
                        else {
                            error = new Error(response.statusText);
                            return [2 /*return*/, Promise.reject(error)];
                        }
                    }
                case 3:
                    error = new Error(response.statusText);
                    return [2 /*return*/, Promise.reject(error)];
                case 4: return [3 /*break*/, 6];
                case 5:
                    e_1 = _a.sent();
                    console.warn("post_error", e_1); // 30
                    throw e_1;
                case 6: return [2 /*return*/];
            }
        });
    });
}
function postCache(url, input, cachekey) {
    return __awaiter$2(this, void 0, void 0, function () {
        var headers, request, response, json, error, error, error, e_2;
        return __generator$2(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 5, , 6]);
                    if (input) {
                        input.Contexto = contexto;
                    }
                    headers = {
                        "Content-Type": "application/json",
                    };
                    if (cachekey)
                        headers["x-cache-key"] = cachekey;
                    request = new Request(getApiServer() + "/cache/" + url, {
                        method: 'POST',
                        mode: 'cors',
                        credentials: "include",
                        headers: headers,
                        body: JSON.stringify(input)
                    });
                    return [4 /*yield*/, window.fetch(request)];
                case 1:
                    response = _a.sent();
                    if (!response.ok) return [3 /*break*/, 3];
                    return [4 /*yield*/, response.json()];
                case 2:
                    json = _a.sent();
                    if (response.ok) {
                        if (json) {
                            //data.fetchedAt = (new Date()).toLocaleTimeString();
                            //if (json.Contexto) contexto = json.Contexto;
                            return [2 /*return*/, json];
                        }
                        else {
                            return [2 /*return*/, null];
                        }
                    }
                    else {
                        if (json) {
                            error = new Error(json.mensaje);
                            return [2 /*return*/, Promise.reject(error)];
                        }
                        else {
                            error = new Error(response.statusText);
                            return [2 /*return*/, Promise.reject(error)];
                        }
                    }
                case 3:
                    error = new Error(response.statusText);
                    return [2 /*return*/, Promise.reject(error)];
                case 4: return [3 /*break*/, 6];
                case 5:
                    e_2 = _a.sent();
                    console.warn("post_error", e_2); // 30
                    throw e_2;
                case 6: return [2 /*return*/];
            }
        });
    });
}
function getAsync(url) {
    return __awaiter$2(this, void 0, void 0, function () {
        var request, response;
        return __generator$2(this, function (_a) {
            switch (_a.label) {
                case 0:
                    request = new Request(getApiServer() + url, {
                        method: 'GET',
                        mode: 'cors',
                        credentials: "include"
                    });
                    return [4 /*yield*/, window.fetch(request)];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response.json()];
            }
        });
    });
}
function makeLogin(url, noredirect) {
    return __awaiter$2(this, void 0, void 0, function () {
        var request, response, data, error, error, e_3;
        return __generator$2(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    request = new Request(getApiServer() + url, {
                        method: 'POST',
                        mode: 'cors',
                        credentials: "include",
                        body: JSON.stringify({ Contexto: getBackendContext(), Entrada: { Path: window.location.pathname + window.location.search, NoRedirect: noredirect } })
                    });
                    return [4 /*yield*/, window.fetch(request)];
                case 1:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 2:
                    data = _a.sent();
                    if (response.ok) {
                        if (data) {
                            //data.fetchedAt = new Date();
                            if (data.Contexto)
                                contexto = data.Contexto;
                            return [2 /*return*/, data];
                        }
                        else {
                            return [2 /*return*/, null];
                        }
                    }
                    else {
                        if (data) {
                            error = new Error(data.mensaje);
                            return [2 /*return*/, Promise.reject(error)];
                        }
                        else {
                            error = new Error(response.statusText);
                            return [2 /*return*/, Promise.reject(error)];
                        }
                    }
                case 3:
                    e_3 = _a.sent();
                    login();
                    console.warn("get_error", e_3); // 30
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    });
}
function get(url) {
    return __awaiter$2(this, void 0, void 0, function () {
        var request, response, data, error, error, e_4;
        return __generator$2(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    request = new Request(getApiServer() + url, {
                        method: 'GET',
                        mode: 'cors',
                        credentials: "include"
                    });
                    return [4 /*yield*/, window.fetch(request)];
                case 1:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 2:
                    data = _a.sent();
                    if (response.ok) {
                        if (data) {
                            //data.fetchedAt = new Date();
                            //if (data.Contexto) contexto = data.Contexto;
                            return [2 /*return*/, data];
                        }
                        else {
                            return [2 /*return*/, null];
                        }
                    }
                    else {
                        if (data) {
                            error = new Error(data.mensaje);
                            return [2 /*return*/, Promise.reject(error)];
                        }
                        else {
                            error = new Error(response.statusText);
                            return [2 /*return*/, Promise.reject(error)];
                        }
                    }
                case 3:
                    e_4 = _a.sent();
                    console.warn("get_error", e_4); // 30
                    throw e_4;
                case 4: return [2 /*return*/];
            }
        });
    });
}
function login() {
    window.location.href = getApiServer() + "/login/?d="
        + encodeURIComponent(window.location.href);
}
function logout() {
    window.fetch(getApiServer() + "/logout", {
        method: 'GET',
        mode: 'cors',
        credentials: "include",
    })
        .then(function () { return new Promise(function (resolve) { return setTimeout(resolve, 6000); }); })
        .then(function () { return window.location.href = "/"; });
}
function getApiServer() {
    if (window.location.hostname.startsWith("w") || window.location.hostname.startsWith("localhost")) {
        return esGestiona() ? apiServerAlphaGes : apiServerAlpha;
    }
    else if (window.location.hostname.startsWith("d")) {
        return esGestiona() ? apiServerDevGes : apiServerDev;
    }
    else {
        if (esGestiona())
            return apiServerProGes;
        else {
            var cia = getCiaFromUrl();
            if (cia == "SCO" || cia === "PRE" || cia === "AIE") {
                return apiServerProBcn;
            }
            else {
                return apiServerProMad;
            }
        }
    }
}
function traceNav(session, location, prevLocation, aplicacion, cia) {
    var mensaje = { session: session, "loc": location, "prev": prevLocation, "app": aplicacion, "cia": cia };
    if (navigator.sendBeacon) {
        navigator.sendBeacon(getApiServer() + "/trace/nav", JSON.stringify(mensaje));
    }
    else {
        post("/trace/nav", mensaje);
    }
}
function traceSess(session, location, browser, app, msalUser) {
    var mensaje = { session: session, "loc": location, "info": browser, "app": app.app, "ver": app.ver, "mode": app.mode, "aplicacion": app.aplicacion, "cia": app.cia, "msal": msalUser };
    if (navigator.sendBeacon) {
        navigator.sendBeacon(getApiServer() + "/trace/sess", JSON.stringify(mensaje));
    }
    else {
        post("/trace/sess", mensaje);
    }
}
function traceError(session, location, error, stack, app, ver, aplicacion, cia) {
    var mensaje = {
        "session": session,
        "loc": location,
        "error": error,
        "stack": stack,
        "app": app,
        "ver": ver,
        "aplicacion": aplicacion,
        "cia": cia
    };
    if (navigator.sendBeacon) {
        navigator.sendBeacon(getApiServer() + "/trace/error", JSON.stringify(mensaje));
    }
    else {
        post("/trace/error", mensaje);
    }
}
function ultimaVisita(svc, url, titulo, tipo) {
    var mensaje = { Entrada: { Url: url, Titulo: titulo, Tipo: tipo }, Contexto: contexto };
    if (navigator.sendBeacon) {
        navigator.sendBeacon(getApiServer() + svc, JSON.stringify(mensaje));
    }
    else {
        post(svc, mensaje);
    }
}
var api = { getApiServer: getApiServer, login: login, logout: logout, get: get, post: post, postCache: postCache, getAsync: getAsync, traceNav: traceNav, traceSess: traceSess, traceError: traceError, ultimaVisita: ultimaVisita, makeLogin: makeLogin };

function getMenuOption(menu, url) {
    var _a;
    var orig = url;
    url = url.toLowerCase();
    if ((url.indexOf("/aplicacion?") >= 0) || (url.indexOf("/aplicacion/default.aspx?") >= 0)) {
        var search = orig.substring(url.indexOf("?"));
        var qs = new URLSearchParams(search);
        return {
            titulo: "Aplicación",
            tipo: qs.get("aplicacion"),
            plantilla: "GCOAPP",
            urlApp: getUrlTransaccion(search)
        };
    }
    else if (menu != null) {
        var menuUrl = (_a = menu.url) === null || _a === void 0 ? void 0 : _a.toLowerCase();
        if (menuUrl === url) {
            return menu;
        }
        if (menu.enlaces && (!menuUrl || url.startsWith(menuUrl) || menu.origen == "GRUPO")) {
            var encontrado = null;
            menu.enlaces.forEach(function (e) { var option = getMenuOption(e, url); if (option != null)
                encontrado = option; });
            return encontrado;
        }
        else {
            return null;
        }
    }
    else {
        return null;
    }
}
function findMenuOptions(menu, texto) {
    texto = texto.toLowerCase();
    var results = [];
    if (menu !== null) {
        if (!menu.oculto) {
            var menuTitulo = menu.titulo ? menu.titulo.toLowerCase() : "";
            if (menuTitulo.indexOf(texto) >= 0) {
                results.push(menu);
            }
        }
        if (menu.enlaces && menu.enlaces.length > 0) {
            menu.enlaces.forEach(function (e) {
                var resultsEnlace = findMenuOptions(e, texto);
                if (resultsEnlace && resultsEnlace.length > 0) {
                    results = results.concat(resultsEnlace);
                }
            });
        }
    }
    return results;
}
function getMenuOptionPath(menu, url) {
    var _a;
    url = url.toLowerCase();
    if (menu != null) {
        var menuUrl = (_a = menu.url) === null || _a === void 0 ? void 0 : _a.toLowerCase();
        if (esGestiona()) {
            if (menuUrl === null || menuUrl === void 0 ? void 0 : menuUrl.endsWith("agrupado")) {
                menuUrl = undefined;
            }
        }
        if (menuUrl === url) {
            return [menu];
        }
        if (menu.enlaces && (!menuUrl || url.startsWith(menuUrl))) {
            var encontrado = [];
            var indx = 0;
            menu.enlaces.forEach(function (e) {
                var path = getMenuOptionPath(e, url);
                if (path != null) {
                    encontrado = path;
                    path[0].orden = indx;
                }
                indx++;
            });
            if (encontrado.length > 0) {
                if (menuUrl)
                    encontrado.unshift(menu);
                return encontrado;
            }
            else
                return null;
        }
        else {
            return null;
        }
    }
    else {
        return null;
    }
}
function esVentanaNueva(menuOption) {
    var _a;
    var esVentanaNueva = false;
    var tipo = (_a = menuOption === null || menuOption === void 0 ? void 0 : menuOption.tipo) === null || _a === void 0 ? void 0 : _a.toUpperCase();
    var cia = getCiaFromUrl();
    var desarrollo = window.location.hostname.startsWith("d") || window.location.hostname.startsWith("w") || window.location.hostname.startsWith("localhost");
    if (menuOption !== null) { //provisional
        esVentanaNueva = (menuOption.ventanaNueva && cia != "PRE") || (menuOption.ventanaNueva && cia === "PRE" && desarrollo) ||
            (menuOption.popup && cia != "PRE") || (menuOption.popup && cia === "PRE" && desarrollo) ||
            (menuOption.plantilla === "GCOAPP" && tipo === "ENLACE") ||
            (menuOption.plantilla === "GCOAPP" && tipo === "PORTAL") ||
            (menuOption.plantilla === "GCOAPP" && (tipo === null || tipo === void 0 ? void 0 : tipo.startsWith("PORTALINTRANET"))) ||
            (menuOption.plantilla === "GCOAPPSP") ||
            (cia === "PRE" && !desarrollo && menuOption.plantilla === "GCOAPP"
                && (tipo === "WEBSPHERE"
                    || tipo === "APLICACIONESGCO"
                    || tipo === "APLICACIONESSCO"
                    || tipo === "PREPERSAAPLICACIONES"
                    || tipo === "APLICACIONESPREPERSA"
                    || tipo === "IVIASB"
                    || tipo === "SINIESTROSSB"
                    || tipo === "OTHERAPPSB"
                    || tipo === "MICROSTRATEGY")); //temporal?
    }
    return esVentanaNueva;
}
function getUrl(menuOption) {
    var _a, _b, _c;
    var url = "";
    var desarrollo = window.location.hostname.startsWith("d") || window.location.hostname.startsWith("w") || window.location.hostname.startsWith("localhost");
    if (menuOption !== null) {
        url = (_a = menuOption.urlApp) !== null && _a !== void 0 ? _a : "";
        var tipo = (_b = menuOption.tipo) === null || _b === void 0 ? void 0 : _b.toUpperCase();
        if (tipo === "APLICACIONESREACT") {
            url = (_c = menuOption.url) !== null && _c !== void 0 ? _c : "";
        }
        else if (!url.startsWith("http://") && !url.startsWith("https://")) {
            if (tipo === "WEBSPHERE") {
                url = (desarrollo ? "https://dwebapp.gco.global/sso/" : "https://webapp.gco.global/sso/") + url;
            }
            else if (tipo === "APLICACIONESGCO") {
                url = (desarrollo ? "https://grupodaplicaciones.gco.global/" : "https://grupoaplicaciones.gco.global/") + url;
            }
            else if (tipo === "APLICACIONESSCO") {
                url = (desarrollo ? "https://catalanadaplicaciones.gco.global/" : "https://catalanaaplicaciones.gco.global/") + url;
            }
            else if (tipo === "MICROSTRATEGY") {
                url = (desarrollo ? "https://dssosiportal.gco.global/" : "https://ssosiportal.gco.global/") + url;
            }
            else if (tipo === "FIRMA") {
                url = (desarrollo ? "https://dfirma.gco.global/" : "https://firma.gco.global/") + url;
            }
            else if (tipo === "NEXUSAX") {
                url = (desarrollo ? "https://dnexusax.gco.global/" : "https://nexusax.gco.global/") + url;
            }
            else if (tipo === "IVIASB") {
                url = (desarrollo ? "https://dsegurosbilbaoivia.gco.global/" : "https://segurosbilbaoivia.gco.global/") + url;
            }
            else if (tipo === "APPPORTAL") {
                url = (desarrollo ? "https://dsegurosbilbaoappportal.gco.global/" : "https://segurosbilbaoappportal.gco.global/") + url;
            }
            else if (tipo === "SINIESTROSSB") {
                url = (desarrollo ? "https://segurosbilbaodsiniestros.gco.global/" : "https://segurosbilbaosiniestros.gco.global/") + url;
            }
            else if (tipo === "OTHERSAPPSB") {
                url = (desarrollo ? "https://segurosbilbaodothersapp.gco.global/" : "https://segurosbilbaoothersapp.gco.global/") + url;
            }
            else if (tipo === "PREPERSAAPLICACIONES" || tipo === "APLICACIONESPREPERSA") {
                url = (desarrollo ? "https://prepersadaplicaciones.gco.global/" : "https://prepersaaplicaciones.gco.global/") + url;
            }
            else if (tipo === "APLICACIONESPUEMPLEADOS") {
                url = (desarrollo ? "https://dintranetpu.gco.global/portales/pasarela/fe.aspx?des=/" : "https://intranetpu.gco.global/portales/pasarela/fe.aspx?des=/") + url;
            }
            else if (tipo === "APLICACIONESPUMEDIADORES") {
                url = (desarrollo ? "https://daplicacionespu.gco.global/portales/pasarela/fe.aspx?des=/" : "https://aplicacionespu.gco.global/portales/pasarela/fe.aspx?des=/") + url;
            }
            else if (tipo === "APLICACIONESNORTEHISPANA") {
                url = (desarrollo ? "https://dnortehispanaservicios.gco.global/" : "https://nortehispanaservicios.gco.global/") + url;
            }
            else if (tipo === "PORTALBI") {
                url = (desarrollo ? "https://dportalbi.gco.global/" : "https://portalbi.gco.global/") + url;
            }
            else if (tipo === "SAP") {
                url = "https://catalanabw.gco.global/sap/bw/BEx?" + url;
            }
            else if (tipo === "DWH") {
                url = api.getApiServer() + "/dwh?path=/" + url;
            }
            else if (tipo === null || tipo === void 0 ? void 0 : tipo.startsWith("PORTALINTRANET")) {
                var sitio = url.startsWith("/sitios") ? url.substring(7) : url;
                if (sitio.indexOf(",") > 0) {
                    url = (desarrollo ? "https://grupocatalanaoccidente.sharepoint.com/sites/dportalpublicaciones/SitePages/Detalle.aspx?BE=" : "https://grupocatalanaoccidente.sharepoint.com/sites/portalpublicaciones/SitePages/Detalle.aspx?BE=") + sitio;
                }
                else {
                    url = (desarrollo ? "https://grupocatalanaoccidente.sharepoint.com/sites/dportalpublicaciones?BE=" : "https://grupocatalanaoccidente.sharepoint.com/sites/portalpublicaciones?BE=") + sitio;
                }
            }
        }
        else if (desarrollo && !url.startsWith("https://grupocatalanaoccidente.sharepoint.com")) {
            url = url.replace("https://", "https://d");
        }
    }
    return url;
}
function buildMenuDictionary(menu) {
    var menuDict = new Map();
    buildMenuDictionaryRec(menu, menuDict);
    return menuDict;
}
function buildMenuDictionaryRec(menu, menuDict, padreId) {
    if (menu != null) {
        var hijosId_1 = [];
        if (menu.enlaces && menu.enlaces.length > 0) {
            menu.enlaces.forEach(function (e) {
                buildMenuDictionaryRec(e, menuDict, menu.id);
                if (e.id)
                    hijosId_1.push(e.id);
            });
        }
        if (menu.id)
            menuDict.set(menu.id, __assign$2(__assign$2({}, menu), { enlaces: undefined, hijosId: hijosId_1, padreId: padreId }));
    }
}
var getUrlTransaccion = function (str) {
    if (str) {
        var aux = str.toLowerCase();
        var key = "urltransaccion=";
        if (aux.includes(key)) {
            var pos = aux.indexOf(key);
            return str.slice(pos + key.length, str.length);
        }
    }
    return null;
};
var getFavName = function (menuDict, idNodo) {
    var name = "";
    var nodo = menuDict === null || menuDict === void 0 ? void 0 : menuDict.get(idNodo);
    if (nodo) {
        var padreId = nodo.padreId;
        var menuPadre = null;
        if (padreId)
            menuPadre = menuDict === null || menuDict === void 0 ? void 0 : menuDict.get(padreId);
        if (menuPadre) {
            name = menuPadre.titulo + " > " + nodo.titulo;
        }
        else {
            name = nodo.titulo;
        }
    }
    return name;
};
var menuHelper = {
    getMenuOption: getMenuOption,
    getMenuOptionPath: getMenuOptionPath,
    findMenuOptions: findMenuOptions,
    esVentanaNueva: esVentanaNueva,
    getUrl: getUrl,
    buildMenuDictionary: buildMenuDictionary,
    getUrlTransaccion: getUrlTransaccion,
    getFavName: getFavName
};

var AppContainer = function (props) {
    var menuOption = props.menuOption;
    var _a = useState(false), isLoaded = _a[0], setIsLoaded = _a[1];
    var _b = useState(null), mensaje = _b[0], setMensaje = _b[1];
    var url = menuOption.urlApp;
    var hacerTransicion = menuOption.popup || menuHelper.esVentanaNueva(menuOption);
    url = menuHelper.getUrl(menuOption);
    useEffect(function () {
        if (url != null && window.location.search.indexOf("marco=false") > 0) {
            window.location.href = url;
            setMensaje({ titulo: "Se le redirigirá a la aplicación", subtitulo: "", tipo: "info" });
        }
        else if (hacerTransicion) {
            if (url != null) {
                window.location.href = url;
                // window.close();
                // window.open(url, menuOption.tipo ?? undefined);
                // window.open("", "_self");
                // let x =window.open('','_self');
                // window.open('http://www.google.com','_blank');
                // window.setTimeout(function(){this.close();},1000)
                // x?.close();
                // this.close();
                setMensaje({ titulo: "La aplicación se abrirá en una ventana nueva", subtitulo: "Asegúrate de no tener las ventanas emergentes bloqueadas", tipo: "info" });
            }
        }
    }, [menuOption]);
    return (React__default.createElement("div", null,
        !isLoaded && React__default.createElement(Splash, { titulo: menuOption.titulo, mensaje: mensaje }),
        !hacerTransicion &&
            React__default.createElement(Fade, { "in": isLoaded, timeout: 1000 },
                React__default.createElement("iframe", { name: "<__MAINFRAME__>", className: "site-layout-content-iframe", allow: "camera;microphone", seamless: true, src: url !== null && url !== void 0 ? url : undefined, title: menuOption.titulo, style: {
                        width: "1px",
                        minWidth: "100%",
                        border: "0px",
                        display: isLoaded ? "block" : "none",
                        minHeight: "calc(100vh - 52px)",
                        backgroundColor: "#ffffff"
                    }, onLoad: function () {
                        setIsLoaded(true);
                    } }))));
};

var DialogoTitulo = withStyles(function (theme) { return ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
        color: theme.palette.secondary.main,
        '& h6': {
            color: theme.palette.secondary.main,
            fontFamily: 'CO-Bold',
        }
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.secondary.main,
    },
}); })(function (props) {
    var children = props.children, classes = props.classes, onClose = props.onClose, other = __rest(props, ["children", "classes", "onClose"]);
    return (React__default.createElement(MuiDialogTitle, __assign$2({ disableTypography: true, className: classes.root }, other),
        React__default.createElement(Typography, { variant: "h6" }, children),
        onClose ? (React__default.createElement(IconButton, { "aria-label": "close", className: classes.closeButton, onClick: onClose },
            React__default.createElement(IconCerrar, { style: { height: "18px", width: "18px" } }))) : null));
});
var DialogoContenido = withStyles(function (theme) { return ({
    root: {
        padding: theme.spacing(2),
        borderBottom: "0px"
    },
}); })(MuiDialogContent);
var DialogoAcciones = withStyles(function (theme) { return ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },
}); })(MuiDialogActions);
var useStyles$g = makeStyles$1(function (theme) { return ({
    dialogContainer: {
        '& .MuiDialog-paper': {
            borderRadius: '0px',
        }
    },
    botonPrimario: {
        border: '2px solid ' + theme.palette.secondary.main,
        borderRadius: 0,
        width: '150px',
        color: '#fff',
        background: theme.palette.secondary.main,
        fontWeight: 'bold',
        boxShadow: 'none !important',
        padding: '4px 16px',
        '&:hover': {
            background: '#919191',
            border: '2px solid #919191',
        },
        '&:focus, &:active': {
            background: '#DC0028',
            border: '2px solid #DC0028',
        },
        '& .MuiTouchRipple-root': {
            display: 'none',
        }
    },
    botonSecundario: {
        border: '2px solid ' + theme.palette.secondary.main,
        background: '#fff !important',
        borderRadius: 0,
        width: '150px',
        color: theme.palette.secondary.main,
        fontWeight: 'bold',
        boxShadow: 'none !important',
        padding: '4px 16px',
        '&:hover': {
            border: '2px solid #919191',
            color: '#919191',
        },
        '&:focus, &:active': {
            border: '2px solid #DC0028',
            color: '#DC0028',
        },
        '& .MuiTouchRipple-root': {
            display: 'none',
        }
    }
}); });
var CustomizedDialog = function (props) {
    var _a, _b;
    var clases = useStyles$g();
    // @ts-ignore
    var handleClose = function (e, reason) {
        props.manejarCierre(reason);
    };
    return (React__default.createElement("div", null,
        React__default.createElement(Dialog, { onClose: function (e, reason) { return handleClose(e, reason); }, "aria-labelledby": "customized-dialog-title", open: props.open, fullWidth: true, maxWidth: "lg", style: { borderRadius: 0 }, className: clases.dialogContainer },
            React__default.createElement(DialogoTitulo, { id: "customized-dialog-title", onClose: function (e, reason) { return handleClose(e, reason); } }, props.title),
            React__default.createElement(DialogoContenido, { dividers: true }, props.children),
            React__default.createElement(DialogoAcciones, null,
                React__default.createElement(Button, { onClick: function () { return props.manejarCierre('cancelar'); }, variant: "outlined", className: clases.botonSecundario }, (_a = props.tituloCancelar) !== null && _a !== void 0 ? _a : "Cancelar"),
                React__default.createElement(Button, { onClick: function () { return props.guardar(false); }, variant: "contained", className: clases.botonPrimario }, (_b = props.tituloAceptar) !== null && _b !== void 0 ? _b : "Aceptar")))));
};

var Enlace = function (props) {
    var _a = React__default.useContext(PortalContext), menu = _a.menu, historial = _a.historial, session = _a.session, ciaGestiona = _a.ciaGestiona;
    var obtenerDimensionesDetachedWindow = function () {
        var parametros = "scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no";
        var width = window.innerWidth * 0.8;
        var height = window.innerHeight * 0.8;
        parametros += ",width=" + width;
        parametros += ",height=" + height;
        var left = (window.innerWidth / 2) - (width / 2);
        var top = (screen.height - height) / 2;
        parametros += ",left=" + left;
        parametros += ",top=" + top;
        // parametros += ",popup=1";  
        return parametros;
    };
    var guardarHistorial = function (url) {
        if (historial && historial.guardarSvc) {
            if (url !== "/") {
                var path = menuHelper.getMenuOptionPath(menu, url);
                var titulo = "";
                var id = "";
                if (path && path.length > 0) {
                    titulo = path[path.length - 1].titulo;
                    id = path[path.length - 1].id;
                    if (path.length > 1) {
                        titulo = path[path.length - 2].titulo + " > " + titulo;
                    }
                }
                if (titulo !== "" && id !== "")
                    api.ultimaVisita(historial.guardarSvc, id, titulo, "pm");
            }
        }
    };
    var abrirEnPopup = function (url, esPopup, name) {
        var popup = esPopup ? window.open(url, name !== null && name !== void 0 ? name : "_BLANK", obtenerDimensionesDetachedWindow()) : window.open(url, name !== null && name !== void 0 ? name : "_BLANK");
        // evitar memory leaks
        popup === null || popup === void 0 ? void 0 : popup.addEventListener('pagehide', function () {
            var _a;
            if (!((_a = popup === null || popup === void 0 ? void 0 : popup.location) === null || _a === void 0 ? void 0 : _a.host))
                return;
            // hacer el objeto disponible para ser garbage collected
            popup = null;
        });
        guardarHistorial(url);
    };
    var abrirEnlace = function (option) {
        var _a;
        var name = (option === null || option === void 0 ? void 0 : option.plantilla) + "_" + (option === null || option === void 0 ? void 0 : option.tipo);
        var url = "";
        if (((_a = option === null || option === void 0 ? void 0 : option.tipo) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === "PORTAL") {
            var cia = void 0;
            if (option === null || option === void 0 ? void 0 : option.url) {
                var aux = option.url;
                var path = menuHelper.getMenuOptionPath(menu, aux);
                while (path && path.length > 0) {
                    var x = path === null || path === void 0 ? void 0 : path.pop();
                    if ((x === null || x === void 0 ? void 0 : x.origen) && x.origen) {
                        cia = x.origen;
                        break;
                    }
                }
            }
            var parametrosEntrada = {
                Entrada: {
                    Identificador: option === null || option === void 0 ? void 0 : option.id,
                    App: cia ? 'Portal' : '',
                    CiaGrupo: cia ? cia : ''
                }
            };
            api.post("/be/accesoaplicaciones", parametrosEntrada).then(function (x) {
                if (x.Salida.Enlace) {
                    url = x.Salida.Enlace;
                    var desarrollo = window.location.hostname.startsWith("d") || window.location.hostname.startsWith("w") || window.location.hostname.startsWith("localhost");
                    if (desarrollo) {
                        if (url.startsWith("https://grupo")) {
                            url = url.replace("https://grupo", "https://grupod");
                        }
                        else if (url.startsWith("https://catalana")) {
                            url = url.replace("https://catalana", "https://catalanad");
                        }
                        else if (url.startsWith("https://")) {
                            url = url.replace("https://", "https://d");
                        }
                    }
                }
                else {
                    url = menuHelper.getUrl(option);
                }
                //abrirEnPopup( url, option.popup?? false, name);
                abrirEnPopup(url, false, name);
            });
        }
        // else if (option?.tipo?.toUpperCase() === "MICROSTRATEGY") {
        //   let nam = (option?.ventanaNueva || option?.popup) ? undefined: name;
        //   url = location.origin + option?.url
        //   abrirEnPopup( url, false, nam); 
        // }
        else {
            url = menuHelper.getUrl(option);
            //abrirEnPopup( url, option.popup?? false, name);
            abrirEnPopup(url, false, name);
        }
        guardarHistorial(url);
    };
    var externa = props.to && (props.to.startsWith("http:") || props.to.startsWith("https:") || props.to.startsWith("mailto:") || props.to.startsWith("tel:")) && !props.to.startsWith(location.origin);
    var clickEvent = function (event) {
        var _a;
        createCiaOrigenCookie(ciaGestiona);
        if (externa) {
            event.preventDefault();
            // provisional: lo dejamos como estaba 
            abrirEnPopup(props.to, false);
        }
        else {
            var option = menuHelper.getMenuOption(menu, props.to);
            if (option && (option.popup || menuHelper.esVentanaNueva(option) || ((_a = option.tipo) === null || _a === void 0 ? void 0 : _a.toUpperCase()) == "PORTAL")) {
                event.preventDefault();
                abrirEnlace(option);
                // enviar visita...
                api.traceNav(session, { pathname: option.url }, { pathname: window.location.pathname }, getAplicacionFromUrl(), getCiaFromUrl());
            }
        }
        if (props.actualizarIdClick != undefined)
            props.actualizarIdClick();
    };
    return externa ? React__default.createElement("a", __assign$2({ href: props.to }, props, { onClick: clickEvent })) : props.origen == undefined || props.origen != "GRUPO" ? React__default.createElement(Link, __assign$2({}, props, { onClick: clickEvent })) : React__default.createElement("span", __assign$2({}, props));
};

var ErrorBoundary = /** @class */ (function (_super) {
    __extends$2(ErrorBoundary, _super);
    function ErrorBoundary(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { hasError: false };
        return _this;
    }
    ErrorBoundary.getDerivedStateFromError = function (error) {
        // Actualiza el estado para que el siguiente renderizado muestre la interfaz de repuesto
        console.error("getDerivedStateFromError", error);
        return { hasError: true, error: error };
    };
    ErrorBoundary.prototype.componentDidCatch = function (error, errorInfo) {
        var _a, _b;
        // También puedes registrar el error en un servicio de reporte de errores
        var stack = errorInfo.componentStack.replaceAll("\n   ", "");
        var aplicacion = getAplicacionFromUrl();
        var cia = getCiaFromUrl();
        var app = (_a = process === null || process === void 0 ? void 0 : process.env) === null || _a === void 0 ? void 0 : _a.REACT_APP_NAME;
        var ver = (_b = process === null || process === void 0 ? void 0 : process.env) === null || _b === void 0 ? void 0 : _b.REACT_APP_VERSION;
        api.traceError(this.context.session, window.location.href, error.message, stack, app !== null && app !== void 0 ? app : "-", ver !== null && ver !== void 0 ? ver : "-", aplicacion, cia);
        console.error("componentDidCatch", error, errorInfo);
    };
    ErrorBoundary.prototype.render = function () {
        var fallback = this.props.fallback;
        if (this.state.hasError && fallback) {
            return fallback(this.state.error);
        }
        return this.props.children;
    };
    ErrorBoundary.contextType = PortalContext;
    return ErrorBoundary;
}(React__default.Component));

var HomeWidget$1 = /** @class */ (function (_super) {
    __extends$2(HomeWidget, _super);
    function HomeWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            editar: false
        };
        _this.changeEditar = _this.changeEditar.bind(_this);
        return _this;
    }
    HomeWidget.prototype.changeEditar = function () {
        var valor = !this.state.editar;
        this.setState({
            editar: valor
        });
    };
    HomeWidget.prototype.render = function () {
        return (React__default.createElement("div", { className: this.props.classes.content },
            React__default.createElement("div", null, this.props.heading),
            React__default.createElement("div", { style: { paddingTop: "20px" } },
                React__default.createElement(Typography$1, { variant: "h6" }, "Mi espacio"),
                React__default.createElement(Divider, { variant: "fullWidth", light: false })),
            React__default.createElement(Grid$1, { container: true, spacing: 2, style: { padding: "12px 0px" } }, Array.isArray(this.props.children) ? this.props.children.map(function (x, i) {
                return React__default.createElement(Grid$1, { key: "it_" + i, item: true, xs: 12, md: 6, lg: 3, zeroMinWidth: true }, x);
            })
                : React__default.createElement(Grid$1, { item: true, xs: 12, md: 6, lg: 3, zeroMinWidth: true }, this.props.children))));
    };
    return HomeWidget;
}(React__default.Component));
var Home = withStyles$1(function (theme) {
    var _a;
    return ({
        content: (_a = {
                padding: "0px 28px 20px",
                backgroundColor: "#f0f0f0"
            },
            _a[theme.breakpoints.down('sm')] = {
                padding: "0px 12px 20px",
                overflowX: "hidden"
            },
            _a)
    });
})(HomeWidget$1);

var useStyles$f = makeStyles(function (theme) { return ({
    widgetError: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-evenly",
        padding: "50px",
        height: "150px",
        textAlign: "center"
    },
    textoWidgetError: {
        color: theme.palette.secondary.main,
        fontSize: '14px'
    },
    iconoWidgetError: {
        height: 64,
        width: 64,
        color: "#D6D8D8"
    }
}); });
function HomeWidgetError(props) {
    var classes = useStyles$f(props);
    return React__default.createElement("div", { className: classes.widgetError },
        React__default.createElement("div", null,
            React__default.createElement(IconError, { className: classes.iconoWidgetError })),
        React__default.createElement("div", { className: classes.textoWidgetError }, typeof props.error === "string" ? props.error : "Servicio temporalmente no disponible"));
}

var useStyles$e = makeStyles$1(function (theme) {
    return createStyles({
        popover: {
            pointerEvents: 'none',
        },
        paper: {
            padding: theme.spacing(1),
        },
        iconErrorWidget: {
            marginLeft: '8px',
            position: 'absolute',
        }
    });
});
function HomeWidgetIconError(props) {
    var classes = useStyles$e();
    var _a = React__default.useState(null), anchorEl = _a[0], setAnchorEl = _a[1];
    var handlePopoverOpen = function (event) {
        setAnchorEl(event.currentTarget);
    };
    var handlePopoverClose = function () {
        setAnchorEl(null);
    };
    var open = Boolean(anchorEl);
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(Typography, { className: classes.iconErrorWidget, component: "span", "aria-owns": open ? 'mouse-over-popover' : undefined, "aria-haspopup": "true", onMouseEnter: handlePopoverOpen, onMouseLeave: handlePopoverClose },
            React__default.createElement(IconError, { style: {
                    height: 16,
                    width: 16,
                    color: "rgba(220, 0, 40, 0.9)"
                } })),
        React__default.createElement(Popover, { id: "mouse-over-popover", className: classes.popover, classes: {
                paper: classes.paper,
            }, open: open, anchorEl: anchorEl, anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'left',
            }, transformOrigin: {
                vertical: 'top',
                horizontal: 'left',
            }, onClose: handlePopoverClose, disableRestoreFocus: true },
            React__default.createElement(Typography, null, props.error))));
}

var useStyles$d = makeStyles(function (theme) { return ({
    widgetVacio: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-evenly",
        padding: "50px",
        height: "150px",
        textAlign: "center"
    },
    textoWidgetVacio: {
        color: theme.palette.secondary.main,
        fontSize: '14px'
    },
    iconoWidgetVacio: {
        height: 64,
        width: 64,
        color: "#D6D8D8"
    }
}); });
function HomeWidgetVacio(props) {
    var _a;
    var classes = useStyles$d(props);
    return React__default.createElement("div", { className: classes.widgetVacio },
        React__default.createElement("div", null,
            React__default.createElement(IconCaja, { className: classes.iconoWidgetVacio })),
        React__default.createElement("div", { className: classes.textoWidgetVacio }, (_a = props.mensaje) !== null && _a !== void 0 ? _a : "Sin datos obtenidos"));
}

var useStyles$c = makeStyles(function (theme) { return ({
    root: {
        display: "flex",
        color: theme.palette.secondary.main,
        borderBottom: "1px solid #919191",
        paddingBottom: '12px',
    },
    titulo: {
        flexGrow: 1,
        fontWeight: "bold",
        fontFamily: 'CO-Bold',
    },
    button: {
        color: '#DC0028',
        padding: '0px',
        marginLeft: "6px",
        fontSize: '12px',
        minWidth: '0',
        fontWeight: 'bold',
        borderBottom: '1px solid',
        borderRadius: '0',
        '&:hover': {
            color: '#b7788f',
            borderBottom: '1px solid #b7788f',
            background: 'transparent',
        },
        '& .MuiButton-label': {
            lineHeight: 'initial',
        },
        '& .MuiTouchRipple-root': {
            display: 'none',
        }
    },
    iconCarga: {
        marginLeft: '8px',
        position: 'absolute',
    },
    cardHeightStyles: {
        height: 480,
        maxHeight: 480,
        width: "100%",
        '@media screen and (max-width: 959px)': {
            height: 'auto',
        }
    }
}); });
function HomeWidget(props) {
    var classes = useStyles$c(props);
    return React__default.createElement(Card$1, { elevation: 0, className: props.className + ' ' + classes.cardHeightStyles },
        React__default.createElement(CardContent$1, null,
            React__default.createElement("div", { className: classes.root },
                React__default.createElement("span", { className: classes.titulo },
                    props.titulo,
                    (props.children && props.error && !props.isLoading) && React__default.createElement(HomeWidgetIconError, { error: props.error }),
                    props.isLoading && React__default.createElement(CircularProgress, { color: "primary", size: 16, thickness: 2, className: classes.iconCarga })),
                props.config && React__default.createElement(Button$1, { color: "primary", variant: "text", className: classes.button, onClick: props.config }, "Configurar"),
                props.vermas && React__default.createElement(Button$1, { color: "primary", variant: "text", className: classes.button, component: Enlace, to: props.vermas }, "Ver m\u00E1s")),
            props.children,
            (!props.children && props.error) && React__default.createElement(HomeWidgetError, { error: props.error }),
            (!props.children && !props.error) && React__default.createElement(HomeWidgetVacio, { mensaje: props.empty })));
}

function getModalStyle() {
    var top = 50;
    var left = 50;
    return {
        top: top + "%",
        left: left + "%",
        transform: "translate(-" + top + "%, -" + left + "%)",
    };
}
var useStyles$b = makeStyles(function (theme) { return ({
    paper: {
        position: 'absolute',
        width: function (props) { return props.width ? props.width + "px" : "400px"; },
        minWidth: function (props) { return props.minWidth ? props.minWidth + "px" : "400px"; },
        maxWidth: function (props) { return props.minWidth ? props.minWidth + "px" : "1500px"; },
        height: function (props) { return props.height ? props.height + "px" : "400px"; },
        minHeight: function (props) { return props.minHeight ? props.minHeight + "px" : "400px"; },
        maxHeight: function (props) { return props.maxHeight ? props.maxHeight + "px" : "900px"; },
        overflow: 'auto',
        backgroundColor: theme.palette.background.paper,
        border: "1px solid " + theme.palette.primary.main,
        boxShadow: theme.shadows[5],
        padding: '0px 0px 8px 0px',
    },
    cabecera: {
        height: '50px',
        width: '100%',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center'
    },
    titulo: {
        padding: '10px',
        color: theme.palette.secondary.main,
        fontSize: '16px',
    }
}); });
var CustomModal = function (props) {
    var handleClose = function (reason) {
        props.handleClose(reason);
    };
    var classes = useStyles$b(props);
    return (React__default.createElement("div", null,
        React__default.createElement(Modal, { open: props.open, 
            // @ts-ignore
            onClose: function (event, reason) { return handleClose(reason); }, "aria-labelledby": "simple-modal-title", "aria-describedby": "simple-modal-description" },
            React__default.createElement("div", { style: getModalStyle(), className: classes.paper },
                React__default.createElement("div", { id: "header", className: classes.cabecera },
                    React__default.createElement("span", { className: classes.titulo }, props.title)),
                props.children))));
};

var Page = function (props) {
    useEffect(function () {
        var cia = getCiaTitle();
        document.title = cia + (" - " + props.title || "");
    }, [props.title]);
    return React__default.createElement(React__default.Fragment, null, props.children);
};

var lottie = createCommonjsModule(function (module) {
(typeof navigator !== "undefined") && (function(root, factory) {
    if (module.exports) {
        module.exports = factory(root);
    } else {
        root.lottie = factory(root);
        root.bodymovin = root.lottie;
    }
}((window || {}), function(window) {

/* exported svgNS, locationHref, initialDefaultFrame */

var svgNS = 'http://www.w3.org/2000/svg';

var locationHref = '';

var initialDefaultFrame = -999999;

/* global createSizedArray */
/* exported subframeEnabled, expressionsPlugin, isSafari, cachedColors, bmPow, bmSqrt, bmFloor, bmMax, bmMin, ProjectInterface,
defaultCurveSegments, degToRads, roundCorner, bmRnd, styleDiv, BMEnterFrameEvent, BMCompleteEvent, BMCompleteLoopEvent,
BMSegmentStartEvent, BMDestroyEvent, BMRenderFrameErrorEvent, BMConfigErrorEvent, BMAnimationConfigErrorEvent, createElementID,
addSaturationToRGB, addBrightnessToRGB, addHueToRGB, rgbToHex */

var subframeEnabled = true;
var idPrefix = '';
var expressionsPlugin;
var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
var bmPow = Math.pow;
var bmSqrt = Math.sqrt;
var bmFloor = Math.floor;
var bmMax = Math.max;
var bmMin = Math.min;

var BMMath = {};
(function () {
  var propertyNames = ['abs', 'acos', 'acosh', 'asin', 'asinh', 'atan', 'atanh', 'atan2', 'ceil', 'cbrt', 'expm1', 'clz32', 'cos', 'cosh', 'exp', 'floor', 'fround', 'hypot', 'imul', 'log', 'log1p', 'log2', 'log10', 'max', 'min', 'pow', 'random', 'round', 'sign', 'sin', 'sinh', 'sqrt', 'tan', 'tanh', 'trunc', 'E', 'LN10', 'LN2', 'LOG10E', 'LOG2E', 'PI', 'SQRT1_2', 'SQRT2'];
  var i;
  var len = propertyNames.length;
  for (i = 0; i < len; i += 1) {
    BMMath[propertyNames[i]] = Math[propertyNames[i]];
  }
}());

function ProjectInterface() { return {}; }

BMMath.random = Math.random;
BMMath.abs = function (val) {
  var tOfVal = typeof val;
  if (tOfVal === 'object' && val.length) {
    var absArr = createSizedArray(val.length);
    var i;
    var len = val.length;
    for (i = 0; i < len; i += 1) {
      absArr[i] = Math.abs(val[i]);
    }
    return absArr;
  }
  return Math.abs(val);
};
var defaultCurveSegments = 150;
var degToRads = Math.PI / 180;
var roundCorner = 0.5519;

function styleDiv(element) {
  element.style.position = 'absolute';
  element.style.top = 0;
  element.style.left = 0;
  element.style.display = 'block';
  element.style.transformOrigin = '0 0';
  element.style.webkitTransformOrigin = '0 0';
  element.style.backfaceVisibility = 'visible';
  element.style.webkitBackfaceVisibility = 'visible';
  element.style.transformStyle = 'preserve-3d';
  element.style.webkitTransformStyle = 'preserve-3d';
  element.style.mozTransformStyle = 'preserve-3d';
}

function BMEnterFrameEvent(type, currentTime, totalTime, frameMultiplier) {
  this.type = type;
  this.currentTime = currentTime;
  this.totalTime = totalTime;
  this.direction = frameMultiplier < 0 ? -1 : 1;
}

function BMCompleteEvent(type, frameMultiplier) {
  this.type = type;
  this.direction = frameMultiplier < 0 ? -1 : 1;
}

function BMCompleteLoopEvent(type, totalLoops, currentLoop, frameMultiplier) {
  this.type = type;
  this.currentLoop = currentLoop;
  this.totalLoops = totalLoops;
  this.direction = frameMultiplier < 0 ? -1 : 1;
}

function BMSegmentStartEvent(type, firstFrame, totalFrames) {
  this.type = type;
  this.firstFrame = firstFrame;
  this.totalFrames = totalFrames;
}

function BMDestroyEvent(type, target) {
  this.type = type;
  this.target = target;
}

function BMRenderFrameErrorEvent(nativeError, currentTime) {
  this.type = 'renderFrameError';
  this.nativeError = nativeError;
  this.currentTime = currentTime;
}

function BMConfigErrorEvent(nativeError) {
  this.type = 'configError';
  this.nativeError = nativeError;
}

var createElementID = (function () {
  var _count = 0;
  return function createID() {
    _count += 1;
    return idPrefix + '__lottie_element_' + _count;
  };
}());

function HSVtoRGB(h, s, v) {
  var r;
  var g;
  var b;
  var i;
  var f;
  var p;
  var q;
  var t;
  i = Math.floor(h * 6);
  f = h * 6 - i;
  p = v * (1 - s);
  q = v * (1 - f * s);
  t = v * (1 - (1 - f) * s);
  switch (i % 6) {
    case 0: r = v; g = t; b = p; break;
    case 1: r = q; g = v; b = p; break;
    case 2: r = p; g = v; b = t; break;
    case 3: r = p; g = q; b = v; break;
    case 4: r = t; g = p; b = v; break;
    case 5: r = v; g = p; b = q; break;
  }
  return [r,
    g,
    b];
}

function RGBtoHSV(r, g, b) {
  var max = Math.max(r, g, b);
  var min = Math.min(r, g, b);
  var d = max - min;
  var h;
  var s = (max === 0 ? 0 : d / max);
  var v = max / 255;

  switch (max) {
    case min: h = 0; break;
    case r: h = (g - b) + d * (g < b ? 6 : 0); h /= 6 * d; break;
    case g: h = (b - r) + d * 2; h /= 6 * d; break;
    case b: h = (r - g) + d * 4; h /= 6 * d; break;
  }

  return [
    h,
    s,
    v,
  ];
}

function addSaturationToRGB(color, offset) {
  var hsv = RGBtoHSV(color[0] * 255, color[1] * 255, color[2] * 255);
  hsv[1] += offset;
  if (hsv[1] > 1) {
    hsv[1] = 1;
  } else if (hsv[1] <= 0) {
    hsv[1] = 0;
  }
  return HSVtoRGB(hsv[0], hsv[1], hsv[2]);
}

function addBrightnessToRGB(color, offset) {
  var hsv = RGBtoHSV(color[0] * 255, color[1] * 255, color[2] * 255);
  hsv[2] += offset;
  if (hsv[2] > 1) {
    hsv[2] = 1;
  } else if (hsv[2] < 0) {
    hsv[2] = 0;
  }
  return HSVtoRGB(hsv[0], hsv[1], hsv[2]);
}

function addHueToRGB(color, offset) {
  var hsv = RGBtoHSV(color[0] * 255, color[1] * 255, color[2] * 255);
  hsv[0] += offset / 360;
  if (hsv[0] > 1) {
    hsv[0] -= 1;
  } else if (hsv[0] < 0) {
    hsv[0] += 1;
  }
  return HSVtoRGB(hsv[0], hsv[1], hsv[2]);
}

var rgbToHex = (function () {
  var colorMap = [];
  var i;
  var hex;
  for (i = 0; i < 256; i += 1) {
    hex = i.toString(16);
    colorMap[i] = hex.length === 1 ? '0' + hex : hex;
  }

  return function (r, g, b) {
    if (r < 0) {
      r = 0;
    }
    if (g < 0) {
      g = 0;
    }
    if (b < 0) {
      b = 0;
    }
    return '#' + colorMap[r] + colorMap[g] + colorMap[b];
  };
}());

function BaseEvent() {}
BaseEvent.prototype = {
  triggerEvent: function (eventName, args) {
    if (this._cbs[eventName]) {
      var len = this._cbs[eventName].length;
      for (var i = 0; i < len; i += 1) {
        this._cbs[eventName][i](args);
      }
    }
  },
  addEventListener: function (eventName, callback) {
    if (!this._cbs[eventName]) {
      this._cbs[eventName] = [];
    }
    this._cbs[eventName].push(callback);

    return function () {
      this.removeEventListener(eventName, callback);
    }.bind(this);
  },
  removeEventListener: function (eventName, callback) {
    if (!callback) {
      this._cbs[eventName] = null;
    } else if (this._cbs[eventName]) {
      var i = 0;
      var len = this._cbs[eventName].length;
      while (i < len) {
        if (this._cbs[eventName][i] === callback) {
          this._cbs[eventName].splice(i, 1);
          i -= 1;
          len -= 1;
        }
        i += 1;
      }
      if (!this._cbs[eventName].length) {
        this._cbs[eventName] = null;
      }
    }
  },
};

/* exported createTypedArray, createSizedArray */

var createTypedArray = (function () {
  function createRegularArray(type, len) {
    var i = 0;
    var arr = [];
    var value;
    switch (type) {
      case 'int16':
      case 'uint8c':
        value = 1;
        break;
      default:
        value = 1.1;
        break;
    }
    for (i = 0; i < len; i += 1) {
      arr.push(value);
    }
    return arr;
  }
  function createTypedArrayFactory(type, len) {
    if (type === 'float32') {
      return new Float32Array(len);
    } if (type === 'int16') {
      return new Int16Array(len);
    } if (type === 'uint8c') {
      return new Uint8ClampedArray(len);
    }
    return createRegularArray(type, len);
  }
  if (typeof Uint8ClampedArray === 'function' && typeof Float32Array === 'function') {
    return createTypedArrayFactory;
  }
  return createRegularArray;
}());

function createSizedArray(len) {
  return Array.apply(null, { length: len });
}

/* global svgNS */
/* exported createNS */

function createNS(type) {
  // return {appendChild:function(){},setAttribute:function(){},style:{}}
  return document.createElementNS(svgNS, type);
}

/* exported createTag */

function createTag(type) {
  // return {appendChild:function(){},setAttribute:function(){},style:{}}
  return document.createElement(type);
}

function DynamicPropertyContainer() {}
DynamicPropertyContainer.prototype = {
  addDynamicProperty: function (prop) {
    if (this.dynamicProperties.indexOf(prop) === -1) {
      this.dynamicProperties.push(prop);
      this.container.addDynamicProperty(this);
      this._isAnimated = true;
    }
  },
  iterateDynamicProperties: function () {
    this._mdf = false;
    var i;
    var len = this.dynamicProperties.length;
    for (i = 0; i < len; i += 1) {
      this.dynamicProperties[i].getValue();
      if (this.dynamicProperties[i]._mdf) {
        this._mdf = true;
      }
    }
  },
  initDynamicPropertyContainer: function (container) {
    this.container = container;
    this.dynamicProperties = [];
    this._mdf = false;
    this._isAnimated = false;
  },
};

/* exported getBlendMode */

var getBlendMode = (function () {
  var blendModeEnums = {
    0: 'source-over',
    1: 'multiply',
    2: 'screen',
    3: 'overlay',
    4: 'darken',
    5: 'lighten',
    6: 'color-dodge',
    7: 'color-burn',
    8: 'hard-light',
    9: 'soft-light',
    10: 'difference',
    11: 'exclusion',
    12: 'hue',
    13: 'saturation',
    14: 'color',
    15: 'luminosity',
  };

  return function (mode) {
    return blendModeEnums[mode] || '';
  };
}());

/* global createTypedArray */

/*!
 Transformation Matrix v2.0
 (c) Epistemex 2014-2015
 www.epistemex.com
 By Ken Fyrstenberg
 Contributions by leeoniya.
 License: MIT, header required.
 */

/**
 * 2D transformation matrix object initialized with identity matrix.
 *
 * The matrix can synchronize a canvas context by supplying the context
 * as an argument, or later apply current absolute transform to an
 * existing context.
 *
 * All values are handled as floating point values.
 *
 * @param {CanvasRenderingContext2D} [context] - Optional context to sync with Matrix
 * @prop {number} a - scale x
 * @prop {number} b - shear y
 * @prop {number} c - shear x
 * @prop {number} d - scale y
 * @prop {number} e - translate x
 * @prop {number} f - translate y
 * @prop {CanvasRenderingContext2D|null} [context=null] - set or get current canvas context
 * @constructor
 */

var Matrix = (function () {
  var _cos = Math.cos;
  var _sin = Math.sin;
  var _tan = Math.tan;
  var _rnd = Math.round;

  function reset() {
    this.props[0] = 1;
    this.props[1] = 0;
    this.props[2] = 0;
    this.props[3] = 0;
    this.props[4] = 0;
    this.props[5] = 1;
    this.props[6] = 0;
    this.props[7] = 0;
    this.props[8] = 0;
    this.props[9] = 0;
    this.props[10] = 1;
    this.props[11] = 0;
    this.props[12] = 0;
    this.props[13] = 0;
    this.props[14] = 0;
    this.props[15] = 1;
    return this;
  }

  function rotate(angle) {
    if (angle === 0) {
      return this;
    }
    var mCos = _cos(angle);
    var mSin = _sin(angle);
    return this._t(mCos, -mSin, 0, 0, mSin, mCos, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
  }

  function rotateX(angle) {
    if (angle === 0) {
      return this;
    }
    var mCos = _cos(angle);
    var mSin = _sin(angle);
    return this._t(1, 0, 0, 0, 0, mCos, -mSin, 0, 0, mSin, mCos, 0, 0, 0, 0, 1);
  }

  function rotateY(angle) {
    if (angle === 0) {
      return this;
    }
    var mCos = _cos(angle);
    var mSin = _sin(angle);
    return this._t(mCos, 0, mSin, 0, 0, 1, 0, 0, -mSin, 0, mCos, 0, 0, 0, 0, 1);
  }

  function rotateZ(angle) {
    if (angle === 0) {
      return this;
    }
    var mCos = _cos(angle);
    var mSin = _sin(angle);
    return this._t(mCos, -mSin, 0, 0, mSin, mCos, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
  }

  function shear(sx, sy) {
    return this._t(1, sy, sx, 1, 0, 0);
  }

  function skew(ax, ay) {
    return this.shear(_tan(ax), _tan(ay));
  }

  function skewFromAxis(ax, angle) {
    var mCos = _cos(angle);
    var mSin = _sin(angle);
    return this._t(mCos, mSin, 0, 0, -mSin, mCos, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)
      ._t(1, 0, 0, 0, _tan(ax), 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)
      ._t(mCos, -mSin, 0, 0, mSin, mCos, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
    // return this._t(mCos, mSin, -mSin, mCos, 0, 0)._t(1, 0, _tan(ax), 1, 0, 0)._t(mCos, -mSin, mSin, mCos, 0, 0);
  }

  function scale(sx, sy, sz) {
    if (!sz && sz !== 0) {
      sz = 1;
    }
    if (sx === 1 && sy === 1 && sz === 1) {
      return this;
    }
    return this._t(sx, 0, 0, 0, 0, sy, 0, 0, 0, 0, sz, 0, 0, 0, 0, 1);
  }

  function setTransform(a, b, c, d, e, f, g, h, i, j, k, l, m, n, o, p) {
    this.props[0] = a;
    this.props[1] = b;
    this.props[2] = c;
    this.props[3] = d;
    this.props[4] = e;
    this.props[5] = f;
    this.props[6] = g;
    this.props[7] = h;
    this.props[8] = i;
    this.props[9] = j;
    this.props[10] = k;
    this.props[11] = l;
    this.props[12] = m;
    this.props[13] = n;
    this.props[14] = o;
    this.props[15] = p;
    return this;
  }

  function translate(tx, ty, tz) {
    tz = tz || 0;
    if (tx !== 0 || ty !== 0 || tz !== 0) {
      return this._t(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, tx, ty, tz, 1);
    }
    return this;
  }

  function transform(a2, b2, c2, d2, e2, f2, g2, h2, i2, j2, k2, l2, m2, n2, o2, p2) {
    var _p = this.props;

    if (a2 === 1 && b2 === 0 && c2 === 0 && d2 === 0 && e2 === 0 && f2 === 1 && g2 === 0 && h2 === 0 && i2 === 0 && j2 === 0 && k2 === 1 && l2 === 0) {
      // NOTE: commenting this condition because TurboFan deoptimizes code when present
      // if(m2 !== 0 || n2 !== 0 || o2 !== 0){
      _p[12] = _p[12] * a2 + _p[15] * m2;
      _p[13] = _p[13] * f2 + _p[15] * n2;
      _p[14] = _p[14] * k2 + _p[15] * o2;
      _p[15] *= p2;
      // }
      this._identityCalculated = false;
      return this;
    }

    var a1 = _p[0];
    var b1 = _p[1];
    var c1 = _p[2];
    var d1 = _p[3];
    var e1 = _p[4];
    var f1 = _p[5];
    var g1 = _p[6];
    var h1 = _p[7];
    var i1 = _p[8];
    var j1 = _p[9];
    var k1 = _p[10];
    var l1 = _p[11];
    var m1 = _p[12];
    var n1 = _p[13];
    var o1 = _p[14];
    var p1 = _p[15];

    /* matrix order (canvas compatible):
         * ace
         * bdf
         * 001
         */
    _p[0] = a1 * a2 + b1 * e2 + c1 * i2 + d1 * m2;
    _p[1] = a1 * b2 + b1 * f2 + c1 * j2 + d1 * n2;
    _p[2] = a1 * c2 + b1 * g2 + c1 * k2 + d1 * o2;
    _p[3] = a1 * d2 + b1 * h2 + c1 * l2 + d1 * p2;

    _p[4] = e1 * a2 + f1 * e2 + g1 * i2 + h1 * m2;
    _p[5] = e1 * b2 + f1 * f2 + g1 * j2 + h1 * n2;
    _p[6] = e1 * c2 + f1 * g2 + g1 * k2 + h1 * o2;
    _p[7] = e1 * d2 + f1 * h2 + g1 * l2 + h1 * p2;

    _p[8] = i1 * a2 + j1 * e2 + k1 * i2 + l1 * m2;
    _p[9] = i1 * b2 + j1 * f2 + k1 * j2 + l1 * n2;
    _p[10] = i1 * c2 + j1 * g2 + k1 * k2 + l1 * o2;
    _p[11] = i1 * d2 + j1 * h2 + k1 * l2 + l1 * p2;

    _p[12] = m1 * a2 + n1 * e2 + o1 * i2 + p1 * m2;
    _p[13] = m1 * b2 + n1 * f2 + o1 * j2 + p1 * n2;
    _p[14] = m1 * c2 + n1 * g2 + o1 * k2 + p1 * o2;
    _p[15] = m1 * d2 + n1 * h2 + o1 * l2 + p1 * p2;

    this._identityCalculated = false;
    return this;
  }

  function isIdentity() {
    if (!this._identityCalculated) {
      this._identity = !(this.props[0] !== 1 || this.props[1] !== 0 || this.props[2] !== 0 || this.props[3] !== 0 || this.props[4] !== 0 || this.props[5] !== 1 || this.props[6] !== 0 || this.props[7] !== 0 || this.props[8] !== 0 || this.props[9] !== 0 || this.props[10] !== 1 || this.props[11] !== 0 || this.props[12] !== 0 || this.props[13] !== 0 || this.props[14] !== 0 || this.props[15] !== 1);
      this._identityCalculated = true;
    }
    return this._identity;
  }

  function equals(matr) {
    var i = 0;
    while (i < 16) {
      if (matr.props[i] !== this.props[i]) {
        return false;
      }
      i += 1;
    }
    return true;
  }

  function clone(matr) {
    var i;
    for (i = 0; i < 16; i += 1) {
      matr.props[i] = this.props[i];
    }
    return matr;
  }

  function cloneFromProps(props) {
    var i;
    for (i = 0; i < 16; i += 1) {
      this.props[i] = props[i];
    }
  }

  function applyToPoint(x, y, z) {
    return {
      x: x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12],
      y: x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13],
      z: x * this.props[2] + y * this.props[6] + z * this.props[10] + this.props[14],
    };
    /* return {
         x: x * me.a + y * me.c + me.e,
         y: x * me.b + y * me.d + me.f
         }; */
  }
  function applyToX(x, y, z) {
    return x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12];
  }
  function applyToY(x, y, z) {
    return x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13];
  }
  function applyToZ(x, y, z) {
    return x * this.props[2] + y * this.props[6] + z * this.props[10] + this.props[14];
  }

  function getInverseMatrix() {
    var determinant = this.props[0] * this.props[5] - this.props[1] * this.props[4];
    var a = this.props[5] / determinant;
    var b = -this.props[1] / determinant;
    var c = -this.props[4] / determinant;
    var d = this.props[0] / determinant;
    var e = (this.props[4] * this.props[13] - this.props[5] * this.props[12]) / determinant;
    var f = -(this.props[0] * this.props[13] - this.props[1] * this.props[12]) / determinant;
    var inverseMatrix = new Matrix();
    inverseMatrix.props[0] = a;
    inverseMatrix.props[1] = b;
    inverseMatrix.props[4] = c;
    inverseMatrix.props[5] = d;
    inverseMatrix.props[12] = e;
    inverseMatrix.props[13] = f;
    return inverseMatrix;
  }

  function inversePoint(pt) {
    var inverseMatrix = this.getInverseMatrix();
    return inverseMatrix.applyToPointArray(pt[0], pt[1], pt[2] || 0);
  }

  function inversePoints(pts) {
    var i;
    var len = pts.length;
    var retPts = [];
    for (i = 0; i < len; i += 1) {
      retPts[i] = inversePoint(pts[i]);
    }
    return retPts;
  }

  function applyToTriplePoints(pt1, pt2, pt3) {
    var arr = createTypedArray('float32', 6);
    if (this.isIdentity()) {
      arr[0] = pt1[0];
      arr[1] = pt1[1];
      arr[2] = pt2[0];
      arr[3] = pt2[1];
      arr[4] = pt3[0];
      arr[5] = pt3[1];
    } else {
      var p0 = this.props[0];
      var p1 = this.props[1];
      var p4 = this.props[4];
      var p5 = this.props[5];
      var p12 = this.props[12];
      var p13 = this.props[13];
      arr[0] = pt1[0] * p0 + pt1[1] * p4 + p12;
      arr[1] = pt1[0] * p1 + pt1[1] * p5 + p13;
      arr[2] = pt2[0] * p0 + pt2[1] * p4 + p12;
      arr[3] = pt2[0] * p1 + pt2[1] * p5 + p13;
      arr[4] = pt3[0] * p0 + pt3[1] * p4 + p12;
      arr[5] = pt3[0] * p1 + pt3[1] * p5 + p13;
    }
    return arr;
  }

  function applyToPointArray(x, y, z) {
    var arr;
    if (this.isIdentity()) {
      arr = [x, y, z];
    } else {
      arr = [
        x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12],
        x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13],
        x * this.props[2] + y * this.props[6] + z * this.props[10] + this.props[14],
      ];
    }
    return arr;
  }

  function applyToPointStringified(x, y) {
    if (this.isIdentity()) {
      return x + ',' + y;
    }
    var _p = this.props;
    return Math.round((x * _p[0] + y * _p[4] + _p[12]) * 100) / 100 + ',' + Math.round((x * _p[1] + y * _p[5] + _p[13]) * 100) / 100;
  }

  function toCSS() {
    // Doesn't make much sense to add this optimization. If it is an identity matrix, it's very likely this will get called only once since it won't be keyframed.
    /* if(this.isIdentity()) {
            return '';
        } */
    var i = 0;
    var props = this.props;
    var cssValue = 'matrix3d(';
    var v = 10000;
    while (i < 16) {
      cssValue += _rnd(props[i] * v) / v;
      cssValue += i === 15 ? ')' : ',';
      i += 1;
    }
    return cssValue;
  }

  function roundMatrixProperty(val) {
    var v = 10000;
    if ((val < 0.000001 && val > 0) || (val > -0.000001 && val < 0)) {
      return _rnd(val * v) / v;
    }
    return val;
  }

  function to2dCSS() {
    // Doesn't make much sense to add this optimization. If it is an identity matrix, it's very likely this will get called only once since it won't be keyframed.
    /* if(this.isIdentity()) {
            return '';
        } */
    var props = this.props;
    var _a = roundMatrixProperty(props[0]);
    var _b = roundMatrixProperty(props[1]);
    var _c = roundMatrixProperty(props[4]);
    var _d = roundMatrixProperty(props[5]);
    var _e = roundMatrixProperty(props[12]);
    var _f = roundMatrixProperty(props[13]);
    return 'matrix(' + _a + ',' + _b + ',' + _c + ',' + _d + ',' + _e + ',' + _f + ')';
  }

  return function () {
    this.reset = reset;
    this.rotate = rotate;
    this.rotateX = rotateX;
    this.rotateY = rotateY;
    this.rotateZ = rotateZ;
    this.skew = skew;
    this.skewFromAxis = skewFromAxis;
    this.shear = shear;
    this.scale = scale;
    this.setTransform = setTransform;
    this.translate = translate;
    this.transform = transform;
    this.applyToPoint = applyToPoint;
    this.applyToX = applyToX;
    this.applyToY = applyToY;
    this.applyToZ = applyToZ;
    this.applyToPointArray = applyToPointArray;
    this.applyToTriplePoints = applyToTriplePoints;
    this.applyToPointStringified = applyToPointStringified;
    this.toCSS = toCSS;
    this.to2dCSS = to2dCSS;
    this.clone = clone;
    this.cloneFromProps = cloneFromProps;
    this.equals = equals;
    this.inversePoints = inversePoints;
    this.inversePoint = inversePoint;
    this.getInverseMatrix = getInverseMatrix;
    this._t = this.transform;
    this.isIdentity = isIdentity;
    this._identity = true;
    this._identityCalculated = false;

    this.props = createTypedArray('float32', 16);
    this.reset();
  };
}());

/* eslint-disable */
/*
 Copyright 2014 David Bau.

 Permission is hereby granted, free of charge, to any person obtaining
 a copy of this software and associated documentation files (the
 "Software"), to deal in the Software without restriction, including
 without limitation the rights to use, copy, modify, merge, publish,
 distribute, sublicense, and/or sell copies of the Software, and to
 permit persons to whom the Software is furnished to do so, subject to
 the following conditions:

 The above copyright notice and this permission notice shall be
 included in all copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
 IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
 CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
 TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
 SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

 */

(function (pool, math) {
//
// The following constants are related to IEEE 754 limits.
//
    var global = this,
        width = 256,        // each RC4 output is 0 <= x < 256
        chunks = 6,         // at least six RC4 outputs for each double
        digits = 52,        // there are 52 significant digits in a double
        rngname = 'random', // rngname: name for Math.random and Math.seedrandom
        startdenom = math.pow(width, chunks),
        significance = math.pow(2, digits),
        overflow = significance * 2,
        mask = width - 1,
        nodecrypto;         // node.js crypto module, initialized at the bottom.

//
// seedrandom()
// This is the seedrandom function described above.
//
    function seedrandom(seed, options, callback) {
        var key = [];
        options = (options === true) ? { entropy: true } : (options || {});

        // Flatten the seed string or build one from local entropy if needed.
        var shortseed = mixkey(flatten(
            options.entropy ? [seed, tostring(pool)] :
                (seed === null) ? autoseed() : seed, 3), key);

        // Use the seed to initialize an ARC4 generator.
        var arc4 = new ARC4(key);

        // This function returns a random double in [0, 1) that contains
        // randomness in every bit of the mantissa of the IEEE 754 value.
        var prng = function() {
            var n = arc4.g(chunks),             // Start with a numerator n < 2 ^ 48
                d = startdenom,                 //   and denominator d = 2 ^ 48.
                x = 0;                          //   and no 'extra last byte'.
            while (n < significance) {          // Fill up all significant digits by
                n = (n + x) * width;              //   shifting numerator and
                d *= width;                       //   denominator and generating a
                x = arc4.g(1);                    //   new least-significant-byte.
            }
            while (n >= overflow) {             // To avoid rounding up, before adding
                n /= 2;                           //   last byte, shift everything
                d /= 2;                           //   right using integer math until
                x >>>= 1;                         //   we have exactly the desired bits.
            }
            return (n + x) / d;                 // Form the number within [0, 1).
        };

        prng.int32 = function() { return arc4.g(4) | 0; };
        prng.quick = function() { return arc4.g(4) / 0x100000000; };
        prng.double = prng;

        // Mix the randomness into accumulated entropy.
        mixkey(tostring(arc4.S), pool);

        // Calling convention: what to return as a function of prng, seed, is_math.
        return (options.pass || callback ||
        function(prng, seed, is_math_call, state) {
            if (state) {
                // Load the arc4 state from the given state if it has an S array.
                if (state.S) { copy(state, arc4); }
                // Only provide the .state method if requested via options.state.
                prng.state = function() { return copy(arc4, {}); };
            }

            // If called as a method of Math (Math.seedrandom()), mutate
            // Math.random because that is how seedrandom.js has worked since v1.0.
            if (is_math_call) { math[rngname] = prng; return seed; }

            // Otherwise, it is a newer calling convention, so return the
            // prng directly.
            else return prng;
        })(
            prng,
            shortseed,
            'global' in options ? options.global : (this == math),
            options.state);
    }
    math['seed' + rngname] = seedrandom;

//
// ARC4
//
// An ARC4 implementation.  The constructor takes a key in the form of
// an array of at most (width) integers that should be 0 <= x < (width).
//
// The g(count) method returns a pseudorandom integer that concatenates
// the next (count) outputs from ARC4.  Its return value is a number x
// that is in the range 0 <= x < (width ^ count).
//
    function ARC4(key) {
        var t, keylen = key.length,
            me = this, i = 0, j = me.i = me.j = 0, s = me.S = [];

        // The empty key [] is treated as [0].
        if (!keylen) { key = [keylen++]; }

        // Set up S using the standard key scheduling algorithm.
        while (i < width) {
            s[i] = i++;
        }
        for (i = 0; i < width; i++) {
            s[i] = s[j = mask & (j + key[i % keylen] + (t = s[i]))];
            s[j] = t;
        }

        // The "g" method returns the next (count) outputs as one number.
        me.g = function(count) {
            // Using instance members instead of closure state nearly doubles speed.
            var t, r = 0,
                i = me.i, j = me.j, s = me.S;
            while (count--) {
                t = s[i = mask & (i + 1)];
                r = r * width + s[mask & ((s[i] = s[j = mask & (j + t)]) + (s[j] = t))];
            }
            me.i = i; me.j = j;
            return r;
            // For robust unpredictability, the function call below automatically
            // discards an initial batch of values.  This is called RC4-drop[256].
            // See http://google.com/search?q=rsa+fluhrer+response&btnI
        };
    }

//
// copy()
// Copies internal state of ARC4 to or from a plain object.
//
    function copy(f, t) {
        t.i = f.i;
        t.j = f.j;
        t.S = f.S.slice();
        return t;
    }

//
// flatten()
// Converts an object tree to nested arrays of strings.
//
    function flatten(obj, depth) {
        var result = [], typ = (typeof obj), prop;
        if (depth && typ == 'object') {
            for (prop in obj) {
                try { result.push(flatten(obj[prop], depth - 1)); } catch (e) {}
            }
        }
        return (result.length ? result : typ == 'string' ? obj : obj + '\0');
    }

//
// mixkey()
// Mixes a string seed into a key that is an array of integers, and
// returns a shortened string seed that is equivalent to the result key.
//
    function mixkey(seed, key) {
        var stringseed = seed + '', smear, j = 0;
        while (j < stringseed.length) {
            key[mask & j] =
                mask & ((smear ^= key[mask & j] * 19) + stringseed.charCodeAt(j++));
        }
        return tostring(key);
    }

//
// autoseed()
// Returns an object for autoseeding, using window.crypto and Node crypto
// module if available.
//
    function autoseed() {
        try {
            if (nodecrypto) ;
            var out = new Uint8Array(width);
            (global.crypto || global.msCrypto).getRandomValues(out);
            return tostring(out);
        } catch (e) {
            var browser = global.navigator,
                plugins = browser && browser.plugins;
            return [+new Date(), global, plugins, global.screen, tostring(pool)];
        }
    }

//
// tostring()
// Converts an array of charcodes to a string
//
    function tostring(a) {
        return String.fromCharCode.apply(0, a);
    }

//
// When seedrandom.js is loaded, we immediately mix a few bits
// from the built-in RNG into the entropy pool.  Because we do
// not want to interfere with deterministic PRNG state later,
// seedrandom will not call math.random on its own again after
// initialization.
//
    mixkey(math.random(), pool);

//
// Nodejs and AMD support: export the implementation as a module using
// either convention.
//

// End anonymous scope, and pass initial values.
})(
    [],     // pool: entropy pool starts empty
    BMMath    // math: package containing random, pow, and seedrandom
);
/* eslint-disable */
var BezierFactory = (function () {
  /**
     * BezierEasing - use bezier curve for transition easing function
     * by Gaëtan Renaudeau 2014 - 2015 – MIT License
     *
     * Credits: is based on Firefox's nsSMILKeySpline.cpp
     * Usage:
     * var spline = BezierEasing([ 0.25, 0.1, 0.25, 1.0 ])
     * spline.get(x) => returns the easing value | x must be in [0, 1] range
     *
     */

  var ob = {};
  ob.getBezierEasing = getBezierEasing;
  var beziers = {};

  function getBezierEasing(a, b, c, d, nm) {
    var str = nm || ('bez_' + a + '_' + b + '_' + c + '_' + d).replace(/\./g, 'p');
    if (beziers[str]) {
      return beziers[str];
    }
    var bezEasing = new BezierEasing([a, b, c, d]);
    beziers[str] = bezEasing;
    return bezEasing;
  }

  // These values are established by empiricism with tests (tradeoff: performance VS precision)
  var NEWTON_ITERATIONS = 4;
  var NEWTON_MIN_SLOPE = 0.001;
  var SUBDIVISION_PRECISION = 0.0000001;
  var SUBDIVISION_MAX_ITERATIONS = 10;

  var kSplineTableSize = 11;
  var kSampleStepSize = 1.0 / (kSplineTableSize - 1.0);

  var float32ArraySupported = typeof Float32Array === 'function';

  function A(aA1, aA2) { return 1.0 - 3.0 * aA2 + 3.0 * aA1; }
  function B(aA1, aA2) { return 3.0 * aA2 - 6.0 * aA1; }
  function C(aA1) { return 3.0 * aA1; }

  // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
  function calcBezier(aT, aA1, aA2) {
    return ((A(aA1, aA2) * aT + B(aA1, aA2)) * aT + C(aA1)) * aT;
  }

  // Returns dx/dt given t, x1, and x2, or dy/dt given t, y1, and y2.
  function getSlope(aT, aA1, aA2) {
    return 3.0 * A(aA1, aA2) * aT * aT + 2.0 * B(aA1, aA2) * aT + C(aA1);
  }

  function binarySubdivide(aX, aA, aB, mX1, mX2) {
    var currentX,
      currentT,
      i = 0;
    do {
      currentT = aA + (aB - aA) / 2.0;
      currentX = calcBezier(currentT, mX1, mX2) - aX;
      if (currentX > 0.0) {
        aB = currentT;
      } else {
        aA = currentT;
      }
    } while (Math.abs(currentX) > SUBDIVISION_PRECISION && ++i < SUBDIVISION_MAX_ITERATIONS);
    return currentT;
  }

  function newtonRaphsonIterate(aX, aGuessT, mX1, mX2) {
    for (var i = 0; i < NEWTON_ITERATIONS; ++i) {
      var currentSlope = getSlope(aGuessT, mX1, mX2);
      if (currentSlope === 0.0) return aGuessT;
      var currentX = calcBezier(aGuessT, mX1, mX2) - aX;
      aGuessT -= currentX / currentSlope;
    }
    return aGuessT;
  }

  /**
     * points is an array of [ mX1, mY1, mX2, mY2 ]
     */
  function BezierEasing(points) {
    this._p = points;
    this._mSampleValues = float32ArraySupported ? new Float32Array(kSplineTableSize) : new Array(kSplineTableSize);
    this._precomputed = false;

    this.get = this.get.bind(this);
  }

  BezierEasing.prototype = {

    get: function (x) {
      var mX1 = this._p[0],
        mY1 = this._p[1],
        mX2 = this._p[2],
        mY2 = this._p[3];
      if (!this._precomputed) this._precompute();
      if (mX1 === mY1 && mX2 === mY2) return x; // linear
      // Because JavaScript number are imprecise, we should guarantee the extremes are right.
      if (x === 0) return 0;
      if (x === 1) return 1;
      return calcBezier(this._getTForX(x), mY1, mY2);
    },

    // Private part

    _precompute: function () {
      var mX1 = this._p[0],
        mY1 = this._p[1],
        mX2 = this._p[2],
        mY2 = this._p[3];
      this._precomputed = true;
      if (mX1 !== mY1 || mX2 !== mY2) { this._calcSampleValues(); }
    },

    _calcSampleValues: function () {
      var mX1 = this._p[0],
        mX2 = this._p[2];
      for (var i = 0; i < kSplineTableSize; ++i) {
        this._mSampleValues[i] = calcBezier(i * kSampleStepSize, mX1, mX2);
      }
    },

    /**
         * getTForX chose the fastest heuristic to determine the percentage value precisely from a given X projection.
         */
    _getTForX: function (aX) {
      var mX1 = this._p[0],
        mX2 = this._p[2],
        mSampleValues = this._mSampleValues;

      var intervalStart = 0.0;
      var currentSample = 1;
      var lastSample = kSplineTableSize - 1;

      for (; currentSample !== lastSample && mSampleValues[currentSample] <= aX; ++currentSample) {
        intervalStart += kSampleStepSize;
      }
      --currentSample;

      // Interpolate to provide an initial guess for t
      var dist = (aX - mSampleValues[currentSample]) / (mSampleValues[currentSample + 1] - mSampleValues[currentSample]);
      var guessForT = intervalStart + dist * kSampleStepSize;

      var initialSlope = getSlope(guessForT, mX1, mX2);
      if (initialSlope >= NEWTON_MIN_SLOPE) {
        return newtonRaphsonIterate(aX, guessForT, mX1, mX2);
      } if (initialSlope === 0.0) {
        return guessForT;
      }
      return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize, mX1, mX2);
    },
  };

  return ob;
}());

(function () {
  var lastTime = 0;
  var vendors = ['ms', 'moz', 'webkit', 'o'];
  for (var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) { // eslint-disable-line no-plusplus
    window.requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
    window.cancelAnimationFrame = window[vendors[x] + 'CancelAnimationFrame'] || window[vendors[x] + 'CancelRequestAnimationFrame'];
  }
  if (!window.requestAnimationFrame) {
    window.requestAnimationFrame = function (callback) {
      var currTime = new Date().getTime();
      var timeToCall = Math.max(0, 16 - (currTime - lastTime));
      var id = setTimeout(function () {
        callback(currTime + timeToCall);
      },
      timeToCall);
      lastTime = currTime + timeToCall;
      return id;
    };
  }
  if (!window.cancelAnimationFrame) {
    window.cancelAnimationFrame = function (id) {
      clearTimeout(id);
    };
  }
}());

/* exported extendPrototype, getDescriptor, createProxyFunction */

function extendPrototype(sources, destination) {
  var i;
  var len = sources.length;
  var sourcePrototype;
  for (i = 0; i < len; i += 1) {
    sourcePrototype = sources[i].prototype;
    for (var attr in sourcePrototype) {
      if (Object.prototype.hasOwnProperty.call(sourcePrototype, attr)) destination.prototype[attr] = sourcePrototype[attr];
    }
  }
}

function getDescriptor(object, prop) {
  return Object.getOwnPropertyDescriptor(object, prop);
}

function createProxyFunction(prototype) {
  function ProxyFunction() {}
  ProxyFunction.prototype = prototype;
  return ProxyFunction;
}

/* global segmentsLengthPool, defaultCurveSegments, createSizedArray, bmPow, bmSqrt, bmFloor, createTypedArray, bezierLengthPool */
/* exported bez */

function bezFunction() {
  var math = Math;

  function pointOnLine2D(x1, y1, x2, y2, x3, y3) {
    var det1 = (x1 * y2) + (y1 * x3) + (x2 * y3) - (x3 * y2) - (y3 * x1) - (x2 * y1);
    return det1 > -0.001 && det1 < 0.001;
  }

  function pointOnLine3D(x1, y1, z1, x2, y2, z2, x3, y3, z3) {
    if (z1 === 0 && z2 === 0 && z3 === 0) {
      return pointOnLine2D(x1, y1, x2, y2, x3, y3);
    }
    var dist1 = math.sqrt(math.pow(x2 - x1, 2) + math.pow(y2 - y1, 2) + math.pow(z2 - z1, 2));
    var dist2 = math.sqrt(math.pow(x3 - x1, 2) + math.pow(y3 - y1, 2) + math.pow(z3 - z1, 2));
    var dist3 = math.sqrt(math.pow(x3 - x2, 2) + math.pow(y3 - y2, 2) + math.pow(z3 - z2, 2));
    var diffDist;
    if (dist1 > dist2) {
      if (dist1 > dist3) {
        diffDist = dist1 - dist2 - dist3;
      } else {
        diffDist = dist3 - dist2 - dist1;
      }
    } else if (dist3 > dist2) {
      diffDist = dist3 - dist2 - dist1;
    } else {
      diffDist = dist2 - dist1 - dist3;
    }
    return diffDist > -0.0001 && diffDist < 0.0001;
  }

  var getBezierLength = (function () {
    return function (pt1, pt2, pt3, pt4) {
      var curveSegments = defaultCurveSegments;
      var k;
      var i;
      var len;
      var ptCoord;
      var perc;
      var addedLength = 0;
      var ptDistance;
      var point = [];
      var lastPoint = [];
      var lengthData = bezierLengthPool.newElement();
      len = pt3.length;
      for (k = 0; k < curveSegments; k += 1) {
        perc = k / (curveSegments - 1);
        ptDistance = 0;
        for (i = 0; i < len; i += 1) {
          ptCoord = bmPow(1 - perc, 3) * pt1[i] + 3 * bmPow(1 - perc, 2) * perc * pt3[i] + 3 * (1 - perc) * bmPow(perc, 2) * pt4[i] + bmPow(perc, 3) * pt2[i];
          point[i] = ptCoord;
          if (lastPoint[i] !== null) {
            ptDistance += bmPow(point[i] - lastPoint[i], 2);
          }
          lastPoint[i] = point[i];
        }
        if (ptDistance) {
          ptDistance = bmSqrt(ptDistance);
          addedLength += ptDistance;
        }
        lengthData.percents[k] = perc;
        lengthData.lengths[k] = addedLength;
      }
      lengthData.addedLength = addedLength;
      return lengthData;
    };
  }());

  function getSegmentsLength(shapeData) {
    var segmentsLength = segmentsLengthPool.newElement();
    var closed = shapeData.c;
    var pathV = shapeData.v;
    var pathO = shapeData.o;
    var pathI = shapeData.i;
    var i;
    var len = shapeData._length;
    var lengths = segmentsLength.lengths;
    var totalLength = 0;
    for (i = 0; i < len - 1; i += 1) {
      lengths[i] = getBezierLength(pathV[i], pathV[i + 1], pathO[i], pathI[i + 1]);
      totalLength += lengths[i].addedLength;
    }
    if (closed && len) {
      lengths[i] = getBezierLength(pathV[i], pathV[0], pathO[i], pathI[0]);
      totalLength += lengths[i].addedLength;
    }
    segmentsLength.totalLength = totalLength;
    return segmentsLength;
  }

  function BezierData(length) {
    this.segmentLength = 0;
    this.points = new Array(length);
  }

  function PointData(partial, point) {
    this.partialLength = partial;
    this.point = point;
  }

  var buildBezierData = (function () {
    var storedData = {};

    return function (pt1, pt2, pt3, pt4) {
      var bezierName = (pt1[0] + '_' + pt1[1] + '_' + pt2[0] + '_' + pt2[1] + '_' + pt3[0] + '_' + pt3[1] + '_' + pt4[0] + '_' + pt4[1]).replace(/\./g, 'p');
      if (!storedData[bezierName]) {
        var curveSegments = defaultCurveSegments;
        var k;
        var i;
        var len;
        var ptCoord;
        var perc;
        var addedLength = 0;
        var ptDistance;
        var point;
        var lastPoint = null;
        if (pt1.length === 2 && (pt1[0] !== pt2[0] || pt1[1] !== pt2[1]) && pointOnLine2D(pt1[0], pt1[1], pt2[0], pt2[1], pt1[0] + pt3[0], pt1[1] + pt3[1]) && pointOnLine2D(pt1[0], pt1[1], pt2[0], pt2[1], pt2[0] + pt4[0], pt2[1] + pt4[1])) {
          curveSegments = 2;
        }
        var bezierData = new BezierData(curveSegments);
        len = pt3.length;
        for (k = 0; k < curveSegments; k += 1) {
          point = createSizedArray(len);
          perc = k / (curveSegments - 1);
          ptDistance = 0;
          for (i = 0; i < len; i += 1) {
            ptCoord = bmPow(1 - perc, 3) * pt1[i] + 3 * bmPow(1 - perc, 2) * perc * (pt1[i] + pt3[i]) + 3 * (1 - perc) * bmPow(perc, 2) * (pt2[i] + pt4[i]) + bmPow(perc, 3) * pt2[i];
            point[i] = ptCoord;
            if (lastPoint !== null) {
              ptDistance += bmPow(point[i] - lastPoint[i], 2);
            }
          }
          ptDistance = bmSqrt(ptDistance);
          addedLength += ptDistance;
          bezierData.points[k] = new PointData(ptDistance, point);
          lastPoint = point;
        }
        bezierData.segmentLength = addedLength;
        storedData[bezierName] = bezierData;
      }
      return storedData[bezierName];
    };
  }());

  function getDistancePerc(perc, bezierData) {
    var percents = bezierData.percents;
    var lengths = bezierData.lengths;
    var len = percents.length;
    var initPos = bmFloor((len - 1) * perc);
    var lengthPos = perc * bezierData.addedLength;
    var lPerc = 0;
    if (initPos === len - 1 || initPos === 0 || lengthPos === lengths[initPos]) {
      return percents[initPos];
    }
    var dir = lengths[initPos] > lengthPos ? -1 : 1;
    var flag = true;
    while (flag) {
      if (lengths[initPos] <= lengthPos && lengths[initPos + 1] > lengthPos) {
        lPerc = (lengthPos - lengths[initPos]) / (lengths[initPos + 1] - lengths[initPos]);
        flag = false;
      } else {
        initPos += dir;
      }
      if (initPos < 0 || initPos >= len - 1) {
        // FIX for TypedArrays that don't store floating point values with enough accuracy
        if (initPos === len - 1) {
          return percents[initPos];
        }
        flag = false;
      }
    }
    return percents[initPos] + (percents[initPos + 1] - percents[initPos]) * lPerc;
  }

  function getPointInSegment(pt1, pt2, pt3, pt4, percent, bezierData) {
    var t1 = getDistancePerc(percent, bezierData);
    var u1 = 1 - t1;
    var ptX = math.round((u1 * u1 * u1 * pt1[0] + (t1 * u1 * u1 + u1 * t1 * u1 + u1 * u1 * t1) * pt3[0] + (t1 * t1 * u1 + u1 * t1 * t1 + t1 * u1 * t1) * pt4[0] + t1 * t1 * t1 * pt2[0]) * 1000) / 1000;
    var ptY = math.round((u1 * u1 * u1 * pt1[1] + (t1 * u1 * u1 + u1 * t1 * u1 + u1 * u1 * t1) * pt3[1] + (t1 * t1 * u1 + u1 * t1 * t1 + t1 * u1 * t1) * pt4[1] + t1 * t1 * t1 * pt2[1]) * 1000) / 1000;
    return [ptX, ptY];
  }

  var bezierSegmentPoints = createTypedArray('float32', 8);

  function getNewSegment(pt1, pt2, pt3, pt4, startPerc, endPerc, bezierData) {
    if (startPerc < 0) {
      startPerc = 0;
    } else if (startPerc > 1) {
      startPerc = 1;
    }
    var t0 = getDistancePerc(startPerc, bezierData);
    endPerc = endPerc > 1 ? 1 : endPerc;
    var t1 = getDistancePerc(endPerc, bezierData);
    var i;
    var len = pt1.length;
    var u0 = 1 - t0;
    var u1 = 1 - t1;
    var u0u0u0 = u0 * u0 * u0;
    var t0u0u0_3 = t0 * u0 * u0 * 3; // eslint-disable-line camelcase
    var t0t0u0_3 = t0 * t0 * u0 * 3; // eslint-disable-line camelcase
    var t0t0t0 = t0 * t0 * t0;
    //
    var u0u0u1 = u0 * u0 * u1;
    var t0u0u1_3 = t0 * u0 * u1 + u0 * t0 * u1 + u0 * u0 * t1; // eslint-disable-line camelcase
    var t0t0u1_3 = t0 * t0 * u1 + u0 * t0 * t1 + t0 * u0 * t1; // eslint-disable-line camelcase
    var t0t0t1 = t0 * t0 * t1;
    //
    var u0u1u1 = u0 * u1 * u1;
    var t0u1u1_3 = t0 * u1 * u1 + u0 * t1 * u1 + u0 * u1 * t1; // eslint-disable-line camelcase
    var t0t1u1_3 = t0 * t1 * u1 + u0 * t1 * t1 + t0 * u1 * t1; // eslint-disable-line camelcase
    var t0t1t1 = t0 * t1 * t1;
    //
    var u1u1u1 = u1 * u1 * u1;
    var t1u1u1_3 = t1 * u1 * u1 + u1 * t1 * u1 + u1 * u1 * t1; // eslint-disable-line camelcase
    var t1t1u1_3 = t1 * t1 * u1 + u1 * t1 * t1 + t1 * u1 * t1; // eslint-disable-line camelcase
    var t1t1t1 = t1 * t1 * t1;
    for (i = 0; i < len; i += 1) {
      bezierSegmentPoints[i * 4] = math.round((u0u0u0 * pt1[i] + t0u0u0_3 * pt3[i] + t0t0u0_3 * pt4[i] + t0t0t0 * pt2[i]) * 1000) / 1000; // eslint-disable-line camelcase
      bezierSegmentPoints[i * 4 + 1] = math.round((u0u0u1 * pt1[i] + t0u0u1_3 * pt3[i] + t0t0u1_3 * pt4[i] + t0t0t1 * pt2[i]) * 1000) / 1000; // eslint-disable-line camelcase
      bezierSegmentPoints[i * 4 + 2] = math.round((u0u1u1 * pt1[i] + t0u1u1_3 * pt3[i] + t0t1u1_3 * pt4[i] + t0t1t1 * pt2[i]) * 1000) / 1000; // eslint-disable-line camelcase
      bezierSegmentPoints[i * 4 + 3] = math.round((u1u1u1 * pt1[i] + t1u1u1_3 * pt3[i] + t1t1u1_3 * pt4[i] + t1t1t1 * pt2[i]) * 1000) / 1000; // eslint-disable-line camelcase
    }

    return bezierSegmentPoints;
  }

  return {
    getSegmentsLength: getSegmentsLength,
    getNewSegment: getNewSegment,
    getPointInSegment: getPointInSegment,
    buildBezierData: buildBezierData,
    pointOnLine2D: pointOnLine2D,
    pointOnLine3D: pointOnLine3D,
  };
}

var bez = bezFunction();

/* exported dataManager */

function dataFunctionManager() {
  // var tCanvasHelper = createTag('canvas').getContext('2d');

  function completeLayers(layers, comps, fontManager) {
    var layerData;
    var i;
    var len = layers.length;
    var j;
    var jLen;
    var k;
    var kLen;
    for (i = 0; i < len; i += 1) {
      layerData = layers[i];
      if (('ks' in layerData) && !layerData.completed) {
        layerData.completed = true;
        if (layerData.tt) {
          layers[i - 1].td = layerData.tt;
        }
        if (layerData.hasMask) {
          var maskProps = layerData.masksProperties;
          jLen = maskProps.length;
          for (j = 0; j < jLen; j += 1) {
            if (maskProps[j].pt.k.i) {
              convertPathsToAbsoluteValues(maskProps[j].pt.k);
            } else {
              kLen = maskProps[j].pt.k.length;
              for (k = 0; k < kLen; k += 1) {
                if (maskProps[j].pt.k[k].s) {
                  convertPathsToAbsoluteValues(maskProps[j].pt.k[k].s[0]);
                }
                if (maskProps[j].pt.k[k].e) {
                  convertPathsToAbsoluteValues(maskProps[j].pt.k[k].e[0]);
                }
              }
            }
          }
        }
        if (layerData.ty === 0) {
          layerData.layers = findCompLayers(layerData.refId, comps);
          completeLayers(layerData.layers, comps);
        } else if (layerData.ty === 4) {
          completeShapes(layerData.shapes);
        } else if (layerData.ty === 5) {
          completeText(layerData);
        }
      }
    }
  }

  function findCompLayers(id, comps) {
    var i = 0;
    var len = comps.length;
    while (i < len) {
      if (comps[i].id === id) {
        if (!comps[i].layers.__used) {
          comps[i].layers.__used = true;
          return comps[i].layers;
        }
        return JSON.parse(JSON.stringify(comps[i].layers));
      }
      i += 1;
    }
    return null;
  }

  function completeShapes(arr) {
    var i;
    var len = arr.length;
    var j;
    var jLen;
    for (i = len - 1; i >= 0; i -= 1) {
      if (arr[i].ty === 'sh') {
        if (arr[i].ks.k.i) {
          convertPathsToAbsoluteValues(arr[i].ks.k);
        } else {
          jLen = arr[i].ks.k.length;
          for (j = 0; j < jLen; j += 1) {
            if (arr[i].ks.k[j].s) {
              convertPathsToAbsoluteValues(arr[i].ks.k[j].s[0]);
            }
            if (arr[i].ks.k[j].e) {
              convertPathsToAbsoluteValues(arr[i].ks.k[j].e[0]);
            }
          }
        }
      } else if (arr[i].ty === 'gr') {
        completeShapes(arr[i].it);
      }
    }
  }

  function convertPathsToAbsoluteValues(path) {
    var i;
    var len = path.i.length;
    for (i = 0; i < len; i += 1) {
      path.i[i][0] += path.v[i][0];
      path.i[i][1] += path.v[i][1];
      path.o[i][0] += path.v[i][0];
      path.o[i][1] += path.v[i][1];
    }
  }

  function checkVersion(minimum, animVersionString) {
    var animVersion = animVersionString ? animVersionString.split('.') : [100, 100, 100];
    if (minimum[0] > animVersion[0]) {
      return true;
    } if (animVersion[0] > minimum[0]) {
      return false;
    }
    if (minimum[1] > animVersion[1]) {
      return true;
    } if (animVersion[1] > minimum[1]) {
      return false;
    }
    if (minimum[2] > animVersion[2]) {
      return true;
    } if (animVersion[2] > minimum[2]) {
      return false;
    }
    return null;
  }

  var checkText = (function () {
    var minimumVersion = [4, 4, 14];

    function updateTextLayer(textLayer) {
      var documentData = textLayer.t.d;
      textLayer.t.d = {
        k: [
          {
            s: documentData,
            t: 0,
          },
        ],
      };
    }

    function iterateLayers(layers) {
      var i;
      var len = layers.length;
      for (i = 0; i < len; i += 1) {
        if (layers[i].ty === 5) {
          updateTextLayer(layers[i]);
        }
      }
    }

    return function (animationData) {
      if (checkVersion(minimumVersion, animationData.v)) {
        iterateLayers(animationData.layers);
        if (animationData.assets) {
          var i;
          var len = animationData.assets.length;
          for (i = 0; i < len; i += 1) {
            if (animationData.assets[i].layers) {
              iterateLayers(animationData.assets[i].layers);
            }
          }
        }
      }
    };
  }());

  var checkChars = (function () {
    var minimumVersion = [4, 7, 99];
    return function (animationData) {
      if (animationData.chars && !checkVersion(minimumVersion, animationData.v)) {
        var i;
        var len = animationData.chars.length;
        var j;
        var jLen;
        var pathData;
        var paths;
        for (i = 0; i < len; i += 1) {
          if (animationData.chars[i].data && animationData.chars[i].data.shapes) {
            paths = animationData.chars[i].data.shapes[0].it;
            jLen = paths.length;

            for (j = 0; j < jLen; j += 1) {
              pathData = paths[j].ks.k;
              if (!pathData.__converted) {
                convertPathsToAbsoluteValues(paths[j].ks.k);
                pathData.__converted = true;
              }
            }
          }
        }
      }
    };
  }());

  var checkColors = (function () {
    var minimumVersion = [4, 1, 9];

    function iterateShapes(shapes) {
      var i;
      var len = shapes.length;
      var j;
      var jLen;
      for (i = 0; i < len; i += 1) {
        if (shapes[i].ty === 'gr') {
          iterateShapes(shapes[i].it);
        } else if (shapes[i].ty === 'fl' || shapes[i].ty === 'st') {
          if (shapes[i].c.k && shapes[i].c.k[0].i) {
            jLen = shapes[i].c.k.length;
            for (j = 0; j < jLen; j += 1) {
              if (shapes[i].c.k[j].s) {
                shapes[i].c.k[j].s[0] /= 255;
                shapes[i].c.k[j].s[1] /= 255;
                shapes[i].c.k[j].s[2] /= 255;
                shapes[i].c.k[j].s[3] /= 255;
              }
              if (shapes[i].c.k[j].e) {
                shapes[i].c.k[j].e[0] /= 255;
                shapes[i].c.k[j].e[1] /= 255;
                shapes[i].c.k[j].e[2] /= 255;
                shapes[i].c.k[j].e[3] /= 255;
              }
            }
          } else {
            shapes[i].c.k[0] /= 255;
            shapes[i].c.k[1] /= 255;
            shapes[i].c.k[2] /= 255;
            shapes[i].c.k[3] /= 255;
          }
        }
      }
    }

    function iterateLayers(layers) {
      var i;
      var len = layers.length;
      for (i = 0; i < len; i += 1) {
        if (layers[i].ty === 4) {
          iterateShapes(layers[i].shapes);
        }
      }
    }

    return function (animationData) {
      if (checkVersion(minimumVersion, animationData.v)) {
        iterateLayers(animationData.layers);
        if (animationData.assets) {
          var i;
          var len = animationData.assets.length;
          for (i = 0; i < len; i += 1) {
            if (animationData.assets[i].layers) {
              iterateLayers(animationData.assets[i].layers);
            }
          }
        }
      }
    };
  }());

  var checkShapes = (function () {
    var minimumVersion = [4, 4, 18];

    function completeClosingShapes(arr) {
      var i;
      var len = arr.length;
      var j;
      var jLen;
      for (i = len - 1; i >= 0; i -= 1) {
        if (arr[i].ty === 'sh') {
          if (arr[i].ks.k.i) {
            arr[i].ks.k.c = arr[i].closed;
          } else {
            jLen = arr[i].ks.k.length;
            for (j = 0; j < jLen; j += 1) {
              if (arr[i].ks.k[j].s) {
                arr[i].ks.k[j].s[0].c = arr[i].closed;
              }
              if (arr[i].ks.k[j].e) {
                arr[i].ks.k[j].e[0].c = arr[i].closed;
              }
            }
          }
        } else if (arr[i].ty === 'gr') {
          completeClosingShapes(arr[i].it);
        }
      }
    }

    function iterateLayers(layers) {
      var layerData;
      var i;
      var len = layers.length;
      var j;
      var jLen;
      var k;
      var kLen;
      for (i = 0; i < len; i += 1) {
        layerData = layers[i];
        if (layerData.hasMask) {
          var maskProps = layerData.masksProperties;
          jLen = maskProps.length;
          for (j = 0; j < jLen; j += 1) {
            if (maskProps[j].pt.k.i) {
              maskProps[j].pt.k.c = maskProps[j].cl;
            } else {
              kLen = maskProps[j].pt.k.length;
              for (k = 0; k < kLen; k += 1) {
                if (maskProps[j].pt.k[k].s) {
                  maskProps[j].pt.k[k].s[0].c = maskProps[j].cl;
                }
                if (maskProps[j].pt.k[k].e) {
                  maskProps[j].pt.k[k].e[0].c = maskProps[j].cl;
                }
              }
            }
          }
        }
        if (layerData.ty === 4) {
          completeClosingShapes(layerData.shapes);
        }
      }
    }

    return function (animationData) {
      if (checkVersion(minimumVersion, animationData.v)) {
        iterateLayers(animationData.layers);
        if (animationData.assets) {
          var i;
          var len = animationData.assets.length;
          for (i = 0; i < len; i += 1) {
            if (animationData.assets[i].layers) {
              iterateLayers(animationData.assets[i].layers);
            }
          }
        }
      }
    };
  }());

  function completeData(animationData, fontManager) {
    if (animationData.__complete) {
      return;
    }
    checkColors(animationData);
    checkText(animationData);
    checkChars(animationData);
    checkShapes(animationData);
    completeLayers(animationData.layers, animationData.assets);
    animationData.__complete = true;
  }

  function completeText(data) {
    if (data.t.a.length === 0 && !('m' in data.t.p)) {
      data.singleShape = true;
    }
  }

  var moduleOb = {};
  moduleOb.completeData = completeData;
  moduleOb.checkColors = checkColors;
  moduleOb.checkChars = checkChars;
  moduleOb.checkShapes = checkShapes;
  moduleOb.completeLayers = completeLayers;

  return moduleOb;
}

var dataManager = dataFunctionManager();

/* exported getFontProperties */

function getFontProperties(fontData) {
  var styles = fontData.fStyle ? fontData.fStyle.split(' ') : [];

  var fWeight = 'normal'; var
    fStyle = 'normal';
  var len = styles.length;
  var styleName;
  for (var i = 0; i < len; i += 1) {
    styleName = styles[i].toLowerCase();
    switch (styleName) {
      case 'italic':
        fStyle = 'italic';
        break;
      case 'bold':
        fWeight = '700';
        break;
      case 'black':
        fWeight = '900';
        break;
      case 'medium':
        fWeight = '500';
        break;
      case 'regular':
      case 'normal':
        fWeight = '400';
        break;
      case 'light':
      case 'thin':
        fWeight = '200';
        break;
    }
  }

  return {
    style: fStyle,
    weight: fontData.fWeight || fWeight,
  };
}

/* global createNS, createTag, getFontProperties */
/* exported FontManager */

var FontManager = (function () {
  var maxWaitingTime = 5000;
  var emptyChar = {
    w: 0,
    size: 0,
    shapes: [],
  };
  var combinedCharacters = [];
  // Hindi characters
  combinedCharacters = combinedCharacters.concat([2304, 2305, 2306, 2307, 2362, 2363, 2364, 2364, 2366,
    2367, 2368, 2369, 2370, 2371, 2372, 2373, 2374, 2375, 2376, 2377, 2378, 2379,
    2380, 2381, 2382, 2383, 2387, 2388, 2389, 2390, 2391, 2402, 2403]);

  function trimFontOptions(font) {
    var familyArray = font.split(',');
    var i;
    var len = familyArray.length;
    var enabledFamilies = [];
    for (i = 0; i < len; i += 1) {
      if (familyArray[i] !== 'sans-serif' && familyArray[i] !== 'monospace') {
        enabledFamilies.push(familyArray[i]);
      }
    }
    return enabledFamilies.join(',');
  }

  function setUpNode(font, family) {
    var parentNode = createTag('span');
    // Node is invisible to screen readers.
    parentNode.setAttribute('aria-hidden', true);
    parentNode.style.fontFamily = family;
    var node = createTag('span');
    // Characters that vary significantly among different fonts
    node.innerText = 'giItT1WQy@!-/#';
    // Visible - so we can measure it - but not on the screen
    parentNode.style.position = 'absolute';
    parentNode.style.left = '-10000px';
    parentNode.style.top = '-10000px';
    // Large font size makes even subtle changes obvious
    parentNode.style.fontSize = '300px';
    // Reset any font properties
    parentNode.style.fontVariant = 'normal';
    parentNode.style.fontStyle = 'normal';
    parentNode.style.fontWeight = 'normal';
    parentNode.style.letterSpacing = '0';
    parentNode.appendChild(node);
    document.body.appendChild(parentNode);

    // Remember width with no applied web font
    var width = node.offsetWidth;
    node.style.fontFamily = trimFontOptions(font) + ', ' + family;
    return { node: node, w: width, parent: parentNode };
  }

  function checkLoadedFonts() {
    var i;
    var len = this.fonts.length;
    var node;
    var w;
    var loadedCount = len;
    for (i = 0; i < len; i += 1) {
      if (this.fonts[i].loaded) {
        loadedCount -= 1;
      } else if (this.fonts[i].fOrigin === 'n' || this.fonts[i].origin === 0) {
        this.fonts[i].loaded = true;
      } else {
        node = this.fonts[i].monoCase.node;
        w = this.fonts[i].monoCase.w;
        if (node.offsetWidth !== w) {
          loadedCount -= 1;
          this.fonts[i].loaded = true;
        } else {
          node = this.fonts[i].sansCase.node;
          w = this.fonts[i].sansCase.w;
          if (node.offsetWidth !== w) {
            loadedCount -= 1;
            this.fonts[i].loaded = true;
          }
        }
        if (this.fonts[i].loaded) {
          this.fonts[i].sansCase.parent.parentNode.removeChild(this.fonts[i].sansCase.parent);
          this.fonts[i].monoCase.parent.parentNode.removeChild(this.fonts[i].monoCase.parent);
        }
      }
    }

    if (loadedCount !== 0 && Date.now() - this.initTime < maxWaitingTime) {
      setTimeout(this.checkLoadedFontsBinded, 20);
    } else {
      setTimeout(this.setIsLoadedBinded, 10);
    }
  }

  function createHelper(def, fontData) {
    var tHelper = createNS('text');
    tHelper.style.fontSize = '100px';
    // tHelper.style.fontFamily = fontData.fFamily;

    var fontProps = getFontProperties(fontData);
    tHelper.setAttribute('font-family', fontData.fFamily);
    tHelper.setAttribute('font-style', fontProps.style);
    tHelper.setAttribute('font-weight', fontProps.weight);
    tHelper.textContent = '1';
    if (fontData.fClass) {
      tHelper.style.fontFamily = 'inherit';
      tHelper.setAttribute('class', fontData.fClass);
    } else {
      tHelper.style.fontFamily = fontData.fFamily;
    }
    def.appendChild(tHelper);
    var tCanvasHelper = createTag('canvas').getContext('2d');
    tCanvasHelper.font = fontData.fWeight + ' ' + fontData.fStyle + ' 100px ' + fontData.fFamily;
    // tCanvasHelper.font = ' 100px '+ fontData.fFamily;
    return tHelper;
  }

  function addFonts(fontData, defs) {
    if (!fontData) {
      this.isLoaded = true;
      return;
    }
    if (this.chars) {
      this.isLoaded = true;
      this.fonts = fontData.list;
      return;
    }

    var fontArr = fontData.list;
    var i;
    var len = fontArr.length;
    var _pendingFonts = len;
    for (i = 0; i < len; i += 1) {
      var shouldLoadFont = true;
      var loadedSelector;
      var j;
      fontArr[i].loaded = false;
      fontArr[i].monoCase = setUpNode(fontArr[i].fFamily, 'monospace');
      fontArr[i].sansCase = setUpNode(fontArr[i].fFamily, 'sans-serif');
      if (!fontArr[i].fPath) {
        fontArr[i].loaded = true;
        _pendingFonts -= 1;
      } else if (fontArr[i].fOrigin === 'p' || fontArr[i].origin === 3) {
        loadedSelector = document.querySelectorAll('style[f-forigin="p"][f-family="' + fontArr[i].fFamily + '"], style[f-origin="3"][f-family="' + fontArr[i].fFamily + '"]');

        if (loadedSelector.length > 0) {
          shouldLoadFont = false;
        }

        if (shouldLoadFont) {
          var s = createTag('style');
          s.setAttribute('f-forigin', fontArr[i].fOrigin);
          s.setAttribute('f-origin', fontArr[i].origin);
          s.setAttribute('f-family', fontArr[i].fFamily);
          s.type = 'text/css';
          s.innerText = '@font-face {font-family: ' + fontArr[i].fFamily + "; font-style: normal; src: url('" + fontArr[i].fPath + "');}";
          defs.appendChild(s);
        }
      } else if (fontArr[i].fOrigin === 'g' || fontArr[i].origin === 1) {
        loadedSelector = document.querySelectorAll('link[f-forigin="g"], link[f-origin="1"]');

        for (j = 0; j < loadedSelector.length; j += 1) {
          if (loadedSelector[j].href.indexOf(fontArr[i].fPath) !== -1) {
            // Font is already loaded
            shouldLoadFont = false;
          }
        }

        if (shouldLoadFont) {
          var l = createTag('link');
          l.setAttribute('f-forigin', fontArr[i].fOrigin);
          l.setAttribute('f-origin', fontArr[i].origin);
          l.type = 'text/css';
          l.rel = 'stylesheet';
          l.href = fontArr[i].fPath;
          document.body.appendChild(l);
        }
      } else if (fontArr[i].fOrigin === 't' || fontArr[i].origin === 2) {
        loadedSelector = document.querySelectorAll('script[f-forigin="t"], script[f-origin="2"]');

        for (j = 0; j < loadedSelector.length; j += 1) {
          if (fontArr[i].fPath === loadedSelector[j].src) {
            // Font is already loaded
            shouldLoadFont = false;
          }
        }

        if (shouldLoadFont) {
          var sc = createTag('link');
          sc.setAttribute('f-forigin', fontArr[i].fOrigin);
          sc.setAttribute('f-origin', fontArr[i].origin);
          sc.setAttribute('rel', 'stylesheet');
          sc.setAttribute('href', fontArr[i].fPath);
          defs.appendChild(sc);
        }
      }
      fontArr[i].helper = createHelper(defs, fontArr[i]);
      fontArr[i].cache = {};
      this.fonts.push(fontArr[i]);
    }
    if (_pendingFonts === 0) {
      this.isLoaded = true;
    } else {
      // On some cases even if the font is loaded, it won't load correctly when measuring text on canvas.
      // Adding this timeout seems to fix it
      setTimeout(this.checkLoadedFonts.bind(this), 100);
    }
  }

  function addChars(chars) {
    if (!chars) {
      return;
    }
    if (!this.chars) {
      this.chars = [];
    }
    var i;
    var len = chars.length;
    var j;
    var jLen = this.chars.length;
    var found;
    for (i = 0; i < len; i += 1) {
      j = 0;
      found = false;
      while (j < jLen) {
        if (this.chars[j].style === chars[i].style && this.chars[j].fFamily === chars[i].fFamily && this.chars[j].ch === chars[i].ch) {
          found = true;
        }
        j += 1;
      }
      if (!found) {
        this.chars.push(chars[i]);
        jLen += 1;
      }
    }
  }

  function getCharData(char, style, font) {
    var i = 0;
    var len = this.chars.length;
    while (i < len) {
      if (this.chars[i].ch === char && this.chars[i].style === style && this.chars[i].fFamily === font) {
        return this.chars[i];
      }
      i += 1;
    }
    if (((typeof char === 'string' && char.charCodeAt(0) !== 13) || !char)
            && console
            && console.warn // eslint-disable-line no-console
            && !this._warned
    ) {
      this._warned = true;
      console.warn('Missing character from exported characters list: ', char, style, font); // eslint-disable-line no-console
    }
    return emptyChar;
  }

  function measureText(char, fontName, size) {
    var fontData = this.getFontByName(fontName);
    var index = char.charCodeAt(0);
    if (!fontData.cache[index + 1]) {
      var tHelper = fontData.helper;
      // Canvas version
      // fontData.cache[index] = tHelper.measureText(char).width / 100;
      // SVG version
      // console.log(tHelper.getBBox().width)
      if (char === ' ') {
        tHelper.textContent = '|' + char + '|';
        var doubleSize = tHelper.getComputedTextLength();
        tHelper.textContent = '||';
        var singleSize = tHelper.getComputedTextLength();
        fontData.cache[index + 1] = (doubleSize - singleSize) / 100;
      } else {
        tHelper.textContent = char;
        fontData.cache[index + 1] = (tHelper.getComputedTextLength()) / 100;
      }
    }
    return fontData.cache[index + 1] * size;
  }

  function getFontByName(name) {
    var i = 0;
    var len = this.fonts.length;
    while (i < len) {
      if (this.fonts[i].fName === name) {
        return this.fonts[i];
      }
      i += 1;
    }
    return this.fonts[0];
  }

  function getCombinedCharacterCodes() {
    return combinedCharacters;
  }

  function setIsLoaded() {
    this.isLoaded = true;
  }

  var Font = function () {
    this.fonts = [];
    this.chars = null;
    this.typekitLoaded = 0;
    this.isLoaded = false;
    this._warned = false;
    this.initTime = Date.now();
    this.setIsLoadedBinded = this.setIsLoaded.bind(this);
    this.checkLoadedFontsBinded = this.checkLoadedFonts.bind(this);
  };
    // TODO: for now I'm adding these methods to the Class and not the prototype. Think of a better way to implement it.
  Font.getCombinedCharacterCodes = getCombinedCharacterCodes;

  var fontPrototype = {
    addChars: addChars,
    addFonts: addFonts,
    getCharData: getCharData,
    getFontByName: getFontByName,
    measureText: measureText,
    checkLoadedFonts: checkLoadedFonts,
    setIsLoaded: setIsLoaded,
  };

  Font.prototype = fontPrototype;

  return Font;
}());

/* global initialDefaultFrame, BezierFactory, degToRads, bez, createTypedArray */
/* exported PropertyFactory */

var PropertyFactory = (function () {
  var initFrame = initialDefaultFrame;
  var mathAbs = Math.abs;

  function interpolateValue(frameNum, caching) {
    var offsetTime = this.offsetTime;
    var newValue;
    if (this.propType === 'multidimensional') {
      newValue = createTypedArray('float32', this.pv.length);
    }
    var iterationIndex = caching.lastIndex;
    var i = iterationIndex;
    var len = this.keyframes.length - 1;
    var flag = true;
    var keyData;
    var nextKeyData;

    while (flag) {
      keyData = this.keyframes[i];
      nextKeyData = this.keyframes[i + 1];
      if (i === len - 1 && frameNum >= nextKeyData.t - offsetTime) {
        if (keyData.h) {
          keyData = nextKeyData;
        }
        iterationIndex = 0;
        break;
      }
      if ((nextKeyData.t - offsetTime) > frameNum) {
        iterationIndex = i;
        break;
      }
      if (i < len - 1) {
        i += 1;
      } else {
        iterationIndex = 0;
        flag = false;
      }
    }

    var k;
    var kLen;
    var perc;
    var jLen;
    var j;
    var fnc;
    var nextKeyTime = nextKeyData.t - offsetTime;
    var keyTime = keyData.t - offsetTime;
    var endValue;
    if (keyData.to) {
      if (!keyData.bezierData) {
        keyData.bezierData = bez.buildBezierData(keyData.s, nextKeyData.s || keyData.e, keyData.to, keyData.ti);
      }
      var bezierData = keyData.bezierData;
      if (frameNum >= nextKeyTime || frameNum < keyTime) {
        var ind = frameNum >= nextKeyTime ? bezierData.points.length - 1 : 0;
        kLen = bezierData.points[ind].point.length;
        for (k = 0; k < kLen; k += 1) {
          newValue[k] = bezierData.points[ind].point[k];
        }
        // caching._lastKeyframeIndex = -1;
      } else {
        if (keyData.__fnct) {
          fnc = keyData.__fnct;
        } else {
          fnc = BezierFactory.getBezierEasing(keyData.o.x, keyData.o.y, keyData.i.x, keyData.i.y, keyData.n).get;
          keyData.__fnct = fnc;
        }
        perc = fnc((frameNum - keyTime) / (nextKeyTime - keyTime));
        var distanceInLine = bezierData.segmentLength * perc;

        var segmentPerc;
        var addedLength = (caching.lastFrame < frameNum && caching._lastKeyframeIndex === i) ? caching._lastAddedLength : 0;
        j = (caching.lastFrame < frameNum && caching._lastKeyframeIndex === i) ? caching._lastPoint : 0;
        flag = true;
        jLen = bezierData.points.length;
        while (flag) {
          addedLength += bezierData.points[j].partialLength;
          if (distanceInLine === 0 || perc === 0 || j === bezierData.points.length - 1) {
            kLen = bezierData.points[j].point.length;
            for (k = 0; k < kLen; k += 1) {
              newValue[k] = bezierData.points[j].point[k];
            }
            break;
          } else if (distanceInLine >= addedLength && distanceInLine < addedLength + bezierData.points[j + 1].partialLength) {
            segmentPerc = (distanceInLine - addedLength) / bezierData.points[j + 1].partialLength;
            kLen = bezierData.points[j].point.length;
            for (k = 0; k < kLen; k += 1) {
              newValue[k] = bezierData.points[j].point[k] + (bezierData.points[j + 1].point[k] - bezierData.points[j].point[k]) * segmentPerc;
            }
            break;
          }
          if (j < jLen - 1) {
            j += 1;
          } else {
            flag = false;
          }
        }
        caching._lastPoint = j;
        caching._lastAddedLength = addedLength - bezierData.points[j].partialLength;
        caching._lastKeyframeIndex = i;
      }
    } else {
      var outX;
      var outY;
      var inX;
      var inY;
      var keyValue;
      len = keyData.s.length;
      endValue = nextKeyData.s || keyData.e;
      if (this.sh && keyData.h !== 1) {
        if (frameNum >= nextKeyTime) {
          newValue[0] = endValue[0];
          newValue[1] = endValue[1];
          newValue[2] = endValue[2];
        } else if (frameNum <= keyTime) {
          newValue[0] = keyData.s[0];
          newValue[1] = keyData.s[1];
          newValue[2] = keyData.s[2];
        } else {
          var quatStart = createQuaternion(keyData.s);
          var quatEnd = createQuaternion(endValue);
          var time = (frameNum - keyTime) / (nextKeyTime - keyTime);
          quaternionToEuler(newValue, slerp(quatStart, quatEnd, time));
        }
      } else {
        for (i = 0; i < len; i += 1) {
          if (keyData.h !== 1) {
            if (frameNum >= nextKeyTime) {
              perc = 1;
            } else if (frameNum < keyTime) {
              perc = 0;
            } else {
              if (keyData.o.x.constructor === Array) {
                if (!keyData.__fnct) {
                  keyData.__fnct = [];
                }
                if (!keyData.__fnct[i]) {
                  outX = (typeof keyData.o.x[i] === 'undefined') ? keyData.o.x[0] : keyData.o.x[i];
                  outY = (typeof keyData.o.y[i] === 'undefined') ? keyData.o.y[0] : keyData.o.y[i];
                  inX = (typeof keyData.i.x[i] === 'undefined') ? keyData.i.x[0] : keyData.i.x[i];
                  inY = (typeof keyData.i.y[i] === 'undefined') ? keyData.i.y[0] : keyData.i.y[i];
                  fnc = BezierFactory.getBezierEasing(outX, outY, inX, inY).get;
                  keyData.__fnct[i] = fnc;
                } else {
                  fnc = keyData.__fnct[i];
                }
              } else if (!keyData.__fnct) {
                outX = keyData.o.x;
                outY = keyData.o.y;
                inX = keyData.i.x;
                inY = keyData.i.y;
                fnc = BezierFactory.getBezierEasing(outX, outY, inX, inY).get;
                keyData.__fnct = fnc;
              } else {
                fnc = keyData.__fnct;
              }
              perc = fnc((frameNum - keyTime) / (nextKeyTime - keyTime));
            }
          }

          endValue = nextKeyData.s || keyData.e;
          keyValue = keyData.h === 1 ? keyData.s[i] : keyData.s[i] + (endValue[i] - keyData.s[i]) * perc;

          if (this.propType === 'multidimensional') {
            newValue[i] = keyValue;
          } else {
            newValue = keyValue;
          }
        }
      }
    }
    caching.lastIndex = iterationIndex;
    return newValue;
  }

  // based on @Toji's https://github.com/toji/gl-matrix/
  function slerp(a, b, t) {
    var out = [];
    var ax = a[0];
    var ay = a[1];
    var az = a[2];
    var aw = a[3];
    var bx = b[0];
    var by = b[1];
    var bz = b[2];
    var bw = b[3];

    var omega;
    var cosom;
    var sinom;
    var scale0;
    var scale1;

    cosom = ax * bx + ay * by + az * bz + aw * bw;
    if (cosom < 0.0) {
      cosom = -cosom;
      bx = -bx;
      by = -by;
      bz = -bz;
      bw = -bw;
    }
    if ((1.0 - cosom) > 0.000001) {
      omega = Math.acos(cosom);
      sinom = Math.sin(omega);
      scale0 = Math.sin((1.0 - t) * omega) / sinom;
      scale1 = Math.sin(t * omega) / sinom;
    } else {
      scale0 = 1.0 - t;
      scale1 = t;
    }
    out[0] = scale0 * ax + scale1 * bx;
    out[1] = scale0 * ay + scale1 * by;
    out[2] = scale0 * az + scale1 * bz;
    out[3] = scale0 * aw + scale1 * bw;

    return out;
  }

  function quaternionToEuler(out, quat) {
    var qx = quat[0];
    var qy = quat[1];
    var qz = quat[2];
    var qw = quat[3];
    var heading = Math.atan2(2 * qy * qw - 2 * qx * qz, 1 - 2 * qy * qy - 2 * qz * qz);
    var attitude = Math.asin(2 * qx * qy + 2 * qz * qw);
    var bank = Math.atan2(2 * qx * qw - 2 * qy * qz, 1 - 2 * qx * qx - 2 * qz * qz);
    out[0] = heading / degToRads;
    out[1] = attitude / degToRads;
    out[2] = bank / degToRads;
  }

  function createQuaternion(values) {
    var heading = values[0] * degToRads;
    var attitude = values[1] * degToRads;
    var bank = values[2] * degToRads;
    var c1 = Math.cos(heading / 2);
    var c2 = Math.cos(attitude / 2);
    var c3 = Math.cos(bank / 2);
    var s1 = Math.sin(heading / 2);
    var s2 = Math.sin(attitude / 2);
    var s3 = Math.sin(bank / 2);
    var w = c1 * c2 * c3 - s1 * s2 * s3;
    var x = s1 * s2 * c3 + c1 * c2 * s3;
    var y = s1 * c2 * c3 + c1 * s2 * s3;
    var z = c1 * s2 * c3 - s1 * c2 * s3;

    return [x, y, z, w];
  }

  function getValueAtCurrentTime() {
    var frameNum = this.comp.renderedFrame - this.offsetTime;
    var initTime = this.keyframes[0].t - this.offsetTime;
    var endTime = this.keyframes[this.keyframes.length - 1].t - this.offsetTime;
    if (!(frameNum === this._caching.lastFrame || (this._caching.lastFrame !== initFrame && ((this._caching.lastFrame >= endTime && frameNum >= endTime) || (this._caching.lastFrame < initTime && frameNum < initTime))))) {
      if (this._caching.lastFrame >= frameNum) {
        this._caching._lastKeyframeIndex = -1;
        this._caching.lastIndex = 0;
      }

      var renderResult = this.interpolateValue(frameNum, this._caching);
      this.pv = renderResult;
    }
    this._caching.lastFrame = frameNum;
    return this.pv;
  }

  function setVValue(val) {
    var multipliedValue;
    if (this.propType === 'unidimensional') {
      multipliedValue = val * this.mult;
      if (mathAbs(this.v - multipliedValue) > 0.00001) {
        this.v = multipliedValue;
        this._mdf = true;
      }
    } else {
      var i = 0;
      var len = this.v.length;
      while (i < len) {
        multipliedValue = val[i] * this.mult;
        if (mathAbs(this.v[i] - multipliedValue) > 0.00001) {
          this.v[i] = multipliedValue;
          this._mdf = true;
        }
        i += 1;
      }
    }
  }

  function processEffectsSequence() {
    if (this.elem.globalData.frameId === this.frameId || !this.effectsSequence.length) {
      return;
    }
    if (this.lock) {
      this.setVValue(this.pv);
      return;
    }
    this.lock = true;
    this._mdf = this._isFirstFrame;
    var i;
    var len = this.effectsSequence.length;
    var finalValue = this.kf ? this.pv : this.data.k;
    for (i = 0; i < len; i += 1) {
      finalValue = this.effectsSequence[i](finalValue);
    }
    this.setVValue(finalValue);
    this._isFirstFrame = false;
    this.lock = false;
    this.frameId = this.elem.globalData.frameId;
  }

  function addEffect(effectFunction) {
    this.effectsSequence.push(effectFunction);
    this.container.addDynamicProperty(this);
  }

  function ValueProperty(elem, data, mult, container) {
    this.propType = 'unidimensional';
    this.mult = mult || 1;
    this.data = data;
    this.v = mult ? data.k * mult : data.k;
    this.pv = data.k;
    this._mdf = false;
    this.elem = elem;
    this.container = container;
    this.comp = elem.comp;
    this.k = false;
    this.kf = false;
    this.vel = 0;
    this.effectsSequence = [];
    this._isFirstFrame = true;
    this.getValue = processEffectsSequence;
    this.setVValue = setVValue;
    this.addEffect = addEffect;
  }

  function MultiDimensionalProperty(elem, data, mult, container) {
    this.propType = 'multidimensional';
    this.mult = mult || 1;
    this.data = data;
    this._mdf = false;
    this.elem = elem;
    this.container = container;
    this.comp = elem.comp;
    this.k = false;
    this.kf = false;
    this.frameId = -1;
    var i;
    var len = data.k.length;
    this.v = createTypedArray('float32', len);
    this.pv = createTypedArray('float32', len);
    this.vel = createTypedArray('float32', len);
    for (i = 0; i < len; i += 1) {
      this.v[i] = data.k[i] * this.mult;
      this.pv[i] = data.k[i];
    }
    this._isFirstFrame = true;
    this.effectsSequence = [];
    this.getValue = processEffectsSequence;
    this.setVValue = setVValue;
    this.addEffect = addEffect;
  }

  function KeyframedValueProperty(elem, data, mult, container) {
    this.propType = 'unidimensional';
    this.keyframes = data.k;
    this.offsetTime = elem.data.st;
    this.frameId = -1;
    this._caching = {
      lastFrame: initFrame, lastIndex: 0, value: 0, _lastKeyframeIndex: -1,
    };
    this.k = true;
    this.kf = true;
    this.data = data;
    this.mult = mult || 1;
    this.elem = elem;
    this.container = container;
    this.comp = elem.comp;
    this.v = initFrame;
    this.pv = initFrame;
    this._isFirstFrame = true;
    this.getValue = processEffectsSequence;
    this.setVValue = setVValue;
    this.interpolateValue = interpolateValue;
    this.effectsSequence = [getValueAtCurrentTime.bind(this)];
    this.addEffect = addEffect;
  }

  function KeyframedMultidimensionalProperty(elem, data, mult, container) {
    this.propType = 'multidimensional';
    var i;
    var len = data.k.length;
    var s;
    var e;
    var to;
    var ti;
    for (i = 0; i < len - 1; i += 1) {
      if (data.k[i].to && data.k[i].s && data.k[i + 1] && data.k[i + 1].s) {
        s = data.k[i].s;
        e = data.k[i + 1].s;
        to = data.k[i].to;
        ti = data.k[i].ti;
        if ((s.length === 2 && !(s[0] === e[0] && s[1] === e[1]) && bez.pointOnLine2D(s[0], s[1], e[0], e[1], s[0] + to[0], s[1] + to[1]) && bez.pointOnLine2D(s[0], s[1], e[0], e[1], e[0] + ti[0], e[1] + ti[1])) || (s.length === 3 && !(s[0] === e[0] && s[1] === e[1] && s[2] === e[2]) && bez.pointOnLine3D(s[0], s[1], s[2], e[0], e[1], e[2], s[0] + to[0], s[1] + to[1], s[2] + to[2]) && bez.pointOnLine3D(s[0], s[1], s[2], e[0], e[1], e[2], e[0] + ti[0], e[1] + ti[1], e[2] + ti[2]))) {
          data.k[i].to = null;
          data.k[i].ti = null;
        }
        if (s[0] === e[0] && s[1] === e[1] && to[0] === 0 && to[1] === 0 && ti[0] === 0 && ti[1] === 0) {
          if (s.length === 2 || (s[2] === e[2] && to[2] === 0 && ti[2] === 0)) {
            data.k[i].to = null;
            data.k[i].ti = null;
          }
        }
      }
    }
    this.effectsSequence = [getValueAtCurrentTime.bind(this)];
    this.data = data;
    this.keyframes = data.k;
    this.offsetTime = elem.data.st;
    this.k = true;
    this.kf = true;
    this._isFirstFrame = true;
    this.mult = mult || 1;
    this.elem = elem;
    this.container = container;
    this.comp = elem.comp;
    this.getValue = processEffectsSequence;
    this.setVValue = setVValue;
    this.interpolateValue = interpolateValue;
    this.frameId = -1;
    var arrLen = data.k[0].s.length;
    this.v = createTypedArray('float32', arrLen);
    this.pv = createTypedArray('float32', arrLen);
    for (i = 0; i < arrLen; i += 1) {
      this.v[i] = initFrame;
      this.pv[i] = initFrame;
    }
    this._caching = { lastFrame: initFrame, lastIndex: 0, value: createTypedArray('float32', arrLen) };
    this.addEffect = addEffect;
  }

  function getProp(elem, data, type, mult, container) {
    var p;
    if (!data.k.length) {
      p = new ValueProperty(elem, data, mult, container);
    } else if (typeof (data.k[0]) === 'number') {
      p = new MultiDimensionalProperty(elem, data, mult, container);
    } else {
      switch (type) {
        case 0:
          p = new KeyframedValueProperty(elem, data, mult, container);
          break;
        case 1:
          p = new KeyframedMultidimensionalProperty(elem, data, mult, container);
          break;
      }
    }
    if (p.effectsSequence.length) {
      container.addDynamicProperty(p);
    }
    return p;
  }

  var ob = {
    getProp: getProp,
  };
  return ob;
}());

/* global Matrix, degToRads, PropertyFactory, extendPrototype, DynamicPropertyContainer */
/* exported TransformPropertyFactory */

var TransformPropertyFactory = (function () {
  var defaultVector = [0, 0];

  function applyToMatrix(mat) {
    var _mdf = this._mdf;
    this.iterateDynamicProperties();
    this._mdf = this._mdf || _mdf;
    if (this.a) {
      mat.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]);
    }
    if (this.s) {
      mat.scale(this.s.v[0], this.s.v[1], this.s.v[2]);
    }
    if (this.sk) {
      mat.skewFromAxis(-this.sk.v, this.sa.v);
    }
    if (this.r) {
      mat.rotate(-this.r.v);
    } else {
      mat.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2])
        .rotateY(this.or.v[1])
        .rotateX(this.or.v[0]);
    }
    if (this.data.p.s) {
      if (this.data.p.z) {
        mat.translate(this.px.v, this.py.v, -this.pz.v);
      } else {
        mat.translate(this.px.v, this.py.v, 0);
      }
    } else {
      mat.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
    }
  }
  function processKeys(forceRender) {
    if (this.elem.globalData.frameId === this.frameId) {
      return;
    }
    if (this._isDirty) {
      this.precalculateMatrix();
      this._isDirty = false;
    }

    this.iterateDynamicProperties();

    if (this._mdf || forceRender) {
      var frameRate;
      this.v.cloneFromProps(this.pre.props);
      if (this.appliedTransformations < 1) {
        this.v.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]);
      }
      if (this.appliedTransformations < 2) {
        this.v.scale(this.s.v[0], this.s.v[1], this.s.v[2]);
      }
      if (this.sk && this.appliedTransformations < 3) {
        this.v.skewFromAxis(-this.sk.v, this.sa.v);
      }
      if (this.r && this.appliedTransformations < 4) {
        this.v.rotate(-this.r.v);
      } else if (!this.r && this.appliedTransformations < 4) {
        this.v.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2])
          .rotateY(this.or.v[1])
          .rotateX(this.or.v[0]);
      }
      if (this.autoOriented) {
        var v1;
        var v2;
        frameRate = this.elem.globalData.frameRate;
        if (this.p && this.p.keyframes && this.p.getValueAtTime) {
          if (this.p._caching.lastFrame + this.p.offsetTime <= this.p.keyframes[0].t) {
            v1 = this.p.getValueAtTime((this.p.keyframes[0].t + 0.01) / frameRate, 0);
            v2 = this.p.getValueAtTime(this.p.keyframes[0].t / frameRate, 0);
          } else if (this.p._caching.lastFrame + this.p.offsetTime >= this.p.keyframes[this.p.keyframes.length - 1].t) {
            v1 = this.p.getValueAtTime((this.p.keyframes[this.p.keyframes.length - 1].t / frameRate), 0);
            v2 = this.p.getValueAtTime((this.p.keyframes[this.p.keyframes.length - 1].t - 0.05) / frameRate, 0);
          } else {
            v1 = this.p.pv;
            v2 = this.p.getValueAtTime((this.p._caching.lastFrame + this.p.offsetTime - 0.01) / frameRate, this.p.offsetTime);
          }
        } else if (this.px && this.px.keyframes && this.py.keyframes && this.px.getValueAtTime && this.py.getValueAtTime) {
          v1 = [];
          v2 = [];
          var px = this.px;
          var py = this.py;
          if (px._caching.lastFrame + px.offsetTime <= px.keyframes[0].t) {
            v1[0] = px.getValueAtTime((px.keyframes[0].t + 0.01) / frameRate, 0);
            v1[1] = py.getValueAtTime((py.keyframes[0].t + 0.01) / frameRate, 0);
            v2[0] = px.getValueAtTime((px.keyframes[0].t) / frameRate, 0);
            v2[1] = py.getValueAtTime((py.keyframes[0].t) / frameRate, 0);
          } else if (px._caching.lastFrame + px.offsetTime >= px.keyframes[px.keyframes.length - 1].t) {
            v1[0] = px.getValueAtTime((px.keyframes[px.keyframes.length - 1].t / frameRate), 0);
            v1[1] = py.getValueAtTime((py.keyframes[py.keyframes.length - 1].t / frameRate), 0);
            v2[0] = px.getValueAtTime((px.keyframes[px.keyframes.length - 1].t - 0.01) / frameRate, 0);
            v2[1] = py.getValueAtTime((py.keyframes[py.keyframes.length - 1].t - 0.01) / frameRate, 0);
          } else {
            v1 = [px.pv, py.pv];
            v2[0] = px.getValueAtTime((px._caching.lastFrame + px.offsetTime - 0.01) / frameRate, px.offsetTime);
            v2[1] = py.getValueAtTime((py._caching.lastFrame + py.offsetTime - 0.01) / frameRate, py.offsetTime);
          }
        } else {
          v2 = defaultVector;
          v1 = v2;
        }
        this.v.rotate(-Math.atan2(v1[1] - v2[1], v1[0] - v2[0]));
      }
      if (this.data.p && this.data.p.s) {
        if (this.data.p.z) {
          this.v.translate(this.px.v, this.py.v, -this.pz.v);
        } else {
          this.v.translate(this.px.v, this.py.v, 0);
        }
      } else {
        this.v.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
      }
    }
    this.frameId = this.elem.globalData.frameId;
  }

  function precalculateMatrix() {
    if (!this.a.k) {
      this.pre.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]);
      this.appliedTransformations = 1;
    } else {
      return;
    }
    if (!this.s.effectsSequence.length) {
      this.pre.scale(this.s.v[0], this.s.v[1], this.s.v[2]);
      this.appliedTransformations = 2;
    } else {
      return;
    }
    if (this.sk) {
      if (!this.sk.effectsSequence.length && !this.sa.effectsSequence.length) {
        this.pre.skewFromAxis(-this.sk.v, this.sa.v);
        this.appliedTransformations = 3;
      } else {
        return;
      }
    }
    if (this.r) {
      if (!this.r.effectsSequence.length) {
        this.pre.rotate(-this.r.v);
        this.appliedTransformations = 4;
      }
    } else if (!this.rz.effectsSequence.length && !this.ry.effectsSequence.length && !this.rx.effectsSequence.length && !this.or.effectsSequence.length) {
      this.pre.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2])
        .rotateY(this.or.v[1])
        .rotateX(this.or.v[0]);
      this.appliedTransformations = 4;
    }
  }

  function autoOrient() {
    //
    // var prevP = this.getValueAtTime();
  }

  function addDynamicProperty(prop) {
    this._addDynamicProperty(prop);
    this.elem.addDynamicProperty(prop);
    this._isDirty = true;
  }

  function TransformProperty(elem, data, container) {
    this.elem = elem;
    this.frameId = -1;
    this.propType = 'transform';
    this.data = data;
    this.v = new Matrix();
    // Precalculated matrix with non animated properties
    this.pre = new Matrix();
    this.appliedTransformations = 0;
    this.initDynamicPropertyContainer(container || elem);
    if (data.p && data.p.s) {
      this.px = PropertyFactory.getProp(elem, data.p.x, 0, 0, this);
      this.py = PropertyFactory.getProp(elem, data.p.y, 0, 0, this);
      if (data.p.z) {
        this.pz = PropertyFactory.getProp(elem, data.p.z, 0, 0, this);
      }
    } else {
      this.p = PropertyFactory.getProp(elem, data.p || { k: [0, 0, 0] }, 1, 0, this);
    }
    if (data.rx) {
      this.rx = PropertyFactory.getProp(elem, data.rx, 0, degToRads, this);
      this.ry = PropertyFactory.getProp(elem, data.ry, 0, degToRads, this);
      this.rz = PropertyFactory.getProp(elem, data.rz, 0, degToRads, this);
      if (data.or.k[0].ti) {
        var i;
        var len = data.or.k.length;
        for (i = 0; i < len; i += 1) {
          data.or.k[i].to = null;
          data.or.k[i].ti = null;
        }
      }
      this.or = PropertyFactory.getProp(elem, data.or, 1, degToRads, this);
      // sh Indicates it needs to be capped between -180 and 180
      this.or.sh = true;
    } else {
      this.r = PropertyFactory.getProp(elem, data.r || { k: 0 }, 0, degToRads, this);
    }
    if (data.sk) {
      this.sk = PropertyFactory.getProp(elem, data.sk, 0, degToRads, this);
      this.sa = PropertyFactory.getProp(elem, data.sa, 0, degToRads, this);
    }
    this.a = PropertyFactory.getProp(elem, data.a || { k: [0, 0, 0] }, 1, 0, this);
    this.s = PropertyFactory.getProp(elem, data.s || { k: [100, 100, 100] }, 1, 0.01, this);
    // Opacity is not part of the transform properties, that's why it won't use this.dynamicProperties. That way transforms won't get updated if opacity changes.
    if (data.o) {
      this.o = PropertyFactory.getProp(elem, data.o, 0, 0.01, elem);
    } else {
      this.o = { _mdf: false, v: 1 };
    }
    this._isDirty = true;
    if (!this.dynamicProperties.length) {
      this.getValue(true);
    }
  }

  TransformProperty.prototype = {
    applyToMatrix: applyToMatrix,
    getValue: processKeys,
    precalculateMatrix: precalculateMatrix,
    autoOrient: autoOrient,
  };

  extendPrototype([DynamicPropertyContainer], TransformProperty);
  TransformProperty.prototype.addDynamicProperty = addDynamicProperty;
  TransformProperty.prototype._addDynamicProperty = DynamicPropertyContainer.prototype.addDynamicProperty;

  function getTransformProperty(elem, data, container) {
    return new TransformProperty(elem, data, container);
  }

  return {
    getTransformProperty: getTransformProperty,
  };
}());

/* global createSizedArray, createSizedArray, pointPool */

function ShapePath() {
  this.c = false;
  this._length = 0;
  this._maxLength = 8;
  this.v = createSizedArray(this._maxLength);
  this.o = createSizedArray(this._maxLength);
  this.i = createSizedArray(this._maxLength);
}

ShapePath.prototype.setPathData = function (closed, len) {
  this.c = closed;
  this.setLength(len);
  var i = 0;
  while (i < len) {
    this.v[i] = pointPool.newElement();
    this.o[i] = pointPool.newElement();
    this.i[i] = pointPool.newElement();
    i += 1;
  }
};

ShapePath.prototype.setLength = function (len) {
  while (this._maxLength < len) {
    this.doubleArrayLength();
  }
  this._length = len;
};

ShapePath.prototype.doubleArrayLength = function () {
  this.v = this.v.concat(createSizedArray(this._maxLength));
  this.i = this.i.concat(createSizedArray(this._maxLength));
  this.o = this.o.concat(createSizedArray(this._maxLength));
  this._maxLength *= 2;
};

ShapePath.prototype.setXYAt = function (x, y, type, pos, replace) {
  var arr;
  this._length = Math.max(this._length, pos + 1);
  if (this._length >= this._maxLength) {
    this.doubleArrayLength();
  }
  switch (type) {
    case 'v':
      arr = this.v;
      break;
    case 'i':
      arr = this.i;
      break;
    case 'o':
      arr = this.o;
      break;
    default:
      arr = [];
      break;
  }
  if (!arr[pos] || (arr[pos] && !replace)) {
    arr[pos] = pointPool.newElement();
  }
  arr[pos][0] = x;
  arr[pos][1] = y;
};

ShapePath.prototype.setTripleAt = function (vX, vY, oX, oY, iX, iY, pos, replace) {
  this.setXYAt(vX, vY, 'v', pos, replace);
  this.setXYAt(oX, oY, 'o', pos, replace);
  this.setXYAt(iX, iY, 'i', pos, replace);
};

ShapePath.prototype.reverse = function () {
  var newPath = new ShapePath();
  newPath.setPathData(this.c, this._length);
  var vertices = this.v;
  var outPoints = this.o;
  var inPoints = this.i;
  var init = 0;
  if (this.c) {
    newPath.setTripleAt(vertices[0][0], vertices[0][1], inPoints[0][0], inPoints[0][1], outPoints[0][0], outPoints[0][1], 0, false);
    init = 1;
  }
  var cnt = this._length - 1;
  var len = this._length;

  var i;
  for (i = init; i < len; i += 1) {
    newPath.setTripleAt(vertices[cnt][0], vertices[cnt][1], inPoints[cnt][0], inPoints[cnt][1], outPoints[cnt][0], outPoints[cnt][1], i, false);
    cnt -= 1;
  }
  return newPath;
};

/* global extendPrototype, roundCorner, BezierFactory, shapePool, degToRads,
  shapeCollectionPool, PropertyFactory, bmMin, DynamicPropertyContainer */
/* exported ShapePropertyFactory */

var ShapePropertyFactory = (function () {
  var initFrame = -999999;

  function interpolateShape(frameNum, previousValue, caching) {
    var iterationIndex = caching.lastIndex;
    var keyPropS;
    var keyPropE;
    var isHold;
    var j;
    var k;
    var jLen;
    var kLen;
    var perc;
    var vertexValue;
    var kf = this.keyframes;
    if (frameNum < kf[0].t - this.offsetTime) {
      keyPropS = kf[0].s[0];
      isHold = true;
      iterationIndex = 0;
    } else if (frameNum >= kf[kf.length - 1].t - this.offsetTime) {
      keyPropS = kf[kf.length - 1].s ? kf[kf.length - 1].s[0] : kf[kf.length - 2].e[0];
      /* if(kf[kf.length - 1].s){
                keyPropS = kf[kf.length - 1].s[0];
            }else{
                keyPropS = kf[kf.length - 2].e[0];
            } */
      isHold = true;
    } else {
      var i = iterationIndex;
      var len = kf.length - 1;
      var flag = true;
      var keyData;
      var nextKeyData;
      while (flag) {
        keyData = kf[i];
        nextKeyData = kf[i + 1];
        if ((nextKeyData.t - this.offsetTime) > frameNum) {
          break;
        }
        if (i < len - 1) {
          i += 1;
        } else {
          flag = false;
        }
      }
      isHold = keyData.h === 1;
      iterationIndex = i;
      if (!isHold) {
        if (frameNum >= nextKeyData.t - this.offsetTime) {
          perc = 1;
        } else if (frameNum < keyData.t - this.offsetTime) {
          perc = 0;
        } else {
          var fnc;
          if (keyData.__fnct) {
            fnc = keyData.__fnct;
          } else {
            fnc = BezierFactory.getBezierEasing(keyData.o.x, keyData.o.y, keyData.i.x, keyData.i.y).get;
            keyData.__fnct = fnc;
          }
          perc = fnc((frameNum - (keyData.t - this.offsetTime)) / ((nextKeyData.t - this.offsetTime) - (keyData.t - this.offsetTime)));
        }
        keyPropE = nextKeyData.s ? nextKeyData.s[0] : keyData.e[0];
      }
      keyPropS = keyData.s[0];
    }
    jLen = previousValue._length;
    kLen = keyPropS.i[0].length;
    caching.lastIndex = iterationIndex;

    for (j = 0; j < jLen; j += 1) {
      for (k = 0; k < kLen; k += 1) {
        vertexValue = isHold ? keyPropS.i[j][k] : keyPropS.i[j][k] + (keyPropE.i[j][k] - keyPropS.i[j][k]) * perc;
        previousValue.i[j][k] = vertexValue;
        vertexValue = isHold ? keyPropS.o[j][k] : keyPropS.o[j][k] + (keyPropE.o[j][k] - keyPropS.o[j][k]) * perc;
        previousValue.o[j][k] = vertexValue;
        vertexValue = isHold ? keyPropS.v[j][k] : keyPropS.v[j][k] + (keyPropE.v[j][k] - keyPropS.v[j][k]) * perc;
        previousValue.v[j][k] = vertexValue;
      }
    }
  }

  function interpolateShapeCurrentTime() {
    var frameNum = this.comp.renderedFrame - this.offsetTime;
    var initTime = this.keyframes[0].t - this.offsetTime;
    var endTime = this.keyframes[this.keyframes.length - 1].t - this.offsetTime;
    var lastFrame = this._caching.lastFrame;
    if (!(lastFrame !== initFrame && ((lastFrame < initTime && frameNum < initTime) || (lastFrame > endTime && frameNum > endTime)))) {
      /// /
      this._caching.lastIndex = lastFrame < frameNum ? this._caching.lastIndex : 0;
      this.interpolateShape(frameNum, this.pv, this._caching);
      /// /
    }
    this._caching.lastFrame = frameNum;
    return this.pv;
  }

  function resetShape() {
    this.paths = this.localShapeCollection;
  }

  function shapesEqual(shape1, shape2) {
    if (shape1._length !== shape2._length || shape1.c !== shape2.c) {
      return false;
    }
    var i;
    var len = shape1._length;
    for (i = 0; i < len; i += 1) {
      if (shape1.v[i][0] !== shape2.v[i][0]
            || shape1.v[i][1] !== shape2.v[i][1]
            || shape1.o[i][0] !== shape2.o[i][0]
            || shape1.o[i][1] !== shape2.o[i][1]
            || shape1.i[i][0] !== shape2.i[i][0]
            || shape1.i[i][1] !== shape2.i[i][1]) {
        return false;
      }
    }
    return true;
  }

  function setVValue(newPath) {
    if (!shapesEqual(this.v, newPath)) {
      this.v = shapePool.clone(newPath);
      this.localShapeCollection.releaseShapes();
      this.localShapeCollection.addShape(this.v);
      this._mdf = true;
      this.paths = this.localShapeCollection;
    }
  }

  function processEffectsSequence() {
    if (this.elem.globalData.frameId === this.frameId) {
      return;
    } if (!this.effectsSequence.length) {
      this._mdf = false;
      return;
    }
    if (this.lock) {
      this.setVValue(this.pv);
      return;
    }
    this.lock = true;
    this._mdf = false;
    var finalValue;
    if (this.kf) {
      finalValue = this.pv;
    } else if (this.data.ks) {
      finalValue = this.data.ks.k;
    } else {
      finalValue = this.data.pt.k;
    }
    var i;
    var len = this.effectsSequence.length;
    for (i = 0; i < len; i += 1) {
      finalValue = this.effectsSequence[i](finalValue);
    }
    this.setVValue(finalValue);
    this.lock = false;
    this.frameId = this.elem.globalData.frameId;
  }

  function ShapeProperty(elem, data, type) {
    this.propType = 'shape';
    this.comp = elem.comp;
    this.container = elem;
    this.elem = elem;
    this.data = data;
    this.k = false;
    this.kf = false;
    this._mdf = false;
    var pathData = type === 3 ? data.pt.k : data.ks.k;
    this.v = shapePool.clone(pathData);
    this.pv = shapePool.clone(this.v);
    this.localShapeCollection = shapeCollectionPool.newShapeCollection();
    this.paths = this.localShapeCollection;
    this.paths.addShape(this.v);
    this.reset = resetShape;
    this.effectsSequence = [];
  }

  function addEffect(effectFunction) {
    this.effectsSequence.push(effectFunction);
    this.container.addDynamicProperty(this);
  }

  ShapeProperty.prototype.interpolateShape = interpolateShape;
  ShapeProperty.prototype.getValue = processEffectsSequence;
  ShapeProperty.prototype.setVValue = setVValue;
  ShapeProperty.prototype.addEffect = addEffect;

  function KeyframedShapeProperty(elem, data, type) {
    this.propType = 'shape';
    this.comp = elem.comp;
    this.elem = elem;
    this.container = elem;
    this.offsetTime = elem.data.st;
    this.keyframes = type === 3 ? data.pt.k : data.ks.k;
    this.k = true;
    this.kf = true;
    var len = this.keyframes[0].s[0].i.length;
    this.v = shapePool.newElement();
    this.v.setPathData(this.keyframes[0].s[0].c, len);
    this.pv = shapePool.clone(this.v);
    this.localShapeCollection = shapeCollectionPool.newShapeCollection();
    this.paths = this.localShapeCollection;
    this.paths.addShape(this.v);
    this.lastFrame = initFrame;
    this.reset = resetShape;
    this._caching = { lastFrame: initFrame, lastIndex: 0 };
    this.effectsSequence = [interpolateShapeCurrentTime.bind(this)];
  }
  KeyframedShapeProperty.prototype.getValue = processEffectsSequence;
  KeyframedShapeProperty.prototype.interpolateShape = interpolateShape;
  KeyframedShapeProperty.prototype.setVValue = setVValue;
  KeyframedShapeProperty.prototype.addEffect = addEffect;

  var EllShapeProperty = (function () {
    var cPoint = roundCorner;

    function EllShapePropertyFactory(elem, data) {
      /* this.v = {
                v: createSizedArray(4),
                i: createSizedArray(4),
                o: createSizedArray(4),
                c: true
            }; */
      this.v = shapePool.newElement();
      this.v.setPathData(true, 4);
      this.localShapeCollection = shapeCollectionPool.newShapeCollection();
      this.paths = this.localShapeCollection;
      this.localShapeCollection.addShape(this.v);
      this.d = data.d;
      this.elem = elem;
      this.comp = elem.comp;
      this.frameId = -1;
      this.initDynamicPropertyContainer(elem);
      this.p = PropertyFactory.getProp(elem, data.p, 1, 0, this);
      this.s = PropertyFactory.getProp(elem, data.s, 1, 0, this);
      if (this.dynamicProperties.length) {
        this.k = true;
      } else {
        this.k = false;
        this.convertEllToPath();
      }
    }

    EllShapePropertyFactory.prototype = {
      reset: resetShape,
      getValue: function () {
        if (this.elem.globalData.frameId === this.frameId) {
          return;
        }
        this.frameId = this.elem.globalData.frameId;
        this.iterateDynamicProperties();

        if (this._mdf) {
          this.convertEllToPath();
        }
      },
      convertEllToPath: function () {
        var p0 = this.p.v[0];
        var p1 = this.p.v[1];
        var s0 = this.s.v[0] / 2;
        var s1 = this.s.v[1] / 2;
        var _cw = this.d !== 3;
        var _v = this.v;
        _v.v[0][0] = p0;
        _v.v[0][1] = p1 - s1;
        _v.v[1][0] = _cw ? p0 + s0 : p0 - s0;
        _v.v[1][1] = p1;
        _v.v[2][0] = p0;
        _v.v[2][1] = p1 + s1;
        _v.v[3][0] = _cw ? p0 - s0 : p0 + s0;
        _v.v[3][1] = p1;
        _v.i[0][0] = _cw ? p0 - s0 * cPoint : p0 + s0 * cPoint;
        _v.i[0][1] = p1 - s1;
        _v.i[1][0] = _cw ? p0 + s0 : p0 - s0;
        _v.i[1][1] = p1 - s1 * cPoint;
        _v.i[2][0] = _cw ? p0 + s0 * cPoint : p0 - s0 * cPoint;
        _v.i[2][1] = p1 + s1;
        _v.i[3][0] = _cw ? p0 - s0 : p0 + s0;
        _v.i[3][1] = p1 + s1 * cPoint;
        _v.o[0][0] = _cw ? p0 + s0 * cPoint : p0 - s0 * cPoint;
        _v.o[0][1] = p1 - s1;
        _v.o[1][0] = _cw ? p0 + s0 : p0 - s0;
        _v.o[1][1] = p1 + s1 * cPoint;
        _v.o[2][0] = _cw ? p0 - s0 * cPoint : p0 + s0 * cPoint;
        _v.o[2][1] = p1 + s1;
        _v.o[3][0] = _cw ? p0 - s0 : p0 + s0;
        _v.o[3][1] = p1 - s1 * cPoint;
      },
    };

    extendPrototype([DynamicPropertyContainer], EllShapePropertyFactory);

    return EllShapePropertyFactory;
  }());

  var StarShapeProperty = (function () {
    function StarShapePropertyFactory(elem, data) {
      this.v = shapePool.newElement();
      this.v.setPathData(true, 0);
      this.elem = elem;
      this.comp = elem.comp;
      this.data = data;
      this.frameId = -1;
      this.d = data.d;
      this.initDynamicPropertyContainer(elem);
      if (data.sy === 1) {
        this.ir = PropertyFactory.getProp(elem, data.ir, 0, 0, this);
        this.is = PropertyFactory.getProp(elem, data.is, 0, 0.01, this);
        this.convertToPath = this.convertStarToPath;
      } else {
        this.convertToPath = this.convertPolygonToPath;
      }
      this.pt = PropertyFactory.getProp(elem, data.pt, 0, 0, this);
      this.p = PropertyFactory.getProp(elem, data.p, 1, 0, this);
      this.r = PropertyFactory.getProp(elem, data.r, 0, degToRads, this);
      this.or = PropertyFactory.getProp(elem, data.or, 0, 0, this);
      this.os = PropertyFactory.getProp(elem, data.os, 0, 0.01, this);
      this.localShapeCollection = shapeCollectionPool.newShapeCollection();
      this.localShapeCollection.addShape(this.v);
      this.paths = this.localShapeCollection;
      if (this.dynamicProperties.length) {
        this.k = true;
      } else {
        this.k = false;
        this.convertToPath();
      }
    }

    StarShapePropertyFactory.prototype = {
      reset: resetShape,
      getValue: function () {
        if (this.elem.globalData.frameId === this.frameId) {
          return;
        }
        this.frameId = this.elem.globalData.frameId;
        this.iterateDynamicProperties();
        if (this._mdf) {
          this.convertToPath();
        }
      },
      convertStarToPath: function () {
        var numPts = Math.floor(this.pt.v) * 2;
        var angle = (Math.PI * 2) / numPts;
        /* this.v.v.length = numPts;
                this.v.i.length = numPts;
                this.v.o.length = numPts; */
        var longFlag = true;
        var longRad = this.or.v;
        var shortRad = this.ir.v;
        var longRound = this.os.v;
        var shortRound = this.is.v;
        var longPerimSegment = (2 * Math.PI * longRad) / (numPts * 2);
        var shortPerimSegment = (2 * Math.PI * shortRad) / (numPts * 2);
        var i;
        var rad;
        var roundness;
        var perimSegment;
        var currentAng = -Math.PI / 2;
        currentAng += this.r.v;
        var dir = this.data.d === 3 ? -1 : 1;
        this.v._length = 0;
        for (i = 0; i < numPts; i += 1) {
          rad = longFlag ? longRad : shortRad;
          roundness = longFlag ? longRound : shortRound;
          perimSegment = longFlag ? longPerimSegment : shortPerimSegment;
          var x = rad * Math.cos(currentAng);
          var y = rad * Math.sin(currentAng);
          var ox = x === 0 && y === 0 ? 0 : y / Math.sqrt(x * x + y * y);
          var oy = x === 0 && y === 0 ? 0 : -x / Math.sqrt(x * x + y * y);
          x += +this.p.v[0];
          y += +this.p.v[1];
          this.v.setTripleAt(x, y, x - ox * perimSegment * roundness * dir, y - oy * perimSegment * roundness * dir, x + ox * perimSegment * roundness * dir, y + oy * perimSegment * roundness * dir, i, true);

          /* this.v.v[i] = [x,y];
                    this.v.i[i] = [x+ox*perimSegment*roundness*dir,y+oy*perimSegment*roundness*dir];
                    this.v.o[i] = [x-ox*perimSegment*roundness*dir,y-oy*perimSegment*roundness*dir];
                    this.v._length = numPts; */
          longFlag = !longFlag;
          currentAng += angle * dir;
        }
      },
      convertPolygonToPath: function () {
        var numPts = Math.floor(this.pt.v);
        var angle = (Math.PI * 2) / numPts;
        var rad = this.or.v;
        var roundness = this.os.v;
        var perimSegment = (2 * Math.PI * rad) / (numPts * 4);
        var i;
        var currentAng = -Math.PI * 0.5;
        var dir = this.data.d === 3 ? -1 : 1;
        currentAng += this.r.v;
        this.v._length = 0;
        for (i = 0; i < numPts; i += 1) {
          var x = rad * Math.cos(currentAng);
          var y = rad * Math.sin(currentAng);
          var ox = x === 0 && y === 0 ? 0 : y / Math.sqrt(x * x + y * y);
          var oy = x === 0 && y === 0 ? 0 : -x / Math.sqrt(x * x + y * y);
          x += +this.p.v[0];
          y += +this.p.v[1];
          this.v.setTripleAt(x, y, x - ox * perimSegment * roundness * dir, y - oy * perimSegment * roundness * dir, x + ox * perimSegment * roundness * dir, y + oy * perimSegment * roundness * dir, i, true);
          currentAng += angle * dir;
        }
        this.paths.length = 0;
        this.paths[0] = this.v;
      },

    };
    extendPrototype([DynamicPropertyContainer], StarShapePropertyFactory);

    return StarShapePropertyFactory;
  }());

  var RectShapeProperty = (function () {
    function RectShapePropertyFactory(elem, data) {
      this.v = shapePool.newElement();
      this.v.c = true;
      this.localShapeCollection = shapeCollectionPool.newShapeCollection();
      this.localShapeCollection.addShape(this.v);
      this.paths = this.localShapeCollection;
      this.elem = elem;
      this.comp = elem.comp;
      this.frameId = -1;
      this.d = data.d;
      this.initDynamicPropertyContainer(elem);
      this.p = PropertyFactory.getProp(elem, data.p, 1, 0, this);
      this.s = PropertyFactory.getProp(elem, data.s, 1, 0, this);
      this.r = PropertyFactory.getProp(elem, data.r, 0, 0, this);
      if (this.dynamicProperties.length) {
        this.k = true;
      } else {
        this.k = false;
        this.convertRectToPath();
      }
    }

    RectShapePropertyFactory.prototype = {
      convertRectToPath: function () {
        var p0 = this.p.v[0];
        var p1 = this.p.v[1];
        var v0 = this.s.v[0] / 2;
        var v1 = this.s.v[1] / 2;
        var round = bmMin(v0, v1, this.r.v);
        var cPoint = round * (1 - roundCorner);
        this.v._length = 0;

        if (this.d === 2 || this.d === 1) {
          this.v.setTripleAt(p0 + v0, p1 - v1 + round, p0 + v0, p1 - v1 + round, p0 + v0, p1 - v1 + cPoint, 0, true);
          this.v.setTripleAt(p0 + v0, p1 + v1 - round, p0 + v0, p1 + v1 - cPoint, p0 + v0, p1 + v1 - round, 1, true);
          if (round !== 0) {
            this.v.setTripleAt(p0 + v0 - round, p1 + v1, p0 + v0 - round, p1 + v1, p0 + v0 - cPoint, p1 + v1, 2, true);
            this.v.setTripleAt(p0 - v0 + round, p1 + v1, p0 - v0 + cPoint, p1 + v1, p0 - v0 + round, p1 + v1, 3, true);
            this.v.setTripleAt(p0 - v0, p1 + v1 - round, p0 - v0, p1 + v1 - round, p0 - v0, p1 + v1 - cPoint, 4, true);
            this.v.setTripleAt(p0 - v0, p1 - v1 + round, p0 - v0, p1 - v1 + cPoint, p0 - v0, p1 - v1 + round, 5, true);
            this.v.setTripleAt(p0 - v0 + round, p1 - v1, p0 - v0 + round, p1 - v1, p0 - v0 + cPoint, p1 - v1, 6, true);
            this.v.setTripleAt(p0 + v0 - round, p1 - v1, p0 + v0 - cPoint, p1 - v1, p0 + v0 - round, p1 - v1, 7, true);
          } else {
            this.v.setTripleAt(p0 - v0, p1 + v1, p0 - v0 + cPoint, p1 + v1, p0 - v0, p1 + v1, 2);
            this.v.setTripleAt(p0 - v0, p1 - v1, p0 - v0, p1 - v1 + cPoint, p0 - v0, p1 - v1, 3);
          }
        } else {
          this.v.setTripleAt(p0 + v0, p1 - v1 + round, p0 + v0, p1 - v1 + cPoint, p0 + v0, p1 - v1 + round, 0, true);
          if (round !== 0) {
            this.v.setTripleAt(p0 + v0 - round, p1 - v1, p0 + v0 - round, p1 - v1, p0 + v0 - cPoint, p1 - v1, 1, true);
            this.v.setTripleAt(p0 - v0 + round, p1 - v1, p0 - v0 + cPoint, p1 - v1, p0 - v0 + round, p1 - v1, 2, true);
            this.v.setTripleAt(p0 - v0, p1 - v1 + round, p0 - v0, p1 - v1 + round, p0 - v0, p1 - v1 + cPoint, 3, true);
            this.v.setTripleAt(p0 - v0, p1 + v1 - round, p0 - v0, p1 + v1 - cPoint, p0 - v0, p1 + v1 - round, 4, true);
            this.v.setTripleAt(p0 - v0 + round, p1 + v1, p0 - v0 + round, p1 + v1, p0 - v0 + cPoint, p1 + v1, 5, true);
            this.v.setTripleAt(p0 + v0 - round, p1 + v1, p0 + v0 - cPoint, p1 + v1, p0 + v0 - round, p1 + v1, 6, true);
            this.v.setTripleAt(p0 + v0, p1 + v1 - round, p0 + v0, p1 + v1 - round, p0 + v0, p1 + v1 - cPoint, 7, true);
          } else {
            this.v.setTripleAt(p0 - v0, p1 - v1, p0 - v0 + cPoint, p1 - v1, p0 - v0, p1 - v1, 1, true);
            this.v.setTripleAt(p0 - v0, p1 + v1, p0 - v0, p1 + v1 - cPoint, p0 - v0, p1 + v1, 2, true);
            this.v.setTripleAt(p0 + v0, p1 + v1, p0 + v0 - cPoint, p1 + v1, p0 + v0, p1 + v1, 3, true);
          }
        }
      },
      getValue: function () {
        if (this.elem.globalData.frameId === this.frameId) {
          return;
        }
        this.frameId = this.elem.globalData.frameId;
        this.iterateDynamicProperties();
        if (this._mdf) {
          this.convertRectToPath();
        }
      },
      reset: resetShape,
    };
    extendPrototype([DynamicPropertyContainer], RectShapePropertyFactory);

    return RectShapePropertyFactory;
  }());

  function getShapeProp(elem, data, type) {
    var prop;
    if (type === 3 || type === 4) {
      var dataProp = type === 3 ? data.pt : data.ks;
      var keys = dataProp.k;
      if (keys.length) {
        prop = new KeyframedShapeProperty(elem, data, type);
      } else {
        prop = new ShapeProperty(elem, data, type);
      }
    } else if (type === 5) {
      prop = new RectShapeProperty(elem, data);
    } else if (type === 6) {
      prop = new EllShapeProperty(elem, data);
    } else if (type === 7) {
      prop = new StarShapeProperty(elem, data);
    }
    if (prop.k) {
      elem.addDynamicProperty(prop);
    }
    return prop;
  }

  function getConstructorFunction() {
    return ShapeProperty;
  }

  function getKeyframedConstructorFunction() {
    return KeyframedShapeProperty;
  }

  var ob = {};
  ob.getShapeProp = getShapeProp;
  ob.getConstructorFunction = getConstructorFunction;
  ob.getKeyframedConstructorFunction = getKeyframedConstructorFunction;
  return ob;
}());

/* global shapeCollectionPool, initialDefaultFrame, extendPrototype, DynamicPropertyContainer */
/* exported ShapeModifiers */

var ShapeModifiers = (function () {
  var ob = {};
  var modifiers = {};
  ob.registerModifier = registerModifier;
  ob.getModifier = getModifier;

  function registerModifier(nm, factory) {
    if (!modifiers[nm]) {
      modifiers[nm] = factory;
    }
  }

  function getModifier(nm, elem, data) {
    return new modifiers[nm](elem, data);
  }

  return ob;
}());

function ShapeModifier() {}
ShapeModifier.prototype.initModifierProperties = function () {};
ShapeModifier.prototype.addShapeToModifier = function () {};
ShapeModifier.prototype.addShape = function (data) {
  if (!this.closed) {
    // Adding shape to dynamic properties. It covers the case where a shape has no effects applied, to reset it's _mdf state on every tick.
    data.sh.container.addDynamicProperty(data.sh);
    var shapeData = { shape: data.sh, data: data, localShapeCollection: shapeCollectionPool.newShapeCollection() };
    this.shapes.push(shapeData);
    this.addShapeToModifier(shapeData);
    if (this._isAnimated) {
      data.setAsAnimated();
    }
  }
};
ShapeModifier.prototype.init = function (elem, data) {
  this.shapes = [];
  this.elem = elem;
  this.initDynamicPropertyContainer(elem);
  this.initModifierProperties(elem, data);
  this.frameId = initialDefaultFrame;
  this.closed = false;
  this.k = false;
  if (this.dynamicProperties.length) {
    this.k = true;
  } else {
    this.getValue(true);
  }
};
ShapeModifier.prototype.processKeys = function () {
  if (this.elem.globalData.frameId === this.frameId) {
    return;
  }
  this.frameId = this.elem.globalData.frameId;
  this.iterateDynamicProperties();
};

extendPrototype([DynamicPropertyContainer], ShapeModifier);

/* global extendPrototype, ShapeModifier, PropertyFactory, segmentsLengthPool, bez, shapePool, ShapeModifiers */

function TrimModifier() {
}
extendPrototype([ShapeModifier], TrimModifier);
TrimModifier.prototype.initModifierProperties = function (elem, data) {
  this.s = PropertyFactory.getProp(elem, data.s, 0, 0.01, this);
  this.e = PropertyFactory.getProp(elem, data.e, 0, 0.01, this);
  this.o = PropertyFactory.getProp(elem, data.o, 0, 0, this);
  this.sValue = 0;
  this.eValue = 0;
  this.getValue = this.processKeys;
  this.m = data.m;
  this._isAnimated = !!this.s.effectsSequence.length || !!this.e.effectsSequence.length || !!this.o.effectsSequence.length;
};

TrimModifier.prototype.addShapeToModifier = function (shapeData) {
  shapeData.pathsData = [];
};

TrimModifier.prototype.calculateShapeEdges = function (s, e, shapeLength, addedLength, totalModifierLength) {
  var segments = [];
  if (e <= 1) {
    segments.push({
      s: s,
      e: e,
    });
  } else if (s >= 1) {
    segments.push({
      s: s - 1,
      e: e - 1,
    });
  } else {
    segments.push({
      s: s,
      e: 1,
    });
    segments.push({
      s: 0,
      e: e - 1,
    });
  }
  var shapeSegments = [];
  var i;
  var len = segments.length;
  var segmentOb;
  for (i = 0; i < len; i += 1) {
    segmentOb = segments[i];
    if (!(segmentOb.e * totalModifierLength < addedLength || segmentOb.s * totalModifierLength > addedLength + shapeLength)) {
      var shapeS;
      var shapeE;
      if (segmentOb.s * totalModifierLength <= addedLength) {
        shapeS = 0;
      } else {
        shapeS = (segmentOb.s * totalModifierLength - addedLength) / shapeLength;
      }
      if (segmentOb.e * totalModifierLength >= addedLength + shapeLength) {
        shapeE = 1;
      } else {
        shapeE = ((segmentOb.e * totalModifierLength - addedLength) / shapeLength);
      }
      shapeSegments.push([shapeS, shapeE]);
    }
  }
  if (!shapeSegments.length) {
    shapeSegments.push([0, 0]);
  }
  return shapeSegments;
};

TrimModifier.prototype.releasePathsData = function (pathsData) {
  var i;
  var len = pathsData.length;
  for (i = 0; i < len; i += 1) {
    segmentsLengthPool.release(pathsData[i]);
  }
  pathsData.length = 0;
  return pathsData;
};

TrimModifier.prototype.processShapes = function (_isFirstFrame) {
  var s;
  var e;
  if (this._mdf || _isFirstFrame) {
    var o = (this.o.v % 360) / 360;
    if (o < 0) {
      o += 1;
    }
    if (this.s.v > 1) {
      s = 1 + o;
    } else if (this.s.v < 0) {
      s = 0 + o;
    } else {
      s = this.s.v + o;
    }
    if (this.e.v > 1) {
      e = 1 + o;
    } else if (this.e.v < 0) {
      e = 0 + o;
    } else {
      e = this.e.v + o;
    }

    if (s > e) {
      var _s = s;
      s = e;
      e = _s;
    }
    s = Math.round(s * 10000) * 0.0001;
    e = Math.round(e * 10000) * 0.0001;
    this.sValue = s;
    this.eValue = e;
  } else {
    s = this.sValue;
    e = this.eValue;
  }
  var shapePaths;
  var i;
  var len = this.shapes.length;
  var j;
  var jLen;
  var pathsData;
  var pathData;
  var totalShapeLength;
  var totalModifierLength = 0;

  if (e === s) {
    for (i = 0; i < len; i += 1) {
      this.shapes[i].localShapeCollection.releaseShapes();
      this.shapes[i].shape._mdf = true;
      this.shapes[i].shape.paths = this.shapes[i].localShapeCollection;
      if (this._mdf) {
        this.shapes[i].pathsData.length = 0;
      }
    }
  } else if (!((e === 1 && s === 0) || (e === 0 && s === 1))) {
    var segments = [];
    var shapeData;
    var localShapeCollection;
    for (i = 0; i < len; i += 1) {
      shapeData = this.shapes[i];
      // if shape hasn't changed and trim properties haven't changed, cached previous path can be used
      if (!shapeData.shape._mdf && !this._mdf && !_isFirstFrame && this.m !== 2) {
        shapeData.shape.paths = shapeData.localShapeCollection;
      } else {
        shapePaths = shapeData.shape.paths;
        jLen = shapePaths._length;
        totalShapeLength = 0;
        if (!shapeData.shape._mdf && shapeData.pathsData.length) {
          totalShapeLength = shapeData.totalShapeLength;
        } else {
          pathsData = this.releasePathsData(shapeData.pathsData);
          for (j = 0; j < jLen; j += 1) {
            pathData = bez.getSegmentsLength(shapePaths.shapes[j]);
            pathsData.push(pathData);
            totalShapeLength += pathData.totalLength;
          }
          shapeData.totalShapeLength = totalShapeLength;
          shapeData.pathsData = pathsData;
        }

        totalModifierLength += totalShapeLength;
        shapeData.shape._mdf = true;
      }
    }
    var shapeS = s;
    var shapeE = e;
    var addedLength = 0;
    var edges;
    for (i = len - 1; i >= 0; i -= 1) {
      shapeData = this.shapes[i];
      if (shapeData.shape._mdf) {
        localShapeCollection = shapeData.localShapeCollection;
        localShapeCollection.releaseShapes();
        // if m === 2 means paths are trimmed individually so edges need to be found for this specific shape relative to whoel group
        if (this.m === 2 && len > 1) {
          edges = this.calculateShapeEdges(s, e, shapeData.totalShapeLength, addedLength, totalModifierLength);
          addedLength += shapeData.totalShapeLength;
        } else {
          edges = [[shapeS, shapeE]];
        }
        jLen = edges.length;
        for (j = 0; j < jLen; j += 1) {
          shapeS = edges[j][0];
          shapeE = edges[j][1];
          segments.length = 0;
          if (shapeE <= 1) {
            segments.push({
              s: shapeData.totalShapeLength * shapeS,
              e: shapeData.totalShapeLength * shapeE,
            });
          } else if (shapeS >= 1) {
            segments.push({
              s: shapeData.totalShapeLength * (shapeS - 1),
              e: shapeData.totalShapeLength * (shapeE - 1),
            });
          } else {
            segments.push({
              s: shapeData.totalShapeLength * shapeS,
              e: shapeData.totalShapeLength,
            });
            segments.push({
              s: 0,
              e: shapeData.totalShapeLength * (shapeE - 1),
            });
          }
          var newShapesData = this.addShapes(shapeData, segments[0]);
          if (segments[0].s !== segments[0].e) {
            if (segments.length > 1) {
              var lastShapeInCollection = shapeData.shape.paths.shapes[shapeData.shape.paths._length - 1];
              if (lastShapeInCollection.c) {
                var lastShape = newShapesData.pop();
                this.addPaths(newShapesData, localShapeCollection);
                newShapesData = this.addShapes(shapeData, segments[1], lastShape);
              } else {
                this.addPaths(newShapesData, localShapeCollection);
                newShapesData = this.addShapes(shapeData, segments[1]);
              }
            }
            this.addPaths(newShapesData, localShapeCollection);
          }
        }
        shapeData.shape.paths = localShapeCollection;
      }
    }
  } else if (this._mdf) {
    for (i = 0; i < len; i += 1) {
      // Releasign Trim Cached paths data when no trim applied in case shapes are modified inbetween.
      // Don't remove this even if it's losing cached info.
      this.shapes[i].pathsData.length = 0;
      this.shapes[i].shape._mdf = true;
    }
  }
};

TrimModifier.prototype.addPaths = function (newPaths, localShapeCollection) {
  var i;
  var len = newPaths.length;
  for (i = 0; i < len; i += 1) {
    localShapeCollection.addShape(newPaths[i]);
  }
};

TrimModifier.prototype.addSegment = function (pt1, pt2, pt3, pt4, shapePath, pos, newShape) {
  shapePath.setXYAt(pt2[0], pt2[1], 'o', pos);
  shapePath.setXYAt(pt3[0], pt3[1], 'i', pos + 1);
  if (newShape) {
    shapePath.setXYAt(pt1[0], pt1[1], 'v', pos);
  }
  shapePath.setXYAt(pt4[0], pt4[1], 'v', pos + 1);
};

TrimModifier.prototype.addSegmentFromArray = function (points, shapePath, pos, newShape) {
  shapePath.setXYAt(points[1], points[5], 'o', pos);
  shapePath.setXYAt(points[2], points[6], 'i', pos + 1);
  if (newShape) {
    shapePath.setXYAt(points[0], points[4], 'v', pos);
  }
  shapePath.setXYAt(points[3], points[7], 'v', pos + 1);
};

TrimModifier.prototype.addShapes = function (shapeData, shapeSegment, shapePath) {
  var pathsData = shapeData.pathsData;
  var shapePaths = shapeData.shape.paths.shapes;
  var i;
  var len = shapeData.shape.paths._length;
  var j;
  var jLen;
  var addedLength = 0;
  var currentLengthData;
  var segmentCount;
  var lengths;
  var segment;
  var shapes = [];
  var initPos;
  var newShape = true;
  if (!shapePath) {
    shapePath = shapePool.newElement();
    segmentCount = 0;
    initPos = 0;
  } else {
    segmentCount = shapePath._length;
    initPos = shapePath._length;
  }
  shapes.push(shapePath);
  for (i = 0; i < len; i += 1) {
    lengths = pathsData[i].lengths;
    shapePath.c = shapePaths[i].c;
    jLen = shapePaths[i].c ? lengths.length : lengths.length + 1;
    for (j = 1; j < jLen; j += 1) {
      currentLengthData = lengths[j - 1];
      if (addedLength + currentLengthData.addedLength < shapeSegment.s) {
        addedLength += currentLengthData.addedLength;
        shapePath.c = false;
      } else if (addedLength > shapeSegment.e) {
        shapePath.c = false;
        break;
      } else {
        if (shapeSegment.s <= addedLength && shapeSegment.e >= addedLength + currentLengthData.addedLength) {
          this.addSegment(shapePaths[i].v[j - 1], shapePaths[i].o[j - 1], shapePaths[i].i[j], shapePaths[i].v[j], shapePath, segmentCount, newShape);
          newShape = false;
        } else {
          segment = bez.getNewSegment(shapePaths[i].v[j - 1], shapePaths[i].v[j], shapePaths[i].o[j - 1], shapePaths[i].i[j], (shapeSegment.s - addedLength) / currentLengthData.addedLength, (shapeSegment.e - addedLength) / currentLengthData.addedLength, lengths[j - 1]);
          this.addSegmentFromArray(segment, shapePath, segmentCount, newShape);
          // this.addSegment(segment.pt1, segment.pt3, segment.pt4, segment.pt2, shapePath, segmentCount, newShape);
          newShape = false;
          shapePath.c = false;
        }
        addedLength += currentLengthData.addedLength;
        segmentCount += 1;
      }
    }
    if (shapePaths[i].c && lengths.length) {
      currentLengthData = lengths[j - 1];
      if (addedLength <= shapeSegment.e) {
        var segmentLength = lengths[j - 1].addedLength;
        if (shapeSegment.s <= addedLength && shapeSegment.e >= addedLength + segmentLength) {
          this.addSegment(shapePaths[i].v[j - 1], shapePaths[i].o[j - 1], shapePaths[i].i[0], shapePaths[i].v[0], shapePath, segmentCount, newShape);
          newShape = false;
        } else {
          segment = bez.getNewSegment(shapePaths[i].v[j - 1], shapePaths[i].v[0], shapePaths[i].o[j - 1], shapePaths[i].i[0], (shapeSegment.s - addedLength) / segmentLength, (shapeSegment.e - addedLength) / segmentLength, lengths[j - 1]);
          this.addSegmentFromArray(segment, shapePath, segmentCount, newShape);
          // this.addSegment(segment.pt1, segment.pt3, segment.pt4, segment.pt2, shapePath, segmentCount, newShape);
          newShape = false;
          shapePath.c = false;
        }
      } else {
        shapePath.c = false;
      }
      addedLength += currentLengthData.addedLength;
      segmentCount += 1;
    }
    if (shapePath._length) {
      shapePath.setXYAt(shapePath.v[initPos][0], shapePath.v[initPos][1], 'i', initPos);
      shapePath.setXYAt(shapePath.v[shapePath._length - 1][0], shapePath.v[shapePath._length - 1][1], 'o', shapePath._length - 1);
    }
    if (addedLength > shapeSegment.e) {
      break;
    }
    if (i < len - 1) {
      shapePath = shapePool.newElement();
      newShape = true;
      shapes.push(shapePath);
      segmentCount = 0;
    }
  }
  return shapes;
};

ShapeModifiers.registerModifier('tm', TrimModifier);

/* global extendPrototype, ShapeModifier, PropertyFactory, shapePool, roundCorner, ShapeModifiers */

function RoundCornersModifier() {}
extendPrototype([ShapeModifier], RoundCornersModifier);
RoundCornersModifier.prototype.initModifierProperties = function (elem, data) {
  this.getValue = this.processKeys;
  this.rd = PropertyFactory.getProp(elem, data.r, 0, null, this);
  this._isAnimated = !!this.rd.effectsSequence.length;
};

RoundCornersModifier.prototype.processPath = function (path, round) {
  var clonedPath = shapePool.newElement();
  clonedPath.c = path.c;
  var i;
  var len = path._length;
  var currentV;
  var currentI;
  var currentO;
  var closerV;
  var distance;
  var newPosPerc;
  var index = 0;
  var vX;
  var vY;
  var oX;
  var oY;
  var iX;
  var iY;
  for (i = 0; i < len; i += 1) {
    currentV = path.v[i];
    currentO = path.o[i];
    currentI = path.i[i];
    if (currentV[0] === currentO[0] && currentV[1] === currentO[1] && currentV[0] === currentI[0] && currentV[1] === currentI[1]) {
      if ((i === 0 || i === len - 1) && !path.c) {
        clonedPath.setTripleAt(currentV[0], currentV[1], currentO[0], currentO[1], currentI[0], currentI[1], index);
        /* clonedPath.v[index] = currentV;
                clonedPath.o[index] = currentO;
                clonedPath.i[index] = currentI; */
        index += 1;
      } else {
        if (i === 0) {
          closerV = path.v[len - 1];
        } else {
          closerV = path.v[i - 1];
        }
        distance = Math.sqrt(Math.pow(currentV[0] - closerV[0], 2) + Math.pow(currentV[1] - closerV[1], 2));
        newPosPerc = distance ? Math.min(distance / 2, round) / distance : 0;
        iX = currentV[0] + (closerV[0] - currentV[0]) * newPosPerc;
        vX = iX;
        iY = currentV[1] - (currentV[1] - closerV[1]) * newPosPerc;
        vY = iY;
        oX = vX - (vX - currentV[0]) * roundCorner;
        oY = vY - (vY - currentV[1]) * roundCorner;
        clonedPath.setTripleAt(vX, vY, oX, oY, iX, iY, index);
        index += 1;

        if (i === len - 1) {
          closerV = path.v[0];
        } else {
          closerV = path.v[i + 1];
        }
        distance = Math.sqrt(Math.pow(currentV[0] - closerV[0], 2) + Math.pow(currentV[1] - closerV[1], 2));
        newPosPerc = distance ? Math.min(distance / 2, round) / distance : 0;
        oX = currentV[0] + (closerV[0] - currentV[0]) * newPosPerc;
        vX = oX;
        oY = currentV[1] + (closerV[1] - currentV[1]) * newPosPerc;
        vY = oY;
        iX = vX - (vX - currentV[0]) * roundCorner;
        iY = vY - (vY - currentV[1]) * roundCorner;
        clonedPath.setTripleAt(vX, vY, oX, oY, iX, iY, index);
        index += 1;
      }
    } else {
      clonedPath.setTripleAt(path.v[i][0], path.v[i][1], path.o[i][0], path.o[i][1], path.i[i][0], path.i[i][1], index);
      index += 1;
    }
  }
  return clonedPath;
};

RoundCornersModifier.prototype.processShapes = function (_isFirstFrame) {
  var shapePaths;
  var i;
  var len = this.shapes.length;
  var j;
  var jLen;
  var rd = this.rd.v;

  if (rd !== 0) {
    var shapeData;
    var localShapeCollection;
    for (i = 0; i < len; i += 1) {
      shapeData = this.shapes[i];
      localShapeCollection = shapeData.localShapeCollection;
      if (!(!shapeData.shape._mdf && !this._mdf && !_isFirstFrame)) {
        localShapeCollection.releaseShapes();
        shapeData.shape._mdf = true;
        shapePaths = shapeData.shape.paths.shapes;
        jLen = shapeData.shape.paths._length;
        for (j = 0; j < jLen; j += 1) {
          localShapeCollection.addShape(this.processPath(shapePaths[j], rd));
        }
      }
      shapeData.shape.paths = shapeData.localShapeCollection;
    }
  }
  if (!this.dynamicProperties.length) {
    this._mdf = false;
  }
};

ShapeModifiers.registerModifier('rd', RoundCornersModifier);

/* global extendPrototype, ShapeModifier, PropertyFactory, shapePool, ShapeModifiers */

function PuckerAndBloatModifier() {}
extendPrototype([ShapeModifier], PuckerAndBloatModifier);
PuckerAndBloatModifier.prototype.initModifierProperties = function (elem, data) {
  this.getValue = this.processKeys;
  this.amount = PropertyFactory.getProp(elem, data.a, 0, null, this);
  this._isAnimated = !!this.amount.effectsSequence.length;
};

PuckerAndBloatModifier.prototype.processPath = function (path, amount) {
  var percent = amount / 100;
  var centerPoint = [0, 0];
  var pathLength = path._length;
  var i = 0;
  for (i = 0; i < pathLength; i += 1) {
    centerPoint[0] += path.v[i][0];
    centerPoint[1] += path.v[i][1];
  }
  centerPoint[0] /= pathLength;
  centerPoint[1] /= pathLength;
  var clonedPath = shapePool.newElement();
  clonedPath.c = path.c;
  var vX;
  var vY;
  var oX;
  var oY;
  var iX;
  var iY;
  for (i = 0; i < pathLength; i += 1) {
    vX = path.v[i][0] + (centerPoint[0] - path.v[i][0]) * percent;
    vY = path.v[i][1] + (centerPoint[1] - path.v[i][1]) * percent;
    oX = path.o[i][0] + (centerPoint[0] - path.o[i][0]) * -percent;
    oY = path.o[i][1] + (centerPoint[1] - path.o[i][1]) * -percent;
    iX = path.i[i][0] + (centerPoint[0] - path.i[i][0]) * -percent;
    iY = path.i[i][1] + (centerPoint[1] - path.i[i][1]) * -percent;
    clonedPath.setTripleAt(vX, vY, oX, oY, iX, iY, i);
  }
  return clonedPath;
};

PuckerAndBloatModifier.prototype.processShapes = function (_isFirstFrame) {
  var shapePaths;
  var i;
  var len = this.shapes.length;
  var j;
  var jLen;
  var amount = this.amount.v;

  if (amount !== 0) {
    var shapeData;
    var localShapeCollection;
    for (i = 0; i < len; i += 1) {
      shapeData = this.shapes[i];
      localShapeCollection = shapeData.localShapeCollection;
      if (!(!shapeData.shape._mdf && !this._mdf && !_isFirstFrame)) {
        localShapeCollection.releaseShapes();
        shapeData.shape._mdf = true;
        shapePaths = shapeData.shape.paths.shapes;
        jLen = shapeData.shape.paths._length;
        for (j = 0; j < jLen; j += 1) {
          localShapeCollection.addShape(this.processPath(shapePaths[j], amount));
        }
      }
      shapeData.shape.paths = shapeData.localShapeCollection;
    }
  }
  if (!this.dynamicProperties.length) {
    this._mdf = false;
  }
};
ShapeModifiers.registerModifier('pb', PuckerAndBloatModifier);

/* global extendPrototype, ShapeModifier, TransformPropertyFactory, PropertyFactory, Matrix, ShapeModifiers */

function RepeaterModifier() {}
extendPrototype([ShapeModifier], RepeaterModifier);

RepeaterModifier.prototype.initModifierProperties = function (elem, data) {
  this.getValue = this.processKeys;
  this.c = PropertyFactory.getProp(elem, data.c, 0, null, this);
  this.o = PropertyFactory.getProp(elem, data.o, 0, null, this);
  this.tr = TransformPropertyFactory.getTransformProperty(elem, data.tr, this);
  this.so = PropertyFactory.getProp(elem, data.tr.so, 0, 0.01, this);
  this.eo = PropertyFactory.getProp(elem, data.tr.eo, 0, 0.01, this);
  this.data = data;
  if (!this.dynamicProperties.length) {
    this.getValue(true);
  }
  this._isAnimated = !!this.dynamicProperties.length;
  this.pMatrix = new Matrix();
  this.rMatrix = new Matrix();
  this.sMatrix = new Matrix();
  this.tMatrix = new Matrix();
  this.matrix = new Matrix();
};

RepeaterModifier.prototype.applyTransforms = function (pMatrix, rMatrix, sMatrix, transform, perc, inv) {
  var dir = inv ? -1 : 1;
  var scaleX = transform.s.v[0] + (1 - transform.s.v[0]) * (1 - perc);
  var scaleY = transform.s.v[1] + (1 - transform.s.v[1]) * (1 - perc);
  pMatrix.translate(transform.p.v[0] * dir * perc, transform.p.v[1] * dir * perc, transform.p.v[2]);
  rMatrix.translate(-transform.a.v[0], -transform.a.v[1], transform.a.v[2]);
  rMatrix.rotate(-transform.r.v * dir * perc);
  rMatrix.translate(transform.a.v[0], transform.a.v[1], transform.a.v[2]);
  sMatrix.translate(-transform.a.v[0], -transform.a.v[1], transform.a.v[2]);
  sMatrix.scale(inv ? 1 / scaleX : scaleX, inv ? 1 / scaleY : scaleY);
  sMatrix.translate(transform.a.v[0], transform.a.v[1], transform.a.v[2]);
};

RepeaterModifier.prototype.init = function (elem, arr, pos, elemsData) {
  this.elem = elem;
  this.arr = arr;
  this.pos = pos;
  this.elemsData = elemsData;
  this._currentCopies = 0;
  this._elements = [];
  this._groups = [];
  this.frameId = -1;
  this.initDynamicPropertyContainer(elem);
  this.initModifierProperties(elem, arr[pos]);
  while (pos > 0) {
    pos -= 1;
    // this._elements.unshift(arr.splice(pos,1)[0]);
    this._elements.unshift(arr[pos]);
  }
  if (this.dynamicProperties.length) {
    this.k = true;
  } else {
    this.getValue(true);
  }
};

RepeaterModifier.prototype.resetElements = function (elements) {
  var i;
  var len = elements.length;
  for (i = 0; i < len; i += 1) {
    elements[i]._processed = false;
    if (elements[i].ty === 'gr') {
      this.resetElements(elements[i].it);
    }
  }
};

RepeaterModifier.prototype.cloneElements = function (elements) {
  var newElements = JSON.parse(JSON.stringify(elements));
  this.resetElements(newElements);
  return newElements;
};

RepeaterModifier.prototype.changeGroupRender = function (elements, renderFlag) {
  var i;
  var len = elements.length;
  for (i = 0; i < len; i += 1) {
    elements[i]._render = renderFlag;
    if (elements[i].ty === 'gr') {
      this.changeGroupRender(elements[i].it, renderFlag);
    }
  }
};

RepeaterModifier.prototype.processShapes = function (_isFirstFrame) {
  var items;
  var itemsTransform;
  var i;
  var dir;
  var cont;
  var hasReloaded = false;
  if (this._mdf || _isFirstFrame) {
    var copies = Math.ceil(this.c.v);
    if (this._groups.length < copies) {
      while (this._groups.length < copies) {
        var group = {
          it: this.cloneElements(this._elements),
          ty: 'gr',
        };
        group.it.push({
          a: { a: 0, ix: 1, k: [0, 0] }, nm: 'Transform', o: { a: 0, ix: 7, k: 100 }, p: { a: 0, ix: 2, k: [0, 0] }, r: { a: 1, ix: 6, k: [{ s: 0, e: 0, t: 0 }, { s: 0, e: 0, t: 1 }] }, s: { a: 0, ix: 3, k: [100, 100] }, sa: { a: 0, ix: 5, k: 0 }, sk: { a: 0, ix: 4, k: 0 }, ty: 'tr',
        });

        this.arr.splice(0, 0, group);
        this._groups.splice(0, 0, group);
        this._currentCopies += 1;
      }
      this.elem.reloadShapes();
      hasReloaded = true;
    }
    cont = 0;
    var renderFlag;
    for (i = 0; i <= this._groups.length - 1; i += 1) {
      renderFlag = cont < copies;
      this._groups[i]._render = renderFlag;
      this.changeGroupRender(this._groups[i].it, renderFlag);
      if (!renderFlag) {
        var elems = this.elemsData[i].it;
        var transformData = elems[elems.length - 1];
        if (transformData.transform.op.v !== 0) {
          transformData.transform.op._mdf = true;
          transformData.transform.op.v = 0;
        } else {
          transformData.transform.op._mdf = false;
        }
      }
      cont += 1;
    }

    this._currentCopies = copies;
    /// /

    var offset = this.o.v;
    var offsetModulo = offset % 1;
    var roundOffset = offset > 0 ? Math.floor(offset) : Math.ceil(offset);
    var pProps = this.pMatrix.props;
    var rProps = this.rMatrix.props;
    var sProps = this.sMatrix.props;
    this.pMatrix.reset();
    this.rMatrix.reset();
    this.sMatrix.reset();
    this.tMatrix.reset();
    this.matrix.reset();
    var iteration = 0;

    if (offset > 0) {
      while (iteration < roundOffset) {
        this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, false);
        iteration += 1;
      }
      if (offsetModulo) {
        this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, offsetModulo, false);
        iteration += offsetModulo;
      }
    } else if (offset < 0) {
      while (iteration > roundOffset) {
        this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, true);
        iteration -= 1;
      }
      if (offsetModulo) {
        this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, -offsetModulo, true);
        iteration -= offsetModulo;
      }
    }
    i = this.data.m === 1 ? 0 : this._currentCopies - 1;
    dir = this.data.m === 1 ? 1 : -1;
    cont = this._currentCopies;
    var j;
    var jLen;
    while (cont) {
      items = this.elemsData[i].it;
      itemsTransform = items[items.length - 1].transform.mProps.v.props;
      jLen = itemsTransform.length;
      items[items.length - 1].transform.mProps._mdf = true;
      items[items.length - 1].transform.op._mdf = true;
      items[items.length - 1].transform.op.v = this._currentCopies === 1
        ? this.so.v
        : this.so.v + (this.eo.v - this.so.v) * (i / (this._currentCopies - 1));

      if (iteration !== 0) {
        if ((i !== 0 && dir === 1) || (i !== this._currentCopies - 1 && dir === -1)) {
          this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, false);
        }
        this.matrix.transform(rProps[0], rProps[1], rProps[2], rProps[3], rProps[4], rProps[5], rProps[6], rProps[7], rProps[8], rProps[9], rProps[10], rProps[11], rProps[12], rProps[13], rProps[14], rProps[15]);
        this.matrix.transform(sProps[0], sProps[1], sProps[2], sProps[3], sProps[4], sProps[5], sProps[6], sProps[7], sProps[8], sProps[9], sProps[10], sProps[11], sProps[12], sProps[13], sProps[14], sProps[15]);
        this.matrix.transform(pProps[0], pProps[1], pProps[2], pProps[3], pProps[4], pProps[5], pProps[6], pProps[7], pProps[8], pProps[9], pProps[10], pProps[11], pProps[12], pProps[13], pProps[14], pProps[15]);

        for (j = 0; j < jLen; j += 1) {
          itemsTransform[j] = this.matrix.props[j];
        }
        this.matrix.reset();
      } else {
        this.matrix.reset();
        for (j = 0; j < jLen; j += 1) {
          itemsTransform[j] = this.matrix.props[j];
        }
      }
      iteration += 1;
      cont -= 1;
      i += dir;
    }
  } else {
    cont = this._currentCopies;
    i = 0;
    dir = 1;
    while (cont) {
      items = this.elemsData[i].it;
      itemsTransform = items[items.length - 1].transform.mProps.v.props;
      items[items.length - 1].transform.mProps._mdf = false;
      items[items.length - 1].transform.op._mdf = false;
      cont -= 1;
      i += dir;
    }
  }
  return hasReloaded;
};

RepeaterModifier.prototype.addShape = function () {};

ShapeModifiers.registerModifier('rp', RepeaterModifier);

/* global createSizedArray, shapePool */

function ShapeCollection() {
  this._length = 0;
  this._maxLength = 4;
  this.shapes = createSizedArray(this._maxLength);
}

ShapeCollection.prototype.addShape = function (shapeData) {
  if (this._length === this._maxLength) {
    this.shapes = this.shapes.concat(createSizedArray(this._maxLength));
    this._maxLength *= 2;
  }
  this.shapes[this._length] = shapeData;
  this._length += 1;
};

ShapeCollection.prototype.releaseShapes = function () {
  var i;
  for (i = 0; i < this._length; i += 1) {
    shapePool.release(this.shapes[i]);
  }
  this._length = 0;
};

/* global createSizedArray, createTypedArray, PropertyFactory, extendPrototype, DynamicPropertyContainer */

function DashProperty(elem, data, renderer, container) {
  this.elem = elem;
  this.frameId = -1;
  this.dataProps = createSizedArray(data.length);
  this.renderer = renderer;
  this.k = false;
  this.dashStr = '';
  this.dashArray = createTypedArray('float32', data.length ? data.length - 1 : 0);
  this.dashoffset = createTypedArray('float32', 1);
  this.initDynamicPropertyContainer(container);
  var i;
  var len = data.length || 0;
  var prop;
  for (i = 0; i < len; i += 1) {
    prop = PropertyFactory.getProp(elem, data[i].v, 0, 0, this);
    this.k = prop.k || this.k;
    this.dataProps[i] = { n: data[i].n, p: prop };
  }
  if (!this.k) {
    this.getValue(true);
  }
  this._isAnimated = this.k;
}

DashProperty.prototype.getValue = function (forceRender) {
  if (this.elem.globalData.frameId === this.frameId && !forceRender) {
    return;
  }
  this.frameId = this.elem.globalData.frameId;
  this.iterateDynamicProperties();
  this._mdf = this._mdf || forceRender;
  if (this._mdf) {
    var i = 0;
    var len = this.dataProps.length;
    if (this.renderer === 'svg') {
      this.dashStr = '';
    }
    for (i = 0; i < len; i += 1) {
      if (this.dataProps[i].n !== 'o') {
        if (this.renderer === 'svg') {
          this.dashStr += ' ' + this.dataProps[i].p.v;
        } else {
          this.dashArray[i] = this.dataProps[i].p.v;
        }
      } else {
        this.dashoffset[0] = this.dataProps[i].p.v;
      }
    }
  }
};
extendPrototype([DynamicPropertyContainer], DashProperty);

/* global createTypedArray, PropertyFactory, extendPrototype, DynamicPropertyContainer */
function GradientProperty(elem, data, container) {
  this.data = data;
  this.c = createTypedArray('uint8c', data.p * 4);
  var cLength = data.k.k[0].s ? (data.k.k[0].s.length - data.p * 4) : data.k.k.length - data.p * 4;
  this.o = createTypedArray('float32', cLength);
  this._cmdf = false;
  this._omdf = false;
  this._collapsable = this.checkCollapsable();
  this._hasOpacity = cLength;
  this.initDynamicPropertyContainer(container);
  this.prop = PropertyFactory.getProp(elem, data.k, 1, null, this);
  this.k = this.prop.k;
  this.getValue(true);
}

GradientProperty.prototype.comparePoints = function (values, points) {
  var i = 0;
  var len = this.o.length / 2;
  var diff;
  while (i < len) {
    diff = Math.abs(values[i * 4] - values[points * 4 + i * 2]);
    if (diff > 0.01) {
      return false;
    }
    i += 1;
  }
  return true;
};

GradientProperty.prototype.checkCollapsable = function () {
  if (this.o.length / 2 !== this.c.length / 4) {
    return false;
  }
  if (this.data.k.k[0].s) {
    var i = 0;
    var len = this.data.k.k.length;
    while (i < len) {
      if (!this.comparePoints(this.data.k.k[i].s, this.data.p)) {
        return false;
      }
      i += 1;
    }
  } else if (!this.comparePoints(this.data.k.k, this.data.p)) {
    return false;
  }
  return true;
};

GradientProperty.prototype.getValue = function (forceRender) {
  this.prop.getValue();
  this._mdf = false;
  this._cmdf = false;
  this._omdf = false;
  if (this.prop._mdf || forceRender) {
    var i;
    var len = this.data.p * 4;
    var mult;
    var val;
    for (i = 0; i < len; i += 1) {
      mult = i % 4 === 0 ? 100 : 255;
      val = Math.round(this.prop.v[i] * mult);
      if (this.c[i] !== val) {
        this.c[i] = val;
        this._cmdf = !forceRender;
      }
    }
    if (this.o.length) {
      len = this.prop.v.length;
      for (i = this.data.p * 4; i < len; i += 1) {
        mult = i % 2 === 0 ? 100 : 1;
        val = i % 2 === 0 ? Math.round(this.prop.v[i] * 100) : this.prop.v[i];
        if (this.o[i - this.data.p * 4] !== val) {
          this.o[i - this.data.p * 4] = val;
          this._omdf = !forceRender;
        }
      }
    }
    this._mdf = !forceRender;
  }
};

extendPrototype([DynamicPropertyContainer], GradientProperty);

/* exported buildShapeString */

var buildShapeString = function (pathNodes, length, closed, mat) {
  if (length === 0) {
    return '';
  }
  var _o = pathNodes.o;
  var _i = pathNodes.i;
  var _v = pathNodes.v;
  var i;
  var shapeString = ' M' + mat.applyToPointStringified(_v[0][0], _v[0][1]);
  for (i = 1; i < length; i += 1) {
    shapeString += ' C' + mat.applyToPointStringified(_o[i - 1][0], _o[i - 1][1]) + ' ' + mat.applyToPointStringified(_i[i][0], _i[i][1]) + ' ' + mat.applyToPointStringified(_v[i][0], _v[i][1]);
  }
  if (closed && length) {
    shapeString += ' C' + mat.applyToPointStringified(_o[i - 1][0], _o[i - 1][1]) + ' ' + mat.applyToPointStringified(_i[0][0], _i[0][1]) + ' ' + mat.applyToPointStringified(_v[0][0], _v[0][1]);
    shapeString += 'z';
  }
  return shapeString;
};

/* global Howl */
/* exported audioControllerFactory */

var audioControllerFactory = (function () {
  function AudioController(audioFactory) {
    this.audios = [];
    this.audioFactory = audioFactory;
    this._volume = 1;
    this._isMuted = false;
  }

  AudioController.prototype = {
    addAudio: function (audio) {
      this.audios.push(audio);
    },
    pause: function () {
      var i;
      var len = this.audios.length;
      for (i = 0; i < len; i += 1) {
        this.audios[i].pause();
      }
    },
    resume: function () {
      var i;
      var len = this.audios.length;
      for (i = 0; i < len; i += 1) {
        this.audios[i].resume();
      }
    },
    setRate: function (rateValue) {
      var i;
      var len = this.audios.length;
      for (i = 0; i < len; i += 1) {
        this.audios[i].setRate(rateValue);
      }
    },
    createAudio: function (assetPath) {
      if (this.audioFactory) {
        return this.audioFactory(assetPath);
      } if (Howl) {
        return new Howl({
          src: [assetPath],
        });
      }
      return {
        isPlaying: false,
        play: function () { this.isPlaying = true; },
        seek: function () { this.isPlaying = false; },
        playing: function () {},
        rate: function () {},
        setVolume: function () {},
      };
    },
    setAudioFactory: function (audioFactory) {
      this.audioFactory = audioFactory;
    },
    setVolume: function (value) {
      this._volume = value;
      this._updateVolume();
    },
    mute: function () {
      this._isMuted = true;
      this._updateVolume();
    },
    unmute: function () {
      this._isMuted = false;
      this._updateVolume();
    },
    getVolume: function () {
      return this._volume;
    },
    _updateVolume: function () {
      var i;
      var len = this.audios.length;
      for (i = 0; i < len; i += 1) {
        this.audios[i].volume(this._volume * (this._isMuted ? 0 : 1));
      }
    },
  };

  return function () {
    return new AudioController();
  };
}());

/* global createTag, createNS, isSafari, assetLoader */
/* exported ImagePreloader */

var ImagePreloader = (function () {
  var proxyImage = (function () {
    var canvas = createTag('canvas');
    canvas.width = 1;
    canvas.height = 1;
    var ctx = canvas.getContext('2d');
    ctx.fillStyle = 'rgba(0,0,0,0)';
    ctx.fillRect(0, 0, 1, 1);
    return canvas;
  }());

  function imageLoaded() {
    this.loadedAssets += 1;
    if (this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages) {
      if (this.imagesLoadedCb) {
        this.imagesLoadedCb(null);
      }
    }
  }
  function footageLoaded() {
    this.loadedFootagesCount += 1;
    if (this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages) {
      if (this.imagesLoadedCb) {
        this.imagesLoadedCb(null);
      }
    }
  }

  function getAssetsPath(assetData, assetsPath, originalPath) {
    var path = '';
    if (assetData.e) {
      path = assetData.p;
    } else if (assetsPath) {
      var imagePath = assetData.p;
      if (imagePath.indexOf('images/') !== -1) {
        imagePath = imagePath.split('/')[1];
      }
      path = assetsPath + imagePath;
    } else {
      path = originalPath;
      path += assetData.u ? assetData.u : '';
      path += assetData.p;
    }
    return path;
  }

  function testImageLoaded(img) {
    var _count = 0;
    var intervalId = setInterval(function () {
      var box = img.getBBox();
      if (box.width || _count > 500) {
        this._imageLoaded();
        clearInterval(intervalId);
      }
      _count += 1;
    }.bind(this), 50);
  }

  function createImageData(assetData) {
    var path = getAssetsPath(assetData, this.assetsPath, this.path);
    var img = createNS('image');
    if (isSafari) {
      this.testImageLoaded(img);
    } else {
      img.addEventListener('load', this._imageLoaded, false);
    }
    img.addEventListener('error', function () {
      ob.img = proxyImage;
      this._imageLoaded();
    }.bind(this), false);
    img.setAttributeNS('http://www.w3.org/1999/xlink', 'href', path);
    if (this._elementHelper.append) {
      this._elementHelper.append(img);
    } else {
      this._elementHelper.appendChild(img);
    }
    var ob = {
      img: img,
      assetData: assetData,
    };
    return ob;
  }

  function createImgData(assetData) {
    var path = getAssetsPath(assetData, this.assetsPath, this.path);
    var img = createTag('img');
    img.crossOrigin = 'anonymous';
    img.addEventListener('load', this._imageLoaded, false);
    img.addEventListener('error', function () {
      ob.img = proxyImage;
      this._imageLoaded();
    }.bind(this), false);
    img.src = path;
    var ob = {
      img: img,
      assetData: assetData,
    };
    return ob;
  }

  function createFootageData(data) {
    var ob = {
      assetData: data,
    };
    var path = getAssetsPath(data, this.assetsPath, this.path);
    assetLoader.load(path, function (footageData) {
      ob.img = footageData;
      this._footageLoaded();
    }.bind(this), function () {
      ob.img = {};
      this._footageLoaded();
    }.bind(this));
    return ob;
  }

  function loadAssets(assets, cb) {
    this.imagesLoadedCb = cb;
    var i;
    var len = assets.length;
    for (i = 0; i < len; i += 1) {
      if (!assets[i].layers) {
        if (!assets[i].t || assets[i].t === 'seq') {
          this.totalImages += 1;
          this.images.push(this._createImageData(assets[i]));
        } else if (assets[i].t === 3) {
          this.totalFootages += 1;
          this.images.push(this.createFootageData(assets[i]));
        }
      }
    }
  }

  function setPath(path) {
    this.path = path || '';
  }

  function setAssetsPath(path) {
    this.assetsPath = path || '';
  }

  function getAsset(assetData) {
    var i = 0;
    var len = this.images.length;
    while (i < len) {
      if (this.images[i].assetData === assetData) {
        return this.images[i].img;
      }
      i += 1;
    }
    return null;
  }

  function destroy() {
    this.imagesLoadedCb = null;
    this.images.length = 0;
  }

  function loadedImages() {
    return this.totalImages === this.loadedAssets;
  }

  function loadedFootages() {
    return this.totalFootages === this.loadedFootagesCount;
  }

  function setCacheType(type, elementHelper) {
    if (type === 'svg') {
      this._elementHelper = elementHelper;
      this._createImageData = this.createImageData.bind(this);
    } else {
      this._createImageData = this.createImgData.bind(this);
    }
  }

  function ImagePreloaderFactory() {
    this._imageLoaded = imageLoaded.bind(this);
    this._footageLoaded = footageLoaded.bind(this);
    this.testImageLoaded = testImageLoaded.bind(this);
    this.createFootageData = createFootageData.bind(this);
    this.assetsPath = '';
    this.path = '';
    this.totalImages = 0;
    this.totalFootages = 0;
    this.loadedAssets = 0;
    this.loadedFootagesCount = 0;
    this.imagesLoadedCb = null;
    this.images = [];
  }

  ImagePreloaderFactory.prototype = {
    loadAssets: loadAssets,
    setAssetsPath: setAssetsPath,
    setPath: setPath,
    loadedImages: loadedImages,
    loadedFootages: loadedFootages,
    destroy: destroy,
    getAsset: getAsset,
    createImgData: createImgData,
    createImageData: createImageData,
    imageLoaded: imageLoaded,
    footageLoaded: footageLoaded,
    setCacheType: setCacheType,
  };

  return ImagePreloaderFactory;
}());

/* exported featureSupport */

var featureSupport = (function () {
  var ob = {
    maskType: true,
  };
  if (/MSIE 10/i.test(navigator.userAgent) || /MSIE 9/i.test(navigator.userAgent) || /rv:11.0/i.test(navigator.userAgent) || /Edge\/\d./i.test(navigator.userAgent)) {
    ob.maskType = false;
  }
  return ob;
}());

/* global createNS */
/* exported filtersFactory */

var filtersFactory = (function () {
  var ob = {};
  ob.createFilter = createFilter;
  ob.createAlphaToLuminanceFilter = createAlphaToLuminanceFilter;

  function createFilter(filId, skipCoordinates) {
    var fil = createNS('filter');
    fil.setAttribute('id', filId);
    if (skipCoordinates !== true) {
      fil.setAttribute('filterUnits', 'objectBoundingBox');
      fil.setAttribute('x', '0%');
      fil.setAttribute('y', '0%');
      fil.setAttribute('width', '100%');
      fil.setAttribute('height', '100%');
    }
    return fil;
  }

  function createAlphaToLuminanceFilter() {
    var feColorMatrix = createNS('feColorMatrix');
    feColorMatrix.setAttribute('type', 'matrix');
    feColorMatrix.setAttribute('color-interpolation-filters', 'sRGB');
    feColorMatrix.setAttribute('values', '0 0 0 1 0  0 0 0 1 0  0 0 0 1 0  0 0 0 1 1');
    return feColorMatrix;
  }

  return ob;
}());

/* exported assetLoader */

var assetLoader = (function () {
  function formatResponse(xhr) {
    if (xhr.response && typeof xhr.response === 'object') {
      return xhr.response;
    } if (xhr.response && typeof xhr.response === 'string') {
      return JSON.parse(xhr.response);
    } if (xhr.responseText) {
      return JSON.parse(xhr.responseText);
    }
    return null;
  }

  function loadAsset(path, callback, errorCallback) {
    var response;
    var xhr = new XMLHttpRequest();
    // set responseType after calling open or IE will break.
    try {
      // This crashes on Android WebView prior to KitKat
      xhr.responseType = 'json';
    } catch (err) {} // eslint-disable-line no-empty
    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4) {
        if (xhr.status === 200) {
          response = formatResponse(xhr);
          callback(response);
        } else {
          try {
            response = formatResponse(xhr);
            callback(response);
          } catch (err) {
            if (errorCallback) {
              errorCallback(err);
            }
          }
        }
      }
    };
    xhr.open('GET', path, true);
    xhr.send();
  }
  return {
    load: loadAsset,
  };
}());

/* global createSizedArray, PropertyFactory, TextAnimatorDataProperty, bez, addHueToRGB,
  addSaturationToRGB, addBrightnessToRGB, LetterProps, Matrix, extendPrototype, DynamicPropertyContainer */

function TextAnimatorProperty(textData, renderType, elem) {
  this._isFirstFrame = true;
  this._hasMaskedPath = false;
  this._frameId = -1;
  this._textData = textData;
  this._renderType = renderType;
  this._elem = elem;
  this._animatorsData = createSizedArray(this._textData.a.length);
  this._pathData = {};
  this._moreOptions = {
    alignment: {},
  };
  this.renderedLetters = [];
  this.lettersChangedFlag = false;
  this.initDynamicPropertyContainer(elem);
}

TextAnimatorProperty.prototype.searchProperties = function () {
  var i;
  var len = this._textData.a.length;
  var animatorProps;
  var getProp = PropertyFactory.getProp;
  for (i = 0; i < len; i += 1) {
    animatorProps = this._textData.a[i];
    this._animatorsData[i] = new TextAnimatorDataProperty(this._elem, animatorProps, this);
  }
  if (this._textData.p && 'm' in this._textData.p) {
    this._pathData = {
      f: getProp(this._elem, this._textData.p.f, 0, 0, this),
      l: getProp(this._elem, this._textData.p.l, 0, 0, this),
      r: this._textData.p.r,
      m: this._elem.maskManager.getMaskProperty(this._textData.p.m),
    };
    this._hasMaskedPath = true;
  } else {
    this._hasMaskedPath = false;
  }
  this._moreOptions.alignment = getProp(this._elem, this._textData.m.a, 1, 0, this);
};

TextAnimatorProperty.prototype.getMeasures = function (documentData, lettersChangedFlag) {
  this.lettersChangedFlag = lettersChangedFlag;
  if (!this._mdf && !this._isFirstFrame && !lettersChangedFlag && (!this._hasMaskedPath || !this._pathData.m._mdf)) {
    return;
  }
  this._isFirstFrame = false;
  var alignment = this._moreOptions.alignment.v;
  var animators = this._animatorsData;
  var textData = this._textData;
  var matrixHelper = this.mHelper;
  var renderType = this._renderType;
  var renderedLettersCount = this.renderedLetters.length;
  var xPos;
  var yPos;
  var i;
  var len;
  var letters = documentData.l;
  var pathInfo;
  var currentLength;
  var currentPoint;
  var segmentLength;
  var flag;
  var pointInd;
  var segmentInd;
  var prevPoint;
  var points;
  var segments;
  var partialLength;
  var totalLength;
  var perc;
  var tanAngle;
  var mask;
  if (this._hasMaskedPath) {
    mask = this._pathData.m;
    if (!this._pathData.n || this._pathData._mdf) {
      var paths = mask.v;
      if (this._pathData.r) {
        paths = paths.reverse();
      }
      // TODO: release bezier data cached from previous pathInfo: this._pathData.pi
      pathInfo = {
        tLength: 0,
        segments: [],
      };
      len = paths._length - 1;
      var bezierData;
      totalLength = 0;
      for (i = 0; i < len; i += 1) {
        bezierData = bez.buildBezierData(paths.v[i],
          paths.v[i + 1],
          [paths.o[i][0] - paths.v[i][0], paths.o[i][1] - paths.v[i][1]],
          [paths.i[i + 1][0] - paths.v[i + 1][0], paths.i[i + 1][1] - paths.v[i + 1][1]]);
        pathInfo.tLength += bezierData.segmentLength;
        pathInfo.segments.push(bezierData);
        totalLength += bezierData.segmentLength;
      }
      i = len;
      if (mask.v.c) {
        bezierData = bez.buildBezierData(paths.v[i],
          paths.v[0],
          [paths.o[i][0] - paths.v[i][0], paths.o[i][1] - paths.v[i][1]],
          [paths.i[0][0] - paths.v[0][0], paths.i[0][1] - paths.v[0][1]]);
        pathInfo.tLength += bezierData.segmentLength;
        pathInfo.segments.push(bezierData);
        totalLength += bezierData.segmentLength;
      }
      this._pathData.pi = pathInfo;
    }
    pathInfo = this._pathData.pi;

    currentLength = this._pathData.f.v;
    segmentInd = 0;
    pointInd = 1;
    segmentLength = 0;
    flag = true;
    segments = pathInfo.segments;
    if (currentLength < 0 && mask.v.c) {
      if (pathInfo.tLength < Math.abs(currentLength)) {
        currentLength = -Math.abs(currentLength) % pathInfo.tLength;
      }
      segmentInd = segments.length - 1;
      points = segments[segmentInd].points;
      pointInd = points.length - 1;
      while (currentLength < 0) {
        currentLength += points[pointInd].partialLength;
        pointInd -= 1;
        if (pointInd < 0) {
          segmentInd -= 1;
          points = segments[segmentInd].points;
          pointInd = points.length - 1;
        }
      }
    }
    points = segments[segmentInd].points;
    prevPoint = points[pointInd - 1];
    currentPoint = points[pointInd];
    partialLength = currentPoint.partialLength;
  }

  len = letters.length;
  xPos = 0;
  yPos = 0;
  var yOff = documentData.finalSize * 1.2 * 0.714;
  var firstLine = true;
  var animatorProps;
  var animatorSelector;
  var j;
  var jLen;
  var letterValue;

  jLen = animators.length;

  var mult;
  var ind = -1;
  var offf;
  var xPathPos;
  var yPathPos;
  var initPathPos = currentLength;
  var initSegmentInd = segmentInd;
  var initPointInd = pointInd;
  var currentLine = -1;
  var elemOpacity;
  var sc;
  var sw;
  var fc;
  var k;
  var letterSw;
  var letterSc;
  var letterFc;
  var letterM = '';
  var letterP = this.defaultPropsArray;
  var letterO;

  //
  if (documentData.j === 2 || documentData.j === 1) {
    var animatorJustifyOffset = 0;
    var animatorFirstCharOffset = 0;
    var justifyOffsetMult = documentData.j === 2 ? -0.5 : -1;
    var lastIndex = 0;
    var isNewLine = true;

    for (i = 0; i < len; i += 1) {
      if (letters[i].n) {
        if (animatorJustifyOffset) {
          animatorJustifyOffset += animatorFirstCharOffset;
        }
        while (lastIndex < i) {
          letters[lastIndex].animatorJustifyOffset = animatorJustifyOffset;
          lastIndex += 1;
        }
        animatorJustifyOffset = 0;
        isNewLine = true;
      } else {
        for (j = 0; j < jLen; j += 1) {
          animatorProps = animators[j].a;
          if (animatorProps.t.propType) {
            if (isNewLine && documentData.j === 2) {
              animatorFirstCharOffset += animatorProps.t.v * justifyOffsetMult;
            }
            animatorSelector = animators[j].s;
            mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
            if (mult.length) {
              animatorJustifyOffset += animatorProps.t.v * mult[0] * justifyOffsetMult;
            } else {
              animatorJustifyOffset += animatorProps.t.v * mult * justifyOffsetMult;
            }
          }
        }
        isNewLine = false;
      }
    }
    if (animatorJustifyOffset) {
      animatorJustifyOffset += animatorFirstCharOffset;
    }
    while (lastIndex < i) {
      letters[lastIndex].animatorJustifyOffset = animatorJustifyOffset;
      lastIndex += 1;
    }
  }
  //

  for (i = 0; i < len; i += 1) {
    matrixHelper.reset();
    elemOpacity = 1;
    if (letters[i].n) {
      xPos = 0;
      yPos += documentData.yOffset;
      yPos += firstLine ? 1 : 0;
      currentLength = initPathPos;
      firstLine = false;
      if (this._hasMaskedPath) {
        segmentInd = initSegmentInd;
        pointInd = initPointInd;
        points = segments[segmentInd].points;
        prevPoint = points[pointInd - 1];
        currentPoint = points[pointInd];
        partialLength = currentPoint.partialLength;
        segmentLength = 0;
      }
      letterM = '';
      letterFc = '';
      letterSw = '';
      letterO = '';
      letterP = this.defaultPropsArray;
    } else {
      if (this._hasMaskedPath) {
        if (currentLine !== letters[i].line) {
          switch (documentData.j) {
            case 1:
              currentLength += totalLength - documentData.lineWidths[letters[i].line];
              break;
            case 2:
              currentLength += (totalLength - documentData.lineWidths[letters[i].line]) / 2;
              break;
          }
          currentLine = letters[i].line;
        }
        if (ind !== letters[i].ind) {
          if (letters[ind]) {
            currentLength += letters[ind].extra;
          }
          currentLength += letters[i].an / 2;
          ind = letters[i].ind;
        }
        currentLength += (alignment[0] * letters[i].an) * 0.005;
        var animatorOffset = 0;
        for (j = 0; j < jLen; j += 1) {
          animatorProps = animators[j].a;
          if (animatorProps.p.propType) {
            animatorSelector = animators[j].s;
            mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
            if (mult.length) {
              animatorOffset += animatorProps.p.v[0] * mult[0];
            } else {
              animatorOffset += animatorProps.p.v[0] * mult;
            }
          }
          if (animatorProps.a.propType) {
            animatorSelector = animators[j].s;
            mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
            if (mult.length) {
              animatorOffset += animatorProps.a.v[0] * mult[0];
            } else {
              animatorOffset += animatorProps.a.v[0] * mult;
            }
          }
        }
        flag = true;
        while (flag) {
          if (segmentLength + partialLength >= currentLength + animatorOffset || !points) {
            perc = (currentLength + animatorOffset - segmentLength) / currentPoint.partialLength;
            xPathPos = prevPoint.point[0] + (currentPoint.point[0] - prevPoint.point[0]) * perc;
            yPathPos = prevPoint.point[1] + (currentPoint.point[1] - prevPoint.point[1]) * perc;
            matrixHelper.translate((-alignment[0] * letters[i].an) * 0.005, -(alignment[1] * yOff) * 0.01);
            flag = false;
          } else if (points) {
            segmentLength += currentPoint.partialLength;
            pointInd += 1;
            if (pointInd >= points.length) {
              pointInd = 0;
              segmentInd += 1;
              if (!segments[segmentInd]) {
                if (mask.v.c) {
                  pointInd = 0;
                  segmentInd = 0;
                  points = segments[segmentInd].points;
                } else {
                  segmentLength -= currentPoint.partialLength;
                  points = null;
                }
              } else {
                points = segments[segmentInd].points;
              }
            }
            if (points) {
              prevPoint = currentPoint;
              currentPoint = points[pointInd];
              partialLength = currentPoint.partialLength;
            }
          }
        }
        offf = letters[i].an / 2 - letters[i].add;
        matrixHelper.translate(-offf, 0, 0);
      } else {
        offf = letters[i].an / 2 - letters[i].add;
        matrixHelper.translate(-offf, 0, 0);

        // Grouping alignment
        matrixHelper.translate((-alignment[0] * letters[i].an) * 0.005, (-alignment[1] * yOff) * 0.01, 0);
      }

      for (j = 0; j < jLen; j += 1) {
        animatorProps = animators[j].a;
        if (animatorProps.t.propType) {
          animatorSelector = animators[j].s;
          mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
          // This condition is to prevent applying tracking to first character in each line. Might be better to use a boolean "isNewLine"
          if (xPos !== 0 || documentData.j !== 0) {
            if (this._hasMaskedPath) {
              if (mult.length) {
                currentLength += animatorProps.t.v * mult[0];
              } else {
                currentLength += animatorProps.t.v * mult;
              }
            } else if (mult.length) {
              xPos += animatorProps.t.v * mult[0];
            } else {
              xPos += animatorProps.t.v * mult;
            }
          }
        }
      }
      if (documentData.strokeWidthAnim) {
        sw = documentData.sw || 0;
      }
      if (documentData.strokeColorAnim) {
        if (documentData.sc) {
          sc = [documentData.sc[0], documentData.sc[1], documentData.sc[2]];
        } else {
          sc = [0, 0, 0];
        }
      }
      if (documentData.fillColorAnim && documentData.fc) {
        fc = [documentData.fc[0], documentData.fc[1], documentData.fc[2]];
      }
      for (j = 0; j < jLen; j += 1) {
        animatorProps = animators[j].a;
        if (animatorProps.a.propType) {
          animatorSelector = animators[j].s;
          mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);

          if (mult.length) {
            matrixHelper.translate(-animatorProps.a.v[0] * mult[0], -animatorProps.a.v[1] * mult[1], animatorProps.a.v[2] * mult[2]);
          } else {
            matrixHelper.translate(-animatorProps.a.v[0] * mult, -animatorProps.a.v[1] * mult, animatorProps.a.v[2] * mult);
          }
        }
      }
      for (j = 0; j < jLen; j += 1) {
        animatorProps = animators[j].a;
        if (animatorProps.s.propType) {
          animatorSelector = animators[j].s;
          mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
          if (mult.length) {
            matrixHelper.scale(1 + ((animatorProps.s.v[0] - 1) * mult[0]), 1 + ((animatorProps.s.v[1] - 1) * mult[1]), 1);
          } else {
            matrixHelper.scale(1 + ((animatorProps.s.v[0] - 1) * mult), 1 + ((animatorProps.s.v[1] - 1) * mult), 1);
          }
        }
      }
      for (j = 0; j < jLen; j += 1) {
        animatorProps = animators[j].a;
        animatorSelector = animators[j].s;
        mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
        if (animatorProps.sk.propType) {
          if (mult.length) {
            matrixHelper.skewFromAxis(-animatorProps.sk.v * mult[0], animatorProps.sa.v * mult[1]);
          } else {
            matrixHelper.skewFromAxis(-animatorProps.sk.v * mult, animatorProps.sa.v * mult);
          }
        }
        if (animatorProps.r.propType) {
          if (mult.length) {
            matrixHelper.rotateZ(-animatorProps.r.v * mult[2]);
          } else {
            matrixHelper.rotateZ(-animatorProps.r.v * mult);
          }
        }
        if (animatorProps.ry.propType) {
          if (mult.length) {
            matrixHelper.rotateY(animatorProps.ry.v * mult[1]);
          } else {
            matrixHelper.rotateY(animatorProps.ry.v * mult);
          }
        }
        if (animatorProps.rx.propType) {
          if (mult.length) {
            matrixHelper.rotateX(animatorProps.rx.v * mult[0]);
          } else {
            matrixHelper.rotateX(animatorProps.rx.v * mult);
          }
        }
        if (animatorProps.o.propType) {
          if (mult.length) {
            elemOpacity += ((animatorProps.o.v) * mult[0] - elemOpacity) * mult[0];
          } else {
            elemOpacity += ((animatorProps.o.v) * mult - elemOpacity) * mult;
          }
        }
        if (documentData.strokeWidthAnim && animatorProps.sw.propType) {
          if (mult.length) {
            sw += animatorProps.sw.v * mult[0];
          } else {
            sw += animatorProps.sw.v * mult;
          }
        }
        if (documentData.strokeColorAnim && animatorProps.sc.propType) {
          for (k = 0; k < 3; k += 1) {
            if (mult.length) {
              sc[k] += (animatorProps.sc.v[k] - sc[k]) * mult[0];
            } else {
              sc[k] += (animatorProps.sc.v[k] - sc[k]) * mult;
            }
          }
        }
        if (documentData.fillColorAnim && documentData.fc) {
          if (animatorProps.fc.propType) {
            for (k = 0; k < 3; k += 1) {
              if (mult.length) {
                fc[k] += (animatorProps.fc.v[k] - fc[k]) * mult[0];
              } else {
                fc[k] += (animatorProps.fc.v[k] - fc[k]) * mult;
              }
            }
          }
          if (animatorProps.fh.propType) {
            if (mult.length) {
              fc = addHueToRGB(fc, animatorProps.fh.v * mult[0]);
            } else {
              fc = addHueToRGB(fc, animatorProps.fh.v * mult);
            }
          }
          if (animatorProps.fs.propType) {
            if (mult.length) {
              fc = addSaturationToRGB(fc, animatorProps.fs.v * mult[0]);
            } else {
              fc = addSaturationToRGB(fc, animatorProps.fs.v * mult);
            }
          }
          if (animatorProps.fb.propType) {
            if (mult.length) {
              fc = addBrightnessToRGB(fc, animatorProps.fb.v * mult[0]);
            } else {
              fc = addBrightnessToRGB(fc, animatorProps.fb.v * mult);
            }
          }
        }
      }

      for (j = 0; j < jLen; j += 1) {
        animatorProps = animators[j].a;

        if (animatorProps.p.propType) {
          animatorSelector = animators[j].s;
          mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
          if (this._hasMaskedPath) {
            if (mult.length) {
              matrixHelper.translate(0, animatorProps.p.v[1] * mult[0], -animatorProps.p.v[2] * mult[1]);
            } else {
              matrixHelper.translate(0, animatorProps.p.v[1] * mult, -animatorProps.p.v[2] * mult);
            }
          } else if (mult.length) {
            matrixHelper.translate(animatorProps.p.v[0] * mult[0], animatorProps.p.v[1] * mult[1], -animatorProps.p.v[2] * mult[2]);
          } else {
            matrixHelper.translate(animatorProps.p.v[0] * mult, animatorProps.p.v[1] * mult, -animatorProps.p.v[2] * mult);
          }
        }
      }
      if (documentData.strokeWidthAnim) {
        letterSw = sw < 0 ? 0 : sw;
      }
      if (documentData.strokeColorAnim) {
        letterSc = 'rgb(' + Math.round(sc[0] * 255) + ',' + Math.round(sc[1] * 255) + ',' + Math.round(sc[2] * 255) + ')';
      }
      if (documentData.fillColorAnim && documentData.fc) {
        letterFc = 'rgb(' + Math.round(fc[0] * 255) + ',' + Math.round(fc[1] * 255) + ',' + Math.round(fc[2] * 255) + ')';
      }

      if (this._hasMaskedPath) {
        matrixHelper.translate(0, -documentData.ls);

        matrixHelper.translate(0, (alignment[1] * yOff) * 0.01 + yPos, 0);
        if (textData.p.p) {
          tanAngle = (currentPoint.point[1] - prevPoint.point[1]) / (currentPoint.point[0] - prevPoint.point[0]);
          var rot = (Math.atan(tanAngle) * 180) / Math.PI;
          if (currentPoint.point[0] < prevPoint.point[0]) {
            rot += 180;
          }
          matrixHelper.rotate((-rot * Math.PI) / 180);
        }
        matrixHelper.translate(xPathPos, yPathPos, 0);
        currentLength -= (alignment[0] * letters[i].an) * 0.005;
        if (letters[i + 1] && ind !== letters[i + 1].ind) {
          currentLength += letters[i].an / 2;
          currentLength += (documentData.tr * 0.001) * documentData.finalSize;
        }
      } else {
        matrixHelper.translate(xPos, yPos, 0);

        if (documentData.ps) {
          // matrixHelper.translate(documentData.ps[0],documentData.ps[1],0);
          matrixHelper.translate(documentData.ps[0], documentData.ps[1] + documentData.ascent, 0);
        }
        switch (documentData.j) {
          case 1:
            matrixHelper.translate(letters[i].animatorJustifyOffset + documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[letters[i].line]), 0, 0);
            break;
          case 2:
            matrixHelper.translate(letters[i].animatorJustifyOffset + documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[letters[i].line]) / 2, 0, 0);
            break;
        }
        matrixHelper.translate(0, -documentData.ls);
        matrixHelper.translate(offf, 0, 0);
        matrixHelper.translate((alignment[0] * letters[i].an) * 0.005, (alignment[1] * yOff) * 0.01, 0);
        xPos += letters[i].l + (documentData.tr * 0.001) * documentData.finalSize;
      }
      if (renderType === 'html') {
        letterM = matrixHelper.toCSS();
      } else if (renderType === 'svg') {
        letterM = matrixHelper.to2dCSS();
      } else {
        letterP = [matrixHelper.props[0], matrixHelper.props[1], matrixHelper.props[2], matrixHelper.props[3], matrixHelper.props[4], matrixHelper.props[5], matrixHelper.props[6], matrixHelper.props[7], matrixHelper.props[8], matrixHelper.props[9], matrixHelper.props[10], matrixHelper.props[11], matrixHelper.props[12], matrixHelper.props[13], matrixHelper.props[14], matrixHelper.props[15]];
      }
      letterO = elemOpacity;
    }

    if (renderedLettersCount <= i) {
      letterValue = new LetterProps(letterO, letterSw, letterSc, letterFc, letterM, letterP);
      this.renderedLetters.push(letterValue);
      renderedLettersCount += 1;
      this.lettersChangedFlag = true;
    } else {
      letterValue = this.renderedLetters[i];
      this.lettersChangedFlag = letterValue.update(letterO, letterSw, letterSc, letterFc, letterM, letterP) || this.lettersChangedFlag;
    }
  }
};

TextAnimatorProperty.prototype.getValue = function () {
  if (this._elem.globalData.frameId === this._frameId) {
    return;
  }
  this._frameId = this._elem.globalData.frameId;
  this.iterateDynamicProperties();
};

TextAnimatorProperty.prototype.mHelper = new Matrix();
TextAnimatorProperty.prototype.defaultPropsArray = [];
extendPrototype([DynamicPropertyContainer], TextAnimatorProperty);

/* global PropertyFactory, degToRads, TextSelectorProp */
/* exported TextAnimatorDataProperty */

function TextAnimatorDataProperty(elem, animatorProps, container) {
  var defaultData = { propType: false };
  var getProp = PropertyFactory.getProp;
  var textAnimatorAnimatables = animatorProps.a;
  this.a = {
    r: textAnimatorAnimatables.r ? getProp(elem, textAnimatorAnimatables.r, 0, degToRads, container) : defaultData,
    rx: textAnimatorAnimatables.rx ? getProp(elem, textAnimatorAnimatables.rx, 0, degToRads, container) : defaultData,
    ry: textAnimatorAnimatables.ry ? getProp(elem, textAnimatorAnimatables.ry, 0, degToRads, container) : defaultData,
    sk: textAnimatorAnimatables.sk ? getProp(elem, textAnimatorAnimatables.sk, 0, degToRads, container) : defaultData,
    sa: textAnimatorAnimatables.sa ? getProp(elem, textAnimatorAnimatables.sa, 0, degToRads, container) : defaultData,
    s: textAnimatorAnimatables.s ? getProp(elem, textAnimatorAnimatables.s, 1, 0.01, container) : defaultData,
    a: textAnimatorAnimatables.a ? getProp(elem, textAnimatorAnimatables.a, 1, 0, container) : defaultData,
    o: textAnimatorAnimatables.o ? getProp(elem, textAnimatorAnimatables.o, 0, 0.01, container) : defaultData,
    p: textAnimatorAnimatables.p ? getProp(elem, textAnimatorAnimatables.p, 1, 0, container) : defaultData,
    sw: textAnimatorAnimatables.sw ? getProp(elem, textAnimatorAnimatables.sw, 0, 0, container) : defaultData,
    sc: textAnimatorAnimatables.sc ? getProp(elem, textAnimatorAnimatables.sc, 1, 0, container) : defaultData,
    fc: textAnimatorAnimatables.fc ? getProp(elem, textAnimatorAnimatables.fc, 1, 0, container) : defaultData,
    fh: textAnimatorAnimatables.fh ? getProp(elem, textAnimatorAnimatables.fh, 0, 0, container) : defaultData,
    fs: textAnimatorAnimatables.fs ? getProp(elem, textAnimatorAnimatables.fs, 0, 0.01, container) : defaultData,
    fb: textAnimatorAnimatables.fb ? getProp(elem, textAnimatorAnimatables.fb, 0, 0.01, container) : defaultData,
    t: textAnimatorAnimatables.t ? getProp(elem, textAnimatorAnimatables.t, 0, 0, container) : defaultData,
  };

  this.s = TextSelectorProp.getTextSelectorProp(elem, animatorProps.s, container);
  this.s.t = animatorProps.s.t;
}

function LetterProps(o, sw, sc, fc, m, p) {
  this.o = o;
  this.sw = sw;
  this.sc = sc;
  this.fc = fc;
  this.m = m;
  this.p = p;
  this._mdf = {
    o: true,
    sw: !!sw,
    sc: !!sc,
    fc: !!fc,
    m: true,
    p: true,
  };
}

LetterProps.prototype.update = function (o, sw, sc, fc, m, p) {
  this._mdf.o = false;
  this._mdf.sw = false;
  this._mdf.sc = false;
  this._mdf.fc = false;
  this._mdf.m = false;
  this._mdf.p = false;
  var updated = false;

  if (this.o !== o) {
    this.o = o;
    this._mdf.o = true;
    updated = true;
  }
  if (this.sw !== sw) {
    this.sw = sw;
    this._mdf.sw = true;
    updated = true;
  }
  if (this.sc !== sc) {
    this.sc = sc;
    this._mdf.sc = true;
    updated = true;
  }
  if (this.fc !== fc) {
    this.fc = fc;
    this._mdf.fc = true;
    updated = true;
  }
  if (this.m !== m) {
    this.m = m;
    this._mdf.m = true;
    updated = true;
  }
  if (p.length && (this.p[0] !== p[0] || this.p[1] !== p[1] || this.p[4] !== p[4] || this.p[5] !== p[5] || this.p[12] !== p[12] || this.p[13] !== p[13])) {
    this.p = p;
    this._mdf.p = true;
    updated = true;
  }
  return updated;
};

/* global FontManager, initialDefaultFrame, getFontProperties */
/* exported TextProperty */

function TextProperty(elem, data) {
  this._frameId = initialDefaultFrame;
  this.pv = '';
  this.v = '';
  this.kf = false;
  this._isFirstFrame = true;
  this._mdf = false;
  this.data = data;
  this.elem = elem;
  this.comp = this.elem.comp;
  this.keysIndex = 0;
  this.canResize = false;
  this.minimumFontSize = 1;
  this.effectsSequence = [];
  this.currentData = {
    ascent: 0,
    boxWidth: this.defaultBoxWidth,
    f: '',
    fStyle: '',
    fWeight: '',
    fc: '',
    j: '',
    justifyOffset: '',
    l: [],
    lh: 0,
    lineWidths: [],
    ls: '',
    of: '',
    s: '',
    sc: '',
    sw: 0,
    t: 0,
    tr: 0,
    sz: 0,
    ps: null,
    fillColorAnim: false,
    strokeColorAnim: false,
    strokeWidthAnim: false,
    yOffset: 0,
    finalSize: 0,
    finalText: [],
    finalLineHeight: 0,
    __complete: false,

  };
  this.copyData(this.currentData, this.data.d.k[0].s);

  if (!this.searchProperty()) {
    this.completeTextData(this.currentData);
  }
}

TextProperty.prototype.defaultBoxWidth = [0, 0];

TextProperty.prototype.copyData = function (obj, data) {
  for (var s in data) {
    if (Object.prototype.hasOwnProperty.call(data, s)) {
      obj[s] = data[s];
    }
  }
  return obj;
};

TextProperty.prototype.setCurrentData = function (data) {
  if (!data.__complete) {
    this.completeTextData(data);
  }
  this.currentData = data;
  this.currentData.boxWidth = this.currentData.boxWidth || this.defaultBoxWidth;
  this._mdf = true;
};

TextProperty.prototype.searchProperty = function () {
  return this.searchKeyframes();
};

TextProperty.prototype.searchKeyframes = function () {
  this.kf = this.data.d.k.length > 1;
  if (this.kf) {
    this.addEffect(this.getKeyframeValue.bind(this));
  }
  return this.kf;
};

TextProperty.prototype.addEffect = function (effectFunction) {
  this.effectsSequence.push(effectFunction);
  this.elem.addDynamicProperty(this);
};

TextProperty.prototype.getValue = function (_finalValue) {
  if ((this.elem.globalData.frameId === this.frameId || !this.effectsSequence.length) && !_finalValue) {
    return;
  }
  this.currentData.t = this.data.d.k[this.keysIndex].s.t;
  var currentValue = this.currentData;
  var currentIndex = this.keysIndex;
  if (this.lock) {
    this.setCurrentData(this.currentData);
    return;
  }
  this.lock = true;
  this._mdf = false;
  var i; var
    len = this.effectsSequence.length;
  var finalValue = _finalValue || this.data.d.k[this.keysIndex].s;
  for (i = 0; i < len; i += 1) {
    // Checking if index changed to prevent creating a new object every time the expression updates.
    if (currentIndex !== this.keysIndex) {
      finalValue = this.effectsSequence[i](finalValue, finalValue.t);
    } else {
      finalValue = this.effectsSequence[i](this.currentData, finalValue.t);
    }
  }
  if (currentValue !== finalValue) {
    this.setCurrentData(finalValue);
  }
  this.v = this.currentData;
  this.pv = this.v;
  this.lock = false;
  this.frameId = this.elem.globalData.frameId;
};

TextProperty.prototype.getKeyframeValue = function () {
  var textKeys = this.data.d.k;
  var frameNum = this.elem.comp.renderedFrame;
  var i = 0; var
    len = textKeys.length;
  while (i <= len - 1) {
    if (i === len - 1 || textKeys[i + 1].t > frameNum) {
      break;
    }
    i += 1;
  }
  if (this.keysIndex !== i) {
    this.keysIndex = i;
  }
  return this.data.d.k[this.keysIndex].s;
};

TextProperty.prototype.buildFinalText = function (text) {
  var combinedCharacters = FontManager.getCombinedCharacterCodes();
  var charactersArray = [];
  var i = 0; var
    len = text.length;
  var charCode;
  while (i < len) {
    charCode = text.charCodeAt(i);
    if (combinedCharacters.indexOf(charCode) !== -1) {
      charactersArray[charactersArray.length - 1] += text.charAt(i);
    } else if (charCode >= 0xD800 && charCode <= 0xDBFF) {
      charCode = text.charCodeAt(i + 1);
      if (charCode >= 0xDC00 && charCode <= 0xDFFF) {
        charactersArray.push(text.substr(i, 2));
        i += 1;
      } else {
        charactersArray.push(text.charAt(i));
      }
    } else {
      charactersArray.push(text.charAt(i));
    }
    i += 1;
  }
  return charactersArray;
};

TextProperty.prototype.completeTextData = function (documentData) {
  documentData.__complete = true;
  var fontManager = this.elem.globalData.fontManager;
  var data = this.data;
  var letters = [];
  var i; var
    len;
  var newLineFlag; var index = 0; var
    val;
  var anchorGrouping = data.m.g;
  var currentSize = 0; var currentPos = 0; var currentLine = 0; var
    lineWidths = [];
  var lineWidth = 0;
  var maxLineWidth = 0;
  var j; var
    jLen;
  var fontData = fontManager.getFontByName(documentData.f);
  var charData; var
    cLength = 0;

  var fontProps = getFontProperties(fontData);
  documentData.fWeight = fontProps.weight;
  documentData.fStyle = fontProps.style;
  documentData.finalSize = documentData.s;
  documentData.finalText = this.buildFinalText(documentData.t);
  len = documentData.finalText.length;
  documentData.finalLineHeight = documentData.lh;
  var trackingOffset = (documentData.tr / 1000) * documentData.finalSize;
  var charCode;
  if (documentData.sz) {
    var flag = true;
    var boxWidth = documentData.sz[0];
    var boxHeight = documentData.sz[1];
    var currentHeight; var
      finalText;
    while (flag) {
      finalText = this.buildFinalText(documentData.t);
      currentHeight = 0;
      lineWidth = 0;
      len = finalText.length;
      trackingOffset = (documentData.tr / 1000) * documentData.finalSize;
      var lastSpaceIndex = -1;
      for (i = 0; i < len; i += 1) {
        charCode = finalText[i].charCodeAt(0);
        newLineFlag = false;
        if (finalText[i] === ' ') {
          lastSpaceIndex = i;
        } else if (charCode === 13 || charCode === 3) {
          lineWidth = 0;
          newLineFlag = true;
          currentHeight += documentData.finalLineHeight || documentData.finalSize * 1.2;
        }
        if (fontManager.chars) {
          charData = fontManager.getCharData(finalText[i], fontData.fStyle, fontData.fFamily);
          cLength = newLineFlag ? 0 : (charData.w * documentData.finalSize) / 100;
        } else {
          // tCanvasHelper.font = documentData.s + 'px '+ fontData.fFamily;
          cLength = fontManager.measureText(finalText[i], documentData.f, documentData.finalSize);
        }
        if (lineWidth + cLength > boxWidth && finalText[i] !== ' ') {
          if (lastSpaceIndex === -1) {
            len += 1;
          } else {
            i = lastSpaceIndex;
          }
          currentHeight += documentData.finalLineHeight || documentData.finalSize * 1.2;
          finalText.splice(i, lastSpaceIndex === i ? 1 : 0, '\r');
          // finalText = finalText.substr(0,i) + "\r" + finalText.substr(i === lastSpaceIndex ? i + 1 : i);
          lastSpaceIndex = -1;
          lineWidth = 0;
        } else {
          lineWidth += cLength;
          lineWidth += trackingOffset;
        }
      }
      currentHeight += (fontData.ascent * documentData.finalSize) / 100;
      if (this.canResize && documentData.finalSize > this.minimumFontSize && boxHeight < currentHeight) {
        documentData.finalSize -= 1;
        documentData.finalLineHeight = (documentData.finalSize * documentData.lh) / documentData.s;
      } else {
        documentData.finalText = finalText;
        len = documentData.finalText.length;
        flag = false;
      }
    }
  }
  lineWidth = -trackingOffset;
  cLength = 0;
  var uncollapsedSpaces = 0;
  var currentChar;
  for (i = 0; i < len; i += 1) {
    newLineFlag = false;
    currentChar = documentData.finalText[i];
    charCode = currentChar.charCodeAt(0);
    if (charCode === 13 || charCode === 3) {
      uncollapsedSpaces = 0;
      lineWidths.push(lineWidth);
      maxLineWidth = lineWidth > maxLineWidth ? lineWidth : maxLineWidth;
      lineWidth = -2 * trackingOffset;
      val = '';
      newLineFlag = true;
      currentLine += 1;
    } else {
      val = currentChar;
    }
    if (fontManager.chars) {
      charData = fontManager.getCharData(currentChar, fontData.fStyle, fontManager.getFontByName(documentData.f).fFamily);
      cLength = newLineFlag ? 0 : (charData.w * documentData.finalSize) / 100;
    } else {
      // var charWidth = fontManager.measureText(val, documentData.f, documentData.finalSize);
      // tCanvasHelper.font = documentData.finalSize + 'px '+ fontManager.getFontByName(documentData.f).fFamily;
      cLength = fontManager.measureText(val, documentData.f, documentData.finalSize);
    }

    //
    if (currentChar === ' ') {
      uncollapsedSpaces += cLength + trackingOffset;
    } else {
      lineWidth += cLength + trackingOffset + uncollapsedSpaces;
      uncollapsedSpaces = 0;
    }
    letters.push({
      l: cLength, an: cLength, add: currentSize, n: newLineFlag, anIndexes: [], val: val, line: currentLine, animatorJustifyOffset: 0,
    });
    if (anchorGrouping == 2) { // eslint-disable-line eqeqeq
      currentSize += cLength;
      if (val === '' || val === ' ' || i === len - 1) {
        if (val === '' || val === ' ') {
          currentSize -= cLength;
        }
        while (currentPos <= i) {
          letters[currentPos].an = currentSize;
          letters[currentPos].ind = index;
          letters[currentPos].extra = cLength;
          currentPos += 1;
        }
        index += 1;
        currentSize = 0;
      }
    } else if (anchorGrouping == 3) { // eslint-disable-line eqeqeq
      currentSize += cLength;
      if (val === '' || i === len - 1) {
        if (val === '') {
          currentSize -= cLength;
        }
        while (currentPos <= i) {
          letters[currentPos].an = currentSize;
          letters[currentPos].ind = index;
          letters[currentPos].extra = cLength;
          currentPos += 1;
        }
        currentSize = 0;
        index += 1;
      }
    } else {
      letters[index].ind = index;
      letters[index].extra = 0;
      index += 1;
    }
  }
  documentData.l = letters;
  maxLineWidth = lineWidth > maxLineWidth ? lineWidth : maxLineWidth;
  lineWidths.push(lineWidth);
  if (documentData.sz) {
    documentData.boxWidth = documentData.sz[0];
    documentData.justifyOffset = 0;
  } else {
    documentData.boxWidth = maxLineWidth;
    switch (documentData.j) {
      case 1:
        documentData.justifyOffset = -documentData.boxWidth;
        break;
      case 2:
        documentData.justifyOffset = -documentData.boxWidth / 2;
        break;
      default:
        documentData.justifyOffset = 0;
    }
  }
  documentData.lineWidths = lineWidths;

  var animators = data.a; var animatorData; var
    letterData;
  jLen = animators.length;
  var based; var ind; var
    indexes = [];
  for (j = 0; j < jLen; j += 1) {
    animatorData = animators[j];
    if (animatorData.a.sc) {
      documentData.strokeColorAnim = true;
    }
    if (animatorData.a.sw) {
      documentData.strokeWidthAnim = true;
    }
    if (animatorData.a.fc || animatorData.a.fh || animatorData.a.fs || animatorData.a.fb) {
      documentData.fillColorAnim = true;
    }
    ind = 0;
    based = animatorData.s.b;
    for (i = 0; i < len; i += 1) {
      letterData = letters[i];
      letterData.anIndexes[j] = ind;
      if ((based == 1 && letterData.val !== '') || (based == 2 && letterData.val !== '' && letterData.val !== ' ') || (based == 3 && (letterData.n || letterData.val == ' ' || i == len - 1)) || (based == 4 && (letterData.n || i == len - 1))) { // eslint-disable-line eqeqeq
        if (animatorData.s.rn === 1) {
          indexes.push(ind);
        }
        ind += 1;
      }
    }
    data.a[j].s.totalChars = ind;
    var currentInd = -1; var
      newInd;
    if (animatorData.s.rn === 1) {
      for (i = 0; i < len; i += 1) {
        letterData = letters[i];
        if (currentInd != letterData.anIndexes[j]) { // eslint-disable-line eqeqeq
          currentInd = letterData.anIndexes[j];
          newInd = indexes.splice(Math.floor(Math.random() * indexes.length), 1)[0];
        }
        letterData.anIndexes[j] = newInd;
      }
    }
  }
  documentData.yOffset = documentData.finalLineHeight || documentData.finalSize * 1.2;
  documentData.ls = documentData.ls || 0;
  documentData.ascent = (fontData.ascent * documentData.finalSize) / 100;
};

TextProperty.prototype.updateDocumentData = function (newData, index) {
  index = index === undefined ? this.keysIndex : index;
  var dData = this.copyData({}, this.data.d.k[index].s);
  dData = this.copyData(dData, newData);
  this.data.d.k[index].s = dData;
  this.recalculate(index);
  this.elem.addDynamicProperty(this);
};

TextProperty.prototype.recalculate = function (index) {
  var dData = this.data.d.k[index].s;
  dData.__complete = false;
  this.keysIndex = 0;
  this._isFirstFrame = true;
  this.getValue(dData);
};

TextProperty.prototype.canResizeFont = function (_canResize) {
  this.canResize = _canResize;
  this.recalculate(this.keysIndex);
  this.elem.addDynamicProperty(this);
};

TextProperty.prototype.setMinimumFontSize = function (_fontValue) {
  this.minimumFontSize = Math.floor(_fontValue) || 1;
  this.recalculate(this.keysIndex);
  this.elem.addDynamicProperty(this);
};

/* global extendPrototype, BezierFactory, PropertyFactory, DynamicPropertyContainer */
/* exported TextSelectorProp */

var TextSelectorProp = (function () {
  var max = Math.max;
  var min = Math.min;
  var floor = Math.floor;

  function TextSelectorPropFactory(elem, data) {
    this._currentTextLength = -1;
    this.k = false;
    this.data = data;
    this.elem = elem;
    this.comp = elem.comp;
    this.finalS = 0;
    this.finalE = 0;
    this.initDynamicPropertyContainer(elem);
    this.s = PropertyFactory.getProp(elem, data.s || { k: 0 }, 0, 0, this);
    if ('e' in data) {
      this.e = PropertyFactory.getProp(elem, data.e, 0, 0, this);
    } else {
      this.e = { v: 100 };
    }
    this.o = PropertyFactory.getProp(elem, data.o || { k: 0 }, 0, 0, this);
    this.xe = PropertyFactory.getProp(elem, data.xe || { k: 0 }, 0, 0, this);
    this.ne = PropertyFactory.getProp(elem, data.ne || { k: 0 }, 0, 0, this);
    this.a = PropertyFactory.getProp(elem, data.a, 0, 0.01, this);
    if (!this.dynamicProperties.length) {
      this.getValue();
    }
  }

  TextSelectorPropFactory.prototype = {
    getMult: function (ind) {
      if (this._currentTextLength !== this.elem.textProperty.currentData.l.length) {
        this.getValue();
      }
      // var easer = bez.getEasingCurve(this.ne.v/100,0,1-this.xe.v/100,1);
      var x1 = 0;
      var y1 = 0;
      var x2 = 1;
      var y2 = 1;
      if (this.ne.v > 0) {
        x1 = this.ne.v / 100.0;
      } else {
        y1 = -this.ne.v / 100.0;
      }
      if (this.xe.v > 0) {
        x2 = 1.0 - this.xe.v / 100.0;
      } else {
        y2 = 1.0 + this.xe.v / 100.0;
      }
      var easer = BezierFactory.getBezierEasing(x1, y1, x2, y2).get;

      var mult = 0;
      var s = this.finalS;
      var e = this.finalE;
      var type = this.data.sh;
      if (type === 2) {
        if (e === s) {
          mult = ind >= e ? 1 : 0;
        } else {
          mult = max(0, min(0.5 / (e - s) + (ind - s) / (e - s), 1));
        }
        mult = easer(mult);
      } else if (type === 3) {
        if (e === s) {
          mult = ind >= e ? 0 : 1;
        } else {
          mult = 1 - max(0, min(0.5 / (e - s) + (ind - s) / (e - s), 1));
        }

        mult = easer(mult);
      } else if (type === 4) {
        if (e === s) {
          mult = 0;
        } else {
          mult = max(0, min(0.5 / (e - s) + (ind - s) / (e - s), 1));
          if (mult < 0.5) {
            mult *= 2;
          } else {
            mult = 1 - 2 * (mult - 0.5);
          }
        }
        mult = easer(mult);
      } else if (type === 5) {
        if (e === s) {
          mult = 0;
        } else {
          var tot = e - s;
          /* ind += 0.5;
                    mult = -4/(tot*tot)*(ind*ind)+(4/tot)*ind; */
          ind = min(max(0, ind + 0.5 - s), e - s);
          var x = -tot / 2 + ind;
          var a = tot / 2;
          mult = Math.sqrt(1 - (x * x) / (a * a));
        }
        mult = easer(mult);
      } else if (type === 6) {
        if (e === s) {
          mult = 0;
        } else {
          ind = min(max(0, ind + 0.5 - s), e - s);
          mult = (1 + (Math.cos((Math.PI + Math.PI * 2 * (ind) / (e - s))))) / 2; // eslint-disable-line
        }
        mult = easer(mult);
      } else {
        if (ind >= floor(s)) {
          if (ind - s < 0) {
            mult = max(0, min(min(e, 1) - (s - ind), 1));
          } else {
            mult = max(0, min(e - ind, 1));
          }
        }
        mult = easer(mult);
      }
      return mult * this.a.v;
    },
    getValue: function (newCharsFlag) {
      this.iterateDynamicProperties();
      this._mdf = newCharsFlag || this._mdf;
      this._currentTextLength = this.elem.textProperty.currentData.l.length || 0;
      if (newCharsFlag && this.data.r === 2) {
        this.e.v = this._currentTextLength;
      }
      var divisor = this.data.r === 2 ? 1 : 100 / this.data.totalChars;
      var o = this.o.v / divisor;
      var s = this.s.v / divisor + o;
      var e = (this.e.v / divisor) + o;
      if (s > e) {
        var _s = s;
        s = e;
        e = _s;
      }
      this.finalS = s;
      this.finalE = e;
    },
  };
  extendPrototype([DynamicPropertyContainer], TextSelectorPropFactory);

  function getTextSelectorProp(elem, data, arr) {
    return new TextSelectorPropFactory(elem, data, arr);
  }

  return {
    getTextSelectorProp: getTextSelectorProp,
  };
}());

/* global createSizedArray, pooling */
/* exported poolFactory */

var poolFactory = (function () {
  return function (initialLength, _create, _release) {
    var _length = 0;
    var _maxLength = initialLength;
    var pool = createSizedArray(_maxLength);

    var ob = {
      newElement: newElement,
      release: release,
    };

    function newElement() {
      var element;
      if (_length) {
        _length -= 1;
        element = pool[_length];
      } else {
        element = _create();
      }
      return element;
    }

    function release(element) {
      if (_length === _maxLength) {
        pool = pooling.double(pool);
        _maxLength *= 2;
      }
      if (_release) {
        _release(element);
      }
      pool[_length] = element;
      _length += 1;
    }

    return ob;
  };
}());

/* global createSizedArray */
/* exported pooling */

var pooling = (function () {
  function double(arr) {
    return arr.concat(createSizedArray(arr.length));
  }

  return {
    double: double,
  };
}());

/* global createTypedArray, poolFactory */
/* exported pointPool */

var pointPool = (function () {
  function create() {
    return createTypedArray('float32', 2);
  }
  return poolFactory(8, create);
}());

/* global ShapePath, pointPool, poolFactory */
/* exported shapePool */

var shapePool = (function () {
  function create() {
    return new ShapePath();
  }

  function release(shapePath) {
    var len = shapePath._length;
    var i;
    for (i = 0; i < len; i += 1) {
      pointPool.release(shapePath.v[i]);
      pointPool.release(shapePath.i[i]);
      pointPool.release(shapePath.o[i]);
      shapePath.v[i] = null;
      shapePath.i[i] = null;
      shapePath.o[i] = null;
    }
    shapePath._length = 0;
    shapePath.c = false;
  }

  function clone(shape) {
    var cloned = factory.newElement();
    var i;
    var len = shape._length === undefined ? shape.v.length : shape._length;
    cloned.setLength(len);
    cloned.c = shape.c;

    for (i = 0; i < len; i += 1) {
      cloned.setTripleAt(shape.v[i][0], shape.v[i][1], shape.o[i][0], shape.o[i][1], shape.i[i][0], shape.i[i][1], i);
    }
    return cloned;
  }

  var factory = poolFactory(4, create, release);
  factory.clone = clone;

  return factory;
}());

/* global createSizedArray, ShapeCollection, shapePool, pooling */
/* exported shapeCollectionPool */

var shapeCollectionPool = (function () {
  var ob = {
    newShapeCollection: newShapeCollection,
    release: release,
  };

  var _length = 0;
  var _maxLength = 4;
  var pool = createSizedArray(_maxLength);

  function newShapeCollection() {
    var shapeCollection;
    if (_length) {
      _length -= 1;
      shapeCollection = pool[_length];
    } else {
      shapeCollection = new ShapeCollection();
    }
    return shapeCollection;
  }

  function release(shapeCollection) {
    var i;
    var len = shapeCollection._length;
    for (i = 0; i < len; i += 1) {
      shapePool.release(shapeCollection.shapes[i]);
    }
    shapeCollection._length = 0;

    if (_length === _maxLength) {
      pool = pooling.double(pool);
      _maxLength *= 2;
    }
    pool[_length] = shapeCollection;
    _length += 1;
  }

  return ob;
}());

/* global poolFactory, bezierLengthPool */
/* exported segmentsLengthPool */

var segmentsLengthPool = (function () {
  function create() {
    return {
      lengths: [],
      totalLength: 0,
    };
  }

  function release(element) {
    var i;
    var len = element.lengths.length;
    for (i = 0; i < len; i += 1) {
      bezierLengthPool.release(element.lengths[i]);
    }
    element.lengths.length = 0;
  }

  return poolFactory(8, create, release);
}());

/* global createTypedArray, defaultCurveSegments, poolFactory */
/* exported bezierLengthPool */

var bezierLengthPool = (function () {
  function create() {
    return {
      addedLength: 0,
      percents: createTypedArray('float32', defaultCurveSegments),
      lengths: createTypedArray('float32', defaultCurveSegments),
    };
  }
  return poolFactory(8, create);
}());

/* exported markerParser */

var markerParser = (

  function () {
    function parsePayloadLines(payload) {
      var lines = payload.split('\r\n');
      var keys = {};
      var line;
      var keysCount = 0;
      for (var i = 0; i < lines.length; i += 1) {
        line = lines[i].split(':');
        if (line.length === 2) {
          keys[line[0]] = line[1].trim();
          keysCount += 1;
        }
      }
      if (keysCount === 0) {
        throw new Error();
      }
      return keys;
    }

    return function (_markers) {
      var markers = [];
      for (var i = 0; i < _markers.length; i += 1) {
        var _marker = _markers[i];
        var markerData = {
          time: _marker.tm,
          duration: _marker.dr,
        };
        try {
          markerData.payload = JSON.parse(_markers[i].cm);
        } catch (_) {
          try {
            markerData.payload = parsePayloadLines(_markers[i].cm);
          } catch (__) {
            markerData.payload = {
              name: _markers[i],
            };
          }
        }
        markers.push(markerData);
      }
      return markers;
    };
  }());

/* global AudioElement, FootageElement, FontManager */

function BaseRenderer() {}
BaseRenderer.prototype.checkLayers = function (num) {
  var i;
  var len = this.layers.length;
  var data;
  this.completeLayers = true;
  for (i = len - 1; i >= 0; i -= 1) {
    if (!this.elements[i]) {
      data = this.layers[i];
      if (data.ip - data.st <= (num - this.layers[i].st) && data.op - data.st > (num - this.layers[i].st)) {
        this.buildItem(i);
      }
    }
    this.completeLayers = this.elements[i] ? this.completeLayers : false;
  }
  this.checkPendingElements();
};

BaseRenderer.prototype.createItem = function (layer) {
  switch (layer.ty) {
    case 2:
      return this.createImage(layer);
    case 0:
      return this.createComp(layer);
    case 1:
      return this.createSolid(layer);
    case 3:
      return this.createNull(layer);
    case 4:
      return this.createShape(layer);
    case 5:
      return this.createText(layer);
    case 6:
      return this.createAudio(layer);
    case 13:
      return this.createCamera(layer);
    case 15:
      return this.createFootage(layer);
    default:
      return this.createNull(layer);
  }
};

BaseRenderer.prototype.createCamera = function () {
  throw new Error('You\'re using a 3d camera. Try the html renderer.');
};

BaseRenderer.prototype.createAudio = function (data) {
  return new AudioElement(data, this.globalData, this);
};

BaseRenderer.prototype.createFootage = function (data) {
  return new FootageElement(data, this.globalData, this);
};

BaseRenderer.prototype.buildAllItems = function () {
  var i;
  var len = this.layers.length;
  for (i = 0; i < len; i += 1) {
    this.buildItem(i);
  }
  this.checkPendingElements();
};

BaseRenderer.prototype.includeLayers = function (newLayers) {
  this.completeLayers = false;
  var i;
  var len = newLayers.length;
  var j;
  var jLen = this.layers.length;
  for (i = 0; i < len; i += 1) {
    j = 0;
    while (j < jLen) {
      if (this.layers[j].id === newLayers[i].id) {
        this.layers[j] = newLayers[i];
        break;
      }
      j += 1;
    }
  }
};

BaseRenderer.prototype.setProjectInterface = function (pInterface) {
  this.globalData.projectInterface = pInterface;
};

BaseRenderer.prototype.initItems = function () {
  if (!this.globalData.progressiveLoad) {
    this.buildAllItems();
  }
};
BaseRenderer.prototype.buildElementParenting = function (element, parentName, hierarchy) {
  var elements = this.elements;
  var layers = this.layers;
  var i = 0;
  var len = layers.length;
  while (i < len) {
    if (layers[i].ind == parentName) { // eslint-disable-line eqeqeq
      if (!elements[i] || elements[i] === true) {
        this.buildItem(i);
        this.addPendingElement(element);
      } else {
        hierarchy.push(elements[i]);
        elements[i].setAsParent();
        if (layers[i].parent !== undefined) {
          this.buildElementParenting(element, layers[i].parent, hierarchy);
        } else {
          element.setHierarchy(hierarchy);
        }
      }
    }
    i += 1;
  }
};

BaseRenderer.prototype.addPendingElement = function (element) {
  this.pendingElements.push(element);
};

BaseRenderer.prototype.searchExtraCompositions = function (assets) {
  var i;
  var len = assets.length;
  for (i = 0; i < len; i += 1) {
    if (assets[i].xt) {
      var comp = this.createComp(assets[i]);
      comp.initExpressions();
      this.globalData.projectInterface.registerComposition(comp);
    }
  }
};

BaseRenderer.prototype.setupGlobalData = function (animData, fontsContainer) {
  this.globalData.fontManager = new FontManager();
  this.globalData.fontManager.addChars(animData.chars);
  this.globalData.fontManager.addFonts(animData.fonts, fontsContainer);
  this.globalData.getAssetData = this.animationItem.getAssetData.bind(this.animationItem);
  this.globalData.getAssetsPath = this.animationItem.getAssetsPath.bind(this.animationItem);
  this.globalData.imageLoader = this.animationItem.imagePreloader;
  this.globalData.audioController = this.animationItem.audioController;
  this.globalData.frameId = 0;
  this.globalData.frameRate = animData.fr;
  this.globalData.nm = animData.nm;
  this.globalData.compSize = {
    w: animData.w,
    h: animData.h,
  };
};

/* global createElementID, extendPrototype, BaseRenderer, NullElement, SVGShapeElement, SVGTextLottieElement,
IImageElement, SVGCompElement, ISolidElement, createNS, locationHref, createSizedArray, expressionsPlugin */

function SVGRenderer(animationItem, config) {
  this.animationItem = animationItem;
  this.layers = null;
  this.renderedFrame = -1;
  this.svgElement = createNS('svg');
  var ariaLabel = '';
  if (config && config.title) {
    var titleElement = createNS('title');
    var titleId = createElementID();
    titleElement.setAttribute('id', titleId);
    titleElement.textContent = config.title;
    this.svgElement.appendChild(titleElement);
    ariaLabel += titleId;
  }
  if (config && config.description) {
    var descElement = createNS('desc');
    var descId = createElementID();
    descElement.setAttribute('id', descId);
    descElement.textContent = config.description;
    this.svgElement.appendChild(descElement);
    ariaLabel += ' ' + descId;
  }
  if (ariaLabel) {
    this.svgElement.setAttribute('aria-labelledby', ariaLabel);
  }
  var defs = createNS('defs');
  this.svgElement.appendChild(defs);
  var maskElement = createNS('g');
  this.svgElement.appendChild(maskElement);
  this.layerElement = maskElement;
  this.renderConfig = {
    preserveAspectRatio: (config && config.preserveAspectRatio) || 'xMidYMid meet',
    imagePreserveAspectRatio: (config && config.imagePreserveAspectRatio) || 'xMidYMid slice',
    progressiveLoad: (config && config.progressiveLoad) || false,
    hideOnTransparent: !((config && config.hideOnTransparent === false)),
    viewBoxOnly: (config && config.viewBoxOnly) || false,
    viewBoxSize: (config && config.viewBoxSize) || false,
    className: (config && config.className) || '',
    id: (config && config.id) || '',
    focusable: config && config.focusable,
    filterSize: {
      width: (config && config.filterSize && config.filterSize.width) || '100%',
      height: (config && config.filterSize && config.filterSize.height) || '100%',
      x: (config && config.filterSize && config.filterSize.x) || '0%',
      y: (config && config.filterSize && config.filterSize.y) || '0%',
    },
  };

  this.globalData = {
    _mdf: false,
    frameNum: -1,
    defs: defs,
    renderConfig: this.renderConfig,
  };
  this.elements = [];
  this.pendingElements = [];
  this.destroyed = false;
  this.rendererType = 'svg';
}

extendPrototype([BaseRenderer], SVGRenderer);

SVGRenderer.prototype.createNull = function (data) {
  return new NullElement(data, this.globalData, this);
};

SVGRenderer.prototype.createShape = function (data) {
  return new SVGShapeElement(data, this.globalData, this);
};

SVGRenderer.prototype.createText = function (data) {
  return new SVGTextLottieElement(data, this.globalData, this);
};

SVGRenderer.prototype.createImage = function (data) {
  return new IImageElement(data, this.globalData, this);
};

SVGRenderer.prototype.createComp = function (data) {
  return new SVGCompElement(data, this.globalData, this);
};

SVGRenderer.prototype.createSolid = function (data) {
  return new ISolidElement(data, this.globalData, this);
};

SVGRenderer.prototype.configAnimation = function (animData) {
  this.svgElement.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
  if (this.renderConfig.viewBoxSize) {
    this.svgElement.setAttribute('viewBox', this.renderConfig.viewBoxSize);
  } else {
    this.svgElement.setAttribute('viewBox', '0 0 ' + animData.w + ' ' + animData.h);
  }

  if (!this.renderConfig.viewBoxOnly) {
    this.svgElement.setAttribute('width', animData.w);
    this.svgElement.setAttribute('height', animData.h);
    this.svgElement.style.width = '100%';
    this.svgElement.style.height = '100%';
    this.svgElement.style.transform = 'translate3d(0,0,0)';
  }
  if (this.renderConfig.className) {
    this.svgElement.setAttribute('class', this.renderConfig.className);
  }
  if (this.renderConfig.id) {
    this.svgElement.setAttribute('id', this.renderConfig.id);
  }
  if (this.renderConfig.focusable !== undefined) {
    this.svgElement.setAttribute('focusable', this.renderConfig.focusable);
  }
  this.svgElement.setAttribute('preserveAspectRatio', this.renderConfig.preserveAspectRatio);
  // this.layerElement.style.transform = 'translate3d(0,0,0)';
  // this.layerElement.style.transformOrigin = this.layerElement.style.mozTransformOrigin = this.layerElement.style.webkitTransformOrigin = this.layerElement.style['-webkit-transform'] = "0px 0px 0px";
  this.animationItem.wrapper.appendChild(this.svgElement);
  // Mask animation
  var defs = this.globalData.defs;

  this.setupGlobalData(animData, defs);
  this.globalData.progressiveLoad = this.renderConfig.progressiveLoad;
  this.data = animData;

  var maskElement = createNS('clipPath');
  var rect = createNS('rect');
  rect.setAttribute('width', animData.w);
  rect.setAttribute('height', animData.h);
  rect.setAttribute('x', 0);
  rect.setAttribute('y', 0);
  var maskId = createElementID();
  maskElement.setAttribute('id', maskId);
  maskElement.appendChild(rect);
  this.layerElement.setAttribute('clip-path', 'url(' + locationHref + '#' + maskId + ')');

  defs.appendChild(maskElement);
  this.layers = animData.layers;
  this.elements = createSizedArray(animData.layers.length);
};

SVGRenderer.prototype.destroy = function () {
  if (this.animationItem.wrapper) {
    this.animationItem.wrapper.innerText = '';
  }
  this.layerElement = null;
  this.globalData.defs = null;
  var i;
  var len = this.layers ? this.layers.length : 0;
  for (i = 0; i < len; i += 1) {
    if (this.elements[i]) {
      this.elements[i].destroy();
    }
  }
  this.elements.length = 0;
  this.destroyed = true;
  this.animationItem = null;
};

SVGRenderer.prototype.updateContainerSize = function () {
};

SVGRenderer.prototype.buildItem = function (pos) {
  var elements = this.elements;
  if (elements[pos] || this.layers[pos].ty === 99) {
    return;
  }
  elements[pos] = true;
  var element = this.createItem(this.layers[pos]);

  elements[pos] = element;
  if (expressionsPlugin) {
    if (this.layers[pos].ty === 0) {
      this.globalData.projectInterface.registerComposition(element);
    }
    element.initExpressions();
  }
  this.appendElementInPos(element, pos);
  if (this.layers[pos].tt) {
    if (!this.elements[pos - 1] || this.elements[pos - 1] === true) {
      this.buildItem(pos - 1);
      this.addPendingElement(element);
    } else {
      element.setMatte(elements[pos - 1].layerId);
    }
  }
};

SVGRenderer.prototype.checkPendingElements = function () {
  while (this.pendingElements.length) {
    var element = this.pendingElements.pop();
    element.checkParenting();
    if (element.data.tt) {
      var i = 0;
      var len = this.elements.length;
      while (i < len) {
        if (this.elements[i] === element) {
          element.setMatte(this.elements[i - 1].layerId);
          break;
        }
        i += 1;
      }
    }
  }
};

SVGRenderer.prototype.renderFrame = function (num) {
  if (this.renderedFrame === num || this.destroyed) {
    return;
  }
  if (num === null) {
    num = this.renderedFrame;
  } else {
    this.renderedFrame = num;
  }
  // console.log('-------');
  // console.log('FRAME ',num);
  this.globalData.frameNum = num;
  this.globalData.frameId += 1;
  this.globalData.projectInterface.currentFrame = num;
  this.globalData._mdf = false;
  var i;
  var len = this.layers.length;
  if (!this.completeLayers) {
    this.checkLayers(num);
  }
  for (i = len - 1; i >= 0; i -= 1) {
    if (this.completeLayers || this.elements[i]) {
      this.elements[i].prepareFrame(num - this.layers[i].st);
    }
  }
  if (this.globalData._mdf) {
    for (i = 0; i < len; i += 1) {
      if (this.completeLayers || this.elements[i]) {
        this.elements[i].renderFrame();
      }
    }
  }
};

SVGRenderer.prototype.appendElementInPos = function (element, pos) {
  var newElement = element.getBaseElement();
  if (!newElement) {
    return;
  }
  var i = 0;
  var nextElement;
  while (i < pos) {
    if (this.elements[i] && this.elements[i] !== true && this.elements[i].getBaseElement()) {
      nextElement = this.elements[i].getBaseElement();
    }
    i += 1;
  }
  if (nextElement) {
    this.layerElement.insertBefore(newElement, nextElement);
  } else {
    this.layerElement.appendChild(newElement);
  }
};

SVGRenderer.prototype.hide = function () {
  this.layerElement.style.display = 'none';
};

SVGRenderer.prototype.show = function () {
  this.layerElement.style.display = 'block';
};

/* global CVContextData, Matrix, extendPrototype, BaseRenderer, CVShapeElement, CVTextElement,
CVImageElement, CVCompElement, CVSolidElement, SVGRenderer, createTag, createSizedArray */

function CanvasRenderer(animationItem, config) {
  this.animationItem = animationItem;
  this.renderConfig = {
    clearCanvas: (config && config.clearCanvas !== undefined) ? config.clearCanvas : true,
    context: (config && config.context) || null,
    progressiveLoad: (config && config.progressiveLoad) || false,
    preserveAspectRatio: (config && config.preserveAspectRatio) || 'xMidYMid meet',
    imagePreserveAspectRatio: (config && config.imagePreserveAspectRatio) || 'xMidYMid slice',
    className: (config && config.className) || '',
    id: (config && config.id) || '',
  };
  this.renderConfig.dpr = (config && config.dpr) || 1;
  if (this.animationItem.wrapper) {
    this.renderConfig.dpr = (config && config.dpr) || window.devicePixelRatio || 1;
  }
  this.renderedFrame = -1;
  this.globalData = {
    frameNum: -1,
    _mdf: false,
    renderConfig: this.renderConfig,
    currentGlobalAlpha: -1,
  };
  this.contextData = new CVContextData();
  this.elements = [];
  this.pendingElements = [];
  this.transformMat = new Matrix();
  this.completeLayers = false;
  this.rendererType = 'canvas';
}
extendPrototype([BaseRenderer], CanvasRenderer);

CanvasRenderer.prototype.createShape = function (data) {
  return new CVShapeElement(data, this.globalData, this);
};

CanvasRenderer.prototype.createText = function (data) {
  return new CVTextElement(data, this.globalData, this);
};

CanvasRenderer.prototype.createImage = function (data) {
  return new CVImageElement(data, this.globalData, this);
};

CanvasRenderer.prototype.createComp = function (data) {
  return new CVCompElement(data, this.globalData, this);
};

CanvasRenderer.prototype.createSolid = function (data) {
  return new CVSolidElement(data, this.globalData, this);
};

CanvasRenderer.prototype.createNull = SVGRenderer.prototype.createNull;

CanvasRenderer.prototype.ctxTransform = function (props) {
  if (props[0] === 1 && props[1] === 0 && props[4] === 0 && props[5] === 1 && props[12] === 0 && props[13] === 0) {
    return;
  }
  if (!this.renderConfig.clearCanvas) {
    this.canvasContext.transform(props[0], props[1], props[4], props[5], props[12], props[13]);
    return;
  }
  this.transformMat.cloneFromProps(props);
  var cProps = this.contextData.cTr.props;
  this.transformMat.transform(cProps[0], cProps[1], cProps[2], cProps[3], cProps[4], cProps[5], cProps[6], cProps[7], cProps[8], cProps[9], cProps[10], cProps[11], cProps[12], cProps[13], cProps[14], cProps[15]);
  // this.contextData.cTr.transform(props[0],props[1],props[2],props[3],props[4],props[5],props[6],props[7],props[8],props[9],props[10],props[11],props[12],props[13],props[14],props[15]);
  this.contextData.cTr.cloneFromProps(this.transformMat.props);
  var trProps = this.contextData.cTr.props;
  this.canvasContext.setTransform(trProps[0], trProps[1], trProps[4], trProps[5], trProps[12], trProps[13]);
};

CanvasRenderer.prototype.ctxOpacity = function (op) {
  /* if(op === 1){
        return;
    } */
  if (!this.renderConfig.clearCanvas) {
    this.canvasContext.globalAlpha *= op < 0 ? 0 : op;
    this.globalData.currentGlobalAlpha = this.contextData.cO;
    return;
  }
  this.contextData.cO *= op < 0 ? 0 : op;
  if (this.globalData.currentGlobalAlpha !== this.contextData.cO) {
    this.canvasContext.globalAlpha = this.contextData.cO;
    this.globalData.currentGlobalAlpha = this.contextData.cO;
  }
};

CanvasRenderer.prototype.reset = function () {
  if (!this.renderConfig.clearCanvas) {
    this.canvasContext.restore();
    return;
  }
  this.contextData.reset();
};

CanvasRenderer.prototype.save = function (actionFlag) {
  if (!this.renderConfig.clearCanvas) {
    this.canvasContext.save();
    return;
  }
  if (actionFlag) {
    this.canvasContext.save();
  }
  var props = this.contextData.cTr.props;
  if (this.contextData._length <= this.contextData.cArrPos) {
    this.contextData.duplicate();
  }
  var i;
  var arr = this.contextData.saved[this.contextData.cArrPos];
  for (i = 0; i < 16; i += 1) {
    arr[i] = props[i];
  }
  this.contextData.savedOp[this.contextData.cArrPos] = this.contextData.cO;
  this.contextData.cArrPos += 1;
};

CanvasRenderer.prototype.restore = function (actionFlag) {
  if (!this.renderConfig.clearCanvas) {
    this.canvasContext.restore();
    return;
  }
  if (actionFlag) {
    this.canvasContext.restore();
    this.globalData.blendMode = 'source-over';
  }
  this.contextData.cArrPos -= 1;
  var popped = this.contextData.saved[this.contextData.cArrPos];
  var i;
  var arr = this.contextData.cTr.props;
  for (i = 0; i < 16; i += 1) {
    arr[i] = popped[i];
  }
  this.canvasContext.setTransform(popped[0], popped[1], popped[4], popped[5], popped[12], popped[13]);
  popped = this.contextData.savedOp[this.contextData.cArrPos];
  this.contextData.cO = popped;
  if (this.globalData.currentGlobalAlpha !== popped) {
    this.canvasContext.globalAlpha = popped;
    this.globalData.currentGlobalAlpha = popped;
  }
};

CanvasRenderer.prototype.configAnimation = function (animData) {
  if (this.animationItem.wrapper) {
    this.animationItem.container = createTag('canvas');
    var containerStyle = this.animationItem.container.style;
    containerStyle.width = '100%';
    containerStyle.height = '100%';
    var origin = '0px 0px 0px';
    containerStyle.transformOrigin = origin;
    containerStyle.mozTransformOrigin = origin;
    containerStyle.webkitTransformOrigin = origin;
    containerStyle['-webkit-transform'] = origin;
    this.animationItem.wrapper.appendChild(this.animationItem.container);
    this.canvasContext = this.animationItem.container.getContext('2d');
    if (this.renderConfig.className) {
      this.animationItem.container.setAttribute('class', this.renderConfig.className);
    }
    if (this.renderConfig.id) {
      this.animationItem.container.setAttribute('id', this.renderConfig.id);
    }
  } else {
    this.canvasContext = this.renderConfig.context;
  }
  this.data = animData;
  this.layers = animData.layers;
  this.transformCanvas = {
    w: animData.w,
    h: animData.h,
    sx: 0,
    sy: 0,
    tx: 0,
    ty: 0,
  };
  this.setupGlobalData(animData, document.body);
  this.globalData.canvasContext = this.canvasContext;
  this.globalData.renderer = this;
  this.globalData.isDashed = false;
  this.globalData.progressiveLoad = this.renderConfig.progressiveLoad;
  this.globalData.transformCanvas = this.transformCanvas;
  this.elements = createSizedArray(animData.layers.length);

  this.updateContainerSize();
};

CanvasRenderer.prototype.updateContainerSize = function () {
  this.reset();
  var elementWidth;
  var elementHeight;
  if (this.animationItem.wrapper && this.animationItem.container) {
    elementWidth = this.animationItem.wrapper.offsetWidth;
    elementHeight = this.animationItem.wrapper.offsetHeight;
    this.animationItem.container.setAttribute('width', elementWidth * this.renderConfig.dpr);
    this.animationItem.container.setAttribute('height', elementHeight * this.renderConfig.dpr);
  } else {
    elementWidth = this.canvasContext.canvas.width * this.renderConfig.dpr;
    elementHeight = this.canvasContext.canvas.height * this.renderConfig.dpr;
  }
  var elementRel;
  var animationRel;
  if (this.renderConfig.preserveAspectRatio.indexOf('meet') !== -1 || this.renderConfig.preserveAspectRatio.indexOf('slice') !== -1) {
    var par = this.renderConfig.preserveAspectRatio.split(' ');
    var fillType = par[1] || 'meet';
    var pos = par[0] || 'xMidYMid';
    var xPos = pos.substr(0, 4);
    var yPos = pos.substr(4);
    elementRel = elementWidth / elementHeight;
    animationRel = this.transformCanvas.w / this.transformCanvas.h;
    if ((animationRel > elementRel && fillType === 'meet') || (animationRel < elementRel && fillType === 'slice')) {
      this.transformCanvas.sx = elementWidth / (this.transformCanvas.w / this.renderConfig.dpr);
      this.transformCanvas.sy = elementWidth / (this.transformCanvas.w / this.renderConfig.dpr);
    } else {
      this.transformCanvas.sx = elementHeight / (this.transformCanvas.h / this.renderConfig.dpr);
      this.transformCanvas.sy = elementHeight / (this.transformCanvas.h / this.renderConfig.dpr);
    }

    if (xPos === 'xMid' && ((animationRel < elementRel && fillType === 'meet') || (animationRel > elementRel && fillType === 'slice'))) {
      this.transformCanvas.tx = ((elementWidth - this.transformCanvas.w * (elementHeight / this.transformCanvas.h)) / 2) * this.renderConfig.dpr;
    } else if (xPos === 'xMax' && ((animationRel < elementRel && fillType === 'meet') || (animationRel > elementRel && fillType === 'slice'))) {
      this.transformCanvas.tx = (elementWidth - this.transformCanvas.w * (elementHeight / this.transformCanvas.h)) * this.renderConfig.dpr;
    } else {
      this.transformCanvas.tx = 0;
    }
    if (yPos === 'YMid' && ((animationRel > elementRel && fillType === 'meet') || (animationRel < elementRel && fillType === 'slice'))) {
      this.transformCanvas.ty = ((elementHeight - this.transformCanvas.h * (elementWidth / this.transformCanvas.w)) / 2) * this.renderConfig.dpr;
    } else if (yPos === 'YMax' && ((animationRel > elementRel && fillType === 'meet') || (animationRel < elementRel && fillType === 'slice'))) {
      this.transformCanvas.ty = ((elementHeight - this.transformCanvas.h * (elementWidth / this.transformCanvas.w))) * this.renderConfig.dpr;
    } else {
      this.transformCanvas.ty = 0;
    }
  } else if (this.renderConfig.preserveAspectRatio === 'none') {
    this.transformCanvas.sx = elementWidth / (this.transformCanvas.w / this.renderConfig.dpr);
    this.transformCanvas.sy = elementHeight / (this.transformCanvas.h / this.renderConfig.dpr);
    this.transformCanvas.tx = 0;
    this.transformCanvas.ty = 0;
  } else {
    this.transformCanvas.sx = this.renderConfig.dpr;
    this.transformCanvas.sy = this.renderConfig.dpr;
    this.transformCanvas.tx = 0;
    this.transformCanvas.ty = 0;
  }
  this.transformCanvas.props = [this.transformCanvas.sx, 0, 0, 0, 0, this.transformCanvas.sy, 0, 0, 0, 0, 1, 0, this.transformCanvas.tx, this.transformCanvas.ty, 0, 1];
  /* var i, len = this.elements.length;
    for(i=0;i<len;i+=1){
        if(this.elements[i] && this.elements[i].data.ty === 0){
            this.elements[i].resize(this.globalData.transformCanvas);
        }
    } */
  this.ctxTransform(this.transformCanvas.props);
  this.canvasContext.beginPath();
  this.canvasContext.rect(0, 0, this.transformCanvas.w, this.transformCanvas.h);
  this.canvasContext.closePath();
  this.canvasContext.clip();

  this.renderFrame(this.renderedFrame, true);
};

CanvasRenderer.prototype.destroy = function () {
  if (this.renderConfig.clearCanvas && this.animationItem.wrapper) {
    this.animationItem.wrapper.innerText = '';
  }
  var i;
  var len = this.layers ? this.layers.length : 0;
  for (i = len - 1; i >= 0; i -= 1) {
    if (this.elements[i]) {
      this.elements[i].destroy();
    }
  }
  this.elements.length = 0;
  this.globalData.canvasContext = null;
  this.animationItem.container = null;
  this.destroyed = true;
};

CanvasRenderer.prototype.renderFrame = function (num, forceRender) {
  if ((this.renderedFrame === num && this.renderConfig.clearCanvas === true && !forceRender) || this.destroyed || num === -1) {
    return;
  }
  this.renderedFrame = num;
  this.globalData.frameNum = num - this.animationItem._isFirstFrame;
  this.globalData.frameId += 1;
  this.globalData._mdf = !this.renderConfig.clearCanvas || forceRender;
  this.globalData.projectInterface.currentFrame = num;

  // console.log('--------');
  // console.log('NEW: ',num);
  var i;
  var len = this.layers.length;
  if (!this.completeLayers) {
    this.checkLayers(num);
  }

  for (i = 0; i < len; i += 1) {
    if (this.completeLayers || this.elements[i]) {
      this.elements[i].prepareFrame(num - this.layers[i].st);
    }
  }
  if (this.globalData._mdf) {
    if (this.renderConfig.clearCanvas === true) {
      this.canvasContext.clearRect(0, 0, this.transformCanvas.w, this.transformCanvas.h);
    } else {
      this.save();
    }
    for (i = len - 1; i >= 0; i -= 1) {
      if (this.completeLayers || this.elements[i]) {
        this.elements[i].renderFrame();
      }
    }
    if (this.renderConfig.clearCanvas !== true) {
      this.restore();
    }
  }
};

CanvasRenderer.prototype.buildItem = function (pos) {
  var elements = this.elements;
  if (elements[pos] || this.layers[pos].ty === 99) {
    return;
  }
  var element = this.createItem(this.layers[pos], this, this.globalData);
  elements[pos] = element;
  element.initExpressions();
  /* if(this.layers[pos].ty === 0){
        element.resize(this.globalData.transformCanvas);
    } */
};

CanvasRenderer.prototype.checkPendingElements = function () {
  while (this.pendingElements.length) {
    var element = this.pendingElements.pop();
    element.checkParenting();
  }
};

CanvasRenderer.prototype.hide = function () {
  this.animationItem.container.style.display = 'none';
};

CanvasRenderer.prototype.show = function () {
  this.animationItem.container.style.display = 'block';
};

/* global extendPrototype, BaseRenderer, SVGRenderer, SVGShapeElement, HShapeElement, SVGTextLottieElement,
HTextElement, HCameraElement, IImageElement, HImageElement, SVGCompElement, HCompElement, ISolidElement,
HSolidElement, styleDiv, createTag, createNS */

function HybridRenderer(animationItem, config) {
  this.animationItem = animationItem;
  this.layers = null;
  this.renderedFrame = -1;
  this.renderConfig = {
    className: (config && config.className) || '',
    imagePreserveAspectRatio: (config && config.imagePreserveAspectRatio) || 'xMidYMid slice',
    hideOnTransparent: !(config && config.hideOnTransparent === false),
    filterSize: {
      width: (config && config.filterSize && config.filterSize.width) || '400%',
      height: (config && config.filterSize && config.filterSize.height) || '400%',
      x: (config && config.filterSize && config.filterSize.x) || '-100%',
      y: (config && config.filterSize && config.filterSize.y) || '-100%',
    },
  };
  this.globalData = {
    _mdf: false,
    frameNum: -1,
    renderConfig: this.renderConfig,
  };
  this.pendingElements = [];
  this.elements = [];
  this.threeDElements = [];
  this.destroyed = false;
  this.camera = null;
  this.supports3d = true;
  this.rendererType = 'html';
}

extendPrototype([BaseRenderer], HybridRenderer);

HybridRenderer.prototype.buildItem = SVGRenderer.prototype.buildItem;

HybridRenderer.prototype.checkPendingElements = function () {
  while (this.pendingElements.length) {
    var element = this.pendingElements.pop();
    element.checkParenting();
  }
};

HybridRenderer.prototype.appendElementInPos = function (element, pos) {
  var newDOMElement = element.getBaseElement();
  if (!newDOMElement) {
    return;
  }
  var layer = this.layers[pos];
  if (!layer.ddd || !this.supports3d) {
    if (this.threeDElements) {
      this.addTo3dContainer(newDOMElement, pos);
    } else {
      var i = 0;
      var nextDOMElement;
      var nextLayer;
      var tmpDOMElement;
      while (i < pos) {
        if (this.elements[i] && this.elements[i] !== true && this.elements[i].getBaseElement) {
          nextLayer = this.elements[i];
          tmpDOMElement = this.layers[i].ddd ? this.getThreeDContainerByPos(i) : nextLayer.getBaseElement();
          nextDOMElement = tmpDOMElement || nextDOMElement;
        }
        i += 1;
      }
      if (nextDOMElement) {
        if (!layer.ddd || !this.supports3d) {
          this.layerElement.insertBefore(newDOMElement, nextDOMElement);
        }
      } else if (!layer.ddd || !this.supports3d) {
        this.layerElement.appendChild(newDOMElement);
      }
    }
  } else {
    this.addTo3dContainer(newDOMElement, pos);
  }
};

HybridRenderer.prototype.createShape = function (data) {
  if (!this.supports3d) {
    return new SVGShapeElement(data, this.globalData, this);
  }
  return new HShapeElement(data, this.globalData, this);
};

HybridRenderer.prototype.createText = function (data) {
  if (!this.supports3d) {
    return new SVGTextLottieElement(data, this.globalData, this);
  }
  return new HTextElement(data, this.globalData, this);
};

HybridRenderer.prototype.createCamera = function (data) {
  this.camera = new HCameraElement(data, this.globalData, this);
  return this.camera;
};

HybridRenderer.prototype.createImage = function (data) {
  if (!this.supports3d) {
    return new IImageElement(data, this.globalData, this);
  }
  return new HImageElement(data, this.globalData, this);
};

HybridRenderer.prototype.createComp = function (data) {
  if (!this.supports3d) {
    return new SVGCompElement(data, this.globalData, this);
  }
  return new HCompElement(data, this.globalData, this);
};

HybridRenderer.prototype.createSolid = function (data) {
  if (!this.supports3d) {
    return new ISolidElement(data, this.globalData, this);
  }
  return new HSolidElement(data, this.globalData, this);
};

HybridRenderer.prototype.createNull = SVGRenderer.prototype.createNull;

HybridRenderer.prototype.getThreeDContainerByPos = function (pos) {
  var i = 0;
  var len = this.threeDElements.length;
  while (i < len) {
    if (this.threeDElements[i].startPos <= pos && this.threeDElements[i].endPos >= pos) {
      return this.threeDElements[i].perspectiveElem;
    }
    i += 1;
  }
  return null;
};

HybridRenderer.prototype.createThreeDContainer = function (pos, type) {
  var perspectiveElem = createTag('div');
  var style;
  var containerStyle;
  styleDiv(perspectiveElem);
  var container = createTag('div');
  styleDiv(container);
  if (type === '3d') {
    style = perspectiveElem.style;
    style.width = this.globalData.compSize.w + 'px';
    style.height = this.globalData.compSize.h + 'px';
    var center = '50% 50%';
    style.webkitTransformOrigin = center;
    style.mozTransformOrigin = center;
    style.transformOrigin = center;
    containerStyle = container.style;
    var matrix = 'matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)';
    containerStyle.transform = matrix;
    containerStyle.webkitTransform = matrix;
  }

  perspectiveElem.appendChild(container);
  // this.resizerElem.appendChild(perspectiveElem);
  var threeDContainerData = {
    container: container,
    perspectiveElem: perspectiveElem,
    startPos: pos,
    endPos: pos,
    type: type,
  };
  this.threeDElements.push(threeDContainerData);
  return threeDContainerData;
};

HybridRenderer.prototype.build3dContainers = function () {
  var i;
  var len = this.layers.length;
  var lastThreeDContainerData;
  var currentContainer = '';
  for (i = 0; i < len; i += 1) {
    if (this.layers[i].ddd && this.layers[i].ty !== 3) {
      if (currentContainer !== '3d') {
        currentContainer = '3d';
        lastThreeDContainerData = this.createThreeDContainer(i, '3d');
      }
      lastThreeDContainerData.endPos = Math.max(lastThreeDContainerData.endPos, i);
    } else {
      if (currentContainer !== '2d') {
        currentContainer = '2d';
        lastThreeDContainerData = this.createThreeDContainer(i, '2d');
      }
      lastThreeDContainerData.endPos = Math.max(lastThreeDContainerData.endPos, i);
    }
  }
  len = this.threeDElements.length;
  for (i = len - 1; i >= 0; i -= 1) {
    this.resizerElem.appendChild(this.threeDElements[i].perspectiveElem);
  }
};

HybridRenderer.prototype.addTo3dContainer = function (elem, pos) {
  var i = 0;
  var len = this.threeDElements.length;
  while (i < len) {
    if (pos <= this.threeDElements[i].endPos) {
      var j = this.threeDElements[i].startPos;
      var nextElement;
      while (j < pos) {
        if (this.elements[j] && this.elements[j].getBaseElement) {
          nextElement = this.elements[j].getBaseElement();
        }
        j += 1;
      }
      if (nextElement) {
        this.threeDElements[i].container.insertBefore(elem, nextElement);
      } else {
        this.threeDElements[i].container.appendChild(elem);
      }
      break;
    }
    i += 1;
  }
};

HybridRenderer.prototype.configAnimation = function (animData) {
  var resizerElem = createTag('div');
  var wrapper = this.animationItem.wrapper;
  var style = resizerElem.style;
  style.width = animData.w + 'px';
  style.height = animData.h + 'px';
  this.resizerElem = resizerElem;
  styleDiv(resizerElem);
  style.transformStyle = 'flat';
  style.mozTransformStyle = 'flat';
  style.webkitTransformStyle = 'flat';
  if (this.renderConfig.className) {
    resizerElem.setAttribute('class', this.renderConfig.className);
  }
  wrapper.appendChild(resizerElem);

  style.overflow = 'hidden';
  var svg = createNS('svg');
  svg.setAttribute('width', '1');
  svg.setAttribute('height', '1');
  styleDiv(svg);
  this.resizerElem.appendChild(svg);
  var defs = createNS('defs');
  svg.appendChild(defs);
  this.data = animData;
  // Mask animation
  this.setupGlobalData(animData, svg);
  this.globalData.defs = defs;
  this.layers = animData.layers;
  this.layerElement = this.resizerElem;
  this.build3dContainers();
  this.updateContainerSize();
};

HybridRenderer.prototype.destroy = function () {
  if (this.animationItem.wrapper) {
    this.animationItem.wrapper.innerText = '';
  }
  this.animationItem.container = null;
  this.globalData.defs = null;
  var i;
  var len = this.layers ? this.layers.length : 0;
  for (i = 0; i < len; i += 1) {
    this.elements[i].destroy();
  }
  this.elements.length = 0;
  this.destroyed = true;
  this.animationItem = null;
};

HybridRenderer.prototype.updateContainerSize = function () {
  var elementWidth = this.animationItem.wrapper.offsetWidth;
  var elementHeight = this.animationItem.wrapper.offsetHeight;
  var elementRel = elementWidth / elementHeight;
  var animationRel = this.globalData.compSize.w / this.globalData.compSize.h;
  var sx;
  var sy;
  var tx;
  var ty;
  if (animationRel > elementRel) {
    sx = elementWidth / (this.globalData.compSize.w);
    sy = elementWidth / (this.globalData.compSize.w);
    tx = 0;
    ty = ((elementHeight - this.globalData.compSize.h * (elementWidth / this.globalData.compSize.w)) / 2);
  } else {
    sx = elementHeight / (this.globalData.compSize.h);
    sy = elementHeight / (this.globalData.compSize.h);
    tx = (elementWidth - this.globalData.compSize.w * (elementHeight / this.globalData.compSize.h)) / 2;
    ty = 0;
  }
  var style = this.resizerElem.style;
  style.webkitTransform = 'matrix3d(' + sx + ',0,0,0,0,' + sy + ',0,0,0,0,1,0,' + tx + ',' + ty + ',0,1)';
  style.transform = style.webkitTransform;
};

HybridRenderer.prototype.renderFrame = SVGRenderer.prototype.renderFrame;

HybridRenderer.prototype.hide = function () {
  this.resizerElem.style.display = 'none';
};

HybridRenderer.prototype.show = function () {
  this.resizerElem.style.display = 'block';
};

HybridRenderer.prototype.initItems = function () {
  this.buildAllItems();
  if (this.camera) {
    this.camera.setup();
  } else {
    var cWidth = this.globalData.compSize.w;
    var cHeight = this.globalData.compSize.h;
    var i;
    var len = this.threeDElements.length;
    for (i = 0; i < len; i += 1) {
      var style = this.threeDElements[i].perspectiveElem.style;
      style.webkitPerspective = Math.sqrt(Math.pow(cWidth, 2) + Math.pow(cHeight, 2)) + 'px';
      style.perspective = style.webkitPerspective;
    }
  }
};

HybridRenderer.prototype.searchExtraCompositions = function (assets) {
  var i;
  var len = assets.length;
  var floatingContainer = createTag('div');
  for (i = 0; i < len; i += 1) {
    if (assets[i].xt) {
      var comp = this.createComp(assets[i], floatingContainer, this.globalData.comp, null);
      comp.initExpressions();
      this.globalData.projectInterface.registerComposition(comp);
    }
  }
};

/* global createSizedArray, createElementID, PropertyFactory, ShapePropertyFactory, createNS, locationHref */

function MaskElement(data, element, globalData) {
  this.data = data;
  this.element = element;
  this.globalData = globalData;
  this.storedData = [];
  this.masksProperties = this.data.masksProperties || [];
  this.maskElement = null;
  var defs = this.globalData.defs;
  var i;
  var len = this.masksProperties ? this.masksProperties.length : 0;
  this.viewData = createSizedArray(len);
  this.solidPath = '';

  var path;
  var properties = this.masksProperties;
  var count = 0;
  var currentMasks = [];
  var j;
  var jLen;
  var layerId = createElementID();
  var rect;
  var expansor;
  var feMorph;
  var x;
  var maskType = 'clipPath';
  var maskRef = 'clip-path';
  for (i = 0; i < len; i += 1) {
    if ((properties[i].mode !== 'a' && properties[i].mode !== 'n') || properties[i].inv || properties[i].o.k !== 100 || properties[i].o.x) {
      maskType = 'mask';
      maskRef = 'mask';
    }

    if ((properties[i].mode === 's' || properties[i].mode === 'i') && count === 0) {
      rect = createNS('rect');
      rect.setAttribute('fill', '#ffffff');
      rect.setAttribute('width', this.element.comp.data.w || 0);
      rect.setAttribute('height', this.element.comp.data.h || 0);
      currentMasks.push(rect);
    } else {
      rect = null;
    }

    path = createNS('path');
    if (properties[i].mode === 'n') {
      // TODO move this to a factory or to a constructor
      this.viewData[i] = {
        op: PropertyFactory.getProp(this.element, properties[i].o, 0, 0.01, this.element),
        prop: ShapePropertyFactory.getShapeProp(this.element, properties[i], 3),
        elem: path,
        lastPath: '',
      };
      defs.appendChild(path);
    } else {
      count += 1;

      path.setAttribute('fill', properties[i].mode === 's' ? '#000000' : '#ffffff');
      path.setAttribute('clip-rule', 'nonzero');
      var filterID;

      if (properties[i].x.k !== 0) {
        maskType = 'mask';
        maskRef = 'mask';
        x = PropertyFactory.getProp(this.element, properties[i].x, 0, null, this.element);
        filterID = createElementID();
        expansor = createNS('filter');
        expansor.setAttribute('id', filterID);
        feMorph = createNS('feMorphology');
        feMorph.setAttribute('operator', 'erode');
        feMorph.setAttribute('in', 'SourceGraphic');
        feMorph.setAttribute('radius', '0');
        expansor.appendChild(feMorph);
        defs.appendChild(expansor);
        path.setAttribute('stroke', properties[i].mode === 's' ? '#000000' : '#ffffff');
      } else {
        feMorph = null;
        x = null;
      }

      // TODO move this to a factory or to a constructor
      this.storedData[i] = {
        elem: path,
        x: x,
        expan: feMorph,
        lastPath: '',
        lastOperator: '',
        filterId: filterID,
        lastRadius: 0,
      };
      if (properties[i].mode === 'i') {
        jLen = currentMasks.length;
        var g = createNS('g');
        for (j = 0; j < jLen; j += 1) {
          g.appendChild(currentMasks[j]);
        }
        var mask = createNS('mask');
        mask.setAttribute('mask-type', 'alpha');
        mask.setAttribute('id', layerId + '_' + count);
        mask.appendChild(path);
        defs.appendChild(mask);
        g.setAttribute('mask', 'url(' + locationHref + '#' + layerId + '_' + count + ')');

        currentMasks.length = 0;
        currentMasks.push(g);
      } else {
        currentMasks.push(path);
      }
      if (properties[i].inv && !this.solidPath) {
        this.solidPath = this.createLayerSolidPath();
      }
      // TODO move this to a factory or to a constructor
      this.viewData[i] = {
        elem: path,
        lastPath: '',
        op: PropertyFactory.getProp(this.element, properties[i].o, 0, 0.01, this.element),
        prop: ShapePropertyFactory.getShapeProp(this.element, properties[i], 3),
        invRect: rect,
      };
      if (!this.viewData[i].prop.k) {
        this.drawPath(properties[i], this.viewData[i].prop.v, this.viewData[i]);
      }
    }
  }

  this.maskElement = createNS(maskType);

  len = currentMasks.length;
  for (i = 0; i < len; i += 1) {
    this.maskElement.appendChild(currentMasks[i]);
  }

  if (count > 0) {
    this.maskElement.setAttribute('id', layerId);
    this.element.maskedElement.setAttribute(maskRef, 'url(' + locationHref + '#' + layerId + ')');
    defs.appendChild(this.maskElement);
  }
  if (this.viewData.length) {
    this.element.addRenderableComponent(this);
  }
}

MaskElement.prototype.getMaskProperty = function (pos) {
  return this.viewData[pos].prop;
};

MaskElement.prototype.renderFrame = function (isFirstFrame) {
  var finalMat = this.element.finalTransform.mat;
  var i;
  var len = this.masksProperties.length;
  for (i = 0; i < len; i += 1) {
    if (this.viewData[i].prop._mdf || isFirstFrame) {
      this.drawPath(this.masksProperties[i], this.viewData[i].prop.v, this.viewData[i]);
    }
    if (this.viewData[i].op._mdf || isFirstFrame) {
      this.viewData[i].elem.setAttribute('fill-opacity', this.viewData[i].op.v);
    }
    if (this.masksProperties[i].mode !== 'n') {
      if (this.viewData[i].invRect && (this.element.finalTransform.mProp._mdf || isFirstFrame)) {
        this.viewData[i].invRect.setAttribute('transform', finalMat.getInverseMatrix().to2dCSS());
      }
      if (this.storedData[i].x && (this.storedData[i].x._mdf || isFirstFrame)) {
        var feMorph = this.storedData[i].expan;
        if (this.storedData[i].x.v < 0) {
          if (this.storedData[i].lastOperator !== 'erode') {
            this.storedData[i].lastOperator = 'erode';
            this.storedData[i].elem.setAttribute('filter', 'url(' + locationHref + '#' + this.storedData[i].filterId + ')');
          }
          feMorph.setAttribute('radius', -this.storedData[i].x.v);
        } else {
          if (this.storedData[i].lastOperator !== 'dilate') {
            this.storedData[i].lastOperator = 'dilate';
            this.storedData[i].elem.setAttribute('filter', null);
          }
          this.storedData[i].elem.setAttribute('stroke-width', this.storedData[i].x.v * 2);
        }
      }
    }
  }
};

MaskElement.prototype.getMaskelement = function () {
  return this.maskElement;
};

MaskElement.prototype.createLayerSolidPath = function () {
  var path = 'M0,0 ';
  path += ' h' + this.globalData.compSize.w;
  path += ' v' + this.globalData.compSize.h;
  path += ' h-' + this.globalData.compSize.w;
  path += ' v-' + this.globalData.compSize.h + ' ';
  return path;
};

MaskElement.prototype.drawPath = function (pathData, pathNodes, viewData) {
  var pathString = ' M' + pathNodes.v[0][0] + ',' + pathNodes.v[0][1];
  var i;
  var len;
  len = pathNodes._length;
  for (i = 1; i < len; i += 1) {
    // pathString += " C"+pathNodes.o[i-1][0]+','+pathNodes.o[i-1][1] + " "+pathNodes.i[i][0]+','+pathNodes.i[i][1] + " "+pathNodes.v[i][0]+','+pathNodes.v[i][1];
    pathString += ' C' + pathNodes.o[i - 1][0] + ',' + pathNodes.o[i - 1][1] + ' ' + pathNodes.i[i][0] + ',' + pathNodes.i[i][1] + ' ' + pathNodes.v[i][0] + ',' + pathNodes.v[i][1];
  }
  // pathString += " C"+pathNodes.o[i-1][0]+','+pathNodes.o[i-1][1] + " "+pathNodes.i[0][0]+','+pathNodes.i[0][1] + " "+pathNodes.v[0][0]+','+pathNodes.v[0][1];
  if (pathNodes.c && len > 1) {
    pathString += ' C' + pathNodes.o[i - 1][0] + ',' + pathNodes.o[i - 1][1] + ' ' + pathNodes.i[0][0] + ',' + pathNodes.i[0][1] + ' ' + pathNodes.v[0][0] + ',' + pathNodes.v[0][1];
  }
  // pathNodes.__renderedString = pathString;

  if (viewData.lastPath !== pathString) {
    var pathShapeValue = '';
    if (viewData.elem) {
      if (pathNodes.c) {
        pathShapeValue = pathData.inv ? this.solidPath + pathString : pathString;
      }
      viewData.elem.setAttribute('d', pathShapeValue);
    }
    viewData.lastPath = pathString;
  }
};

MaskElement.prototype.destroy = function () {
  this.element = null;
  this.globalData = null;
  this.maskElement = null;
  this.data = null;
  this.masksProperties = null;
};

/**
 * @file
 * Handles AE's layer parenting property.
 *
 */

function HierarchyElement() {}

HierarchyElement.prototype = {
  /**
     * @function
     * Initializes hierarchy properties
     *
     */
  initHierarchy: function () {
    // element's parent list
    this.hierarchy = [];
    // if element is parent of another layer _isParent will be true
    this._isParent = false;
    this.checkParenting();
  },
  /**
     * @function
     * Sets layer's hierarchy.
     * @param {array} hierarch
     * layer's parent list
     *
     */
  setHierarchy: function (hierarchy) {
    this.hierarchy = hierarchy;
  },
  /**
     * @function
     * Sets layer as parent.
     *
     */
  setAsParent: function () {
    this._isParent = true;
  },
  /**
     * @function
     * Searches layer's parenting chain
     *
     */
  checkParenting: function () {
    if (this.data.parent !== undefined) {
      this.comp.buildElementParenting(this, this.data.parent, []);
    }
  },
};

/**
 * @file
 * Handles element's layer frame update.
 * Checks layer in point and out point
 *
 */

function FrameElement() {}

FrameElement.prototype = {
  /**
     * @function
     * Initializes frame related properties.
     *
     */
  initFrame: function () {
    // set to true when inpoint is rendered
    this._isFirstFrame = false;
    // list of animated properties
    this.dynamicProperties = [];
    // If layer has been modified in current tick this will be true
    this._mdf = false;
  },
  /**
     * @function
     * Calculates all dynamic values
     *
     * @param {number} num
     * current frame number in Layer's time
     * @param {boolean} isVisible
     * if layers is currently in range
     *
     */
  prepareProperties: function (num, isVisible) {
    var i;
    var len = this.dynamicProperties.length;
    for (i = 0; i < len; i += 1) {
      if (isVisible || (this._isParent && this.dynamicProperties[i].propType === 'transform')) {
        this.dynamicProperties[i].getValue();
        if (this.dynamicProperties[i]._mdf) {
          this.globalData._mdf = true;
          this._mdf = true;
        }
      }
    }
  },
  addDynamicProperty: function (prop) {
    if (this.dynamicProperties.indexOf(prop) === -1) {
      this.dynamicProperties.push(prop);
    }
  },
};

/* global TransformPropertyFactory, Matrix */

function TransformElement() {}

TransformElement.prototype = {
  initTransform: function () {
    this.finalTransform = {
      mProp: this.data.ks ? TransformPropertyFactory.getTransformProperty(this, this.data.ks, this) : { o: 0 },
      _matMdf: false,
      _opMdf: false,
      mat: new Matrix(),
    };
    if (this.data.ao) {
      this.finalTransform.mProp.autoOriented = true;
    }

    // TODO: check TYPE 11: Guided elements
    if (this.data.ty !== 11) ;
  },
  renderTransform: function () {
    this.finalTransform._opMdf = this.finalTransform.mProp.o._mdf || this._isFirstFrame;
    this.finalTransform._matMdf = this.finalTransform.mProp._mdf || this._isFirstFrame;

    if (this.hierarchy) {
      var mat;
      var finalMat = this.finalTransform.mat;
      var i = 0;
      var len = this.hierarchy.length;
      // Checking if any of the transformation matrices in the hierarchy chain has changed.
      if (!this.finalTransform._matMdf) {
        while (i < len) {
          if (this.hierarchy[i].finalTransform.mProp._mdf) {
            this.finalTransform._matMdf = true;
            break;
          }
          i += 1;
        }
      }

      if (this.finalTransform._matMdf) {
        mat = this.finalTransform.mProp.v.props;
        finalMat.cloneFromProps(mat);
        for (i = 0; i < len; i += 1) {
          mat = this.hierarchy[i].finalTransform.mProp.v.props;
          finalMat.transform(mat[0], mat[1], mat[2], mat[3], mat[4], mat[5], mat[6], mat[7], mat[8], mat[9], mat[10], mat[11], mat[12], mat[13], mat[14], mat[15]);
        }
      }
    }
  },
  globalToLocal: function (pt) {
    var transforms = [];
    transforms.push(this.finalTransform);
    var flag = true;
    var comp = this.comp;
    while (flag) {
      if (comp.finalTransform) {
        if (comp.data.hasMask) {
          transforms.splice(0, 0, comp.finalTransform);
        }
        comp = comp.comp;
      } else {
        flag = false;
      }
    }
    var i;
    var len = transforms.length;
    var ptNew;
    for (i = 0; i < len; i += 1) {
      ptNew = transforms[i].mat.applyToPointArray(0, 0, 0);
      // ptNew = transforms[i].mat.applyToPointArray(pt[0],pt[1],pt[2]);
      pt = [pt[0] - ptNew[0], pt[1] - ptNew[1], 0];
    }
    return pt;
  },
  mHelper: new Matrix(),
};

function RenderableElement() {

}

RenderableElement.prototype = {
  initRenderable: function () {
    // layer's visibility related to inpoint and outpoint. Rename isVisible to isInRange
    this.isInRange = false;
    // layer's display state
    this.hidden = false;
    // If layer's transparency equals 0, it can be hidden
    this.isTransparent = false;
    // list of animated components
    this.renderableComponents = [];
  },
  addRenderableComponent: function (component) {
    if (this.renderableComponents.indexOf(component) === -1) {
      this.renderableComponents.push(component);
    }
  },
  removeRenderableComponent: function (component) {
    if (this.renderableComponents.indexOf(component) !== -1) {
      this.renderableComponents.splice(this.renderableComponents.indexOf(component), 1);
    }
  },
  prepareRenderableFrame: function (num) {
    this.checkLayerLimits(num);
  },
  checkTransparency: function () {
    if (this.finalTransform.mProp.o.v <= 0) {
      if (!this.isTransparent && this.globalData.renderConfig.hideOnTransparent) {
        this.isTransparent = true;
        this.hide();
      }
    } else if (this.isTransparent) {
      this.isTransparent = false;
      this.show();
    }
  },
  /**
     * @function
     * Initializes frame related properties.
     *
     * @param {number} num
     * current frame number in Layer's time
     *
     */
  checkLayerLimits: function (num) {
    if (this.data.ip - this.data.st <= num && this.data.op - this.data.st > num) {
      if (this.isInRange !== true) {
        this.globalData._mdf = true;
        this._mdf = true;
        this.isInRange = true;
        this.show();
      }
    } else if (this.isInRange !== false) {
      this.globalData._mdf = true;
      this.isInRange = false;
      this.hide();
    }
  },
  renderRenderable: function () {
    var i;
    var len = this.renderableComponents.length;
    for (i = 0; i < len; i += 1) {
      this.renderableComponents[i].renderFrame(this._isFirstFrame);
    }
    /* this.maskManager.renderFrame(this.finalTransform.mat);
        this.renderableEffectsManager.renderFrame(this._isFirstFrame); */
  },
  sourceRectAtTime: function () {
    return {
      top: 0,
      left: 0,
      width: 100,
      height: 100,
    };
  },
  getLayerSize: function () {
    if (this.data.ty === 5) {
      return { w: this.data.textData.width, h: this.data.textData.height };
    }
    return { w: this.data.width, h: this.data.height };
  },
};

/* global extendPrototype, RenderableElement, createProxyFunction */

function RenderableDOMElement() {}

(function () {
  var _prototype = {
    initElement: function (data, globalData, comp) {
      this.initFrame();
      this.initBaseData(data, globalData, comp);
      this.initTransform(data, globalData, comp);
      this.initHierarchy();
      this.initRenderable();
      this.initRendererElement();
      this.createContainerElements();
      this.createRenderableComponents();
      this.createContent();
      this.hide();
    },
    hide: function () {
      if (!this.hidden && (!this.isInRange || this.isTransparent)) {
        var elem = this.baseElement || this.layerElement;
        elem.style.display = 'none';
        this.hidden = true;
      }
    },
    show: function () {
      if (this.isInRange && !this.isTransparent) {
        if (!this.data.hd) {
          var elem = this.baseElement || this.layerElement;
          elem.style.display = 'block';
        }
        this.hidden = false;
        this._isFirstFrame = true;
      }
    },
    renderFrame: function () {
      // If it is exported as hidden (data.hd === true) no need to render
      // If it is not visible no need to render
      if (this.data.hd || this.hidden) {
        return;
      }
      this.renderTransform();
      this.renderRenderable();
      this.renderElement();
      this.renderInnerContent();
      if (this._isFirstFrame) {
        this._isFirstFrame = false;
      }
    },
    renderInnerContent: function () {},
    prepareFrame: function (num) {
      this._mdf = false;
      this.prepareRenderableFrame(num);
      this.prepareProperties(num, this.isInRange);
      this.checkTransparency();
    },
    destroy: function () {
      this.innerElem = null;
      this.destroyBaseElement();
    },
  };
  extendPrototype([RenderableElement, createProxyFunction(_prototype)], RenderableDOMElement);
}());

/* exported ProcessedElement */

function ProcessedElement(element, position) {
  this.elem = element;
  this.pos = position;
}

/* global createNS */

function SVGStyleData(data, level) {
  this.data = data;
  this.type = data.ty;
  this.d = '';
  this.lvl = level;
  this._mdf = false;
  this.closed = data.hd === true;
  this.pElem = createNS('path');
  this.msElem = null;
}

SVGStyleData.prototype.reset = function () {
  this.d = '';
  this._mdf = false;
};

function SVGShapeData(transformers, level, shape) {
  this.caches = [];
  this.styles = [];
  this.transformers = transformers;
  this.lStr = '';
  this.sh = shape;
  this.lvl = level;
  // TODO find if there are some cases where _isAnimated can be false.
  // For now, since shapes add up with other shapes. They have to be calculated every time.
  // One way of finding out is checking if all styles associated to this shape depend only of this shape
  this._isAnimated = !!shape.k;
  // TODO: commenting this for now since all shapes are animated
  var i = 0;
  var len = transformers.length;
  while (i < len) {
    if (transformers[i].mProps.dynamicProperties.length) {
      this._isAnimated = true;
      break;
    }
    i += 1;
  }
}

SVGShapeData.prototype.setAsAnimated = function () {
  this._isAnimated = true;
};

/* exported SVGTransformData */

function SVGTransformData(mProps, op, container) {
  this.transform = {
    mProps: mProps,
    op: op,
    container: container,
  };
  this.elements = [];
  this._isAnimated = this.transform.mProps.dynamicProperties.length || this.transform.op.effectsSequence.length;
}

/* global DashProperty, PropertyFactory, extendPrototype, DynamicPropertyContainer */

function SVGStrokeStyleData(elem, data, styleOb) {
  this.initDynamicPropertyContainer(elem);
  this.getValue = this.iterateDynamicProperties;
  this.o = PropertyFactory.getProp(elem, data.o, 0, 0.01, this);
  this.w = PropertyFactory.getProp(elem, data.w, 0, null, this);
  this.d = new DashProperty(elem, data.d || {}, 'svg', this);
  this.c = PropertyFactory.getProp(elem, data.c, 1, 255, this);
  this.style = styleOb;
  this._isAnimated = !!this._isAnimated;
}

extendPrototype([DynamicPropertyContainer], SVGStrokeStyleData);

/* global PropertyFactory, extendPrototype, DynamicPropertyContainer */

function SVGFillStyleData(elem, data, styleOb) {
  this.initDynamicPropertyContainer(elem);
  this.getValue = this.iterateDynamicProperties;
  this.o = PropertyFactory.getProp(elem, data.o, 0, 0.01, this);
  this.c = PropertyFactory.getProp(elem, data.c, 1, 255, this);
  this.style = styleOb;
}

extendPrototype([DynamicPropertyContainer], SVGFillStyleData);

/* global PropertyFactory, degToRads, GradientProperty, createElementID, createNS, locationHref,
extendPrototype, DynamicPropertyContainer */

function SVGGradientFillStyleData(elem, data, styleOb) {
  this.initDynamicPropertyContainer(elem);
  this.getValue = this.iterateDynamicProperties;
  this.initGradientData(elem, data, styleOb);
}

SVGGradientFillStyleData.prototype.initGradientData = function (elem, data, styleOb) {
  this.o = PropertyFactory.getProp(elem, data.o, 0, 0.01, this);
  this.s = PropertyFactory.getProp(elem, data.s, 1, null, this);
  this.e = PropertyFactory.getProp(elem, data.e, 1, null, this);
  this.h = PropertyFactory.getProp(elem, data.h || { k: 0 }, 0, 0.01, this);
  this.a = PropertyFactory.getProp(elem, data.a || { k: 0 }, 0, degToRads, this);
  this.g = new GradientProperty(elem, data.g, this);
  this.style = styleOb;
  this.stops = [];
  this.setGradientData(styleOb.pElem, data);
  this.setGradientOpacity(data, styleOb);
  this._isAnimated = !!this._isAnimated;
};

SVGGradientFillStyleData.prototype.setGradientData = function (pathElement, data) {
  var gradientId = createElementID();
  var gfill = createNS(data.t === 1 ? 'linearGradient' : 'radialGradient');
  gfill.setAttribute('id', gradientId);
  gfill.setAttribute('spreadMethod', 'pad');
  gfill.setAttribute('gradientUnits', 'userSpaceOnUse');
  var stops = [];
  var stop;
  var j;
  var jLen;
  jLen = data.g.p * 4;
  for (j = 0; j < jLen; j += 4) {
    stop = createNS('stop');
    gfill.appendChild(stop);
    stops.push(stop);
  }
  pathElement.setAttribute(data.ty === 'gf' ? 'fill' : 'stroke', 'url(' + locationHref + '#' + gradientId + ')');

  this.gf = gfill;
  this.cst = stops;
};

SVGGradientFillStyleData.prototype.setGradientOpacity = function (data, styleOb) {
  if (this.g._hasOpacity && !this.g._collapsable) {
    var stop;
    var j;
    var jLen;
    var mask = createNS('mask');
    var maskElement = createNS('path');
    mask.appendChild(maskElement);
    var opacityId = createElementID();
    var maskId = createElementID();
    mask.setAttribute('id', maskId);
    var opFill = createNS(data.t === 1 ? 'linearGradient' : 'radialGradient');
    opFill.setAttribute('id', opacityId);
    opFill.setAttribute('spreadMethod', 'pad');
    opFill.setAttribute('gradientUnits', 'userSpaceOnUse');
    jLen = data.g.k.k[0].s ? data.g.k.k[0].s.length : data.g.k.k.length;
    var stops = this.stops;
    for (j = data.g.p * 4; j < jLen; j += 2) {
      stop = createNS('stop');
      stop.setAttribute('stop-color', 'rgb(255,255,255)');
      opFill.appendChild(stop);
      stops.push(stop);
    }
    maskElement.setAttribute(data.ty === 'gf' ? 'fill' : 'stroke', 'url(' + locationHref + '#' + opacityId + ')');
    this.of = opFill;
    this.ms = mask;
    this.ost = stops;
    this.maskId = maskId;
    styleOb.msElem = maskElement;
  }
};

extendPrototype([DynamicPropertyContainer], SVGGradientFillStyleData);

/* global PropertyFactory, DashProperty, extendPrototype, SVGGradientFillStyleData, DynamicPropertyContainer */

function SVGGradientStrokeStyleData(elem, data, styleOb) {
  this.initDynamicPropertyContainer(elem);
  this.getValue = this.iterateDynamicProperties;
  this.w = PropertyFactory.getProp(elem, data.w, 0, null, this);
  this.d = new DashProperty(elem, data.d || {}, 'svg', this);
  this.initGradientData(elem, data, styleOb);
  this._isAnimated = !!this._isAnimated;
}

extendPrototype([SVGGradientFillStyleData, DynamicPropertyContainer], SVGGradientStrokeStyleData);

/* global createNS */
/* exported ShapeGroupData */

function ShapeGroupData() {
  this.it = [];
  this.prevViewData = [];
  this.gr = createNS('g');
}

/* global Matrix, buildShapeString, bmFloor */
/* exported SVGElementsRenderer */

var SVGElementsRenderer = (function () {
  var _identityMatrix = new Matrix();
  var _matrixHelper = new Matrix();

  var ob = {
    createRenderFunction: createRenderFunction,
  };

  function createRenderFunction(data) {
    switch (data.ty) {
      case 'fl':
        return renderFill;
      case 'gf':
        return renderGradient;
      case 'gs':
        return renderGradientStroke;
      case 'st':
        return renderStroke;
      case 'sh':
      case 'el':
      case 'rc':
      case 'sr':
        return renderPath;
      case 'tr':
        return renderContentTransform;
      default:
        return null;
    }
  }

  function renderContentTransform(styleData, itemData, isFirstFrame) {
    if (isFirstFrame || itemData.transform.op._mdf) {
      itemData.transform.container.setAttribute('opacity', itemData.transform.op.v);
    }
    if (isFirstFrame || itemData.transform.mProps._mdf) {
      itemData.transform.container.setAttribute('transform', itemData.transform.mProps.v.to2dCSS());
    }
  }

  function renderPath(styleData, itemData, isFirstFrame) {
    var j;
    var jLen;
    var pathStringTransformed;
    var redraw;
    var pathNodes;
    var l;
    var lLen = itemData.styles.length;
    var lvl = itemData.lvl;
    var paths;
    var mat;
    var props;
    var iterations;
    var k;
    for (l = 0; l < lLen; l += 1) {
      redraw = itemData.sh._mdf || isFirstFrame;
      if (itemData.styles[l].lvl < lvl) {
        mat = _matrixHelper.reset();
        iterations = lvl - itemData.styles[l].lvl;
        k = itemData.transformers.length - 1;
        while (!redraw && iterations > 0) {
          redraw = itemData.transformers[k].mProps._mdf || redraw;
          iterations -= 1;
          k -= 1;
        }
        if (redraw) {
          iterations = lvl - itemData.styles[l].lvl;
          k = itemData.transformers.length - 1;
          while (iterations > 0) {
            props = itemData.transformers[k].mProps.v.props;
            mat.transform(props[0], props[1], props[2], props[3], props[4], props[5], props[6], props[7], props[8], props[9], props[10], props[11], props[12], props[13], props[14], props[15]);
            iterations -= 1;
            k -= 1;
          }
        }
      } else {
        mat = _identityMatrix;
      }
      paths = itemData.sh.paths;
      jLen = paths._length;
      if (redraw) {
        pathStringTransformed = '';
        for (j = 0; j < jLen; j += 1) {
          pathNodes = paths.shapes[j];
          if (pathNodes && pathNodes._length) {
            pathStringTransformed += buildShapeString(pathNodes, pathNodes._length, pathNodes.c, mat);
          }
        }
        itemData.caches[l] = pathStringTransformed;
      } else {
        pathStringTransformed = itemData.caches[l];
      }
      itemData.styles[l].d += styleData.hd === true ? '' : pathStringTransformed;
      itemData.styles[l]._mdf = redraw || itemData.styles[l]._mdf;
    }
  }

  function renderFill(styleData, itemData, isFirstFrame) {
    var styleElem = itemData.style;

    if (itemData.c._mdf || isFirstFrame) {
      styleElem.pElem.setAttribute('fill', 'rgb(' + bmFloor(itemData.c.v[0]) + ',' + bmFloor(itemData.c.v[1]) + ',' + bmFloor(itemData.c.v[2]) + ')');
    }
    if (itemData.o._mdf || isFirstFrame) {
      styleElem.pElem.setAttribute('fill-opacity', itemData.o.v);
    }
  }

  function renderGradientStroke(styleData, itemData, isFirstFrame) {
    renderGradient(styleData, itemData, isFirstFrame);
    renderStroke(styleData, itemData, isFirstFrame);
  }

  function renderGradient(styleData, itemData, isFirstFrame) {
    var gfill = itemData.gf;
    var hasOpacity = itemData.g._hasOpacity;
    var pt1 = itemData.s.v;
    var pt2 = itemData.e.v;

    if (itemData.o._mdf || isFirstFrame) {
      var attr = styleData.ty === 'gf' ? 'fill-opacity' : 'stroke-opacity';
      itemData.style.pElem.setAttribute(attr, itemData.o.v);
    }
    if (itemData.s._mdf || isFirstFrame) {
      var attr1 = styleData.t === 1 ? 'x1' : 'cx';
      var attr2 = attr1 === 'x1' ? 'y1' : 'cy';
      gfill.setAttribute(attr1, pt1[0]);
      gfill.setAttribute(attr2, pt1[1]);
      if (hasOpacity && !itemData.g._collapsable) {
        itemData.of.setAttribute(attr1, pt1[0]);
        itemData.of.setAttribute(attr2, pt1[1]);
      }
    }
    var stops;
    var i;
    var len;
    var stop;
    if (itemData.g._cmdf || isFirstFrame) {
      stops = itemData.cst;
      var cValues = itemData.g.c;
      len = stops.length;
      for (i = 0; i < len; i += 1) {
        stop = stops[i];
        stop.setAttribute('offset', cValues[i * 4] + '%');
        stop.setAttribute('stop-color', 'rgb(' + cValues[i * 4 + 1] + ',' + cValues[i * 4 + 2] + ',' + cValues[i * 4 + 3] + ')');
      }
    }
    if (hasOpacity && (itemData.g._omdf || isFirstFrame)) {
      var oValues = itemData.g.o;
      if (itemData.g._collapsable) {
        stops = itemData.cst;
      } else {
        stops = itemData.ost;
      }
      len = stops.length;
      for (i = 0; i < len; i += 1) {
        stop = stops[i];
        if (!itemData.g._collapsable) {
          stop.setAttribute('offset', oValues[i * 2] + '%');
        }
        stop.setAttribute('stop-opacity', oValues[i * 2 + 1]);
      }
    }
    if (styleData.t === 1) {
      if (itemData.e._mdf || isFirstFrame) {
        gfill.setAttribute('x2', pt2[0]);
        gfill.setAttribute('y2', pt2[1]);
        if (hasOpacity && !itemData.g._collapsable) {
          itemData.of.setAttribute('x2', pt2[0]);
          itemData.of.setAttribute('y2', pt2[1]);
        }
      }
    } else {
      var rad;
      if (itemData.s._mdf || itemData.e._mdf || isFirstFrame) {
        rad = Math.sqrt(Math.pow(pt1[0] - pt2[0], 2) + Math.pow(pt1[1] - pt2[1], 2));
        gfill.setAttribute('r', rad);
        if (hasOpacity && !itemData.g._collapsable) {
          itemData.of.setAttribute('r', rad);
        }
      }
      if (itemData.e._mdf || itemData.h._mdf || itemData.a._mdf || isFirstFrame) {
        if (!rad) {
          rad = Math.sqrt(Math.pow(pt1[0] - pt2[0], 2) + Math.pow(pt1[1] - pt2[1], 2));
        }
        var ang = Math.atan2(pt2[1] - pt1[1], pt2[0] - pt1[0]);

        var percent = itemData.h.v;
        if (percent >= 1) {
          percent = 0.99;
        } else if (percent <= -1) {
          percent = -0.99;
        }
        var dist = rad * percent;
        var x = Math.cos(ang + itemData.a.v) * dist + pt1[0];
        var y = Math.sin(ang + itemData.a.v) * dist + pt1[1];
        gfill.setAttribute('fx', x);
        gfill.setAttribute('fy', y);
        if (hasOpacity && !itemData.g._collapsable) {
          itemData.of.setAttribute('fx', x);
          itemData.of.setAttribute('fy', y);
        }
      }
      // gfill.setAttribute('fy','200');
    }
  }

  function renderStroke(styleData, itemData, isFirstFrame) {
    var styleElem = itemData.style;
    var d = itemData.d;
    if (d && (d._mdf || isFirstFrame) && d.dashStr) {
      styleElem.pElem.setAttribute('stroke-dasharray', d.dashStr);
      styleElem.pElem.setAttribute('stroke-dashoffset', d.dashoffset[0]);
    }
    if (itemData.c && (itemData.c._mdf || isFirstFrame)) {
      styleElem.pElem.setAttribute('stroke', 'rgb(' + bmFloor(itemData.c.v[0]) + ',' + bmFloor(itemData.c.v[1]) + ',' + bmFloor(itemData.c.v[2]) + ')');
    }
    if (itemData.o._mdf || isFirstFrame) {
      styleElem.pElem.setAttribute('stroke-opacity', itemData.o.v);
    }
    if (itemData.w._mdf || isFirstFrame) {
      styleElem.pElem.setAttribute('stroke-width', itemData.w.v);
      if (styleElem.msElem) {
        styleElem.msElem.setAttribute('stroke-width', itemData.w.v);
      }
    }
  }

  return ob;
}());

/* global Matrix */

function ShapeTransformManager() {
  this.sequences = {};
  this.sequenceList = [];
  this.transform_key_count = 0;
}

ShapeTransformManager.prototype = {
  addTransformSequence: function (transforms) {
    var i;
    var len = transforms.length;
    var key = '_';
    for (i = 0; i < len; i += 1) {
      key += transforms[i].transform.key + '_';
    }
    var sequence = this.sequences[key];
    if (!sequence) {
      sequence = {
        transforms: [].concat(transforms),
        finalTransform: new Matrix(),
        _mdf: false,
      };
      this.sequences[key] = sequence;
      this.sequenceList.push(sequence);
    }
    return sequence;
  },
  processSequence: function (sequence, isFirstFrame) {
    var i = 0;
    var len = sequence.transforms.length;
    var _mdf = isFirstFrame;
    while (i < len && !isFirstFrame) {
      if (sequence.transforms[i].transform.mProps._mdf) {
        _mdf = true;
        break;
      }
      i += 1;
    }
    if (_mdf) {
      var props;
      sequence.finalTransform.reset();
      for (i = len - 1; i >= 0; i -= 1) {
        props = sequence.transforms[i].transform.mProps.v.props;
        sequence.finalTransform.transform(props[0], props[1], props[2], props[3], props[4], props[5], props[6], props[7], props[8], props[9], props[10], props[11], props[12], props[13], props[14], props[15]);
      }
    }
    sequence._mdf = _mdf;
  },
  processSequences: function (isFirstFrame) {
    var i;
    var len = this.sequenceList.length;
    for (i = 0; i < len; i += 1) {
      this.processSequence(this.sequenceList[i], isFirstFrame);
    }
  },
  getNewKey: function () {
    this.transform_key_count += 1;
    return '_' + this.transform_key_count;
  },
};

/* global ShapePropertyFactory, SVGShapeData */

function CVShapeData(element, data, styles, transformsManager) {
  this.styledShapes = [];
  this.tr = [0, 0, 0, 0, 0, 0];
  var ty = 4;
  if (data.ty === 'rc') {
    ty = 5;
  } else if (data.ty === 'el') {
    ty = 6;
  } else if (data.ty === 'sr') {
    ty = 7;
  }
  this.sh = ShapePropertyFactory.getShapeProp(element, data, ty, element);
  var i;
  var len = styles.length;
  var styledShape;
  for (i = 0; i < len; i += 1) {
    if (!styles[i].closed) {
      styledShape = {
        transforms: transformsManager.addTransformSequence(styles[i].transforms),
        trNodes: [],
      };
      this.styledShapes.push(styledShape);
      styles[i].elements.push(styledShape);
    }
  }
}

CVShapeData.prototype.setAsAnimated = SVGShapeData.prototype.setAsAnimated;

/* global LayerExpressionInterface, EffectsExpressionInterface, CompExpressionInterface, ShapeExpressionInterface,
TextExpressionInterface, getBlendMode,createElementID, EffectsManager */

function BaseElement() {
}

BaseElement.prototype = {
  checkMasks: function () {
    if (!this.data.hasMask) {
      return false;
    }
    var i = 0;
    var len = this.data.masksProperties.length;
    while (i < len) {
      if ((this.data.masksProperties[i].mode !== 'n' && this.data.masksProperties[i].cl !== false)) {
        return true;
      }
      i += 1;
    }
    return false;
  },
  initExpressions: function () {
    this.layerInterface = LayerExpressionInterface(this);
    if (this.data.hasMask && this.maskManager) {
      this.layerInterface.registerMaskInterface(this.maskManager);
    }
    var effectsInterface = EffectsExpressionInterface.createEffectsInterface(this, this.layerInterface);
    this.layerInterface.registerEffectsInterface(effectsInterface);

    if (this.data.ty === 0 || this.data.xt) {
      this.compInterface = CompExpressionInterface(this);
    } else if (this.data.ty === 4) {
      this.layerInterface.shapeInterface = ShapeExpressionInterface(this.shapesData, this.itemsData, this.layerInterface);
      this.layerInterface.content = this.layerInterface.shapeInterface;
    } else if (this.data.ty === 5) {
      this.layerInterface.textInterface = TextExpressionInterface(this);
      this.layerInterface.text = this.layerInterface.textInterface;
    }
  },
  setBlendMode: function () {
    var blendModeValue = getBlendMode(this.data.bm);
    var elem = this.baseElement || this.layerElement;

    elem.style['mix-blend-mode'] = blendModeValue;
  },
  initBaseData: function (data, globalData, comp) {
    this.globalData = globalData;
    this.comp = comp;
    this.data = data;
    this.layerId = createElementID();

    // Stretch factor for old animations missing this property.
    if (!this.data.sr) {
      this.data.sr = 1;
    }
    // effects manager
    this.effectsManager = new EffectsManager(this.data, this, this.dynamicProperties);
  },
  getType: function () {
    return this.type;
  },
  sourceRectAtTime: function () {},
};

/* global extendPrototype, BaseElement, TransformElement, HierarchyElement, FrameElement */

function NullElement(data, globalData, comp) {
  this.initFrame();
  this.initBaseData(data, globalData, comp);
  this.initFrame();
  this.initTransform(data, globalData, comp);
  this.initHierarchy();
}

NullElement.prototype.prepareFrame = function (num) {
  this.prepareProperties(num, true);
};

NullElement.prototype.renderFrame = function () {
};

NullElement.prototype.getBaseElement = function () {
  return null;
};

NullElement.prototype.destroy = function () {
};

NullElement.prototype.sourceRectAtTime = function () {
};

NullElement.prototype.hide = function () {
};

extendPrototype([BaseElement, TransformElement, HierarchyElement, FrameElement], NullElement);

/* global filtersFactory, featureSupport, filtersFactory, createElementID, createNS, MaskElement, SVGEffects, locationHref */

function SVGBaseElement() {
}

SVGBaseElement.prototype = {
  initRendererElement: function () {
    this.layerElement = createNS('g');
  },
  createContainerElements: function () {
    this.matteElement = createNS('g');
    this.transformedElement = this.layerElement;
    this.maskedElement = this.layerElement;
    this._sizeChanged = false;
    var layerElementParent = null;
    // If this layer acts as a mask for the following layer
    var filId;
    var fil;
    var gg;
    if (this.data.td) {
      if (this.data.td == 3 || this.data.td == 1) { // eslint-disable-line eqeqeq
        var masker = createNS('mask');
        masker.setAttribute('id', this.layerId);
        masker.setAttribute('mask-type', this.data.td == 3 ? 'luminance' : 'alpha'); // eslint-disable-line eqeqeq
        masker.appendChild(this.layerElement);
        layerElementParent = masker;
        this.globalData.defs.appendChild(masker);
        // This is only for IE and Edge when mask if of type alpha
        if (!featureSupport.maskType && this.data.td == 1) { // eslint-disable-line eqeqeq
          masker.setAttribute('mask-type', 'luminance');
          filId = createElementID();
          fil = filtersFactory.createFilter(filId);
          this.globalData.defs.appendChild(fil);
          fil.appendChild(filtersFactory.createAlphaToLuminanceFilter());
          gg = createNS('g');
          gg.appendChild(this.layerElement);
          layerElementParent = gg;
          masker.appendChild(gg);
          gg.setAttribute('filter', 'url(' + locationHref + '#' + filId + ')');
        }
      } else if (this.data.td == 2) { // eslint-disable-line eqeqeq
        var maskGroup = createNS('mask');
        maskGroup.setAttribute('id', this.layerId);
        maskGroup.setAttribute('mask-type', 'alpha');
        var maskGrouper = createNS('g');
        maskGroup.appendChild(maskGrouper);
        filId = createElementID();
        fil = filtersFactory.createFilter(filId);
        /// /

        // This solution doesn't work on Android when meta tag with viewport attribute is set
        /* var feColorMatrix = createNS('feColorMatrix');
                feColorMatrix.setAttribute('type', 'matrix');
                feColorMatrix.setAttribute('color-interpolation-filters', 'sRGB');
                feColorMatrix.setAttribute('values','1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 -1 1');
                fil.appendChild(feColorMatrix); */
        /// /
        var feCTr = createNS('feComponentTransfer');
        feCTr.setAttribute('in', 'SourceGraphic');
        fil.appendChild(feCTr);
        var feFunc = createNS('feFuncA');
        feFunc.setAttribute('type', 'table');
        feFunc.setAttribute('tableValues', '1.0 0.0');
        feCTr.appendChild(feFunc);
        /// /
        this.globalData.defs.appendChild(fil);
        var alphaRect = createNS('rect');
        alphaRect.setAttribute('width', this.comp.data.w);
        alphaRect.setAttribute('height', this.comp.data.h);
        alphaRect.setAttribute('x', '0');
        alphaRect.setAttribute('y', '0');
        alphaRect.setAttribute('fill', '#ffffff');
        alphaRect.setAttribute('opacity', '0');
        maskGrouper.setAttribute('filter', 'url(' + locationHref + '#' + filId + ')');
        maskGrouper.appendChild(alphaRect);
        maskGrouper.appendChild(this.layerElement);
        layerElementParent = maskGrouper;
        if (!featureSupport.maskType) {
          maskGroup.setAttribute('mask-type', 'luminance');
          fil.appendChild(filtersFactory.createAlphaToLuminanceFilter());
          gg = createNS('g');
          maskGrouper.appendChild(alphaRect);
          gg.appendChild(this.layerElement);
          layerElementParent = gg;
          maskGrouper.appendChild(gg);
        }
        this.globalData.defs.appendChild(maskGroup);
      }
    } else if (this.data.tt) {
      this.matteElement.appendChild(this.layerElement);
      layerElementParent = this.matteElement;
      this.baseElement = this.matteElement;
    } else {
      this.baseElement = this.layerElement;
    }
    if (this.data.ln) {
      this.layerElement.setAttribute('id', this.data.ln);
    }
    if (this.data.cl) {
      this.layerElement.setAttribute('class', this.data.cl);
    }
    // Clipping compositions to hide content that exceeds boundaries. If collapsed transformations is on, component should not be clipped
    if (this.data.ty === 0 && !this.data.hd) {
      var cp = createNS('clipPath');
      var pt = createNS('path');
      pt.setAttribute('d', 'M0,0 L' + this.data.w + ',0 L' + this.data.w + ',' + this.data.h + ' L0,' + this.data.h + 'z');
      var clipId = createElementID();
      cp.setAttribute('id', clipId);
      cp.appendChild(pt);
      this.globalData.defs.appendChild(cp);

      if (this.checkMasks()) {
        var cpGroup = createNS('g');
        cpGroup.setAttribute('clip-path', 'url(' + locationHref + '#' + clipId + ')');
        cpGroup.appendChild(this.layerElement);
        this.transformedElement = cpGroup;
        if (layerElementParent) {
          layerElementParent.appendChild(this.transformedElement);
        } else {
          this.baseElement = this.transformedElement;
        }
      } else {
        this.layerElement.setAttribute('clip-path', 'url(' + locationHref + '#' + clipId + ')');
      }
    }
    if (this.data.bm !== 0) {
      this.setBlendMode();
    }
  },
  renderElement: function () {
    if (this.finalTransform._matMdf) {
      this.transformedElement.setAttribute('transform', this.finalTransform.mat.to2dCSS());
    }
    if (this.finalTransform._opMdf) {
      this.transformedElement.setAttribute('opacity', this.finalTransform.mProp.o.v);
    }
  },
  destroyBaseElement: function () {
    this.layerElement = null;
    this.matteElement = null;
    this.maskManager.destroy();
  },
  getBaseElement: function () {
    if (this.data.hd) {
      return null;
    }
    return this.baseElement;
  },
  createRenderableComponents: function () {
    this.maskManager = new MaskElement(this.data, this, this.globalData);
    this.renderableEffectsManager = new SVGEffects(this);
  },
  setMatte: function (id) {
    if (!this.matteElement) {
      return;
    }
    this.matteElement.setAttribute('mask', 'url(' + locationHref + '#' + id + ')');
  },
};

/* global ProcessedElement */

function IShapeElement() {
}

IShapeElement.prototype = {
  addShapeToModifiers: function (data) {
    var i;
    var len = this.shapeModifiers.length;
    for (i = 0; i < len; i += 1) {
      this.shapeModifiers[i].addShape(data);
    }
  },
  isShapeInAnimatedModifiers: function (data) {
    var i = 0;
    var len = this.shapeModifiers.length;
    while (i < len) {
      if (this.shapeModifiers[i].isAnimatedWithShape(data)) {
        return true;
      }
    }
    return false;
  },
  renderModifiers: function () {
    if (!this.shapeModifiers.length) {
      return;
    }
    var i;
    var len = this.shapes.length;
    for (i = 0; i < len; i += 1) {
      this.shapes[i].sh.reset();
    }

    len = this.shapeModifiers.length;
    var shouldBreakProcess;
    for (i = len - 1; i >= 0; i -= 1) {
      shouldBreakProcess = this.shapeModifiers[i].processShapes(this._isFirstFrame);
      // workaround to fix cases where a repeater resets the shape so the following processes get called twice
      // TODO: find a better solution for this
      if (shouldBreakProcess) {
        break;
      }
    }
  },
  lcEnum: {
    1: 'butt',
    2: 'round',
    3: 'square',
  },
  ljEnum: {
    1: 'miter',
    2: 'round',
    3: 'bevel',
  },
  searchProcessedElement: function (elem) {
    var elements = this.processedElements;
    var i = 0;
    var len = elements.length;
    while (i < len) {
      if (elements[i].elem === elem) {
        return elements[i].pos;
      }
      i += 1;
    }
    return 0;
  },
  addProcessedElement: function (elem, pos) {
    var elements = this.processedElements;
    var i = elements.length;
    while (i) {
      i -= 1;
      if (elements[i].elem === elem) {
        elements[i].pos = pos;
        return;
      }
    }
    elements.push(new ProcessedElement(elem, pos));
  },
  prepareFrame: function (num) {
    this.prepareRenderableFrame(num);
    this.prepareProperties(num, this.isInRange);
  },
};

/* global TextProperty, TextAnimatorProperty, buildShapeString, LetterProps */

function ITextElement() {
}

ITextElement.prototype.initElement = function (data, globalData, comp) {
  this.lettersChangedFlag = true;
  this.initFrame();
  this.initBaseData(data, globalData, comp);
  this.textProperty = new TextProperty(this, data.t, this.dynamicProperties);
  this.textAnimator = new TextAnimatorProperty(data.t, this.renderType, this);
  this.initTransform(data, globalData, comp);
  this.initHierarchy();
  this.initRenderable();
  this.initRendererElement();
  this.createContainerElements();
  this.createRenderableComponents();
  this.createContent();
  this.hide();
  this.textAnimator.searchProperties(this.dynamicProperties);
};

ITextElement.prototype.prepareFrame = function (num) {
  this._mdf = false;
  this.prepareRenderableFrame(num);
  this.prepareProperties(num, this.isInRange);
  if (this.textProperty._mdf || this.textProperty._isFirstFrame) {
    this.buildNewText();
    this.textProperty._isFirstFrame = false;
    this.textProperty._mdf = false;
  }
};

ITextElement.prototype.createPathShape = function (matrixHelper, shapes) {
  var j;
  var jLen = shapes.length;
  var pathNodes;
  var shapeStr = '';
  for (j = 0; j < jLen; j += 1) {
    pathNodes = shapes[j].ks.k;
    shapeStr += buildShapeString(pathNodes, pathNodes.i.length, true, matrixHelper);
  }
  return shapeStr;
};

ITextElement.prototype.updateDocumentData = function (newData, index) {
  this.textProperty.updateDocumentData(newData, index);
};

ITextElement.prototype.canResizeFont = function (_canResize) {
  this.textProperty.canResizeFont(_canResize);
};

ITextElement.prototype.setMinimumFontSize = function (_fontSize) {
  this.textProperty.setMinimumFontSize(_fontSize);
};

ITextElement.prototype.applyTextPropertiesToMatrix = function (documentData, matrixHelper, lineNumber, xPos, yPos) {
  if (documentData.ps) {
    matrixHelper.translate(documentData.ps[0], documentData.ps[1] + documentData.ascent, 0);
  }
  matrixHelper.translate(0, -documentData.ls, 0);
  switch (documentData.j) {
    case 1:
      matrixHelper.translate(documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[lineNumber]), 0, 0);
      break;
    case 2:
      matrixHelper.translate(documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[lineNumber]) / 2, 0, 0);
      break;
  }
  matrixHelper.translate(xPos, yPos, 0);
};

ITextElement.prototype.buildColor = function (colorData) {
  return 'rgb(' + Math.round(colorData[0] * 255) + ',' + Math.round(colorData[1] * 255) + ',' + Math.round(colorData[2] * 255) + ')';
};

ITextElement.prototype.emptyProp = new LetterProps();

ITextElement.prototype.destroy = function () {

};

/* global extendPrototype, BaseElement, TransformElement, HierarchyElement, FrameElement, RenderableDOMElement */

function ICompElement() {}

extendPrototype([BaseElement, TransformElement, HierarchyElement, FrameElement, RenderableDOMElement], ICompElement);

ICompElement.prototype.initElement = function (data, globalData, comp) {
  this.initFrame();
  this.initBaseData(data, globalData, comp);
  this.initTransform(data, globalData, comp);
  this.initRenderable();
  this.initHierarchy();
  this.initRendererElement();
  this.createContainerElements();
  this.createRenderableComponents();
  if (this.data.xt || !globalData.progressiveLoad) {
    this.buildAllItems();
  }
  this.hide();
};

/* ICompElement.prototype.hide = function(){
    if(!this.hidden){
        this.hideElement();
        var i,len = this.elements.length;
        for( i = 0; i < len; i+=1 ){
            if(this.elements[i]){
                this.elements[i].hide();
            }
        }
    }
}; */

ICompElement.prototype.prepareFrame = function (num) {
  this._mdf = false;
  this.prepareRenderableFrame(num);
  this.prepareProperties(num, this.isInRange);
  if (!this.isInRange && !this.data.xt) {
    return;
  }

  if (!this.tm._placeholder) {
    var timeRemapped = this.tm.v;
    if (timeRemapped === this.data.op) {
      timeRemapped = this.data.op - 1;
    }
    this.renderedFrame = timeRemapped;
  } else {
    this.renderedFrame = num / this.data.sr;
  }
  var i;
  var len = this.elements.length;
  if (!this.completeLayers) {
    this.checkLayers(this.renderedFrame);
  }
  // This iteration needs to be backwards because of how expressions connect between each other
  for (i = len - 1; i >= 0; i -= 1) {
    if (this.completeLayers || this.elements[i]) {
      this.elements[i].prepareFrame(this.renderedFrame - this.layers[i].st);
      if (this.elements[i]._mdf) {
        this._mdf = true;
      }
    }
  }
};

ICompElement.prototype.renderInnerContent = function () {
  var i;
  var len = this.layers.length;
  for (i = 0; i < len; i += 1) {
    if (this.completeLayers || this.elements[i]) {
      this.elements[i].renderFrame();
    }
  }
};

ICompElement.prototype.setElements = function (elems) {
  this.elements = elems;
};

ICompElement.prototype.getElements = function () {
  return this.elements;
};

ICompElement.prototype.destroyElements = function () {
  var i;
  var len = this.layers.length;
  for (i = 0; i < len; i += 1) {
    if (this.elements[i]) {
      this.elements[i].destroy();
    }
  }
};

ICompElement.prototype.destroy = function () {
  this.destroyElements();
  this.destroyBaseElement();
};

/* global extendPrototype, BaseElement, TransformElement, SVGBaseElement, HierarchyElement, FrameElement, RenderableDOMElement, createNS */

function IImageElement(data, globalData, comp) {
  this.assetData = globalData.getAssetData(data.refId);
  this.initElement(data, globalData, comp);
  this.sourceRect = {
    top: 0, left: 0, width: this.assetData.w, height: this.assetData.h,
  };
}

extendPrototype([BaseElement, TransformElement, SVGBaseElement, HierarchyElement, FrameElement, RenderableDOMElement], IImageElement);

IImageElement.prototype.createContent = function () {
  var assetPath = this.globalData.getAssetsPath(this.assetData);

  this.innerElem = createNS('image');
  this.innerElem.setAttribute('width', this.assetData.w + 'px');
  this.innerElem.setAttribute('height', this.assetData.h + 'px');
  this.innerElem.setAttribute('preserveAspectRatio', this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio);
  this.innerElem.setAttributeNS('http://www.w3.org/1999/xlink', 'href', assetPath);

  this.layerElement.appendChild(this.innerElem);
};

IImageElement.prototype.sourceRectAtTime = function () {
  return this.sourceRect;
};

/* global extendPrototype, IImageElement, createNS */

function ISolidElement(data, globalData, comp) {
  this.initElement(data, globalData, comp);
}
extendPrototype([IImageElement], ISolidElement);

ISolidElement.prototype.createContent = function () {
  var rect = createNS('rect');
  /// /rect.style.width = this.data.sw;
  /// /rect.style.height = this.data.sh;
  /// /rect.style.fill = this.data.sc;
  rect.setAttribute('width', this.data.sw);
  rect.setAttribute('height', this.data.sh);
  rect.setAttribute('fill', this.data.sc);
  this.layerElement.appendChild(rect);
};

/* global PropertyFactory, extendPrototype, RenderableElement, BaseElement, FrameElement */

function AudioElement(data, globalData, comp) {
  this.initFrame();
  this.initRenderable();
  this.assetData = globalData.getAssetData(data.refId);
  this.initBaseData(data, globalData, comp);
  this._isPlaying = false;
  this._canPlay = false;
  var assetPath = this.globalData.getAssetsPath(this.assetData);
  this.audio = this.globalData.audioController.createAudio(assetPath);
  this._currentTime = 0;
  this.globalData.audioController.addAudio(this);
  this.tm = data.tm ? PropertyFactory.getProp(this, data.tm, 0, globalData.frameRate, this) : { _placeholder: true };
}

AudioElement.prototype.prepareFrame = function (num) {
  this.prepareRenderableFrame(num, true);
  this.prepareProperties(num, true);
  if (!this.tm._placeholder) {
    var timeRemapped = this.tm.v;
    this._currentTime = timeRemapped;
  } else {
    this._currentTime = num / this.data.sr;
  }
};

extendPrototype([RenderableElement, BaseElement, FrameElement], AudioElement);

AudioElement.prototype.renderFrame = function () {
  if (this.isInRange && this._canPlay) {
    if (!this._isPlaying) {
      this.audio.play();
      this.audio.seek(this._currentTime / this.globalData.frameRate);
      this._isPlaying = true;
    } else if (!this.audio.playing()
      || Math.abs(this._currentTime / this.globalData.frameRate - this.audio.seek()) > 0.1
    ) {
      this.audio.seek(this._currentTime / this.globalData.frameRate);
    }
  }
};

AudioElement.prototype.show = function () {
  // this.audio.play()
};

AudioElement.prototype.hide = function () {
  this.audio.pause();
  this._isPlaying = false;
};

AudioElement.prototype.pause = function () {
  this.audio.pause();
  this._isPlaying = false;
  this._canPlay = false;
};

AudioElement.prototype.resume = function () {
  this._canPlay = true;
};

AudioElement.prototype.setRate = function (rateValue) {
  this.audio.rate(rateValue);
};

AudioElement.prototype.volume = function (volumeValue) {
  this.audio.volume(volumeValue);
};

AudioElement.prototype.getBaseElement = function () {
  return null;
};

AudioElement.prototype.destroy = function () {
};

AudioElement.prototype.sourceRectAtTime = function () {
};

AudioElement.prototype.initExpressions = function () {
};

/* global extendPrototype, RenderableElement, BaseElement, FrameElement, FootageInterface */

function FootageElement(data, globalData, comp) {
  this.initFrame();
  this.initRenderable();
  this.assetData = globalData.getAssetData(data.refId);
  this.footageData = globalData.imageLoader.getAsset(this.assetData);
  this.initBaseData(data, globalData, comp);
}

FootageElement.prototype.prepareFrame = function () {
};

extendPrototype([RenderableElement, BaseElement, FrameElement], FootageElement);

FootageElement.prototype.getBaseElement = function () {
  return null;
};

FootageElement.prototype.renderFrame = function () {
};

FootageElement.prototype.destroy = function () {
};

FootageElement.prototype.initExpressions = function () {
  this.layerInterface = FootageInterface(this);
};

FootageElement.prototype.getFootageData = function () {
  return this.footageData;
};

/* global createSizedArray, PropertyFactory, extendPrototype, SVGRenderer, ICompElement, SVGBaseElement */

function SVGCompElement(data, globalData, comp) {
  this.layers = data.layers;
  this.supports3d = true;
  this.completeLayers = false;
  this.pendingElements = [];
  this.elements = this.layers ? createSizedArray(this.layers.length) : [];
  // this.layerElement = createNS('g');
  this.initElement(data, globalData, comp);
  this.tm = data.tm ? PropertyFactory.getProp(this, data.tm, 0, globalData.frameRate, this) : { _placeholder: true };
}

extendPrototype([SVGRenderer, ICompElement, SVGBaseElement], SVGCompElement);

/* global extendPrototype, BaseElement, TransformElement, SVGBaseElement, HierarchyElement, FrameElement,
RenderableDOMElement, ITextElement, createSizedArray, createNS */

function SVGTextLottieElement(data, globalData, comp) {
  this.textSpans = [];
  this.renderType = 'svg';
  this.initElement(data, globalData, comp);
}

extendPrototype([BaseElement, TransformElement, SVGBaseElement, HierarchyElement, FrameElement, RenderableDOMElement, ITextElement], SVGTextLottieElement);

SVGTextLottieElement.prototype.createContent = function () {
  if (this.data.singleShape && !this.globalData.fontManager.chars) {
    this.textContainer = createNS('text');
  }
};

SVGTextLottieElement.prototype.buildTextContents = function (textArray) {
  var i = 0;
  var len = textArray.length;
  var textContents = [];
  var currentTextContent = '';
  while (i < len) {
    if (textArray[i] === String.fromCharCode(13) || textArray[i] === String.fromCharCode(3)) {
      textContents.push(currentTextContent);
      currentTextContent = '';
    } else {
      currentTextContent += textArray[i];
    }
    i += 1;
  }
  textContents.push(currentTextContent);
  return textContents;
};

SVGTextLottieElement.prototype.buildNewText = function () {
  var i;
  var len;

  var documentData = this.textProperty.currentData;
  this.renderedLetters = createSizedArray(documentData ? documentData.l.length : 0);
  if (documentData.fc) {
    this.layerElement.setAttribute('fill', this.buildColor(documentData.fc));
  } else {
    this.layerElement.setAttribute('fill', 'rgba(0,0,0,0)');
  }
  if (documentData.sc) {
    this.layerElement.setAttribute('stroke', this.buildColor(documentData.sc));
    this.layerElement.setAttribute('stroke-width', documentData.sw);
  }
  this.layerElement.setAttribute('font-size', documentData.finalSize);
  var fontData = this.globalData.fontManager.getFontByName(documentData.f);
  if (fontData.fClass) {
    this.layerElement.setAttribute('class', fontData.fClass);
  } else {
    this.layerElement.setAttribute('font-family', fontData.fFamily);
    var fWeight = documentData.fWeight;
    var fStyle = documentData.fStyle;
    this.layerElement.setAttribute('font-style', fStyle);
    this.layerElement.setAttribute('font-weight', fWeight);
  }
  this.layerElement.setAttribute('aria-label', documentData.t);

  var letters = documentData.l || [];
  var usesGlyphs = !!this.globalData.fontManager.chars;
  len = letters.length;

  var tSpan;
  var matrixHelper = this.mHelper;
  var shapes;
  var shapeStr = '';
  var singleShape = this.data.singleShape;
  var xPos = 0;
  var yPos = 0;
  var firstLine = true;
  var trackingOffset = documentData.tr * 0.001 * documentData.finalSize;
  if (singleShape && !usesGlyphs && !documentData.sz) {
    var tElement = this.textContainer;
    var justify = 'start';
    switch (documentData.j) {
      case 1:
        justify = 'end';
        break;
      case 2:
        justify = 'middle';
        break;
      default:
        justify = 'start';
        break;
    }
    tElement.setAttribute('text-anchor', justify);
    tElement.setAttribute('letter-spacing', trackingOffset);
    var textContent = this.buildTextContents(documentData.finalText);
    len = textContent.length;
    yPos = documentData.ps ? documentData.ps[1] + documentData.ascent : 0;
    for (i = 0; i < len; i += 1) {
      tSpan = this.textSpans[i] || createNS('tspan');
      tSpan.textContent = textContent[i];
      tSpan.setAttribute('x', 0);
      tSpan.setAttribute('y', yPos);
      tSpan.style.display = 'inherit';
      tElement.appendChild(tSpan);
      this.textSpans[i] = tSpan;
      yPos += documentData.finalLineHeight;
    }

    this.layerElement.appendChild(tElement);
  } else {
    var cachedSpansLength = this.textSpans.length;
    var shapeData;
    var charData;
    for (i = 0; i < len; i += 1) {
      if (!usesGlyphs || !singleShape || i === 0) {
        tSpan = cachedSpansLength > i ? this.textSpans[i] : createNS(usesGlyphs ? 'path' : 'text');
        if (cachedSpansLength <= i) {
          tSpan.setAttribute('stroke-linecap', 'butt');
          tSpan.setAttribute('stroke-linejoin', 'round');
          tSpan.setAttribute('stroke-miterlimit', '4');
          this.textSpans[i] = tSpan;
          this.layerElement.appendChild(tSpan);
        }
        tSpan.style.display = 'inherit';
      }

      matrixHelper.reset();
      matrixHelper.scale(documentData.finalSize / 100, documentData.finalSize / 100);
      if (singleShape) {
        if (letters[i].n) {
          xPos = -trackingOffset;
          yPos += documentData.yOffset;
          yPos += firstLine ? 1 : 0;
          firstLine = false;
        }
        this.applyTextPropertiesToMatrix(documentData, matrixHelper, letters[i].line, xPos, yPos);
        xPos += letters[i].l || 0;
        // xPos += letters[i].val === ' ' ? 0 : trackingOffset;
        xPos += trackingOffset;
      }
      if (usesGlyphs) {
        charData = this.globalData.fontManager.getCharData(documentData.finalText[i], fontData.fStyle, this.globalData.fontManager.getFontByName(documentData.f).fFamily);
        shapeData = (charData && charData.data) || {};
        shapes = shapeData.shapes ? shapeData.shapes[0].it : [];
        if (!singleShape) {
          tSpan.setAttribute('d', this.createPathShape(matrixHelper, shapes));
        } else {
          shapeStr += this.createPathShape(matrixHelper, shapes);
        }
      } else {
        if (singleShape) {
          tSpan.setAttribute('transform', 'translate(' + matrixHelper.props[12] + ',' + matrixHelper.props[13] + ')');
        }
        tSpan.textContent = letters[i].val;
        tSpan.setAttributeNS('http://www.w3.org/XML/1998/namespace', 'xml:space', 'preserve');
      }
      //
    }
    if (singleShape && tSpan) {
      tSpan.setAttribute('d', shapeStr);
    }
  }
  while (i < this.textSpans.length) {
    this.textSpans[i].style.display = 'none';
    i += 1;
  }

  this._sizeChanged = true;
};

SVGTextLottieElement.prototype.sourceRectAtTime = function () {
  this.prepareFrame(this.comp.renderedFrame - this.data.st);
  this.renderInnerContent();
  if (this._sizeChanged) {
    this._sizeChanged = false;
    var textBox = this.layerElement.getBBox();
    this.bbox = {
      top: textBox.y,
      left: textBox.x,
      width: textBox.width,
      height: textBox.height,
    };
  }
  return this.bbox;
};

SVGTextLottieElement.prototype.renderInnerContent = function () {
  if (!this.data.singleShape) {
    this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
    if (this.lettersChangedFlag || this.textAnimator.lettersChangedFlag) {
      this._sizeChanged = true;
      var i;
      var len;
      var renderedLetters = this.textAnimator.renderedLetters;

      var letters = this.textProperty.currentData.l;

      len = letters.length;
      var renderedLetter;
      var textSpan;
      for (i = 0; i < len; i += 1) {
        if (!letters[i].n) {
          renderedLetter = renderedLetters[i];
          textSpan = this.textSpans[i];
          if (renderedLetter._mdf.m) {
            textSpan.setAttribute('transform', renderedLetter.m);
          }
          if (renderedLetter._mdf.o) {
            textSpan.setAttribute('opacity', renderedLetter.o);
          }
          if (renderedLetter._mdf.sw) {
            textSpan.setAttribute('stroke-width', renderedLetter.sw);
          }
          if (renderedLetter._mdf.sc) {
            textSpan.setAttribute('stroke', renderedLetter.sc);
          }
          if (renderedLetter._mdf.fc) {
            textSpan.setAttribute('fill', renderedLetter.fc);
          }
        }
      }
    }
  }
};

/* global extendPrototype, BaseElement, TransformElement, SVGBaseElement, IShapeElement, HierarchyElement,
FrameElement, RenderableDOMElement, Matrix, SVGStyleData, SVGStrokeStyleData, SVGFillStyleData,
SVGGradientFillStyleData, SVGGradientStrokeStyleData, locationHref, getBlendMode, ShapeGroupData,
TransformPropertyFactory, SVGTransformData, ShapePropertyFactory, SVGShapeData, SVGElementsRenderer, ShapeModifiers */

function SVGShapeElement(data, globalData, comp) {
  // List of drawable elements
  this.shapes = [];
  // Full shape data
  this.shapesData = data.shapes;
  // List of styles that will be applied to shapes
  this.stylesList = [];
  // List of modifiers that will be applied to shapes
  this.shapeModifiers = [];
  // List of items in shape tree
  this.itemsData = [];
  // List of items in previous shape tree
  this.processedElements = [];
  // List of animated components
  this.animatedContents = [];
  this.initElement(data, globalData, comp);
  // Moving any property that doesn't get too much access after initialization because of v8 way of handling more than 10 properties.
  // List of elements that have been created
  this.prevViewData = [];
  // Moving any property that doesn't get too much access after initialization because of v8 way of handling more than 10 properties.
}

extendPrototype([BaseElement, TransformElement, SVGBaseElement, IShapeElement, HierarchyElement, FrameElement, RenderableDOMElement], SVGShapeElement);

SVGShapeElement.prototype.initSecondaryElement = function () {
};

SVGShapeElement.prototype.identityMatrix = new Matrix();

SVGShapeElement.prototype.buildExpressionInterface = function () {};

SVGShapeElement.prototype.createContent = function () {
  this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], true);
  this.filterUniqueShapes();
};

/*
This method searches for multiple shapes that affect a single element and one of them is animated
*/
SVGShapeElement.prototype.filterUniqueShapes = function () {
  var i;
  var len = this.shapes.length;
  var shape;
  var j;
  var jLen = this.stylesList.length;
  var style;
  var tempShapes = [];
  var areAnimated = false;
  for (j = 0; j < jLen; j += 1) {
    style = this.stylesList[j];
    areAnimated = false;
    tempShapes.length = 0;
    for (i = 0; i < len; i += 1) {
      shape = this.shapes[i];
      if (shape.styles.indexOf(style) !== -1) {
        tempShapes.push(shape);
        areAnimated = shape._isAnimated || areAnimated;
      }
    }
    if (tempShapes.length > 1 && areAnimated) {
      this.setShapesAsAnimated(tempShapes);
    }
  }
};

SVGShapeElement.prototype.setShapesAsAnimated = function (shapes) {
  var i;
  var len = shapes.length;
  for (i = 0; i < len; i += 1) {
    shapes[i].setAsAnimated();
  }
};

SVGShapeElement.prototype.createStyleElement = function (data, level) {
  // TODO: prevent drawing of hidden styles
  var elementData;
  var styleOb = new SVGStyleData(data, level);

  var pathElement = styleOb.pElem;
  if (data.ty === 'st') {
    elementData = new SVGStrokeStyleData(this, data, styleOb);
  } else if (data.ty === 'fl') {
    elementData = new SVGFillStyleData(this, data, styleOb);
  } else if (data.ty === 'gf' || data.ty === 'gs') {
    var GradientConstructor = data.ty === 'gf' ? SVGGradientFillStyleData : SVGGradientStrokeStyleData;
    elementData = new GradientConstructor(this, data, styleOb);
    this.globalData.defs.appendChild(elementData.gf);
    if (elementData.maskId) {
      this.globalData.defs.appendChild(elementData.ms);
      this.globalData.defs.appendChild(elementData.of);
      pathElement.setAttribute('mask', 'url(' + locationHref + '#' + elementData.maskId + ')');
    }
  }

  if (data.ty === 'st' || data.ty === 'gs') {
    pathElement.setAttribute('stroke-linecap', this.lcEnum[data.lc] || 'round');
    pathElement.setAttribute('stroke-linejoin', this.ljEnum[data.lj] || 'round');
    pathElement.setAttribute('fill-opacity', '0');
    if (data.lj === 1) {
      pathElement.setAttribute('stroke-miterlimit', data.ml);
    }
  }

  if (data.r === 2) {
    pathElement.setAttribute('fill-rule', 'evenodd');
  }

  if (data.ln) {
    pathElement.setAttribute('id', data.ln);
  }
  if (data.cl) {
    pathElement.setAttribute('class', data.cl);
  }
  if (data.bm) {
    pathElement.style['mix-blend-mode'] = getBlendMode(data.bm);
  }
  this.stylesList.push(styleOb);
  this.addToAnimatedContents(data, elementData);
  return elementData;
};

SVGShapeElement.prototype.createGroupElement = function (data) {
  var elementData = new ShapeGroupData();
  if (data.ln) {
    elementData.gr.setAttribute('id', data.ln);
  }
  if (data.cl) {
    elementData.gr.setAttribute('class', data.cl);
  }
  if (data.bm) {
    elementData.gr.style['mix-blend-mode'] = getBlendMode(data.bm);
  }
  return elementData;
};

SVGShapeElement.prototype.createTransformElement = function (data, container) {
  var transformProperty = TransformPropertyFactory.getTransformProperty(this, data, this);
  var elementData = new SVGTransformData(transformProperty, transformProperty.o, container);
  this.addToAnimatedContents(data, elementData);
  return elementData;
};

SVGShapeElement.prototype.createShapeElement = function (data, ownTransformers, level) {
  var ty = 4;
  if (data.ty === 'rc') {
    ty = 5;
  } else if (data.ty === 'el') {
    ty = 6;
  } else if (data.ty === 'sr') {
    ty = 7;
  }
  var shapeProperty = ShapePropertyFactory.getShapeProp(this, data, ty, this);
  var elementData = new SVGShapeData(ownTransformers, level, shapeProperty);
  this.shapes.push(elementData);
  this.addShapeToModifiers(elementData);
  this.addToAnimatedContents(data, elementData);
  return elementData;
};

SVGShapeElement.prototype.addToAnimatedContents = function (data, element) {
  var i = 0;
  var len = this.animatedContents.length;
  while (i < len) {
    if (this.animatedContents[i].element === element) {
      return;
    }
    i += 1;
  }
  this.animatedContents.push({
    fn: SVGElementsRenderer.createRenderFunction(data),
    element: element,
    data: data,
  });
};

SVGShapeElement.prototype.setElementStyles = function (elementData) {
  var arr = elementData.styles;
  var j;
  var jLen = this.stylesList.length;
  for (j = 0; j < jLen; j += 1) {
    if (!this.stylesList[j].closed) {
      arr.push(this.stylesList[j]);
    }
  }
};

SVGShapeElement.prototype.reloadShapes = function () {
  this._isFirstFrame = true;
  var i;
  var len = this.itemsData.length;
  for (i = 0; i < len; i += 1) {
    this.prevViewData[i] = this.itemsData[i];
  }
  this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], true);
  this.filterUniqueShapes();
  len = this.dynamicProperties.length;
  for (i = 0; i < len; i += 1) {
    this.dynamicProperties[i].getValue();
  }
  this.renderModifiers();
};

SVGShapeElement.prototype.searchShapes = function (arr, itemsData, prevViewData, container, level, transformers, render) {
  var ownTransformers = [].concat(transformers);
  var i;
  var len = arr.length - 1;
  var j;
  var jLen;
  var ownStyles = [];
  var ownModifiers = [];
  var currentTransform;
  var modifier;
  var processedPos;
  for (i = len; i >= 0; i -= 1) {
    processedPos = this.searchProcessedElement(arr[i]);
    if (!processedPos) {
      arr[i]._render = render;
    } else {
      itemsData[i] = prevViewData[processedPos - 1];
    }
    if (arr[i].ty === 'fl' || arr[i].ty === 'st' || arr[i].ty === 'gf' || arr[i].ty === 'gs') {
      if (!processedPos) {
        itemsData[i] = this.createStyleElement(arr[i], level);
      } else {
        itemsData[i].style.closed = false;
      }
      if (arr[i]._render) {
        container.appendChild(itemsData[i].style.pElem);
      }
      ownStyles.push(itemsData[i].style);
    } else if (arr[i].ty === 'gr') {
      if (!processedPos) {
        itemsData[i] = this.createGroupElement(arr[i]);
      } else {
        jLen = itemsData[i].it.length;
        for (j = 0; j < jLen; j += 1) {
          itemsData[i].prevViewData[j] = itemsData[i].it[j];
        }
      }
      this.searchShapes(arr[i].it, itemsData[i].it, itemsData[i].prevViewData, itemsData[i].gr, level + 1, ownTransformers, render);
      if (arr[i]._render) {
        container.appendChild(itemsData[i].gr);
      }
    } else if (arr[i].ty === 'tr') {
      if (!processedPos) {
        itemsData[i] = this.createTransformElement(arr[i], container);
      }
      currentTransform = itemsData[i].transform;
      ownTransformers.push(currentTransform);
    } else if (arr[i].ty === 'sh' || arr[i].ty === 'rc' || arr[i].ty === 'el' || arr[i].ty === 'sr') {
      if (!processedPos) {
        itemsData[i] = this.createShapeElement(arr[i], ownTransformers, level);
      }
      this.setElementStyles(itemsData[i]);
    } else if (arr[i].ty === 'tm' || arr[i].ty === 'rd' || arr[i].ty === 'ms' || arr[i].ty === 'pb') {
      if (!processedPos) {
        modifier = ShapeModifiers.getModifier(arr[i].ty);
        modifier.init(this, arr[i]);
        itemsData[i] = modifier;
        this.shapeModifiers.push(modifier);
      } else {
        modifier = itemsData[i];
        modifier.closed = false;
      }
      ownModifiers.push(modifier);
    } else if (arr[i].ty === 'rp') {
      if (!processedPos) {
        modifier = ShapeModifiers.getModifier(arr[i].ty);
        itemsData[i] = modifier;
        modifier.init(this, arr, i, itemsData);
        this.shapeModifiers.push(modifier);
        render = false;
      } else {
        modifier = itemsData[i];
        modifier.closed = true;
      }
      ownModifiers.push(modifier);
    }
    this.addProcessedElement(arr[i], i + 1);
  }
  len = ownStyles.length;
  for (i = 0; i < len; i += 1) {
    ownStyles[i].closed = true;
  }
  len = ownModifiers.length;
  for (i = 0; i < len; i += 1) {
    ownModifiers[i].closed = true;
  }
};

SVGShapeElement.prototype.renderInnerContent = function () {
  this.renderModifiers();
  var i;
  var len = this.stylesList.length;
  for (i = 0; i < len; i += 1) {
    this.stylesList[i].reset();
  }
  this.renderShape();

  for (i = 0; i < len; i += 1) {
    if (this.stylesList[i]._mdf || this._isFirstFrame) {
      if (this.stylesList[i].msElem) {
        this.stylesList[i].msElem.setAttribute('d', this.stylesList[i].d);
        // Adding M0 0 fixes same mask bug on all browsers
        this.stylesList[i].d = 'M0 0' + this.stylesList[i].d;
      }
      this.stylesList[i].pElem.setAttribute('d', this.stylesList[i].d || 'M0 0');
    }
  }
};

SVGShapeElement.prototype.renderShape = function () {
  var i;
  var len = this.animatedContents.length;
  var animatedContent;
  for (i = 0; i < len; i += 1) {
    animatedContent = this.animatedContents[i];
    if ((this._isFirstFrame || animatedContent.element._isAnimated) && animatedContent.data !== true) {
      animatedContent.fn(animatedContent.data, animatedContent.element, this._isFirstFrame);
    }
  }
};

SVGShapeElement.prototype.destroy = function () {
  this.destroyBaseElement();
  this.shapesData = null;
  this.itemsData = null;
};

/* global createNS */

function SVGTintFilter(filter, filterManager) {
  this.filterManager = filterManager;
  var feColorMatrix = createNS('feColorMatrix');
  feColorMatrix.setAttribute('type', 'matrix');
  feColorMatrix.setAttribute('color-interpolation-filters', 'linearRGB');
  feColorMatrix.setAttribute('values', '0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0');
  feColorMatrix.setAttribute('result', 'f1');
  filter.appendChild(feColorMatrix);
  feColorMatrix = createNS('feColorMatrix');
  feColorMatrix.setAttribute('type', 'matrix');
  feColorMatrix.setAttribute('color-interpolation-filters', 'sRGB');
  feColorMatrix.setAttribute('values', '1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0');
  feColorMatrix.setAttribute('result', 'f2');
  filter.appendChild(feColorMatrix);
  this.matrixFilter = feColorMatrix;
  if (filterManager.effectElements[2].p.v !== 100 || filterManager.effectElements[2].p.k) {
    var feMerge = createNS('feMerge');
    filter.appendChild(feMerge);
    var feMergeNode;
    feMergeNode = createNS('feMergeNode');
    feMergeNode.setAttribute('in', 'SourceGraphic');
    feMerge.appendChild(feMergeNode);
    feMergeNode = createNS('feMergeNode');
    feMergeNode.setAttribute('in', 'f2');
    feMerge.appendChild(feMergeNode);
  }
}

SVGTintFilter.prototype.renderFrame = function (forceRender) {
  if (forceRender || this.filterManager._mdf) {
    var colorBlack = this.filterManager.effectElements[0].p.v;
    var colorWhite = this.filterManager.effectElements[1].p.v;
    var opacity = this.filterManager.effectElements[2].p.v / 100;
    this.matrixFilter.setAttribute('values', (colorWhite[0] - colorBlack[0]) + ' 0 0 0 ' + colorBlack[0] + ' ' + (colorWhite[1] - colorBlack[1]) + ' 0 0 0 ' + colorBlack[1] + ' ' + (colorWhite[2] - colorBlack[2]) + ' 0 0 0 ' + colorBlack[2] + ' 0 0 0 ' + opacity + ' 0');
  }
};

/* global createNS */

function SVGFillFilter(filter, filterManager) {
  this.filterManager = filterManager;
  var feColorMatrix = createNS('feColorMatrix');
  feColorMatrix.setAttribute('type', 'matrix');
  feColorMatrix.setAttribute('color-interpolation-filters', 'sRGB');
  feColorMatrix.setAttribute('values', '1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0');
  filter.appendChild(feColorMatrix);
  this.matrixFilter = feColorMatrix;
}
SVGFillFilter.prototype.renderFrame = function (forceRender) {
  if (forceRender || this.filterManager._mdf) {
    var color = this.filterManager.effectElements[2].p.v;
    var opacity = this.filterManager.effectElements[6].p.v;
    this.matrixFilter.setAttribute('values', '0 0 0 0 ' + color[0] + ' 0 0 0 0 ' + color[1] + ' 0 0 0 0 ' + color[2] + ' 0 0 0 ' + opacity + ' 0');
  }
};

/* global createNS */

function SVGGaussianBlurEffect(filter, filterManager) {
  // Outset the filter region by 100% on all sides to accommodate blur expansion.
  filter.setAttribute('x', '-100%');
  filter.setAttribute('y', '-100%');
  filter.setAttribute('width', '300%');
  filter.setAttribute('height', '300%');

  this.filterManager = filterManager;
  var feGaussianBlur = createNS('feGaussianBlur');
  filter.appendChild(feGaussianBlur);
  this.feGaussianBlur = feGaussianBlur;
}

SVGGaussianBlurEffect.prototype.renderFrame = function (forceRender) {
  if (forceRender || this.filterManager._mdf) {
    // Empirical value, matching AE's blur appearance.
    var kBlurrinessToSigma = 0.3;
    var sigma = this.filterManager.effectElements[0].p.v * kBlurrinessToSigma;

    // Dimensions mapping:
    //
    //   1 -> horizontal & vertical
    //   2 -> horizontal only
    //   3 -> vertical only
    //
    var dimensions = this.filterManager.effectElements[1].p.v;
    var sigmaX = (dimensions == 3) ? 0 : sigma; // eslint-disable-line eqeqeq
    var sigmaY = (dimensions == 2) ? 0 : sigma; // eslint-disable-line eqeqeq

    this.feGaussianBlur.setAttribute('stdDeviation', sigmaX + ' ' + sigmaY);

    // Repeat edges mapping:
    //
    //   0 -> off -> duplicate
    //   1 -> on  -> wrap
    var edgeMode = (this.filterManager.effectElements[2].p.v == 1) ? 'wrap' : 'duplicate'; // eslint-disable-line eqeqeq
    this.feGaussianBlur.setAttribute('edgeMode', edgeMode);
  }
};

/* global createNS, createElementID, locationHref, bmFloor */

function SVGStrokeEffect(elem, filterManager) {
  this.initialized = false;
  this.filterManager = filterManager;
  this.elem = elem;
  this.paths = [];
}

SVGStrokeEffect.prototype.initialize = function () {
  var elemChildren = this.elem.layerElement.children || this.elem.layerElement.childNodes;
  var path;
  var groupPath;
  var i;
  var len;
  if (this.filterManager.effectElements[1].p.v === 1) {
    len = this.elem.maskManager.masksProperties.length;
    i = 0;
  } else {
    i = this.filterManager.effectElements[0].p.v - 1;
    len = i + 1;
  }
  groupPath = createNS('g');
  groupPath.setAttribute('fill', 'none');
  groupPath.setAttribute('stroke-linecap', 'round');
  groupPath.setAttribute('stroke-dashoffset', 1);
  for (i; i < len; i += 1) {
    path = createNS('path');
    groupPath.appendChild(path);
    this.paths.push({ p: path, m: i });
  }
  if (this.filterManager.effectElements[10].p.v === 3) {
    var mask = createNS('mask');
    var id = createElementID();
    mask.setAttribute('id', id);
    mask.setAttribute('mask-type', 'alpha');
    mask.appendChild(groupPath);
    this.elem.globalData.defs.appendChild(mask);
    var g = createNS('g');
    g.setAttribute('mask', 'url(' + locationHref + '#' + id + ')');
    while (elemChildren[0]) {
      g.appendChild(elemChildren[0]);
    }
    this.elem.layerElement.appendChild(g);
    this.masker = mask;
    groupPath.setAttribute('stroke', '#fff');
  } else if (this.filterManager.effectElements[10].p.v === 1 || this.filterManager.effectElements[10].p.v === 2) {
    if (this.filterManager.effectElements[10].p.v === 2) {
      elemChildren = this.elem.layerElement.children || this.elem.layerElement.childNodes;
      while (elemChildren.length) {
        this.elem.layerElement.removeChild(elemChildren[0]);
      }
    }
    this.elem.layerElement.appendChild(groupPath);
    this.elem.layerElement.removeAttribute('mask');
    groupPath.setAttribute('stroke', '#fff');
  }
  this.initialized = true;
  this.pathMasker = groupPath;
};

SVGStrokeEffect.prototype.renderFrame = function (forceRender) {
  if (!this.initialized) {
    this.initialize();
  }
  var i;
  var len = this.paths.length;
  var mask;
  var path;
  for (i = 0; i < len; i += 1) {
    if (this.paths[i].m !== -1) {
      mask = this.elem.maskManager.viewData[this.paths[i].m];
      path = this.paths[i].p;
      if (forceRender || this.filterManager._mdf || mask.prop._mdf) {
        path.setAttribute('d', mask.lastPath);
      }
      if (forceRender || this.filterManager.effectElements[9].p._mdf || this.filterManager.effectElements[4].p._mdf || this.filterManager.effectElements[7].p._mdf || this.filterManager.effectElements[8].p._mdf || mask.prop._mdf) {
        var dasharrayValue;
        if (this.filterManager.effectElements[7].p.v !== 0 || this.filterManager.effectElements[8].p.v !== 100) {
          var s = Math.min(this.filterManager.effectElements[7].p.v, this.filterManager.effectElements[8].p.v) * 0.01;
          var e = Math.max(this.filterManager.effectElements[7].p.v, this.filterManager.effectElements[8].p.v) * 0.01;
          var l = path.getTotalLength();
          dasharrayValue = '0 0 0 ' + l * s + ' ';
          var lineLength = l * (e - s);
          var segment = 1 + this.filterManager.effectElements[4].p.v * 2 * this.filterManager.effectElements[9].p.v * 0.01;
          var units = Math.floor(lineLength / segment);
          var j;
          for (j = 0; j < units; j += 1) {
            dasharrayValue += '1 ' + this.filterManager.effectElements[4].p.v * 2 * this.filterManager.effectElements[9].p.v * 0.01 + ' ';
          }
          dasharrayValue += '0 ' + l * 10 + ' 0 0';
        } else {
          dasharrayValue = '1 ' + this.filterManager.effectElements[4].p.v * 2 * this.filterManager.effectElements[9].p.v * 0.01;
        }
        path.setAttribute('stroke-dasharray', dasharrayValue);
      }
    }
  }
  if (forceRender || this.filterManager.effectElements[4].p._mdf) {
    this.pathMasker.setAttribute('stroke-width', this.filterManager.effectElements[4].p.v * 2);
  }

  if (forceRender || this.filterManager.effectElements[6].p._mdf) {
    this.pathMasker.setAttribute('opacity', this.filterManager.effectElements[6].p.v);
  }
  if (this.filterManager.effectElements[10].p.v === 1 || this.filterManager.effectElements[10].p.v === 2) {
    if (forceRender || this.filterManager.effectElements[3].p._mdf) {
      var color = this.filterManager.effectElements[3].p.v;
      this.pathMasker.setAttribute('stroke', 'rgb(' + bmFloor(color[0] * 255) + ',' + bmFloor(color[1] * 255) + ',' + bmFloor(color[2] * 255) + ')');
    }
  }
};

/* global createNS */

function SVGTritoneFilter(filter, filterManager) {
  this.filterManager = filterManager;
  var feColorMatrix = createNS('feColorMatrix');
  feColorMatrix.setAttribute('type', 'matrix');
  feColorMatrix.setAttribute('color-interpolation-filters', 'linearRGB');
  feColorMatrix.setAttribute('values', '0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0');
  feColorMatrix.setAttribute('result', 'f1');
  filter.appendChild(feColorMatrix);
  var feComponentTransfer = createNS('feComponentTransfer');
  feComponentTransfer.setAttribute('color-interpolation-filters', 'sRGB');
  filter.appendChild(feComponentTransfer);
  this.matrixFilter = feComponentTransfer;
  var feFuncR = createNS('feFuncR');
  feFuncR.setAttribute('type', 'table');
  feComponentTransfer.appendChild(feFuncR);
  this.feFuncR = feFuncR;
  var feFuncG = createNS('feFuncG');
  feFuncG.setAttribute('type', 'table');
  feComponentTransfer.appendChild(feFuncG);
  this.feFuncG = feFuncG;
  var feFuncB = createNS('feFuncB');
  feFuncB.setAttribute('type', 'table');
  feComponentTransfer.appendChild(feFuncB);
  this.feFuncB = feFuncB;
}

SVGTritoneFilter.prototype.renderFrame = function (forceRender) {
  if (forceRender || this.filterManager._mdf) {
    var color1 = this.filterManager.effectElements[0].p.v;
    var color2 = this.filterManager.effectElements[1].p.v;
    var color3 = this.filterManager.effectElements[2].p.v;
    var tableR = color3[0] + ' ' + color2[0] + ' ' + color1[0];
    var tableG = color3[1] + ' ' + color2[1] + ' ' + color1[1];
    var tableB = color3[2] + ' ' + color2[2] + ' ' + color1[2];
    this.feFuncR.setAttribute('tableValues', tableR);
    this.feFuncG.setAttribute('tableValues', tableG);
    this.feFuncB.setAttribute('tableValues', tableB);
    // var opacity = this.filterManager.effectElements[2].p.v/100;
    // this.matrixFilter.setAttribute('values',(colorWhite[0]- colorBlack[0])+' 0 0 0 '+ colorBlack[0] +' '+ (colorWhite[1]- colorBlack[1]) +' 0 0 0 '+ colorBlack[1] +' '+ (colorWhite[2]- colorBlack[2]) +' 0 0 0 '+ colorBlack[2] +' 0 0 0 ' + opacity + ' 0');
  }
};

/* global createNS */

function SVGProLevelsFilter(filter, filterManager) {
  this.filterManager = filterManager;
  var effectElements = this.filterManager.effectElements;
  var feComponentTransfer = createNS('feComponentTransfer');

  if (effectElements[10].p.k || effectElements[10].p.v !== 0 || effectElements[11].p.k || effectElements[11].p.v !== 1 || effectElements[12].p.k || effectElements[12].p.v !== 1 || effectElements[13].p.k || effectElements[13].p.v !== 0 || effectElements[14].p.k || effectElements[14].p.v !== 1) {
    this.feFuncR = this.createFeFunc('feFuncR', feComponentTransfer);
  }
  if (effectElements[17].p.k || effectElements[17].p.v !== 0 || effectElements[18].p.k || effectElements[18].p.v !== 1 || effectElements[19].p.k || effectElements[19].p.v !== 1 || effectElements[20].p.k || effectElements[20].p.v !== 0 || effectElements[21].p.k || effectElements[21].p.v !== 1) {
    this.feFuncG = this.createFeFunc('feFuncG', feComponentTransfer);
  }
  if (effectElements[24].p.k || effectElements[24].p.v !== 0 || effectElements[25].p.k || effectElements[25].p.v !== 1 || effectElements[26].p.k || effectElements[26].p.v !== 1 || effectElements[27].p.k || effectElements[27].p.v !== 0 || effectElements[28].p.k || effectElements[28].p.v !== 1) {
    this.feFuncB = this.createFeFunc('feFuncB', feComponentTransfer);
  }
  if (effectElements[31].p.k || effectElements[31].p.v !== 0 || effectElements[32].p.k || effectElements[32].p.v !== 1 || effectElements[33].p.k || effectElements[33].p.v !== 1 || effectElements[34].p.k || effectElements[34].p.v !== 0 || effectElements[35].p.k || effectElements[35].p.v !== 1) {
    this.feFuncA = this.createFeFunc('feFuncA', feComponentTransfer);
  }

  if (this.feFuncR || this.feFuncG || this.feFuncB || this.feFuncA) {
    feComponentTransfer.setAttribute('color-interpolation-filters', 'sRGB');
    filter.appendChild(feComponentTransfer);
    feComponentTransfer = createNS('feComponentTransfer');
  }

  if (effectElements[3].p.k || effectElements[3].p.v !== 0 || effectElements[4].p.k || effectElements[4].p.v !== 1 || effectElements[5].p.k || effectElements[5].p.v !== 1 || effectElements[6].p.k || effectElements[6].p.v !== 0 || effectElements[7].p.k || effectElements[7].p.v !== 1) {
    feComponentTransfer.setAttribute('color-interpolation-filters', 'sRGB');
    filter.appendChild(feComponentTransfer);
    this.feFuncRComposed = this.createFeFunc('feFuncR', feComponentTransfer);
    this.feFuncGComposed = this.createFeFunc('feFuncG', feComponentTransfer);
    this.feFuncBComposed = this.createFeFunc('feFuncB', feComponentTransfer);
  }
}

SVGProLevelsFilter.prototype.createFeFunc = function (type, feComponentTransfer) {
  var feFunc = createNS(type);
  feFunc.setAttribute('type', 'table');
  feComponentTransfer.appendChild(feFunc);
  return feFunc;
};

SVGProLevelsFilter.prototype.getTableValue = function (inputBlack, inputWhite, gamma, outputBlack, outputWhite) {
  var cnt = 0;
  var segments = 256;
  var perc;
  var min = Math.min(inputBlack, inputWhite);
  var max = Math.max(inputBlack, inputWhite);
  var table = Array.call(null, { length: segments });
  var colorValue;
  var pos = 0;
  var outputDelta = outputWhite - outputBlack;
  var inputDelta = inputWhite - inputBlack;
  while (cnt <= 256) {
    perc = cnt / 256;
    if (perc <= min) {
      colorValue = inputDelta < 0 ? outputWhite : outputBlack;
    } else if (perc >= max) {
      colorValue = inputDelta < 0 ? outputBlack : outputWhite;
    } else {
      colorValue = (outputBlack + outputDelta * Math.pow((perc - inputBlack) / inputDelta, 1 / gamma));
    }
    table[pos] = colorValue;
    pos += 1;
    cnt += 256 / (segments - 1);
  }
  return table.join(' ');
};

SVGProLevelsFilter.prototype.renderFrame = function (forceRender) {
  if (forceRender || this.filterManager._mdf) {
    var val;
    var effectElements = this.filterManager.effectElements;
    if (this.feFuncRComposed && (forceRender || effectElements[3].p._mdf || effectElements[4].p._mdf || effectElements[5].p._mdf || effectElements[6].p._mdf || effectElements[7].p._mdf)) {
      val = this.getTableValue(effectElements[3].p.v, effectElements[4].p.v, effectElements[5].p.v, effectElements[6].p.v, effectElements[7].p.v);
      this.feFuncRComposed.setAttribute('tableValues', val);
      this.feFuncGComposed.setAttribute('tableValues', val);
      this.feFuncBComposed.setAttribute('tableValues', val);
    }

    if (this.feFuncR && (forceRender || effectElements[10].p._mdf || effectElements[11].p._mdf || effectElements[12].p._mdf || effectElements[13].p._mdf || effectElements[14].p._mdf)) {
      val = this.getTableValue(effectElements[10].p.v, effectElements[11].p.v, effectElements[12].p.v, effectElements[13].p.v, effectElements[14].p.v);
      this.feFuncR.setAttribute('tableValues', val);
    }

    if (this.feFuncG && (forceRender || effectElements[17].p._mdf || effectElements[18].p._mdf || effectElements[19].p._mdf || effectElements[20].p._mdf || effectElements[21].p._mdf)) {
      val = this.getTableValue(effectElements[17].p.v, effectElements[18].p.v, effectElements[19].p.v, effectElements[20].p.v, effectElements[21].p.v);
      this.feFuncG.setAttribute('tableValues', val);
    }

    if (this.feFuncB && (forceRender || effectElements[24].p._mdf || effectElements[25].p._mdf || effectElements[26].p._mdf || effectElements[27].p._mdf || effectElements[28].p._mdf)) {
      val = this.getTableValue(effectElements[24].p.v, effectElements[25].p.v, effectElements[26].p.v, effectElements[27].p.v, effectElements[28].p.v);
      this.feFuncB.setAttribute('tableValues', val);
    }

    if (this.feFuncA && (forceRender || effectElements[31].p._mdf || effectElements[32].p._mdf || effectElements[33].p._mdf || effectElements[34].p._mdf || effectElements[35].p._mdf)) {
      val = this.getTableValue(effectElements[31].p.v, effectElements[32].p.v, effectElements[33].p.v, effectElements[34].p.v, effectElements[35].p.v);
      this.feFuncA.setAttribute('tableValues', val);
    }
  }
};

/* global createNS, rgbToHex, degToRads */

function SVGDropShadowEffect(filter, filterManager) {
  var filterSize = filterManager.container.globalData.renderConfig.filterSize;
  filter.setAttribute('x', filterSize.x);
  filter.setAttribute('y', filterSize.y);
  filter.setAttribute('width', filterSize.width);
  filter.setAttribute('height', filterSize.height);
  this.filterManager = filterManager;

  var feGaussianBlur = createNS('feGaussianBlur');
  feGaussianBlur.setAttribute('in', 'SourceAlpha');
  feGaussianBlur.setAttribute('result', 'drop_shadow_1');
  feGaussianBlur.setAttribute('stdDeviation', '0');
  this.feGaussianBlur = feGaussianBlur;
  filter.appendChild(feGaussianBlur);

  var feOffset = createNS('feOffset');
  feOffset.setAttribute('dx', '25');
  feOffset.setAttribute('dy', '0');
  feOffset.setAttribute('in', 'drop_shadow_1');
  feOffset.setAttribute('result', 'drop_shadow_2');
  this.feOffset = feOffset;
  filter.appendChild(feOffset);
  var feFlood = createNS('feFlood');
  feFlood.setAttribute('flood-color', '#00ff00');
  feFlood.setAttribute('flood-opacity', '1');
  feFlood.setAttribute('result', 'drop_shadow_3');
  this.feFlood = feFlood;
  filter.appendChild(feFlood);

  var feComposite = createNS('feComposite');
  feComposite.setAttribute('in', 'drop_shadow_3');
  feComposite.setAttribute('in2', 'drop_shadow_2');
  feComposite.setAttribute('operator', 'in');
  feComposite.setAttribute('result', 'drop_shadow_4');
  filter.appendChild(feComposite);

  var feMerge = createNS('feMerge');
  filter.appendChild(feMerge);
  var feMergeNode;
  feMergeNode = createNS('feMergeNode');
  feMerge.appendChild(feMergeNode);
  feMergeNode = createNS('feMergeNode');
  feMergeNode.setAttribute('in', 'SourceGraphic');
  this.feMergeNode = feMergeNode;
  this.feMerge = feMerge;
  this.originalNodeAdded = false;
  feMerge.appendChild(feMergeNode);
}

SVGDropShadowEffect.prototype.renderFrame = function (forceRender) {
  if (forceRender || this.filterManager._mdf) {
    if (forceRender || this.filterManager.effectElements[4].p._mdf) {
      this.feGaussianBlur.setAttribute('stdDeviation', this.filterManager.effectElements[4].p.v / 4);
    }
    if (forceRender || this.filterManager.effectElements[0].p._mdf) {
      var col = this.filterManager.effectElements[0].p.v;
      this.feFlood.setAttribute('flood-color', rgbToHex(Math.round(col[0] * 255), Math.round(col[1] * 255), Math.round(col[2] * 255)));
    }
    if (forceRender || this.filterManager.effectElements[1].p._mdf) {
      this.feFlood.setAttribute('flood-opacity', this.filterManager.effectElements[1].p.v / 255);
    }
    if (forceRender || this.filterManager.effectElements[2].p._mdf || this.filterManager.effectElements[3].p._mdf) {
      var distance = this.filterManager.effectElements[3].p.v;
      var angle = (this.filterManager.effectElements[2].p.v - 90) * degToRads;
      var x = distance * Math.cos(angle);
      var y = distance * Math.sin(angle);
      this.feOffset.setAttribute('dx', x);
      this.feOffset.setAttribute('dy', y);
    }
    /* if(forceRender || this.filterManager.effectElements[5].p._mdf){
            if(this.filterManager.effectElements[5].p.v === 1 && this.originalNodeAdded) {
                this.feMerge.removeChild(this.feMergeNode);
                this.originalNodeAdded = false;
            } else if(this.filterManager.effectElements[5].p.v === 0 && !this.originalNodeAdded) {
                this.feMerge.appendChild(this.feMergeNode);
                this.originalNodeAdded = true;
            }
        } */
  }
};

/* global createElementID, createNS */

var _svgMatteSymbols = [];

function SVGMatte3Effect(filterElem, filterManager, elem) {
  this.initialized = false;
  this.filterManager = filterManager;
  this.filterElem = filterElem;
  this.elem = elem;
  elem.matteElement = createNS('g');
  elem.matteElement.appendChild(elem.layerElement);
  elem.matteElement.appendChild(elem.transformedElement);
  elem.baseElement = elem.matteElement;
}

SVGMatte3Effect.prototype.findSymbol = function (mask) {
  var i = 0;
  var len = _svgMatteSymbols.length;
  while (i < len) {
    if (_svgMatteSymbols[i] === mask) {
      return _svgMatteSymbols[i];
    }
    i += 1;
  }
  return null;
};

SVGMatte3Effect.prototype.replaceInParent = function (mask, symbolId) {
  var parentNode = mask.layerElement.parentNode;
  if (!parentNode) {
    return;
  }
  var children = parentNode.children;
  var i = 0;
  var len = children.length;
  while (i < len) {
    if (children[i] === mask.layerElement) {
      break;
    }
    i += 1;
  }
  var nextChild;
  if (i <= len - 2) {
    nextChild = children[i + 1];
  }
  var useElem = createNS('use');
  useElem.setAttribute('href', '#' + symbolId);
  if (nextChild) {
    parentNode.insertBefore(useElem, nextChild);
  } else {
    parentNode.appendChild(useElem);
  }
};

SVGMatte3Effect.prototype.setElementAsMask = function (elem, mask) {
  if (!this.findSymbol(mask)) {
    var symbolId = createElementID();
    var masker = createNS('mask');
    masker.setAttribute('id', mask.layerId);
    masker.setAttribute('mask-type', 'alpha');
    _svgMatteSymbols.push(mask);
    var defs = elem.globalData.defs;
    defs.appendChild(masker);
    var symbol = createNS('symbol');
    symbol.setAttribute('id', symbolId);
    this.replaceInParent(mask, symbolId);
    symbol.appendChild(mask.layerElement);
    defs.appendChild(symbol);
    var useElem = createNS('use');
    useElem.setAttribute('href', '#' + symbolId);
    masker.appendChild(useElem);
    mask.data.hd = false;
    mask.show();
  }
  elem.setMatte(mask.layerId);
};

SVGMatte3Effect.prototype.initialize = function () {
  var ind = this.filterManager.effectElements[0].p.v;
  var elements = this.elem.comp.elements;
  var i = 0;
  var len = elements.length;
  while (i < len) {
    if (elements[i] && elements[i].data.ind === ind) {
      this.setElementAsMask(this.elem, elements[i]);
    }
    i += 1;
  }
  this.initialized = true;
};

SVGMatte3Effect.prototype.renderFrame = function () {
  if (!this.initialized) {
    this.initialize();
  }
};

/* global createElementID, filtersFactory, SVGTintFilter, SVGFillFilter, SVGStrokeEffect, SVGTritoneFilter,
SVGProLevelsFilter, SVGDropShadowEffect, SVGMatte3Effect, SVGGaussianBlurEffect, locationHref */

function SVGEffects(elem) {
  var i;
  var len = elem.data.ef ? elem.data.ef.length : 0;
  var filId = createElementID();
  var fil = filtersFactory.createFilter(filId, true);
  var count = 0;
  this.filters = [];
  var filterManager;
  for (i = 0; i < len; i += 1) {
    filterManager = null;
    if (elem.data.ef[i].ty === 20) {
      count += 1;
      filterManager = new SVGTintFilter(fil, elem.effectsManager.effectElements[i]);
    } else if (elem.data.ef[i].ty === 21) {
      count += 1;
      filterManager = new SVGFillFilter(fil, elem.effectsManager.effectElements[i]);
    } else if (elem.data.ef[i].ty === 22) {
      filterManager = new SVGStrokeEffect(elem, elem.effectsManager.effectElements[i]);
    } else if (elem.data.ef[i].ty === 23) {
      count += 1;
      filterManager = new SVGTritoneFilter(fil, elem.effectsManager.effectElements[i]);
    } else if (elem.data.ef[i].ty === 24) {
      count += 1;
      filterManager = new SVGProLevelsFilter(fil, elem.effectsManager.effectElements[i]);
    } else if (elem.data.ef[i].ty === 25) {
      count += 1;
      filterManager = new SVGDropShadowEffect(fil, elem.effectsManager.effectElements[i]);
    } else if (elem.data.ef[i].ty === 28) {
      // count += 1;
      filterManager = new SVGMatte3Effect(fil, elem.effectsManager.effectElements[i], elem);
    } else if (elem.data.ef[i].ty === 29) {
      count += 1;
      filterManager = new SVGGaussianBlurEffect(fil, elem.effectsManager.effectElements[i]);
    }
    if (filterManager) {
      this.filters.push(filterManager);
    }
  }
  if (count) {
    elem.globalData.defs.appendChild(fil);
    elem.layerElement.setAttribute('filter', 'url(' + locationHref + '#' + filId + ')');
  }
  if (this.filters.length) {
    elem.addRenderableComponent(this);
  }
}

SVGEffects.prototype.renderFrame = function (_isFirstFrame) {
  var i;
  var len = this.filters.length;
  for (i = 0; i < len; i += 1) {
    this.filters[i].renderFrame(_isFirstFrame);
  }
};

/* global Matrix, createTypedArray */

function CVContextData() {
  this.saved = [];
  this.cArrPos = 0;
  this.cTr = new Matrix();
  this.cO = 1;
  var i;
  var len = 15;
  this.savedOp = createTypedArray('float32', len);
  for (i = 0; i < len; i += 1) {
    this.saved[i] = createTypedArray('float32', 16);
  }
  this._length = len;
}

CVContextData.prototype.duplicate = function () {
  var newLength = this._length * 2;
  var currentSavedOp = this.savedOp;
  this.savedOp = createTypedArray('float32', newLength);
  this.savedOp.set(currentSavedOp);
  var i = 0;
  for (i = this._length; i < newLength; i += 1) {
    this.saved[i] = createTypedArray('float32', 16);
  }
  this._length = newLength;
};

CVContextData.prototype.reset = function () {
  this.cArrPos = 0;
  this.cTr.reset();
  this.cO = 1;
};

/* global CVEffects, getBlendMode, CVMaskElement, Matrix */

function CVBaseElement() {
}

CVBaseElement.prototype = {
  createElements: function () {},
  initRendererElement: function () {},
  createContainerElements: function () {
    this.canvasContext = this.globalData.canvasContext;
    this.renderableEffectsManager = new CVEffects(this);
  },
  createContent: function () {},
  setBlendMode: function () {
    var globalData = this.globalData;
    if (globalData.blendMode !== this.data.bm) {
      globalData.blendMode = this.data.bm;
      var blendModeValue = getBlendMode(this.data.bm);
      globalData.canvasContext.globalCompositeOperation = blendModeValue;
    }
  },
  createRenderableComponents: function () {
    this.maskManager = new CVMaskElement(this.data, this);
  },
  hideElement: function () {
    if (!this.hidden && (!this.isInRange || this.isTransparent)) {
      this.hidden = true;
    }
  },
  showElement: function () {
    if (this.isInRange && !this.isTransparent) {
      this.hidden = false;
      this._isFirstFrame = true;
      this.maskManager._isFirstFrame = true;
    }
  },
  renderFrame: function () {
    if (this.hidden || this.data.hd) {
      return;
    }
    this.renderTransform();
    this.renderRenderable();
    this.setBlendMode();
    var forceRealStack = this.data.ty === 0;
    this.globalData.renderer.save(forceRealStack);
    this.globalData.renderer.ctxTransform(this.finalTransform.mat.props);
    this.globalData.renderer.ctxOpacity(this.finalTransform.mProp.o.v);
    this.renderInnerContent();
    this.globalData.renderer.restore(forceRealStack);
    if (this.maskManager.hasMasks) {
      this.globalData.renderer.restore(true);
    }
    if (this._isFirstFrame) {
      this._isFirstFrame = false;
    }
  },
  destroy: function () {
    this.canvasContext = null;
    this.data = null;
    this.globalData = null;
    this.maskManager.destroy();
  },
  mHelper: new Matrix(),
};
CVBaseElement.prototype.hide = CVBaseElement.prototype.hideElement;
CVBaseElement.prototype.show = CVBaseElement.prototype.showElement;

/* global extendPrototype, BaseElement, TransformElement, CVBaseElement,HierarchyElement, FrameElement,
RenderableElement, SVGShapeElement, IImageElement, createTag */

function CVImageElement(data, globalData, comp) {
  this.assetData = globalData.getAssetData(data.refId);
  this.img = globalData.imageLoader.getAsset(this.assetData);
  this.initElement(data, globalData, comp);
}
extendPrototype([BaseElement, TransformElement, CVBaseElement, HierarchyElement, FrameElement, RenderableElement], CVImageElement);

CVImageElement.prototype.initElement = SVGShapeElement.prototype.initElement;
CVImageElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame;

CVImageElement.prototype.createContent = function () {
  if (this.img.width && (this.assetData.w !== this.img.width || this.assetData.h !== this.img.height)) {
    var canvas = createTag('canvas');
    canvas.width = this.assetData.w;
    canvas.height = this.assetData.h;
    var ctx = canvas.getContext('2d');

    var imgW = this.img.width;
    var imgH = this.img.height;
    var imgRel = imgW / imgH;
    var canvasRel = this.assetData.w / this.assetData.h;
    var widthCrop;
    var heightCrop;
    var par = this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio;
    if ((imgRel > canvasRel && par === 'xMidYMid slice') || (imgRel < canvasRel && par !== 'xMidYMid slice')) {
      heightCrop = imgH;
      widthCrop = heightCrop * canvasRel;
    } else {
      widthCrop = imgW;
      heightCrop = widthCrop / canvasRel;
    }
    ctx.drawImage(this.img, (imgW - widthCrop) / 2, (imgH - heightCrop) / 2, widthCrop, heightCrop, 0, 0, this.assetData.w, this.assetData.h);
    this.img = canvas;
  }
};

CVImageElement.prototype.renderInnerContent = function () {
  this.canvasContext.drawImage(this.img, 0, 0);
};

CVImageElement.prototype.destroy = function () {
  this.img = null;
};

/* global createSizedArray, PropertyFactory, extendPrototype, CanvasRenderer, ICompElement, CVBaseElement */

function CVCompElement(data, globalData, comp) {
  this.completeLayers = false;
  this.layers = data.layers;
  this.pendingElements = [];
  this.elements = createSizedArray(this.layers.length);
  this.initElement(data, globalData, comp);
  this.tm = data.tm ? PropertyFactory.getProp(this, data.tm, 0, globalData.frameRate, this) : { _placeholder: true };
}

extendPrototype([CanvasRenderer, ICompElement, CVBaseElement], CVCompElement);

CVCompElement.prototype.renderInnerContent = function () {
  var ctx = this.canvasContext;
  ctx.beginPath();
  ctx.moveTo(0, 0);
  ctx.lineTo(this.data.w, 0);
  ctx.lineTo(this.data.w, this.data.h);
  ctx.lineTo(0, this.data.h);
  ctx.lineTo(0, 0);
  ctx.clip();
  var i;
  var len = this.layers.length;
  for (i = len - 1; i >= 0; i -= 1) {
    if (this.completeLayers || this.elements[i]) {
      this.elements[i].renderFrame();
    }
  }
};

CVCompElement.prototype.destroy = function () {
  var i;
  var len = this.layers.length;
  for (i = len - 1; i >= 0; i -= 1) {
    if (this.elements[i]) {
      this.elements[i].destroy();
    }
  }
  this.layers = null;
  this.elements = null;
};

/* global createSizedArray, ShapePropertyFactory, MaskElement */

function CVMaskElement(data, element) {
  this.data = data;
  this.element = element;
  this.masksProperties = this.data.masksProperties || [];
  this.viewData = createSizedArray(this.masksProperties.length);
  var i;
  var len = this.masksProperties.length;
  var hasMasks = false;
  for (i = 0; i < len; i += 1) {
    if (this.masksProperties[i].mode !== 'n') {
      hasMasks = true;
    }
    this.viewData[i] = ShapePropertyFactory.getShapeProp(this.element, this.masksProperties[i], 3);
  }
  this.hasMasks = hasMasks;
  if (hasMasks) {
    this.element.addRenderableComponent(this);
  }
}

CVMaskElement.prototype.renderFrame = function () {
  if (!this.hasMasks) {
    return;
  }
  var transform = this.element.finalTransform.mat;
  var ctx = this.element.canvasContext;
  var i;
  var len = this.masksProperties.length;
  var pt;
  var pts;
  var data;
  ctx.beginPath();
  for (i = 0; i < len; i += 1) {
    if (this.masksProperties[i].mode !== 'n') {
      if (this.masksProperties[i].inv) {
        ctx.moveTo(0, 0);
        ctx.lineTo(this.element.globalData.compSize.w, 0);
        ctx.lineTo(this.element.globalData.compSize.w, this.element.globalData.compSize.h);
        ctx.lineTo(0, this.element.globalData.compSize.h);
        ctx.lineTo(0, 0);
      }
      data = this.viewData[i].v;
      pt = transform.applyToPointArray(data.v[0][0], data.v[0][1], 0);
      ctx.moveTo(pt[0], pt[1]);
      var j;
      var jLen = data._length;
      for (j = 1; j < jLen; j += 1) {
        pts = transform.applyToTriplePoints(data.o[j - 1], data.i[j], data.v[j]);
        ctx.bezierCurveTo(pts[0], pts[1], pts[2], pts[3], pts[4], pts[5]);
      }
      pts = transform.applyToTriplePoints(data.o[j - 1], data.i[0], data.v[0]);
      ctx.bezierCurveTo(pts[0], pts[1], pts[2], pts[3], pts[4], pts[5]);
    }
  }
  this.element.globalData.renderer.save(true);
  ctx.clip();
};

CVMaskElement.prototype.getMaskProperty = MaskElement.prototype.getMaskProperty;

CVMaskElement.prototype.destroy = function () {
  this.element = null;
};

/* global ShapeTransformManager, extendPrototype, BaseElement, TransformElement, CVBaseElement, IShapeElement,
HierarchyElement, FrameElement, RenderableElement, RenderableDOMElement, PropertyFactory, degToRads, GradientProperty,
DashProperty, TransformPropertyFactory, CVShapeData, ShapeModifiers, bmFloor */

function CVShapeElement(data, globalData, comp) {
  this.shapes = [];
  this.shapesData = data.shapes;
  this.stylesList = [];
  this.itemsData = [];
  this.prevViewData = [];
  this.shapeModifiers = [];
  this.processedElements = [];
  this.transformsManager = new ShapeTransformManager();
  this.initElement(data, globalData, comp);
}

extendPrototype([BaseElement, TransformElement, CVBaseElement, IShapeElement, HierarchyElement, FrameElement, RenderableElement], CVShapeElement);

CVShapeElement.prototype.initElement = RenderableDOMElement.prototype.initElement;

CVShapeElement.prototype.transformHelper = { opacity: 1, _opMdf: false };

CVShapeElement.prototype.dashResetter = [];

CVShapeElement.prototype.createContent = function () {
  this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, true, []);
};

CVShapeElement.prototype.createStyleElement = function (data, transforms) {
  var styleElem = {
    data: data,
    type: data.ty,
    preTransforms: this.transformsManager.addTransformSequence(transforms),
    transforms: [],
    elements: [],
    closed: data.hd === true,
  };
  var elementData = {};
  if (data.ty === 'fl' || data.ty === 'st') {
    elementData.c = PropertyFactory.getProp(this, data.c, 1, 255, this);
    if (!elementData.c.k) {
      styleElem.co = 'rgb(' + bmFloor(elementData.c.v[0]) + ',' + bmFloor(elementData.c.v[1]) + ',' + bmFloor(elementData.c.v[2]) + ')';
    }
  } else if (data.ty === 'gf' || data.ty === 'gs') {
    elementData.s = PropertyFactory.getProp(this, data.s, 1, null, this);
    elementData.e = PropertyFactory.getProp(this, data.e, 1, null, this);
    elementData.h = PropertyFactory.getProp(this, data.h || { k: 0 }, 0, 0.01, this);
    elementData.a = PropertyFactory.getProp(this, data.a || { k: 0 }, 0, degToRads, this);
    elementData.g = new GradientProperty(this, data.g, this);
  }
  elementData.o = PropertyFactory.getProp(this, data.o, 0, 0.01, this);
  if (data.ty === 'st' || data.ty === 'gs') {
    styleElem.lc = this.lcEnum[data.lc] || 'round';
    styleElem.lj = this.ljEnum[data.lj] || 'round';
    if (data.lj == 1) { // eslint-disable-line eqeqeq
      styleElem.ml = data.ml;
    }
    elementData.w = PropertyFactory.getProp(this, data.w, 0, null, this);
    if (!elementData.w.k) {
      styleElem.wi = elementData.w.v;
    }
    if (data.d) {
      var d = new DashProperty(this, data.d, 'canvas', this);
      elementData.d = d;
      if (!elementData.d.k) {
        styleElem.da = elementData.d.dashArray;
        styleElem.do = elementData.d.dashoffset[0];
      }
    }
  } else {
    styleElem.r = data.r === 2 ? 'evenodd' : 'nonzero';
  }
  this.stylesList.push(styleElem);
  elementData.style = styleElem;
  return elementData;
};

CVShapeElement.prototype.createGroupElement = function () {
  var elementData = {
    it: [],
    prevViewData: [],
  };
  return elementData;
};

CVShapeElement.prototype.createTransformElement = function (data) {
  var elementData = {
    transform: {
      opacity: 1,
      _opMdf: false,
      key: this.transformsManager.getNewKey(),
      op: PropertyFactory.getProp(this, data.o, 0, 0.01, this),
      mProps: TransformPropertyFactory.getTransformProperty(this, data, this),
    },
  };
  return elementData;
};

CVShapeElement.prototype.createShapeElement = function (data) {
  var elementData = new CVShapeData(this, data, this.stylesList, this.transformsManager);

  this.shapes.push(elementData);
  this.addShapeToModifiers(elementData);
  return elementData;
};

CVShapeElement.prototype.reloadShapes = function () {
  this._isFirstFrame = true;
  var i;
  var len = this.itemsData.length;
  for (i = 0; i < len; i += 1) {
    this.prevViewData[i] = this.itemsData[i];
  }
  this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, true, []);
  len = this.dynamicProperties.length;
  for (i = 0; i < len; i += 1) {
    this.dynamicProperties[i].getValue();
  }
  this.renderModifiers();
  this.transformsManager.processSequences(this._isFirstFrame);
};

CVShapeElement.prototype.addTransformToStyleList = function (transform) {
  var i;
  var len = this.stylesList.length;
  for (i = 0; i < len; i += 1) {
    if (!this.stylesList[i].closed) {
      this.stylesList[i].transforms.push(transform);
    }
  }
};

CVShapeElement.prototype.removeTransformFromStyleList = function () {
  var i;
  var len = this.stylesList.length;
  for (i = 0; i < len; i += 1) {
    if (!this.stylesList[i].closed) {
      this.stylesList[i].transforms.pop();
    }
  }
};

CVShapeElement.prototype.closeStyles = function (styles) {
  var i;
  var len = styles.length;
  for (i = 0; i < len; i += 1) {
    styles[i].closed = true;
  }
};

CVShapeElement.prototype.searchShapes = function (arr, itemsData, prevViewData, shouldRender, transforms) {
  var i;
  var len = arr.length - 1;
  var j;
  var jLen;
  var ownStyles = [];
  var ownModifiers = [];
  var processedPos;
  var modifier;
  var currentTransform;
  var ownTransforms = [].concat(transforms);
  for (i = len; i >= 0; i -= 1) {
    processedPos = this.searchProcessedElement(arr[i]);
    if (!processedPos) {
      arr[i]._shouldRender = shouldRender;
    } else {
      itemsData[i] = prevViewData[processedPos - 1];
    }
    if (arr[i].ty === 'fl' || arr[i].ty === 'st' || arr[i].ty === 'gf' || arr[i].ty === 'gs') {
      if (!processedPos) {
        itemsData[i] = this.createStyleElement(arr[i], ownTransforms);
      } else {
        itemsData[i].style.closed = false;
      }

      ownStyles.push(itemsData[i].style);
    } else if (arr[i].ty === 'gr') {
      if (!processedPos) {
        itemsData[i] = this.createGroupElement(arr[i]);
      } else {
        jLen = itemsData[i].it.length;
        for (j = 0; j < jLen; j += 1) {
          itemsData[i].prevViewData[j] = itemsData[i].it[j];
        }
      }
      this.searchShapes(arr[i].it, itemsData[i].it, itemsData[i].prevViewData, shouldRender, ownTransforms);
    } else if (arr[i].ty === 'tr') {
      if (!processedPos) {
        currentTransform = this.createTransformElement(arr[i]);
        itemsData[i] = currentTransform;
      }
      ownTransforms.push(itemsData[i]);
      this.addTransformToStyleList(itemsData[i]);
    } else if (arr[i].ty === 'sh' || arr[i].ty === 'rc' || arr[i].ty === 'el' || arr[i].ty === 'sr') {
      if (!processedPos) {
        itemsData[i] = this.createShapeElement(arr[i]);
      }
    } else if (arr[i].ty === 'tm' || arr[i].ty === 'rd' || arr[i].ty === 'pb') {
      if (!processedPos) {
        modifier = ShapeModifiers.getModifier(arr[i].ty);
        modifier.init(this, arr[i]);
        itemsData[i] = modifier;
        this.shapeModifiers.push(modifier);
      } else {
        modifier = itemsData[i];
        modifier.closed = false;
      }
      ownModifiers.push(modifier);
    } else if (arr[i].ty === 'rp') {
      if (!processedPos) {
        modifier = ShapeModifiers.getModifier(arr[i].ty);
        itemsData[i] = modifier;
        modifier.init(this, arr, i, itemsData);
        this.shapeModifiers.push(modifier);
        shouldRender = false;
      } else {
        modifier = itemsData[i];
        modifier.closed = true;
      }
      ownModifiers.push(modifier);
    }
    this.addProcessedElement(arr[i], i + 1);
  }
  this.removeTransformFromStyleList();
  this.closeStyles(ownStyles);
  len = ownModifiers.length;
  for (i = 0; i < len; i += 1) {
    ownModifiers[i].closed = true;
  }
};

CVShapeElement.prototype.renderInnerContent = function () {
  this.transformHelper.opacity = 1;
  this.transformHelper._opMdf = false;
  this.renderModifiers();
  this.transformsManager.processSequences(this._isFirstFrame);
  this.renderShape(this.transformHelper, this.shapesData, this.itemsData, true);
};

CVShapeElement.prototype.renderShapeTransform = function (parentTransform, groupTransform) {
  if (parentTransform._opMdf || groupTransform.op._mdf || this._isFirstFrame) {
    groupTransform.opacity = parentTransform.opacity;
    groupTransform.opacity *= groupTransform.op.v;
    groupTransform._opMdf = true;
  }
};

CVShapeElement.prototype.drawLayer = function () {
  var i;
  var len = this.stylesList.length;
  var j;
  var jLen;
  var k;
  var kLen;
  var elems;
  var nodes;
  var renderer = this.globalData.renderer;
  var ctx = this.globalData.canvasContext;
  var type;
  var currentStyle;
  for (i = 0; i < len; i += 1) {
    currentStyle = this.stylesList[i];
    type = currentStyle.type;

    // Skipping style when
    // Stroke width equals 0
    // style should not be rendered (extra unused repeaters)
    // current opacity equals 0
    // global opacity equals 0
    if (!(((type === 'st' || type === 'gs') && currentStyle.wi === 0) || !currentStyle.data._shouldRender || currentStyle.coOp === 0 || this.globalData.currentGlobalAlpha === 0)) {
      renderer.save();
      elems = currentStyle.elements;
      if (type === 'st' || type === 'gs') {
        ctx.strokeStyle = type === 'st' ? currentStyle.co : currentStyle.grd;
        ctx.lineWidth = currentStyle.wi;
        ctx.lineCap = currentStyle.lc;
        ctx.lineJoin = currentStyle.lj;
        ctx.miterLimit = currentStyle.ml || 0;
      } else {
        ctx.fillStyle = type === 'fl' ? currentStyle.co : currentStyle.grd;
      }
      renderer.ctxOpacity(currentStyle.coOp);
      if (type !== 'st' && type !== 'gs') {
        ctx.beginPath();
      }
      renderer.ctxTransform(currentStyle.preTransforms.finalTransform.props);
      jLen = elems.length;
      for (j = 0; j < jLen; j += 1) {
        if (type === 'st' || type === 'gs') {
          ctx.beginPath();
          if (currentStyle.da) {
            ctx.setLineDash(currentStyle.da);
            ctx.lineDashOffset = currentStyle.do;
          }
        }
        nodes = elems[j].trNodes;
        kLen = nodes.length;

        for (k = 0; k < kLen; k += 1) {
          if (nodes[k].t === 'm') {
            ctx.moveTo(nodes[k].p[0], nodes[k].p[1]);
          } else if (nodes[k].t === 'c') {
            ctx.bezierCurveTo(nodes[k].pts[0], nodes[k].pts[1], nodes[k].pts[2], nodes[k].pts[3], nodes[k].pts[4], nodes[k].pts[5]);
          } else {
            ctx.closePath();
          }
        }
        if (type === 'st' || type === 'gs') {
          ctx.stroke();
          if (currentStyle.da) {
            ctx.setLineDash(this.dashResetter);
          }
        }
      }
      if (type !== 'st' && type !== 'gs') {
        ctx.fill(currentStyle.r);
      }
      renderer.restore();
    }
  }
};

CVShapeElement.prototype.renderShape = function (parentTransform, items, data, isMain) {
  var i;
  var len = items.length - 1;
  var groupTransform;
  groupTransform = parentTransform;
  for (i = len; i >= 0; i -= 1) {
    if (items[i].ty === 'tr') {
      groupTransform = data[i].transform;
      this.renderShapeTransform(parentTransform, groupTransform);
    } else if (items[i].ty === 'sh' || items[i].ty === 'el' || items[i].ty === 'rc' || items[i].ty === 'sr') {
      this.renderPath(items[i], data[i]);
    } else if (items[i].ty === 'fl') {
      this.renderFill(items[i], data[i], groupTransform);
    } else if (items[i].ty === 'st') {
      this.renderStroke(items[i], data[i], groupTransform);
    } else if (items[i].ty === 'gf' || items[i].ty === 'gs') {
      this.renderGradientFill(items[i], data[i], groupTransform);
    } else if (items[i].ty === 'gr') {
      this.renderShape(groupTransform, items[i].it, data[i].it);
    } else if (items[i].ty === 'tm') ;
  }
  if (isMain) {
    this.drawLayer();
  }
};

CVShapeElement.prototype.renderStyledShape = function (styledShape, shape) {
  if (this._isFirstFrame || shape._mdf || styledShape.transforms._mdf) {
    var shapeNodes = styledShape.trNodes;
    var paths = shape.paths;
    var i;
    var len;
    var j;
    var jLen = paths._length;
    shapeNodes.length = 0;
    var groupTransformMat = styledShape.transforms.finalTransform;
    for (j = 0; j < jLen; j += 1) {
      var pathNodes = paths.shapes[j];
      if (pathNodes && pathNodes.v) {
        len = pathNodes._length;
        for (i = 1; i < len; i += 1) {
          if (i === 1) {
            shapeNodes.push({
              t: 'm',
              p: groupTransformMat.applyToPointArray(pathNodes.v[0][0], pathNodes.v[0][1], 0),
            });
          }
          shapeNodes.push({
            t: 'c',
            pts: groupTransformMat.applyToTriplePoints(pathNodes.o[i - 1], pathNodes.i[i], pathNodes.v[i]),
          });
        }
        if (len === 1) {
          shapeNodes.push({
            t: 'm',
            p: groupTransformMat.applyToPointArray(pathNodes.v[0][0], pathNodes.v[0][1], 0),
          });
        }
        if (pathNodes.c && len) {
          shapeNodes.push({
            t: 'c',
            pts: groupTransformMat.applyToTriplePoints(pathNodes.o[i - 1], pathNodes.i[0], pathNodes.v[0]),
          });
          shapeNodes.push({
            t: 'z',
          });
        }
      }
    }
    styledShape.trNodes = shapeNodes;
  }
};

CVShapeElement.prototype.renderPath = function (pathData, itemData) {
  if (pathData.hd !== true && pathData._shouldRender) {
    var i;
    var len = itemData.styledShapes.length;
    for (i = 0; i < len; i += 1) {
      this.renderStyledShape(itemData.styledShapes[i], itemData.sh);
    }
  }
};

CVShapeElement.prototype.renderFill = function (styleData, itemData, groupTransform) {
  var styleElem = itemData.style;

  if (itemData.c._mdf || this._isFirstFrame) {
    styleElem.co = 'rgb('
        + bmFloor(itemData.c.v[0]) + ','
        + bmFloor(itemData.c.v[1]) + ','
        + bmFloor(itemData.c.v[2]) + ')';
  }
  if (itemData.o._mdf || groupTransform._opMdf || this._isFirstFrame) {
    styleElem.coOp = itemData.o.v * groupTransform.opacity;
  }
};

CVShapeElement.prototype.renderGradientFill = function (styleData, itemData, groupTransform) {
  var styleElem = itemData.style;
  var grd;
  if (!styleElem.grd || itemData.g._mdf || itemData.s._mdf || itemData.e._mdf || (styleData.t !== 1 && (itemData.h._mdf || itemData.a._mdf))) {
    var ctx = this.globalData.canvasContext;
    var pt1 = itemData.s.v;
    var pt2 = itemData.e.v;
    if (styleData.t === 1) {
      grd = ctx.createLinearGradient(pt1[0], pt1[1], pt2[0], pt2[1]);
    } else {
      var rad = Math.sqrt(Math.pow(pt1[0] - pt2[0], 2) + Math.pow(pt1[1] - pt2[1], 2));
      var ang = Math.atan2(pt2[1] - pt1[1], pt2[0] - pt1[0]);

      var percent = itemData.h.v;
      if (percent >= 1) {
        percent = 0.99;
      } else if (percent <= -1) {
        percent = -0.99;
      }
      var dist = rad * percent;
      var x = Math.cos(ang + itemData.a.v) * dist + pt1[0];
      var y = Math.sin(ang + itemData.a.v) * dist + pt1[1];
      grd = ctx.createRadialGradient(x, y, 0, pt1[0], pt1[1], rad);
    }

    var i;
    var len = styleData.g.p;
    var cValues = itemData.g.c;
    var opacity = 1;

    for (i = 0; i < len; i += 1) {
      if (itemData.g._hasOpacity && itemData.g._collapsable) {
        opacity = itemData.g.o[i * 2 + 1];
      }
      grd.addColorStop(cValues[i * 4] / 100, 'rgba(' + cValues[i * 4 + 1] + ',' + cValues[i * 4 + 2] + ',' + cValues[i * 4 + 3] + ',' + opacity + ')');
    }
    styleElem.grd = grd;
  }
  styleElem.coOp = itemData.o.v * groupTransform.opacity;
};

CVShapeElement.prototype.renderStroke = function (styleData, itemData, groupTransform) {
  var styleElem = itemData.style;
  var d = itemData.d;
  if (d && (d._mdf || this._isFirstFrame)) {
    styleElem.da = d.dashArray;
    styleElem.do = d.dashoffset[0];
  }
  if (itemData.c._mdf || this._isFirstFrame) {
    styleElem.co = 'rgb(' + bmFloor(itemData.c.v[0]) + ',' + bmFloor(itemData.c.v[1]) + ',' + bmFloor(itemData.c.v[2]) + ')';
  }
  if (itemData.o._mdf || groupTransform._opMdf || this._isFirstFrame) {
    styleElem.coOp = itemData.o.v * groupTransform.opacity;
  }
  if (itemData.w._mdf || this._isFirstFrame) {
    styleElem.wi = itemData.w.v;
  }
};

CVShapeElement.prototype.destroy = function () {
  this.shapesData = null;
  this.globalData = null;
  this.canvasContext = null;
  this.stylesList.length = 0;
  this.itemsData.length = 0;
};

/* global extendPrototype, BaseElement, TransformElement, CVBaseElement, HierarchyElement, FrameElement, RenderableElement,
SVGShapeElement, IImageElement */

function CVSolidElement(data, globalData, comp) {
  this.initElement(data, globalData, comp);
}
extendPrototype([BaseElement, TransformElement, CVBaseElement, HierarchyElement, FrameElement, RenderableElement], CVSolidElement);

CVSolidElement.prototype.initElement = SVGShapeElement.prototype.initElement;
CVSolidElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame;

CVSolidElement.prototype.renderInnerContent = function () {
  var ctx = this.canvasContext;
  ctx.fillStyle = this.data.sc;
  ctx.fillRect(0, 0, this.data.sw, this.data.sh);
  //
};

/* global extendPrototype, BaseElement, TransformElement, CVBaseElement, HierarchyElement, FrameElement,
RenderableElement, ITextElement, createTag, createSizedArray */

function CVTextElement(data, globalData, comp) {
  this.textSpans = [];
  this.yOffset = 0;
  this.fillColorAnim = false;
  this.strokeColorAnim = false;
  this.strokeWidthAnim = false;
  this.stroke = false;
  this.fill = false;
  this.justifyOffset = 0;
  this.currentRender = null;
  this.renderType = 'canvas';
  this.values = {
    fill: 'rgba(0,0,0,0)',
    stroke: 'rgba(0,0,0,0)',
    sWidth: 0,
    fValue: '',
  };
  this.initElement(data, globalData, comp);
}
extendPrototype([BaseElement, TransformElement, CVBaseElement, HierarchyElement, FrameElement, RenderableElement, ITextElement], CVTextElement);

CVTextElement.prototype.tHelper = createTag('canvas').getContext('2d');

CVTextElement.prototype.buildNewText = function () {
  var documentData = this.textProperty.currentData;
  this.renderedLetters = createSizedArray(documentData.l ? documentData.l.length : 0);

  var hasFill = false;
  if (documentData.fc) {
    hasFill = true;
    this.values.fill = this.buildColor(documentData.fc);
  } else {
    this.values.fill = 'rgba(0,0,0,0)';
  }
  this.fill = hasFill;
  var hasStroke = false;
  if (documentData.sc) {
    hasStroke = true;
    this.values.stroke = this.buildColor(documentData.sc);
    this.values.sWidth = documentData.sw;
  }
  var fontData = this.globalData.fontManager.getFontByName(documentData.f);
  var i;
  var len;
  var letters = documentData.l;
  var matrixHelper = this.mHelper;
  this.stroke = hasStroke;
  this.values.fValue = documentData.finalSize + 'px ' + this.globalData.fontManager.getFontByName(documentData.f).fFamily;
  len = documentData.finalText.length;
  // this.tHelper.font = this.values.fValue;
  var charData;
  var shapeData;
  var k;
  var kLen;
  var shapes;
  var j;
  var jLen;
  var pathNodes;
  var commands;
  var pathArr;
  var singleShape = this.data.singleShape;
  var trackingOffset = documentData.tr * 0.001 * documentData.finalSize;
  var xPos = 0;
  var yPos = 0;
  var firstLine = true;
  var cnt = 0;
  for (i = 0; i < len; i += 1) {
    charData = this.globalData.fontManager.getCharData(documentData.finalText[i], fontData.fStyle, this.globalData.fontManager.getFontByName(documentData.f).fFamily);
    shapeData = (charData && charData.data) || {};
    matrixHelper.reset();
    if (singleShape && letters[i].n) {
      xPos = -trackingOffset;
      yPos += documentData.yOffset;
      yPos += firstLine ? 1 : 0;
      firstLine = false;
    }

    shapes = shapeData.shapes ? shapeData.shapes[0].it : [];
    jLen = shapes.length;
    matrixHelper.scale(documentData.finalSize / 100, documentData.finalSize / 100);
    if (singleShape) {
      this.applyTextPropertiesToMatrix(documentData, matrixHelper, letters[i].line, xPos, yPos);
    }
    commands = createSizedArray(jLen);
    for (j = 0; j < jLen; j += 1) {
      kLen = shapes[j].ks.k.i.length;
      pathNodes = shapes[j].ks.k;
      pathArr = [];
      for (k = 1; k < kLen; k += 1) {
        if (k === 1) {
          pathArr.push(matrixHelper.applyToX(pathNodes.v[0][0], pathNodes.v[0][1], 0), matrixHelper.applyToY(pathNodes.v[0][0], pathNodes.v[0][1], 0));
        }
        pathArr.push(matrixHelper.applyToX(pathNodes.o[k - 1][0], pathNodes.o[k - 1][1], 0), matrixHelper.applyToY(pathNodes.o[k - 1][0], pathNodes.o[k - 1][1], 0), matrixHelper.applyToX(pathNodes.i[k][0], pathNodes.i[k][1], 0), matrixHelper.applyToY(pathNodes.i[k][0], pathNodes.i[k][1], 0), matrixHelper.applyToX(pathNodes.v[k][0], pathNodes.v[k][1], 0), matrixHelper.applyToY(pathNodes.v[k][0], pathNodes.v[k][1], 0));
      }
      pathArr.push(matrixHelper.applyToX(pathNodes.o[k - 1][0], pathNodes.o[k - 1][1], 0), matrixHelper.applyToY(pathNodes.o[k - 1][0], pathNodes.o[k - 1][1], 0), matrixHelper.applyToX(pathNodes.i[0][0], pathNodes.i[0][1], 0), matrixHelper.applyToY(pathNodes.i[0][0], pathNodes.i[0][1], 0), matrixHelper.applyToX(pathNodes.v[0][0], pathNodes.v[0][1], 0), matrixHelper.applyToY(pathNodes.v[0][0], pathNodes.v[0][1], 0));
      commands[j] = pathArr;
    }
    if (singleShape) {
      xPos += letters[i].l;
      xPos += trackingOffset;
    }
    if (this.textSpans[cnt]) {
      this.textSpans[cnt].elem = commands;
    } else {
      this.textSpans[cnt] = { elem: commands };
    }
    cnt += 1;
  }
};

CVTextElement.prototype.renderInnerContent = function () {
  var ctx = this.canvasContext;
  ctx.font = this.values.fValue;
  ctx.lineCap = 'butt';
  ctx.lineJoin = 'miter';
  ctx.miterLimit = 4;

  if (!this.data.singleShape) {
    this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
  }

  var i;
  var len;
  var j;
  var jLen;
  var k;
  var kLen;
  var renderedLetters = this.textAnimator.renderedLetters;

  var letters = this.textProperty.currentData.l;

  len = letters.length;
  var renderedLetter;
  var lastFill = null;
  var lastStroke = null;
  var lastStrokeW = null;
  var commands;
  var pathArr;
  for (i = 0; i < len; i += 1) {
    if (!letters[i].n) {
      renderedLetter = renderedLetters[i];
      if (renderedLetter) {
        this.globalData.renderer.save();
        this.globalData.renderer.ctxTransform(renderedLetter.p);
        this.globalData.renderer.ctxOpacity(renderedLetter.o);
      }
      if (this.fill) {
        if (renderedLetter && renderedLetter.fc) {
          if (lastFill !== renderedLetter.fc) {
            lastFill = renderedLetter.fc;
            ctx.fillStyle = renderedLetter.fc;
          }
        } else if (lastFill !== this.values.fill) {
          lastFill = this.values.fill;
          ctx.fillStyle = this.values.fill;
        }
        commands = this.textSpans[i].elem;
        jLen = commands.length;
        this.globalData.canvasContext.beginPath();
        for (j = 0; j < jLen; j += 1) {
          pathArr = commands[j];
          kLen = pathArr.length;
          this.globalData.canvasContext.moveTo(pathArr[0], pathArr[1]);
          for (k = 2; k < kLen; k += 6) {
            this.globalData.canvasContext.bezierCurveTo(pathArr[k], pathArr[k + 1], pathArr[k + 2], pathArr[k + 3], pathArr[k + 4], pathArr[k + 5]);
          }
        }
        this.globalData.canvasContext.closePath();
        this.globalData.canvasContext.fill();
        /// ctx.fillText(this.textSpans[i].val,0,0);
      }
      if (this.stroke) {
        if (renderedLetter && renderedLetter.sw) {
          if (lastStrokeW !== renderedLetter.sw) {
            lastStrokeW = renderedLetter.sw;
            ctx.lineWidth = renderedLetter.sw;
          }
        } else if (lastStrokeW !== this.values.sWidth) {
          lastStrokeW = this.values.sWidth;
          ctx.lineWidth = this.values.sWidth;
        }
        if (renderedLetter && renderedLetter.sc) {
          if (lastStroke !== renderedLetter.sc) {
            lastStroke = renderedLetter.sc;
            ctx.strokeStyle = renderedLetter.sc;
          }
        } else if (lastStroke !== this.values.stroke) {
          lastStroke = this.values.stroke;
          ctx.strokeStyle = this.values.stroke;
        }
        commands = this.textSpans[i].elem;
        jLen = commands.length;
        this.globalData.canvasContext.beginPath();
        for (j = 0; j < jLen; j += 1) {
          pathArr = commands[j];
          kLen = pathArr.length;
          this.globalData.canvasContext.moveTo(pathArr[0], pathArr[1]);
          for (k = 2; k < kLen; k += 6) {
            this.globalData.canvasContext.bezierCurveTo(pathArr[k], pathArr[k + 1], pathArr[k + 2], pathArr[k + 3], pathArr[k + 4], pathArr[k + 5]);
          }
        }
        this.globalData.canvasContext.closePath();
        this.globalData.canvasContext.stroke();
        /// ctx.strokeText(letters[i].val,0,0);
      }
      if (renderedLetter) {
        this.globalData.renderer.restore();
      }
    }
  }
};

function CVEffects() {

}
CVEffects.prototype.renderFrame = function () {};

/* global createTag, createNS, styleDiv, CVEffects, MaskElement, SVGBaseElement, HybridRenderer */

function HBaseElement() {}
HBaseElement.prototype = {
  checkBlendMode: function () {},
  initRendererElement: function () {
    this.baseElement = createTag(this.data.tg || 'div');
    if (this.data.hasMask) {
      this.svgElement = createNS('svg');
      this.layerElement = createNS('g');
      this.maskedElement = this.layerElement;
      this.svgElement.appendChild(this.layerElement);
      this.baseElement.appendChild(this.svgElement);
    } else {
      this.layerElement = this.baseElement;
    }
    styleDiv(this.baseElement);
  },
  createContainerElements: function () {
    this.renderableEffectsManager = new CVEffects(this);
    this.transformedElement = this.baseElement;
    this.maskedElement = this.layerElement;
    if (this.data.ln) {
      this.layerElement.setAttribute('id', this.data.ln);
    }
    if (this.data.cl) {
      this.layerElement.setAttribute('class', this.data.cl);
    }
    if (this.data.bm !== 0) {
      this.setBlendMode();
    }
  },
  renderElement: function () {
    var transformedElementStyle = this.transformedElement ? this.transformedElement.style : {};
    if (this.finalTransform._matMdf) {
      var matrixValue = this.finalTransform.mat.toCSS();
      transformedElementStyle.transform = matrixValue;
      transformedElementStyle.webkitTransform = matrixValue;
    }
    if (this.finalTransform._opMdf) {
      transformedElementStyle.opacity = this.finalTransform.mProp.o.v;
    }
  },
  renderFrame: function () {
    // If it is exported as hidden (data.hd === true) no need to render
    // If it is not visible no need to render
    if (this.data.hd || this.hidden) {
      return;
    }
    this.renderTransform();
    this.renderRenderable();
    this.renderElement();
    this.renderInnerContent();
    if (this._isFirstFrame) {
      this._isFirstFrame = false;
    }
  },
  destroy: function () {
    this.layerElement = null;
    this.transformedElement = null;
    if (this.matteElement) {
      this.matteElement = null;
    }
    if (this.maskManager) {
      this.maskManager.destroy();
      this.maskManager = null;
    }
  },
  createRenderableComponents: function () {
    this.maskManager = new MaskElement(this.data, this, this.globalData);
  },
  addEffects: function () {
  },
  setMatte: function () {},
};
HBaseElement.prototype.getBaseElement = SVGBaseElement.prototype.getBaseElement;
HBaseElement.prototype.destroyBaseElement = HBaseElement.prototype.destroy;
HBaseElement.prototype.buildElementParenting = HybridRenderer.prototype.buildElementParenting;

/* global extendPrototype, BaseElement, TransformElement, HBaseElement, HierarchyElement, FrameElement,
RenderableDOMElement, createNS, createTag */

function HSolidElement(data, globalData, comp) {
  this.initElement(data, globalData, comp);
}
extendPrototype([BaseElement, TransformElement, HBaseElement, HierarchyElement, FrameElement, RenderableDOMElement], HSolidElement);

HSolidElement.prototype.createContent = function () {
  var rect;
  if (this.data.hasMask) {
    rect = createNS('rect');
    rect.setAttribute('width', this.data.sw);
    rect.setAttribute('height', this.data.sh);
    rect.setAttribute('fill', this.data.sc);
    this.svgElement.setAttribute('width', this.data.sw);
    this.svgElement.setAttribute('height', this.data.sh);
  } else {
    rect = createTag('div');
    rect.style.width = this.data.sw + 'px';
    rect.style.height = this.data.sh + 'px';
    rect.style.backgroundColor = this.data.sc;
  }
  this.layerElement.appendChild(rect);
};

/* global createSizedArray, PropertyFactory, extendPrototype, HybridRenderer, ICompElement, HBaseElement */

function HCompElement(data, globalData, comp) {
  this.layers = data.layers;
  this.supports3d = !data.hasMask;
  this.completeLayers = false;
  this.pendingElements = [];
  this.elements = this.layers ? createSizedArray(this.layers.length) : [];
  this.initElement(data, globalData, comp);
  this.tm = data.tm ? PropertyFactory.getProp(this, data.tm, 0, globalData.frameRate, this) : { _placeholder: true };
}

extendPrototype([HybridRenderer, ICompElement, HBaseElement], HCompElement);
HCompElement.prototype._createBaseContainerElements = HCompElement.prototype.createContainerElements;

HCompElement.prototype.createContainerElements = function () {
  this._createBaseContainerElements();
  // divElement.style.clip = 'rect(0px, '+this.data.w+'px, '+this.data.h+'px, 0px)';
  if (this.data.hasMask) {
    this.svgElement.setAttribute('width', this.data.w);
    this.svgElement.setAttribute('height', this.data.h);
    this.transformedElement = this.baseElement;
  } else {
    this.transformedElement = this.layerElement;
  }
};

HCompElement.prototype.addTo3dContainer = function (elem, pos) {
  var j = 0;
  var nextElement;
  while (j < pos) {
    if (this.elements[j] && this.elements[j].getBaseElement) {
      nextElement = this.elements[j].getBaseElement();
    }
    j += 1;
  }
  if (nextElement) {
    this.layerElement.insertBefore(elem, nextElement);
  } else {
    this.layerElement.appendChild(elem);
  }
};

/* global createNS, extendPrototype, BaseElement, TransformElement, HSolidElement, SVGShapeElement, HBaseElement,
HierarchyElement, FrameElement, RenderableElement, createNS, bmMin, bmSqrt, bmMin, bmMax, bmPow */

function HShapeElement(data, globalData, comp) {
  // List of drawable elements
  this.shapes = [];
  // Full shape data
  this.shapesData = data.shapes;
  // List of styles that will be applied to shapes
  this.stylesList = [];
  // List of modifiers that will be applied to shapes
  this.shapeModifiers = [];
  // List of items in shape tree
  this.itemsData = [];
  // List of items in previous shape tree
  this.processedElements = [];
  // List of animated components
  this.animatedContents = [];
  this.shapesContainer = createNS('g');
  this.initElement(data, globalData, comp);
  // Moving any property that doesn't get too much access after initialization because of v8 way of handling more than 10 properties.
  // List of elements that have been created
  this.prevViewData = [];
  this.currentBBox = {
    x: 999999,
    y: -999999,
    h: 0,
    w: 0,
  };
}
extendPrototype([BaseElement, TransformElement, HSolidElement, SVGShapeElement, HBaseElement, HierarchyElement, FrameElement, RenderableElement], HShapeElement);
HShapeElement.prototype._renderShapeFrame = HShapeElement.prototype.renderInnerContent;

HShapeElement.prototype.createContent = function () {
  var cont;
  this.baseElement.style.fontSize = 0;
  if (this.data.hasMask) {
    this.layerElement.appendChild(this.shapesContainer);
    cont = this.svgElement;
  } else {
    cont = createNS('svg');
    var size = this.comp.data ? this.comp.data : this.globalData.compSize;
    cont.setAttribute('width', size.w);
    cont.setAttribute('height', size.h);
    cont.appendChild(this.shapesContainer);
    this.layerElement.appendChild(cont);
  }

  this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.shapesContainer, 0, [], true);
  this.filterUniqueShapes();
  this.shapeCont = cont;
};

HShapeElement.prototype.getTransformedPoint = function (transformers, point) {
  var i;
  var len = transformers.length;
  for (i = 0; i < len; i += 1) {
    point = transformers[i].mProps.v.applyToPointArray(point[0], point[1], 0);
  }
  return point;
};

HShapeElement.prototype.calculateShapeBoundingBox = function (item, boundingBox) {
  var shape = item.sh.v;
  var transformers = item.transformers;
  var i;
  var len = shape._length;
  var vPoint;
  var oPoint;
  var nextIPoint;
  var nextVPoint;
  if (len <= 1) {
    return;
  }
  for (i = 0; i < len - 1; i += 1) {
    vPoint = this.getTransformedPoint(transformers, shape.v[i]);
    oPoint = this.getTransformedPoint(transformers, shape.o[i]);
    nextIPoint = this.getTransformedPoint(transformers, shape.i[i + 1]);
    nextVPoint = this.getTransformedPoint(transformers, shape.v[i + 1]);
    this.checkBounds(vPoint, oPoint, nextIPoint, nextVPoint, boundingBox);
  }
  if (shape.c) {
    vPoint = this.getTransformedPoint(transformers, shape.v[i]);
    oPoint = this.getTransformedPoint(transformers, shape.o[i]);
    nextIPoint = this.getTransformedPoint(transformers, shape.i[0]);
    nextVPoint = this.getTransformedPoint(transformers, shape.v[0]);
    this.checkBounds(vPoint, oPoint, nextIPoint, nextVPoint, boundingBox);
  }
};

HShapeElement.prototype.checkBounds = function (vPoint, oPoint, nextIPoint, nextVPoint, boundingBox) {
  this.getBoundsOfCurve(vPoint, oPoint, nextIPoint, nextVPoint);
  var bounds = this.shapeBoundingBox;
  boundingBox.x = bmMin(bounds.left, boundingBox.x);
  boundingBox.xMax = bmMax(bounds.right, boundingBox.xMax);
  boundingBox.y = bmMin(bounds.top, boundingBox.y);
  boundingBox.yMax = bmMax(bounds.bottom, boundingBox.yMax);
};

HShapeElement.prototype.shapeBoundingBox = {
  left: 0,
  right: 0,
  top: 0,
  bottom: 0,
};

HShapeElement.prototype.tempBoundingBox = {
  x: 0,
  xMax: 0,
  y: 0,
  yMax: 0,
  width: 0,
  height: 0,
};

HShapeElement.prototype.getBoundsOfCurve = function (p0, p1, p2, p3) {
  var bounds = [[p0[0], p3[0]], [p0[1], p3[1]]];

  for (var a, b, c, t, b2ac, t1, t2, i = 0; i < 2; ++i) { // eslint-disable-line no-plusplus
    b = 6 * p0[i] - 12 * p1[i] + 6 * p2[i];
    a = -3 * p0[i] + 9 * p1[i] - 9 * p2[i] + 3 * p3[i];
    c = 3 * p1[i] - 3 * p0[i];

    b |= 0; // eslint-disable-line no-bitwise
    a |= 0; // eslint-disable-line no-bitwise
    c |= 0; // eslint-disable-line no-bitwise

    if (a === 0 && b === 0) ; else if (a === 0) {
      t = -c / b;

      if (t > 0 && t < 1) {
        bounds[i].push(this.calculateF(t, p0, p1, p2, p3, i));
      }
    } else {
      b2ac = b * b - 4 * c * a;

      if (b2ac >= 0) {
        t1 = (-b + bmSqrt(b2ac)) / (2 * a);
        if (t1 > 0 && t1 < 1) bounds[i].push(this.calculateF(t1, p0, p1, p2, p3, i));
        t2 = (-b - bmSqrt(b2ac)) / (2 * a);
        if (t2 > 0 && t2 < 1) bounds[i].push(this.calculateF(t2, p0, p1, p2, p3, i));
      }
    }
  }

  this.shapeBoundingBox.left = bmMin.apply(null, bounds[0]);
  this.shapeBoundingBox.top = bmMin.apply(null, bounds[1]);
  this.shapeBoundingBox.right = bmMax.apply(null, bounds[0]);
  this.shapeBoundingBox.bottom = bmMax.apply(null, bounds[1]);
};

HShapeElement.prototype.calculateF = function (t, p0, p1, p2, p3, i) {
  return bmPow(1 - t, 3) * p0[i]
        + 3 * bmPow(1 - t, 2) * t * p1[i]
        + 3 * (1 - t) * bmPow(t, 2) * p2[i]
        + bmPow(t, 3) * p3[i];
};

HShapeElement.prototype.calculateBoundingBox = function (itemsData, boundingBox) {
  var i;
  var len = itemsData.length;
  for (i = 0; i < len; i += 1) {
    if (itemsData[i] && itemsData[i].sh) {
      this.calculateShapeBoundingBox(itemsData[i], boundingBox);
    } else if (itemsData[i] && itemsData[i].it) {
      this.calculateBoundingBox(itemsData[i].it, boundingBox);
    }
  }
};

HShapeElement.prototype.currentBoxContains = function (box) {
  return this.currentBBox.x <= box.x
    && this.currentBBox.y <= box.y
    && this.currentBBox.width + this.currentBBox.x >= box.x + box.width
    && this.currentBBox.height + this.currentBBox.y >= box.y + box.height;
};

HShapeElement.prototype.renderInnerContent = function () {
  this._renderShapeFrame();

  if (!this.hidden && (this._isFirstFrame || this._mdf)) {
    var tempBoundingBox = this.tempBoundingBox;
    var max = 999999;
    tempBoundingBox.x = max;
    tempBoundingBox.xMax = -max;
    tempBoundingBox.y = max;
    tempBoundingBox.yMax = -max;
    this.calculateBoundingBox(this.itemsData, tempBoundingBox);
    tempBoundingBox.width = tempBoundingBox.xMax < tempBoundingBox.x ? 0 : tempBoundingBox.xMax - tempBoundingBox.x;
    tempBoundingBox.height = tempBoundingBox.yMax < tempBoundingBox.y ? 0 : tempBoundingBox.yMax - tempBoundingBox.y;
    // var tempBoundingBox = this.shapeCont.getBBox();
    if (this.currentBoxContains(tempBoundingBox)) {
      return;
    }
    var changed = false;
    if (this.currentBBox.w !== tempBoundingBox.width) {
      this.currentBBox.w = tempBoundingBox.width;
      this.shapeCont.setAttribute('width', tempBoundingBox.width);
      changed = true;
    }
    if (this.currentBBox.h !== tempBoundingBox.height) {
      this.currentBBox.h = tempBoundingBox.height;
      this.shapeCont.setAttribute('height', tempBoundingBox.height);
      changed = true;
    }
    if (changed || this.currentBBox.x !== tempBoundingBox.x || this.currentBBox.y !== tempBoundingBox.y) {
      this.currentBBox.w = tempBoundingBox.width;
      this.currentBBox.h = tempBoundingBox.height;
      this.currentBBox.x = tempBoundingBox.x;
      this.currentBBox.y = tempBoundingBox.y;

      this.shapeCont.setAttribute('viewBox', this.currentBBox.x + ' ' + this.currentBBox.y + ' ' + this.currentBBox.w + ' ' + this.currentBBox.h);
      var shapeStyle = this.shapeCont.style;
      var shapeTransform = 'translate(' + this.currentBBox.x + 'px,' + this.currentBBox.y + 'px)';
      shapeStyle.transform = shapeTransform;
      shapeStyle.webkitTransform = shapeTransform;
    }
  }
};

/* global extendPrototype, BaseElement, TransformElement, HBaseElement, HierarchyElement, FrameElement,
RenderableDOMElement, ITextElement, createSizedArray, createTag, styleDiv, createNS */

function HTextElement(data, globalData, comp) {
  this.textSpans = [];
  this.textPaths = [];
  this.currentBBox = {
    x: 999999,
    y: -999999,
    h: 0,
    w: 0,
  };
  this.renderType = 'svg';
  this.isMasked = false;
  this.initElement(data, globalData, comp);
}
extendPrototype([BaseElement, TransformElement, HBaseElement, HierarchyElement, FrameElement, RenderableDOMElement, ITextElement], HTextElement);

HTextElement.prototype.createContent = function () {
  this.isMasked = this.checkMasks();
  if (this.isMasked) {
    this.renderType = 'svg';
    this.compW = this.comp.data.w;
    this.compH = this.comp.data.h;
    this.svgElement.setAttribute('width', this.compW);
    this.svgElement.setAttribute('height', this.compH);
    var g = createNS('g');
    this.maskedElement.appendChild(g);
    this.innerElem = g;
  } else {
    this.renderType = 'html';
    this.innerElem = this.layerElement;
  }

  this.checkParenting();
};

HTextElement.prototype.buildNewText = function () {
  var documentData = this.textProperty.currentData;
  this.renderedLetters = createSizedArray(documentData.l ? documentData.l.length : 0);
  var innerElemStyle = this.innerElem.style;
  var textColor = documentData.fc ? this.buildColor(documentData.fc) : 'rgba(0,0,0,0)';
  innerElemStyle.fill = textColor;
  innerElemStyle.color = textColor;
  if (documentData.sc) {
    innerElemStyle.stroke = this.buildColor(documentData.sc);
    innerElemStyle.strokeWidth = documentData.sw + 'px';
  }
  var fontData = this.globalData.fontManager.getFontByName(documentData.f);
  if (!this.globalData.fontManager.chars) {
    innerElemStyle.fontSize = documentData.finalSize + 'px';
    innerElemStyle.lineHeight = documentData.finalSize + 'px';
    if (fontData.fClass) {
      this.innerElem.className = fontData.fClass;
    } else {
      innerElemStyle.fontFamily = fontData.fFamily;
      var fWeight = documentData.fWeight;
      var fStyle = documentData.fStyle;
      innerElemStyle.fontStyle = fStyle;
      innerElemStyle.fontWeight = fWeight;
    }
  }
  var i;
  var len;

  var letters = documentData.l;
  len = letters.length;
  var tSpan;
  var tParent;
  var tCont;
  var matrixHelper = this.mHelper;
  var shapes;
  var shapeStr = '';
  var cnt = 0;
  for (i = 0; i < len; i += 1) {
    if (this.globalData.fontManager.chars) {
      if (!this.textPaths[cnt]) {
        tSpan = createNS('path');
        tSpan.setAttribute('stroke-linecap', 'butt');
        tSpan.setAttribute('stroke-linejoin', 'round');
        tSpan.setAttribute('stroke-miterlimit', '4');
      } else {
        tSpan = this.textPaths[cnt];
      }
      if (!this.isMasked) {
        if (this.textSpans[cnt]) {
          tParent = this.textSpans[cnt];
          tCont = tParent.children[0];
        } else {
          tParent = createTag('div');
          tParent.style.lineHeight = 0;
          tCont = createNS('svg');
          tCont.appendChild(tSpan);
          styleDiv(tParent);
        }
      }
    } else if (!this.isMasked) {
      if (this.textSpans[cnt]) {
        tParent = this.textSpans[cnt];
        tSpan = this.textPaths[cnt];
      } else {
        tParent = createTag('span');
        styleDiv(tParent);
        tSpan = createTag('span');
        styleDiv(tSpan);
        tParent.appendChild(tSpan);
      }
    } else {
      tSpan = this.textPaths[cnt] ? this.textPaths[cnt] : createNS('text');
    }
    // tSpan.setAttribute('visibility', 'hidden');
    if (this.globalData.fontManager.chars) {
      var charData = this.globalData.fontManager.getCharData(documentData.finalText[i], fontData.fStyle, this.globalData.fontManager.getFontByName(documentData.f).fFamily);
      var shapeData;
      if (charData) {
        shapeData = charData.data;
      } else {
        shapeData = null;
      }
      matrixHelper.reset();
      if (shapeData && shapeData.shapes) {
        shapes = shapeData.shapes[0].it;
        matrixHelper.scale(documentData.finalSize / 100, documentData.finalSize / 100);
        shapeStr = this.createPathShape(matrixHelper, shapes);
        tSpan.setAttribute('d', shapeStr);
      }
      if (!this.isMasked) {
        this.innerElem.appendChild(tParent);
        if (shapeData && shapeData.shapes) {
          // document.body.appendChild is needed to get exact measure of shape
          document.body.appendChild(tCont);
          var boundingBox = tCont.getBBox();
          tCont.setAttribute('width', boundingBox.width + 2);
          tCont.setAttribute('height', boundingBox.height + 2);
          tCont.setAttribute('viewBox', (boundingBox.x - 1) + ' ' + (boundingBox.y - 1) + ' ' + (boundingBox.width + 2) + ' ' + (boundingBox.height + 2));
          var tContStyle = tCont.style;
          var tContTranslation = 'translate(' + (boundingBox.x - 1) + 'px,' + (boundingBox.y - 1) + 'px)';
          tContStyle.transform = tContTranslation;
          tContStyle.webkitTransform = tContTranslation;

          letters[i].yOffset = boundingBox.y - 1;
        } else {
          tCont.setAttribute('width', 1);
          tCont.setAttribute('height', 1);
        }
        tParent.appendChild(tCont);
      } else {
        this.innerElem.appendChild(tSpan);
      }
    } else {
      tSpan.textContent = letters[i].val;
      tSpan.setAttributeNS('http://www.w3.org/XML/1998/namespace', 'xml:space', 'preserve');
      if (!this.isMasked) {
        this.innerElem.appendChild(tParent);
        //
        var tStyle = tSpan.style;
        var tSpanTranslation = 'translate3d(0,' + -documentData.finalSize / 1.2 + 'px,0)';
        tStyle.transform = tSpanTranslation;
        tStyle.webkitTransform = tSpanTranslation;
      } else {
        this.innerElem.appendChild(tSpan);
      }
    }
    //
    if (!this.isMasked) {
      this.textSpans[cnt] = tParent;
    } else {
      this.textSpans[cnt] = tSpan;
    }
    this.textSpans[cnt].style.display = 'block';
    this.textPaths[cnt] = tSpan;
    cnt += 1;
  }
  while (cnt < this.textSpans.length) {
    this.textSpans[cnt].style.display = 'none';
    cnt += 1;
  }
};

HTextElement.prototype.renderInnerContent = function () {
  var svgStyle;
  if (this.data.singleShape) {
    if (!this._isFirstFrame && !this.lettersChangedFlag) {
      return;
    } if (this.isMasked && this.finalTransform._matMdf) {
      // Todo Benchmark if using this is better than getBBox
      this.svgElement.setAttribute('viewBox', -this.finalTransform.mProp.p.v[0] + ' ' + -this.finalTransform.mProp.p.v[1] + ' ' + this.compW + ' ' + this.compH);
      svgStyle = this.svgElement.style;
      var translation = 'translate(' + -this.finalTransform.mProp.p.v[0] + 'px,' + -this.finalTransform.mProp.p.v[1] + 'px)';
      svgStyle.transform = translation;
      svgStyle.webkitTransform = translation;
    }
  }

  this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
  if (!this.lettersChangedFlag && !this.textAnimator.lettersChangedFlag) {
    return;
  }
  var i;
  var len;
  var count = 0;
  var renderedLetters = this.textAnimator.renderedLetters;

  var letters = this.textProperty.currentData.l;

  len = letters.length;
  var renderedLetter;
  var textSpan;
  var textPath;
  for (i = 0; i < len; i += 1) {
    if (letters[i].n) {
      count += 1;
    } else {
      textSpan = this.textSpans[i];
      textPath = this.textPaths[i];
      renderedLetter = renderedLetters[count];
      count += 1;
      if (renderedLetter._mdf.m) {
        if (!this.isMasked) {
          textSpan.style.webkitTransform = renderedLetter.m;
          textSpan.style.transform = renderedLetter.m;
        } else {
          textSpan.setAttribute('transform', renderedLetter.m);
        }
      }
      /// /textSpan.setAttribute('opacity',renderedLetter.o);
      textSpan.style.opacity = renderedLetter.o;
      if (renderedLetter.sw && renderedLetter._mdf.sw) {
        textPath.setAttribute('stroke-width', renderedLetter.sw);
      }
      if (renderedLetter.sc && renderedLetter._mdf.sc) {
        textPath.setAttribute('stroke', renderedLetter.sc);
      }
      if (renderedLetter.fc && renderedLetter._mdf.fc) {
        textPath.setAttribute('fill', renderedLetter.fc);
        textPath.style.color = renderedLetter.fc;
      }
    }
  }

  if (this.innerElem.getBBox && !this.hidden && (this._isFirstFrame || this._mdf)) {
    var boundingBox = this.innerElem.getBBox();

    if (this.currentBBox.w !== boundingBox.width) {
      this.currentBBox.w = boundingBox.width;
      this.svgElement.setAttribute('width', boundingBox.width);
    }
    if (this.currentBBox.h !== boundingBox.height) {
      this.currentBBox.h = boundingBox.height;
      this.svgElement.setAttribute('height', boundingBox.height);
    }

    var margin = 1;
    if (this.currentBBox.w !== (boundingBox.width + margin * 2) || this.currentBBox.h !== (boundingBox.height + margin * 2) || this.currentBBox.x !== (boundingBox.x - margin) || this.currentBBox.y !== (boundingBox.y - margin)) {
      this.currentBBox.w = boundingBox.width + margin * 2;
      this.currentBBox.h = boundingBox.height + margin * 2;
      this.currentBBox.x = boundingBox.x - margin;
      this.currentBBox.y = boundingBox.y - margin;

      this.svgElement.setAttribute('viewBox', this.currentBBox.x + ' ' + this.currentBBox.y + ' ' + this.currentBBox.w + ' ' + this.currentBBox.h);
      svgStyle = this.svgElement.style;
      var svgTransform = 'translate(' + this.currentBBox.x + 'px,' + this.currentBBox.y + 'px)';
      svgStyle.transform = svgTransform;
      svgStyle.webkitTransform = svgTransform;
    }
  }
};

/* global extendPrototype, BaseElement, TransformElement, HBaseElement, HSolidElement, HierarchyElement,
FrameElement, RenderableElement, createNS */

function HImageElement(data, globalData, comp) {
  this.assetData = globalData.getAssetData(data.refId);
  this.initElement(data, globalData, comp);
}

extendPrototype([BaseElement, TransformElement, HBaseElement, HSolidElement, HierarchyElement, FrameElement, RenderableElement], HImageElement);

HImageElement.prototype.createContent = function () {
  var assetPath = this.globalData.getAssetsPath(this.assetData);
  var img = new Image();

  if (this.data.hasMask) {
    this.imageElem = createNS('image');
    this.imageElem.setAttribute('width', this.assetData.w + 'px');
    this.imageElem.setAttribute('height', this.assetData.h + 'px');
    this.imageElem.setAttributeNS('http://www.w3.org/1999/xlink', 'href', assetPath);
    this.layerElement.appendChild(this.imageElem);
    this.baseElement.setAttribute('width', this.assetData.w);
    this.baseElement.setAttribute('height', this.assetData.h);
  } else {
    this.layerElement.appendChild(img);
  }
  img.crossOrigin = 'anonymous';
  img.src = assetPath;
  if (this.data.ln) {
    this.baseElement.setAttribute('id', this.data.ln);
  }
};

/* global PropertyFactory, degToRads, Matrix, extendPrototype, BaseElement, FrameElement, HierarchyElement */

function HCameraElement(data, globalData, comp) {
  this.initFrame();
  this.initBaseData(data, globalData, comp);
  this.initHierarchy();
  var getProp = PropertyFactory.getProp;
  this.pe = getProp(this, data.pe, 0, 0, this);
  if (data.ks.p.s) {
    this.px = getProp(this, data.ks.p.x, 1, 0, this);
    this.py = getProp(this, data.ks.p.y, 1, 0, this);
    this.pz = getProp(this, data.ks.p.z, 1, 0, this);
  } else {
    this.p = getProp(this, data.ks.p, 1, 0, this);
  }
  if (data.ks.a) {
    this.a = getProp(this, data.ks.a, 1, 0, this);
  }
  if (data.ks.or.k.length && data.ks.or.k[0].to) {
    var i;
    var len = data.ks.or.k.length;
    for (i = 0; i < len; i += 1) {
      data.ks.or.k[i].to = null;
      data.ks.or.k[i].ti = null;
    }
  }
  this.or = getProp(this, data.ks.or, 1, degToRads, this);
  this.or.sh = true;
  this.rx = getProp(this, data.ks.rx, 0, degToRads, this);
  this.ry = getProp(this, data.ks.ry, 0, degToRads, this);
  this.rz = getProp(this, data.ks.rz, 0, degToRads, this);
  this.mat = new Matrix();
  this._prevMat = new Matrix();
  this._isFirstFrame = true;

  // TODO: find a better way to make the HCamera element to be compatible with the LayerInterface and TransformInterface.
  this.finalTransform = {
    mProp: this,
  };
}
extendPrototype([BaseElement, FrameElement, HierarchyElement], HCameraElement);

HCameraElement.prototype.setup = function () {
  var i;
  var len = this.comp.threeDElements.length;
  var comp;
  var perspectiveStyle;
  var containerStyle;
  for (i = 0; i < len; i += 1) {
    // [perspectiveElem,container]
    comp = this.comp.threeDElements[i];
    if (comp.type === '3d') {
      perspectiveStyle = comp.perspectiveElem.style;
      containerStyle = comp.container.style;
      var perspective = this.pe.v + 'px';
      var origin = '0px 0px 0px';
      var matrix = 'matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)';
      perspectiveStyle.perspective = perspective;
      perspectiveStyle.webkitPerspective = perspective;
      containerStyle.transformOrigin = origin;
      containerStyle.mozTransformOrigin = origin;
      containerStyle.webkitTransformOrigin = origin;
      perspectiveStyle.transform = matrix;
      perspectiveStyle.webkitTransform = matrix;
    }
  }
};

HCameraElement.prototype.createElements = function () {
};

HCameraElement.prototype.hide = function () {
};

HCameraElement.prototype.renderFrame = function () {
  var _mdf = this._isFirstFrame;
  var i;
  var len;
  if (this.hierarchy) {
    len = this.hierarchy.length;
    for (i = 0; i < len; i += 1) {
      _mdf = this.hierarchy[i].finalTransform.mProp._mdf || _mdf;
    }
  }
  if (_mdf || this.pe._mdf || (this.p && this.p._mdf) || (this.px && (this.px._mdf || this.py._mdf || this.pz._mdf)) || this.rx._mdf || this.ry._mdf || this.rz._mdf || this.or._mdf || (this.a && this.a._mdf)) {
    this.mat.reset();

    if (this.hierarchy) {
      len = this.hierarchy.length - 1;
      for (i = len; i >= 0; i -= 1) {
        var mTransf = this.hierarchy[i].finalTransform.mProp;
        this.mat.translate(-mTransf.p.v[0], -mTransf.p.v[1], mTransf.p.v[2]);
        this.mat.rotateX(-mTransf.or.v[0]).rotateY(-mTransf.or.v[1]).rotateZ(mTransf.or.v[2]);
        this.mat.rotateX(-mTransf.rx.v).rotateY(-mTransf.ry.v).rotateZ(mTransf.rz.v);
        this.mat.scale(1 / mTransf.s.v[0], 1 / mTransf.s.v[1], 1 / mTransf.s.v[2]);
        this.mat.translate(mTransf.a.v[0], mTransf.a.v[1], mTransf.a.v[2]);
      }
    }
    if (this.p) {
      this.mat.translate(-this.p.v[0], -this.p.v[1], this.p.v[2]);
    } else {
      this.mat.translate(-this.px.v, -this.py.v, this.pz.v);
    }
    if (this.a) {
      var diffVector;
      if (this.p) {
        diffVector = [this.p.v[0] - this.a.v[0], this.p.v[1] - this.a.v[1], this.p.v[2] - this.a.v[2]];
      } else {
        diffVector = [this.px.v - this.a.v[0], this.py.v - this.a.v[1], this.pz.v - this.a.v[2]];
      }
      var mag = Math.sqrt(Math.pow(diffVector[0], 2) + Math.pow(diffVector[1], 2) + Math.pow(diffVector[2], 2));
      // var lookDir = getNormalizedPoint(getDiffVector(this.a.v,this.p.v));
      var lookDir = [diffVector[0] / mag, diffVector[1] / mag, diffVector[2] / mag];
      var lookLengthOnXZ = Math.sqrt(lookDir[2] * lookDir[2] + lookDir[0] * lookDir[0]);
      var mRotationX = (Math.atan2(lookDir[1], lookLengthOnXZ));
      var mRotationY = (Math.atan2(lookDir[0], -lookDir[2]));
      this.mat.rotateY(mRotationY).rotateX(-mRotationX);
    }
    this.mat.rotateX(-this.rx.v).rotateY(-this.ry.v).rotateZ(this.rz.v);
    this.mat.rotateX(-this.or.v[0]).rotateY(-this.or.v[1]).rotateZ(this.or.v[2]);
    this.mat.translate(this.globalData.compSize.w / 2, this.globalData.compSize.h / 2, 0);
    this.mat.translate(0, 0, this.pe.v);

    var hasMatrixChanged = !this._prevMat.equals(this.mat);
    if ((hasMatrixChanged || this.pe._mdf) && this.comp.threeDElements) {
      len = this.comp.threeDElements.length;
      var comp;
      var perspectiveStyle;
      var containerStyle;
      for (i = 0; i < len; i += 1) {
        comp = this.comp.threeDElements[i];
        if (comp.type === '3d') {
          if (hasMatrixChanged) {
            var matValue = this.mat.toCSS();
            containerStyle = comp.container.style;
            containerStyle.transform = matValue;
            containerStyle.webkitTransform = matValue;
          }
          if (this.pe._mdf) {
            perspectiveStyle = comp.perspectiveElem.style;
            perspectiveStyle.perspective = this.pe.v + 'px';
            perspectiveStyle.webkitPerspective = this.pe.v + 'px';
          }
        }
      }
      this.mat.clone(this._prevMat);
    }
  }
  this._isFirstFrame = false;
};

HCameraElement.prototype.prepareFrame = function (num) {
  this.prepareProperties(num, true);
};

HCameraElement.prototype.destroy = function () {
};
HCameraElement.prototype.getBaseElement = function () { return null; };

/* global createTag, AnimationItem */
/* exported animationManager */

var animationManager = (function () {
  var moduleOb = {};
  var registeredAnimations = [];
  var initTime = 0;
  var len = 0;
  var playingAnimationsNum = 0;
  var _stopped = true;
  var _isFrozen = false;

  function removeElement(ev) {
    var i = 0;
    var animItem = ev.target;
    while (i < len) {
      if (registeredAnimations[i].animation === animItem) {
        registeredAnimations.splice(i, 1);
        i -= 1;
        len -= 1;
        if (!animItem.isPaused) {
          subtractPlayingCount();
        }
      }
      i += 1;
    }
  }

  function registerAnimation(element, animationData) {
    if (!element) {
      return null;
    }
    var i = 0;
    while (i < len) {
      if (registeredAnimations[i].elem === element && registeredAnimations[i].elem !== null) {
        return registeredAnimations[i].animation;
      }
      i += 1;
    }
    var animItem = new AnimationItem();
    setupAnimation(animItem, element);
    animItem.setData(element, animationData);
    return animItem;
  }

  function getRegisteredAnimations() {
    var i;
    var lenAnims = registeredAnimations.length;
    var animations = [];
    for (i = 0; i < lenAnims; i += 1) {
      animations.push(registeredAnimations[i].animation);
    }
    return animations;
  }

  function addPlayingCount() {
    playingAnimationsNum += 1;
    activate();
  }

  function subtractPlayingCount() {
    playingAnimationsNum -= 1;
  }

  function setupAnimation(animItem, element) {
    animItem.addEventListener('destroy', removeElement);
    animItem.addEventListener('_active', addPlayingCount);
    animItem.addEventListener('_idle', subtractPlayingCount);
    registeredAnimations.push({ elem: element, animation: animItem });
    len += 1;
  }

  function loadAnimation(params) {
    var animItem = new AnimationItem();
    setupAnimation(animItem, null);
    animItem.setParams(params);
    return animItem;
  }

  function setSpeed(val, animation) {
    var i;
    for (i = 0; i < len; i += 1) {
      registeredAnimations[i].animation.setSpeed(val, animation);
    }
  }

  function setDirection(val, animation) {
    var i;
    for (i = 0; i < len; i += 1) {
      registeredAnimations[i].animation.setDirection(val, animation);
    }
  }

  function play(animation) {
    var i;
    for (i = 0; i < len; i += 1) {
      registeredAnimations[i].animation.play(animation);
    }
  }
  function resume(nowTime) {
    var elapsedTime = nowTime - initTime;
    var i;
    for (i = 0; i < len; i += 1) {
      registeredAnimations[i].animation.advanceTime(elapsedTime);
    }
    initTime = nowTime;
    if (playingAnimationsNum && !_isFrozen) {
      window.requestAnimationFrame(resume);
    } else {
      _stopped = true;
    }
  }

  function first(nowTime) {
    initTime = nowTime;
    window.requestAnimationFrame(resume);
  }

  function pause(animation) {
    var i;
    for (i = 0; i < len; i += 1) {
      registeredAnimations[i].animation.pause(animation);
    }
  }

  function goToAndStop(value, isFrame, animation) {
    var i;
    for (i = 0; i < len; i += 1) {
      registeredAnimations[i].animation.goToAndStop(value, isFrame, animation);
    }
  }

  function stop(animation) {
    var i;
    for (i = 0; i < len; i += 1) {
      registeredAnimations[i].animation.stop(animation);
    }
  }

  function togglePause(animation) {
    var i;
    for (i = 0; i < len; i += 1) {
      registeredAnimations[i].animation.togglePause(animation);
    }
  }

  function destroy(animation) {
    var i;
    for (i = (len - 1); i >= 0; i -= 1) {
      registeredAnimations[i].animation.destroy(animation);
    }
  }

  function searchAnimations(animationData, standalone, renderer) {
    var animElements = [].concat([].slice.call(document.getElementsByClassName('lottie')),
      [].slice.call(document.getElementsByClassName('bodymovin')));
    var i;
    var lenAnims = animElements.length;
    for (i = 0; i < lenAnims; i += 1) {
      if (renderer) {
        animElements[i].setAttribute('data-bm-type', renderer);
      }
      registerAnimation(animElements[i], animationData);
    }
    if (standalone && lenAnims === 0) {
      if (!renderer) {
        renderer = 'svg';
      }
      var body = document.getElementsByTagName('body')[0];
      body.innerText = '';
      var div = createTag('div');
      div.style.width = '100%';
      div.style.height = '100%';
      div.setAttribute('data-bm-type', renderer);
      body.appendChild(div);
      registerAnimation(div, animationData);
    }
  }

  function resize() {
    var i;
    for (i = 0; i < len; i += 1) {
      registeredAnimations[i].animation.resize();
    }
  }

  function activate() {
    if (!_isFrozen && playingAnimationsNum) {
      if (_stopped) {
        window.requestAnimationFrame(first);
        _stopped = false;
      }
    }
  }

  function freeze() {
    _isFrozen = true;
  }

  function unfreeze() {
    _isFrozen = false;
    activate();
  }

  function setVolume(val, animation) {
    var i;
    for (i = 0; i < len; i += 1) {
      registeredAnimations[i].animation.setVolume(val, animation);
    }
  }

  function mute(animation) {
    var i;
    for (i = 0; i < len; i += 1) {
      registeredAnimations[i].animation.mute(animation);
    }
  }

  function unmute(animation) {
    var i;
    for (i = 0; i < len; i += 1) {
      registeredAnimations[i].animation.unmute(animation);
    }
  }

  moduleOb.registerAnimation = registerAnimation;
  moduleOb.loadAnimation = loadAnimation;
  moduleOb.setSpeed = setSpeed;
  moduleOb.setDirection = setDirection;
  moduleOb.play = play;
  moduleOb.pause = pause;
  moduleOb.stop = stop;
  moduleOb.togglePause = togglePause;
  moduleOb.searchAnimations = searchAnimations;
  moduleOb.resize = resize;
  // moduleOb.start = start;
  moduleOb.goToAndStop = goToAndStop;
  moduleOb.destroy = destroy;
  moduleOb.freeze = freeze;
  moduleOb.unfreeze = unfreeze;
  moduleOb.setVolume = setVolume;
  moduleOb.mute = mute;
  moduleOb.unmute = unmute;
  moduleOb.getRegisteredAnimations = getRegisteredAnimations;
  return moduleOb;
}());

/* global createElementID, subframeEnabled, ProjectInterface, ImagePreloader, audioControllerFactory, extendPrototype, BaseEvent,
CanvasRenderer, SVGRenderer, HybridRenderer, assetLoader, dataManager, expressionsPlugin, BMEnterFrameEvent, BMCompleteLoopEvent,
BMCompleteEvent, BMSegmentStartEvent, BMDestroyEvent, BMEnterFrameEvent, BMCompleteLoopEvent, BMCompleteEvent, BMSegmentStartEvent,
BMDestroyEvent, BMRenderFrameErrorEvent, BMConfigErrorEvent, markerParser */

var AnimationItem = function () {
  this._cbs = [];
  this.name = '';
  this.path = '';
  this.isLoaded = false;
  this.currentFrame = 0;
  this.currentRawFrame = 0;
  this.firstFrame = 0;
  this.totalFrames = 0;
  this.frameRate = 0;
  this.frameMult = 0;
  this.playSpeed = 1;
  this.playDirection = 1;
  this.playCount = 0;
  this.animationData = {};
  this.assets = [];
  this.isPaused = true;
  this.autoplay = false;
  this.loop = true;
  this.renderer = null;
  this.animationID = createElementID();
  this.assetsPath = '';
  this.timeCompleted = 0;
  this.segmentPos = 0;
  this.isSubframeEnabled = subframeEnabled;
  this.segments = [];
  this._idle = true;
  this._completedLoop = false;
  this.projectInterface = ProjectInterface();
  this.imagePreloader = new ImagePreloader();
  this.audioController = audioControllerFactory();
  this.markers = [];
};

extendPrototype([BaseEvent], AnimationItem);

AnimationItem.prototype.setParams = function (params) {
  if (params.wrapper || params.container) {
    this.wrapper = params.wrapper || params.container;
  }
  var animType = 'svg';
  if (params.animType) {
    animType = params.animType;
  } else if (params.renderer) {
    animType = params.renderer;
  }
  switch (animType) {
    case 'canvas':
      this.renderer = new CanvasRenderer(this, params.rendererSettings);
      break;
    case 'svg':
      this.renderer = new SVGRenderer(this, params.rendererSettings);
      break;
    default:
      this.renderer = new HybridRenderer(this, params.rendererSettings);
      break;
  }
  this.imagePreloader.setCacheType(animType, this.renderer.globalData.defs);
  this.renderer.setProjectInterface(this.projectInterface);
  this.animType = animType;
  if (params.loop === ''
        || params.loop === null
        || params.loop === undefined
        || params.loop === true) {
    this.loop = true;
  } else if (params.loop === false) {
    this.loop = false;
  } else {
    this.loop = parseInt(params.loop, 10);
  }
  this.autoplay = 'autoplay' in params ? params.autoplay : true;
  this.name = params.name ? params.name : '';
  this.autoloadSegments = Object.prototype.hasOwnProperty.call(params, 'autoloadSegments') ? params.autoloadSegments : true;
  this.assetsPath = params.assetsPath;
  this.initialSegment = params.initialSegment;
  if (params.audioFactory) {
    this.audioController.setAudioFactory(params.audioFactory);
  }
  if (params.animationData) {
    this.configAnimation(params.animationData);
  } else if (params.path) {
    if (params.path.lastIndexOf('\\') !== -1) {
      this.path = params.path.substr(0, params.path.lastIndexOf('\\') + 1);
    } else {
      this.path = params.path.substr(0, params.path.lastIndexOf('/') + 1);
    }
    this.fileName = params.path.substr(params.path.lastIndexOf('/') + 1);
    this.fileName = this.fileName.substr(0, this.fileName.lastIndexOf('.json'));

    assetLoader.load(params.path, this.configAnimation.bind(this), function () {
      this.trigger('data_failed');
    }.bind(this));
  }
};

AnimationItem.prototype.setData = function (wrapper, animationData) {
  if (animationData) {
    if (typeof animationData !== 'object') {
      animationData = JSON.parse(animationData);
    }
  }
  var params = {
    wrapper: wrapper,
    animationData: animationData,
  };
  var wrapperAttributes = wrapper.attributes;

  params.path = wrapperAttributes.getNamedItem('data-animation-path') // eslint-disable-line no-nested-ternary
    ? wrapperAttributes.getNamedItem('data-animation-path').value
    : wrapperAttributes.getNamedItem('data-bm-path') // eslint-disable-line no-nested-ternary
      ? wrapperAttributes.getNamedItem('data-bm-path').value
      : wrapperAttributes.getNamedItem('bm-path')
        ? wrapperAttributes.getNamedItem('bm-path').value
        : '';
  params.animType = wrapperAttributes.getNamedItem('data-anim-type') // eslint-disable-line no-nested-ternary
    ? wrapperAttributes.getNamedItem('data-anim-type').value
    : wrapperAttributes.getNamedItem('data-bm-type') // eslint-disable-line no-nested-ternary
      ? wrapperAttributes.getNamedItem('data-bm-type').value
      : wrapperAttributes.getNamedItem('bm-type') // eslint-disable-line no-nested-ternary
        ? wrapperAttributes.getNamedItem('bm-type').value
        : wrapperAttributes.getNamedItem('data-bm-renderer') // eslint-disable-line no-nested-ternary
          ? wrapperAttributes.getNamedItem('data-bm-renderer').value
          : wrapperAttributes.getNamedItem('bm-renderer')
            ? wrapperAttributes.getNamedItem('bm-renderer').value
            : 'canvas';

  var loop = wrapperAttributes.getNamedItem('data-anim-loop') // eslint-disable-line no-nested-ternary
    ? wrapperAttributes.getNamedItem('data-anim-loop').value
    : wrapperAttributes.getNamedItem('data-bm-loop') // eslint-disable-line no-nested-ternary
      ? wrapperAttributes.getNamedItem('data-bm-loop').value
      : wrapperAttributes.getNamedItem('bm-loop')
        ? wrapperAttributes.getNamedItem('bm-loop').value
        : '';
  if (loop === 'false') {
    params.loop = false;
  } else if (loop === 'true') {
    params.loop = true;
  } else if (loop !== '') {
    params.loop = parseInt(loop, 10);
  }
  var autoplay = wrapperAttributes.getNamedItem('data-anim-autoplay') // eslint-disable-line no-nested-ternary
    ? wrapperAttributes.getNamedItem('data-anim-autoplay').value
    : wrapperAttributes.getNamedItem('data-bm-autoplay') // eslint-disable-line no-nested-ternary
      ? wrapperAttributes.getNamedItem('data-bm-autoplay').value
      : wrapperAttributes.getNamedItem('bm-autoplay')
        ? wrapperAttributes.getNamedItem('bm-autoplay').value
        : true;
  params.autoplay = autoplay !== 'false';

  params.name = wrapperAttributes.getNamedItem('data-name') // eslint-disable-line no-nested-ternary
    ? wrapperAttributes.getNamedItem('data-name').value
    : wrapperAttributes.getNamedItem('data-bm-name') // eslint-disable-line no-nested-ternary
      ? wrapperAttributes.getNamedItem('data-bm-name').value
      : wrapperAttributes.getNamedItem('bm-name')
        ? wrapperAttributes.getNamedItem('bm-name').value
        : '';
  var prerender = wrapperAttributes.getNamedItem('data-anim-prerender') // eslint-disable-line no-nested-ternary
    ? wrapperAttributes.getNamedItem('data-anim-prerender').value
    : wrapperAttributes.getNamedItem('data-bm-prerender') // eslint-disable-line no-nested-ternary
      ? wrapperAttributes.getNamedItem('data-bm-prerender').value
      : wrapperAttributes.getNamedItem('bm-prerender')
        ? wrapperAttributes.getNamedItem('bm-prerender').value
        : '';

  if (prerender === 'false') {
    params.prerender = false;
  }
  this.setParams(params);
};

AnimationItem.prototype.includeLayers = function (data) {
  if (data.op > this.animationData.op) {
    this.animationData.op = data.op;
    this.totalFrames = Math.floor(data.op - this.animationData.ip);
  }
  var layers = this.animationData.layers;
  var i;
  var len = layers.length;
  var newLayers = data.layers;
  var j;
  var jLen = newLayers.length;
  for (j = 0; j < jLen; j += 1) {
    i = 0;
    while (i < len) {
      if (layers[i].id === newLayers[j].id) {
        layers[i] = newLayers[j];
        break;
      }
      i += 1;
    }
  }
  if (data.chars || data.fonts) {
    this.renderer.globalData.fontManager.addChars(data.chars);
    this.renderer.globalData.fontManager.addFonts(data.fonts, this.renderer.globalData.defs);
  }
  if (data.assets) {
    len = data.assets.length;
    for (i = 0; i < len; i += 1) {
      this.animationData.assets.push(data.assets[i]);
    }
  }
  this.animationData.__complete = false;
  dataManager.completeData(this.animationData, this.renderer.globalData.fontManager);
  this.renderer.includeLayers(data.layers);
  if (expressionsPlugin) {
    expressionsPlugin.initExpressions(this);
  }
  this.loadNextSegment();
};

AnimationItem.prototype.loadNextSegment = function () {
  var segments = this.animationData.segments;
  if (!segments || segments.length === 0 || !this.autoloadSegments) {
    this.trigger('data_ready');
    this.timeCompleted = this.totalFrames;
    return;
  }
  var segment = segments.shift();
  this.timeCompleted = segment.time * this.frameRate;
  var segmentPath = this.path + this.fileName + '_' + this.segmentPos + '.json';
  this.segmentPos += 1;
  assetLoader.load(segmentPath, this.includeLayers.bind(this), function () {
    this.trigger('data_failed');
  }.bind(this));
};

AnimationItem.prototype.loadSegments = function () {
  var segments = this.animationData.segments;
  if (!segments) {
    this.timeCompleted = this.totalFrames;
  }
  this.loadNextSegment();
};

AnimationItem.prototype.imagesLoaded = function () {
  this.trigger('loaded_images');
  this.checkLoaded();
};

AnimationItem.prototype.preloadImages = function () {
  this.imagePreloader.setAssetsPath(this.assetsPath);
  this.imagePreloader.setPath(this.path);
  this.imagePreloader.loadAssets(this.animationData.assets, this.imagesLoaded.bind(this));
};

AnimationItem.prototype.configAnimation = function (animData) {
  if (!this.renderer) {
    return;
  }
  try {
    this.animationData = animData;

    if (this.initialSegment) {
      this.totalFrames = Math.floor(this.initialSegment[1] - this.initialSegment[0]);
      this.firstFrame = Math.round(this.initialSegment[0]);
    } else {
      this.totalFrames = Math.floor(this.animationData.op - this.animationData.ip);
      this.firstFrame = Math.round(this.animationData.ip);
    }
    this.renderer.configAnimation(animData);
    if (!animData.assets) {
      animData.assets = [];
    }

    this.assets = this.animationData.assets;
    this.frameRate = this.animationData.fr;
    this.frameMult = this.animationData.fr / 1000;
    this.renderer.searchExtraCompositions(animData.assets);
    this.markers = markerParser(animData.markers || []);
    this.trigger('config_ready');
    this.preloadImages();
    this.loadSegments();
    this.updaFrameModifier();
    this.waitForFontsLoaded();
    if (this.isPaused) {
      this.audioController.pause();
    }
  } catch (error) {
    this.triggerConfigError(error);
  }
};

AnimationItem.prototype.waitForFontsLoaded = function () {
  if (!this.renderer) {
    return;
  }
  if (this.renderer.globalData.fontManager.isLoaded) {
    this.checkLoaded();
  } else {
    setTimeout(this.waitForFontsLoaded.bind(this), 20);
  }
};

AnimationItem.prototype.checkLoaded = function () {
  if (!this.isLoaded
        && this.renderer.globalData.fontManager.isLoaded
        && (this.imagePreloader.loadedImages() || this.renderer.rendererType !== 'canvas')
        && (this.imagePreloader.loadedFootages())
  ) {
    this.isLoaded = true;
    dataManager.completeData(this.animationData, this.renderer.globalData.fontManager);
    if (expressionsPlugin) {
      expressionsPlugin.initExpressions(this);
    }
    this.renderer.initItems();
    setTimeout(function () {
      this.trigger('DOMLoaded');
    }.bind(this), 0);
    this.gotoFrame();
    if (this.autoplay) {
      this.play();
    }
  }
};

AnimationItem.prototype.resize = function () {
  this.renderer.updateContainerSize();
};

AnimationItem.prototype.setSubframe = function (flag) {
  this.isSubframeEnabled = !!flag;
};

AnimationItem.prototype.gotoFrame = function () {
  this.currentFrame = this.isSubframeEnabled ? this.currentRawFrame : ~~this.currentRawFrame; // eslint-disable-line no-bitwise

  if (this.timeCompleted !== this.totalFrames && this.currentFrame > this.timeCompleted) {
    this.currentFrame = this.timeCompleted;
  }
  this.trigger('enterFrame');
  this.renderFrame();
};

AnimationItem.prototype.renderFrame = function () {
  if (this.isLoaded === false || !this.renderer) {
    return;
  }
  try {
    this.renderer.renderFrame(this.currentFrame + this.firstFrame);
  } catch (error) {
    this.triggerRenderFrameError(error);
  }
};

AnimationItem.prototype.play = function (name) {
  if (name && this.name !== name) {
    return;
  }
  if (this.isPaused === true) {
    this.isPaused = false;
    this.audioController.resume();
    if (this._idle) {
      this._idle = false;
      this.trigger('_active');
    }
  }
};

AnimationItem.prototype.pause = function (name) {
  if (name && this.name !== name) {
    return;
  }
  if (this.isPaused === false) {
    this.isPaused = true;
    this._idle = true;
    this.trigger('_idle');
    this.audioController.pause();
  }
};

AnimationItem.prototype.togglePause = function (name) {
  if (name && this.name !== name) {
    return;
  }
  if (this.isPaused === true) {
    this.play();
  } else {
    this.pause();
  }
};

AnimationItem.prototype.stop = function (name) {
  if (name && this.name !== name) {
    return;
  }
  this.pause();
  this.playCount = 0;
  this._completedLoop = false;
  this.setCurrentRawFrameValue(0);
};

AnimationItem.prototype.getMarkerData = function (markerName) {
  var marker;
  for (var i = 0; i < this.markers.length; i += 1) {
    marker = this.markers[i];
    if (marker.payload && marker.payload.name === markerName) {
      return marker;
    }
  }
  return null;
};

AnimationItem.prototype.goToAndStop = function (value, isFrame, name) {
  if (name && this.name !== name) {
    return;
  }
  var numValue = Number(value);
  if (isNaN(numValue)) {
    var marker = this.getMarkerData(value);
    if (marker) {
      this.goToAndStop(marker.time, true);
    }
  } else if (isFrame) {
    this.setCurrentRawFrameValue(value);
  } else {
    this.setCurrentRawFrameValue(value * this.frameModifier);
  }
  this.pause();
};

AnimationItem.prototype.goToAndPlay = function (value, isFrame, name) {
  if (name && this.name !== name) {
    return;
  }
  var numValue = Number(value);
  if (isNaN(numValue)) {
    var marker = this.getMarkerData(value);
    if (marker) {
      if (!marker.duration) {
        this.goToAndStop(marker.time, true);
      } else {
        this.playSegments([marker.time, marker.time + marker.duration], true);
      }
    }
  } else {
    this.goToAndStop(numValue, isFrame, name);
  }
  this.play();
};

AnimationItem.prototype.advanceTime = function (value) {
  if (this.isPaused === true || this.isLoaded === false) {
    return;
  }
  var nextValue = this.currentRawFrame + value * this.frameModifier;
  var _isComplete = false;
  // Checking if nextValue > totalFrames - 1 for addressing non looping and looping animations.
  // If animation won't loop, it should stop at totalFrames - 1. If it will loop it should complete the last frame and then loop.
  if (nextValue >= this.totalFrames - 1 && this.frameModifier > 0) {
    if (!this.loop || this.playCount === this.loop) {
      if (!this.checkSegments(nextValue > this.totalFrames ? nextValue % this.totalFrames : 0)) {
        _isComplete = true;
        nextValue = this.totalFrames - 1;
      }
    } else if (nextValue >= this.totalFrames) {
      this.playCount += 1;
      if (!this.checkSegments(nextValue % this.totalFrames)) {
        this.setCurrentRawFrameValue(nextValue % this.totalFrames);
        this._completedLoop = true;
        this.trigger('loopComplete');
      }
    } else {
      this.setCurrentRawFrameValue(nextValue);
    }
  } else if (nextValue < 0) {
    if (!this.checkSegments(nextValue % this.totalFrames)) {
      if (this.loop && !(this.playCount-- <= 0 && this.loop !== true)) { // eslint-disable-line no-plusplus
        this.setCurrentRawFrameValue(this.totalFrames + (nextValue % this.totalFrames));
        if (!this._completedLoop) {
          this._completedLoop = true;
        } else {
          this.trigger('loopComplete');
        }
      } else {
        _isComplete = true;
        nextValue = 0;
      }
    }
  } else {
    this.setCurrentRawFrameValue(nextValue);
  }
  if (_isComplete) {
    this.setCurrentRawFrameValue(nextValue);
    this.pause();
    this.trigger('complete');
  }
};

AnimationItem.prototype.adjustSegment = function (arr, offset) {
  this.playCount = 0;
  if (arr[1] < arr[0]) {
    if (this.frameModifier > 0) {
      if (this.playSpeed < 0) {
        this.setSpeed(-this.playSpeed);
      } else {
        this.setDirection(-1);
      }
    }
    this.totalFrames = arr[0] - arr[1];
    this.timeCompleted = this.totalFrames;
    this.firstFrame = arr[1];
    this.setCurrentRawFrameValue(this.totalFrames - 0.001 - offset);
  } else if (arr[1] > arr[0]) {
    if (this.frameModifier < 0) {
      if (this.playSpeed < 0) {
        this.setSpeed(-this.playSpeed);
      } else {
        this.setDirection(1);
      }
    }
    this.totalFrames = arr[1] - arr[0];
    this.timeCompleted = this.totalFrames;
    this.firstFrame = arr[0];
    this.setCurrentRawFrameValue(0.001 + offset);
  }
  this.trigger('segmentStart');
};
AnimationItem.prototype.setSegment = function (init, end) {
  var pendingFrame = -1;
  if (this.isPaused) {
    if (this.currentRawFrame + this.firstFrame < init) {
      pendingFrame = init;
    } else if (this.currentRawFrame + this.firstFrame > end) {
      pendingFrame = end - init;
    }
  }

  this.firstFrame = init;
  this.totalFrames = end - init;
  this.timeCompleted = this.totalFrames;
  if (pendingFrame !== -1) {
    this.goToAndStop(pendingFrame, true);
  }
};

AnimationItem.prototype.playSegments = function (arr, forceFlag) {
  if (forceFlag) {
    this.segments.length = 0;
  }
  if (typeof arr[0] === 'object') {
    var i;
    var len = arr.length;
    for (i = 0; i < len; i += 1) {
      this.segments.push(arr[i]);
    }
  } else {
    this.segments.push(arr);
  }
  if (this.segments.length && forceFlag) {
    this.adjustSegment(this.segments.shift(), 0);
  }
  if (this.isPaused) {
    this.play();
  }
};

AnimationItem.prototype.resetSegments = function (forceFlag) {
  this.segments.length = 0;
  this.segments.push([this.animationData.ip, this.animationData.op]);
  // this.segments.push([this.animationData.ip*this.frameRate,Math.floor(this.animationData.op - this.animationData.ip+this.animationData.ip*this.frameRate)]);
  if (forceFlag) {
    this.checkSegments(0);
  }
};
AnimationItem.prototype.checkSegments = function (offset) {
  if (this.segments.length) {
    this.adjustSegment(this.segments.shift(), offset);
    return true;
  }
  return false;
};

AnimationItem.prototype.destroy = function (name) {
  if ((name && this.name !== name) || !this.renderer) {
    return;
  }
  this.renderer.destroy();
  this.imagePreloader.destroy();
  this.trigger('destroy');
  this._cbs = null;
  this.onEnterFrame = null;
  this.onLoopComplete = null;
  this.onComplete = null;
  this.onSegmentStart = null;
  this.onDestroy = null;
  this.renderer = null;
  this.renderer = null;
  this.imagePreloader = null;
  this.projectInterface = null;
};

AnimationItem.prototype.setCurrentRawFrameValue = function (value) {
  this.currentRawFrame = value;
  this.gotoFrame();
};

AnimationItem.prototype.setSpeed = function (val) {
  this.playSpeed = val;
  this.updaFrameModifier();
};

AnimationItem.prototype.setDirection = function (val) {
  this.playDirection = val < 0 ? -1 : 1;
  this.updaFrameModifier();
};

AnimationItem.prototype.setVolume = function (val, name) {
  if (name && this.name !== name) {
    return;
  }
  this.audioController.setVolume(val);
};

AnimationItem.prototype.getVolume = function () {
  return this.audioController.getVolume();
};

AnimationItem.prototype.mute = function (name) {
  if (name && this.name !== name) {
    return;
  }
  this.audioController.mute();
};

AnimationItem.prototype.unmute = function (name) {
  if (name && this.name !== name) {
    return;
  }
  this.audioController.unmute();
};

AnimationItem.prototype.updaFrameModifier = function () {
  this.frameModifier = this.frameMult * this.playSpeed * this.playDirection;
  this.audioController.setRate(this.playSpeed * this.playDirection);
};

AnimationItem.prototype.getPath = function () {
  return this.path;
};

AnimationItem.prototype.getAssetsPath = function (assetData) {
  var path = '';
  if (assetData.e) {
    path = assetData.p;
  } else if (this.assetsPath) {
    var imagePath = assetData.p;
    if (imagePath.indexOf('images/') !== -1) {
      imagePath = imagePath.split('/')[1];
    }
    path = this.assetsPath + imagePath;
  } else {
    path = this.path;
    path += assetData.u ? assetData.u : '';
    path += assetData.p;
  }
  return path;
};

AnimationItem.prototype.getAssetData = function (id) {
  var i = 0;
  var len = this.assets.length;
  while (i < len) {
    if (id === this.assets[i].id) {
      return this.assets[i];
    }
    i += 1;
  }
  return null;
};

AnimationItem.prototype.hide = function () {
  this.renderer.hide();
};

AnimationItem.prototype.show = function () {
  this.renderer.show();
};

AnimationItem.prototype.getDuration = function (isFrame) {
  return isFrame ? this.totalFrames : this.totalFrames / this.frameRate;
};

AnimationItem.prototype.trigger = function (name) {
  if (this._cbs && this._cbs[name]) {
    switch (name) {
      case 'enterFrame':
        this.triggerEvent(name, new BMEnterFrameEvent(name, this.currentFrame, this.totalFrames, this.frameModifier));
        break;
      case 'loopComplete':
        this.triggerEvent(name, new BMCompleteLoopEvent(name, this.loop, this.playCount, this.frameMult));
        break;
      case 'complete':
        this.triggerEvent(name, new BMCompleteEvent(name, this.frameMult));
        break;
      case 'segmentStart':
        this.triggerEvent(name, new BMSegmentStartEvent(name, this.firstFrame, this.totalFrames));
        break;
      case 'destroy':
        this.triggerEvent(name, new BMDestroyEvent(name, this));
        break;
      default:
        this.triggerEvent(name);
    }
  }
  if (name === 'enterFrame' && this.onEnterFrame) {
    this.onEnterFrame.call(this, new BMEnterFrameEvent(name, this.currentFrame, this.totalFrames, this.frameMult));
  }
  if (name === 'loopComplete' && this.onLoopComplete) {
    this.onLoopComplete.call(this, new BMCompleteLoopEvent(name, this.loop, this.playCount, this.frameMult));
  }
  if (name === 'complete' && this.onComplete) {
    this.onComplete.call(this, new BMCompleteEvent(name, this.frameMult));
  }
  if (name === 'segmentStart' && this.onSegmentStart) {
    this.onSegmentStart.call(this, new BMSegmentStartEvent(name, this.firstFrame, this.totalFrames));
  }
  if (name === 'destroy' && this.onDestroy) {
    this.onDestroy.call(this, new BMDestroyEvent(name, this));
  }
};

AnimationItem.prototype.triggerRenderFrameError = function (nativeError) {
  var error = new BMRenderFrameErrorEvent(nativeError, this.currentFrame);
  this.triggerEvent('error', error);

  if (this.onError) {
    this.onError.call(this, error);
  }
};

AnimationItem.prototype.triggerConfigError = function (nativeError) {
  var error = new BMConfigErrorEvent(nativeError, this.currentFrame);
  this.triggerEvent('error', error);

  if (this.onError) {
    this.onError.call(this, error);
  }
};

/* global CompExpressionInterface, expressionsPlugin: writable */
/* exported expressionsPlugin */

var Expressions = (function () {
  var ob = {};
  ob.initExpressions = initExpressions;

  function initExpressions(animation) {
    var stackCount = 0;
    var registers = [];

    function pushExpression() {
      stackCount += 1;
    }

    function popExpression() {
      stackCount -= 1;
      if (stackCount === 0) {
        releaseInstances();
      }
    }

    function registerExpressionProperty(expression) {
      if (registers.indexOf(expression) === -1) {
        registers.push(expression);
      }
    }

    function releaseInstances() {
      var i;
      var len = registers.length;
      for (i = 0; i < len; i += 1) {
        registers[i].release();
      }
      registers.length = 0;
    }

    animation.renderer.compInterface = CompExpressionInterface(animation.renderer);
    animation.renderer.globalData.projectInterface.registerComposition(animation.renderer);
    animation.renderer.globalData.pushExpression = pushExpression;
    animation.renderer.globalData.popExpression = popExpression;
    animation.renderer.globalData.registerExpressionProperty = registerExpressionProperty;
  }
  return ob;
}());

expressionsPlugin = Expressions;

/* eslint-disable camelcase, no-unused-vars */
/* global BMMath, BezierFactory, createTypedArray, degToRads, shapePool */

var ExpressionManager = (function () {

  var ob = {};
  var Math = BMMath;

  BezierFactory.getBezierEasing(0.333, 0, 0.833, 0.833, 'easeIn').get;
  BezierFactory.getBezierEasing(0.167, 0.167, 0.667, 1, 'easeOut').get;
  BezierFactory.getBezierEasing(0.33, 0, 0.667, 1, 'easeInOut').get;

  function initiateExpression(elem, data, property) {
    var val = data.x;
    var needsVelocity = /velocity(?![\w\d])/.test(val);
    var _needsRandom = val.indexOf('random') !== -1;
    var elemType = elem.data.ty;
    var transform;
    var content;
    var effect;
    var thisProperty = property;
    thisProperty.valueAtTime = thisProperty.getValueAtTime;
    Object.defineProperty(thisProperty, 'value', {
      get: function () {
        return thisProperty.v;
      },
    });
    elem.comp.frameDuration = 1 / elem.comp.globalData.frameRate;
    elem.comp.displayStartTime = 0;
    elem.data.ip / elem.comp.globalData.frameRate;
    elem.data.op / elem.comp.globalData.frameRate;
    elem.data.sw ? elem.data.sw : 0;
    elem.data.sh ? elem.data.sh : 0;
    elem.data.nm;
    var thisLayer;
    var velocityAtTime;

    var scoped_bm_rt;
    // val = val.replace(/(\\?"|')((http)(s)?(:\/))?\/.*?(\\?"|')/g, "\"\""); // deter potential network calls
    var expression_function = eval('[function _expression_function(){' + val + ';scoped_bm_rt=$bm_rt}]')[0]; // eslint-disable-line no-eval
    property.kf ? data.k.length : 0;

    !this.data || this.data.hd !== true;

    (function wiggle(freq, amp) {
      var iWiggle;
      var j;
      var lenWiggle = this.pv.length ? this.pv.length : 1;
      var addedAmps = createTypedArray('float32', lenWiggle);
      freq = 5;
      var iterations = Math.floor(time * freq);
      iWiggle = 0;
      j = 0;
      while (iWiggle < iterations) {
        // var rnd = BMMath.random();
        for (j = 0; j < lenWiggle; j += 1) {
          addedAmps[j] += -amp + amp * 2 * BMMath.random();
          // addedAmps[j] += -amp + amp*2*rnd;
        }
        iWiggle += 1;
      }
      // var rnd2 = BMMath.random();
      var periods = time * freq;
      var perc = periods - Math.floor(periods);
      var arr = createTypedArray('float32', lenWiggle);
      if (lenWiggle > 1) {
        for (j = 0; j < lenWiggle; j += 1) {
          arr[j] = this.pv[j] + addedAmps[j] + (-amp + amp * 2 * BMMath.random()) * perc;
          // arr[j] = this.pv[j] + addedAmps[j] + (-amp + amp*2*rnd)*perc;
          // arr[i] = this.pv[i] + addedAmp + amp1*perc + amp2*(1-perc);
        }
        return arr;
      }
      return this.pv + addedAmps[0] + (-amp + amp * 2 * BMMath.random()) * perc;
    }).bind(this);

    if (thisProperty.loopIn) {
      thisProperty.loopIn.bind(thisProperty);
    }

    if (thisProperty.loopOut) {
      thisProperty.loopOut.bind(thisProperty);
    }

    if (thisProperty.smooth) {
      thisProperty.smooth.bind(thisProperty);
    }

    if (this.getValueAtTime) {
      this.getValueAtTime.bind(this);
    }

    if (this.getVelocityAtTime) {
      velocityAtTime = this.getVelocityAtTime.bind(this);
    }

    elem.comp.globalData.projectInterface.bind(elem.comp.globalData.projectInterface);

    function seedRandom(seed) {
      BMMath.seedrandom(randSeed + seed);
    }

    var time;
    var value;
    elem.data.ind;
    var hasParent = !!(elem.hierarchy && elem.hierarchy.length);
    var parent;
    var randSeed = Math.floor(Math.random() * 1000000);
    elem.globalData;
    function executeExpression(_value) {
      // globalData.pushExpression();
      value = _value;
      if (_needsRandom) {
        seedRandom(randSeed);
      }
      if (this.frameExpressionId === elem.globalData.frameId && this.propType !== 'textSelector') {
        return value;
      }
      if (this.propType === 'textSelector') ;
      if (!thisLayer) {
        elem.layerInterface.text;
        thisLayer = elem.layerInterface;
        elem.comp.compInterface;
        thisLayer.toWorld.bind(thisLayer);
        thisLayer.fromWorld.bind(thisLayer);
        thisLayer.fromComp.bind(thisLayer);
        thisLayer.toComp.bind(thisLayer);
        thisLayer.mask ? thisLayer.mask.bind(thisLayer) : null;
      }
      if (!transform) {
        transform = elem.layerInterface('ADBE Transform Group');
      }

      if (elemType === 4 && !content) {
        content = thisLayer('ADBE Root Vectors Group');
      }
      if (!effect) {
        effect = thisLayer(4);
      }
      hasParent = !!(elem.hierarchy && elem.hierarchy.length);
      if (hasParent && !parent) {
        parent = elem.hierarchy[0].layerInterface;
      }
      time = this.comp.renderedFrame / this.comp.globalData.frameRate;
      if (needsVelocity) {
        velocityAtTime(time);
      }
      expression_function();
      this.frameExpressionId = elem.globalData.frameId;

      // TODO: Check if it's possible to return on ShapeInterface the .v value
      if (scoped_bm_rt.propType === 'shape') ;
      // globalData.popExpression();
      return scoped_bm_rt;
    }
    return executeExpression;
  }

  ob.initiateExpression = initiateExpression;
  return ob;
}());

/* global ExpressionManager, createTypedArray */
/* exported expressionHelpers */

var expressionHelpers = (function () {
  function searchExpressions(elem, data, prop) {
    if (data.x) {
      prop.k = true;
      prop.x = true;
      prop.initiateExpression = ExpressionManager.initiateExpression;
      prop.effectsSequence.push(prop.initiateExpression(elem, data, prop).bind(prop));
    }
  }

  function getValueAtTime(frameNum) {
    frameNum *= this.elem.globalData.frameRate;
    frameNum -= this.offsetTime;
    if (frameNum !== this._cachingAtTime.lastFrame) {
      this._cachingAtTime.lastIndex = this._cachingAtTime.lastFrame < frameNum ? this._cachingAtTime.lastIndex : 0;
      this._cachingAtTime.value = this.interpolateValue(frameNum, this._cachingAtTime);
      this._cachingAtTime.lastFrame = frameNum;
    }
    return this._cachingAtTime.value;
  }

  function getSpeedAtTime(frameNum) {
    var delta = -0.01;
    var v1 = this.getValueAtTime(frameNum);
    var v2 = this.getValueAtTime(frameNum + delta);
    var speed = 0;
    if (v1.length) {
      var i;
      for (i = 0; i < v1.length; i += 1) {
        speed += Math.pow(v2[i] - v1[i], 2);
      }
      speed = Math.sqrt(speed) * 100;
    } else {
      speed = 0;
    }
    return speed;
  }

  function getVelocityAtTime(frameNum) {
    if (this.vel !== undefined) {
      return this.vel;
    }
    var delta = -0.001;
    // frameNum += this.elem.data.st;
    var v1 = this.getValueAtTime(frameNum);
    var v2 = this.getValueAtTime(frameNum + delta);
    var velocity;
    if (v1.length) {
      velocity = createTypedArray('float32', v1.length);
      var i;
      for (i = 0; i < v1.length; i += 1) {
        // removing frameRate
        // if needed, don't add it here
        // velocity[i] = this.elem.globalData.frameRate*((v2[i] - v1[i])/delta);
        velocity[i] = (v2[i] - v1[i]) / delta;
      }
    } else {
      velocity = (v2 - v1) / delta;
    }
    return velocity;
  }

  function getStaticValueAtTime() {
    return this.pv;
  }

  function setGroupProperty(propertyGroup) {
    this.propertyGroup = propertyGroup;
  }

  return {
    searchExpressions: searchExpressions,
    getSpeedAtTime: getSpeedAtTime,
    getVelocityAtTime: getVelocityAtTime,
    getValueAtTime: getValueAtTime,
    getStaticValueAtTime: getStaticValueAtTime,
    setGroupProperty: setGroupProperty,
  };
}());

/* global createTypedArray, Matrix, TransformPropertyFactory, expressionHelpers, PropertyFactory, expressionHelpers,
initialDefaultFrame, shapePool, ShapePropertyFactory, bez, extendPrototype, ExpressionManager, createSizedArray */

(function addPropertyDecorator() {
  function loopOut(type, duration, durationFlag) {
    if (!this.k || !this.keyframes) {
      return this.pv;
    }
    type = type ? type.toLowerCase() : '';
    var currentFrame = this.comp.renderedFrame;
    var keyframes = this.keyframes;
    var lastKeyFrame = keyframes[keyframes.length - 1].t;
    if (currentFrame <= lastKeyFrame) {
      return this.pv;
    }
    var cycleDuration;
    var firstKeyFrame;
    if (!durationFlag) {
      if (!duration || duration > keyframes.length - 1) {
        duration = keyframes.length - 1;
      }
      firstKeyFrame = keyframes[keyframes.length - 1 - duration].t;
      cycleDuration = lastKeyFrame - firstKeyFrame;
    } else {
      if (!duration) {
        cycleDuration = Math.max(0, lastKeyFrame - this.elem.data.ip);
      } else {
        cycleDuration = Math.abs(lastKeyFrame - this.elem.comp.globalData.frameRate * duration);
      }
      firstKeyFrame = lastKeyFrame - cycleDuration;
    }
    var i;
    var len;
    var ret;
    if (type === 'pingpong') {
      var iterations = Math.floor((currentFrame - firstKeyFrame) / cycleDuration);
      if (iterations % 2 !== 0) {
          return this.getValueAtTime(((cycleDuration - (currentFrame - firstKeyFrame) % cycleDuration + firstKeyFrame)) / this.comp.globalData.frameRate, 0); // eslint-disable-line
      }
    } else if (type === 'offset') {
      var initV = this.getValueAtTime(firstKeyFrame / this.comp.globalData.frameRate, 0);
      var endV = this.getValueAtTime(lastKeyFrame / this.comp.globalData.frameRate, 0);
        var current = this.getValueAtTime(((currentFrame - firstKeyFrame) % cycleDuration + firstKeyFrame) / this.comp.globalData.frameRate, 0); // eslint-disable-line
      var repeats = Math.floor((currentFrame - firstKeyFrame) / cycleDuration);
      if (this.pv.length) {
        ret = new Array(initV.length);
        len = ret.length;
        for (i = 0; i < len; i += 1) {
          ret[i] = (endV[i] - initV[i]) * repeats + current[i];
        }
        return ret;
      }
      return (endV - initV) * repeats + current;
    } else if (type === 'continue') {
      var lastValue = this.getValueAtTime(lastKeyFrame / this.comp.globalData.frameRate, 0);
      var nextLastValue = this.getValueAtTime((lastKeyFrame - 0.001) / this.comp.globalData.frameRate, 0);
      if (this.pv.length) {
        ret = new Array(lastValue.length);
        len = ret.length;
        for (i = 0; i < len; i += 1) {
            ret[i] = lastValue[i] + (lastValue[i] - nextLastValue[i]) * ((currentFrame - lastKeyFrame) / this.comp.globalData.frameRate) / 0.0005; // eslint-disable-line
        }
        return ret;
      }
      return lastValue + (lastValue - nextLastValue) * (((currentFrame - lastKeyFrame)) / 0.001);
    }
      return this.getValueAtTime((((currentFrame - firstKeyFrame) % cycleDuration + firstKeyFrame)) / this.comp.globalData.frameRate, 0); // eslint-disable-line

  }

  function loopIn(type, duration, durationFlag) {
    if (!this.k) {
      return this.pv;
    }
    type = type ? type.toLowerCase() : '';
    var currentFrame = this.comp.renderedFrame;
    var keyframes = this.keyframes;
    var firstKeyFrame = keyframes[0].t;
    if (currentFrame >= firstKeyFrame) {
      return this.pv;
    }
    var cycleDuration;
    var lastKeyFrame;
    if (!durationFlag) {
      if (!duration || duration > keyframes.length - 1) {
        duration = keyframes.length - 1;
      }
      lastKeyFrame = keyframes[duration].t;
      cycleDuration = lastKeyFrame - firstKeyFrame;
    } else {
      if (!duration) {
        cycleDuration = Math.max(0, this.elem.data.op - firstKeyFrame);
      } else {
        cycleDuration = Math.abs(this.elem.comp.globalData.frameRate * duration);
      }
      lastKeyFrame = firstKeyFrame + cycleDuration;
    }
    var i;
    var len;
    var ret;
    if (type === 'pingpong') {
      var iterations = Math.floor((firstKeyFrame - currentFrame) / cycleDuration);
      if (iterations % 2 === 0) {
          return this.getValueAtTime((((firstKeyFrame - currentFrame) % cycleDuration + firstKeyFrame)) / this.comp.globalData.frameRate, 0); // eslint-disable-line
      }
    } else if (type === 'offset') {
      var initV = this.getValueAtTime(firstKeyFrame / this.comp.globalData.frameRate, 0);
      var endV = this.getValueAtTime(lastKeyFrame / this.comp.globalData.frameRate, 0);
      var current = this.getValueAtTime((cycleDuration - ((firstKeyFrame - currentFrame) % cycleDuration) + firstKeyFrame) / this.comp.globalData.frameRate, 0);
      var repeats = Math.floor((firstKeyFrame - currentFrame) / cycleDuration) + 1;
      if (this.pv.length) {
        ret = new Array(initV.length);
        len = ret.length;
        for (i = 0; i < len; i += 1) {
          ret[i] = current[i] - (endV[i] - initV[i]) * repeats;
        }
        return ret;
      }
      return current - (endV - initV) * repeats;
    } else if (type === 'continue') {
      var firstValue = this.getValueAtTime(firstKeyFrame / this.comp.globalData.frameRate, 0);
      var nextFirstValue = this.getValueAtTime((firstKeyFrame + 0.001) / this.comp.globalData.frameRate, 0);
      if (this.pv.length) {
        ret = new Array(firstValue.length);
        len = ret.length;
        for (i = 0; i < len; i += 1) {
          ret[i] = firstValue[i] + ((firstValue[i] - nextFirstValue[i]) * (firstKeyFrame - currentFrame)) / 0.001;
        }
        return ret;
      }
      return firstValue + ((firstValue - nextFirstValue) * (firstKeyFrame - currentFrame)) / 0.001;
    }
      return this.getValueAtTime(((cycleDuration - ((firstKeyFrame - currentFrame) % cycleDuration + firstKeyFrame))) / this.comp.globalData.frameRate, 0); // eslint-disable-line

  }

  function smooth(width, samples) {
    if (!this.k) {
      return this.pv;
    }
    width = (width || 0.4) * 0.5;
    samples = Math.floor(samples || 5);
    if (samples <= 1) {
      return this.pv;
    }
    var currentTime = this.comp.renderedFrame / this.comp.globalData.frameRate;
    var initFrame = currentTime - width;
    var endFrame = currentTime + width;
    var sampleFrequency = samples > 1 ? (endFrame - initFrame) / (samples - 1) : 1;
    var i = 0;
    var j = 0;
    var value;
    if (this.pv.length) {
      value = createTypedArray('float32', this.pv.length);
    } else {
      value = 0;
    }
    var sampleValue;
    while (i < samples) {
      sampleValue = this.getValueAtTime(initFrame + i * sampleFrequency);
      if (this.pv.length) {
        for (j = 0; j < this.pv.length; j += 1) {
          value[j] += sampleValue[j];
        }
      } else {
        value += sampleValue;
      }
      i += 1;
    }
    if (this.pv.length) {
      for (j = 0; j < this.pv.length; j += 1) {
        value[j] /= samples;
      }
    } else {
      value /= samples;
    }
    return value;
  }

  function getTransformValueAtTime(time) {
    if (!this._transformCachingAtTime) {
      this._transformCachingAtTime = {
        v: new Matrix(),
      };
    }
    /// /
    var matrix = this._transformCachingAtTime.v;
    matrix.cloneFromProps(this.pre.props);
    if (this.appliedTransformations < 1) {
      var anchor = this.a.getValueAtTime(time);
      matrix.translate(
        -anchor[0] * this.a.mult,
        -anchor[1] * this.a.mult,
        anchor[2] * this.a.mult
      );
    }
    if (this.appliedTransformations < 2) {
      var scale = this.s.getValueAtTime(time);
      matrix.scale(
        scale[0] * this.s.mult,
        scale[1] * this.s.mult,
        scale[2] * this.s.mult
      );
    }
    if (this.sk && this.appliedTransformations < 3) {
      var skew = this.sk.getValueAtTime(time);
      var skewAxis = this.sa.getValueAtTime(time);
      matrix.skewFromAxis(-skew * this.sk.mult, skewAxis * this.sa.mult);
    }
    if (this.r && this.appliedTransformations < 4) {
      var rotation = this.r.getValueAtTime(time);
      matrix.rotate(-rotation * this.r.mult);
    } else if (!this.r && this.appliedTransformations < 4) {
      var rotationZ = this.rz.getValueAtTime(time);
      var rotationY = this.ry.getValueAtTime(time);
      var rotationX = this.rx.getValueAtTime(time);
      var orientation = this.or.getValueAtTime(time);
      matrix.rotateZ(-rotationZ * this.rz.mult)
        .rotateY(rotationY * this.ry.mult)
        .rotateX(rotationX * this.rx.mult)
        .rotateZ(-orientation[2] * this.or.mult)
        .rotateY(orientation[1] * this.or.mult)
        .rotateX(orientation[0] * this.or.mult);
    }
    if (this.data.p && this.data.p.s) {
      var positionX = this.px.getValueAtTime(time);
      var positionY = this.py.getValueAtTime(time);
      if (this.data.p.z) {
        var positionZ = this.pz.getValueAtTime(time);
        matrix.translate(
          positionX * this.px.mult,
          positionY * this.py.mult,
          -positionZ * this.pz.mult
        );
      } else {
        matrix.translate(positionX * this.px.mult, positionY * this.py.mult, 0);
      }
    } else {
      var position = this.p.getValueAtTime(time);
      matrix.translate(
        position[0] * this.p.mult,
        position[1] * this.p.mult,
        -position[2] * this.p.mult
      );
    }
    return matrix;
    /// /
  }

  function getTransformStaticValueAtTime() {
    return this.v.clone(new Matrix());
  }

  var getTransformProperty = TransformPropertyFactory.getTransformProperty;
  TransformPropertyFactory.getTransformProperty = function (elem, data, container) {
    var prop = getTransformProperty(elem, data, container);
    if (prop.dynamicProperties.length) {
      prop.getValueAtTime = getTransformValueAtTime.bind(prop);
    } else {
      prop.getValueAtTime = getTransformStaticValueAtTime.bind(prop);
    }
    prop.setGroupProperty = expressionHelpers.setGroupProperty;
    return prop;
  };

  var propertyGetProp = PropertyFactory.getProp;
  PropertyFactory.getProp = function (elem, data, type, mult, container) {
    var prop = propertyGetProp(elem, data, type, mult, container);
    // prop.getVelocityAtTime = getVelocityAtTime;
    // prop.loopOut = loopOut;
    // prop.loopIn = loopIn;
    if (prop.kf) {
      prop.getValueAtTime = expressionHelpers.getValueAtTime.bind(prop);
    } else {
      prop.getValueAtTime = expressionHelpers.getStaticValueAtTime.bind(prop);
    }
    prop.setGroupProperty = expressionHelpers.setGroupProperty;
    prop.loopOut = loopOut;
    prop.loopIn = loopIn;
    prop.smooth = smooth;
    prop.getVelocityAtTime = expressionHelpers.getVelocityAtTime.bind(prop);
    prop.getSpeedAtTime = expressionHelpers.getSpeedAtTime.bind(prop);
    prop.numKeys = data.a === 1 ? data.k.length : 0;
    prop.propertyIndex = data.ix;
    var value = 0;
    if (type !== 0) {
      value = createTypedArray('float32', data.a === 1 ? data.k[0].s.length : data.k.length);
    }
    prop._cachingAtTime = {
      lastFrame: initialDefaultFrame,
      lastIndex: 0,
      value: value,
    };
    expressionHelpers.searchExpressions(elem, data, prop);
    if (prop.k) {
      container.addDynamicProperty(prop);
    }

    return prop;
  };

  function getShapeValueAtTime(frameNum) {
    // For now this caching object is created only when needed instead of creating it when the shape is initialized.
    if (!this._cachingAtTime) {
      this._cachingAtTime = {
        shapeValue: shapePool.clone(this.pv),
        lastIndex: 0,
        lastTime: initialDefaultFrame,
      };
    }

    frameNum *= this.elem.globalData.frameRate;
    frameNum -= this.offsetTime;
    if (frameNum !== this._cachingAtTime.lastTime) {
      this._cachingAtTime.lastIndex = this._cachingAtTime.lastTime < frameNum ? this._caching.lastIndex : 0;
      this._cachingAtTime.lastTime = frameNum;
      this.interpolateShape(frameNum, this._cachingAtTime.shapeValue, this._cachingAtTime);
    }
    return this._cachingAtTime.shapeValue;
  }

  var ShapePropertyConstructorFunction = ShapePropertyFactory.getConstructorFunction();
  var KeyframedShapePropertyConstructorFunction = ShapePropertyFactory.getKeyframedConstructorFunction();

  function ShapeExpressions() {}
  ShapeExpressions.prototype = {
    vertices: function (prop, time) {
      if (this.k) {
        this.getValue();
      }
      var shapePath = this.v;
      if (time !== undefined) {
        shapePath = this.getValueAtTime(time, 0);
      }
      var i;
      var len = shapePath._length;
      var vertices = shapePath[prop];
      var points = shapePath.v;
      var arr = createSizedArray(len);
      for (i = 0; i < len; i += 1) {
        if (prop === 'i' || prop === 'o') {
          arr[i] = [vertices[i][0] - points[i][0], vertices[i][1] - points[i][1]];
        } else {
          arr[i] = [vertices[i][0], vertices[i][1]];
        }
      }
      return arr;
    },
    points: function (time) {
      return this.vertices('v', time);
    },
    inTangents: function (time) {
      return this.vertices('i', time);
    },
    outTangents: function (time) {
      return this.vertices('o', time);
    },
    isClosed: function () {
      return this.v.c;
    },
    pointOnPath: function (perc, time) {
      var shapePath = this.v;
      if (time !== undefined) {
        shapePath = this.getValueAtTime(time, 0);
      }
      if (!this._segmentsLength) {
        this._segmentsLength = bez.getSegmentsLength(shapePath);
      }

      var segmentsLength = this._segmentsLength;
      var lengths = segmentsLength.lengths;
      var lengthPos = segmentsLength.totalLength * perc;
      var i = 0;
      var len = lengths.length;
      var accumulatedLength = 0;
      var pt;
      while (i < len) {
        if (accumulatedLength + lengths[i].addedLength > lengthPos) {
          var initIndex = i;
          var endIndex = (shapePath.c && i === len - 1) ? 0 : i + 1;
          var segmentPerc = (lengthPos - accumulatedLength) / lengths[i].addedLength;
          pt = bez.getPointInSegment(shapePath.v[initIndex], shapePath.v[endIndex], shapePath.o[initIndex], shapePath.i[endIndex], segmentPerc, lengths[i]);
          break;
        } else {
          accumulatedLength += lengths[i].addedLength;
        }
        i += 1;
      }
      if (!pt) {
        pt = shapePath.c ? [shapePath.v[0][0], shapePath.v[0][1]] : [shapePath.v[shapePath._length - 1][0], shapePath.v[shapePath._length - 1][1]];
      }
      return pt;
    },
    vectorOnPath: function (perc, time, vectorType) {
      // perc doesn't use triple equality because it can be a Number object as well as a primitive.
      if (perc == 1) { // eslint-disable-line eqeqeq
        perc = this.v.c;
      } else if (perc == 0) { // eslint-disable-line eqeqeq
        perc = 0.999;
      }
      var pt1 = this.pointOnPath(perc, time);
      var pt2 = this.pointOnPath(perc + 0.001, time);
      var xLength = pt2[0] - pt1[0];
      var yLength = pt2[1] - pt1[1];
      var magnitude = Math.sqrt(Math.pow(xLength, 2) + Math.pow(yLength, 2));
      if (magnitude === 0) {
        return [0, 0];
      }
      var unitVector = vectorType === 'tangent' ? [xLength / magnitude, yLength / magnitude] : [-yLength / magnitude, xLength / magnitude];
      return unitVector;
    },
    tangentOnPath: function (perc, time) {
      return this.vectorOnPath(perc, time, 'tangent');
    },
    normalOnPath: function (perc, time) {
      return this.vectorOnPath(perc, time, 'normal');
    },
    setGroupProperty: expressionHelpers.setGroupProperty,
    getValueAtTime: expressionHelpers.getStaticValueAtTime,
  };
  extendPrototype([ShapeExpressions], ShapePropertyConstructorFunction);
  extendPrototype([ShapeExpressions], KeyframedShapePropertyConstructorFunction);
  KeyframedShapePropertyConstructorFunction.prototype.getValueAtTime = getShapeValueAtTime;
  KeyframedShapePropertyConstructorFunction.prototype.initiateExpression = ExpressionManager.initiateExpression;

  var propertyGetShapeProp = ShapePropertyFactory.getShapeProp;
  ShapePropertyFactory.getShapeProp = function (elem, data, type, arr, trims) {
    var prop = propertyGetShapeProp(elem, data, type, arr, trims);
    prop.propertyIndex = data.ix;
    prop.lock = false;
    if (type === 3) {
      expressionHelpers.searchExpressions(elem, data.pt, prop);
    } else if (type === 4) {
      expressionHelpers.searchExpressions(elem, data.ks, prop);
    }
    if (prop.k) {
      elem.addDynamicProperty(prop);
    }
    return prop;
  };
}());

/* global ExpressionManager, TextProperty */

(function addDecorator() {
  function searchExpressions() {
    if (this.data.d.x) {
      this.calculateExpression = ExpressionManager.initiateExpression.bind(this)(this.elem, this.data.d, this);
      this.addEffect(this.getExpressionValue.bind(this));
      return true;
    }
    return null;
  }

  TextProperty.prototype.getExpressionValue = function (currentValue, text) {
    var newValue = this.calculateExpression(text);
    if (currentValue.t !== newValue) {
      var newData = {};
      this.copyData(newData, currentValue);
      newData.t = newValue.toString();
      newData.__complete = false;
      return newData;
    }
    return currentValue;
  };

  TextProperty.prototype.searchProperty = function () {
    var isKeyframed = this.searchKeyframes();
    var hasExpressions = this.searchExpressions();
    this.kf = isKeyframed || hasExpressions;
    return this.kf;
  };

  TextProperty.prototype.searchExpressions = searchExpressions;
}());

/* global propertyGroupFactory, PropertyInterface */
/* exported ShapePathInterface */

var ShapePathInterface = (

  function () {
    return function pathInterfaceFactory(shape, view, propertyGroup) {
      var prop = view.sh;

      function interfaceFunction(val) {
        if (val === 'Shape' || val === 'shape' || val === 'Path' || val === 'path' || val === 'ADBE Vector Shape' || val === 2) {
          return interfaceFunction.path;
        }
        return null;
      }

      var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
      prop.setGroupProperty(PropertyInterface('Path', _propertyGroup));
      Object.defineProperties(interfaceFunction, {
        path: {
          get: function () {
            if (prop.k) {
              prop.getValue();
            }
            return prop;
          },
        },
        shape: {
          get: function () {
            if (prop.k) {
              prop.getValue();
            }
            return prop;
          },
        },
        _name: { value: shape.nm },
        ix: { value: shape.ix },
        propertyIndex: { value: shape.ix },
        mn: { value: shape.mn },
        propertyGroup: { value: propertyGroup },
      });
      return interfaceFunction;
    };
  }()
);

/* exported propertyGroupFactory */

var propertyGroupFactory = (function () {
  return function (interfaceFunction, parentPropertyGroup) {
    return function (val) {
      val = val === undefined ? 1 : val;
      if (val <= 0) {
        return interfaceFunction;
      }
      return parentPropertyGroup(val - 1);
    };
  };
}());

/* exported PropertyInterface */

var PropertyInterface = (function () {
  return function (propertyName, propertyGroup) {
    var interfaceFunction = {
      _name: propertyName,
    };

    function _propertyGroup(val) {
      val = val === undefined ? 1 : val;
      if (val <= 0) {
        return interfaceFunction;
      }
      return propertyGroup(val - 1);
    }

    return _propertyGroup;
  };
}());

/* global ExpressionPropertyInterface, PropertyInterface, propertyGroupFactory, ShapePathInterface */
/* exported ShapeExpressionInterface */

var ShapeExpressionInterface = (function () {
  function iterateElements(shapes, view, propertyGroup) {
    var arr = [];
    var i;
    var len = shapes ? shapes.length : 0;
    for (i = 0; i < len; i += 1) {
      if (shapes[i].ty === 'gr') {
        arr.push(groupInterfaceFactory(shapes[i], view[i], propertyGroup));
      } else if (shapes[i].ty === 'fl') {
        arr.push(fillInterfaceFactory(shapes[i], view[i], propertyGroup));
      } else if (shapes[i].ty === 'st') {
        arr.push(strokeInterfaceFactory(shapes[i], view[i], propertyGroup));
      } else if (shapes[i].ty === 'tm') {
        arr.push(trimInterfaceFactory(shapes[i], view[i], propertyGroup));
      } else if (shapes[i].ty === 'tr') ; else if (shapes[i].ty === 'el') {
        arr.push(ellipseInterfaceFactory(shapes[i], view[i], propertyGroup));
      } else if (shapes[i].ty === 'sr') {
        arr.push(starInterfaceFactory(shapes[i], view[i], propertyGroup));
      } else if (shapes[i].ty === 'sh') {
        arr.push(ShapePathInterface(shapes[i], view[i], propertyGroup));
      } else if (shapes[i].ty === 'rc') {
        arr.push(rectInterfaceFactory(shapes[i], view[i], propertyGroup));
      } else if (shapes[i].ty === 'rd') {
        arr.push(roundedInterfaceFactory(shapes[i], view[i], propertyGroup));
      } else if (shapes[i].ty === 'rp') {
        arr.push(repeaterInterfaceFactory(shapes[i], view[i], propertyGroup));
      } else if (shapes[i].ty === 'gf') {
        arr.push(gradientFillInterfaceFactory(shapes[i], view[i], propertyGroup));
      } else {
        arr.push(defaultInterfaceFactory(shapes[i], view[i]));
      }
    }
    return arr;
  }

  function contentsInterfaceFactory(shape, view, propertyGroup) {
    var interfaces;
    var interfaceFunction = function _interfaceFunction(value) {
      var i = 0;
      var len = interfaces.length;
      while (i < len) {
        if (interfaces[i]._name === value || interfaces[i].mn === value || interfaces[i].propertyIndex === value || interfaces[i].ix === value || interfaces[i].ind === value) {
          return interfaces[i];
        }
        i += 1;
      }
      if (typeof value === 'number') {
        return interfaces[value - 1];
      }
      return null;
    };

    interfaceFunction.propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
    interfaces = iterateElements(shape.it, view.it, interfaceFunction.propertyGroup);
    interfaceFunction.numProperties = interfaces.length;
    var transformInterface = transformInterfaceFactory(shape.it[shape.it.length - 1], view.it[view.it.length - 1], interfaceFunction.propertyGroup);
    interfaceFunction.transform = transformInterface;
    interfaceFunction.propertyIndex = shape.cix;
    interfaceFunction._name = shape.nm;

    return interfaceFunction;
  }

  function groupInterfaceFactory(shape, view, propertyGroup) {
    var interfaceFunction = function _interfaceFunction(value) {
      switch (value) {
        case 'ADBE Vectors Group':
        case 'Contents':
        case 2:
          return interfaceFunction.content;
          // Not necessary for now. Keeping them here in case a new case appears
          // case 'ADBE Vector Transform Group':
          // case 3:
        default:
          return interfaceFunction.transform;
      }
    };
    interfaceFunction.propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
    var content = contentsInterfaceFactory(shape, view, interfaceFunction.propertyGroup);
    var transformInterface = transformInterfaceFactory(shape.it[shape.it.length - 1], view.it[view.it.length - 1], interfaceFunction.propertyGroup);
    interfaceFunction.content = content;
    interfaceFunction.transform = transformInterface;
    Object.defineProperty(interfaceFunction, '_name', {
      get: function () {
        return shape.nm;
      },
    });
    // interfaceFunction.content = interfaceFunction;
    interfaceFunction.numProperties = shape.np;
    interfaceFunction.propertyIndex = shape.ix;
    interfaceFunction.nm = shape.nm;
    interfaceFunction.mn = shape.mn;
    return interfaceFunction;
  }

  function fillInterfaceFactory(shape, view, propertyGroup) {
    function interfaceFunction(val) {
      if (val === 'Color' || val === 'color') {
        return interfaceFunction.color;
      } if (val === 'Opacity' || val === 'opacity') {
        return interfaceFunction.opacity;
      }
      return null;
    }
    Object.defineProperties(interfaceFunction, {
      color: {
        get: ExpressionPropertyInterface(view.c),
      },
      opacity: {
        get: ExpressionPropertyInterface(view.o),
      },
      _name: { value: shape.nm },
      mn: { value: shape.mn },
    });

    view.c.setGroupProperty(PropertyInterface('Color', propertyGroup));
    view.o.setGroupProperty(PropertyInterface('Opacity', propertyGroup));
    return interfaceFunction;
  }

  function gradientFillInterfaceFactory(shape, view, propertyGroup) {
    function interfaceFunction(val) {
      if (val === 'Start Point' || val === 'start point') {
        return interfaceFunction.startPoint;
      }
      if (val === 'End Point' || val === 'end point') {
        return interfaceFunction.endPoint;
      }
      if (val === 'Opacity' || val === 'opacity') {
        return interfaceFunction.opacity;
      }
      return null;
    }
    Object.defineProperties(interfaceFunction, {
      startPoint: {
        get: ExpressionPropertyInterface(view.s),
      },
      endPoint: {
        get: ExpressionPropertyInterface(view.e),
      },
      opacity: {
        get: ExpressionPropertyInterface(view.o),
      },
      type: {
        get: function () {
          return 'a';
        },
      },
      _name: { value: shape.nm },
      mn: { value: shape.mn },
    });

    view.s.setGroupProperty(PropertyInterface('Start Point', propertyGroup));
    view.e.setGroupProperty(PropertyInterface('End Point', propertyGroup));
    view.o.setGroupProperty(PropertyInterface('Opacity', propertyGroup));
    return interfaceFunction;
  }
  function defaultInterfaceFactory() {
    function interfaceFunction() {
      return null;
    }
    return interfaceFunction;
  }

  function strokeInterfaceFactory(shape, view, propertyGroup) {
    var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
    var _dashPropertyGroup = propertyGroupFactory(dashOb, _propertyGroup);
    function addPropertyToDashOb(i) {
      Object.defineProperty(dashOb, shape.d[i].nm, {
        get: ExpressionPropertyInterface(view.d.dataProps[i].p),
      });
    }
    var i;
    var len = shape.d ? shape.d.length : 0;
    var dashOb = {};
    for (i = 0; i < len; i += 1) {
      addPropertyToDashOb(i);
      view.d.dataProps[i].p.setGroupProperty(_dashPropertyGroup);
    }

    function interfaceFunction(val) {
      if (val === 'Color' || val === 'color') {
        return interfaceFunction.color;
      } if (val === 'Opacity' || val === 'opacity') {
        return interfaceFunction.opacity;
      } if (val === 'Stroke Width' || val === 'stroke width') {
        return interfaceFunction.strokeWidth;
      }
      return null;
    }
    Object.defineProperties(interfaceFunction, {
      color: {
        get: ExpressionPropertyInterface(view.c),
      },
      opacity: {
        get: ExpressionPropertyInterface(view.o),
      },
      strokeWidth: {
        get: ExpressionPropertyInterface(view.w),
      },
      dash: {
        get: function () {
          return dashOb;
        },
      },
      _name: { value: shape.nm },
      mn: { value: shape.mn },
    });

    view.c.setGroupProperty(PropertyInterface('Color', _propertyGroup));
    view.o.setGroupProperty(PropertyInterface('Opacity', _propertyGroup));
    view.w.setGroupProperty(PropertyInterface('Stroke Width', _propertyGroup));
    return interfaceFunction;
  }

  function trimInterfaceFactory(shape, view, propertyGroup) {
    function interfaceFunction(val) {
      if (val === shape.e.ix || val === 'End' || val === 'end') {
        return interfaceFunction.end;
      }
      if (val === shape.s.ix) {
        return interfaceFunction.start;
      }
      if (val === shape.o.ix) {
        return interfaceFunction.offset;
      }
      return null;
    }

    var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
    interfaceFunction.propertyIndex = shape.ix;

    view.s.setGroupProperty(PropertyInterface('Start', _propertyGroup));
    view.e.setGroupProperty(PropertyInterface('End', _propertyGroup));
    view.o.setGroupProperty(PropertyInterface('Offset', _propertyGroup));
    interfaceFunction.propertyIndex = shape.ix;
    interfaceFunction.propertyGroup = propertyGroup;

    Object.defineProperties(interfaceFunction, {
      start: {
        get: ExpressionPropertyInterface(view.s),
      },
      end: {
        get: ExpressionPropertyInterface(view.e),
      },
      offset: {
        get: ExpressionPropertyInterface(view.o),
      },
      _name: { value: shape.nm },
    });
    interfaceFunction.mn = shape.mn;
    return interfaceFunction;
  }

  function transformInterfaceFactory(shape, view, propertyGroup) {
    function interfaceFunction(value) {
      if (shape.a.ix === value || value === 'Anchor Point') {
        return interfaceFunction.anchorPoint;
      }
      if (shape.o.ix === value || value === 'Opacity') {
        return interfaceFunction.opacity;
      }
      if (shape.p.ix === value || value === 'Position') {
        return interfaceFunction.position;
      }
      if (shape.r.ix === value || value === 'Rotation' || value === 'ADBE Vector Rotation') {
        return interfaceFunction.rotation;
      }
      if (shape.s.ix === value || value === 'Scale') {
        return interfaceFunction.scale;
      }
      if ((shape.sk && shape.sk.ix === value) || value === 'Skew') {
        return interfaceFunction.skew;
      }
      if ((shape.sa && shape.sa.ix === value) || value === 'Skew Axis') {
        return interfaceFunction.skewAxis;
      }
      return null;
    }
    var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
    view.transform.mProps.o.setGroupProperty(PropertyInterface('Opacity', _propertyGroup));
    view.transform.mProps.p.setGroupProperty(PropertyInterface('Position', _propertyGroup));
    view.transform.mProps.a.setGroupProperty(PropertyInterface('Anchor Point', _propertyGroup));
    view.transform.mProps.s.setGroupProperty(PropertyInterface('Scale', _propertyGroup));
    view.transform.mProps.r.setGroupProperty(PropertyInterface('Rotation', _propertyGroup));
    if (view.transform.mProps.sk) {
      view.transform.mProps.sk.setGroupProperty(PropertyInterface('Skew', _propertyGroup));
      view.transform.mProps.sa.setGroupProperty(PropertyInterface('Skew Angle', _propertyGroup));
    }
    view.transform.op.setGroupProperty(PropertyInterface('Opacity', _propertyGroup));
    Object.defineProperties(interfaceFunction, {
      opacity: {
        get: ExpressionPropertyInterface(view.transform.mProps.o),
      },
      position: {
        get: ExpressionPropertyInterface(view.transform.mProps.p),
      },
      anchorPoint: {
        get: ExpressionPropertyInterface(view.transform.mProps.a),
      },
      scale: {
        get: ExpressionPropertyInterface(view.transform.mProps.s),
      },
      rotation: {
        get: ExpressionPropertyInterface(view.transform.mProps.r),
      },
      skew: {
        get: ExpressionPropertyInterface(view.transform.mProps.sk),
      },
      skewAxis: {
        get: ExpressionPropertyInterface(view.transform.mProps.sa),
      },
      _name: { value: shape.nm },
    });
    interfaceFunction.ty = 'tr';
    interfaceFunction.mn = shape.mn;
    interfaceFunction.propertyGroup = propertyGroup;
    return interfaceFunction;
  }

  function ellipseInterfaceFactory(shape, view, propertyGroup) {
    function interfaceFunction(value) {
      if (shape.p.ix === value) {
        return interfaceFunction.position;
      }
      if (shape.s.ix === value) {
        return interfaceFunction.size;
      }
      return null;
    }
    var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
    interfaceFunction.propertyIndex = shape.ix;
    var prop = view.sh.ty === 'tm' ? view.sh.prop : view.sh;
    prop.s.setGroupProperty(PropertyInterface('Size', _propertyGroup));
    prop.p.setGroupProperty(PropertyInterface('Position', _propertyGroup));

    Object.defineProperties(interfaceFunction, {
      size: {
        get: ExpressionPropertyInterface(prop.s),
      },
      position: {
        get: ExpressionPropertyInterface(prop.p),
      },
      _name: { value: shape.nm },
    });
    interfaceFunction.mn = shape.mn;
    return interfaceFunction;
  }

  function starInterfaceFactory(shape, view, propertyGroup) {
    function interfaceFunction(value) {
      if (shape.p.ix === value) {
        return interfaceFunction.position;
      }
      if (shape.r.ix === value) {
        return interfaceFunction.rotation;
      }
      if (shape.pt.ix === value) {
        return interfaceFunction.points;
      }
      if (shape.or.ix === value || value === 'ADBE Vector Star Outer Radius') {
        return interfaceFunction.outerRadius;
      }
      if (shape.os.ix === value) {
        return interfaceFunction.outerRoundness;
      }
      if (shape.ir && (shape.ir.ix === value || value === 'ADBE Vector Star Inner Radius')) {
        return interfaceFunction.innerRadius;
      }
      if (shape.is && shape.is.ix === value) {
        return interfaceFunction.innerRoundness;
      }
      return null;
    }

    var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
    var prop = view.sh.ty === 'tm' ? view.sh.prop : view.sh;
    interfaceFunction.propertyIndex = shape.ix;
    prop.or.setGroupProperty(PropertyInterface('Outer Radius', _propertyGroup));
    prop.os.setGroupProperty(PropertyInterface('Outer Roundness', _propertyGroup));
    prop.pt.setGroupProperty(PropertyInterface('Points', _propertyGroup));
    prop.p.setGroupProperty(PropertyInterface('Position', _propertyGroup));
    prop.r.setGroupProperty(PropertyInterface('Rotation', _propertyGroup));
    if (shape.ir) {
      prop.ir.setGroupProperty(PropertyInterface('Inner Radius', _propertyGroup));
      prop.is.setGroupProperty(PropertyInterface('Inner Roundness', _propertyGroup));
    }

    Object.defineProperties(interfaceFunction, {
      position: {
        get: ExpressionPropertyInterface(prop.p),
      },
      rotation: {
        get: ExpressionPropertyInterface(prop.r),
      },
      points: {
        get: ExpressionPropertyInterface(prop.pt),
      },
      outerRadius: {
        get: ExpressionPropertyInterface(prop.or),
      },
      outerRoundness: {
        get: ExpressionPropertyInterface(prop.os),
      },
      innerRadius: {
        get: ExpressionPropertyInterface(prop.ir),
      },
      innerRoundness: {
        get: ExpressionPropertyInterface(prop.is),
      },
      _name: { value: shape.nm },
    });
    interfaceFunction.mn = shape.mn;
    return interfaceFunction;
  }

  function rectInterfaceFactory(shape, view, propertyGroup) {
    function interfaceFunction(value) {
      if (shape.p.ix === value) {
        return interfaceFunction.position;
      }
      if (shape.r.ix === value) {
        return interfaceFunction.roundness;
      }
      if (shape.s.ix === value || value === 'Size' || value === 'ADBE Vector Rect Size') {
        return interfaceFunction.size;
      }
      return null;
    }
    var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);

    var prop = view.sh.ty === 'tm' ? view.sh.prop : view.sh;
    interfaceFunction.propertyIndex = shape.ix;
    prop.p.setGroupProperty(PropertyInterface('Position', _propertyGroup));
    prop.s.setGroupProperty(PropertyInterface('Size', _propertyGroup));
    prop.r.setGroupProperty(PropertyInterface('Rotation', _propertyGroup));

    Object.defineProperties(interfaceFunction, {
      position: {
        get: ExpressionPropertyInterface(prop.p),
      },
      roundness: {
        get: ExpressionPropertyInterface(prop.r),
      },
      size: {
        get: ExpressionPropertyInterface(prop.s),
      },
      _name: { value: shape.nm },
    });
    interfaceFunction.mn = shape.mn;
    return interfaceFunction;
  }

  function roundedInterfaceFactory(shape, view, propertyGroup) {
    function interfaceFunction(value) {
      if (shape.r.ix === value || value === 'Round Corners 1') {
        return interfaceFunction.radius;
      }
      return null;
    }

    var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
    var prop = view;
    interfaceFunction.propertyIndex = shape.ix;
    prop.rd.setGroupProperty(PropertyInterface('Radius', _propertyGroup));

    Object.defineProperties(interfaceFunction, {
      radius: {
        get: ExpressionPropertyInterface(prop.rd),
      },
      _name: { value: shape.nm },
    });
    interfaceFunction.mn = shape.mn;
    return interfaceFunction;
  }

  function repeaterInterfaceFactory(shape, view, propertyGroup) {
    function interfaceFunction(value) {
      if (shape.c.ix === value || value === 'Copies') {
        return interfaceFunction.copies;
      } if (shape.o.ix === value || value === 'Offset') {
        return interfaceFunction.offset;
      }
      return null;
    }

    var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
    var prop = view;
    interfaceFunction.propertyIndex = shape.ix;
    prop.c.setGroupProperty(PropertyInterface('Copies', _propertyGroup));
    prop.o.setGroupProperty(PropertyInterface('Offset', _propertyGroup));
    Object.defineProperties(interfaceFunction, {
      copies: {
        get: ExpressionPropertyInterface(prop.c),
      },
      offset: {
        get: ExpressionPropertyInterface(prop.o),
      },
      _name: { value: shape.nm },
    });
    interfaceFunction.mn = shape.mn;
    return interfaceFunction;
  }

  return function (shapes, view, propertyGroup) {
    var interfaces;
    function _interfaceFunction(value) {
      if (typeof value === 'number') {
        value = value === undefined ? 1 : value;
        if (value === 0) {
          return propertyGroup;
        }
        return interfaces[value - 1];
      }
      var i = 0;
      var len = interfaces.length;
      while (i < len) {
        if (interfaces[i]._name === value) {
          return interfaces[i];
        }
        i += 1;
      }
      return null;
    }
    function parentGroupWrapper() {
      return propertyGroup;
    }
    _interfaceFunction.propertyGroup = propertyGroupFactory(_interfaceFunction, parentGroupWrapper);
    interfaces = iterateElements(shapes, view, _interfaceFunction.propertyGroup);
    _interfaceFunction.numProperties = interfaces.length;
    _interfaceFunction._name = 'Contents';
    return _interfaceFunction;
  };
}());

/* exported TextExpressionInterface */

var TextExpressionInterface = (function () {
  return function (elem) {
    var _prevValue;
    var _sourceText;
    function _thisLayerFunction(name) {
      switch (name) {
        case 'ADBE Text Document':
          return _thisLayerFunction.sourceText;
        default:
          return null;
      }
    }
    Object.defineProperty(_thisLayerFunction, 'sourceText', {
      get: function () {
        elem.textProperty.getValue();
        var stringValue = elem.textProperty.currentData.t;
        if (stringValue !== _prevValue) {
          elem.textProperty.currentData.t = _prevValue;
          _sourceText = new String(stringValue); // eslint-disable-line no-new-wrappers
          // If stringValue is an empty string, eval returns undefined, so it has to be returned as a String primitive
          _sourceText.value = stringValue || new String(stringValue); // eslint-disable-line no-new-wrappers
        }
        return _sourceText;
      },
    });
    return _thisLayerFunction;
  };
}());

/* global Matrix, MaskManagerInterface, TransformExpressionInterface, getDescriptor */
/* exported LayerExpressionInterface */

var LayerExpressionInterface = (function () {
  function getMatrix(time) {
    var toWorldMat = new Matrix();
    if (time !== undefined) {
      var propMatrix = this._elem.finalTransform.mProp.getValueAtTime(time);
      propMatrix.clone(toWorldMat);
    } else {
      var transformMat = this._elem.finalTransform.mProp;
      transformMat.applyToMatrix(toWorldMat);
    }
    return toWorldMat;
  }

  function toWorldVec(arr, time) {
    var toWorldMat = this.getMatrix(time);
    toWorldMat.props[12] = 0;
    toWorldMat.props[13] = 0;
    toWorldMat.props[14] = 0;
    return this.applyPoint(toWorldMat, arr);
  }

  function toWorld(arr, time) {
    var toWorldMat = this.getMatrix(time);
    return this.applyPoint(toWorldMat, arr);
  }

  function fromWorldVec(arr, time) {
    var toWorldMat = this.getMatrix(time);
    toWorldMat.props[12] = 0;
    toWorldMat.props[13] = 0;
    toWorldMat.props[14] = 0;
    return this.invertPoint(toWorldMat, arr);
  }

  function fromWorld(arr, time) {
    var toWorldMat = this.getMatrix(time);
    return this.invertPoint(toWorldMat, arr);
  }

  function applyPoint(matrix, arr) {
    if (this._elem.hierarchy && this._elem.hierarchy.length) {
      var i;
      var len = this._elem.hierarchy.length;
      for (i = 0; i < len; i += 1) {
        this._elem.hierarchy[i].finalTransform.mProp.applyToMatrix(matrix);
      }
    }
    return matrix.applyToPointArray(arr[0], arr[1], arr[2] || 0);
  }

  function invertPoint(matrix, arr) {
    if (this._elem.hierarchy && this._elem.hierarchy.length) {
      var i;
      var len = this._elem.hierarchy.length;
      for (i = 0; i < len; i += 1) {
        this._elem.hierarchy[i].finalTransform.mProp.applyToMatrix(matrix);
      }
    }
    return matrix.inversePoint(arr);
  }

  function fromComp(arr) {
    var toWorldMat = new Matrix();
    toWorldMat.reset();
    this._elem.finalTransform.mProp.applyToMatrix(toWorldMat);
    if (this._elem.hierarchy && this._elem.hierarchy.length) {
      var i;
      var len = this._elem.hierarchy.length;
      for (i = 0; i < len; i += 1) {
        this._elem.hierarchy[i].finalTransform.mProp.applyToMatrix(toWorldMat);
      }
      return toWorldMat.inversePoint(arr);
    }
    return toWorldMat.inversePoint(arr);
  }

  function sampleImage() {
    return [1, 1, 1, 1];
  }

  return function (elem) {
    var transformInterface;

    function _registerMaskInterface(maskManager) {
      _thisLayerFunction.mask = new MaskManagerInterface(maskManager, elem);
    }
    function _registerEffectsInterface(effects) {
      _thisLayerFunction.effect = effects;
    }

    function _thisLayerFunction(name) {
      switch (name) {
        case 'ADBE Root Vectors Group':
        case 'Contents':
        case 2:
          return _thisLayerFunction.shapeInterface;
        case 1:
        case 6:
        case 'Transform':
        case 'transform':
        case 'ADBE Transform Group':
          return transformInterface;
        case 4:
        case 'ADBE Effect Parade':
        case 'effects':
        case 'Effects':
          return _thisLayerFunction.effect;
        case 'ADBE Text Properties':
          return _thisLayerFunction.textInterface;
        default:
          return null;
      }
    }
    _thisLayerFunction.getMatrix = getMatrix;
    _thisLayerFunction.invertPoint = invertPoint;
    _thisLayerFunction.applyPoint = applyPoint;
    _thisLayerFunction.toWorld = toWorld;
    _thisLayerFunction.toWorldVec = toWorldVec;
    _thisLayerFunction.fromWorld = fromWorld;
    _thisLayerFunction.fromWorldVec = fromWorldVec;
    _thisLayerFunction.toComp = toWorld;
    _thisLayerFunction.fromComp = fromComp;
    _thisLayerFunction.sampleImage = sampleImage;
    _thisLayerFunction.sourceRectAtTime = elem.sourceRectAtTime.bind(elem);
    _thisLayerFunction._elem = elem;
    transformInterface = TransformExpressionInterface(elem.finalTransform.mProp);
    var anchorPointDescriptor = getDescriptor(transformInterface, 'anchorPoint');
    Object.defineProperties(_thisLayerFunction, {
      hasParent: {
        get: function () {
          return elem.hierarchy.length;
        },
      },
      parent: {
        get: function () {
          return elem.hierarchy[0].layerInterface;
        },
      },
      rotation: getDescriptor(transformInterface, 'rotation'),
      scale: getDescriptor(transformInterface, 'scale'),
      position: getDescriptor(transformInterface, 'position'),
      opacity: getDescriptor(transformInterface, 'opacity'),
      anchorPoint: anchorPointDescriptor,
      anchor_point: anchorPointDescriptor,
      transform: {
        get: function () {
          return transformInterface;
        },
      },
      active: {
        get: function () {
          return elem.isInRange;
        },
      },
    });

    _thisLayerFunction.startTime = elem.data.st;
    _thisLayerFunction.index = elem.data.ind;
    _thisLayerFunction.source = elem.data.refId;
    _thisLayerFunction.height = elem.data.ty === 0 ? elem.data.h : 100;
    _thisLayerFunction.width = elem.data.ty === 0 ? elem.data.w : 100;
    _thisLayerFunction.inPoint = elem.data.ip / elem.comp.globalData.frameRate;
    _thisLayerFunction.outPoint = elem.data.op / elem.comp.globalData.frameRate;
    _thisLayerFunction._name = elem.data.nm;

    _thisLayerFunction.registerMaskInterface = _registerMaskInterface;
    _thisLayerFunction.registerEffectsInterface = _registerEffectsInterface;
    return _thisLayerFunction;
  };
}());

/* global */
/* exported FootageInterface */

var FootageInterface = (function () {
  var outlineInterfaceFactory = (function (elem) {
    var currentPropertyName = '';
    var currentProperty = elem.getFootageData();
    function init() {
      currentPropertyName = '';
      currentProperty = elem.getFootageData();
      return searchProperty;
    }
    function searchProperty(value) {
      if (currentProperty[value]) {
        currentPropertyName = value;
        currentProperty = currentProperty[value];
        if (typeof currentProperty === 'object') {
          return searchProperty;
        }
        return currentProperty;
      }
      var propertyNameIndex = value.indexOf(currentPropertyName);
      if (propertyNameIndex !== -1) {
        var index = parseInt(value.substr(propertyNameIndex + currentPropertyName.length), 10);
        currentProperty = currentProperty[index];
        if (typeof currentProperty === 'object') {
          return searchProperty;
        }
        return currentProperty;
      }
      return '';
    }
    return init;
  });

  var dataInterfaceFactory = function (elem) {
    function interfaceFunction(value) {
      if (value === 'Outline') {
        return interfaceFunction.outlineInterface();
      }
      return null;
    }

    interfaceFunction._name = 'Outline';
    interfaceFunction.outlineInterface = outlineInterfaceFactory(elem);
    return interfaceFunction;
  };

  return function (elem) {
    function _interfaceFunction(value) {
      if (value === 'Data') {
        return _interfaceFunction.dataInterface;
      }
      return null;
    }

    _interfaceFunction._name = 'Data';
    _interfaceFunction.dataInterface = dataInterfaceFactory(elem);
    return _interfaceFunction;
  };
}());

/* exported CompExpressionInterface */

var CompExpressionInterface = (function () {
  return function (comp) {
    function _thisLayerFunction(name) {
      var i = 0;
      var len = comp.layers.length;
      while (i < len) {
        if (comp.layers[i].nm === name || comp.layers[i].ind === name) {
          return comp.elements[i].layerInterface;
        }
        i += 1;
      }
      return null;
      // return {active:false};
    }
    Object.defineProperty(_thisLayerFunction, '_name', { value: comp.data.nm });
    _thisLayerFunction.layer = _thisLayerFunction;
    _thisLayerFunction.pixelAspect = 1;
    _thisLayerFunction.height = comp.data.h || comp.globalData.compSize.h;
    _thisLayerFunction.width = comp.data.w || comp.globalData.compSize.w;
    _thisLayerFunction.pixelAspect = 1;
    _thisLayerFunction.frameDuration = 1 / comp.globalData.frameRate;
    _thisLayerFunction.displayStartTime = 0;
    _thisLayerFunction.numLayers = comp.layers.length;
    return _thisLayerFunction;
  };
}());

/* global ExpressionPropertyInterface */
/* exported TransformExpressionInterface */

var TransformExpressionInterface = (function () {
  return function (transform) {
    function _thisFunction(name) {
      switch (name) {
        case 'scale':
        case 'Scale':
        case 'ADBE Scale':
        case 6:
          return _thisFunction.scale;
        case 'rotation':
        case 'Rotation':
        case 'ADBE Rotation':
        case 'ADBE Rotate Z':
        case 10:
          return _thisFunction.rotation;
        case 'ADBE Rotate X':
          return _thisFunction.xRotation;
        case 'ADBE Rotate Y':
          return _thisFunction.yRotation;
        case 'position':
        case 'Position':
        case 'ADBE Position':
        case 2:
          return _thisFunction.position;
        case 'ADBE Position_0':
          return _thisFunction.xPosition;
        case 'ADBE Position_1':
          return _thisFunction.yPosition;
        case 'ADBE Position_2':
          return _thisFunction.zPosition;
        case 'anchorPoint':
        case 'AnchorPoint':
        case 'Anchor Point':
        case 'ADBE AnchorPoint':
        case 1:
          return _thisFunction.anchorPoint;
        case 'opacity':
        case 'Opacity':
        case 11:
          return _thisFunction.opacity;
        default:
          return null;
      }
    }
    Object.defineProperty(_thisFunction, 'rotation', {
      get: ExpressionPropertyInterface(transform.r || transform.rz),
    });

    Object.defineProperty(_thisFunction, 'zRotation', {
      get: ExpressionPropertyInterface(transform.rz || transform.r),
    });

    Object.defineProperty(_thisFunction, 'xRotation', {
      get: ExpressionPropertyInterface(transform.rx),
    });

    Object.defineProperty(_thisFunction, 'yRotation', {
      get: ExpressionPropertyInterface(transform.ry),
    });
    Object.defineProperty(_thisFunction, 'scale', {
      get: ExpressionPropertyInterface(transform.s),
    });
    var _px;
    var _py;
    var _pz;
    var _transformFactory;
    if (transform.p) {
      _transformFactory = ExpressionPropertyInterface(transform.p);
    } else {
      _px = ExpressionPropertyInterface(transform.px);
      _py = ExpressionPropertyInterface(transform.py);
      if (transform.pz) {
        _pz = ExpressionPropertyInterface(transform.pz);
      }
    }
    Object.defineProperty(_thisFunction, 'position', {
      get: function () {
        if (transform.p) {
          return _transformFactory();
        }
        return [
          _px(),
          _py(),
          _pz ? _pz() : 0];
      },
    });

    Object.defineProperty(_thisFunction, 'xPosition', {
      get: ExpressionPropertyInterface(transform.px),
    });

    Object.defineProperty(_thisFunction, 'yPosition', {
      get: ExpressionPropertyInterface(transform.py),
    });

    Object.defineProperty(_thisFunction, 'zPosition', {
      get: ExpressionPropertyInterface(transform.pz),
    });

    Object.defineProperty(_thisFunction, 'anchorPoint', {
      get: ExpressionPropertyInterface(transform.a),
    });

    Object.defineProperty(_thisFunction, 'opacity', {
      get: ExpressionPropertyInterface(transform.o),
    });

    Object.defineProperty(_thisFunction, 'skew', {
      get: ExpressionPropertyInterface(transform.sk),
    });

    Object.defineProperty(_thisFunction, 'skewAxis', {
      get: ExpressionPropertyInterface(transform.sa),
    });

    Object.defineProperty(_thisFunction, 'orientation', {
      get: ExpressionPropertyInterface(transform.or),
    });

    return _thisFunction;
  };
}());

/* exported ProjectInterface */

var ProjectInterface = (function () {
  function registerComposition(comp) {
    this.compositions.push(comp);
  }

  return function () {
    function _thisProjectFunction(name) {
      var i = 0;
      var len = this.compositions.length;
      while (i < len) {
        if (this.compositions[i].data && this.compositions[i].data.nm === name) {
          if (this.compositions[i].prepareFrame && this.compositions[i].data.xt) {
            this.compositions[i].prepareFrame(this.currentFrame);
          }
          return this.compositions[i].compInterface;
        }
        i += 1;
      }
      return null;
    }

    _thisProjectFunction.compositions = [];
    _thisProjectFunction.currentFrame = 0;

    _thisProjectFunction.registerComposition = registerComposition;

    return _thisProjectFunction;
  };
}());

/* global propertyGroupFactory, ExpressionPropertyInterface, PropertyInterface */
/* exported EffectsExpressionInterface */

var EffectsExpressionInterface = (function () {
  var ob = {
    createEffectsInterface: createEffectsInterface,
  };

  function createEffectsInterface(elem, propertyGroup) {
    if (elem.effectsManager) {
      var effectElements = [];
      var effectsData = elem.data.ef;
      var i;
      var len = elem.effectsManager.effectElements.length;
      for (i = 0; i < len; i += 1) {
        effectElements.push(createGroupInterface(effectsData[i], elem.effectsManager.effectElements[i], propertyGroup, elem));
      }

      var effects = elem.data.ef || [];
      var groupInterface = function (name) {
        i = 0;
        len = effects.length;
        while (i < len) {
          if (name === effects[i].nm || name === effects[i].mn || name === effects[i].ix) {
            return effectElements[i];
          }
          i += 1;
        }
        return null;
      };
      Object.defineProperty(groupInterface, 'numProperties', {
        get: function () {
          return effects.length;
        },
      });
      return groupInterface;
    }
    return null;
  }

  function createGroupInterface(data, elements, propertyGroup, elem) {
    function groupInterface(name) {
      var effects = data.ef;
      var i = 0;
      var len = effects.length;
      while (i < len) {
        if (name === effects[i].nm || name === effects[i].mn || name === effects[i].ix) {
          if (effects[i].ty === 5) {
            return effectElements[i];
          }
          return effectElements[i]();
        }
        i += 1;
      }
      throw new Error();
    }
    var _propertyGroup = propertyGroupFactory(groupInterface, propertyGroup);

    var effectElements = [];
    var i;
    var len = data.ef.length;
    for (i = 0; i < len; i += 1) {
      if (data.ef[i].ty === 5) {
        effectElements.push(createGroupInterface(data.ef[i], elements.effectElements[i], elements.effectElements[i].propertyGroup, elem));
      } else {
        effectElements.push(createValueInterface(elements.effectElements[i], data.ef[i].ty, elem, _propertyGroup));
      }
    }

    if (data.mn === 'ADBE Color Control') {
      Object.defineProperty(groupInterface, 'color', {
        get: function () {
          return effectElements[0]();
        },
      });
    }
    Object.defineProperties(groupInterface, {
      numProperties: {
        get: function () {
          return data.np;
        },
      },
      _name: { value: data.nm },
      propertyGroup: { value: _propertyGroup },
    });
    groupInterface.enabled = data.en !== 0;
    groupInterface.active = groupInterface.enabled;
    return groupInterface;
  }

  function createValueInterface(element, type, elem, propertyGroup) {
    var expressionProperty = ExpressionPropertyInterface(element.p);
    function interfaceFunction() {
      if (type === 10) {
        return elem.comp.compInterface(element.p.v);
      }
      return expressionProperty();
    }

    if (element.p.setGroupProperty) {
      element.p.setGroupProperty(PropertyInterface('', propertyGroup));
    }

    return interfaceFunction;
  }

  return ob;
}());

/* global createSizedArray */
/* exported MaskManagerInterface */

var MaskManagerInterface = (function () {
  function MaskInterface(mask, data) {
    this._mask = mask;
    this._data = data;
  }
  Object.defineProperty(MaskInterface.prototype, 'maskPath', {
    get: function () {
      if (this._mask.prop.k) {
        this._mask.prop.getValue();
      }
      return this._mask.prop;
    },
  });
  Object.defineProperty(MaskInterface.prototype, 'maskOpacity', {
    get: function () {
      if (this._mask.op.k) {
        this._mask.op.getValue();
      }
      return this._mask.op.v * 100;
    },
  });

  var MaskManager = function (maskManager) {
    var _masksInterfaces = createSizedArray(maskManager.viewData.length);
    var i;
    var len = maskManager.viewData.length;
    for (i = 0; i < len; i += 1) {
      _masksInterfaces[i] = new MaskInterface(maskManager.viewData[i], maskManager.masksProperties[i]);
    }

    var maskFunction = function (name) {
      i = 0;
      while (i < len) {
        if (maskManager.masksProperties[i].nm === name) {
          return _masksInterfaces[i];
        }
        i += 1;
      }
      return null;
    };
    return maskFunction;
  };
  return MaskManager;
}());

/* global createTypedArray */
/* exported ExpressionPropertyInterface */

var ExpressionPropertyInterface = (function () {
  var defaultUnidimensionalValue = { pv: 0, v: 0, mult: 1 };
  var defaultMultidimensionalValue = { pv: [0, 0, 0], v: [0, 0, 0], mult: 1 };

  function completeProperty(expressionValue, property, type) {
    Object.defineProperty(expressionValue, 'velocity', {
      get: function () {
        return property.getVelocityAtTime(property.comp.currentFrame);
      },
    });
    expressionValue.numKeys = property.keyframes ? property.keyframes.length : 0;
    expressionValue.key = function (pos) {
      if (!expressionValue.numKeys) {
        return 0;
      }
      var value = '';
      if ('s' in property.keyframes[pos - 1]) {
        value = property.keyframes[pos - 1].s;
      } else if ('e' in property.keyframes[pos - 2]) {
        value = property.keyframes[pos - 2].e;
      } else {
        value = property.keyframes[pos - 2].s;
      }
      var valueProp = type === 'unidimensional' ? new Number(value) : Object.assign({}, value); // eslint-disable-line no-new-wrappers
      valueProp.time = property.keyframes[pos - 1].t / property.elem.comp.globalData.frameRate;
      valueProp.value = type === 'unidimensional' ? value[0] : value;
      return valueProp;
    };
    expressionValue.valueAtTime = property.getValueAtTime;
    expressionValue.speedAtTime = property.getSpeedAtTime;
    expressionValue.velocityAtTime = property.getVelocityAtTime;
    expressionValue.propertyGroup = property.propertyGroup;
  }

  function UnidimensionalPropertyInterface(property) {
    if (!property || !('pv' in property)) {
      property = defaultUnidimensionalValue;
    }
    var mult = 1 / property.mult;
    var val = property.pv * mult;
    var expressionValue = new Number(val); // eslint-disable-line no-new-wrappers
    expressionValue.value = val;
    completeProperty(expressionValue, property, 'unidimensional');

    return function () {
      if (property.k) {
        property.getValue();
      }
      val = property.v * mult;
      if (expressionValue.value !== val) {
        expressionValue = new Number(val); // eslint-disable-line no-new-wrappers
        expressionValue.value = val;
        completeProperty(expressionValue, property, 'unidimensional');
      }
      return expressionValue;
    };
  }

  function MultidimensionalPropertyInterface(property) {
    if (!property || !('pv' in property)) {
      property = defaultMultidimensionalValue;
    }
    var mult = 1 / property.mult;
    var len = (property.data && property.data.l) || property.pv.length;
    var expressionValue = createTypedArray('float32', len);
    var arrValue = createTypedArray('float32', len);
    expressionValue.value = arrValue;
    completeProperty(expressionValue, property, 'multidimensional');

    return function () {
      if (property.k) {
        property.getValue();
      }
      for (var i = 0; i < len; i += 1) {
        arrValue[i] = property.v[i] * mult;
        expressionValue[i] = arrValue[i];
      }
      return expressionValue;
    };
  }

  // TODO: try to avoid using this getter
  function defaultGetter() {
    return defaultUnidimensionalValue;
  }

  return function (property) {
    if (!property) {
      return defaultGetter;
    } if (property.propType === 'unidimensional') {
      return UnidimensionalPropertyInterface(property);
    }
    return MultidimensionalPropertyInterface(property);
  };
}());

/* global expressionHelpers, TextSelectorProp, ExpressionManager */
/* exported TextExpressionSelectorProp */

(function () {

  var propertyGetTextProp = TextSelectorProp.getTextSelectorProp;
  TextSelectorProp.getTextSelectorProp = function (elem, data, arr) {
    if (data.t === 1) {
      return new TextExpressionSelectorPropFactory(elem, data, arr); // eslint-disable-line no-undef
    }
    return propertyGetTextProp(elem, data, arr);
  };
}());

/* global PropertyFactory */
/* exported SliderEffect, AngleEffect, ColorEffect, PointEffect, LayerIndexEffect, MaskIndexEffect, CheckboxEffect, NoValueEffect */

function SliderEffect(data, elem, container) {
  this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
}
function AngleEffect(data, elem, container) {
  this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
}
function ColorEffect(data, elem, container) {
  this.p = PropertyFactory.getProp(elem, data.v, 1, 0, container);
}
function PointEffect(data, elem, container) {
  this.p = PropertyFactory.getProp(elem, data.v, 1, 0, container);
}
function LayerIndexEffect(data, elem, container) {
  this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
}
function MaskIndexEffect(data, elem, container) {
  this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
}
function CheckboxEffect(data, elem, container) {
  this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
}
function NoValueEffect() {
  this.p = {};
}

/* global extendPrototype, SliderEffect, AngleEffect, ColorEffect, PointEffect, CheckboxEffect, LayerIndexEffect,
MaskIndexEffect, NoValueEffect, DynamicPropertyContainer */

function EffectsManager(data, element) {
  var effects = data.ef || [];
  this.effectElements = [];
  var i;
  var len = effects.length;
  var effectItem;
  for (i = 0; i < len; i += 1) {
    effectItem = new GroupEffect(effects[i], element);
    this.effectElements.push(effectItem);
  }
}

function GroupEffect(data, element) {
  this.init(data, element);
}

extendPrototype([DynamicPropertyContainer], GroupEffect);

GroupEffect.prototype.getValue = GroupEffect.prototype.iterateDynamicProperties;

GroupEffect.prototype.init = function (data, element) {
  this.data = data;
  this.effectElements = [];
  this.initDynamicPropertyContainer(element);
  var i;
  var len = this.data.ef.length;
  var eff;
  var effects = this.data.ef;
  for (i = 0; i < len; i += 1) {
    eff = null;
    switch (effects[i].ty) {
      case 0:
        eff = new SliderEffect(effects[i], element, this);
        break;
      case 1:
        eff = new AngleEffect(effects[i], element, this);
        break;
      case 2:
        eff = new ColorEffect(effects[i], element, this);
        break;
      case 3:
        eff = new PointEffect(effects[i], element, this);
        break;
      case 4:
      case 7:
        eff = new CheckboxEffect(effects[i], element, this);
        break;
      case 10:
        eff = new LayerIndexEffect(effects[i], element, this);
        break;
      case 11:
        eff = new MaskIndexEffect(effects[i], element, this);
        break;
      case 5:
        eff = new EffectsManager(effects[i], element, this);
        break;
        // case 6:
      default:
        eff = new NoValueEffect(effects[i], element, this);
        break;
    }
    if (eff) {
      this.effectElements.push(eff);
    }
  }
};


var lottie = {};

function setLocationHref(href) {
  locationHref = href;
}

function searchAnimations() {
  {
    animationManager.searchAnimations();
  }
}

function setSubframeRendering(flag) {
  subframeEnabled = flag;
}

function setIDPrefix(prefix) {
  idPrefix = prefix;
}

function loadAnimation(params) {
  return animationManager.loadAnimation(params);
}

function setQuality(value) {
  if (typeof value === 'string') {
    switch (value) {
      case 'high':
        defaultCurveSegments = 200;
        break;
      default:
      case 'medium':
        defaultCurveSegments = 50;
        break;
      case 'low':
        defaultCurveSegments = 10;
        break;
    }
  } else if (!isNaN(value) && value > 1) {
    defaultCurveSegments = value;
  }
}

function inBrowser() {
  return typeof navigator !== 'undefined';
}

function installPlugin(type, plugin) {
  if (type === 'expressions') {
    expressionsPlugin = plugin;
  }
}

function getFactory(name) {
  switch (name) {
    case 'propertyFactory':
      return PropertyFactory;
    case 'shapePropertyFactory':
      return ShapePropertyFactory;
    case 'matrix':
      return Matrix;
    default:
      return null;
  }
}

lottie.play = animationManager.play;
lottie.pause = animationManager.pause;
lottie.setLocationHref = setLocationHref;
lottie.togglePause = animationManager.togglePause;
lottie.setSpeed = animationManager.setSpeed;
lottie.setDirection = animationManager.setDirection;
lottie.stop = animationManager.stop;
lottie.searchAnimations = searchAnimations;
lottie.registerAnimation = animationManager.registerAnimation;
lottie.loadAnimation = loadAnimation;
lottie.setSubframeRendering = setSubframeRendering;
lottie.resize = animationManager.resize;
// lottie.start = start;
lottie.goToAndStop = animationManager.goToAndStop;
lottie.destroy = animationManager.destroy;
lottie.setQuality = setQuality;
lottie.inBrowser = inBrowser;
lottie.installPlugin = installPlugin;
lottie.freeze = animationManager.freeze;
lottie.unfreeze = animationManager.unfreeze;
lottie.setVolume = animationManager.setVolume;
lottie.mute = animationManager.mute;
lottie.unmute = animationManager.unmute;
lottie.getRegisteredAnimations = animationManager.getRegisteredAnimations;
lottie.setIDPrefix = setIDPrefix;
lottie.__getFactory = getFactory;
lottie.version = '5.7.11';

function checkReady() {
  if (document.readyState === 'complete') {
    clearInterval(readyStateCheckInterval);
    searchAnimations();
  }
}

function getQueryVariable(variable) {
  var vars = queryString.split('&');
  for (var i = 0; i < vars.length; i += 1) {
    var pair = vars[i].split('=');
    if (decodeURIComponent(pair[0]) == variable) { // eslint-disable-line eqeqeq
      return decodeURIComponent(pair[1]);
    }
  }
  return null;
}
var queryString;
{
  var scripts = document.getElementsByTagName('script');
  var index = scripts.length - 1;
  var myScript = scripts[index] || {
    src: '',
  };
  queryString = myScript.src.replace(/^[^\?]+\??/, ''); // eslint-disable-line no-useless-escape
  getQueryVariable('renderer');
}
var readyStateCheckInterval = setInterval(checkReady, 100);

return lottie;
}));
});

var useLottie = function (props, style) {
    var animationData = props.animationData, loop = props.loop, autoplay = props.autoplay, initialSegment = props.initialSegment, onComplete = props.onComplete, onLoopComplete = props.onLoopComplete, onEnterFrame = props.onEnterFrame, onSegmentStart = props.onSegmentStart, onConfigReady = props.onConfigReady, onDataReady = props.onDataReady, onDataFailed = props.onDataFailed, onLoadedImages = props.onLoadedImages, onDOMLoaded = props.onDOMLoaded, onDestroy = props.onDestroy; 
    // Specified here to take them out from the 'rest'
    props.lottieRef; props.renderer; props.name; props.assetsPath; props.rendererSettings; 
    var // TODO: find a better way to extract the html props to avoid specifying
    //  all the props that we want to exclude (as you can see above)
    rest = __rest(props, ["animationData", "loop", "autoplay", "initialSegment", "onComplete", "onLoopComplete", "onEnterFrame", "onSegmentStart", "onConfigReady", "onDataReady", "onDataFailed", "onLoadedImages", "onDOMLoaded", "onDestroy", "lottieRef", "renderer", "name", "assetsPath", "rendererSettings"]);
    var _a = useState(false), animationLoaded = _a[0], setAnimationLoaded = _a[1];
    var animationInstanceRef = useRef();
    var animationContainer = useRef(null);
    /*
          ======================================
              INTERACTION METHODS
          ======================================
       */
    /**
     * Play
     */
    var play = function () {
        var _a;
        (_a = animationInstanceRef.current) === null || _a === void 0 ? void 0 : _a.play();
    };
    /**
     * Stop
     */
    var stop = function () {
        var _a;
        (_a = animationInstanceRef.current) === null || _a === void 0 ? void 0 : _a.stop();
    };
    /**
     * Pause
     */
    var pause = function () {
        var _a;
        (_a = animationInstanceRef.current) === null || _a === void 0 ? void 0 : _a.pause();
    };
    /**
     * Set animation speed
     * @param speed
     */
    var setSpeed = function (speed) {
        var _a;
        (_a = animationInstanceRef.current) === null || _a === void 0 ? void 0 : _a.setSpeed(speed);
    };
    /**
     * Got to frame and play
     * @param value
     * @param isFrame
     */
    var goToAndPlay = function (value, isFrame) {
        var _a;
        (_a = animationInstanceRef.current) === null || _a === void 0 ? void 0 : _a.goToAndPlay(value, isFrame);
    };
    /**
     * Got to frame and stop
     * @param value
     * @param isFrame
     */
    var goToAndStop = function (value, isFrame) {
        var _a;
        (_a = animationInstanceRef.current) === null || _a === void 0 ? void 0 : _a.goToAndStop(value, isFrame);
    };
    /**
     * Set animation direction
     * @param direction
     */
    var setDirection = function (direction) {
        var _a;
        (_a = animationInstanceRef.current) === null || _a === void 0 ? void 0 : _a.setDirection(direction);
    };
    /**
     * Play animation segments
     * @param segments
     * @param forceFlag
     */
    var playSegments = function (segments, forceFlag) {
        var _a;
        (_a = animationInstanceRef.current) === null || _a === void 0 ? void 0 : _a.playSegments(segments, forceFlag);
    };
    /**
     * Set sub frames
     * @param useSubFrames
     */
    var setSubframe = function (useSubFrames) {
        var _a;
        (_a = animationInstanceRef.current) === null || _a === void 0 ? void 0 : _a.setSubframe(useSubFrames);
    };
    /**
     * Get animation duration
     * @param inFrames
     */
    var getDuration = function (inFrames) {
        var _a;
        return (_a = animationInstanceRef.current) === null || _a === void 0 ? void 0 : _a.getDuration(inFrames);
    };
    /**
     * Destroy animation
     */
    var destroy = function () {
        var _a;
        (_a = animationInstanceRef.current) === null || _a === void 0 ? void 0 : _a.destroy();
    };
    /*
          ======================================
              LOTTIE
          ======================================
       */
    /**
     * Load a new animation, and if it's the case, destroy the previous one
     * @param {Object} forcedConfigs
     */
    var loadAnimation = function (forcedConfigs) {
        var _a;
        if (forcedConfigs === void 0) { forcedConfigs = {}; }
        // Return if the container ref is null
        if (!animationContainer.current) {
            return;
        }
        // Destroy any previous instance
        (_a = animationInstanceRef.current) === null || _a === void 0 ? void 0 : _a.destroy();
        // Build the animation configuration
        var config = __assign$2(__assign$2(__assign$2({}, props), forcedConfigs), { container: animationContainer.current });
        // Save the animation instance
        animationInstanceRef.current = lottie.loadAnimation(config);
        setAnimationLoaded(!!animationInstanceRef.current);
    };
    /**
     * Initialize and listen for changes that affect the animation state
     */
    // Reinitialize when animation data changed
    useEffect(function () {
        loadAnimation();
    }, [animationData]);
    // Update the loop state
    useEffect(function () {
        if (!animationInstanceRef.current) {
            return;
        }
        animationInstanceRef.current.loop = !!loop;
        if (loop && animationInstanceRef.current.isPaused) {
            animationInstanceRef.current.play();
        }
    }, [loop]);
    // Update the autoplay state
    useEffect(function () {
        if (!animationInstanceRef.current) {
            return;
        }
        animationInstanceRef.current.autoplay = !!autoplay;
    }, [autoplay]);
    // Update the initial segment state
    useEffect(function () {
        if (!animationInstanceRef.current) {
            return;
        }
        // When null should reset to default animation length
        if (!initialSegment) {
            animationInstanceRef.current.resetSegments(false);
            return;
        }
        // If it's not a valid segment, do nothing
        if (!Array.isArray(initialSegment) || !initialSegment.length) {
            return;
        }
        // If the current position it's not in the new segment
        // set the current position to start
        if (animationInstanceRef.current.currentRawFrame < initialSegment[0] ||
            animationInstanceRef.current.currentRawFrame > initialSegment[1]) {
            animationInstanceRef.current.currentRawFrame = initialSegment[0];
        }
        // Update the segment
        animationInstanceRef.current.setSegment(initialSegment[0], initialSegment[1]);
    }, [initialSegment]);
    /*
          ======================================
              EVENTS
          ======================================
       */
    /**
     * Reinitialize listener on change
     */
    useEffect(function () {
        var partialListeners = [
            { name: "complete", handler: onComplete },
            { name: "loopComplete", handler: onLoopComplete },
            { name: "enterFrame", handler: onEnterFrame },
            { name: "segmentStart", handler: onSegmentStart },
            { name: "config_ready", handler: onConfigReady },
            { name: "data_ready", handler: onDataReady },
            { name: "data_failed", handler: onDataFailed },
            { name: "loaded_images", handler: onLoadedImages },
            { name: "DOMLoaded", handler: onDOMLoaded },
            { name: "destroy", handler: onDestroy },
        ];
        var listeners = partialListeners.filter(function (listener) {
            return listener.handler != null;
        });
        if (!listeners.length) {
            return;
        }
        var deregisterList = listeners.map(
        /**
         * Handle the process of adding an event listener
         * @param {Listener} listener
         * @return {Function} Function that deregister the listener
         */
        function (listener) {
            var _a;
            (_a = animationInstanceRef.current) === null || _a === void 0 ? void 0 : _a.addEventListener(listener.name, listener.handler);
            // Return a function to deregister this listener
            return function () {
                var _a;
                (_a = animationInstanceRef.current) === null || _a === void 0 ? void 0 : _a.removeEventListener(listener.name, listener.handler);
            };
        });
        // Deregister listeners on unmount
        return function () {
            deregisterList.forEach(function (deregister) { return deregister(); });
        };
    }, [
        onComplete,
        onLoopComplete,
        onEnterFrame,
        onSegmentStart,
        onConfigReady,
        onDataReady,
        onDataFailed,
        onLoadedImages,
        onDOMLoaded,
        onDestroy,
    ]);
    /**
     * Build the animation view
     */
    var View = React__default.createElement("div", __assign$2({ style: style, ref: animationContainer }, rest));
    return {
        View: View,
        play: play,
        stop: stop,
        pause: pause,
        setSpeed: setSpeed,
        goToAndStop: goToAndStop,
        goToAndPlay: goToAndPlay,
        setDirection: setDirection,
        playSegments: playSegments,
        setSubframe: setSubframe,
        getDuration: getDuration,
        destroy: destroy,
        animationLoaded: animationLoaded,
        animationItem: animationInstanceRef.current,
    };
};

// helpers
function getContainerVisibility(container) {
    var _a = container.getBoundingClientRect(), top = _a.top, height = _a.height;
    var current = window.innerHeight - top;
    var max = window.innerHeight + height;
    return current / max;
}
function getContainerCursorPosition(container, cursorX, cursorY) {
    var _a = container.getBoundingClientRect(), top = _a.top, left = _a.left, width = _a.width, height = _a.height;
    var x = (cursorX - left) / width;
    var y = (cursorY - top) / height;
    return { x: x, y: y };
}
var useInitInteractivity = function (_a) {
    var wrapperRef = _a.wrapperRef, animationItem = _a.animationItem, mode = _a.mode, actions = _a.actions;
    useEffect(function () {
        var wrapper = wrapperRef.current;
        if (!wrapper || !animationItem) {
            return;
        }
        animationItem.stop();
        var scrollModeHandler = function () {
            var assignedSegment = null;
            var scrollHandler = function () {
                var currentPercent = getContainerVisibility(wrapper);
                // Find the first action that satisfies the current position conditions
                var action = actions.find(function (_a) {
                    var visibility = _a.visibility;
                    return visibility &&
                        currentPercent >= visibility[0] &&
                        currentPercent <= visibility[1];
                });
                // Skip if no matching action was found!
                if (!action) {
                    return;
                }
                if (action.type === "seek" &&
                    action.visibility &&
                    action.frames.length === 2) {
                    // Seek: Go to a frame based on player scroll position action
                    var frameToGo = action.frames[0] +
                        Math.ceil(((currentPercent - action.visibility[0]) /
                            (action.visibility[1] - action.visibility[0])) *
                            action.frames[1]);
                    //! goToAndStop must be relative to the start of the current segment
                    animationItem.goToAndStop(frameToGo - animationItem.firstFrame - 1, true);
                }
                if (action.type === "loop") {
                    // Loop: Loop a given frames
                    if (assignedSegment === null) {
                        // if not playing any segments currently. play those segments and save to state
                        animationItem.playSegments(action.frames, true);
                        assignedSegment = action.frames;
                    }
                    else {
                        // if playing any segments currently.
                        //check if segments in state are equal to the frames selected by action
                        if (assignedSegment !== action.frames) {
                            // if they are not equal. new segments are to be loaded
                            animationItem.playSegments(action.frames, true);
                            assignedSegment = action.frames;
                        }
                        else if (animationItem.isPaused) {
                            // if they are equal the play method must be called only if lottie is paused
                            animationItem.playSegments(action.frames, true);
                            assignedSegment = action.frames;
                        }
                    }
                }
                if (action.type === "play" && animationItem.isPaused) {
                    // Play: Reset segments and continue playing full animation from current position
                    animationItem.resetSegments(true);
                    animationItem.play();
                }
                if (action.type === "stop") {
                    // Stop: Stop playback
                    animationItem.goToAndStop(action.frames[0] - animationItem.firstFrame - 1, true);
                }
            };
            document.addEventListener("scroll", scrollHandler);
            return function () {
                document.removeEventListener("scroll", scrollHandler);
            };
        };
        var cursorModeHandler = function () {
            var handleCursor = function (_x, _y) {
                var x = _x;
                var y = _y;
                // Resolve cursor position if cursor is inside container
                if (x !== -1 && y !== -1) {
                    // Get container cursor position
                    var pos = getContainerCursorPosition(wrapper, x, y);
                    // Use the resolved position
                    x = pos.x;
                    y = pos.y;
                }
                // Find the first action that satisfies the current position conditions
                var action = actions.find(function (_a) {
                    var position = _a.position;
                    if (position &&
                        Array.isArray(position.x) &&
                        Array.isArray(position.y)) {
                        return (x >= position.x[0] &&
                            x <= position.x[1] &&
                            y >= position.y[0] &&
                            y <= position.y[1]);
                    }
                    if (position &&
                        !Number.isNaN(position.x) &&
                        !Number.isNaN(position.y)) {
                        return x === position.x && y === position.y;
                    }
                    return false;
                });
                // Skip if no matching action was found!
                if (!action) {
                    return;
                }
                // Process action types:
                if (action.type === "seek" &&
                    action.position &&
                    Array.isArray(action.position.x) &&
                    Array.isArray(action.position.y) &&
                    action.frames.length === 2) {
                    // Seek: Go to a frame based on player scroll position action
                    var xPercent = (x - action.position.x[0]) /
                        (action.position.x[1] - action.position.x[0]);
                    var yPercent = (y - action.position.y[0]) /
                        (action.position.y[1] - action.position.y[0]);
                    animationItem.playSegments(action.frames, true);
                    animationItem.goToAndStop(Math.ceil(((xPercent + yPercent) / 2) *
                        (action.frames[1] - action.frames[0])), true);
                }
                if (action.type === "loop") {
                    animationItem.playSegments(action.frames, true);
                }
                if (action.type === "play") {
                    // Play: Reset segments and continue playing full animation from current position
                    if (animationItem.isPaused) {
                        animationItem.resetSegments(false);
                    }
                    animationItem.playSegments(action.frames);
                }
                if (action.type === "stop") {
                    animationItem.goToAndStop(action.frames[0], true);
                }
            };
            var mouseMoveHandler = function (ev) {
                handleCursor(ev.clientX, ev.clientY);
            };
            var mouseOutHandler = function () {
                handleCursor(-1, -1);
            };
            wrapper.addEventListener("mousemove", mouseMoveHandler);
            wrapper.addEventListener("mouseout", mouseOutHandler);
            return function () {
                wrapper.removeEventListener("mousemove", mouseMoveHandler);
                wrapper.removeEventListener("mouseout", mouseOutHandler);
            };
        };
        switch (mode) {
            case "scroll":
                return scrollModeHandler();
            case "cursor":
                return cursorModeHandler();
        }
    }, [mode, animationItem]);
};
var useLottieInteractivity = function (_a) {
    var actions = _a.actions, mode = _a.mode, lottieObj = _a.lottieObj;
    var animationItem = lottieObj.animationItem, View = lottieObj.View;
    var wrapperRef = useRef(null);
    useInitInteractivity({ actions: actions, animationItem: animationItem, mode: mode, wrapperRef: wrapperRef });
    return React__default.createElement("div", { ref: wrapperRef }, View);
};

var Lottie = function (props) {
    var _a;
    var style = props.style, interactivity = props.interactivity, lottieProps = __rest(props, ["style", "interactivity"]);
    /**
     * Initialize the 'useLottie' hook
     */
    var _b = useLottie(lottieProps, style), View = _b.View, play = _b.play, stop = _b.stop, pause = _b.pause, setSpeed = _b.setSpeed, goToAndStop = _b.goToAndStop, goToAndPlay = _b.goToAndPlay, setDirection = _b.setDirection, playSegments = _b.playSegments, setSubframe = _b.setSubframe, getDuration = _b.getDuration, destroy = _b.destroy, animationLoaded = _b.animationLoaded, animationItem = _b.animationItem;
    /**
     * Make the hook variables/methods available through the provided 'lottieRef'
     */
    useEffect(function () {
        if (props.lottieRef) {
            props.lottieRef.current = {
                play: play,
                stop: stop,
                pause: pause,
                setSpeed: setSpeed,
                goToAndPlay: goToAndPlay,
                goToAndStop: goToAndStop,
                setDirection: setDirection,
                playSegments: playSegments,
                setSubframe: setSubframe,
                getDuration: getDuration,
                destroy: destroy,
                animationLoaded: animationLoaded,
                animationItem: animationItem,
            };
        }
    }, [(_a = props.lottieRef) === null || _a === void 0 ? void 0 : _a.current]);
    if (interactivity) {
        var EnhancedView = useLottieInteractivity(__assign$2({ lottieObj: {
                View: View,
                play: play,
                stop: stop,
                pause: pause,
                setSpeed: setSpeed,
                goToAndStop: goToAndStop,
                goToAndPlay: goToAndPlay,
                setDirection: setDirection,
                playSegments: playSegments,
                setSubframe: setSubframe,
                getDuration: getDuration,
                destroy: destroy,
                animationLoaded: animationLoaded,
                animationItem: animationItem,
            } }, interactivity));
        return EnhancedView;
    }
    return View;
};
Lottie.propTypes = {
    animationData: propTypes.shape(undefined).isRequired,
    loop: propTypes.oneOfType([propTypes.bool, propTypes.number]),
    autoplay: propTypes.bool,
    initialSegment: propTypes.arrayOf(propTypes.number.isRequired),
    onComplete: propTypes.func,
    onLoopComplete: propTypes.func,
    onEnterFrame: propTypes.func,
    onSegmentStart: propTypes.func,
    onConfigReady: propTypes.func,
    onDataReady: propTypes.func,
    onDataFailed: propTypes.func,
    onLoadedImages: propTypes.func,
    onDOMLoaded: propTypes.func,
    onDestroy: propTypes.func,
    style: propTypes.shape(undefined),
};
Lottie.defaultProps = {
    loop: false,
    autoplay: true,
    initialSegment: null,
    onComplete: null,
    onLoopComplete: null,
    onEnterFrame: null,
    onSegmentStart: null,
    onConfigReady: null,
    onDataReady: null,
    onDataFailed: null,
    onLoadedImages: null,
    onDOMLoaded: null,
    onDestroy: null,
    style: undefined,
};

var v = "5.7.3";
var fr = 30;
var ip = 0;
var op = 91;
var w = 1000;
var h = 1000;
var nm = "x_01";
var ddd = 0;
var assets = [
];
var layers = [
	{
		ddd: 0,
		ind: 1,
		ty: 4,
		nm: "Shape Layer 2",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					646.5,
					462.5,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					46.5,
					-97.5,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												-251,
												-194
											],
											[
												-24,
												13
											]
										],
										c: false
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "tm",
								s: {
									a: 1,
									k: [
										{
											i: {
												x: [
													0.113
												],
												y: [
													1
												]
											},
											o: {
												x: [
													0.678
												],
												y: [
													0
												]
											},
											t: 16.457,
											s: [
												0
											]
										},
										{
											t: 38,
											s: [
												33
											]
										}
									],
									ix: 1
								},
								e: {
									a: 1,
									k: [
										{
											i: {
												x: [
													0
												],
												y: [
													1
												]
											},
											o: {
												x: [
													0.462
												],
												y: [
													0
												]
											},
											t: 16.457,
											s: [
												0
											]
										},
										{
											t: 33.857421875,
											s: [
												100
											]
										}
									],
									ix: 2
								},
								o: {
									a: 0,
									k: 0,
									ix: 3
								},
								m: 1,
								ix: 2,
								nm: "Trim Paths 1",
								mn: "ADBE Vector Filter - Trim",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.8627450980392157,
										0,
										0.1568627450980392,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 33,
									ix: 5
								},
								lc: 2,
								lj: 1,
								ml: 4,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Shape 1",
						np: 4,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								-65.5,
								-90.5
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								-137.5,
								-90.5
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								-100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 2",
				np: 1,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												-251,
												-194
											],
											[
												-24,
												13
											]
										],
										c: false
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "tm",
								s: {
									a: 1,
									k: [
										{
											i: {
												x: [
													0.113
												],
												y: [
													1
												]
											},
											o: {
												x: [
													0.678
												],
												y: [
													0
												]
											},
											t: 9,
											s: [
												0
											]
										},
										{
											t: 30.54296875,
											s: [
												33
											]
										}
									],
									ix: 1
								},
								e: {
									a: 1,
									k: [
										{
											i: {
												x: [
													0
												],
												y: [
													1
												]
											},
											o: {
												x: [
													0.462
												],
												y: [
													0
												]
											},
											t: 9,
											s: [
												0
											]
										},
										{
											t: 26.400390625,
											s: [
												100
											]
										}
									],
									ix: 2
								},
								o: {
									a: 0,
									k: 0,
									ix: 3
								},
								m: 1,
								ix: 2,
								nm: "Trim Paths 1",
								mn: "ADBE Vector Filter - Trim",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.8627450980392157,
										0,
										0.1568627450980392,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 33,
									ix: 5
								},
								lc: 2,
								lj: 1,
								ml: 4,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Shape 1",
						np: 4,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								-137.5,
								-90.5
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								-137.5,
								-90.5
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 1,
				cix: 2,
				bm: 0,
				ix: 2,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 6,
		op: 92,
		st: 6,
		bm: 0
	},
	{
		ddd: 0,
		ind: 2,
		ty: 4,
		nm: "Shape Layer 4",
		td: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					646.5,
					462.5,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					46.5,
					-97.5,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												-251,
												-194
											],
											[
												-24,
												13
											]
										],
										c: false
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "tm",
								s: {
									a: 1,
									k: [
										{
											i: {
												x: [
													0.113
												],
												y: [
													1
												]
											},
											o: {
												x: [
													0.678
												],
												y: [
													0
												]
											},
											t: 16.457,
											s: [
												0
											]
										},
										{
											t: 38,
											s: [
												33
											]
										}
									],
									ix: 1
								},
								e: {
									a: 1,
									k: [
										{
											i: {
												x: [
													0
												],
												y: [
													1
												]
											},
											o: {
												x: [
													0.462
												],
												y: [
													0
												]
											},
											t: 16.457,
											s: [
												0
											]
										},
										{
											t: 33.857421875,
											s: [
												100
											]
										}
									],
									ix: 2
								},
								o: {
									a: 0,
									k: 0,
									ix: 3
								},
								m: 1,
								ix: 2,
								nm: "Trim Paths 1",
								mn: "ADBE Vector Filter - Trim",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.8627450980392157,
										0,
										0.1568627450980392,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 57,
									ix: 5
								},
								lc: 2,
								lj: 1,
								ml: 4,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Shape 1",
						np: 4,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								-65.5,
								-90.5
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								-137.5,
								-90.5
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								-100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 2",
				np: 1,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												-251,
												-194
											],
											[
												-24,
												13
											]
										],
										c: false
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "tm",
								s: {
									a: 1,
									k: [
										{
											i: {
												x: [
													0.113
												],
												y: [
													1
												]
											},
											o: {
												x: [
													0.678
												],
												y: [
													0
												]
											},
											t: 9,
											s: [
												0
											]
										},
										{
											t: 30.54296875,
											s: [
												33
											]
										}
									],
									ix: 1
								},
								e: {
									a: 1,
									k: [
										{
											i: {
												x: [
													0
												],
												y: [
													1
												]
											},
											o: {
												x: [
													0.462
												],
												y: [
													0
												]
											},
											t: 9,
											s: [
												0
											]
										},
										{
											t: 26.400390625,
											s: [
												100
											]
										}
									],
									ix: 2
								},
								o: {
									a: 0,
									k: 0,
									ix: 3
								},
								m: 1,
								ix: 2,
								nm: "Trim Paths 1",
								mn: "ADBE Vector Filter - Trim",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.8627450980392157,
										0,
										0.1568627450980392,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 57,
									ix: 5
								},
								lc: 2,
								lj: 1,
								ml: 4,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Shape 1",
						np: 4,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								-137.5,
								-90.5
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								-137.5,
								-90.5
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 1,
				cix: 2,
				bm: 0,
				ix: 2,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 6,
		op: 92,
		st: 6,
		bm: 0
	},
	{
		ddd: 0,
		ind: 3,
		ty: 4,
		nm: "Box",
		tt: 2,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					500.293,
					502.219,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					2.293,
					-47.781,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ty: "rc",
						d: 1,
						s: {
							a: 0,
							k: [
								398.586,
								400.438
							],
							ix: 2
						},
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 4
						},
						nm: "Rectangle Path 1",
						mn: "ADBE Vector Shape - Rect",
						hd: false
					},
					{
						ty: "rd",
						nm: "Round Corners 1",
						r: {
							a: 0,
							k: 512,
							ix: 1
						},
						ix: 2,
						mn: "ADBE Vector Filter - RC",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.8627450980392157,
								0,
								0.1568627450980392,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 33,
							ix: 5
						},
						lc: 2,
						lj: 2,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								2.293,
								-47.781
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Rectangle 1",
				np: 4,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "tm",
				s: {
					a: 0,
					k: 0,
					ix: 1
				},
				e: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.403
								],
								y: [
									0
								]
							},
							t: 0,
							s: [
								0
							]
						},
						{
							t: 24,
							s: [
								100
							]
						}
					],
					ix: 2
				},
				o: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.403
								],
								y: [
									0
								]
							},
							t: 0,
							s: [
								0
							]
						},
						{
							t: 24,
							s: [
								55
							]
						}
					],
					ix: 3
				},
				m: 1,
				ix: 2,
				nm: "Trim Paths 1",
				mn: "ADBE Vector Filter - Trim",
				hd: false
			}
		],
		ip: 0,
		op: 91,
		st: 0,
		bm: 0
	}
];
var markers = [
];
var animationData = {
	v: v,
	fr: fr,
	ip: ip,
	op: op,
	w: w,
	h: h,
	nm: nm,
	ddd: ddd,
	assets: assets,
	layers: layers,
	markers: markers
};

var useStyles$a = makeStyles(function (theme) { return ({
    media: {
        backgroundColor: fade(theme.palette.primary.main, 0.25),
        padding: "10px"
    }
}); });
function NotFound(props) {
    var classes = useStyles$a(props);
    var defaultOptions = {
        loop: false,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice"
        }
    };
    return (React__default.createElement(Box, { display: "flex", alignItems: "center", justifyContent: "center", height: "calc(100vh - 92px)", padding: "20px" },
        React__default.createElement(Card$1, { style: { maxWidth: "380px" } },
            React__default.createElement(CardMedia$1, { className: classes.media },
                React__default.createElement(Lottie, __assign$2({}, defaultOptions, { style: { height: "150px", width: "200px", margin: "auto" } }))),
            React__default.createElement(CardContent$1, null,
                React__default.createElement(Typography$1, { variant: "h6" }, "P\u00E1gina no encontrada"),
                React__default.createElement("br", null),
                React__default.createElement(Typography$1, { variant: "body2" }, "Lo sentimos, no hemos encontrado la p\u00E1gina a la que est\u00E1s intentando acceder."),
                React__default.createElement("br", null),
                React__default.createElement(Typography$1, { variant: "caption" },
                    "URL: ",
                    window.location.pathname)),
            React__default.createElement(CardActions, { style: { float: "right" } },
                React__default.createElement(Button$1, { component: Link, to: "/", variant: "text", color: "primary" }, "Volver al inicio")))));
}

function toVal(mix) {
	var k, y, str='';

	if (typeof mix === 'string' || typeof mix === 'number') {
		str += mix;
	} else if (typeof mix === 'object') {
		if (Array.isArray(mix)) {
			for (k=0; k < mix.length; k++) {
				if (mix[k]) {
					if (y = toVal(mix[k])) {
						str && (str += ' ');
						str += y;
					}
				}
			}
		} else {
			for (k in mix) {
				if (mix[k]) {
					str && (str += ' ');
					str += k;
				}
			}
		}
	}

	return str;
}

function clsx () {
	var i=0, tmp, x, str='';
	while (i < arguments.length) {
		if (tmp = arguments[i++]) {
			if (x = toVal(tmp)) {
				str && (str += ' ');
				str += x;
			}
		}
	}
	return str;
}

var TRANSPARENT = "rgba(0,0,0,0)";
var useMenuItemStyles$1 = makeStyles$1(function (theme) { return ({
    root: function (props) { return ({
        backgroundColor: props.open ? theme.palette.action.hover : TRANSPARENT
    }); },
    menuContainer: {
        '& .MuiPaper-rounded': {
            borderRadius: 0,
        },
        '& ul.MuiList-padding': {
            paddingTop: 0,
            paddingBottom: 0,
        },
    },
    dropdownList: {
        padding: 0,
        '& li span:first-of-type': {
            fontSize: '12px',
            color: theme.palette.secondary.main,
        },
        '& .MuiMenuItem-gutters': {
            paddingRight: 0,
            background: 'transparent !important',
            '& .MuiTouchRipple-root': {
                display: 'none',
            },
        },
    },
    dropdownItem: {
        opacity: 1,
        '&:hover': {
            background: '#f4f4f4',
        }
    },
    dropdownListSeparator: {
        borderBottom: '1px solid #d6d8d8',
        background: '#fff',
        '& .MuiTouchRipple-root': {
            display: 'none',
        },
    },
    itemIcon: {
        fontSize: '12px',
        color: theme.palette.secondary.main,
        padding: '0 .5rem',
    },
}); });
/**
 * Use as a drop-in replacement for `<MenuItem>` when you need to add cascading
 * menu elements as children to this component.
 */
var NestedMenuItem = React__default.forwardRef(function NestedMenuItem(props, ref) {
    var iconsStyles = useMenuItemStyles$1(props);
    var parentMenuOpen = props.parentMenuOpen, label = props.label, _a = props.rightIcon, rightIcon = _a === void 0 ? (React__default.createElement(IconFlechaDerecha, { className: iconsStyles.itemIcon })) : _a, children = props.children, className = props.className, tabIndexProp = props.tabIndex, _b = props.ContainerProps, ContainerPropsProp = _b === void 0 ? {} : _b, MenuItemProps = __rest(props, ["parentMenuOpen", "label", "rightIcon", "children", "className", "tabIndex", "ContainerProps"]);
    var containerRefProp = ContainerPropsProp.ref, ContainerProps = __rest(ContainerPropsProp, ["ref"]);
    var menuItemRef = useRef(null);
    useImperativeHandle(ref, function () { return menuItemRef.current; });
    var containerRef = useRef(null);
    useImperativeHandle(containerRefProp, function () { return containerRef.current; });
    var menuContainerRef = useRef(null);
    var _c = useState(false), isSubMenuOpen = _c[0], setIsSubMenuOpen = _c[1];
    var handleMouseEnter = function (event) {
        setIsSubMenuOpen(true);
        if (ContainerProps === null || ContainerProps === void 0 ? void 0 : ContainerProps.onMouseEnter) {
            ContainerProps.onMouseEnter(event);
        }
    };
    var handleMouseLeave = function (event) {
        setIsSubMenuOpen(false);
        if (ContainerProps === null || ContainerProps === void 0 ? void 0 : ContainerProps.onMouseLeave) {
            ContainerProps.onMouseLeave(event);
        }
    };
    // Check if any immediate children are active
    var isSubmenuFocused = function () {
        var _a, _b, _c, _d;
        var active = (_b = (_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.ownerDocument) === null || _b === void 0 ? void 0 : _b.activeElement;
        for (var _i = 0, _e = (_d = Array.prototype.slice.call((_c = menuContainerRef.current) === null || _c === void 0 ? void 0 : _c.children)) !== null && _d !== void 0 ? _d : []; _i < _e.length; _i++) {
            var child = _e[_i];
            if (child === active) {
                return true;
            }
        }
        return false;
    };
    var handleFocus = function (event) {
        if (event.target === containerRef.current) {
            setIsSubMenuOpen(true);
        }
        if (ContainerProps === null || ContainerProps === void 0 ? void 0 : ContainerProps.onFocus) {
            ContainerProps.onFocus(event);
        }
    };
    var handleKeyDown = function (event) {
        var _a, _b, _c, _d;
        if (event.key === "Escape") {
            return;
        }
        if (isSubmenuFocused()) {
            event.stopPropagation();
        }
        var active = (_b = (_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.ownerDocument) === null || _b === void 0 ? void 0 : _b.activeElement;
        if (event.key === "ArrowLeft" && isSubmenuFocused()) {
            (_c = containerRef.current) === null || _c === void 0 ? void 0 : _c.focus();
        }
        if (event.key === "ArrowRight" &&
            event.target === containerRef.current &&
            event.target === active) {
            var firstChild = (_d = menuContainerRef.current) === null || _d === void 0 ? void 0 : _d.children[0];
            firstChild === null || firstChild === void 0 ? void 0 : firstChild.focus();
        }
    };
    var open = isSubMenuOpen && parentMenuOpen;
    var menuItemClasses = useMenuItemStyles$1({ open: open });
    // Root element must have a `tabIndex` attribute for keyboard navigation
    var tabIndex;
    if (!props.disabled) {
        tabIndex = tabIndexProp !== undefined ? tabIndexProp : -1;
    }
    return (React__default.createElement("li", { className: [menuItemClasses.dropdownItem, menuItemClasses.dropdownListSeparator].join(" ") },
        React__default.createElement("div", __assign$2({}, ContainerProps, { ref: containerRef, onFocus: handleFocus, tabIndex: tabIndex, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, onClick: handleMouseLeave, onKeyDown: handleKeyDown }),
            React__default.createElement("ul", { className: menuItemClasses.dropdownList },
                React__default.createElement(Enlace, { actualizarIdClick: props.actualizarIdClick, to: props.to },
                    React__default.createElement(MenuItem, __assign$2({}, MenuItemProps, { className: clsx(menuItemClasses.root, className), ref: menuItemRef }),
                        label,
                        rightIcon))),
            React__default.createElement(Menu
            // Set pointer events to 'none' to prevent the invisible Popover div
            // from capturing events for clicks and hovers
            , { 
                // Set pointer events to 'none' to prevent the invisible Popover div
                // from capturing events for clicks and hovers
                style: { pointerEvents: "none" }, PaperProps: {
                    style: {
                        pointerEvents: 'auto',
                        overflowY: 'scroll',
                        maxHeight: 'calc(100vh-64px)',
                    }
                }, anchorEl: menuItemRef.current, anchorOrigin: {
                    vertical: "top",
                    horizontal: "right"
                }, transformOrigin: {
                    vertical: "top",
                    horizontal: "left"
                }, open: open, autoFocus: false, disableAutoFocus: true, disableEnforceFocus: true, onClose: function () {
                    setIsSubMenuOpen(false);
                }, className: menuItemClasses.menuContainer },
                React__default.createElement("li", { className: menuItemClasses.dropdownItem },
                    React__default.createElement("div", { ref: menuContainerRef },
                        React__default.createElement("ul", { className: menuItemClasses.dropdownList }, children)))))));
});

var useMenuItemStyles = makeStyles$1(function (theme) { return ({
    menuContainer: {
        position: 'inherit',
        '& ': {
            top: '58px !important',
        },
        '& .MuiPaper-rounded': {
            borderRadius: 0,
            marginTop: '42px',
            position: 'fixed',
            zIndex: 2
        },
        '& ul.MuiList-padding': {
            paddingTop: 0,
            paddingBottom: 0,
            '& a': {
                width: '100% !important',
            },
        },
        '& .MuiListItem-button:hover': {
            background: 'transparent !important',
        }
    },
    menuItem: {
        opacity: 1,
        '& .MuiButton-text': {
            padding: "15px 12px",
            '@media screen and (max-width: 1400px)': {
                padding: "15px 5px",
                minWidth: "0",
            }
        },
        '& a': {
            height: '58px',
        },
        '& .MuiTypography-root': {
            color: '#fff',
            fontSize: '14px',
            '@media screen and (max-width: 1400px)': {
                fontSize: '12px',
            }
        },
        '& a:hover,  span:hover': {
            '& .MuiButton-root': {
                background: '#fff',
                color: '#DC0028',
                fontWeight: 'bold',
                '& .MuiTypography-root': {
                    color: '#DC0028',
                    fontWeight: 'bold !important',
                }
            }
        },
        '& .MuiButton-root': {
            height: '58px',
            transition: 'none',
            borderRadius: '0px',
        },
        '& .MuiButton-root:hover, .MuiButton-root:focus, .MuiButton-root:active': {
            backgroundColor: 'transparent',
        },
        '& .MuiTouchRipple-root': {
            display: 'none',
        },
    },
    menuItemActive: {
        '& .MuiButton-root': {
            background: '#fff',
            color: '#DC0028',
            fontWeight: 'bold',
            '& .MuiTypography-root': {
                color: '#DC0028',
                fontWeight: 'bold !important',
            }
        },
    },
    dropdownList: {
        padding: 0,
    },
    dropdownItem: {
        opacity: 1,
        background: '#fff',
        '&:hover': {
            background: '#f4f4f4',
        },
    },
    dropdownItemRoot: {
        minWidth: '210px'
    },
    contDropdownItemTitle: {
        paddingRight: '30px',
    },
    dropdownItemTitle: {
        fontSize: '12px',
        //paddingRight: '30px',
        color: theme.palette.secondary.main,
    },
    dropdownListSeparator: {
        borderBottom: '1px solid #d6d8d8',
    },
    iconFlexContainer: {
        display: 'flex',
        paddingRight: 0,
        alignItems: 'center',
        justifyContent: 'space-between',
        position: 'relative',
    },
    iconWrapper: {
        position: 'absolute',
        right: 0,
        zIndex: 100,
        cursor: 'pointer',
        '& svg': {
            fontSize: '14px',
            paddingRight: '.5rem',
            '&:hover': {
                color: '#919191',
            },
            '&:active': {
                color: '#dc0028',
            },
        },
    },
    selected: {
        color: '#dc0028'
    },
    dropdownItemGroupTitle: {
        color: '#dc0028',
        fontWeight: 'bold',
        fontSize: '12px'
    },
    itemMenuReducidoyCompleto: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: '12px !important',
        color: '#505050',
        '&:hover $itemIconText': {
            opacity: 1,
            maxWidth: '160px'
        },
    },
    itemIcon: {
        padding: '0 0 0 0.5rem',
        fontSize: '12px !important',
        color: '#dc0028 !important'
    },
    itemIconText: {
        opacity: 0,
        maxWidth: '0px',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        color: '#dc0028 !important',
        textDecoration: 'underline'
    }
}); });
function AppBarLgMenu(props) {
    var _a;
    var menuItemClasses = useMenuItemStyles();
    var _b = React__default.useState(null), anchorEl = _b[0], setAnchorEl = _b[1];
    var _c = React__default.useState(false), mostrarModal = _c[0], setMostrarModal = _c[1];
    var _d = React__default.useState(null), mostrarUrlModal = _d[0], setMostrarUrlModal = _d[1];
    var menu = props.menu, selectedMenu = props.selectedMenu, hvcompleta = props.hasVersionCompleta;
    var _e = React__default.useState(props.hasVersionCompleta), hasVersionCompleta = _e[0], setHasVersionCompleta = _e[1];
    React__default.useEffect(function () {
        setHasVersionCompleta(hvcompleta);
    }, [hvcompleta]);
    var location = useLocation();
    var current = location.pathname.startsWith(menu.url);
    var cia = getCiaFromUrl();
    var mutate = useSWRConfig().mutate;
    var menusAgrupadosGestiona = [];
    var user = React__default.useContext(PortalContext).user;
    var handleClose = function () {
        setAnchorEl(null);
        if (props.onClose) {
            props.onClose();
        }
    };
    var handleOnMouseEnter = function (event) {
        if ((props.noExpandirMenu != null && props.noExpandirMenu == true && !esGestiona()) || (esGestiona() && !menusAgrupadosGestiona.includes(event.currentTarget.innerText))) {
            handleClose();
        }
        else {
            setAnchorEl(event.currentTarget);
            if (props.onOpen) {
                props.onOpen(menu.url);
            }
        }
    };
    var AddFavorito = function (menuId, titulo) {
        mutate(["favoritos", user === null || user === void 0 ? void 0 : user.id], function () {
            var _a, _b;
            return api.post((_b = (_a = props.favs) === null || _a === void 0 ? void 0 : _a.favsAddSvc) !== null && _b !== void 0 ? _b : "", {
                Entrada: {
                    Titulo: titulo,
                    Url: menuId,
                    Tipo: "Menu"
                }
            });
        }, false);
    };
    var DelFavorito = function (menuId, esAccesoRapido) {
        if (esAccesoRapido) {
            setMostrarUrlModal(menuId);
            setMostrarModal(true);
        }
        else {
            manejarAceptar(menuId);
        }
    };
    var manejarCierre = function () {
        setMostrarModal(false);
        setMostrarUrlModal(null);
    };
    var manejarAceptar = function (url) {
        mutate(["favoritos", user === null || user === void 0 ? void 0 : user.id], function () {
            var _a, _b;
            return api.post((_b = (_a = props.favs) === null || _a === void 0 ? void 0 : _a.favsDelSvc) !== null && _b !== void 0 ? _b : "", {
                Entrada: {
                    Url: url,
                    Tipo: "Menu"
                }
            });
        }, false);
        setMostrarModal(false);
        setMostrarUrlModal(null);
    };
    var favs = undefined;
    if (props.favs) {
        var options = { focusThrottleInterval: 1000 * 3600 * 4, revalidateOnMount: true, revalidateIfStale: false, revalidateOnFocus: false, revalidateOnReconnect: false, dedupingInterval: 1000 * 3600 * 4 };
        var data = useSWR(["favoritos", user === null || user === void 0 ? void 0 : user.id], function () { var _a, _b; return api.post((_b = (_a = props.favs) === null || _a === void 0 ? void 0 : _a.favsSvc) !== null && _b !== void 0 ? _b : "", { Entrada: {} }); }, options).data;
        favs = (_a = data === null || data === void 0 ? void 0 : data.Salida) === null || _a === void 0 ? void 0 : _a.Favoritos;
    }
    var getMenuItem = function (menuOption, favs, fatherExistsFavDescendent, fatherHasMostrarVersionCompleta, nivel) {
        var _a, _b;
        // debugger;
        var options = menuOption.enlaces != null && !esGestiona()
            ? menuOption.enlaces.filter(function (x) { return !x.oculto; })
            : null;
        var esFav = menuOption.id && favs && favs.find(function (x) { return x.Url != null && x.Url.toLowerCase() == menuOption.id.toLowerCase(); }) != null;
        var esAccesoRapido = menuOption.id && favs && favs.find(function (x) { return x.Url != null && x.Url.toLowerCase() == menuOption.id.toLowerCase() && (x.AccesoRapido != null); }) != null;
        var cia = getCiaFromUrl();
        var desarrollo = window.location.hostname.startsWith("d") || window.location.hostname.startsWith("w") || window.location.hostname.startsWith("localhost");
        if (options != null && options.length > 0) {
            var existsFavDescendent_1 = false;
            var components = options.map(function (enlace) { return !enlace.oculto && getMenuItem(enlace, favs, function (childFav) { {
                existsFavDescendent_1 = existsFavDescendent_1 || childFav;
            } }, fatherHasMostrarVersionCompleta, nivel + 1); });
            if (existsFavDescendent_1 && fatherExistsFavDescendent) {
                fatherExistsFavDescendent(existsFavDescendent_1);
            }
            return !(fatherHasMostrarVersionCompleta || existsFavDescendent_1) ? null : (React__default.createElement(NestedMenuItem, { to: menuOption.url, label: React__default.createElement("span", { style: { flexGrow: 1 } }, menuOption.titulo), key: menuOption.id, parentMenuOpen: !!anchorEl, onClick: handleClose }, components));
        }
        else {
            if (esFav && fatherExistsFavDescendent) {
                fatherExistsFavDescendent(esFav);
            }
            return !(fatherHasMostrarVersionCompleta || esFav) ? null : (React__default.createElement("div", null,
                React__default.createElement("li", { className: [menuItemClasses.dropdownItem, menuItemClasses.dropdownListSeparator, menuItemClasses.iconFlexContainer, nivel == 0 ? menuItemClasses.dropdownItemRoot : ""].join(" ") },
                    React__default.createElement(MenuItem$1, { key: menuOption.id, component: Enlace, to: menuOption.url, actualizarIdClick: props.actualizarIdClick, onClick: function () {
                            handleClose();
                        } },
                        React__default.createElement("div", { className: menuItemClasses.contDropdownItemTitle },
                            React__default.createElement("span", { className: menuItemClasses.dropdownItemTitle }, menuOption.titulo),
                            (cia != "PRE" || (cia === "PRE" && desarrollo)) && (menuOption.ventanaNueva || menuOption.popup) &&
                                !(menuOption.plantilla === "GCOAPP" && menuOption.tipo === "ENLACE") && !(menuOption.plantilla === "GCOAPP" && ((_a = menuOption.tipo) === null || _a === void 0 ? void 0 : _a.startsWith("PORTALINTRANET"))) &&
                                !(menuOption.plantilla === "GCOAPPSP" && menuOption.tipo === "ENLACE") && !(menuOption.plantilla === "GCOAPPSP" && ((_b = menuOption.tipo) === null || _b === void 0 ? void 0 : _b.startsWith("PORTALINTRANET"))) &&
                                React__default.createElement("i", { className: 'icon-enlace-ext', style: { fontSize: '17px', color: '#505050' } }))),
                    menuOption.id && props.favs && React__default.createElement("span", { className: menuItemClasses.iconWrapper },
                        React__default.createElement(IconEstrella, { style: { color: esFav ? "#dc0028" : "#505050" }, onClick: function (e) {
                                !esFav ? AddFavorito(menuOption.id, menuOption.titulo) : DelFavorito(menuOption.id, esAccesoRapido);
                                e.stopPropagation();
                            } }))),
                mostrarModal && mostrarUrlModal &&
                    React__default.createElement(CustomizedDialog, { title: "Eliminar favorito", open: mostrarModal, manejarCierre: manejarCierre, guardar: function () { return manejarAceptar(mostrarUrlModal); }, tituloAceptar: "Eliminar" },
                        React__default.createElement("p", null, "Este Favorito est\u00E1 marcado como Acceso R\u00E1pido, al eliminarlo tambi\u00E9n se eliminar\u00E1 el Acceso R\u00E1pido. \u00BFEst\u00E1s seguro de que quieres eliminarlo?"))));
        }
    };
    var groupByCabecera = function (enlaces, cia) {
        var grupos = {};
        var ciaShowGrouped = ["SBI", "SPU"];
        if (!ciaShowGrouped.includes(cia)) {
            var x = null;
            grupos[x] = enlaces;
        }
        else {
            enlaces.forEach(function (enlace) {
                if (grupos[enlace.cabecera]) {
                    grupos[enlace.cabecera].push(enlace);
                }
                else {
                    grupos[enlace.cabecera] = [enlace];
                }
            });
        }
        return grupos;
    };
    var esMenuAgrupGestiona = false;
    if (esGestiona() && menu.origen === "GRUPO") {
        menusAgrupadosGestiona.push(menu.titulo);
        esMenuAgrupGestiona = true;
    }
    return (React__default.createElement("div", { className: menuItemClasses.menuItem },
        React__default.createElement(Enlace, { actualizarIdClick: props.actualizarIdClick, origen: menu.origen, to: esMenuAgrupGestiona ? window.location.pathname : menu.url, className: menu.url === selectedMenu ? menuItemClasses.menuItemActive : "" },
            React__default.createElement(Button$1, { "aria-haspopup": "true", "aria-label": menu.titulo, onMouseEnter: handleOnMouseEnter, onTouchStart: handleOnMouseEnter, variant: "text", disableElevation: true },
                React__default.createElement(Typography$1, { variant: "caption", style: {
                        textDecoration: "none",
                        textTransform: "none",
                        fontFamily: "CO-Medium",
                        fontWeight: current ? "bold" : "normal",
                        borderBottom: current ? "2px solid white" : "2px solid transparent"
                    } }, menu.titulo))),
        React__default.createElement(Menu$1, { anchorEl: anchorEl, keepMounted: true, BackdropProps: {
                style: {
                    pointerEvents: "auto",
                    backgroundColor: "#50505050",
                    marginTop: "59px"
                }
            }, disableEnforceFocus: true, open: menu.url === selectedMenu, anchorOrigin: {
                vertical: "top",
                horizontal: "left"
            }, transformOrigin: {
                vertical: "top",
                horizontal: "left"
            }, MenuListProps: {
                style: { pointerEvents: "auto" }
            }, onClose: handleClose, className: menuItemClasses.menuContainer },
            (hasVersionCompleta || !hasVersionCompleta) && (props.noExpandirMenu == null || props.noExpandirMenu == false || esGestiona()) && menu.enlaces && Object.entries(groupByCabecera(menu.enlaces.filter(function (x) { return !x.oculto; }), cia)).map(function (grupo) {
                var showMessage = true;
                return React__default.createElement(React__default.Fragment, null,
                    grupo[0] !== 'null' &&
                        (React__default.createElement("li", { className: [menuItemClasses.dropdownItem, menuItemClasses.dropdownListSeparator].join(" ") },
                            React__default.createElement(MenuItem$1, { key: grupo[0], onClick: function (e) { e.stopPropagation(); } },
                                React__default.createElement("span", { className: menuItemClasses.dropdownItemGroupTitle }, grupo[0])))),
                    grupo[1].map(function (enlace) {
                        var value = getMenuItem(enlace, favs, function (childFav) { }, hasVersionCompleta, 0);
                        if (showMessage && value != null)
                            showMessage = false;
                        return value;
                    }),
                    showMessage && !hasVersionCompleta && React__default.createElement("li", { className: [menuItemClasses.dropdownItem, menuItemClasses.dropdownListSeparator, menuItemClasses.itemMenuReducidoyCompleto, menuItemClasses.dropdownItemRoot].join(" ") },
                        React__default.createElement(MenuItem$1, { key: "NoInfoMenuReducido" }, React__default.createElement("div", { className: menuItemClasses.itemMenuReducidoyCompleto },
                            React__default.createElement("span", null,
                                " ",
                                "No hay favoritos añadidos")))));
            }),
            !props.hasVersionCompleta && React__default.createElement("li", { className: [menuItemClasses.dropdownItem, menuItemClasses.dropdownListSeparator, menuItemClasses.itemMenuReducidoyCompleto, menuItemClasses.dropdownItemRoot].join(" "), onClick: function (e) { setHasVersionCompleta(!hasVersionCompleta); e.stopPropagation(); } },
                React__default.createElement(MenuItem$1, { key: "ShowMenuReducido" },
                    hasVersionCompleta && React__default.createElement("div", { className: menuItemClasses.itemMenuReducidoyCompleto },
                        React__default.createElement("span", { className: menuItemClasses.itemIconText },
                            " ",
                            "Ver menos opciones de menú"),
                        React__default.createElement(IconArriba, { className: menuItemClasses.itemIcon })),
                    !hasVersionCompleta && React__default.createElement("div", { className: menuItemClasses.itemMenuReducidoyCompleto },
                        React__default.createElement("span", { className: menuItemClasses.itemIconText },
                            " ",
                            "Ver más opciones de menú"),
                        React__default.createElement(IconAbajo, { className: menuItemClasses.itemIcon })))))));
}

var useStyles$9 = makeStyles$1(function () { return ({
    root: {
        width: "400px",
        maxWidth: "90vw",
        textAlign: "start",
        position: "absolute",
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        margin: "auto auto",
        height: "387px",
    },
    content: {
        paddingBottom: "0px"
    }
}); });
function About() {
    var _a, _b;
    var classes = useStyles$9();
    var logo = getCiaBuilding();
    var portal = getPortalTitle();
    var _c = useContext(PortalContext), app = _c.app, session = _c.session, user = _c.user;
    return (React__default.createElement(Card, { className: classes.root, elevation: 0 },
        React__default.createElement(CardContent, { className: classes.content },
            React__default.createElement(Typography, { gutterBottom: true, variant: "h6", color: "secondary", style: { fontWeight: "bold" } },
                app.name,
                " ",
                portal),
            React__default.createElement(Paper, { style: { backgroundColor: "#fafafa", marginBottom: "4px", padding: "8px" }, elevation: 0 },
                React__default.createElement(List, { dense: true },
                    React__default.createElement(ListItemText, { primary: "Versi\u00F3n", primaryTypographyProps: { variant: "caption" }, secondary: ((_a = app.package) !== null && _a !== void 0 ? _a : "---") + " " + ((_b = app.version) !== null && _b !== void 0 ? _b : "---") }),
                    React__default.createElement(ListItemText, { primary: "Usuario", primaryTypographyProps: { variant: "caption" }, secondary: user === null || user === void 0 ? void 0 : user.user }),
                    React__default.createElement(ListItemText, { primary: "Sesi\u00F3n", primaryTypographyProps: { variant: "caption" }, secondary: session })))),
        React__default.createElement(CardMedia, { component: "img", alt: portal, image: logo, title: portal, height: "160px" })));
}

var useStyles$8 = makeStyles(function (theme) {
    var _a;
    return ({
        userAvatar: {
            color: theme.palette.primary.main,
            backgroundColor: alpha(theme.palette.primary.contrastText, 0.95),
        },
        userAvatarText: {
            fontFamily: "CO-Medium"
        },
        primaryContrastText: {
            color: theme.palette.primary.contrastText,
        },
        small: {
            padding: '4px !important'
        },
        search: (_a = {
                position: "relative",
                borderRadius: theme.shape.borderRadius,
                backgroundColor: alpha(theme.palette.common.white, 0.15),
                "&:hover": {
                    backgroundColor: alpha(theme.palette.common.white, 0.25)
                },
                marginRight: theme.spacing(2),
                marginLeft: 0,
                width: "100%"
            },
            _a[theme.breakpoints.up("sm")] = {
                marginLeft: theme.spacing(3),
                width: "auto"
            },
            _a),
        searchIcon: {
            padding: theme.spacing(0, 1),
            paddingTop: "3px",
            height: "100%",
            position: "absolute",
            pointerEvents: "none",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: alpha(theme.palette.common.white, 0.95)
        },
        optionsList: {
            padding: '.5rem 0',
        },
        userOptions: {
            '& > a': {
                paddingTop: '0',
                paddingBottom: '0',
                '& .optionName span': {
                    fontSize: '14px',
                    color: theme.palette.secondary.main,
                }
            },
        },
        optionsAbout: {
            paddingTop: '0',
            paddingBottom: '0',
            marginTop: '.5rem',
            marginBottom: '.5rem',
            '& span': {
                fontSize: '14px',
                color: theme.palette.secondary.main,
            },
        },
        userProfile: {
            backgroundColor: theme.palette.primary.main,
            textAlign: "center",
            padding: theme.spacing(3, 2)
        },
        userProfileAvatarContainer: {
            padding: theme.spacing(0, 0, 1.5)
        },
        userProfileAvatar: {
            height: "60px",
            width: "60px",
            margin: "auto",
            color: theme.palette.primary.main,
            backgroundColor: alpha(theme.palette.primary.contrastText, 0.95),
        },
        cerrarMenuUsuario: {
            position: 'absolute',
            left: '4px',
            top: '0px',
            marginTop: '20px',
            paddingLeft: '16px',
            boxSizing: 'border-box',
            marginBottom: '15px',
            cursor: 'pointer',
            '& .MuiSvgIcon-root': {
                height: '20px',
                width: '20px',
                color: '#fff',
                opacity: '0.8',
                '&:hover': {
                    color: '#fff',
                },
                '&:focus, &:active': {
                    opacity: '1',
                }
            }
        },
        onlyMobile: {
            display: 'none',
            '@media screen and (max-width: 1115px)': {
                display: 'block',
            },
        },
        mostrarSimuladoStyle: {
            display: 'none',
        },
        simUserAvatar: {
            border: "3px solid #35516d"
        },
        simUserProfileAvatar: {
            border: "3px solid #35516d"
        },
        gcoMessageUserSimu: {
            padding: theme.spacing(1, 2),
            color: "#fff",
            fontSize: "14px",
            backgroundColor: "#35516d",
            textAlign: "center",
            '& a ': {
                color: "#fff",
                textDecoration: "underline",
                '&:hover': {
                    opacity: "0.8",
                }
            }
        },
        defaultIcon: {
            fontWeight: 'bold',
            fontSize: '2rem',
            marginBottom: 5
        },
        mostrarUserCodeAppBarUser: {
            color: theme.palette.primary.contrastText,
            fontFamily: "CO-Medium",
            fontWeight: "normal",
            paddingRight: "5px",
            fontSize: '14px',
            '@media screen and (max-width: 1400px)': {
                fontSize: '12px',
            }
        }
    });
});
function AppBarUser(props) {
    var _a, _b, _c, _d, _e;
    var _f = useContext(PortalContext), user = _f.user, mostrarUserCodeAppBarUser = _f.mostrarUserCodeAppBarUser;
    var _g = useState(false), userDrawerVisible = _g[0], setUserDrawerVisible = _g[1];
    var _h = useState(false), aboutVisible = _h[0], setAboutVisible = _h[1];
    var classes = useStyles$8(props);
    var closeUserDrawer = function () {
        setUserDrawerVisible(false);
    };
    var openUserDrawer = function () {
        setUserDrawerVisible(true);
    };
    var openAbout = function () {
        closeUserDrawer();
        setAboutVisible(true);
    };
    var closeAbout = function () {
        setAboutVisible(false);
    };
    //var desarrollo = window.location.hostname.startsWith("d") || window.location.hostname.startsWith("w") || window.location.hostname.startsWith("localhost");
    var listaOpciones = [];
    listaOpciones.push({ titulo: "Mi fotografía", url: "/aplicacion/?aplicacion=AplicacionesGCO&urlTransaccion=FE/ARQ.AppInt.Fotos.FE.MiFotografia/", className: classes.userOptions });
    listaOpciones.push({ titulo: "Soporte", url: "/utilidades/soporte", className: classes.userOptions + " " + classes.onlyMobile });
    listaOpciones.push({ titulo: "Buzones", url: "/buzones", className: classes.userOptions + " " + classes.onlyMobile });
    if (props.mostrarSimulado)
        listaOpciones.push({ titulo: "Simular usuario", url: "/aplicacion/?aplicacion=AplicacionesSCO&urlTransaccion=FE/TPG.Seguridad.Web.FE.Tssu/", className: classes.userOptions });
    listaOpciones.push({ titulo: "Cambiar contraseña", url: "/aplicacion/?aplicacion=AplicacionesGCO&urlTransaccion=FE/ARQ.AppInt.Passw.FE.CambioPasswUsr/", className: classes.userOptions });
    if (props.mostrarContactoDigital)
        listaOpciones.push({ titulo: "Contacto Digital", url: "/aplicacion/?aplicacion=AplicacionesGCO&urlTransaccion=FE/ARQ.AppInt.Tarjeta.FE.TarjetaUsuario/", className: classes.userOptions });
    listaOpciones.push({ titulo: "Cerrar sesión", url: "/logout", className: classes.userOptions });
    var iconMarquesina;
    if (props && (props === null || props === void 0 ? void 0 : props.marquesina)) {
        var copy = __assign$2({}, (props.marquesina.props));
        copy['onlyIcon'] = true;
        iconMarquesina = __assign$2(__assign$2({}, props.marquesina), { props: copy });
    }
    return React__default.createElement(React__default.Fragment, null,
        React__default.createElement(IconButton$1, { className: classes.small, onClick: openUserDrawer, "aria-label": "Usuario" },
            mostrarUserCodeAppBarUser &&
                React__default.createElement(Typography$1, { variant: "caption", className: classes.mostrarUserCodeAppBarUser }, (_a = user === null || user === void 0 ? void 0 : user.id) === null || _a === void 0 ? void 0 : _a.toLowerCase()),
            React__default.createElement(Avatar, { variant: "circular", className: ((_b = user === null || user === void 0 ? void 0 : user.simulatedUser) === null || _b === void 0 ? void 0 : _b.codigoUsuario) ? [classes.userAvatar, classes.simUserAvatar].join(' ') : classes.userAvatar, src: (user === null || user === void 0 ? void 0 : user.foto) !== null ? api.getApiServer() + (user === null || user === void 0 ? void 0 : user.foto) : "" },
                React__default.createElement("i", { className: "icon-contactos " + classes.defaultIcon })),
            props.marquesina && iconMarquesina),
        React__default.createElement(Drawer, { anchor: "right", open: userDrawerVisible, onClose: closeUserDrawer },
            React__default.createElement("div", { role: "presentation", style: { width: "300px" } },
                React__default.createElement(Paper, { variant: "elevation", square: true, color: "primary", elevation: 2, className: classes.userProfile },
                    React__default.createElement("div", { className: classes.userProfileAvatarContainer },
                        React__default.createElement("div", { className: classes.cerrarMenuUsuario, onClick: closeUserDrawer },
                            React__default.createElement(IconCerrar, null)),
                        React__default.createElement(IconButton$1, { className: classes.small, component: Enlace, to: "/aplicacion/?aplicacion=AplicacionesGCO&urlTransaccion=FE/ARQ.AppInt.Fotos.FE.MiFotografia/", onClick: closeUserDrawer, "aria-label": "Usuario" },
                            React__default.createElement(Avatar, { variant: "circular", src: (user === null || user === void 0 ? void 0 : user.foto) !== null ? api.getApiServer() + (user === null || user === void 0 ? void 0 : user.foto) : "", className: ((_c = user === null || user === void 0 ? void 0 : user.simulatedUser) === null || _c === void 0 ? void 0 : _c.codigoUsuario) ? [classes.userProfileAvatar, classes.simUserProfileAvatar].join(' ') : classes.userProfileAvatar },
                                React__default.createElement("i", { className: 'icon-contactos', style: { fontWeight: 'bold', fontSize: '2.5rem', marginBottom: 5 } })))),
                    React__default.createElement(Typography$1, { variant: "body2", className: classes.primaryContrastText }, user === null || user === void 0 ? void 0 : user.dn),
                    (user === null || user === void 0 ? void 0 : user.upn) && React__default.createElement(React__default.Fragment, null,
                        React__default.createElement(Typography$1, { variant: "caption", className: classes.primaryContrastText }, user === null || user === void 0 ? void 0 : user.upn),
                        React__default.createElement("br", null)),
                    React__default.createElement(Typography$1, { variant: "caption", className: classes.primaryContrastText }, (user === null || user === void 0 ? void 0 : user.ttl) + " - " + (user === null || user === void 0 ? void 0 : user.dpt))),
                ((_d = user === null || user === void 0 ? void 0 : user.simulatedUser) === null || _d === void 0 ? void 0 : _d.codigoUsuario) &&
                    React__default.createElement(Paper, { variant: "outlined", square: true, color: "secondary", elevation: 1, className: classes.gcoMessageUserSimu },
                        React__default.createElement(Typography$1, { variant: "body2" },
                            "Sesi\u00F3n iniciada con los permisos de ",
                            React__default.createElement("br", null),
                            React__default.createElement("b", null, (_e = user === null || user === void 0 ? void 0 : user.simulatedUser) === null || _e === void 0 ? void 0 : _e.nombreUsuario),
                            ".",
                            React__default.createElement("br", null),
                            "Para desconectarse ",
                            React__default.createElement(Enlace, { to: "/aplicacion/?aplicacion=AplicacionesSCO&urlTransaccion=FE/TPG.Seguridad.Web.FE.Tssu/" }, "pulse aqu\u00ED"))),
                React__default.createElement(Paper, { variant: "outlined", square: true, color: "secondary", elevation: 1 },
                    props.marquesina && props.marquesina,
                    React__default.createElement(List, { disablePadding: true, className: classes.optionsList }, listaOpciones.map(function (item) { return (React__default.createElement("li", { className: item.className },
                        React__default.createElement(ListItem, { button: true, component: Enlace, to: item.url, key: item.titulo }, React__default.createElement(ListItemText, { onClick: closeUserDrawer, primary: item.titulo, className: "optionName" })))); })))),
            React__default.createElement(ListItem, { button: true, className: classes.optionsAbout },
                React__default.createElement(ListItemText, { onClick: openAbout, primary: "Acerca de..." }))),
        React__default.createElement(Modal$1, { open: aboutVisible, onClose: closeAbout },
            React__default.createElement(About, null)));
}

var useStyles$7 = makeStyles(function (theme) { return ({
    menu: {
        flexGrow: 1,
        textAlign: "left",
        '@media screen and (max-width: 1115px)': {
            width: 'calc(100vw - 500px)',
        },
    },
    menuGestiona: {
        flexGrow: 1,
        textAlign: "left",
        '@media screen and (max-width: 980px)': {
            width: 'calc(100vw - 380px)',
        },
    },
    logoCompany: {
        margin: 0,
        '& > a': {
            height: '58px',
            float: 'left',
        }
    },
    title: {
        color: theme.palette.primary.main
    },
    menuCentro: {
        flexGrow: 1,
        display: 'flex',
        justifyContent: 'center',
    },
    logoCompanyImage: {
        position: "relative",
        height: '60px',
        top: "0px",
        left: "-19px",
        '@media screen and (max-width: 1450px)': {
            maxWidth: '140px !important',
            marginTop: '-3px',
            left: '0px'
        },
        '@media screen and (min-width: 1451px) and (max-width: 1500px)': {
            maxWidth: '200px !important',
            marginTop: '-3px',
            left: '0px'
        }
    },
    toolBarCustom: {
        '@media screen and (max-width: 1450px)': {
            paddingLeft: '10px',
            paddingRight: '10px',
        }
    },
    headerMain: {
        boxSizing: "border-box",
        width: "100%",
    },
    containerToolBarIcon: {
        borderLeft: '1px solid',
        borderRight: '1px solid',
        height: '100%',
        display: 'inline-block',
        '& .MuiIconButton-root:hover': {
            background: 'transparent',
        },
        '& .MuiIconButton-root': {
            borderRadius: '0%'
        },
        '& .MuiTouchRipple-root': {
            display: 'none',
        },
        '& .MuiButtonBase-root': {
            paddingRight: '12px',
            paddingLeft: '14px',
            height: '100%',
            transition: 'none',
        },
        '& .MuiButtonBase-root:first-child': {
            borderRadius: '0px',
            paddingRight: '8px',
            '@media screen and (max-width: 1200px)': {
                paddingRight: '5px',
            },
            '&::before': {
                content: '" "',
                borderRight: '1px solid #fff',
                position: 'absolute',
                right: '0px',
                height: 'calc(100% + 10px)',
                top: '-9px',
            },
        },
    },
    containerToolBarNoSearch: {
        borderLeft: '1px solid',
        height: '100%',
        display: 'inline-block',
        '& .MuiIconButton-root:hover': {
            background: 'transparent',
        },
        '& .MuiIconButton-root': {
            borderRadius: '0%'
        },
        '& .MuiTouchRipple-root': {
            display: 'none',
        },
        '& .MuiButtonBase-root': {
            paddingRight: '12px',
            paddingLeft: '14px',
            height: '100%',
            transition: 'none',
        },
        '& .MuiButtonBase-root:first-child': {
            borderRadius: '0px',
            '&::before': {
                content: '" "',
                borderRight: '1px solid #fff',
                position: 'absolute',
                right: '0px',
                height: 'calc(100% + 10px)',
                top: '-9px',
            },
        },
    },
    popoverMenuContainer: {
        width: '100% !important',
        zIndex: "1099 !important",
        '& ': {
            top: '58px !important',
        },
        '& > div:first-child': {
            backgroundColor: 'rgba(96, 96, 96, 0.376) !important',
        },
        '& .MuiPopover-paper': {
            marginTop: '0px',
            width: '100% !important',
            maxWidth: '100% !important',
            left: '0px !important',
            top: '0px !important',
            boxShadow: 'none',
        },
    },
    iconMenu: {
        transition: 'all 0.3s ease-in-out',
        '& .MuiSvgIcon-root': {
            color: "white",
            transition: "none",
        },
        '&:hover': {
            background: "#fff !important",
            '& .MuiSvgIcon-root': {
                color: "#DC0028",
            },
        },
        '@media screen and (max-width: 1200px)': {
            padding: '0px',
        },
    },
    iconMenuCompletoReducido: {
        transition: 'all 0.3s ease-in-out',
        '& .MuiSvgIcon-root': {
            color: "white",
            transition: "none",
        },
        '&:hover': {
            background: "#fff !important",
            '& .MuiSvgIcon-root': {
                color: "#DC0028",
            },
        },
        '@media screen and (max-width: 1400px)': {
            padding: '0px',
        },
        '&:hover $iconText': {
            opacity: 1,
            maxWidth: '200px',
            paddingLeft: '8px'
        },
    },
    iconText: {
        opacity: 0,
        maxWidth: '0px',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        transition: 'opacity 0.3s ease-in-out, max-width 0.3s ease-in-out',
        textDecoration: "none",
        textTransform: "none",
        fontFamily: "CO-Medium",
        fontWeight: "bold",
        cursor: "pointer",
    },
    accionesUsu: {
        display: 'flex',
        '@media screen and (max-width: 1115px)': {
            display: 'none',
        },
    },
    menuReducido: {
        display: 'flex',
        alignItems: 'center',
        '& .MuiSwitch-switchBase': {
            color: '#505050'
        },
        '& .MuiSwitch-colorSecondary.Mui-checked': {
            color: '#fafafa'
        }
    },
    containerToolBarIconMenuReducidoCompleto: {
        // borderLeft: '1px solid',
        borderRight: '1px solid',
        height: '100%',
        display: 'inline-block',
        '& .MuiIconButton-root:hover': {
            background: 'transparent',
            '& .MuiTypography-root': {
                color: '#DC0028'
            },
        },
        '& .MuiIconButton-root': {
            borderRadius: '0%'
        },
        '& .MuiTouchRipple-root': {
            display: 'none',
        },
        '& .MuiButtonBase-root': {
            paddingRight: '12px',
            paddingLeft: '14px',
            height: '100%',
            transition: 'none',
        },
        '& .MuiButtonBase-root:first-child': {
            borderRadius: '0px',
            //   paddingRight: '8px',
            //   '@media screen and (max-width: 1200px)': {
            //     paddingRight: '5px',
            //   },
            '&::before': {
                content: '" "',
                // borderRight: '1px solid #fff',
                position: 'absolute',
                right: '0px',
                height: 'calc(100% + 10px)',
                top: '-9px',
            },
        },
        '& .MuiTypography-root': {
            color: '#fff',
            fontSize: '14px',
            '@media screen and (max-width: 1400px)': {
                fontSize: '12px',
            }
        },
    },
}); });
function AppBarLg(props) {
    var _a, _b;
    var _c = useContext(PortalContext), menu = _c.menu, user = _c.user;
    var _d = useState(), selectedMenu = _d[0], setSelectedMenu = _d[1];
    var classes = useStyles$7(props);
    var logoimg = getLogo();
    var portal = getPortalTitle();
    var mutate = useSWRConfig().mutate;
    var refContainer = React__default.useRef(null);
    var _e = React__default.useState(null), anchorEl = _e[0], setAnchorEl = _e[1];
    var handleMenu = function (name, event) {
        setSelectedMenu(name);
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function () {
        setSelectedMenu("");
        setAnchorEl(null);
    };
    var _f = React__default.useState(false), menuReducido = _f[0], setMenuReducido = _f[1];
    if (!esGestiona()) {
        var options2 = { focusThrottleInterval: 1000 * 3600 * 4, revalidateOnMount: true, revalidateIfStale: false, revalidateOnFocus: false, revalidateOnReconnect: false, dedupingInterval: 1000 * 3600 * 4 };
        var data_1 = useSWR(["menureducido", user === null || user === void 0 ? void 0 : user.id], function () { return api.post("/be/menureducido", { Entrada: {} }); }, options2).data;
        React__default.useEffect(function () {
            if (data_1) {
                setMenuReducido(data_1 === null || data_1 === void 0 ? void 0 : data_1.Salida.MenuReducido);
                console.log('dataReducidoEffect in AppBarlg');
            }
        }, [data_1]);
    }
    var ActualizarMenuReducido = function (newvalue) {
        // setMenuReducido(newvalue);
        mutate(["menureducido", user === null || user === void 0 ? void 0 : user.id], function () { return api.post("/be/menureducidoguardar", {
            Entrada: {
                MenuReducido: newvalue
            }
        }); }, false);
    };
    return React__default.createElement(AppBar, { elevation: 1, position: "fixed", className: classes.headerMain, onClick: function () {
            if (selectedMenu !== "") {
                setSelectedMenu("");
            }
        } },
        React__default.createElement(Toolbar, { variant: "dense", className: classes.toolBarCustom },
            React__default.createElement("h1", { className: classes.logoCompany }, (window.location.pathname == '/') ? React__default.createElement("a", { href: "/" },
                React__default.createElement("img", { src: logoimg, width: "auto", height: "48", alt: portal, className: classes.logoCompanyImage })) :
                React__default.createElement(Enlace, { to: "/" },
                    React__default.createElement("img", { src: logoimg, width: "auto", height: "48", alt: portal, className: classes.logoCompanyImage }))),
            React__default.createElement("div", { className: classes.menuCentro },
                React__default.createElement("div", null,
                    !(((_a = props === null || props === void 0 ? void 0 : props.acciones) === null || _a === void 0 ? void 0 : _a.length) > 0) ? null :
                        React__default.createElement("div", { className: props.mostrarBuscador ? classes.containerToolBarIcon : classes.containerToolBarNoSearch }, (_b = props === null || props === void 0 ? void 0 : props.acciones) === null || _b === void 0 ? void 0 : _b.map(function (custom, index) {
                            if ((custom.id != 'buscador') || (custom.id == 'buscador' && props.mostrarBuscador)) {
                                return React__default.createElement(React__default.Fragment, null,
                                    React__default.createElement(IconButton$1, __assign$2({}, props, { "aria-label": "Alertas", size: "small", ref: refContainer, className: classes.iconMenu, onMouseEnter: function (event) {
                                            handleMenu('IconMenu' + index.toString(), event);
                                        }, onClick: function (event) {
                                            handleMenu('IconMenu' + index.toString(), event);
                                        } }), custom.icon),
                                    React__default.createElement(Popover$1, { anchorEl: anchorEl, className: (custom === null || custom === void 0 ? void 0 : custom.classNameBody) ? custom.classNameBody : classes.popoverMenuContainer, keepMounted: true, disableEnforceFocus: true, anchorOrigin: {
                                            vertical: "top",
                                            horizontal: "left"
                                        }, transformOrigin: {
                                            vertical: "top",
                                            horizontal: "left"
                                        }, onClick: function (e) {
                                            e.stopPropagation();
                                        }, open: selectedMenu === ('IconMenu' + index.toString()), onClose: handleClose }, (custom === null || custom === void 0 ? void 0 : custom.body) &&
                                        [custom.body].map(function (body) {
                                            if (body) {
                                                var copy = __assign$2({}, body.props);
                                                copy['onClose'] = handleClose;
                                                copy['actualizarIdClick'] = props.actualizarIdClick;
                                                var componenteWithNewProps = __assign$2(__assign$2({}, body), { props: copy });
                                                return componenteWithNewProps;
                                            }
                                            else
                                                return;
                                        })));
                            }
                            else
                                return;
                        })),
                    !esGestiona() && React__default.createElement("div", { className: classes.containerToolBarIconMenuReducidoCompleto, onClick: function (event) {
                            ActualizarMenuReducido(!menuReducido);
                            handleMenu('IconMenuReducido', event);
                        } },
                        React__default.createElement(React__default.Fragment, null,
                            React__default.createElement(IconButton$1, { title: menuReducido ? 'Ir a menu completo' : 'Ir a mi menú', "aria-label": "Menu", size: "small", className: classes.iconMenuCompletoReducido, onMouseEnter: function (event) {
                                    handleMenu('IconMenuReducido', event);
                                } }, React__default.createElement(React__default.Fragment, null,
                                menuReducido ? React__default.createElement(IconMenuReducido, null) : React__default.createElement(IconMenuCompleto, null),
                                React__default.createElement(Typography$1, { variant: "caption", className: classes.iconText }, menuReducido ? 'Ir a menú completo' : 'Ir a mi menú'))))),
                    React__default.createElement(ButtonGroup, { variant: "contained", color: "primary", "aria-label": "contained primary button group", className: esGestiona() ? classes.menuGestiona : classes.menu, disableElevation: true, size: "small" }, menu && menu.enlaces && menu.enlaces.filter(function (x) { return !x.oculto; }).map(function (enlace) { return (React__default.createElement(AppBarLgMenu, { key: "_" + enlace.url, menu: enlace, selectedMenu: selectedMenu, noExpandirMenu: props.noExpandirMenu, onOpen: function (menu) {
                            setSelectedMenu(menu);
                        }, onClose: function () {
                            setSelectedMenu("");
                        }, actualizarIdClick: props.actualizarIdClick, favs: props.favs, hasVersionCompleta: esGestiona() ? true : !menuReducido })); })))),
            React__default.createElement("div", { className: classes.accionesUsu }, props.accionesUsuario),
            React__default.createElement(AppBarUser, { marquesina: props.marquesina, mostrarSimulado: props.mostrarSimulado, mostrarContactoDigital: props.mostrarContactoDigital })));
}

var useStyles$6 = makeStyles(function (theme) { return ({
    toolbarIcon: {
        color: alpha(theme.palette.primary.contrastText, 0.95)
    },
    buscadorCont: {
        marginBottom: '20px',
        marginTop: '15px',
        '& .MuiFormControl-root': {
            width: 'calc(100% - 30px)',
            marginLeft: '15px',
            '& .MuiInputBase-root ': {
                border: '1px solid #d6d8d8',
                '& .MuiInputBase-input': {
                    height: '34px',
                    padding: '4px 14px',
                },
                '&:before, &:after': {
                    content: "none !important",
                }
            },
            '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
                borderBottom: '0px solid transparent !important',
            }
        },
        '& .MuiInput-underline:before': {
            content: 'none !important',
        },
        '& .MuiInput-underline:after': {
            borderBottom: '2px solid ' + theme.palette.secondary.main,
        },
        '& .MuiSvgIcon-root': {
            color: '#d6d8d8',
            marginTop: '7px',
        }
    },
    favoritosCont: {
        '& a': {
            borderBottom: '1px solid #d6d8d8',
            borderTop: '1px solid #d6d8d8',
            width: '100%',
            float: 'left',
            padding: '13px 16px',
            boxSizing: 'border-box',
        }
    },
    listaMenuMbl: {
        '& a': {
            borderBottom: '1px solid #d6d8d8',
            float: 'left',
            width: '100%',
            background: 'transparent !important',
            '& .MuiTouchRipple-root': {
                display: 'none',
            },
            '&:focus': {
                fontWeight: 'bold',
            },
            '& .MuiListItem-button:hover': {
                backgroundColor: '#fff',
            }
        },
    },
    cerrarMenu: {
        textAlign: 'right',
        float: 'left',
        width: '100%',
        marginTop: '20px',
        paddingRight: '16px',
        boxSizing: 'border-box',
        marginBottom: '15px',
        '& .MuiSvgIcon-root': {
            height: '20px',
            width: '20px',
            color: theme.palette.secondary.main,
            '&:hover': {
                color: '#919191',
            },
            '&:focus, &:active': {
                color: '#DC0028',
            }
        }
    },
    cierreCont: {
        width: '20px',
        display: 'inline-block',
    },
    menuReducidoCompleto: {
        borderBottom: '1px solid #d6d8d8',
        borderTop: '1px solid #d6d8d8',
        width: '100%',
        float: 'left',
        padding: '13px 16px',
        boxSizing: 'border-box',
        color: '#fff !important',
        background: theme.palette.primary.main,
        '& .MuiIconButton-root:hover': {
            background: 'transparent',
        },
        '& .MuiIconButton-root': {
            borderRadius: '0%  !important',
            color: 'inherit !important'
        },
        '& .MuiTouchRipple-root': {
            display: 'none',
        },
    },
    iconMenuReducidoCompleto: {
        marginLeft: '-3px',
        paddingRight: '5px'
    }
}); });
function MenuSm(props) {
    var _a = React__default.useContext(PortalContext), menu = _a.menu, user = _a.user;
    var _b = React__default.useState(), drawerVisible = _b[0], setDrawerVisible = _b[1];
    var classes = useStyles$6(props);
    var mutate = useSWRConfig().mutate;
    var closeDrawer = function () {
        setDrawerVisible(false);
    };
    var openDrawer = function () {
        setDrawerVisible(true);
    };
    var _c = React__default.useState(false), menuReducido = _c[0], setMenuReducido = _c[1];
    if (!esGestiona()) {
        var options2 = { focusThrottleInterval: 1000 * 3600 * 4, revalidateOnMount: true, revalidateIfStale: false, revalidateOnFocus: false, revalidateOnReconnect: false, dedupingInterval: 1000 * 3600 * 4 };
        var data_1 = useSWR(["menureducido", user === null || user === void 0 ? void 0 : user.id], function () { return api.post("/be/menureducido", { Entrada: {} }); }, options2).data;
        React__default.useEffect(function () {
            if (data_1) {
                setMenuReducido(data_1 === null || data_1 === void 0 ? void 0 : data_1.Salida.MenuReducido);
                console.log('dataReducidoEffect in AppBarlg');
            }
        }, [data_1]);
    }
    var ActualizarMenuReducido = function (newvalue) {
        mutate(["menureducido", user === null || user === void 0 ? void 0 : user.id], function () { return api.post("/be/menureducidoguardar", {
            Entrada: {
                MenuReducido: newvalue
            }
        }); }, false);
    };
    return React__default.createElement(React__default.Fragment, null,
        React__default.createElement(IconButton$1, { onClick: openDrawer },
            React__default.createElement(IconMenu, { className: classes.toolbarIcon })),
        React__default.createElement(Drawer, { anchor: "left", disableBackdropClick: false, open: drawerVisible, onClose: closeDrawer }, menu && menu.enlaces &&
            React__default.createElement(Paper, { variant: "elevation", square: true, color: "secondary", elevation: 0, style: { width: "300px" } },
                " ",
                React__default.createElement("div", { className: classes.cerrarMenu },
                    React__default.createElement("div", { className: classes.cierreCont, onClick: closeDrawer },
                        React__default.createElement(IconCerrar, null))),
                props.mostrarBuscador &&
                    React__default.createElement("div", { className: classes.buscadorCont }, props.buscador && props.buscador),
                !esGestiona() && React__default.createElement("div", { className: classes.menuReducidoCompleto },
                    React__default.createElement(IconButton$1, { title: menuReducido ? 'Ir a menu completo' : 'Ir a mi menú', "aria-label": "Menu", size: "small", onClick: function () { ActualizarMenuReducido(!menuReducido); } }, menuReducido ? React__default.createElement(React__default.Fragment, null,
                        React__default.createElement(IconMenuReducido, { className: classes.iconMenuReducidoCompleto }),
                        React__default.createElement(ListItemText, { key: "Menu reducido", primary: "Ir a menú completo" }))
                        :
                            React__default.createElement(React__default.Fragment, null,
                                React__default.createElement(IconMenuCompleto, { className: classes.iconMenuReducidoCompleto }),
                                React__default.createElement(ListItemText, { key: "Menu completo", primary: "Ir a mi menú" })))),
                React__default.createElement("div", { className: classes.favoritosCont },
                    React__default.createElement(Enlace, { to: "/favoritos" },
                        React__default.createElement(ListItemText, { key: "Favoritos", onClick: closeDrawer, primary: "Favoritos" }))),
                React__default.createElement("div", { className: classes.listaMenuMbl },
                    React__default.createElement(List, null, menu.enlaces.map(function (item) {
                        var _a;
                        return (!item.oculto && React__default.createElement(Enlace, { to: (_a = item.url) !== null && _a !== void 0 ? _a : "" },
                            React__default.createElement(ListItem, { button: true, key: item.titulo }, React__default.createElement(ListItemText, { key: item.titulo, onClick: closeDrawer, primary: item.titulo }))));
                    }))))));
}

var useStyles$5 = makeStyles(function (theme) { return ({
    root: {
        flexGrow: 1
    },
    menuButton: {
        marginRight: theme.spacing(2)
    },
    title: {
        flexGrow: 1,
        textAlign: "center"
    },
    toolbarIcon: {
        color: alpha(theme.palette.primary.contrastText, 0.95)
    },
}); });
function AppBarSm(props) {
    var classes = useStyles$5(props);
    var logoimg = getLogo();
    var portal = getPortalTitle();
    return React__default.createElement(AppBar, { position: "fixed", elevation: 1 },
        React__default.createElement(Toolbar, { variant: "dense" },
            React__default.createElement(MenuSm, { buscador: props.buscadorTextField, mostrarBuscador: props.mostrarBuscador }),
            React__default.createElement(Enlace, { to: "/", className: classes.title },
                React__default.createElement("img", { src: logoimg, width: "100%", height: "48", alt: portal })),
            React__default.createElement(AppBarUser, { marquesina: props.marquesina, mostrarSimulado: props.mostrarSimulado, mostrarContactoDigital: props.mostrarContactoDigital })));
}

function Logout() {
    api.logout();
    return React__default.createElement("div", null,
        React__default.createElement(Splash, { titulo: "Cerrando sesi\u00F3n..." }));
}

var useStyles$4 = makeStyles(function (theme) {
    var _a;
    return ({
        intermediateMenuContainer: {
            padding: '0',
            background: '#fff',
        },
        cardContainer: {
            marginBottom: '10px',
            'break-inside': 'avoid-column',
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0,
            '& .MuiCardContent-root:last-child': {
                paddingBottom: '.5rem',
                marginBottom: '15px',
            },
            '& .MuiSvgIcon-root': {
                fontSize: '14px',
                color: theme.palette.secondary.main,
                '&:hover': {
                    color: '#919191 !important',
                },
                '&:focus, &:active': {
                    color: '#DC0028 !important',
                },
            },
        },
        title: {
            fontSize: theme.typography.subtitle1.fontSize,
            //fontFamily: 'CO-Medium',
            fontFamily: 'Catalana-sans, Arial, sans-serif',
            boxShadow: 'inset 0px 3px 0px #dc0028',
            backgroundColor: '#f4f4f4',
            //borderBottom: '1px solid #f4f4f4',
            width: '100%',
            display: 'inline-block',
            //margin: '0 0 .5rem 0',
            padding: '.5rem 1rem',
            'box-sizing': 'border-box',
            '& a': {
                fontSize: '14px',
                fontWeight: 'bold',
                '&:hover': {
                    color: theme.palette.secondary.main + ' !important'
                },
                '&:focus, &:active': {
                    color: '#DC0028 !important',
                },
            }
        },
        listItem: {
            padding: "4px 0",
            borderTop: '1px solid #f4f4f4',
            '& a': {
                fontSize: '14px',
                color: theme.palette.secondary.main + ' !important',
                '&:hover': {
                    color: '#919191 !important',
                },
                '&:focus, &:active': {
                    color: '#DC0028 !important',
                },
            },
            '& .MuiSvgIcon-root': {
                fontSize: '14px',
                color: theme.palette.secondary.main,
                '&:hover': {
                    color: '#919191 !important',
                },
                '&:focus, &:active': {
                    color: '#DC0028 !important',
                },
            }
        },
        content: {
            paddingTop: "0",
            '&:last-of-type': {
                paddingBottom: '8px',
            },
            '&>div > a ': {
                fontWeight: 'Bold',
            }
        },
        columns: (_a = {
                columnCount: 4,
                margin: "0px auto",
                padding: "20px"
            },
            _a[theme.breakpoints.down('sm')] = {
                columnCount: 1,
            },
            _a[theme.breakpoints.up('md')] = {
                columnCount: 2,
            },
            _a[theme.breakpoints.up('lg')] = {
                columnCount: 4,
            },
            _a),
        iconWrapper: {
            float: 'right',
            cursor: 'pointer',
            '& svg': {
                fontSize: '12px',
                '&:hover': {
                    color: '#919191',
                },
                '&:active': {
                    color: '#dc0028',
                },
            },
        },
        itemMenuReducidoCompletoContainer: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        },
        itemMenuReducidoCompleto: {
            color: '#dc0028 !important',
            fontSize: '12px !important',
            cursor: 'pointer',
            textDecoration: 'underline',
            '&:hover': {
                color: '#dc0028 !important',
                '& .MuiSvgIcon-root': {
                    color: '#dc0028 !important',
                }
            }
        },
        itemIcon: {
            padding: '0 0 0 0.5rem',
            fontSize: '12px !important',
            color: '#dc0028 !important',
        }
    });
});
function NavPage(props) {
    var navStyles = useStyles$4();
    var user = React__default.useContext(PortalContext).user;
    var mutate = useSWRConfig().mutate;
    var _a = useState(false), mostrarModal = _a[0], setMostrarModal = _a[1];
    var _b = React__default.useState(null), mostrarUrlModal = _b[0], setMostrarUrlModal = _b[1];
    // const [hasFavDes, sethasFavDes] = React.useState<boolean>(false);
    var _c = React__default.useState(esGestiona() ? true : false), showCompleteVersion = _c[0], setShowCompleteVersion = _c[1];
    var _d = React__default.useState(esGestiona() ? false : true), menuReducido = _d[0], setMenuReducido = _d[1];
    // var favs: any = undefined;
    var _e = React__default.useState(null), favs = _e[0], setFavs = _e[1];
    var _f = React__default.useState(null), navItem = _f[0], setNavItem = _f[1];
    if (props.favs) {
        var options = { focusThrottleInterval: 1000 * 3600 * 4, revalidateOnMount: true, revalidateIfStale: false, revalidateOnFocus: false, revalidateOnReconnect: false, dedupingInterval: 1000 * 3600 * 4 };
        var dataFavs_1 = useSWR(["favoritos", user === null || user === void 0 ? void 0 : user.id], function () { var _a, _b; return api.post((_b = (_a = props.favs) === null || _a === void 0 ? void 0 : _a.favsSvc) !== null && _b !== void 0 ? _b : "", { Entrada: {} }); }, options).data;
        React__default.useEffect(function () {
            var _a;
            setFavs((_a = dataFavs_1 === null || dataFavs_1 === void 0 ? void 0 : dataFavs_1.Salida) === null || _a === void 0 ? void 0 : _a.Favoritos);
        }, [dataFavs_1]);
    }
    if (!esGestiona()) {
        var options2 = { focusThrottleInterval: 1000 * 3600 * 4, revalidateOnMount: true, revalidateIfStale: false, revalidateOnFocus: false, revalidateOnReconnect: false, dedupingInterval: 1000 * 3600 * 4 };
        var dataReducido_1 = useSWR(["menureducido", user === null || user === void 0 ? void 0 : user.id], function () { return api.post("/be/menureducido", { Entrada: {} }); }, options2).data;
        React__default.useEffect(function () {
            var _a;
            console.log('actualizado menu Reducido:', dataReducido_1 === null || dataReducido_1 === void 0 ? void 0 : dataReducido_1.Salida.MenuReducido);
            if (dataReducido_1 && dataReducido_1.Salida && dataReducido_1.Salida.MenuReducido != undefined && menuReducido !== ((_a = dataReducido_1 === null || dataReducido_1 === void 0 ? void 0 : dataReducido_1.Salida) === null || _a === void 0 ? void 0 : _a.MenuReducido)) {
                setMenuReducido(dataReducido_1 === null || dataReducido_1 === void 0 ? void 0 : dataReducido_1.Salida.MenuReducido);
                setShowCompleteVersion(!(dataReducido_1 === null || dataReducido_1 === void 0 ? void 0 : dataReducido_1.Salida.MenuReducido));
            }
        }, [dataReducido_1]);
    }
    React__default.useEffect(function () {
        var NavItem = getNavItem(props.menuOption, 0, showCompleteVersion, null);
        setNavItem(NavItem);
    }, [favs, menuReducido, showCompleteVersion]);
    var AddFavorito = function (menuId, titulo) {
        mutate(["favoritos", user === null || user === void 0 ? void 0 : user.id], function () {
            var _a, _b;
            return api.post((_b = (_a = props.favs) === null || _a === void 0 ? void 0 : _a.favsAddSvc) !== null && _b !== void 0 ? _b : "", {
                Entrada: {
                    Titulo: titulo,
                    Url: menuId,
                    Tipo: "Menu"
                }
            });
        }, false);
    };
    var DelFavorito = function (menuId, esAccesoRapido) {
        if (esAccesoRapido) {
            setMostrarUrlModal(menuId);
            setMostrarModal(true);
        }
        else {
            manejarAceptar(menuId);
        }
    };
    var manejarEnlaceClick = function () {
        // Esperar un segundo para actualizar lista de Ultimas Visitas
        setTimeout(function () {
            mutate(['ultimasvisitas', user === null || user === void 0 ? void 0 : user.id], function () { var _a; return api.post((_a = props.ultimasVisitasSvc) !== null && _a !== void 0 ? _a : '', { Entrada: {} }); }, false);
        }, 1000);
    };
    var manejarCierre = function () {
        setMostrarModal(false);
        setMostrarUrlModal(null);
    };
    var manejarAceptar = function (url) {
        mutate(["favoritos", user === null || user === void 0 ? void 0 : user.id], function () {
            var _a, _b;
            return api.post((_b = (_a = props.favs) === null || _a === void 0 ? void 0 : _a.favsDelSvc) !== null && _b !== void 0 ? _b : "", {
                Entrada: {
                    Url: url,
                    Tipo: "Menu"
                }
            });
        }, false);
        setMostrarModal(false);
        setMostrarUrlModal(null);
    };
    var getFavComponent = function (menu) {
        var esFav = menu.id && favs && favs.find(function (x) { return x.Url != null && x.Url.toLowerCase() == menu.id.toLowerCase(); }) != null;
        var esAccesoRapido = menu.id && favs && favs.find(function (x) { return x.Url != null && x.Url.toLowerCase() == menu.id.toLowerCase() && (x.AccesoRapido != null); }) != null;
        return React__default.createElement("div", { className: navStyles.iconWrapper },
            React__default.createElement("span", null,
                React__default.createElement(IconEstrella, { style: { color: esFav ? "#dc0028" : "#505050" }, onClick: function (e) {
                        !esFav ? AddFavorito(menu.id, menu.titulo) : DelFavorito(menu.id, esAccesoRapido);
                        e.stopPropagation();
                    } })),
            mostrarModal && mostrarUrlModal &&
                React__default.createElement(CustomizedDialog, { title: "Eliminar favorito", open: mostrarModal, manejarCierre: manejarCierre, guardar: function () { return manejarAceptar(mostrarUrlModal); }, tituloAceptar: "Eliminar" },
                    React__default.createElement("p", null, "Este Favorito est\u00E1 marcado como Acceso R\u00E1pido, al eliminarlo tambi\u00E9n se eliminar\u00E1 el Acceso R\u00E1pido. \u00BFEst\u00E1s seguro de que quieres eliminarlo?")));
    };
    var simplificarCIA = function (titulo) {
        titulo = titulo.replaceAll(" SPU", " PU");
        titulo = titulo.replaceAll(" SBI", " SB");
        return titulo;
    };
    var getLink = function (menu) {
        return React__default.createElement(Enlace, { to: menu.url }, simplificarCIA(menu.titulo));
    };
    var openInNewWindow = function (menu) {
        var _a, _b;
        var cia = getCiaFromUrl();
        var desarrollo = window.location.hostname.startsWith("d") || window.location.hostname.startsWith("w") || window.location.hostname.startsWith("localhost");
        if ((cia != "PRE" || (cia === "PRE" && desarrollo)) && (menu.ventanaNueva || menu.popup) &&
            !(menu.plantilla === "GCOAPP" && menu.tipo === "ENLACE") && !(menu.plantilla === "GCOAPP" && ((_a = menu.tipo) === null || _a === void 0 ? void 0 : _a.startsWith("PORTALINTRANET"))) &&
            !(menu.plantilla === "GCOAPPSP" && menu.tipo === "ENLACE") && !(menu.plantilla === "GCOAPPSP" && ((_b = menu.tipo) === null || _b === void 0 ? void 0 : _b.startsWith("PORTALINTRANET")))) {
            return React__default.createElement("i", { className: 'icon-enlace-ext', style: { fontSize: '17px', color: '#505050' } });
        }
        else {
            return null;
        }
    };
    var getNavItem = function (menu, lvl, showCompleteVersion, setFatherHasFavDescendent) {
        var _a, _b, _c;
        if (lvl === void 0) { lvl = 0; }
        var components = null;
        var esFav = menu.id && favs && favs.find(function (x) { var _a; return x.Url != null && x.Url.toLowerCase() == ((_a = menu.id) === null || _a === void 0 ? void 0 : _a.toLowerCase()); }) != null;
        if (esFav) {
            if (setFatherHasFavDescendent)
                setFatherHasFavDescendent(esFav);
        }
        var hasFavDescendent = false;
        switch (lvl) {
            case 0:
                components = (_a = menu.enlaces) === null || _a === void 0 ? void 0 : _a.map(function (enlace) {
                    var comp = getNavItem(enlace, lvl + 1, showCompleteVersion, function (childFav) { hasFavDescendent = hasFavDescendent || childFav; });
                    return !!comp && React__default.createElement(Card$1, { className: navStyles.cardContainer, elevation: 0, key: enlace.Url }, comp);
                });
                return !(showCompleteVersion || hasFavDescendent) ? null : React__default.createElement("div", null, components);
            case 1:
                components = (_b = menu.enlaces) === null || _b === void 0 ? void 0 : _b.filter(function (e) { return !e.oculto; }).map(function (enlace) {
                    return getNavItem(enlace, lvl + 1, showCompleteVersion, function (childFav) { hasFavDescendent = hasFavDescendent || childFav; });
                });
                if (hasFavDescendent) {
                    if (setFatherHasFavDescendent)
                        setFatherHasFavDescendent(hasFavDescendent);
                }
                return !(showCompleteVersion || hasFavDescendent || esFav) ? null : React__default.createElement(React__default.Fragment, null,
                    React__default.createElement(CardContent$1, { className: navStyles.title, onClick: manejarEnlaceClick },
                        getLink(menu),
                        menu.url && (!menu.enlaces || menu.enlaces.filter(function (e) { return !e.oculto; }).length == 0) && props.favs && openInNewWindow(menu),
                        menu.url && (!menu.enlaces || menu.enlaces.filter(function (e) { return !e.oculto; }).length == 0) && props.favs && getFavComponent(menu)),
                    components != null && React__default.createElement(CardContent$1, { className: navStyles.content }, components));
            default:
                components = !(menu.enlaces && menu.enlaces.filter(function (e) { return !e.oculto; }).length > 0) ? null : (_c = menu.enlaces) === null || _c === void 0 ? void 0 : _c.filter(function (e) { return !e.oculto; }).map(function (enlace) {
                    return getNavItem(enlace, lvl + 1, showCompleteVersion, function (childFav) { hasFavDescendent = hasFavDescendent || childFav; });
                });
                if (hasFavDescendent) {
                    if (setFatherHasFavDescendent)
                        setFatherHasFavDescendent(hasFavDescendent);
                }
                return !(showCompleteVersion || hasFavDescendent || esFav) ? null : React__default.createElement(React__default.Fragment, null,
                    React__default.createElement("div", { key: menu.url, className: navStyles.listItem, onClick: manejarEnlaceClick },
                        getLink(menu),
                        menu.url && (!menu.enlaces || menu.enlaces.filter(function (e) { return !e.oculto; }).length == 0) && props.favs && openInNewWindow(menu),
                        menu.url && (!menu.enlaces || menu.enlaces.filter(function (e) { return !e.oculto; }).length == 0) && props.favs && getFavComponent(menu)),
                    components != null && React__default.createElement("div", { style: { paddingLeft: "20px" } }, components));
        }
    };
    return (React__default.createElement("div", { className: navStyles.intermediateMenuContainer },
        menuReducido && React__default.createElement("div", { style: { padding: "20px 0px 0px 0px" } },
            React__default.createElement(Card$1, { className: navStyles.cardContainer, elevation: 0, key: 'botonTemporal' },
                showCompleteVersion && React__default.createElement("div", { className: navStyles.itemMenuReducidoCompletoContainer },
                    React__default.createElement("span", { className: navStyles.itemMenuReducidoCompleto, onClick: function () { setShowCompleteVersion(!showCompleteVersion); } },
                        " ",
                        "Ver menos opciones de menu",
                        React__default.createElement(IconArriba, { className: navStyles.itemIcon }))),
                !showCompleteVersion && React__default.createElement("div", { className: navStyles.itemMenuReducidoCompletoContainer },
                    React__default.createElement("span", { className: navStyles.itemMenuReducidoCompleto, onClick: function () { setShowCompleteVersion(!showCompleteVersion); } },
                        " ",
                        "Ver más opciones de menu",
                        React__default.createElement(IconAbajo, { className: navStyles.itemIcon }))))),
        React__default.createElement("div", { className: navStyles.columns }, navItem)));
}

var useStyles$3 = makeStyles(function (theme) { return ({
    generalContainer: {
        display: 'flex',
        flexWrap: 'wrap',
        paddingTop: '15px',
        backgroundColor: '#fff'
    },
    title: {
        fontSize: theme.typography.subtitle1.fontSize,
        //fontFamily: 'CO-Medium',
        fontFamily: 'Catalana-sans, Arial, sans-serif',
        boxShadow: 'inset 0px 3px 0px #dc0028',
        backgroundColor: '#f4f4f4',
        //borderBottom: '1px solid #f4f4f4',
        width: '100%',
        display: 'inline-block',
        //margin: '0 0 .5rem 0',
        padding: '.5rem 1rem',
        'box-sizing': 'border-box',
        '& a': {
            fontSize: '14px',
            fontWeight: 'bold',
            '&:hover': {
                color: theme.palette.secondary.main + ' !important'
            },
            '&:focus, &:active': {
                color: '#DC0028 !important',
            },
        }
    },
    button: {
        width: "33.33%",
        textAlign: "center",
        flexDirection: "column",
        justifyContent: "center",
        backgroundColor: 'transparent !important',
        color: theme.palette.secondary.main,
        marginBottom: '15px',
        // '& .MuiTouchRipple-root': {
        //     display: 'none',
        // },
        '&:hover i': {
            color: '#919191'
        },
        '&:hover span': {
            color: '#919191'
        },
        '&:focus i': {
            color: '#DC0028'
        },
        '&:focus span': {
            color: '#DC0028'
        },
        '&:active i': {
            color: '#DC0028'
        },
        '&:active span': {
            color: '#DC0028'
        },
        '& .MuiTouchRipple-root': {
            display: 'none',
        }
    },
    label: {
        // Aligns the content of the button vertically.
        flexDirection: 'column'
    },
    startIcon: {
        margin: '0',
        marginTop: theme.spacing(.5),
        marginBottom: '12px'
    },
    wrapper: {
        height: "32px",
        width: "32px",
        margin: 0,
        '& i ': {
            fontSize: '3rem',
            position: 'relative',
            bottom: 0,
            right: 0,
            width: '32px',
            height: '32px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#dc0028'
        },
        '& span ': {
            color: '#dc0028'
        }
    },
    letra: {
        height: "32px",
        width: "32px",
        textAlign: "center",
        lineHeight: 1,
        fontSize: "32px",
        position: "relative",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    }
}); });
function NavIcoPage(props) {
    var navIcoStyles = useStyles$3();
    var crearUrlEnlace = function (enlace) {
        return "/Aplicacion?aplicacion=" + enlace.tipo + "&urlTransaccion=" + enlace.url;
    };
    // console.log('enlaces ' + props.menuOption.enlaces);
    return (React__default.createElement("div", { className: navIcoStyles.generalContainer }, props.menuOption.enlaces.map(function (enlace) {
        // console.log('enlace ' + enlace);
        var targetUrl = enlace.url;
        if (targetUrl == null || targetUrl == "") {
            targetUrl = (enlace.tipo && enlace.tipo !== "") ? crearUrlEnlace(enlace) : enlace.url;
        }
        var targetIcono = enlace.icono;
        return React__default.createElement(Button$1, { variant: "text", color: "primary", classes: { root: navIcoStyles.button, label: navIcoStyles.label, startIcon: navIcoStyles.startIcon }, component: Link, to: targetUrl, startIcon: React__default.createElement("div", { className: navIcoStyles.wrapper }, targetIcono && targetIcono !== null && targetIcono !== "" && targetIcono !== "icon-accion-insatis" ?
                React__default.createElement("i", { className: targetIcono + " Cursor", style: {} }) :
                React__default.createElement("span", { className: navIcoStyles.letra }, (enlace.titulo.length > 0) ? enlace.titulo[0].toUpperCase() : "")) },
            React__default.createElement(Typography$1, { variant: "caption", color: "secondary", style: { lineHeight: 1.2 } }, enlace.titulo));
    })));
}

var SapContainer = /** @class */ (function (_super) {
    __extends$2(SapContainer, _super);
    function SapContainer(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isLoaded: false, isLoggedIn: false
        };
        return _this;
    }
    SapContainer.prototype.componentDidMount = function () {
        var _this = this;
        if (document.cookie.indexOf("sap-contextid") >= 0) {
            this.setState({ isLoggedIn: true });
        }
        else {
            api.get("/be/ssosap").then(function (data) {
                var _a, _b;
                if ((_a = data.Salida) === null || _a === void 0 ? void 0 : _a.Cookies) {
                    (_b = data.Salida) === null || _b === void 0 ? void 0 : _b.Cookies.forEach(function (cookie) { return document.cookie = cookie + ";Domain=.gco.global;Path=/"; });
                }
                _this.setState({ isLoggedIn: true });
            });
        }
    };
    SapContainer.prototype.render = function () {
        var _this = this;
        var menuOption = this.props.menuOption;
        var desarrollo = window.location.hostname.startsWith("d") || window.location.hostname.startsWith("w") || window.location.hostname.startsWith("localhost");
        var url = menuOption.urlApp;
        url = (desarrollo ? "https://catalanadbw.gco.global/sap/bw/BEx?" : "https://catalanabw.gco.global/sap/bw/BEx?") + url;
        return (React__default.createElement("div", null,
            !this.state.isLoaded && React__default.createElement(Splash, { titulo: menuOption.titulo }),
            this.state.isLoggedIn && React__default.createElement(Fade, { "in": this.state.isLoaded, timeout: 1000 },
                React__default.createElement("iframe", { className: "site-layout-content-iframe", sandbox: "allow-scripts allow-same-origin allow-top-navigation allow-forms allow-popups allow-pointer-lock allow-popups-to-escape-sandbox allow-modals allow-downloads", allow: "camera;microphone", seamless: true, src: url !== null && url !== void 0 ? url : undefined, title: menuOption.titulo, style: {
                        width: "1px",
                        minWidth: "100%",
                        border: "0px",
                        display: this.state.isLoaded ? "block" : "none",
                        minHeight: "calc(100vh - 52px)",
                        backgroundColor: "#ffffff"
                    }, onLoad: function () {
                        _this.setState({ isLoaded: true });
                    } }))));
    };
    return SapContainer;
}(React__default.Component));

var AppNHContainer = function (props) {
    var menuOption = props.menuOption;
    var _a = React__default.useState(null), mensaje = _a[0], setMensaje = _a[1];
    var url = menuOption.urlApp;
    var hacerTransicion = menuOption.popup || menuHelper.esVentanaNueva(menuOption);
    url = menuHelper.getUrl(menuOption);
    React__default.useEffect(function () {
        if (hacerTransicion) {
            if (url != null) {
                window.location.href = url;
                // window.open(url, menuOption.tipo ?? undefined);
                setMensaje({ titulo: "La aplicación se abrirá en una ventana nueva", subtitulo: "Asegúrate de no tener las ventanas emergentes bloqueadas", tipo: "info" });
            }
        }
    }, [menuOption]);
    return (React__default.createElement("div", null,
        mensaje && React__default.createElement(Splash, { titulo: menuOption.titulo, mensaje: mensaje }),
        !mensaje && !hacerTransicion &&
            React__default.createElement("iframe", { name: "<__MAINFRAME__>", className: "site-layout-content-iframe", sandbox: "allow-scripts allow-same-origin allow-top-navigation allow-forms allow-popups allow-pointer-lock allow-popups-to-escape-sandbox allow-modals allow-downloads", allow: "camera;microphone", seamless: true, "data-html2canvas-ignore": true, src: url !== null && url !== void 0 ? url : undefined, title: menuOption.titulo, style: {
                    width: "1px",
                    minWidth: "100%",
                    border: "0px",
                    minHeight: "calc(100vh - 52px)",
                    backgroundColor: "#ffffff"
                } })));
};

var getComponenteAplicacionesReact = function (urlApp, componentesReact, globalBotHide, actualizarGlobalBotHide) {
    var _a, _b;
    var retrievedProps = {};
    var codComponente;
    var propList = urlApp.split(';');
    codComponente = (_a = propList[0]) === null || _a === void 0 ? void 0 : _a.toLowerCase();
    propList.forEach(function (pair) {
        var separatorIndex = pair.indexOf(':');
        if (separatorIndex !== -1) {
            var key = pair.substring(0, separatorIndex).trim();
            var value = decodeURIComponent(pair.substring(separatorIndex + 1).trim());
            retrievedProps[key] = value;
        }
    });
    var componente = null;
    if (codComponente && componentesReact) {
        componente = componentesReact[codComponente];
        if (componente) {
            if (codComponente == 'bot') {
                if (((_b = retrievedProps['isFullScreen']) === null || _b === void 0 ? void 0 : _b.toLowerCase()) == 'true' && globalBotHide && !globalBotHide() && actualizarGlobalBotHide)
                    actualizarGlobalBotHide(true);
                if (componentesReact['mybot'] && componentesReact['mybot'].urlApp == urlApp) {
                    componente = componentesReact['mybot'].bot;
                }
                else {
                    componente = __assign$2(__assign$2({}, componente), { props: __assign$2(__assign$2({}, componente.props), retrievedProps) });
                    componentesReact['mybot'] =
                        {
                            urlApp: urlApp,
                            bot: componente
                        };
                }
            }
            else {
                componente = __assign$2(__assign$2({}, componente), { props: __assign$2(__assign$2({}, componente.props), retrievedProps) });
            }
        }
    }
    return componente;
};
var AppReactContainer = function (props) {
    var menuUrlApp = props.menuUrlApp, componentesReact = props.componentesReact, globalBotHide = props.globalBotHide, actualizarGlobalBotHide = props.actualizarGlobalBotHide;
    var componente = getComponenteAplicacionesReact(menuUrlApp, componentesReact, globalBotHide, actualizarGlobalBotHide);
    return componente;
};

var UAParser = require('ua-parser-js');
var Layout = /** @class */ (function (_super) {
    __extends$2(Layout, _super);
    function Layout(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            selectedMenu: "",
            userDrawerVisible: false,
            userData: undefined,
            error: false,
            idClick: 0,
            globalBotHide: false
        };
        return _this;
    }
    Layout.prototype.getRoutesAplicacionesReact = function (menuOption) {
        var _a;
        var rutasAplicacionesReact;
        rutasAplicacionesReact = [];
        if (((_a = menuOption === null || menuOption === void 0 ? void 0 : menuOption.tipo) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === "APLICACIONESREACT") {
            rutasAplicacionesReact.push(menuOption.url);
        }
        if (menuOption.enlaces != null && menuOption.enlaces.length > 0) {
            for (var indx in menuOption.enlaces) {
                var enlace = menuOption.enlaces[indx];
                var rutas = this.getRoutesAplicacionesReact(enlace);
                rutasAplicacionesReact = rutasAplicacionesReact.concat(rutas);
            }
        }
        return rutasAplicacionesReact;
    };
    Layout.prototype.getRoutes = function (menuOption) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
        var routes;
        routes = [];
        if (menuOption.enlaces != null && menuOption.enlaces.length > 0) {
            for (var indx in menuOption.enlaces) {
                var enlace = menuOption.enlaces[indx];
                var rutas = this.getRoutes(enlace);
                routes = routes.concat(rutas);
            }
        }
        var bot = null;
        if (this.props.mostrarBotRRHHMenuEmpleados && ((_a = menuOption === null || menuOption === void 0 ? void 0 : menuOption.url) === null || _a === void 0 ? void 0 : _a.toLowerCase().startsWith("/empleados"))) {
            bot = React__default.createElement(AppReactContainer, { menuUrlApp: "bot;idBot:RRHH", componentesReact: this.props.componentesReact });
        }
        else if (this.props.mostrarBotVIDAFISCALMenuVidaSalud && ((_b = menuOption === null || menuOption === void 0 ? void 0 : menuOption.url) === null || _b === void 0 ? void 0 : _b.toLowerCase().startsWith("/publicaciones/vidaysalud"))) {
            bot = React__default.createElement(AppReactContainer, { menuUrlApp: "bot;idBot:VIDAFISCAL", componentesReact: this.props.componentesReact });
        }
        else if (this.props.mostrarBotLegalCorporativaMenuUtilidades && ((_c = menuOption === null || menuOption === void 0 ? void 0 : menuOption.url) === null || _c === void 0 ? void 0 : _c.toLowerCase().startsWith("/utilidades"))
            && !((_d = menuOption === null || menuOption === void 0 ? void 0 : menuOption.url) === null || _d === void 0 ? void 0 : _d.toLowerCase().startsWith("/utilidades/soporte"))
            && !((_e = menuOption === null || menuOption === void 0 ? void 0 : menuOption.url) === null || _e === void 0 ? void 0 : _e.toLowerCase().startsWith("/utilidades/asistentevirtual"))
            && !((_f = menuOption === null || menuOption === void 0 ? void 0 : menuOption.url) === null || _f === void 0 ? void 0 : _f.toLowerCase().startsWith("/utilidades/directoriogco"))
            && !((_g = menuOption === null || menuOption === void 0 ? void 0 : menuOption.url) === null || _g === void 0 ? void 0 : _g.toLowerCase().startsWith("/utilidades/directorioempleadosntnuevo"))
            && !((_h = menuOption === null || menuOption === void 0 ? void 0 : menuOption.url) === null || _h === void 0 ? void 0 : _h.toLowerCase().startsWith("/utilidades/equivalencianumeraciones"))
            && !((_j = menuOption === null || menuOption === void 0 ? void 0 : menuOption.url) === null || _j === void 0 ? void 0 : _j.toLowerCase().endsWith("/utilidades"))) {
            bot = React__default.createElement(AppReactContainer, { menuUrlApp: "bot;idBot:LEGALCORPORATIVA", componentesReact: this.props.componentesReact });
        }
        else if (this.props.mostrarBotContactCenterMenu && ((_k = menuOption === null || menuOption === void 0 ? void 0 : menuOption.url) === null || _k === void 0 ? void 0 : _k.toLowerCase().startsWith("/portales/portaldelcontactcenter"))) {
            bot = React__default.createElement(AppReactContainer, { menuUrlApp: "bot;idBot:CONTACTCENTER", componentesReact: this.props.componentesReact });
        }
        if (((_l = menuOption === null || menuOption === void 0 ? void 0 : menuOption.tipo) === null || _l === void 0 ? void 0 : _l.toUpperCase()) === "APLICACIONESREACT") {
            var routeApp = (React__default.createElement(Route, { exact: true, path: menuOption.url, key: "KeyRutePPM" + this.state.idClick },
                React__default.createElement(Page, { title: menuOption.titulo, key: menuOption.url },
                    React__default.createElement(AppReactContainer, { menuUrlApp: menuOption.urlApp, componentesReact: this.props.componentesReact }),
                    (((_o = (_m = menuOption === null || menuOption === void 0 ? void 0 : menuOption.urlApp) === null || _m === void 0 ? void 0 : _m.split(';')) === null || _o === void 0 ? void 0 : _o.length) > 0 && ((_p = menuOption === null || menuOption === void 0 ? void 0 : menuOption.urlApp) === null || _p === void 0 ? void 0 : _p.split(';')[0].toLowerCase()) != "bot") ? bot : null)));
            routes.push(routeApp);
        }
        else if (menuOption.plantilla === "GCOAPP" || menuOption.plantilla === "GCOAPPSP") {
            if (menuOption.tipo === "GCOAPP365") {
                var routeApp = (React__default.createElement(Route, { exact: true, path: menuOption.url, key: "KeyRutePPM" + this.state.idClick },
                    React__default.createElement(Page, { title: menuOption.titulo, key: menuOption.url },
                        React__default.createElement(App365Container, { menuOption: menuOption }),
                        bot)));
                routes.push(routeApp);
            }
            else if (menuOption.tipo === "SAP") {
                var routeApp = (React__default.createElement(Route, { exact: true, path: menuOption.url, key: "KeyRutePPM" + this.state.idClick },
                    React__default.createElement(Page, { title: menuOption.titulo, key: menuOption.url },
                        React__default.createElement(SapContainer, { menuOption: menuOption }),
                        bot)));
                routes.push(routeApp);
            }
            else if (((_q = menuOption === null || menuOption === void 0 ? void 0 : menuOption.tipo) === null || _q === void 0 ? void 0 : _q.toUpperCase()) === "APLICACIONESNORTEHISPANA") {
                var routeApp = (React__default.createElement(Route, { exact: true, path: menuOption.url, key: "KeyRutePPM" + this.state.idClick },
                    React__default.createElement(Page, { title: menuOption.titulo, key: menuOption.url },
                        React__default.createElement(AppNHContainer, { menuOption: menuOption }),
                        bot)));
                routes.push(routeApp);
            }
            // else if (menuOption?.tipo?.toUpperCase() === "MICROSTRATEGY") {
            //   var routeApp = (
            //     <Route exact path={menuOption.url}>
            //       <Page title={menuOption.titulo} key={menuOption.url}>
            //         <AppMicrostrategyContainer menuOption={menuOption}/>
            //       </Page>
            //     </Route>
            //   );
            //   routes.push(routeApp);
            // }
            else {
                var routeApp = (React__default.createElement(Route, { exact: true, path: menuOption.url, key: "KeyRutePPM" + this.state.idClick },
                    React__default.createElement(Page, { title: menuOption.titulo, key: menuOption.url },
                        React__default.createElement(AppContainer, { menuOption: menuOption }),
                        bot)));
                routes.push(routeApp);
            }
        }
        else if (menuOption.plantilla === "GCOPROD") {
            var routeApp = (React__default.createElement(Route, { exact: true, path: menuOption.url, key: "KeyRutePPM" + this.state.idClick },
                React__default.createElement(Page, { title: menuOption.titulo, key: menuOption.url },
                    React__default.createElement(App365Container, { menuOption: menuOption }),
                    bot)));
            routes.push(routeApp);
        }
        else if (menuOption.plantilla === "GCONAV") {
            var routeNav = (React__default.createElement(Route, { exact: true, path: menuOption.url, key: "KeyRutePPM" + this.state.idClick },
                React__default.createElement(Page, { title: menuOption.titulo, key: menuOption.url },
                    React__default.createElement(NavPage, { menuOption: menuOption, favs: this.props.favs, ultimasVisitasSvc: this.props.ultimasVisitasSvc }),
                    bot)));
            routes.push(routeNav);
        }
        else if (menuOption.plantilla === "GCONAVICO") {
            var routeNav = (React__default.createElement(Route, { exact: true, path: menuOption.url, key: "KeyRutePPM" + this.state.idClick },
                React__default.createElement(Page, { title: menuOption.titulo, key: menuOption.url },
                    React__default.createElement(NavIcoPage, { menuOption: menuOption, favs: this.props.favs, ultimasVisitasSvc: this.props.ultimasVisitasSvc }),
                    bot)));
            routes.push(routeNav);
        }
        return routes;
    };
    Layout.prototype.componentDidMount = function () {
        var _this = this;
        this.onRouteChanged(this.props.location, null);
        this.onSessionCreated(this.props.location);
        window.addEventListener("message", function (event) {
            if (event.data.tipo === "history.back")
                _this.props.history.goBack();
            return;
            // ...
        }, false);
    };
    Layout.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.location.pathname !== prevProps.location.pathname) {
            this.onRouteChanged(this.props.location, prevProps.location);
        }
    };
    /*
      componentDidCatch(error: any, errorInfo: any) {
        // You can also log the error to an error reporting service
        console.log("CATCH", this.props.session, error, errorInfo);
      }
    */
    Layout.prototype.onRouteChanged = function (location, prevLocation) {
        var aplicacion = getAplicacionFromUrl();
        var cia = getCiaFromUrl();
        api.traceNav(this.props.session, location, prevLocation, aplicacion, cia);
        if (this.props.historial && location.pathname && location.pathname !== "/") {
            var path = menuHelper.getMenuOptionPath(this.context.menu, location.pathname);
            var titulo = "";
            var id = "";
            if (path && path.length > 0) {
                titulo = path[path.length - 1].titulo;
                id = path[path.length - 1].id;
                if (path.length > 1) {
                    titulo = path[path.length - 2].titulo + " > " + titulo;
                }
                api.ultimaVisita(this.props.historial.guardarSvc, id, titulo, "pm");
            }
        }
        if (prevLocation !== null) {
            document.cookie = "SSOCatalanaPortalReferrer=" + (window.location.origin + (prevLocation === null || prevLocation === void 0 ? void 0 : prevLocation.pathname)) + ";Domain=.gco.global;Path=/";
        }
        else {
            document.cookie = "SSOCatalanaPortalReferrer=" + window.location.origin + ";Domain=.gco.global;Path=/";
        }
    };
    Layout.prototype.onSessionCreated = function (location) {
        var _a, _b, _c;
        var parser = new UAParser();
        var browser = parser.getResult();
        browser.screen = { h: window.screen.height, w: window.screen.width };
        var mode = window.matchMedia('(display-mode: standalone)').matches ? "APP" : "WEB";
        var app = (_a = process === null || process === void 0 ? void 0 : process.env) === null || _a === void 0 ? void 0 : _a.REACT_APP_NAME;
        var ver = (_b = process === null || process === void 0 ? void 0 : process.env) === null || _b === void 0 ? void 0 : _b.REACT_APP_VERSION;
        var msalUser = (_c = this.context.msalAccount) === null || _c === void 0 ? void 0 : _c.username;
        var aplicacion = getAplicacionFromUrl();
        var cia = getCiaFromUrl();
        api.traceSess(this.props.session, location, browser, { app: app, ver: ver, mode: mode, aplicacion: aplicacion, cia: cia }, msalUser);
        var ciaGestiona = this.context.ciaGestiona;
        createCiaOrigenCookie(ciaGestiona);
    };
    Layout.prototype.actualizarIdClick = function () {
        // console.log(this.state.idClick);
        this.setState({
            idClick: this.state.idClick + 1
        });
    };
    Layout.prototype.actualizarGlobalBotHide = function (newValue) {
        this.setState({
            globalBotHide: newValue
        });
    };
    Layout.prototype.render = function () {
        var _this = this;
        var _a, _b, _c, _d;
        var _e = this.context, menu = _e.menu, user = _e.user;
        var _f = this.props, classes = _f.classes, width = _f.width;
        var qs = new URLSearchParams(this.props.location.search);
        var routesAplicacionesReact = [];
        (_a = menu === null || menu === void 0 ? void 0 : menu.enlaces) === null || _a === void 0 ? void 0 : _a.forEach(function (enlace) { return routesAplicacionesReact = routesAplicacionesReact.concat(_this.getRoutesAplicacionesReact(enlace)); });
        return (React__default.createElement(React__default.Fragment, null,
            React__default.createElement(Slide, { direction: "down", "in": true },
                React__default.createElement("div", { style: { height: "52px", width: "100%", position: "absolute" } },
                    isWidthUp('md', width) ? React__default.createElement(AppBarLg, __assign$2({ actualizarIdClick: function () { return _this.actualizarIdClick(); } }, this.props)) : React__default.createElement(AppBarSm, __assign$2({}, this.props)),
                    !this.state.globalBotHide && this.props.globalBot ? this.props.globalBot : null)),
            React__default.createElement(Paper, { square: true, elevation: 0, className: classes.mainPaper },
                React__default.createElement(Switch, null,
                    React__default.createElement(Redirect, { from: "/paginas", to: "/", exact: false }),
                    React__default.createElement(Redirect, { from: "/CookieAuth.dll", to: "/", exact: false }),
                    this.props.children && React__default.createElement(Route, { exact: true, path: "/" },
                        React__default.createElement(Page, { title: "Inicio" },
                            React__default.createElement(React__default.Fragment, null, this.props.children))),
                    React__default.createElement(Route, { path: "/Aplicacion" },
                        React__default.createElement(Page, { title: "Aplicaci\u00F3n" }, ((_c = ((_b = qs.get("aplicacion")) !== null && _b !== void 0 ? _b : qs.get("Aplicacion"))) === null || _c === void 0 ? void 0 : _c.toUpperCase()) == "APLICACIONESREACT" ?
                            React__default.createElement(AppReactContainer, { menuUrlApp: menuHelper.getUrlTransaccion(this.props.location.search), componentesReact: this.props.componentesReact, globalBotHide: function () { return _this.state.globalBotHide; }, actualizarGlobalBotHide: function (newValue) { return _this.actualizarGlobalBotHide(newValue); } })
                            : React__default.createElement(AppContainer, { menuOption: { titulo: "Aplicación", tipo: (_d = qs.get("aplicacion")) !== null && _d !== void 0 ? _d : qs.get("Aplicacion"), urlApp: menuHelper.getUrlTransaccion(this.props.location.search), plantilla: "GCOAPP" } }))),
                    this.props.routes && this.props.routes.map(function (route) {
                        if ((!route.admin || user.admin) && !routesAplicacionesReact.find(function (x) { return x == route.path; })) {
                            return React__default.createElement(Route, { exact: route.exact, key: "KeyRutePPM" + _this.state.idClick, path: route.path, children: function () { return React__default.createElement(Page, { title: route.titulo }, route.component); } });
                        }
                        else {
                            return null;
                        }
                    }),
                    menu && menu.enlaces && menu.enlaces.map(function (enlace) { return _this.getRoutes(enlace); }),
                    React__default.createElement(Route, { path: "/logout" },
                        React__default.createElement(Page, { title: "Cerrando sesi\u00F3n..." },
                            React__default.createElement(Logout, null))),
                    React__default.createElement(Route, { path: "/*" },
                        React__default.createElement(Page, { title: "No encontrada" },
                            React__default.createElement(NotFound, null)))))));
    };
    Layout.contextType = PortalContext;
    return Layout;
}(React__default.Component));
var PortalLayout = withWidth()(withRouter(withStyles$1(function (theme) {
    var _a, _b;
    return ({
        root: {
            flexGrow: 1
        },
        menuButton: {
            marginRight: theme.spacing(2)
        },
        title: {
            flexGrow: 1,
            textAlign: "left"
        },
        userAvatar: {
            color: theme.palette.primary.main,
            backgroundColor: fade(theme.palette.primary.contrastText, 0.95)
        },
        userAvatarText: {
            fontFamily: "CO-Medium"
        },
        primaryContrastText: {
            color: theme.palette.primary.contrastText,
            padding: theme.spacing(1)
        },
        toolbarIcon: {
            color: fade(theme.palette.primary.contrastText, 0.95)
        },
        small: {
            padding: 4
        },
        search: (_a = {
                position: "relative",
                borderRadius: theme.shape.borderRadius,
                backgroundColor: fade(theme.palette.common.white, 0.15),
                "&:hover": {
                    backgroundColor: fade(theme.palette.common.white, 0.25)
                },
                marginRight: theme.spacing(2),
                marginLeft: 0,
                width: "100%"
            },
            _a[theme.breakpoints.up("sm")] = {
                marginLeft: theme.spacing(3),
                width: "auto"
            },
            _a),
        searchIcon: {
            padding: theme.spacing(0, 1),
            paddingTop: "3px",
            height: "100%",
            position: "absolute",
            pointerEvents: "none",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: fade(theme.palette.common.white, 0.95)
        },
        inputRoot: {
            color: "inherit"
        },
        userProfile: {
            backgroundColor: theme.palette.primary.main,
            textAlign: "center",
            padding: theme.spacing(1)
        },
        inputInput: (_b = {
                padding: theme.spacing(1, 1, 1, 0),
                // vertical padding + font size from searchIcon
                paddingLeft: "calc(1em + " + theme.spacing(2) + "px)",
                transition: theme.transitions.create("width"),
                width: "100%"
            },
            _b[theme.breakpoints.up("sm")] = {
                width: "12ch",
                "&:focus": {
                    width: "20ch"
                }
            },
            _b),
        mainPaper: {
            backgroundColor: "#f0f0f0",
            minHeight: "calc(100vh - 58px)",
            paddingTop: "58px",
            boxSizing: "border-box",
        }
    });
})(Layout)));

var useStyles$2 = makeStyles$1(function (theme) { return ({
    root: {
        width: "360px",
        maxWidth: "90vw",
        textAlign: "start"
    },
    title: {
        fontFamily: "CO-Medium",
        color: theme.palette.secondary.main
    },
    content: {
        paddingBottom: "0px"
    }
}); });
function PortalSplash(props) {
    var _a, _b, _c;
    var titulo = props.titulo;
    var classes = useStyles$2();
    var logo = getCiaBuilding();
    var portal = getPortalTitle();
    return (React__default.createElement("div", { style: { height: "100vh", width: "100vw", position: "fixed", top: "0" } },
        React__default.createElement(Grid, { container: true, spacing: 0, direction: "column", alignItems: "center", justify: "center", style: { minHeight: "100vh" } },
            React__default.createElement(Grid, { item: true, md: 3 },
                React__default.createElement(Card, { className: classes.root },
                    !props.mensaje && React__default.createElement(LinearProgress, { color: "primary" }),
                    React__default.createElement(CardContent, { className: classes.content },
                        React__default.createElement(Typography, { gutterBottom: true, variant: "h6", className: classes.title }, titulo),
                        React__default.createElement(Collapse, { "in": props.mensaje != null },
                            React__default.createElement(Alert, { severity: (_a = props.mensaje) === null || _a === void 0 ? void 0 : _a.tipo, titulo: (_b = props.mensaje) === null || _b === void 0 ? void 0 : _b.titulo, message: (_c = props.mensaje) === null || _c === void 0 ? void 0 : _c.subtitulo }))),
                    React__default.createElement(CardMedia, { component: "img", alt: portal, image: logo, title: portal }))))));
}

var guid = createCommonjsModule(function (module, exports) {
exports.__esModule = true;
var Guid = /** @class */ (function () {
    function Guid(guid) {
        if (!guid) {
            throw new TypeError("Invalid argument; `value` has no value.");
        }
        this.value = Guid.EMPTY;
        if (guid && Guid.isGuid(guid)) {
            this.value = guid;
        }
    }
    Guid.isGuid = function (guid) {
        var value = guid.toString();
        return guid && (guid instanceof Guid || Guid.validator.test(value));
    };
    Guid.create = function () {
        return new Guid([Guid.gen(2), Guid.gen(1), Guid.gen(1), Guid.gen(1), Guid.gen(3)].join("-"));
    };
    Guid.createEmpty = function () {
        return new Guid("emptyguid");
    };
    Guid.parse = function (guid) {
        return new Guid(guid);
    };
    Guid.raw = function () {
        return [Guid.gen(2), Guid.gen(1), Guid.gen(1), Guid.gen(1), Guid.gen(3)].join("-");
    };
    Guid.gen = function (count) {
        var out = "";
        for (var i = 0; i < count; i++) {
            // tslint:disable-next-line:no-bitwise
            out += (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
        }
        return out;
    };
    Guid.prototype.equals = function (other) {
        // Comparing string `value` against provided `guid` will auto-call
        // toString on `guid` for comparison
        return Guid.isGuid(other) && this.value === other.toString();
    };
    Guid.prototype.isEmpty = function () {
        return this.value === Guid.EMPTY;
    };
    Guid.prototype.toString = function () {
        return this.value;
    };
    Guid.prototype.toJSON = function () {
        return {
            value: this.value
        };
    };
    Guid.validator = new RegExp("^[a-z0-9]{8}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{12}$", "i");
    Guid.EMPTY = "00000000-0000-0000-0000-000000000000";
    return Guid;
}());
exports.Guid = Guid;
});

function ScrollToTop(props) {
    useEffect(function () {
        var unlisten = props.history.listen(function () {
            window.scrollTo(0, 0);
        });
        return function () {
            unlisten();
        };
    }, []);
    return React__default.createElement(Fragment$1, null, props.children);
}
var ScrollToTop$1 = withRouter(ScrollToTop);

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const stringToByteArray$1 = function (str) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let p = 0;
    for (let i = 0; i < str.length; i++) {
        let c = str.charCodeAt(i);
        if (c < 128) {
            out[p++] = c;
        }
        else if (c < 2048) {
            out[p++] = (c >> 6) | 192;
            out[p++] = (c & 63) | 128;
        }
        else if ((c & 0xfc00) === 0xd800 &&
            i + 1 < str.length &&
            (str.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            // Surrogate Pair
            c = 0x10000 + ((c & 0x03ff) << 10) + (str.charCodeAt(++i) & 0x03ff);
            out[p++] = (c >> 18) | 240;
            out[p++] = ((c >> 12) & 63) | 128;
            out[p++] = ((c >> 6) & 63) | 128;
            out[p++] = (c & 63) | 128;
        }
        else {
            out[p++] = (c >> 12) | 224;
            out[p++] = ((c >> 6) & 63) | 128;
            out[p++] = (c & 63) | 128;
        }
    }
    return out;
};
/**
 * Turns an array of numbers into the string given by the concatenation of the
 * characters to which the numbers correspond.
 * @param bytes Array of numbers representing characters.
 * @return Stringification of the array.
 */
const byteArrayToString = function (bytes) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let pos = 0, c = 0;
    while (pos < bytes.length) {
        const c1 = bytes[pos++];
        if (c1 < 128) {
            out[c++] = String.fromCharCode(c1);
        }
        else if (c1 > 191 && c1 < 224) {
            const c2 = bytes[pos++];
            out[c++] = String.fromCharCode(((c1 & 31) << 6) | (c2 & 63));
        }
        else if (c1 > 239 && c1 < 365) {
            // Surrogate Pair
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            const c4 = bytes[pos++];
            const u = (((c1 & 7) << 18) | ((c2 & 63) << 12) | ((c3 & 63) << 6) | (c4 & 63)) -
                0x10000;
            out[c++] = String.fromCharCode(0xd800 + (u >> 10));
            out[c++] = String.fromCharCode(0xdc00 + (u & 1023));
        }
        else {
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            out[c++] = String.fromCharCode(((c1 & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
        }
    }
    return out.join('');
};
// We define it as an object literal instead of a class because a class compiled down to es5 can't
// be treeshaked. https://github.com/rollup/rollup/issues/1691
// Static lookup maps, lazily populated by init_()
const base64 = {
    /**
     * Maps bytes to characters.
     */
    byteToCharMap_: null,
    /**
     * Maps characters to bytes.
     */
    charToByteMap_: null,
    /**
     * Maps bytes to websafe characters.
     * @private
     */
    byteToCharMapWebSafe_: null,
    /**
     * Maps websafe characters to bytes.
     * @private
     */
    charToByteMapWebSafe_: null,
    /**
     * Our default alphabet, shared between
     * ENCODED_VALS and ENCODED_VALS_WEBSAFE
     */
    ENCODED_VALS_BASE: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ' + 'abcdefghijklmnopqrstuvwxyz' + '0123456789',
    /**
     * Our default alphabet. Value 64 (=) is special; it means "nothing."
     */
    get ENCODED_VALS() {
        return this.ENCODED_VALS_BASE + '+/=';
    },
    /**
     * Our websafe alphabet.
     */
    get ENCODED_VALS_WEBSAFE() {
        return this.ENCODED_VALS_BASE + '-_.';
    },
    /**
     * Whether this browser supports the atob and btoa functions. This extension
     * started at Mozilla but is now implemented by many browsers. We use the
     * ASSUME_* variables to avoid pulling in the full useragent detection library
     * but still allowing the standard per-browser compilations.
     *
     */
    HAS_NATIVE_SUPPORT: typeof atob === 'function',
    /**
     * Base64-encode an array of bytes.
     *
     * @param input An array of bytes (numbers with
     *     value in [0, 255]) to encode.
     * @param webSafe Boolean indicating we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */
    encodeByteArray(input, webSafe) {
        if (!Array.isArray(input)) {
            throw Error('encodeByteArray takes an array as a parameter');
        }
        this.init_();
        const byteToCharMap = webSafe
            ? this.byteToCharMapWebSafe_
            : this.byteToCharMap_;
        const output = [];
        for (let i = 0; i < input.length; i += 3) {
            const byte1 = input[i];
            const haveByte2 = i + 1 < input.length;
            const byte2 = haveByte2 ? input[i + 1] : 0;
            const haveByte3 = i + 2 < input.length;
            const byte3 = haveByte3 ? input[i + 2] : 0;
            const outByte1 = byte1 >> 2;
            const outByte2 = ((byte1 & 0x03) << 4) | (byte2 >> 4);
            let outByte3 = ((byte2 & 0x0f) << 2) | (byte3 >> 6);
            let outByte4 = byte3 & 0x3f;
            if (!haveByte3) {
                outByte4 = 64;
                if (!haveByte2) {
                    outByte3 = 64;
                }
            }
            output.push(byteToCharMap[outByte1], byteToCharMap[outByte2], byteToCharMap[outByte3], byteToCharMap[outByte4]);
        }
        return output.join('');
    },
    /**
     * Base64-encode a string.
     *
     * @param input A string to encode.
     * @param webSafe If true, we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */
    encodeString(input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) {
            return btoa(input);
        }
        return this.encodeByteArray(stringToByteArray$1(input), webSafe);
    },
    /**
     * Base64-decode a string.
     *
     * @param input to decode.
     * @param webSafe True if we should use the
     *     alternative alphabet.
     * @return string representing the decoded value.
     */
    decodeString(input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) {
            return atob(input);
        }
        return byteArrayToString(this.decodeStringToByteArray(input, webSafe));
    },
    /**
     * Base64-decode a string.
     *
     * In base-64 decoding, groups of four characters are converted into three
     * bytes.  If the encoder did not apply padding, the input length may not
     * be a multiple of 4.
     *
     * In this case, the last group will have fewer than 4 characters, and
     * padding will be inferred.  If the group has one or two characters, it decodes
     * to one byte.  If the group has three characters, it decodes to two bytes.
     *
     * @param input Input to decode.
     * @param webSafe True if we should use the web-safe alphabet.
     * @return bytes representing the decoded value.
     */
    decodeStringToByteArray(input, webSafe) {
        this.init_();
        const charToByteMap = webSafe
            ? this.charToByteMapWebSafe_
            : this.charToByteMap_;
        const output = [];
        for (let i = 0; i < input.length;) {
            const byte1 = charToByteMap[input.charAt(i++)];
            const haveByte2 = i < input.length;
            const byte2 = haveByte2 ? charToByteMap[input.charAt(i)] : 0;
            ++i;
            const haveByte3 = i < input.length;
            const byte3 = haveByte3 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            const haveByte4 = i < input.length;
            const byte4 = haveByte4 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            if (byte1 == null || byte2 == null || byte3 == null || byte4 == null) {
                throw new DecodeBase64StringError();
            }
            const outByte1 = (byte1 << 2) | (byte2 >> 4);
            output.push(outByte1);
            if (byte3 !== 64) {
                const outByte2 = ((byte2 << 4) & 0xf0) | (byte3 >> 2);
                output.push(outByte2);
                if (byte4 !== 64) {
                    const outByte3 = ((byte3 << 6) & 0xc0) | byte4;
                    output.push(outByte3);
                }
            }
        }
        return output;
    },
    /**
     * Lazy static initialization function. Called before
     * accessing any of the static map variables.
     * @private
     */
    init_() {
        if (!this.byteToCharMap_) {
            this.byteToCharMap_ = {};
            this.charToByteMap_ = {};
            this.byteToCharMapWebSafe_ = {};
            this.charToByteMapWebSafe_ = {};
            // We want quick mappings back and forth, so we precompute two maps.
            for (let i = 0; i < this.ENCODED_VALS.length; i++) {
                this.byteToCharMap_[i] = this.ENCODED_VALS.charAt(i);
                this.charToByteMap_[this.byteToCharMap_[i]] = i;
                this.byteToCharMapWebSafe_[i] = this.ENCODED_VALS_WEBSAFE.charAt(i);
                this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[i]] = i;
                // Be forgiving when decoding and correctly decode both encodings.
                if (i >= this.ENCODED_VALS_BASE.length) {
                    this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(i)] = i;
                    this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(i)] = i;
                }
            }
        }
    }
};
/**
 * An error encountered while decoding base64 string.
 */
class DecodeBase64StringError extends Error {
    constructor() {
        super(...arguments);
        this.name = 'DecodeBase64StringError';
    }
}
/**
 * URL-safe base64 encoding
 */
const base64Encode = function (str) {
    const utf8Bytes = stringToByteArray$1(str);
    return base64.encodeByteArray(utf8Bytes, true);
};
/**
 * URL-safe base64 encoding (without "." padding in the end).
 * e.g. Used in JSON Web Token (JWT) parts.
 */
const base64urlEncodeWithoutPadding = function (str) {
    // Use base64url encoding and remove padding in the end (dot characters).
    return base64Encode(str).replace(/\./g, '');
};
/**
 * URL-safe base64 decoding
 *
 * NOTE: DO NOT use the global atob() function - it does NOT support the
 * base64Url variant encoding.
 *
 * @param str To be decoded
 * @return Decoded result, if possible
 */
const base64Decode = function (str) {
    try {
        return base64.decodeString(str, true);
    }
    catch (e) {
        console.error('base64Decode failed: ', e);
    }
    return null;
};

/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Polyfill for `globalThis` object.
 * @returns the `globalThis` object for the given environment.
 * @public
 */
function getGlobal() {
    if (typeof self !== 'undefined') {
        return self;
    }
    if (typeof window !== 'undefined') {
        return window;
    }
    if (typeof global !== 'undefined') {
        return global;
    }
    throw new Error('Unable to locate global object.');
}

/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const getDefaultsFromGlobal = () => getGlobal().__FIREBASE_DEFAULTS__;
/**
 * Attempt to read defaults from a JSON string provided to
 * process(.)env(.)__FIREBASE_DEFAULTS__ or a JSON file whose path is in
 * process(.)env(.)__FIREBASE_DEFAULTS_PATH__
 * The dots are in parens because certain compilers (Vite?) cannot
 * handle seeing that variable in comments.
 * See https://github.com/firebase/firebase-js-sdk/issues/6838
 */
const getDefaultsFromEnvVariable = () => {
    if (typeof process === 'undefined' || typeof process.env === 'undefined') {
        return;
    }
    const defaultsJsonString = process.env.__FIREBASE_DEFAULTS__;
    if (defaultsJsonString) {
        return JSON.parse(defaultsJsonString);
    }
};
const getDefaultsFromCookie = () => {
    if (typeof document === 'undefined') {
        return;
    }
    let match;
    try {
        match = document.cookie.match(/__FIREBASE_DEFAULTS__=([^;]+)/);
    }
    catch (e) {
        // Some environments such as Angular Universal SSR have a
        // `document` object but error on accessing `document.cookie`.
        return;
    }
    const decoded = match && base64Decode(match[1]);
    return decoded && JSON.parse(decoded);
};
/**
 * Get the __FIREBASE_DEFAULTS__ object. It checks in order:
 * (1) if such an object exists as a property of `globalThis`
 * (2) if such an object was provided on a shell environment variable
 * (3) if such an object exists in a cookie
 * @public
 */
const getDefaults = () => {
    try {
        return (getDefaultsFromGlobal() ||
            getDefaultsFromEnvVariable() ||
            getDefaultsFromCookie());
    }
    catch (e) {
        /**
         * Catch-all for being unable to get __FIREBASE_DEFAULTS__ due
         * to any environment case we have not accounted for. Log to
         * info instead of swallowing so we can find these unknown cases
         * and add paths for them if needed.
         */
        console.info(`Unable to get __FIREBASE_DEFAULTS__ due to: ${e}`);
        return;
    }
};
/**
 * Returns Firebase app config stored in the __FIREBASE_DEFAULTS__ object.
 * @public
 */
const getDefaultAppConfig = () => { var _a; return (_a = getDefaults()) === null || _a === void 0 ? void 0 : _a.config; };

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Deferred {
    constructor() {
        this.reject = () => { };
        this.resolve = () => { };
        this.promise = new Promise((resolve, reject) => {
            this.resolve = resolve;
            this.reject = reject;
        });
    }
    /**
     * Our API internals are not promiseified and cannot because our callback APIs have subtle expectations around
     * invoking promises inline, which Promises are forbidden to do. This method accepts an optional node-style callback
     * and returns a node-style callback which will resolve or reject the Deferred's promise.
     */
    wrapCallback(callback) {
        return (error, value) => {
            if (error) {
                this.reject(error);
            }
            else {
                this.resolve(value);
            }
            if (typeof callback === 'function') {
                // Attaching noop handler just in case developer wasn't expecting
                // promises
                this.promise.catch(() => { });
                // Some of our callbacks don't expect a value and our own tests
                // assert that the parameter length is 1
                if (callback.length === 1) {
                    callback(error);
                }
                else {
                    callback(error, value);
                }
            }
        };
    }
}
/**
 * This method checks if indexedDB is supported by current browser/service worker context
 * @return true if indexedDB is supported by current browser/service worker context
 */
function isIndexedDBAvailable() {
    try {
        return typeof indexedDB === 'object';
    }
    catch (e) {
        return false;
    }
}
/**
 * This method validates browser/sw context for indexedDB by opening a dummy indexedDB database and reject
 * if errors occur during the database open operation.
 *
 * @throws exception if current browser/sw context can't run idb.open (ex: Safari iframe, Firefox
 * private browsing)
 */
function validateIndexedDBOpenable() {
    return new Promise((resolve, reject) => {
        try {
            let preExist = true;
            const DB_CHECK_NAME = 'validate-browser-context-for-indexeddb-analytics-module';
            const request = self.indexedDB.open(DB_CHECK_NAME);
            request.onsuccess = () => {
                request.result.close();
                // delete database only when it doesn't pre-exist
                if (!preExist) {
                    self.indexedDB.deleteDatabase(DB_CHECK_NAME);
                }
                resolve(true);
            };
            request.onupgradeneeded = () => {
                preExist = false;
            };
            request.onerror = () => {
                var _a;
                reject(((_a = request.error) === null || _a === void 0 ? void 0 : _a.message) || '');
            };
        }
        catch (error) {
            reject(error);
        }
    });
}
/**
 *
 * This method checks whether cookie is enabled within current browser
 * @return true if cookie is enabled within current browser
 */
function areCookiesEnabled() {
    if (typeof navigator === 'undefined' || !navigator.cookieEnabled) {
        return false;
    }
    return true;
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @fileoverview Standardized Firebase Error.
 *
 * Usage:
 *
 *   // Typescript string literals for type-safe codes
 *   type Err =
 *     'unknown' |
 *     'object-not-found'
 *     ;
 *
 *   // Closure enum for type-safe error codes
 *   // at-enum {string}
 *   var Err = {
 *     UNKNOWN: 'unknown',
 *     OBJECT_NOT_FOUND: 'object-not-found',
 *   }
 *
 *   let errors: Map<Err, string> = {
 *     'generic-error': "Unknown error",
 *     'file-not-found': "Could not find file: {$file}",
 *   };
 *
 *   // Type-safe function - must pass a valid error code as param.
 *   let error = new ErrorFactory<Err>('service', 'Service', errors);
 *
 *   ...
 *   throw error.create(Err.GENERIC);
 *   ...
 *   throw error.create(Err.FILE_NOT_FOUND, {'file': fileName});
 *   ...
 *   // Service: Could not file file: foo.txt (service/file-not-found).
 *
 *   catch (e) {
 *     assert(e.message === "Could not find file: foo.txt.");
 *     if ((e as FirebaseError)?.code === 'service/file-not-found') {
 *       console.log("Could not read file: " + e['file']);
 *     }
 *   }
 */
const ERROR_NAME = 'FirebaseError';
// Based on code from:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Custom_Error_Types
class FirebaseError extends Error {
    constructor(
    /** The error code for this error. */
    code, message, 
    /** Custom data for this error. */
    customData) {
        super(message);
        this.code = code;
        this.customData = customData;
        /** The custom name for all FirebaseErrors. */
        this.name = ERROR_NAME;
        // Fix For ES5
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, FirebaseError.prototype);
        // Maintains proper stack trace for where our error was thrown.
        // Only available on V8.
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, ErrorFactory.prototype.create);
        }
    }
}
class ErrorFactory {
    constructor(service, serviceName, errors) {
        this.service = service;
        this.serviceName = serviceName;
        this.errors = errors;
    }
    create(code, ...data) {
        const customData = data[0] || {};
        const fullCode = `${this.service}/${code}`;
        const template = this.errors[code];
        const message = template ? replaceTemplate(template, customData) : 'Error';
        // Service Name: Error message (service/code).
        const fullMessage = `${this.serviceName}: ${message} (${fullCode}).`;
        const error = new FirebaseError(fullCode, fullMessage, customData);
        return error;
    }
}
function replaceTemplate(template, data) {
    return template.replace(PATTERN, (_, key) => {
        const value = data[key];
        return value != null ? String(value) : `<${key}?>`;
    });
}
const PATTERN = /\{\$([^}]+)}/g;
/**
 * Deep equal two objects. Support Arrays and Objects.
 */
function deepEqual(a, b) {
    if (a === b) {
        return true;
    }
    const aKeys = Object.keys(a);
    const bKeys = Object.keys(b);
    for (const k of aKeys) {
        if (!bKeys.includes(k)) {
            return false;
        }
        const aProp = a[k];
        const bProp = b[k];
        if (isObject(aProp) && isObject(bProp)) {
            if (!deepEqual(aProp, bProp)) {
                return false;
            }
        }
        else if (aProp !== bProp) {
            return false;
        }
    }
    for (const k of bKeys) {
        if (!aKeys.includes(k)) {
            return false;
        }
    }
    return true;
}
function isObject(thing) {
    return thing !== null && typeof thing === 'object';
}

/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function getModularInstance(service) {
    if (service && service._delegate) {
        return service._delegate;
    }
    else {
        return service;
    }
}

/**
 * Component for service name T, e.g. `auth`, `auth-internal`
 */
class Component {
    /**
     *
     * @param name The public service name, e.g. app, auth, firestore, database
     * @param instanceFactory Service factory responsible for creating the public interface
     * @param type whether the service provided by the component is public or private
     */
    constructor(name, instanceFactory, type) {
        this.name = name;
        this.instanceFactory = instanceFactory;
        this.type = type;
        this.multipleInstances = false;
        /**
         * Properties to be added to the service namespace
         */
        this.serviceProps = {};
        this.instantiationMode = "LAZY" /* InstantiationMode.LAZY */;
        this.onInstanceCreated = null;
    }
    setInstantiationMode(mode) {
        this.instantiationMode = mode;
        return this;
    }
    setMultipleInstances(multipleInstances) {
        this.multipleInstances = multipleInstances;
        return this;
    }
    setServiceProps(props) {
        this.serviceProps = props;
        return this;
    }
    setInstanceCreatedCallback(callback) {
        this.onInstanceCreated = callback;
        return this;
    }
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const DEFAULT_ENTRY_NAME$1 = '[DEFAULT]';

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Provider for instance for service name T, e.g. 'auth', 'auth-internal'
 * NameServiceMapping[T] is an alias for the type of the instance
 */
class Provider {
    constructor(name, container) {
        this.name = name;
        this.container = container;
        this.component = null;
        this.instances = new Map();
        this.instancesDeferred = new Map();
        this.instancesOptions = new Map();
        this.onInitCallbacks = new Map();
    }
    /**
     * @param identifier A provider can provide mulitple instances of a service
     * if this.component.multipleInstances is true.
     */
    get(identifier) {
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        if (!this.instancesDeferred.has(normalizedIdentifier)) {
            const deferred = new Deferred();
            this.instancesDeferred.set(normalizedIdentifier, deferred);
            if (this.isInitialized(normalizedIdentifier) ||
                this.shouldAutoInitialize()) {
                // initialize the service if it can be auto-initialized
                try {
                    const instance = this.getOrInitializeService({
                        instanceIdentifier: normalizedIdentifier
                    });
                    if (instance) {
                        deferred.resolve(instance);
                    }
                }
                catch (e) {
                    // when the instance factory throws an exception during get(), it should not cause
                    // a fatal error. We just return the unresolved promise in this case.
                }
            }
        }
        return this.instancesDeferred.get(normalizedIdentifier).promise;
    }
    getImmediate(options) {
        var _a;
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(options === null || options === void 0 ? void 0 : options.identifier);
        const optional = (_a = options === null || options === void 0 ? void 0 : options.optional) !== null && _a !== void 0 ? _a : false;
        if (this.isInitialized(normalizedIdentifier) ||
            this.shouldAutoInitialize()) {
            try {
                return this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
            }
            catch (e) {
                if (optional) {
                    return null;
                }
                else {
                    throw e;
                }
            }
        }
        else {
            // In case a component is not initialized and should/can not be auto-initialized at the moment, return null if the optional flag is set, or throw
            if (optional) {
                return null;
            }
            else {
                throw Error(`Service ${this.name} is not available`);
            }
        }
    }
    getComponent() {
        return this.component;
    }
    setComponent(component) {
        if (component.name !== this.name) {
            throw Error(`Mismatching Component ${component.name} for Provider ${this.name}.`);
        }
        if (this.component) {
            throw Error(`Component for ${this.name} has already been provided`);
        }
        this.component = component;
        // return early without attempting to initialize the component if the component requires explicit initialization (calling `Provider.initialize()`)
        if (!this.shouldAutoInitialize()) {
            return;
        }
        // if the service is eager, initialize the default instance
        if (isComponentEager(component)) {
            try {
                this.getOrInitializeService({ instanceIdentifier: DEFAULT_ENTRY_NAME$1 });
            }
            catch (e) {
                // when the instance factory for an eager Component throws an exception during the eager
                // initialization, it should not cause a fatal error.
                // TODO: Investigate if we need to make it configurable, because some component may want to cause
                // a fatal error in this case?
            }
        }
        // Create service instances for the pending promises and resolve them
        // NOTE: if this.multipleInstances is false, only the default instance will be created
        // and all promises with resolve with it regardless of the identifier.
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()) {
            const normalizedIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            try {
                // `getOrInitializeService()` should always return a valid instance since a component is guaranteed. use ! to make typescript happy.
                const instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
                instanceDeferred.resolve(instance);
            }
            catch (e) {
                // when the instance factory throws an exception, it should not cause
                // a fatal error. We just leave the promise unresolved.
            }
        }
    }
    clearInstance(identifier = DEFAULT_ENTRY_NAME$1) {
        this.instancesDeferred.delete(identifier);
        this.instancesOptions.delete(identifier);
        this.instances.delete(identifier);
    }
    // app.delete() will call this method on every provider to delete the services
    // TODO: should we mark the provider as deleted?
    async delete() {
        const services = Array.from(this.instances.values());
        await Promise.all([
            ...services
                .filter(service => 'INTERNAL' in service) // legacy services
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                .map(service => service.INTERNAL.delete()),
            ...services
                .filter(service => '_delete' in service) // modularized services
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                .map(service => service._delete())
        ]);
    }
    isComponentSet() {
        return this.component != null;
    }
    isInitialized(identifier = DEFAULT_ENTRY_NAME$1) {
        return this.instances.has(identifier);
    }
    getOptions(identifier = DEFAULT_ENTRY_NAME$1) {
        return this.instancesOptions.get(identifier) || {};
    }
    initialize(opts = {}) {
        const { options = {} } = opts;
        const normalizedIdentifier = this.normalizeInstanceIdentifier(opts.instanceIdentifier);
        if (this.isInitialized(normalizedIdentifier)) {
            throw Error(`${this.name}(${normalizedIdentifier}) has already been initialized`);
        }
        if (!this.isComponentSet()) {
            throw Error(`Component ${this.name} has not been registered yet`);
        }
        const instance = this.getOrInitializeService({
            instanceIdentifier: normalizedIdentifier,
            options
        });
        // resolve any pending promise waiting for the service instance
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()) {
            const normalizedDeferredIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            if (normalizedIdentifier === normalizedDeferredIdentifier) {
                instanceDeferred.resolve(instance);
            }
        }
        return instance;
    }
    /**
     *
     * @param callback - a function that will be invoked  after the provider has been initialized by calling provider.initialize().
     * The function is invoked SYNCHRONOUSLY, so it should not execute any longrunning tasks in order to not block the program.
     *
     * @param identifier An optional instance identifier
     * @returns a function to unregister the callback
     */
    onInit(callback, identifier) {
        var _a;
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        const existingCallbacks = (_a = this.onInitCallbacks.get(normalizedIdentifier)) !== null && _a !== void 0 ? _a : new Set();
        existingCallbacks.add(callback);
        this.onInitCallbacks.set(normalizedIdentifier, existingCallbacks);
        const existingInstance = this.instances.get(normalizedIdentifier);
        if (existingInstance) {
            callback(existingInstance, normalizedIdentifier);
        }
        return () => {
            existingCallbacks.delete(callback);
        };
    }
    /**
     * Invoke onInit callbacks synchronously
     * @param instance the service instance`
     */
    invokeOnInitCallbacks(instance, identifier) {
        const callbacks = this.onInitCallbacks.get(identifier);
        if (!callbacks) {
            return;
        }
        for (const callback of callbacks) {
            try {
                callback(instance, identifier);
            }
            catch (_a) {
                // ignore errors in the onInit callback
            }
        }
    }
    getOrInitializeService({ instanceIdentifier, options = {} }) {
        let instance = this.instances.get(instanceIdentifier);
        if (!instance && this.component) {
            instance = this.component.instanceFactory(this.container, {
                instanceIdentifier: normalizeIdentifierForFactory(instanceIdentifier),
                options
            });
            this.instances.set(instanceIdentifier, instance);
            this.instancesOptions.set(instanceIdentifier, options);
            /**
             * Invoke onInit listeners.
             * Note this.component.onInstanceCreated is different, which is used by the component creator,
             * while onInit listeners are registered by consumers of the provider.
             */
            this.invokeOnInitCallbacks(instance, instanceIdentifier);
            /**
             * Order is important
             * onInstanceCreated() should be called after this.instances.set(instanceIdentifier, instance); which
             * makes `isInitialized()` return true.
             */
            if (this.component.onInstanceCreated) {
                try {
                    this.component.onInstanceCreated(this.container, instanceIdentifier, instance);
                }
                catch (_a) {
                    // ignore errors in the onInstanceCreatedCallback
                }
            }
        }
        return instance || null;
    }
    normalizeInstanceIdentifier(identifier = DEFAULT_ENTRY_NAME$1) {
        if (this.component) {
            return this.component.multipleInstances ? identifier : DEFAULT_ENTRY_NAME$1;
        }
        else {
            return identifier; // assume multiple instances are supported before the component is provided.
        }
    }
    shouldAutoInitialize() {
        return (!!this.component &&
            this.component.instantiationMode !== "EXPLICIT" /* InstantiationMode.EXPLICIT */);
    }
}
// undefined should be passed to the service factory for the default instance
function normalizeIdentifierForFactory(identifier) {
    return identifier === DEFAULT_ENTRY_NAME$1 ? undefined : identifier;
}
function isComponentEager(component) {
    return component.instantiationMode === "EAGER" /* InstantiationMode.EAGER */;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * ComponentContainer that provides Providers for service name T, e.g. `auth`, `auth-internal`
 */
class ComponentContainer {
    constructor(name) {
        this.name = name;
        this.providers = new Map();
    }
    /**
     *
     * @param component Component being added
     * @param overwrite When a component with the same name has already been registered,
     * if overwrite is true: overwrite the existing component with the new component and create a new
     * provider with the new component. It can be useful in tests where you want to use different mocks
     * for different tests.
     * if overwrite is false: throw an exception
     */
    addComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) {
            throw new Error(`Component ${component.name} has already been registered with ${this.name}`);
        }
        provider.setComponent(component);
    }
    addOrOverwriteComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) {
            // delete the existing provider from the container, so we can register the new component
            this.providers.delete(component.name);
        }
        this.addComponent(component);
    }
    /**
     * getProvider provides a type safe interface where it can only be called with a field name
     * present in NameServiceMapping interface.
     *
     * Firebase SDKs providing services should extend NameServiceMapping interface to register
     * themselves.
     */
    getProvider(name) {
        if (this.providers.has(name)) {
            return this.providers.get(name);
        }
        // create a Provider for a service that hasn't registered with Firebase
        const provider = new Provider(name, this);
        this.providers.set(name, provider);
        return provider;
    }
    getProviders() {
        return Array.from(this.providers.values());
    }
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * The JS SDK supports 5 log levels and also allows a user the ability to
 * silence the logs altogether.
 *
 * The order is a follows:
 * DEBUG < VERBOSE < INFO < WARN < ERROR
 *
 * All of the log types above the current log level will be captured (i.e. if
 * you set the log level to `INFO`, errors will still be logged, but `DEBUG` and
 * `VERBOSE` logs will not)
 */
var LogLevel;
(function (LogLevel) {
    LogLevel[LogLevel["DEBUG"] = 0] = "DEBUG";
    LogLevel[LogLevel["VERBOSE"] = 1] = "VERBOSE";
    LogLevel[LogLevel["INFO"] = 2] = "INFO";
    LogLevel[LogLevel["WARN"] = 3] = "WARN";
    LogLevel[LogLevel["ERROR"] = 4] = "ERROR";
    LogLevel[LogLevel["SILENT"] = 5] = "SILENT";
})(LogLevel || (LogLevel = {}));
const levelStringToEnum = {
    'debug': LogLevel.DEBUG,
    'verbose': LogLevel.VERBOSE,
    'info': LogLevel.INFO,
    'warn': LogLevel.WARN,
    'error': LogLevel.ERROR,
    'silent': LogLevel.SILENT
};
/**
 * The default log level
 */
const defaultLogLevel = LogLevel.INFO;
/**
 * By default, `console.debug` is not displayed in the developer console (in
 * chrome). To avoid forcing users to have to opt-in to these logs twice
 * (i.e. once for firebase, and once in the console), we are sending `DEBUG`
 * logs to the `console.log` function.
 */
const ConsoleMethod = {
    [LogLevel.DEBUG]: 'log',
    [LogLevel.VERBOSE]: 'log',
    [LogLevel.INFO]: 'info',
    [LogLevel.WARN]: 'warn',
    [LogLevel.ERROR]: 'error'
};
/**
 * The default log handler will forward DEBUG, VERBOSE, INFO, WARN, and ERROR
 * messages on to their corresponding console counterparts (if the log method
 * is supported by the current log level)
 */
const defaultLogHandler = (instance, logType, ...args) => {
    if (logType < instance.logLevel) {
        return;
    }
    const now = new Date().toISOString();
    const method = ConsoleMethod[logType];
    if (method) {
        console[method](`[${now}]  ${instance.name}:`, ...args);
    }
    else {
        throw new Error(`Attempted to log a message with an invalid logType (value: ${logType})`);
    }
};
class Logger {
    /**
     * Gives you an instance of a Logger to capture messages according to
     * Firebase's logging scheme.
     *
     * @param name The name that the logs will be associated with
     */
    constructor(name) {
        this.name = name;
        /**
         * The log level of the given Logger instance.
         */
        this._logLevel = defaultLogLevel;
        /**
         * The main (internal) log handler for the Logger instance.
         * Can be set to a new function in internal package code but not by user.
         */
        this._logHandler = defaultLogHandler;
        /**
         * The optional, additional, user-defined log handler for the Logger instance.
         */
        this._userLogHandler = null;
    }
    get logLevel() {
        return this._logLevel;
    }
    set logLevel(val) {
        if (!(val in LogLevel)) {
            throw new TypeError(`Invalid value "${val}" assigned to \`logLevel\``);
        }
        this._logLevel = val;
    }
    // Workaround for setter/getter having to be the same type.
    setLogLevel(val) {
        this._logLevel = typeof val === 'string' ? levelStringToEnum[val] : val;
    }
    get logHandler() {
        return this._logHandler;
    }
    set logHandler(val) {
        if (typeof val !== 'function') {
            throw new TypeError('Value assigned to `logHandler` must be a function');
        }
        this._logHandler = val;
    }
    get userLogHandler() {
        return this._userLogHandler;
    }
    set userLogHandler(val) {
        this._userLogHandler = val;
    }
    /**
     * The functions below are all based on the `console` interface
     */
    debug(...args) {
        this._userLogHandler && this._userLogHandler(this, LogLevel.DEBUG, ...args);
        this._logHandler(this, LogLevel.DEBUG, ...args);
    }
    log(...args) {
        this._userLogHandler &&
            this._userLogHandler(this, LogLevel.VERBOSE, ...args);
        this._logHandler(this, LogLevel.VERBOSE, ...args);
    }
    info(...args) {
        this._userLogHandler && this._userLogHandler(this, LogLevel.INFO, ...args);
        this._logHandler(this, LogLevel.INFO, ...args);
    }
    warn(...args) {
        this._userLogHandler && this._userLogHandler(this, LogLevel.WARN, ...args);
        this._logHandler(this, LogLevel.WARN, ...args);
    }
    error(...args) {
        this._userLogHandler && this._userLogHandler(this, LogLevel.ERROR, ...args);
        this._logHandler(this, LogLevel.ERROR, ...args);
    }
}

const instanceOfAny = (object, constructors) => constructors.some((c) => object instanceof c);

let idbProxyableTypes;
let cursorAdvanceMethods;
// This is a function to prevent it throwing up in node environments.
function getIdbProxyableTypes() {
    return (idbProxyableTypes ||
        (idbProxyableTypes = [
            IDBDatabase,
            IDBObjectStore,
            IDBIndex,
            IDBCursor,
            IDBTransaction,
        ]));
}
// This is a function to prevent it throwing up in node environments.
function getCursorAdvanceMethods() {
    return (cursorAdvanceMethods ||
        (cursorAdvanceMethods = [
            IDBCursor.prototype.advance,
            IDBCursor.prototype.continue,
            IDBCursor.prototype.continuePrimaryKey,
        ]));
}
const cursorRequestMap = new WeakMap();
const transactionDoneMap = new WeakMap();
const transactionStoreNamesMap = new WeakMap();
const transformCache = new WeakMap();
const reverseTransformCache = new WeakMap();
function promisifyRequest(request) {
    const promise = new Promise((resolve, reject) => {
        const unlisten = () => {
            request.removeEventListener('success', success);
            request.removeEventListener('error', error);
        };
        const success = () => {
            resolve(wrap(request.result));
            unlisten();
        };
        const error = () => {
            reject(request.error);
            unlisten();
        };
        request.addEventListener('success', success);
        request.addEventListener('error', error);
    });
    promise
        .then((value) => {
        // Since cursoring reuses the IDBRequest (*sigh*), we cache it for later retrieval
        // (see wrapFunction).
        if (value instanceof IDBCursor) {
            cursorRequestMap.set(value, request);
        }
        // Catching to avoid "Uncaught Promise exceptions"
    })
        .catch(() => { });
    // This mapping exists in reverseTransformCache but doesn't doesn't exist in transformCache. This
    // is because we create many promises from a single IDBRequest.
    reverseTransformCache.set(promise, request);
    return promise;
}
function cacheDonePromiseForTransaction(tx) {
    // Early bail if we've already created a done promise for this transaction.
    if (transactionDoneMap.has(tx))
        return;
    const done = new Promise((resolve, reject) => {
        const unlisten = () => {
            tx.removeEventListener('complete', complete);
            tx.removeEventListener('error', error);
            tx.removeEventListener('abort', error);
        };
        const complete = () => {
            resolve();
            unlisten();
        };
        const error = () => {
            reject(tx.error || new DOMException('AbortError', 'AbortError'));
            unlisten();
        };
        tx.addEventListener('complete', complete);
        tx.addEventListener('error', error);
        tx.addEventListener('abort', error);
    });
    // Cache it for later retrieval.
    transactionDoneMap.set(tx, done);
}
let idbProxyTraps = {
    get(target, prop, receiver) {
        if (target instanceof IDBTransaction) {
            // Special handling for transaction.done.
            if (prop === 'done')
                return transactionDoneMap.get(target);
            // Polyfill for objectStoreNames because of Edge.
            if (prop === 'objectStoreNames') {
                return target.objectStoreNames || transactionStoreNamesMap.get(target);
            }
            // Make tx.store return the only store in the transaction, or undefined if there are many.
            if (prop === 'store') {
                return receiver.objectStoreNames[1]
                    ? undefined
                    : receiver.objectStore(receiver.objectStoreNames[0]);
            }
        }
        // Else transform whatever we get back.
        return wrap(target[prop]);
    },
    set(target, prop, value) {
        target[prop] = value;
        return true;
    },
    has(target, prop) {
        if (target instanceof IDBTransaction &&
            (prop === 'done' || prop === 'store')) {
            return true;
        }
        return prop in target;
    },
};
function replaceTraps(callback) {
    idbProxyTraps = callback(idbProxyTraps);
}
function wrapFunction(func) {
    // Due to expected object equality (which is enforced by the caching in `wrap`), we
    // only create one new func per func.
    // Edge doesn't support objectStoreNames (booo), so we polyfill it here.
    if (func === IDBDatabase.prototype.transaction &&
        !('objectStoreNames' in IDBTransaction.prototype)) {
        return function (storeNames, ...args) {
            const tx = func.call(unwrap(this), storeNames, ...args);
            transactionStoreNamesMap.set(tx, storeNames.sort ? storeNames.sort() : [storeNames]);
            return wrap(tx);
        };
    }
    // Cursor methods are special, as the behaviour is a little more different to standard IDB. In
    // IDB, you advance the cursor and wait for a new 'success' on the IDBRequest that gave you the
    // cursor. It's kinda like a promise that can resolve with many values. That doesn't make sense
    // with real promises, so each advance methods returns a new promise for the cursor object, or
    // undefined if the end of the cursor has been reached.
    if (getCursorAdvanceMethods().includes(func)) {
        return function (...args) {
            // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
            // the original object.
            func.apply(unwrap(this), args);
            return wrap(cursorRequestMap.get(this));
        };
    }
    return function (...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        return wrap(func.apply(unwrap(this), args));
    };
}
function transformCachableValue(value) {
    if (typeof value === 'function')
        return wrapFunction(value);
    // This doesn't return, it just creates a 'done' promise for the transaction,
    // which is later returned for transaction.done (see idbObjectHandler).
    if (value instanceof IDBTransaction)
        cacheDonePromiseForTransaction(value);
    if (instanceOfAny(value, getIdbProxyableTypes()))
        return new Proxy(value, idbProxyTraps);
    // Return the same value back if we're not going to transform it.
    return value;
}
function wrap(value) {
    // We sometimes generate multiple promises from a single IDBRequest (eg when cursoring), because
    // IDB is weird and a single IDBRequest can yield many responses, so these can't be cached.
    if (value instanceof IDBRequest)
        return promisifyRequest(value);
    // If we've already transformed this value before, reuse the transformed value.
    // This is faster, but it also provides object equality.
    if (transformCache.has(value))
        return transformCache.get(value);
    const newValue = transformCachableValue(value);
    // Not all types are transformed.
    // These may be primitive types, so they can't be WeakMap keys.
    if (newValue !== value) {
        transformCache.set(value, newValue);
        reverseTransformCache.set(newValue, value);
    }
    return newValue;
}
const unwrap = (value) => reverseTransformCache.get(value);

/**
 * Open a database.
 *
 * @param name Name of the database.
 * @param version Schema version.
 * @param callbacks Additional callbacks.
 */
function openDB(name, version, { blocked, upgrade, blocking, terminated } = {}) {
    const request = indexedDB.open(name, version);
    const openPromise = wrap(request);
    if (upgrade) {
        request.addEventListener('upgradeneeded', (event) => {
            upgrade(wrap(request.result), event.oldVersion, event.newVersion, wrap(request.transaction), event);
        });
    }
    if (blocked) {
        request.addEventListener('blocked', (event) => blocked(
        // Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event.newVersion, event));
    }
    openPromise
        .then((db) => {
        if (terminated)
            db.addEventListener('close', () => terminated());
        if (blocking) {
            db.addEventListener('versionchange', (event) => blocking(event.oldVersion, event.newVersion, event));
        }
    })
        .catch(() => { });
    return openPromise;
}
/**
 * Delete a database.
 *
 * @param name Name of the database.
 */
function deleteDB(name, { blocked } = {}) {
    const request = indexedDB.deleteDatabase(name);
    if (blocked) {
        request.addEventListener('blocked', (event) => blocked(
        // Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event));
    }
    return wrap(request).then(() => undefined);
}

const readMethods = ['get', 'getKey', 'getAll', 'getAllKeys', 'count'];
const writeMethods = ['put', 'add', 'delete', 'clear'];
const cachedMethods = new Map();
function getMethod(target, prop) {
    if (!(target instanceof IDBDatabase &&
        !(prop in target) &&
        typeof prop === 'string')) {
        return;
    }
    if (cachedMethods.get(prop))
        return cachedMethods.get(prop);
    const targetFuncName = prop.replace(/FromIndex$/, '');
    const useIndex = prop !== targetFuncName;
    const isWrite = writeMethods.includes(targetFuncName);
    if (
    // Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(targetFuncName in (useIndex ? IDBIndex : IDBObjectStore).prototype) ||
        !(isWrite || readMethods.includes(targetFuncName))) {
        return;
    }
    const method = async function (storeName, ...args) {
        // isWrite ? 'readwrite' : undefined gzipps better, but fails in Edge :(
        const tx = this.transaction(storeName, isWrite ? 'readwrite' : 'readonly');
        let target = tx.store;
        if (useIndex)
            target = target.index(args.shift());
        // Must reject if op rejects.
        // If it's a write operation, must reject if tx.done rejects.
        // Must reject with op rejection first.
        // Must resolve with op value.
        // Must handle both promises (no unhandled rejections)
        return (await Promise.all([
            target[targetFuncName](...args),
            isWrite && tx.done,
        ]))[0];
    };
    cachedMethods.set(prop, method);
    return method;
}
replaceTraps((oldTraps) => ({
    ...oldTraps,
    get: (target, prop, receiver) => getMethod(target, prop) || oldTraps.get(target, prop, receiver),
    has: (target, prop) => !!getMethod(target, prop) || oldTraps.has(target, prop),
}));

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class PlatformLoggerServiceImpl {
    constructor(container) {
        this.container = container;
    }
    // In initial implementation, this will be called by installations on
    // auth token refresh, and installations will send this string.
    getPlatformInfoString() {
        const providers = this.container.getProviders();
        // Loop through providers and get library/version pairs from any that are
        // version components.
        return providers
            .map(provider => {
            if (isVersionServiceProvider(provider)) {
                const service = provider.getImmediate();
                return `${service.library}/${service.version}`;
            }
            else {
                return null;
            }
        })
            .filter(logString => logString)
            .join(' ');
    }
}
/**
 *
 * @param provider check if this provider provides a VersionService
 *
 * NOTE: Using Provider<'app-version'> is a hack to indicate that the provider
 * provides VersionService. The provider is not necessarily a 'app-version'
 * provider.
 */
function isVersionServiceProvider(provider) {
    const component = provider.getComponent();
    return (component === null || component === void 0 ? void 0 : component.type) === "VERSION" /* ComponentType.VERSION */;
}

const name$p = "@firebase/app";
const version$1$1 = "0.10.5";

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const logger = new Logger('@firebase/app');

const name$o = "@firebase/app-compat";

const name$n = "@firebase/analytics-compat";

const name$m = "@firebase/analytics";

const name$l = "@firebase/app-check-compat";

const name$k = "@firebase/app-check";

const name$j = "@firebase/auth";

const name$i = "@firebase/auth-compat";

const name$h = "@firebase/database";

const name$g = "@firebase/database-compat";

const name$f = "@firebase/functions";

const name$e = "@firebase/functions-compat";

const name$d = "@firebase/installations";

const name$c = "@firebase/installations-compat";

const name$b = "@firebase/messaging";

const name$a = "@firebase/messaging-compat";

const name$9 = "@firebase/performance";

const name$8 = "@firebase/performance-compat";

const name$7 = "@firebase/remote-config";

const name$6 = "@firebase/remote-config-compat";

const name$5 = "@firebase/storage";

const name$4 = "@firebase/storage-compat";

const name$3 = "@firebase/firestore";

const name$2$1 = "@firebase/vertexai-preview";

const name$1$1 = "@firebase/firestore-compat";

const name$q = "firebase";

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * The default app name
 *
 * @internal
 */
const DEFAULT_ENTRY_NAME = '[DEFAULT]';
const PLATFORM_LOG_STRING = {
    [name$p]: 'fire-core',
    [name$o]: 'fire-core-compat',
    [name$m]: 'fire-analytics',
    [name$n]: 'fire-analytics-compat',
    [name$k]: 'fire-app-check',
    [name$l]: 'fire-app-check-compat',
    [name$j]: 'fire-auth',
    [name$i]: 'fire-auth-compat',
    [name$h]: 'fire-rtdb',
    [name$g]: 'fire-rtdb-compat',
    [name$f]: 'fire-fn',
    [name$e]: 'fire-fn-compat',
    [name$d]: 'fire-iid',
    [name$c]: 'fire-iid-compat',
    [name$b]: 'fire-fcm',
    [name$a]: 'fire-fcm-compat',
    [name$9]: 'fire-perf',
    [name$8]: 'fire-perf-compat',
    [name$7]: 'fire-rc',
    [name$6]: 'fire-rc-compat',
    [name$5]: 'fire-gcs',
    [name$4]: 'fire-gcs-compat',
    [name$3]: 'fire-fst',
    [name$1$1]: 'fire-fst-compat',
    [name$2$1]: 'fire-vertex',
    'fire-js': 'fire-js',
    [name$q]: 'fire-js-all'
};

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @internal
 */
const _apps = new Map();
/**
 * @internal
 */
const _serverApps = new Map();
/**
 * Registered components.
 *
 * @internal
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const _components = new Map();
/**
 * @param component - the component being added to this app's container
 *
 * @internal
 */
function _addComponent(app, component) {
    try {
        app.container.addComponent(component);
    }
    catch (e) {
        logger.debug(`Component ${component.name} failed to register with FirebaseApp ${app.name}`, e);
    }
}
/**
 *
 * @param component - the component to register
 * @returns whether or not the component is registered successfully
 *
 * @internal
 */
function _registerComponent(component) {
    const componentName = component.name;
    if (_components.has(componentName)) {
        logger.debug(`There were multiple attempts to register component ${componentName}.`);
        return false;
    }
    _components.set(componentName, component);
    // add the component to existing app instances
    for (const app of _apps.values()) {
        _addComponent(app, component);
    }
    for (const serverApp of _serverApps.values()) {
        _addComponent(serverApp, component);
    }
    return true;
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 *
 * @returns the provider for the service with the matching name
 *
 * @internal
 */
function _getProvider(app, name) {
    const heartbeatController = app.container
        .getProvider('heartbeat')
        .getImmediate({ optional: true });
    if (heartbeatController) {
        void heartbeatController.triggerHeartbeat();
    }
    return app.container.getProvider(name);
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const ERRORS = {
    ["no-app" /* AppError.NO_APP */]: "No Firebase App '{$appName}' has been created - " +
        'call initializeApp() first',
    ["bad-app-name" /* AppError.BAD_APP_NAME */]: "Illegal App name: '{$appName}'",
    ["duplicate-app" /* AppError.DUPLICATE_APP */]: "Firebase App named '{$appName}' already exists with different options or config",
    ["app-deleted" /* AppError.APP_DELETED */]: "Firebase App named '{$appName}' already deleted",
    ["server-app-deleted" /* AppError.SERVER_APP_DELETED */]: 'Firebase Server App has been deleted',
    ["no-options" /* AppError.NO_OPTIONS */]: 'Need to provide options, when not being deployed to hosting via source.',
    ["invalid-app-argument" /* AppError.INVALID_APP_ARGUMENT */]: 'firebase.{$appName}() takes either no argument or a ' +
        'Firebase App instance.',
    ["invalid-log-argument" /* AppError.INVALID_LOG_ARGUMENT */]: 'First argument to `onLog` must be null or a function.',
    ["idb-open" /* AppError.IDB_OPEN */]: 'Error thrown when opening IndexedDB. Original error: {$originalErrorMessage}.',
    ["idb-get" /* AppError.IDB_GET */]: 'Error thrown when reading from IndexedDB. Original error: {$originalErrorMessage}.',
    ["idb-set" /* AppError.IDB_WRITE */]: 'Error thrown when writing to IndexedDB. Original error: {$originalErrorMessage}.',
    ["idb-delete" /* AppError.IDB_DELETE */]: 'Error thrown when deleting from IndexedDB. Original error: {$originalErrorMessage}.',
    ["finalization-registry-not-supported" /* AppError.FINALIZATION_REGISTRY_NOT_SUPPORTED */]: 'FirebaseServerApp deleteOnDeref field defined but the JS runtime does not support FinalizationRegistry.',
    ["invalid-server-app-environment" /* AppError.INVALID_SERVER_APP_ENVIRONMENT */]: 'FirebaseServerApp is not for use in browser environments.'
};
const ERROR_FACTORY$2 = new ErrorFactory('app', 'Firebase', ERRORS);

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class FirebaseAppImpl {
    constructor(options, config, container) {
        this._isDeleted = false;
        this._options = Object.assign({}, options);
        this._config = Object.assign({}, config);
        this._name = config.name;
        this._automaticDataCollectionEnabled =
            config.automaticDataCollectionEnabled;
        this._container = container;
        this.container.addComponent(new Component('app', () => this, "PUBLIC" /* ComponentType.PUBLIC */));
    }
    get automaticDataCollectionEnabled() {
        this.checkDestroyed();
        return this._automaticDataCollectionEnabled;
    }
    set automaticDataCollectionEnabled(val) {
        this.checkDestroyed();
        this._automaticDataCollectionEnabled = val;
    }
    get name() {
        this.checkDestroyed();
        return this._name;
    }
    get options() {
        this.checkDestroyed();
        return this._options;
    }
    get config() {
        this.checkDestroyed();
        return this._config;
    }
    get container() {
        return this._container;
    }
    get isDeleted() {
        return this._isDeleted;
    }
    set isDeleted(val) {
        this._isDeleted = val;
    }
    /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */
    checkDestroyed() {
        if (this.isDeleted) {
            throw ERROR_FACTORY$2.create("app-deleted" /* AppError.APP_DELETED */, { appName: this._name });
        }
    }
}
function initializeApp(_options, rawConfig = {}) {
    let options = _options;
    if (typeof rawConfig !== 'object') {
        const name = rawConfig;
        rawConfig = { name };
    }
    const config = Object.assign({ name: DEFAULT_ENTRY_NAME, automaticDataCollectionEnabled: false }, rawConfig);
    const name = config.name;
    if (typeof name !== 'string' || !name) {
        throw ERROR_FACTORY$2.create("bad-app-name" /* AppError.BAD_APP_NAME */, {
            appName: String(name)
        });
    }
    options || (options = getDefaultAppConfig());
    if (!options) {
        throw ERROR_FACTORY$2.create("no-options" /* AppError.NO_OPTIONS */);
    }
    const existingApp = _apps.get(name);
    if (existingApp) {
        // return the existing app if options and config deep equal the ones in the existing app.
        if (deepEqual(options, existingApp.options) &&
            deepEqual(config, existingApp.config)) {
            return existingApp;
        }
        else {
            throw ERROR_FACTORY$2.create("duplicate-app" /* AppError.DUPLICATE_APP */, { appName: name });
        }
    }
    const container = new ComponentContainer(name);
    for (const component of _components.values()) {
        container.addComponent(component);
    }
    const newApp = new FirebaseAppImpl(options, config, container);
    _apps.set(name, newApp);
    return newApp;
}
/**
 * Retrieves a {@link @firebase/app#FirebaseApp} instance.
 *
 * When called with no arguments, the default app is returned. When an app name
 * is provided, the app corresponding to that name is returned.
 *
 * An exception is thrown if the app being retrieved has not yet been
 * initialized.
 *
 * @example
 * ```javascript
 * // Return the default app
 * const app = getApp();
 * ```
 *
 * @example
 * ```javascript
 * // Return a named app
 * const otherApp = getApp("otherApp");
 * ```
 *
 * @param name - Optional name of the app to return. If no name is
 *   provided, the default is `"[DEFAULT]"`.
 *
 * @returns The app corresponding to the provided app name.
 *   If no app name is provided, the default app is returned.
 *
 * @public
 */
function getApp(name = DEFAULT_ENTRY_NAME) {
    const app = _apps.get(name);
    if (!app && name === DEFAULT_ENTRY_NAME && getDefaultAppConfig()) {
        return initializeApp();
    }
    if (!app) {
        throw ERROR_FACTORY$2.create("no-app" /* AppError.NO_APP */, { appName: name });
    }
    return app;
}
/**
 * Registers a library's name and version for platform logging purposes.
 * @param library - Name of 1p or 3p library (e.g. firestore, angularfire)
 * @param version - Current version of that library.
 * @param variant - Bundle variant, e.g., node, rn, etc.
 *
 * @public
 */
function registerVersion(libraryKeyOrName, version, variant) {
    var _a;
    // TODO: We can use this check to whitelist strings when/if we set up
    // a good whitelist system.
    let library = (_a = PLATFORM_LOG_STRING[libraryKeyOrName]) !== null && _a !== void 0 ? _a : libraryKeyOrName;
    if (variant) {
        library += `-${variant}`;
    }
    const libraryMismatch = library.match(/\s|\//);
    const versionMismatch = version.match(/\s|\//);
    if (libraryMismatch || versionMismatch) {
        const warning = [
            `Unable to register library "${library}" with version "${version}":`
        ];
        if (libraryMismatch) {
            warning.push(`library name "${library}" contains illegal characters (whitespace or "/")`);
        }
        if (libraryMismatch && versionMismatch) {
            warning.push('and');
        }
        if (versionMismatch) {
            warning.push(`version name "${version}" contains illegal characters (whitespace or "/")`);
        }
        logger.warn(warning.join(' '));
        return;
    }
    _registerComponent(new Component(`${library}-version`, () => ({ library, version }), "VERSION" /* ComponentType.VERSION */));
}

/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const DB_NAME = 'firebase-heartbeat-database';
const DB_VERSION = 1;
const STORE_NAME = 'firebase-heartbeat-store';
let dbPromise$2 = null;
function getDbPromise$2() {
    if (!dbPromise$2) {
        dbPromise$2 = openDB(DB_NAME, DB_VERSION, {
            upgrade: (db, oldVersion) => {
                // We don't use 'break' in this switch statement, the fall-through
                // behavior is what we want, because if there are multiple versions between
                // the old version and the current version, we want ALL the migrations
                // that correspond to those versions to run, not only the last one.
                // eslint-disable-next-line default-case
                switch (oldVersion) {
                    case 0:
                        try {
                            db.createObjectStore(STORE_NAME);
                        }
                        catch (e) {
                            // Safari/iOS browsers throw occasional exceptions on
                            // db.createObjectStore() that may be a bug. Avoid blocking
                            // the rest of the app functionality.
                            console.warn(e);
                        }
                }
            }
        }).catch(e => {
            throw ERROR_FACTORY$2.create("idb-open" /* AppError.IDB_OPEN */, {
                originalErrorMessage: e.message
            });
        });
    }
    return dbPromise$2;
}
async function readHeartbeatsFromIndexedDB(app) {
    try {
        const db = await getDbPromise$2();
        const tx = db.transaction(STORE_NAME);
        const result = await tx.objectStore(STORE_NAME).get(computeKey(app));
        // We already have the value but tx.done can throw,
        // so we need to await it here to catch errors
        await tx.done;
        return result;
    }
    catch (e) {
        if (e instanceof FirebaseError) {
            logger.warn(e.message);
        }
        else {
            const idbGetError = ERROR_FACTORY$2.create("idb-get" /* AppError.IDB_GET */, {
                originalErrorMessage: e === null || e === void 0 ? void 0 : e.message
            });
            logger.warn(idbGetError.message);
        }
    }
}
async function writeHeartbeatsToIndexedDB(app, heartbeatObject) {
    try {
        const db = await getDbPromise$2();
        const tx = db.transaction(STORE_NAME, 'readwrite');
        const objectStore = tx.objectStore(STORE_NAME);
        await objectStore.put(heartbeatObject, computeKey(app));
        await tx.done;
    }
    catch (e) {
        if (e instanceof FirebaseError) {
            logger.warn(e.message);
        }
        else {
            const idbGetError = ERROR_FACTORY$2.create("idb-set" /* AppError.IDB_WRITE */, {
                originalErrorMessage: e === null || e === void 0 ? void 0 : e.message
            });
            logger.warn(idbGetError.message);
        }
    }
}
function computeKey(app) {
    return `${app.name}!${app.options.appId}`;
}

/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const MAX_HEADER_BYTES = 1024;
// 30 days
const STORED_HEARTBEAT_RETENTION_MAX_MILLIS = 30 * 24 * 60 * 60 * 1000;
class HeartbeatServiceImpl {
    constructor(container) {
        this.container = container;
        /**
         * In-memory cache for heartbeats, used by getHeartbeatsHeader() to generate
         * the header string.
         * Stores one record per date. This will be consolidated into the standard
         * format of one record per user agent string before being sent as a header.
         * Populated from indexedDB when the controller is instantiated and should
         * be kept in sync with indexedDB.
         * Leave public for easier testing.
         */
        this._heartbeatsCache = null;
        const app = this.container.getProvider('app').getImmediate();
        this._storage = new HeartbeatStorageImpl(app);
        this._heartbeatsCachePromise = this._storage.read().then(result => {
            this._heartbeatsCache = result;
            return result;
        });
    }
    /**
     * Called to report a heartbeat. The function will generate
     * a HeartbeatsByUserAgent object, update heartbeatsCache, and persist it
     * to IndexedDB.
     * Note that we only store one heartbeat per day. So if a heartbeat for today is
     * already logged, subsequent calls to this function in the same day will be ignored.
     */
    async triggerHeartbeat() {
        var _a, _b;
        const platformLogger = this.container
            .getProvider('platform-logger')
            .getImmediate();
        // This is the "Firebase user agent" string from the platform logger
        // service, not the browser user agent.
        const agent = platformLogger.getPlatformInfoString();
        const date = getUTCDateString();
        if (((_a = this._heartbeatsCache) === null || _a === void 0 ? void 0 : _a.heartbeats) == null) {
            this._heartbeatsCache = await this._heartbeatsCachePromise;
            // If we failed to construct a heartbeats cache, then return immediately.
            if (((_b = this._heartbeatsCache) === null || _b === void 0 ? void 0 : _b.heartbeats) == null) {
                return;
            }
        }
        // Do not store a heartbeat if one is already stored for this day
        // or if a header has already been sent today.
        if (this._heartbeatsCache.lastSentHeartbeatDate === date ||
            this._heartbeatsCache.heartbeats.some(singleDateHeartbeat => singleDateHeartbeat.date === date)) {
            return;
        }
        else {
            // There is no entry for this date. Create one.
            this._heartbeatsCache.heartbeats.push({ date, agent });
        }
        // Remove entries older than 30 days.
        this._heartbeatsCache.heartbeats = this._heartbeatsCache.heartbeats.filter(singleDateHeartbeat => {
            const hbTimestamp = new Date(singleDateHeartbeat.date).valueOf();
            const now = Date.now();
            return now - hbTimestamp <= STORED_HEARTBEAT_RETENTION_MAX_MILLIS;
        });
        return this._storage.overwrite(this._heartbeatsCache);
    }
    /**
     * Returns a base64 encoded string which can be attached to the heartbeat-specific header directly.
     * It also clears all heartbeats from memory as well as in IndexedDB.
     *
     * NOTE: Consuming product SDKs should not send the header if this method
     * returns an empty string.
     */
    async getHeartbeatsHeader() {
        var _a;
        if (this._heartbeatsCache === null) {
            await this._heartbeatsCachePromise;
        }
        // If it's still null or the array is empty, there is no data to send.
        if (((_a = this._heartbeatsCache) === null || _a === void 0 ? void 0 : _a.heartbeats) == null ||
            this._heartbeatsCache.heartbeats.length === 0) {
            return '';
        }
        const date = getUTCDateString();
        // Extract as many heartbeats from the cache as will fit under the size limit.
        const { heartbeatsToSend, unsentEntries } = extractHeartbeatsForHeader(this._heartbeatsCache.heartbeats);
        const headerString = base64urlEncodeWithoutPadding(JSON.stringify({ version: 2, heartbeats: heartbeatsToSend }));
        // Store last sent date to prevent another being logged/sent for the same day.
        this._heartbeatsCache.lastSentHeartbeatDate = date;
        if (unsentEntries.length > 0) {
            // Store any unsent entries if they exist.
            this._heartbeatsCache.heartbeats = unsentEntries;
            // This seems more likely than emptying the array (below) to lead to some odd state
            // since the cache isn't empty and this will be called again on the next request,
            // and is probably safest if we await it.
            await this._storage.overwrite(this._heartbeatsCache);
        }
        else {
            this._heartbeatsCache.heartbeats = [];
            // Do not wait for this, to reduce latency.
            void this._storage.overwrite(this._heartbeatsCache);
        }
        return headerString;
    }
}
function getUTCDateString() {
    const today = new Date();
    // Returns date format 'YYYY-MM-DD'
    return today.toISOString().substring(0, 10);
}
function extractHeartbeatsForHeader(heartbeatsCache, maxSize = MAX_HEADER_BYTES) {
    // Heartbeats grouped by user agent in the standard format to be sent in
    // the header.
    const heartbeatsToSend = [];
    // Single date format heartbeats that are not sent.
    let unsentEntries = heartbeatsCache.slice();
    for (const singleDateHeartbeat of heartbeatsCache) {
        // Look for an existing entry with the same user agent.
        const heartbeatEntry = heartbeatsToSend.find(hb => hb.agent === singleDateHeartbeat.agent);
        if (!heartbeatEntry) {
            // If no entry for this user agent exists, create one.
            heartbeatsToSend.push({
                agent: singleDateHeartbeat.agent,
                dates: [singleDateHeartbeat.date]
            });
            if (countBytes(heartbeatsToSend) > maxSize) {
                // If the header would exceed max size, remove the added heartbeat
                // entry and stop adding to the header.
                heartbeatsToSend.pop();
                break;
            }
        }
        else {
            heartbeatEntry.dates.push(singleDateHeartbeat.date);
            // If the header would exceed max size, remove the added date
            // and stop adding to the header.
            if (countBytes(heartbeatsToSend) > maxSize) {
                heartbeatEntry.dates.pop();
                break;
            }
        }
        // Pop unsent entry from queue. (Skipped if adding the entry exceeded
        // quota and the loop breaks early.)
        unsentEntries = unsentEntries.slice(1);
    }
    return {
        heartbeatsToSend,
        unsentEntries
    };
}
class HeartbeatStorageImpl {
    constructor(app) {
        this.app = app;
        this._canUseIndexedDBPromise = this.runIndexedDBEnvironmentCheck();
    }
    async runIndexedDBEnvironmentCheck() {
        if (!isIndexedDBAvailable()) {
            return false;
        }
        else {
            return validateIndexedDBOpenable()
                .then(() => true)
                .catch(() => false);
        }
    }
    /**
     * Read all heartbeats.
     */
    async read() {
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) {
            return { heartbeats: [] };
        }
        else {
            const idbHeartbeatObject = await readHeartbeatsFromIndexedDB(this.app);
            if (idbHeartbeatObject === null || idbHeartbeatObject === void 0 ? void 0 : idbHeartbeatObject.heartbeats) {
                return idbHeartbeatObject;
            }
            else {
                return { heartbeats: [] };
            }
        }
    }
    // overwrite the storage with the provided heartbeats
    async overwrite(heartbeatsObject) {
        var _a;
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) {
            return;
        }
        else {
            const existingHeartbeatsObject = await this.read();
            return writeHeartbeatsToIndexedDB(this.app, {
                lastSentHeartbeatDate: (_a = heartbeatsObject.lastSentHeartbeatDate) !== null && _a !== void 0 ? _a : existingHeartbeatsObject.lastSentHeartbeatDate,
                heartbeats: heartbeatsObject.heartbeats
            });
        }
    }
    // add heartbeats
    async add(heartbeatsObject) {
        var _a;
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) {
            return;
        }
        else {
            const existingHeartbeatsObject = await this.read();
            return writeHeartbeatsToIndexedDB(this.app, {
                lastSentHeartbeatDate: (_a = heartbeatsObject.lastSentHeartbeatDate) !== null && _a !== void 0 ? _a : existingHeartbeatsObject.lastSentHeartbeatDate,
                heartbeats: [
                    ...existingHeartbeatsObject.heartbeats,
                    ...heartbeatsObject.heartbeats
                ]
            });
        }
    }
}
/**
 * Calculate bytes of a HeartbeatsByUserAgent array after being wrapped
 * in a platform logging header JSON object, stringified, and converted
 * to base 64.
 */
function countBytes(heartbeatsCache) {
    // base64 has a restricted set of characters, all of which should be 1 byte.
    return base64urlEncodeWithoutPadding(
    // heartbeatsCache wrapper properties
    JSON.stringify({ version: 2, heartbeats: heartbeatsCache })).length;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function registerCoreComponents(variant) {
    _registerComponent(new Component('platform-logger', container => new PlatformLoggerServiceImpl(container), "PRIVATE" /* ComponentType.PRIVATE */));
    _registerComponent(new Component('heartbeat', container => new HeartbeatServiceImpl(container), "PRIVATE" /* ComponentType.PRIVATE */));
    // Register `app` package.
    registerVersion(name$p, version$1$1, variant);
    // BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
    registerVersion(name$p, version$1$1, 'esm2017');
    // Register platform SDK identifier (no version).
    registerVersion('fire-js', '');
}

/**
 * Firebase App
 *
 * @remarks This package coordinates the communication between the different Firebase components
 * @packageDocumentation
 */
registerCoreComponents('');

var name$2 = "firebase";
var version$2 = "10.12.2";

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
registerVersion(name$2, version$2, 'app');

const name$1 = "@firebase/installations";
const version$1 = "0.6.7";

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const PENDING_TIMEOUT_MS = 10000;
const PACKAGE_VERSION = `w:${version$1}`;
const INTERNAL_AUTH_VERSION = 'FIS_v2';
const INSTALLATIONS_API_URL = 'https://firebaseinstallations.googleapis.com/v1';
const TOKEN_EXPIRATION_BUFFER = 60 * 60 * 1000; // One hour
const SERVICE = 'installations';
const SERVICE_NAME = 'Installations';

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const ERROR_DESCRIPTION_MAP = {
    ["missing-app-config-values" /* ErrorCode.MISSING_APP_CONFIG_VALUES */]: 'Missing App configuration value: "{$valueName}"',
    ["not-registered" /* ErrorCode.NOT_REGISTERED */]: 'Firebase Installation is not registered.',
    ["installation-not-found" /* ErrorCode.INSTALLATION_NOT_FOUND */]: 'Firebase Installation not found.',
    ["request-failed" /* ErrorCode.REQUEST_FAILED */]: '{$requestName} request failed with error "{$serverCode} {$serverStatus}: {$serverMessage}"',
    ["app-offline" /* ErrorCode.APP_OFFLINE */]: 'Could not process request. Application offline.',
    ["delete-pending-registration" /* ErrorCode.DELETE_PENDING_REGISTRATION */]: "Can't delete installation while there is a pending registration request."
};
const ERROR_FACTORY$1 = new ErrorFactory(SERVICE, SERVICE_NAME, ERROR_DESCRIPTION_MAP);
/** Returns true if error is a FirebaseError that is based on an error from the server. */
function isServerError(error) {
    return (error instanceof FirebaseError &&
        error.code.includes("request-failed" /* ErrorCode.REQUEST_FAILED */));
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function getInstallationsEndpoint({ projectId }) {
    return `${INSTALLATIONS_API_URL}/projects/${projectId}/installations`;
}
function extractAuthTokenInfoFromResponse(response) {
    return {
        token: response.token,
        requestStatus: 2 /* RequestStatus.COMPLETED */,
        expiresIn: getExpiresInFromResponseExpiresIn(response.expiresIn),
        creationTime: Date.now()
    };
}
async function getErrorFromResponse(requestName, response) {
    const responseJson = await response.json();
    const errorData = responseJson.error;
    return ERROR_FACTORY$1.create("request-failed" /* ErrorCode.REQUEST_FAILED */, {
        requestName,
        serverCode: errorData.code,
        serverMessage: errorData.message,
        serverStatus: errorData.status
    });
}
function getHeaders$1({ apiKey }) {
    return new Headers({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'x-goog-api-key': apiKey
    });
}
function getHeadersWithAuth(appConfig, { refreshToken }) {
    const headers = getHeaders$1(appConfig);
    headers.append('Authorization', getAuthorizationHeader(refreshToken));
    return headers;
}
/**
 * Calls the passed in fetch wrapper and returns the response.
 * If the returned response has a status of 5xx, re-runs the function once and
 * returns the response.
 */
async function retryIfServerError(fn) {
    const result = await fn();
    if (result.status >= 500 && result.status < 600) {
        // Internal Server Error. Retry request.
        return fn();
    }
    return result;
}
function getExpiresInFromResponseExpiresIn(responseExpiresIn) {
    // This works because the server will never respond with fractions of a second.
    return Number(responseExpiresIn.replace('s', '000'));
}
function getAuthorizationHeader(refreshToken) {
    return `${INTERNAL_AUTH_VERSION} ${refreshToken}`;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function createInstallationRequest({ appConfig, heartbeatServiceProvider }, { fid }) {
    const endpoint = getInstallationsEndpoint(appConfig);
    const headers = getHeaders$1(appConfig);
    // If heartbeat service exists, add the heartbeat string to the header.
    const heartbeatService = heartbeatServiceProvider.getImmediate({
        optional: true
    });
    if (heartbeatService) {
        const heartbeatsHeader = await heartbeatService.getHeartbeatsHeader();
        if (heartbeatsHeader) {
            headers.append('x-firebase-client', heartbeatsHeader);
        }
    }
    const body = {
        fid,
        authVersion: INTERNAL_AUTH_VERSION,
        appId: appConfig.appId,
        sdkVersion: PACKAGE_VERSION
    };
    const request = {
        method: 'POST',
        headers,
        body: JSON.stringify(body)
    };
    const response = await retryIfServerError(() => fetch(endpoint, request));
    if (response.ok) {
        const responseValue = await response.json();
        const registeredInstallationEntry = {
            fid: responseValue.fid || fid,
            registrationStatus: 2 /* RequestStatus.COMPLETED */,
            refreshToken: responseValue.refreshToken,
            authToken: extractAuthTokenInfoFromResponse(responseValue.authToken)
        };
        return registeredInstallationEntry;
    }
    else {
        throw await getErrorFromResponse('Create Installation', response);
    }
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/** Returns a promise that resolves after given time passes. */
function sleep(ms) {
    return new Promise(resolve => {
        setTimeout(resolve, ms);
    });
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function bufferToBase64UrlSafe(array) {
    const b64 = btoa(String.fromCharCode(...array));
    return b64.replace(/\+/g, '-').replace(/\//g, '_');
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const VALID_FID_PATTERN = /^[cdef][\w-]{21}$/;
const INVALID_FID = '';
/**
 * Generates a new FID using random values from Web Crypto API.
 * Returns an empty string if FID generation fails for any reason.
 */
function generateFid() {
    try {
        // A valid FID has exactly 22 base64 characters, which is 132 bits, or 16.5
        // bytes. our implementation generates a 17 byte array instead.
        const fidByteArray = new Uint8Array(17);
        const crypto = self.crypto || self.msCrypto;
        crypto.getRandomValues(fidByteArray);
        // Replace the first 4 random bits with the constant FID header of 0b0111.
        fidByteArray[0] = 0b01110000 + (fidByteArray[0] % 0b00010000);
        const fid = encode(fidByteArray);
        return VALID_FID_PATTERN.test(fid) ? fid : INVALID_FID;
    }
    catch (_a) {
        // FID generation errored
        return INVALID_FID;
    }
}
/** Converts a FID Uint8Array to a base64 string representation. */
function encode(fidByteArray) {
    const b64String = bufferToBase64UrlSafe(fidByteArray);
    // Remove the 23rd character that was added because of the extra 4 bits at the
    // end of our 17 byte array, and the '=' padding.
    return b64String.substr(0, 22);
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/** Returns a string key that can be used to identify the app. */
function getKey$1(appConfig) {
    return `${appConfig.appName}!${appConfig.appId}`;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const fidChangeCallbacks = new Map();
/**
 * Calls the onIdChange callbacks with the new FID value, and broadcasts the
 * change to other tabs.
 */
function fidChanged(appConfig, fid) {
    const key = getKey$1(appConfig);
    callFidChangeCallbacks(key, fid);
    broadcastFidChange(key, fid);
}
function callFidChangeCallbacks(key, fid) {
    const callbacks = fidChangeCallbacks.get(key);
    if (!callbacks) {
        return;
    }
    for (const callback of callbacks) {
        callback(fid);
    }
}
function broadcastFidChange(key, fid) {
    const channel = getBroadcastChannel();
    if (channel) {
        channel.postMessage({ key, fid });
    }
    closeBroadcastChannel();
}
let broadcastChannel = null;
/** Opens and returns a BroadcastChannel if it is supported by the browser. */
function getBroadcastChannel() {
    if (!broadcastChannel && 'BroadcastChannel' in self) {
        broadcastChannel = new BroadcastChannel('[Firebase] FID Change');
        broadcastChannel.onmessage = e => {
            callFidChangeCallbacks(e.data.key, e.data.fid);
        };
    }
    return broadcastChannel;
}
function closeBroadcastChannel() {
    if (fidChangeCallbacks.size === 0 && broadcastChannel) {
        broadcastChannel.close();
        broadcastChannel = null;
    }
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const DATABASE_NAME$1 = 'firebase-installations-database';
const DATABASE_VERSION$1 = 1;
const OBJECT_STORE_NAME$1 = 'firebase-installations-store';
let dbPromise$1 = null;
function getDbPromise$1() {
    if (!dbPromise$1) {
        dbPromise$1 = openDB(DATABASE_NAME$1, DATABASE_VERSION$1, {
            upgrade: (db, oldVersion) => {
                // We don't use 'break' in this switch statement, the fall-through
                // behavior is what we want, because if there are multiple versions between
                // the old version and the current version, we want ALL the migrations
                // that correspond to those versions to run, not only the last one.
                // eslint-disable-next-line default-case
                switch (oldVersion) {
                    case 0:
                        db.createObjectStore(OBJECT_STORE_NAME$1);
                }
            }
        });
    }
    return dbPromise$1;
}
/** Assigns or overwrites the record for the given key with the given value. */
async function set(appConfig, value) {
    const key = getKey$1(appConfig);
    const db = await getDbPromise$1();
    const tx = db.transaction(OBJECT_STORE_NAME$1, 'readwrite');
    const objectStore = tx.objectStore(OBJECT_STORE_NAME$1);
    const oldValue = (await objectStore.get(key));
    await objectStore.put(value, key);
    await tx.done;
    if (!oldValue || oldValue.fid !== value.fid) {
        fidChanged(appConfig, value.fid);
    }
    return value;
}
/** Removes record(s) from the objectStore that match the given key. */
async function remove(appConfig) {
    const key = getKey$1(appConfig);
    const db = await getDbPromise$1();
    const tx = db.transaction(OBJECT_STORE_NAME$1, 'readwrite');
    await tx.objectStore(OBJECT_STORE_NAME$1).delete(key);
    await tx.done;
}
/**
 * Atomically updates a record with the result of updateFn, which gets
 * called with the current value. If newValue is undefined, the record is
 * deleted instead.
 * @return Updated value
 */
async function update(appConfig, updateFn) {
    const key = getKey$1(appConfig);
    const db = await getDbPromise$1();
    const tx = db.transaction(OBJECT_STORE_NAME$1, 'readwrite');
    const store = tx.objectStore(OBJECT_STORE_NAME$1);
    const oldValue = (await store.get(key));
    const newValue = updateFn(oldValue);
    if (newValue === undefined) {
        await store.delete(key);
    }
    else {
        await store.put(newValue, key);
    }
    await tx.done;
    if (newValue && (!oldValue || oldValue.fid !== newValue.fid)) {
        fidChanged(appConfig, newValue.fid);
    }
    return newValue;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Updates and returns the InstallationEntry from the database.
 * Also triggers a registration request if it is necessary and possible.
 */
async function getInstallationEntry(installations) {
    let registrationPromise;
    const installationEntry = await update(installations.appConfig, oldEntry => {
        const installationEntry = updateOrCreateInstallationEntry(oldEntry);
        const entryWithPromise = triggerRegistrationIfNecessary(installations, installationEntry);
        registrationPromise = entryWithPromise.registrationPromise;
        return entryWithPromise.installationEntry;
    });
    if (installationEntry.fid === INVALID_FID) {
        // FID generation failed. Waiting for the FID from the server.
        return { installationEntry: await registrationPromise };
    }
    return {
        installationEntry,
        registrationPromise
    };
}
/**
 * Creates a new Installation Entry if one does not exist.
 * Also clears timed out pending requests.
 */
function updateOrCreateInstallationEntry(oldEntry) {
    const entry = oldEntry || {
        fid: generateFid(),
        registrationStatus: 0 /* RequestStatus.NOT_STARTED */
    };
    return clearTimedOutRequest(entry);
}
/**
 * If the Firebase Installation is not registered yet, this will trigger the
 * registration and return an InProgressInstallationEntry.
 *
 * If registrationPromise does not exist, the installationEntry is guaranteed
 * to be registered.
 */
function triggerRegistrationIfNecessary(installations, installationEntry) {
    if (installationEntry.registrationStatus === 0 /* RequestStatus.NOT_STARTED */) {
        if (!navigator.onLine) {
            // Registration required but app is offline.
            const registrationPromiseWithError = Promise.reject(ERROR_FACTORY$1.create("app-offline" /* ErrorCode.APP_OFFLINE */));
            return {
                installationEntry,
                registrationPromise: registrationPromiseWithError
            };
        }
        // Try registering. Change status to IN_PROGRESS.
        const inProgressEntry = {
            fid: installationEntry.fid,
            registrationStatus: 1 /* RequestStatus.IN_PROGRESS */,
            registrationTime: Date.now()
        };
        const registrationPromise = registerInstallation(installations, inProgressEntry);
        return { installationEntry: inProgressEntry, registrationPromise };
    }
    else if (installationEntry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */) {
        return {
            installationEntry,
            registrationPromise: waitUntilFidRegistration(installations)
        };
    }
    else {
        return { installationEntry };
    }
}
/** This will be executed only once for each new Firebase Installation. */
async function registerInstallation(installations, installationEntry) {
    try {
        const registeredInstallationEntry = await createInstallationRequest(installations, installationEntry);
        return set(installations.appConfig, registeredInstallationEntry);
    }
    catch (e) {
        if (isServerError(e) && e.customData.serverCode === 409) {
            // Server returned a "FID can not be used" error.
            // Generate a new ID next time.
            await remove(installations.appConfig);
        }
        else {
            // Registration failed. Set FID as not registered.
            await set(installations.appConfig, {
                fid: installationEntry.fid,
                registrationStatus: 0 /* RequestStatus.NOT_STARTED */
            });
        }
        throw e;
    }
}
/** Call if FID registration is pending in another request. */
async function waitUntilFidRegistration(installations) {
    // Unfortunately, there is no way of reliably observing when a value in
    // IndexedDB changes (yet, see https://github.com/WICG/indexed-db-observers),
    // so we need to poll.
    let entry = await updateInstallationRequest(installations.appConfig);
    while (entry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */) {
        // createInstallation request still in progress.
        await sleep(100);
        entry = await updateInstallationRequest(installations.appConfig);
    }
    if (entry.registrationStatus === 0 /* RequestStatus.NOT_STARTED */) {
        // The request timed out or failed in a different call. Try again.
        const { installationEntry, registrationPromise } = await getInstallationEntry(installations);
        if (registrationPromise) {
            return registrationPromise;
        }
        else {
            // if there is no registrationPromise, entry is registered.
            return installationEntry;
        }
    }
    return entry;
}
/**
 * Called only if there is a CreateInstallation request in progress.
 *
 * Updates the InstallationEntry in the DB based on the status of the
 * CreateInstallation request.
 *
 * Returns the updated InstallationEntry.
 */
function updateInstallationRequest(appConfig) {
    return update(appConfig, oldEntry => {
        if (!oldEntry) {
            throw ERROR_FACTORY$1.create("installation-not-found" /* ErrorCode.INSTALLATION_NOT_FOUND */);
        }
        return clearTimedOutRequest(oldEntry);
    });
}
function clearTimedOutRequest(entry) {
    if (hasInstallationRequestTimedOut(entry)) {
        return {
            fid: entry.fid,
            registrationStatus: 0 /* RequestStatus.NOT_STARTED */
        };
    }
    return entry;
}
function hasInstallationRequestTimedOut(installationEntry) {
    return (installationEntry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */ &&
        installationEntry.registrationTime + PENDING_TIMEOUT_MS < Date.now());
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function generateAuthTokenRequest({ appConfig, heartbeatServiceProvider }, installationEntry) {
    const endpoint = getGenerateAuthTokenEndpoint(appConfig, installationEntry);
    const headers = getHeadersWithAuth(appConfig, installationEntry);
    // If heartbeat service exists, add the heartbeat string to the header.
    const heartbeatService = heartbeatServiceProvider.getImmediate({
        optional: true
    });
    if (heartbeatService) {
        const heartbeatsHeader = await heartbeatService.getHeartbeatsHeader();
        if (heartbeatsHeader) {
            headers.append('x-firebase-client', heartbeatsHeader);
        }
    }
    const body = {
        installation: {
            sdkVersion: PACKAGE_VERSION,
            appId: appConfig.appId
        }
    };
    const request = {
        method: 'POST',
        headers,
        body: JSON.stringify(body)
    };
    const response = await retryIfServerError(() => fetch(endpoint, request));
    if (response.ok) {
        const responseValue = await response.json();
        const completedAuthToken = extractAuthTokenInfoFromResponse(responseValue);
        return completedAuthToken;
    }
    else {
        throw await getErrorFromResponse('Generate Auth Token', response);
    }
}
function getGenerateAuthTokenEndpoint(appConfig, { fid }) {
    return `${getInstallationsEndpoint(appConfig)}/${fid}/authTokens:generate`;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Returns a valid authentication token for the installation. Generates a new
 * token if one doesn't exist, is expired or about to expire.
 *
 * Should only be called if the Firebase Installation is registered.
 */
async function refreshAuthToken(installations, forceRefresh = false) {
    let tokenPromise;
    const entry = await update(installations.appConfig, oldEntry => {
        if (!isEntryRegistered(oldEntry)) {
            throw ERROR_FACTORY$1.create("not-registered" /* ErrorCode.NOT_REGISTERED */);
        }
        const oldAuthToken = oldEntry.authToken;
        if (!forceRefresh && isAuthTokenValid(oldAuthToken)) {
            // There is a valid token in the DB.
            return oldEntry;
        }
        else if (oldAuthToken.requestStatus === 1 /* RequestStatus.IN_PROGRESS */) {
            // There already is a token request in progress.
            tokenPromise = waitUntilAuthTokenRequest(installations, forceRefresh);
            return oldEntry;
        }
        else {
            // No token or token expired.
            if (!navigator.onLine) {
                throw ERROR_FACTORY$1.create("app-offline" /* ErrorCode.APP_OFFLINE */);
            }
            const inProgressEntry = makeAuthTokenRequestInProgressEntry(oldEntry);
            tokenPromise = fetchAuthTokenFromServer(installations, inProgressEntry);
            return inProgressEntry;
        }
    });
    const authToken = tokenPromise
        ? await tokenPromise
        : entry.authToken;
    return authToken;
}
/**
 * Call only if FID is registered and Auth Token request is in progress.
 *
 * Waits until the current pending request finishes. If the request times out,
 * tries once in this thread as well.
 */
async function waitUntilAuthTokenRequest(installations, forceRefresh) {
    // Unfortunately, there is no way of reliably observing when a value in
    // IndexedDB changes (yet, see https://github.com/WICG/indexed-db-observers),
    // so we need to poll.
    let entry = await updateAuthTokenRequest(installations.appConfig);
    while (entry.authToken.requestStatus === 1 /* RequestStatus.IN_PROGRESS */) {
        // generateAuthToken still in progress.
        await sleep(100);
        entry = await updateAuthTokenRequest(installations.appConfig);
    }
    const authToken = entry.authToken;
    if (authToken.requestStatus === 0 /* RequestStatus.NOT_STARTED */) {
        // The request timed out or failed in a different call. Try again.
        return refreshAuthToken(installations, forceRefresh);
    }
    else {
        return authToken;
    }
}
/**
 * Called only if there is a GenerateAuthToken request in progress.
 *
 * Updates the InstallationEntry in the DB based on the status of the
 * GenerateAuthToken request.
 *
 * Returns the updated InstallationEntry.
 */
function updateAuthTokenRequest(appConfig) {
    return update(appConfig, oldEntry => {
        if (!isEntryRegistered(oldEntry)) {
            throw ERROR_FACTORY$1.create("not-registered" /* ErrorCode.NOT_REGISTERED */);
        }
        const oldAuthToken = oldEntry.authToken;
        if (hasAuthTokenRequestTimedOut(oldAuthToken)) {
            return Object.assign(Object.assign({}, oldEntry), { authToken: { requestStatus: 0 /* RequestStatus.NOT_STARTED */ } });
        }
        return oldEntry;
    });
}
async function fetchAuthTokenFromServer(installations, installationEntry) {
    try {
        const authToken = await generateAuthTokenRequest(installations, installationEntry);
        const updatedInstallationEntry = Object.assign(Object.assign({}, installationEntry), { authToken });
        await set(installations.appConfig, updatedInstallationEntry);
        return authToken;
    }
    catch (e) {
        if (isServerError(e) &&
            (e.customData.serverCode === 401 || e.customData.serverCode === 404)) {
            // Server returned a "FID not found" or a "Invalid authentication" error.
            // Generate a new ID next time.
            await remove(installations.appConfig);
        }
        else {
            const updatedInstallationEntry = Object.assign(Object.assign({}, installationEntry), { authToken: { requestStatus: 0 /* RequestStatus.NOT_STARTED */ } });
            await set(installations.appConfig, updatedInstallationEntry);
        }
        throw e;
    }
}
function isEntryRegistered(installationEntry) {
    return (installationEntry !== undefined &&
        installationEntry.registrationStatus === 2 /* RequestStatus.COMPLETED */);
}
function isAuthTokenValid(authToken) {
    return (authToken.requestStatus === 2 /* RequestStatus.COMPLETED */ &&
        !isAuthTokenExpired(authToken));
}
function isAuthTokenExpired(authToken) {
    const now = Date.now();
    return (now < authToken.creationTime ||
        authToken.creationTime + authToken.expiresIn < now + TOKEN_EXPIRATION_BUFFER);
}
/** Returns an updated InstallationEntry with an InProgressAuthToken. */
function makeAuthTokenRequestInProgressEntry(oldEntry) {
    const inProgressAuthToken = {
        requestStatus: 1 /* RequestStatus.IN_PROGRESS */,
        requestTime: Date.now()
    };
    return Object.assign(Object.assign({}, oldEntry), { authToken: inProgressAuthToken });
}
function hasAuthTokenRequestTimedOut(authToken) {
    return (authToken.requestStatus === 1 /* RequestStatus.IN_PROGRESS */ &&
        authToken.requestTime + PENDING_TIMEOUT_MS < Date.now());
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Creates a Firebase Installation if there isn't one for the app and
 * returns the Installation ID.
 * @param installations - The `Installations` instance.
 *
 * @public
 */
async function getId(installations) {
    const installationsImpl = installations;
    const { installationEntry, registrationPromise } = await getInstallationEntry(installationsImpl);
    if (registrationPromise) {
        registrationPromise.catch(console.error);
    }
    else {
        // If the installation is already registered, update the authentication
        // token if needed.
        refreshAuthToken(installationsImpl).catch(console.error);
    }
    return installationEntry.fid;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Returns a Firebase Installations auth token, identifying the current
 * Firebase Installation.
 * @param installations - The `Installations` instance.
 * @param forceRefresh - Force refresh regardless of token expiration.
 *
 * @public
 */
async function getToken$2(installations, forceRefresh = false) {
    const installationsImpl = installations;
    await completeInstallationRegistration(installationsImpl);
    // At this point we either have a Registered Installation in the DB, or we've
    // already thrown an error.
    const authToken = await refreshAuthToken(installationsImpl, forceRefresh);
    return authToken.token;
}
async function completeInstallationRegistration(installations) {
    const { registrationPromise } = await getInstallationEntry(installations);
    if (registrationPromise) {
        // A createInstallation request is in progress. Wait until it finishes.
        await registrationPromise;
    }
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function extractAppConfig$1(app) {
    if (!app || !app.options) {
        throw getMissingValueError$1('App Configuration');
    }
    if (!app.name) {
        throw getMissingValueError$1('App Name');
    }
    // Required app config keys
    const configKeys = [
        'projectId',
        'apiKey',
        'appId'
    ];
    for (const keyName of configKeys) {
        if (!app.options[keyName]) {
            throw getMissingValueError$1(keyName);
        }
    }
    return {
        appName: app.name,
        projectId: app.options.projectId,
        apiKey: app.options.apiKey,
        appId: app.options.appId
    };
}
function getMissingValueError$1(valueName) {
    return ERROR_FACTORY$1.create("missing-app-config-values" /* ErrorCode.MISSING_APP_CONFIG_VALUES */, {
        valueName
    });
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const INSTALLATIONS_NAME = 'installations';
const INSTALLATIONS_NAME_INTERNAL = 'installations-internal';
const publicFactory = (container) => {
    const app = container.getProvider('app').getImmediate();
    // Throws if app isn't configured properly.
    const appConfig = extractAppConfig$1(app);
    const heartbeatServiceProvider = _getProvider(app, 'heartbeat');
    const installationsImpl = {
        app,
        appConfig,
        heartbeatServiceProvider,
        _delete: () => Promise.resolve()
    };
    return installationsImpl;
};
const internalFactory = (container) => {
    const app = container.getProvider('app').getImmediate();
    // Internal FIS instance relies on public FIS instance.
    const installations = _getProvider(app, INSTALLATIONS_NAME).getImmediate();
    const installationsInternal = {
        getId: () => getId(installations),
        getToken: (forceRefresh) => getToken$2(installations, forceRefresh)
    };
    return installationsInternal;
};
function registerInstallations() {
    _registerComponent(new Component(INSTALLATIONS_NAME, publicFactory, "PUBLIC" /* ComponentType.PUBLIC */));
    _registerComponent(new Component(INSTALLATIONS_NAME_INTERNAL, internalFactory, "PRIVATE" /* ComponentType.PRIVATE */));
}

/**
 * The Firebase Installations Web SDK.
 * This SDK does not work in a Node.js environment.
 *
 * @packageDocumentation
 */
registerInstallations();
registerVersion(name$1, version$1);
// BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
registerVersion(name$1, version$1, 'esm2017');

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const DEFAULT_SW_PATH = '/firebase-messaging-sw.js';
const DEFAULT_SW_SCOPE = '/firebase-cloud-messaging-push-scope';
const DEFAULT_VAPID_KEY = 'BDOU99-h67HcA6JeFXHbSNMu7e2yNNu3RzoMj8TM4W88jITfq7ZmPvIM1Iv-4_l2LxQcYwhqby2xGpWwzjfAnG4';
const ENDPOINT = 'https://fcmregistrations.googleapis.com/v1';
const CONSOLE_CAMPAIGN_ID = 'google.c.a.c_id';
const CONSOLE_CAMPAIGN_NAME = 'google.c.a.c_l';
const CONSOLE_CAMPAIGN_TIME = 'google.c.a.ts';
/** Set to '1' if Analytics is enabled for the campaign */
const CONSOLE_CAMPAIGN_ANALYTICS_ENABLED = 'google.c.a.e';
var MessageType$1;
(function (MessageType) {
    MessageType[MessageType["DATA_MESSAGE"] = 1] = "DATA_MESSAGE";
    MessageType[MessageType["DISPLAY_NOTIFICATION"] = 3] = "DISPLAY_NOTIFICATION";
})(MessageType$1 || (MessageType$1 = {}));

/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this file except
 * in compliance with the License. You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under the License
 * is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express
 * or implied. See the License for the specific language governing permissions and limitations under
 * the License.
 */
var MessageType;
(function (MessageType) {
    MessageType["PUSH_RECEIVED"] = "push-received";
    MessageType["NOTIFICATION_CLICKED"] = "notification-clicked";
})(MessageType || (MessageType = {}));

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function arrayToBase64(array) {
    const uint8Array = new Uint8Array(array);
    const base64String = btoa(String.fromCharCode(...uint8Array));
    return base64String.replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_');
}
function base64ToArray(base64String) {
    const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
    const base64 = (base64String + padding)
        .replace(/\-/g, '+')
        .replace(/_/g, '/');
    const rawData = atob(base64);
    const outputArray = new Uint8Array(rawData.length);
    for (let i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const OLD_DB_NAME = 'fcm_token_details_db';
/**
 * The last DB version of 'fcm_token_details_db' was 4. This is one higher, so that the upgrade
 * callback is called for all versions of the old DB.
 */
const OLD_DB_VERSION = 5;
const OLD_OBJECT_STORE_NAME = 'fcm_token_object_Store';
async function migrateOldDatabase(senderId) {
    if ('databases' in indexedDB) {
        // indexedDb.databases() is an IndexedDB v3 API and does not exist in all browsers. TODO: Remove
        // typecast when it lands in TS types.
        const databases = await indexedDB.databases();
        const dbNames = databases.map(db => db.name);
        if (!dbNames.includes(OLD_DB_NAME)) {
            // old DB didn't exist, no need to open.
            return null;
        }
    }
    let tokenDetails = null;
    const db = await openDB(OLD_DB_NAME, OLD_DB_VERSION, {
        upgrade: async (db, oldVersion, newVersion, upgradeTransaction) => {
            var _a;
            if (oldVersion < 2) {
                // Database too old, skip migration.
                return;
            }
            if (!db.objectStoreNames.contains(OLD_OBJECT_STORE_NAME)) {
                // Database did not exist. Nothing to do.
                return;
            }
            const objectStore = upgradeTransaction.objectStore(OLD_OBJECT_STORE_NAME);
            const value = await objectStore.index('fcmSenderId').get(senderId);
            await objectStore.clear();
            if (!value) {
                // No entry in the database, nothing to migrate.
                return;
            }
            if (oldVersion === 2) {
                const oldDetails = value;
                if (!oldDetails.auth || !oldDetails.p256dh || !oldDetails.endpoint) {
                    return;
                }
                tokenDetails = {
                    token: oldDetails.fcmToken,
                    createTime: (_a = oldDetails.createTime) !== null && _a !== void 0 ? _a : Date.now(),
                    subscriptionOptions: {
                        auth: oldDetails.auth,
                        p256dh: oldDetails.p256dh,
                        endpoint: oldDetails.endpoint,
                        swScope: oldDetails.swScope,
                        vapidKey: typeof oldDetails.vapidKey === 'string'
                            ? oldDetails.vapidKey
                            : arrayToBase64(oldDetails.vapidKey)
                    }
                };
            }
            else if (oldVersion === 3) {
                const oldDetails = value;
                tokenDetails = {
                    token: oldDetails.fcmToken,
                    createTime: oldDetails.createTime,
                    subscriptionOptions: {
                        auth: arrayToBase64(oldDetails.auth),
                        p256dh: arrayToBase64(oldDetails.p256dh),
                        endpoint: oldDetails.endpoint,
                        swScope: oldDetails.swScope,
                        vapidKey: arrayToBase64(oldDetails.vapidKey)
                    }
                };
            }
            else if (oldVersion === 4) {
                const oldDetails = value;
                tokenDetails = {
                    token: oldDetails.fcmToken,
                    createTime: oldDetails.createTime,
                    subscriptionOptions: {
                        auth: arrayToBase64(oldDetails.auth),
                        p256dh: arrayToBase64(oldDetails.p256dh),
                        endpoint: oldDetails.endpoint,
                        swScope: oldDetails.swScope,
                        vapidKey: arrayToBase64(oldDetails.vapidKey)
                    }
                };
            }
        }
    });
    db.close();
    // Delete all old databases.
    await deleteDB(OLD_DB_NAME);
    await deleteDB('fcm_vapid_details_db');
    await deleteDB('undefined');
    return checkTokenDetails(tokenDetails) ? tokenDetails : null;
}
function checkTokenDetails(tokenDetails) {
    if (!tokenDetails || !tokenDetails.subscriptionOptions) {
        return false;
    }
    const { subscriptionOptions } = tokenDetails;
    return (typeof tokenDetails.createTime === 'number' &&
        tokenDetails.createTime > 0 &&
        typeof tokenDetails.token === 'string' &&
        tokenDetails.token.length > 0 &&
        typeof subscriptionOptions.auth === 'string' &&
        subscriptionOptions.auth.length > 0 &&
        typeof subscriptionOptions.p256dh === 'string' &&
        subscriptionOptions.p256dh.length > 0 &&
        typeof subscriptionOptions.endpoint === 'string' &&
        subscriptionOptions.endpoint.length > 0 &&
        typeof subscriptionOptions.swScope === 'string' &&
        subscriptionOptions.swScope.length > 0 &&
        typeof subscriptionOptions.vapidKey === 'string' &&
        subscriptionOptions.vapidKey.length > 0);
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Exported for tests.
const DATABASE_NAME = 'firebase-messaging-database';
const DATABASE_VERSION = 1;
const OBJECT_STORE_NAME = 'firebase-messaging-store';
let dbPromise = null;
function getDbPromise() {
    if (!dbPromise) {
        dbPromise = openDB(DATABASE_NAME, DATABASE_VERSION, {
            upgrade: (upgradeDb, oldVersion) => {
                // We don't use 'break' in this switch statement, the fall-through behavior is what we want,
                // because if there are multiple versions between the old version and the current version, we
                // want ALL the migrations that correspond to those versions to run, not only the last one.
                // eslint-disable-next-line default-case
                switch (oldVersion) {
                    case 0:
                        upgradeDb.createObjectStore(OBJECT_STORE_NAME);
                }
            }
        });
    }
    return dbPromise;
}
/** Gets record(s) from the objectStore that match the given key. */
async function dbGet(firebaseDependencies) {
    const key = getKey(firebaseDependencies);
    const db = await getDbPromise();
    const tokenDetails = (await db
        .transaction(OBJECT_STORE_NAME)
        .objectStore(OBJECT_STORE_NAME)
        .get(key));
    if (tokenDetails) {
        return tokenDetails;
    }
    else {
        // Check if there is a tokenDetails object in the old DB.
        const oldTokenDetails = await migrateOldDatabase(firebaseDependencies.appConfig.senderId);
        if (oldTokenDetails) {
            await dbSet(firebaseDependencies, oldTokenDetails);
            return oldTokenDetails;
        }
    }
}
/** Assigns or overwrites the record for the given key with the given value. */
async function dbSet(firebaseDependencies, tokenDetails) {
    const key = getKey(firebaseDependencies);
    const db = await getDbPromise();
    const tx = db.transaction(OBJECT_STORE_NAME, 'readwrite');
    await tx.objectStore(OBJECT_STORE_NAME).put(tokenDetails, key);
    await tx.done;
    return tokenDetails;
}
function getKey({ appConfig }) {
    return appConfig.appId;
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const ERROR_MAP = {
    ["missing-app-config-values" /* ErrorCode.MISSING_APP_CONFIG_VALUES */]: 'Missing App configuration value: "{$valueName}"',
    ["only-available-in-window" /* ErrorCode.AVAILABLE_IN_WINDOW */]: 'This method is available in a Window context.',
    ["only-available-in-sw" /* ErrorCode.AVAILABLE_IN_SW */]: 'This method is available in a service worker context.',
    ["permission-default" /* ErrorCode.PERMISSION_DEFAULT */]: 'The notification permission was not granted and dismissed instead.',
    ["permission-blocked" /* ErrorCode.PERMISSION_BLOCKED */]: 'The notification permission was not granted and blocked instead.',
    ["unsupported-browser" /* ErrorCode.UNSUPPORTED_BROWSER */]: "This browser doesn't support the API's required to use the Firebase SDK.",
    ["indexed-db-unsupported" /* ErrorCode.INDEXED_DB_UNSUPPORTED */]: "This browser doesn't support indexedDb.open() (ex. Safari iFrame, Firefox Private Browsing, etc)",
    ["failed-service-worker-registration" /* ErrorCode.FAILED_DEFAULT_REGISTRATION */]: 'We are unable to register the default service worker. {$browserErrorMessage}',
    ["token-subscribe-failed" /* ErrorCode.TOKEN_SUBSCRIBE_FAILED */]: 'A problem occurred while subscribing the user to FCM: {$errorInfo}',
    ["token-subscribe-no-token" /* ErrorCode.TOKEN_SUBSCRIBE_NO_TOKEN */]: 'FCM returned no token when subscribing the user to push.',
    ["token-unsubscribe-failed" /* ErrorCode.TOKEN_UNSUBSCRIBE_FAILED */]: 'A problem occurred while unsubscribing the ' +
        'user from FCM: {$errorInfo}',
    ["token-update-failed" /* ErrorCode.TOKEN_UPDATE_FAILED */]: 'A problem occurred while updating the user from FCM: {$errorInfo}',
    ["token-update-no-token" /* ErrorCode.TOKEN_UPDATE_NO_TOKEN */]: 'FCM returned no token when updating the user to push.',
    ["use-sw-after-get-token" /* ErrorCode.USE_SW_AFTER_GET_TOKEN */]: 'The useServiceWorker() method may only be called once and must be ' +
        'called before calling getToken() to ensure your service worker is used.',
    ["invalid-sw-registration" /* ErrorCode.INVALID_SW_REGISTRATION */]: 'The input to useServiceWorker() must be a ServiceWorkerRegistration.',
    ["invalid-bg-handler" /* ErrorCode.INVALID_BG_HANDLER */]: 'The input to setBackgroundMessageHandler() must be a function.',
    ["invalid-vapid-key" /* ErrorCode.INVALID_VAPID_KEY */]: 'The public VAPID key must be a string.',
    ["use-vapid-key-after-get-token" /* ErrorCode.USE_VAPID_KEY_AFTER_GET_TOKEN */]: 'The usePublicVapidKey() method may only be called once and must be ' +
        'called before calling getToken() to ensure your VAPID key is used.'
};
const ERROR_FACTORY = new ErrorFactory('messaging', 'Messaging', ERROR_MAP);

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function requestGetToken(firebaseDependencies, subscriptionOptions) {
    const headers = await getHeaders(firebaseDependencies);
    const body = getBody(subscriptionOptions);
    const subscribeOptions = {
        method: 'POST',
        headers,
        body: JSON.stringify(body)
    };
    let responseData;
    try {
        const response = await fetch(getEndpoint(firebaseDependencies.appConfig), subscribeOptions);
        responseData = await response.json();
    }
    catch (err) {
        throw ERROR_FACTORY.create("token-subscribe-failed" /* ErrorCode.TOKEN_SUBSCRIBE_FAILED */, {
            errorInfo: err === null || err === void 0 ? void 0 : err.toString()
        });
    }
    if (responseData.error) {
        const message = responseData.error.message;
        throw ERROR_FACTORY.create("token-subscribe-failed" /* ErrorCode.TOKEN_SUBSCRIBE_FAILED */, {
            errorInfo: message
        });
    }
    if (!responseData.token) {
        throw ERROR_FACTORY.create("token-subscribe-no-token" /* ErrorCode.TOKEN_SUBSCRIBE_NO_TOKEN */);
    }
    return responseData.token;
}
async function requestUpdateToken(firebaseDependencies, tokenDetails) {
    const headers = await getHeaders(firebaseDependencies);
    const body = getBody(tokenDetails.subscriptionOptions);
    const updateOptions = {
        method: 'PATCH',
        headers,
        body: JSON.stringify(body)
    };
    let responseData;
    try {
        const response = await fetch(`${getEndpoint(firebaseDependencies.appConfig)}/${tokenDetails.token}`, updateOptions);
        responseData = await response.json();
    }
    catch (err) {
        throw ERROR_FACTORY.create("token-update-failed" /* ErrorCode.TOKEN_UPDATE_FAILED */, {
            errorInfo: err === null || err === void 0 ? void 0 : err.toString()
        });
    }
    if (responseData.error) {
        const message = responseData.error.message;
        throw ERROR_FACTORY.create("token-update-failed" /* ErrorCode.TOKEN_UPDATE_FAILED */, {
            errorInfo: message
        });
    }
    if (!responseData.token) {
        throw ERROR_FACTORY.create("token-update-no-token" /* ErrorCode.TOKEN_UPDATE_NO_TOKEN */);
    }
    return responseData.token;
}
async function requestDeleteToken(firebaseDependencies, token) {
    const headers = await getHeaders(firebaseDependencies);
    const unsubscribeOptions = {
        method: 'DELETE',
        headers
    };
    try {
        const response = await fetch(`${getEndpoint(firebaseDependencies.appConfig)}/${token}`, unsubscribeOptions);
        const responseData = await response.json();
        if (responseData.error) {
            const message = responseData.error.message;
            throw ERROR_FACTORY.create("token-unsubscribe-failed" /* ErrorCode.TOKEN_UNSUBSCRIBE_FAILED */, {
                errorInfo: message
            });
        }
    }
    catch (err) {
        throw ERROR_FACTORY.create("token-unsubscribe-failed" /* ErrorCode.TOKEN_UNSUBSCRIBE_FAILED */, {
            errorInfo: err === null || err === void 0 ? void 0 : err.toString()
        });
    }
}
function getEndpoint({ projectId }) {
    return `${ENDPOINT}/projects/${projectId}/registrations`;
}
async function getHeaders({ appConfig, installations }) {
    const authToken = await installations.getToken();
    return new Headers({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'x-goog-api-key': appConfig.apiKey,
        'x-goog-firebase-installations-auth': `FIS ${authToken}`
    });
}
function getBody({ p256dh, auth, endpoint, vapidKey }) {
    const body = {
        web: {
            endpoint,
            auth,
            p256dh
        }
    };
    if (vapidKey !== DEFAULT_VAPID_KEY) {
        body.web.applicationPubKey = vapidKey;
    }
    return body;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// UpdateRegistration will be called once every week.
const TOKEN_EXPIRATION_MS = 7 * 24 * 60 * 60 * 1000; // 7 days
async function getTokenInternal(messaging) {
    const pushSubscription = await getPushSubscription(messaging.swRegistration, messaging.vapidKey);
    const subscriptionOptions = {
        vapidKey: messaging.vapidKey,
        swScope: messaging.swRegistration.scope,
        endpoint: pushSubscription.endpoint,
        auth: arrayToBase64(pushSubscription.getKey('auth')),
        p256dh: arrayToBase64(pushSubscription.getKey('p256dh'))
    };
    const tokenDetails = await dbGet(messaging.firebaseDependencies);
    if (!tokenDetails) {
        // No token, get a new one.
        return getNewToken(messaging.firebaseDependencies, subscriptionOptions);
    }
    else if (!isTokenValid(tokenDetails.subscriptionOptions, subscriptionOptions)) {
        // Invalid token, get a new one.
        try {
            await requestDeleteToken(messaging.firebaseDependencies, tokenDetails.token);
        }
        catch (e) {
            // Suppress errors because of #2364
            console.warn(e);
        }
        return getNewToken(messaging.firebaseDependencies, subscriptionOptions);
    }
    else if (Date.now() >= tokenDetails.createTime + TOKEN_EXPIRATION_MS) {
        // Weekly token refresh
        return updateToken(messaging, {
            token: tokenDetails.token,
            createTime: Date.now(),
            subscriptionOptions
        });
    }
    else {
        // Valid token, nothing to do.
        return tokenDetails.token;
    }
}
async function updateToken(messaging, tokenDetails) {
    try {
        const updatedToken = await requestUpdateToken(messaging.firebaseDependencies, tokenDetails);
        const updatedTokenDetails = Object.assign(Object.assign({}, tokenDetails), { token: updatedToken, createTime: Date.now() });
        await dbSet(messaging.firebaseDependencies, updatedTokenDetails);
        return updatedToken;
    }
    catch (e) {
        throw e;
    }
}
async function getNewToken(firebaseDependencies, subscriptionOptions) {
    const token = await requestGetToken(firebaseDependencies, subscriptionOptions);
    const tokenDetails = {
        token,
        createTime: Date.now(),
        subscriptionOptions
    };
    await dbSet(firebaseDependencies, tokenDetails);
    return tokenDetails.token;
}
/**
 * Gets a PushSubscription for the current user.
 */
async function getPushSubscription(swRegistration, vapidKey) {
    const subscription = await swRegistration.pushManager.getSubscription();
    if (subscription) {
        return subscription;
    }
    return swRegistration.pushManager.subscribe({
        userVisibleOnly: true,
        // Chrome <= 75 doesn't support base64-encoded VAPID key. For backward compatibility, VAPID key
        // submitted to pushManager#subscribe must be of type Uint8Array.
        applicationServerKey: base64ToArray(vapidKey)
    });
}
/**
 * Checks if the saved tokenDetails object matches the configuration provided.
 */
function isTokenValid(dbOptions, currentOptions) {
    const isVapidKeyEqual = currentOptions.vapidKey === dbOptions.vapidKey;
    const isEndpointEqual = currentOptions.endpoint === dbOptions.endpoint;
    const isAuthEqual = currentOptions.auth === dbOptions.auth;
    const isP256dhEqual = currentOptions.p256dh === dbOptions.p256dh;
    return isVapidKeyEqual && isEndpointEqual && isAuthEqual && isP256dhEqual;
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function externalizePayload(internalPayload) {
    const payload = {
        from: internalPayload.from,
        // eslint-disable-next-line camelcase
        collapseKey: internalPayload.collapse_key,
        // eslint-disable-next-line camelcase
        messageId: internalPayload.fcmMessageId
    };
    propagateNotificationPayload(payload, internalPayload);
    propagateDataPayload(payload, internalPayload);
    propagateFcmOptions(payload, internalPayload);
    return payload;
}
function propagateNotificationPayload(payload, messagePayloadInternal) {
    if (!messagePayloadInternal.notification) {
        return;
    }
    payload.notification = {};
    const title = messagePayloadInternal.notification.title;
    if (!!title) {
        payload.notification.title = title;
    }
    const body = messagePayloadInternal.notification.body;
    if (!!body) {
        payload.notification.body = body;
    }
    const image = messagePayloadInternal.notification.image;
    if (!!image) {
        payload.notification.image = image;
    }
    const icon = messagePayloadInternal.notification.icon;
    if (!!icon) {
        payload.notification.icon = icon;
    }
}
function propagateDataPayload(payload, messagePayloadInternal) {
    if (!messagePayloadInternal.data) {
        return;
    }
    payload.data = messagePayloadInternal.data;
}
function propagateFcmOptions(payload, messagePayloadInternal) {
    var _a, _b, _c, _d, _e;
    // fcmOptions.link value is written into notification.click_action. see more in b/232072111
    if (!messagePayloadInternal.fcmOptions &&
        !((_a = messagePayloadInternal.notification) === null || _a === void 0 ? void 0 : _a.click_action)) {
        return;
    }
    payload.fcmOptions = {};
    const link = (_c = (_b = messagePayloadInternal.fcmOptions) === null || _b === void 0 ? void 0 : _b.link) !== null && _c !== void 0 ? _c : (_d = messagePayloadInternal.notification) === null || _d === void 0 ? void 0 : _d.click_action;
    if (!!link) {
        payload.fcmOptions.link = link;
    }
    // eslint-disable-next-line camelcase
    const analyticsLabel = (_e = messagePayloadInternal.fcmOptions) === null || _e === void 0 ? void 0 : _e.analytics_label;
    if (!!analyticsLabel) {
        payload.fcmOptions.analyticsLabel = analyticsLabel;
    }
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function isConsoleMessage(data) {
    // This message has a campaign ID, meaning it was sent using the Firebase Console.
    return typeof data === 'object' && !!data && CONSOLE_CAMPAIGN_ID in data;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
_mergeStrings('hts/frbslgigp.ogepscmv/ieo/eaylg', 'tp:/ieaeogn-agolai.o/1frlglgc/o');
_mergeStrings('AzSCbw63g1R0nCw85jG8', 'Iaya3yLKwmgvh7cF0q4');
function _mergeStrings(s1, s2) {
    const resultArray = [];
    for (let i = 0; i < s1.length; i++) {
        resultArray.push(s1.charAt(i));
        if (i < s2.length) {
            resultArray.push(s2.charAt(i));
        }
    }
    return resultArray.join('');
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function extractAppConfig(app) {
    if (!app || !app.options) {
        throw getMissingValueError('App Configuration Object');
    }
    if (!app.name) {
        throw getMissingValueError('App Name');
    }
    // Required app config keys
    const configKeys = [
        'projectId',
        'apiKey',
        'appId',
        'messagingSenderId'
    ];
    const { options } = app;
    for (const keyName of configKeys) {
        if (!options[keyName]) {
            throw getMissingValueError(keyName);
        }
    }
    return {
        appName: app.name,
        projectId: options.projectId,
        apiKey: options.apiKey,
        appId: options.appId,
        senderId: options.messagingSenderId
    };
}
function getMissingValueError(valueName) {
    return ERROR_FACTORY.create("missing-app-config-values" /* ErrorCode.MISSING_APP_CONFIG_VALUES */, {
        valueName
    });
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class MessagingService {
    constructor(app, installations, analyticsProvider) {
        // logging is only done with end user consent. Default to false.
        this.deliveryMetricsExportedToBigQueryEnabled = false;
        this.onBackgroundMessageHandler = null;
        this.onMessageHandler = null;
        this.logEvents = [];
        this.isLogServiceStarted = false;
        const appConfig = extractAppConfig(app);
        this.firebaseDependencies = {
            app,
            appConfig,
            installations,
            analyticsProvider
        };
    }
    _delete() {
        return Promise.resolve();
    }
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function registerDefaultSw(messaging) {
    try {
        messaging.swRegistration = await navigator.serviceWorker.register(DEFAULT_SW_PATH, {
            scope: DEFAULT_SW_SCOPE
        });
        // The timing when browser updates sw when sw has an update is unreliable from experiment. It
        // leads to version conflict when the SDK upgrades to a newer version in the main page, but sw
        // is stuck with the old version. For example,
        // https://github.com/firebase/firebase-js-sdk/issues/2590 The following line reliably updates
        // sw if there was an update.
        messaging.swRegistration.update().catch(() => {
            /* it is non blocking and we don't care if it failed */
        });
    }
    catch (e) {
        throw ERROR_FACTORY.create("failed-service-worker-registration" /* ErrorCode.FAILED_DEFAULT_REGISTRATION */, {
            browserErrorMessage: e === null || e === void 0 ? void 0 : e.message
        });
    }
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function updateSwReg(messaging, swRegistration) {
    if (!swRegistration && !messaging.swRegistration) {
        await registerDefaultSw(messaging);
    }
    if (!swRegistration && !!messaging.swRegistration) {
        return;
    }
    if (!(swRegistration instanceof ServiceWorkerRegistration)) {
        throw ERROR_FACTORY.create("invalid-sw-registration" /* ErrorCode.INVALID_SW_REGISTRATION */);
    }
    messaging.swRegistration = swRegistration;
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function updateVapidKey(messaging, vapidKey) {
    if (!!vapidKey) {
        messaging.vapidKey = vapidKey;
    }
    else if (!messaging.vapidKey) {
        messaging.vapidKey = DEFAULT_VAPID_KEY;
    }
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function getToken$1(messaging, options) {
    if (!navigator) {
        throw ERROR_FACTORY.create("only-available-in-window" /* ErrorCode.AVAILABLE_IN_WINDOW */);
    }
    if (Notification.permission === 'default') {
        await Notification.requestPermission();
    }
    if (Notification.permission !== 'granted') {
        throw ERROR_FACTORY.create("permission-blocked" /* ErrorCode.PERMISSION_BLOCKED */);
    }
    await updateVapidKey(messaging, options === null || options === void 0 ? void 0 : options.vapidKey);
    await updateSwReg(messaging, options === null || options === void 0 ? void 0 : options.serviceWorkerRegistration);
    return getTokenInternal(messaging);
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function logToScion(messaging, messageType, data) {
    const eventType = getEventType(messageType);
    const analytics = await messaging.firebaseDependencies.analyticsProvider.get();
    analytics.logEvent(eventType, {
        /* eslint-disable camelcase */
        message_id: data[CONSOLE_CAMPAIGN_ID],
        message_name: data[CONSOLE_CAMPAIGN_NAME],
        message_time: data[CONSOLE_CAMPAIGN_TIME],
        message_device_time: Math.floor(Date.now() / 1000)
        /* eslint-enable camelcase */
    });
}
function getEventType(messageType) {
    switch (messageType) {
        case MessageType.NOTIFICATION_CLICKED:
            return 'notification_open';
        case MessageType.PUSH_RECEIVED:
            return 'notification_foreground';
        default:
            throw new Error();
    }
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function messageEventListener(messaging, event) {
    const internalPayload = event.data;
    if (!internalPayload.isFirebaseMessaging) {
        return;
    }
    if (messaging.onMessageHandler &&
        internalPayload.messageType === MessageType.PUSH_RECEIVED) {
        if (typeof messaging.onMessageHandler === 'function') {
            messaging.onMessageHandler(externalizePayload(internalPayload));
        }
        else {
            messaging.onMessageHandler.next(externalizePayload(internalPayload));
        }
    }
    // Log to Scion if applicable
    const dataPayload = internalPayload.data;
    if (isConsoleMessage(dataPayload) &&
        dataPayload[CONSOLE_CAMPAIGN_ANALYTICS_ENABLED] === '1') {
        await logToScion(messaging, internalPayload.messageType, dataPayload);
    }
}

const name = "@firebase/messaging";
const version = "0.12.9";

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const WindowMessagingFactory = (container) => {
    const messaging = new MessagingService(container.getProvider('app').getImmediate(), container.getProvider('installations-internal').getImmediate(), container.getProvider('analytics-internal'));
    navigator.serviceWorker.addEventListener('message', e => messageEventListener(messaging, e));
    return messaging;
};
const WindowMessagingInternalFactory = (container) => {
    const messaging = container
        .getProvider('messaging')
        .getImmediate();
    const messagingInternal = {
        getToken: (options) => getToken$1(messaging, options)
    };
    return messagingInternal;
};
function registerMessagingInWindow() {
    _registerComponent(new Component('messaging', WindowMessagingFactory, "PUBLIC" /* ComponentType.PUBLIC */));
    _registerComponent(new Component('messaging-internal', WindowMessagingInternalFactory, "PRIVATE" /* ComponentType.PRIVATE */));
    registerVersion(name, version);
    // BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
    registerVersion(name, version, 'esm2017');
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Checks if all required APIs exist in the browser.
 * @returns a Promise that resolves to a boolean.
 *
 * @public
 */
async function isWindowSupported() {
    try {
        // This throws if open() is unsupported, so adding it to the conditional
        // statement below can cause an uncaught error.
        await validateIndexedDBOpenable();
    }
    catch (e) {
        return false;
    }
    // firebase-js-sdk/issues/2393 reveals that idb#open in Safari iframe and Firefox private browsing
    // might be prohibited to run. In these contexts, an error would be thrown during the messaging
    // instantiating phase, informing the developers to import/call isSupported for special handling.
    return (typeof window !== 'undefined' &&
        isIndexedDBAvailable() &&
        areCookiesEnabled() &&
        'serviceWorker' in navigator &&
        'PushManager' in window &&
        'Notification' in window &&
        'fetch' in window &&
        ServiceWorkerRegistration.prototype.hasOwnProperty('showNotification') &&
        PushSubscription.prototype.hasOwnProperty('getKey'));
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function onMessage$1(messaging, nextOrObserver) {
    if (!navigator) {
        throw ERROR_FACTORY.create("only-available-in-window" /* ErrorCode.AVAILABLE_IN_WINDOW */);
    }
    messaging.onMessageHandler = nextOrObserver;
    return () => {
        messaging.onMessageHandler = null;
    };
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Retrieves a Firebase Cloud Messaging instance.
 *
 * @returns The Firebase Cloud Messaging instance associated with the provided firebase app.
 *
 * @public
 */
function getMessagingInWindow(app = getApp()) {
    // Conscious decision to make this async check non-blocking during the messaging instance
    // initialization phase for performance consideration. An error would be thrown latter for
    // developer's information. Developers can then choose to import and call `isSupported` for
    // special handling.
    isWindowSupported().then(isSupported => {
        // If `isWindowSupported()` resolved, but returned false.
        if (!isSupported) {
            throw ERROR_FACTORY.create("unsupported-browser" /* ErrorCode.UNSUPPORTED_BROWSER */);
        }
    }, _ => {
        // If `isWindowSupported()` rejected.
        throw ERROR_FACTORY.create("indexed-db-unsupported" /* ErrorCode.INDEXED_DB_UNSUPPORTED */);
    });
    return _getProvider(getModularInstance(app), 'messaging').getImmediate();
}
/**
 * Subscribes the {@link Messaging} instance to push notifications. Returns a Firebase Cloud
 * Messaging registration token that can be used to send push messages to that {@link Messaging}
 * instance.
 *
 * If notification permission isn't already granted, this method asks the user for permission. The
 * returned promise rejects if the user does not allow the app to show notifications.
 *
 * @param messaging - The {@link Messaging} instance.
 * @param options - Provides an optional vapid key and an optional service worker registration.
 *
 * @returns The promise resolves with an FCM registration token.
 *
 * @public
 */
async function getToken(messaging, options) {
    messaging = getModularInstance(messaging);
    return getToken$1(messaging, options);
}
/**
 * When a push message is received and the user is currently on a page for your origin, the
 * message is passed to the page and an `onMessage()` event is dispatched with the payload of
 * the push message.
 *
 *
 * @param messaging - The {@link Messaging} instance.
 * @param nextOrObserver - This function, or observer object with `next` defined,
 *     is called when a message is received and the user is currently viewing your page.
 * @returns To stop listening for messages execute this returned function.
 *
 * @public
 */
function onMessage(messaging, nextOrObserver) {
    messaging = getModularInstance(messaging);
    return onMessage$1(messaging, nextOrObserver);
}

/**
 * The Firebase Cloud Messaging Web SDK.
 * This SDK does not work in a Node.js environment.
 *
 * @packageDocumentation
 */
registerMessagingInWindow();

var css_248z = ":root {\n  --toastify-color-light: #fafafa;\n  --toastify-color-dark: #121212;\n  --toastify-color-info: #2196f3;\n  --toastify-color-success: #4caf50;\n  --toastify-color-warning: #ff9800;\n  --toastify-color-error: #f44336;\n  --toastify-color-transparent: rgba(255, 255, 255, 0.7);\n  --toastify-icon-color-info: var(--toastify-color-info);\n  --toastify-icon-color-success: var(--toastify-color-success);\n  --toastify-icon-color-warning: var(--toastify-color-warning);\n  --toastify-icon-color-error: var(--toastify-color-error);\n  --toastify-toast-width: 344px;\n  --toastify-toast-background: #fff;\n  --toastify-toast-min-height: 48px;\n  --toastify-toast-max-height: 800px;\n  --toastify-toast-border-radius: 8px;\n  --toastify-toast-left-right-padding: 16px;\n  --toastify-toast-top-bottom-padding: 6px;\n  --toastify-font-family: Roboto, Helvetica, Arial, sans-serif;\n  --toastify-font-size: 0.875rem;\n  --toastify-line-height: 14px;\n  --toastify-z-index: 9999;\n  --toastify-text-color-light: #aaa;\n  --toastify-text-color-dark: #fff;\n  --toastify-text-color-info: #fff;\n  --toastify-text-color-success: #fff;\n  --toastify-text-color-warning: #fff;\n  --toastify-text-color-error: #fff;\n  --toastify-spinner-color: #616161;\n  --toastify-spinner-color-empty-area: #e0e0e0;\n  --toastify-color-progress-light: linear-gradient(to right, #4cd964, #5ac8fa, #007aff, #34aadc, #5856d6, #ff2d55);\n  --toastify-color-progress-dark: #bb86fc;\n  --toastify-color-progress-info: var(--toastify-color-info);\n  --toastify-color-progress-success: var(--toastify-color-success);\n  --toastify-color-progress-warning: var(--toastify-color-warning);\n  --toastify-color-progress-error: var(--toastify-color-error);\n}\n\n.Toastify__toast-container {\n  z-index: var(--toastify-z-index);\n  -webkit-transform: translate3d(0, 0, var(--toastify-z-index) px);\n  position: fixed;\n  padding: 4px;\n  width: var(--toastify-toast-width);\n  box-sizing: border-box;\n  color: #fff;\n}\n.Toastify__toast-container--top-left {\n  top: 1em;\n  left: 1em;\n}\n.Toastify__toast-container--top-center {\n  top: 1em;\n  left: 50%;\n  transform: translateX(-50%);\n}\n.Toastify__toast-container--top-right {\n  top: 1em;\n  right: 1em;\n}\n.Toastify__toast-container--bottom-left {\n  bottom: 1em;\n  left: 1em;\n}\n.Toastify__toast-container--bottom-center {\n  bottom: 1em;\n  left: 50%;\n  transform: translateX(-50%);\n}\n.Toastify__toast-container--bottom-right {\n  bottom: 1em;\n  right: 1em;\n}\n\n@media only screen and (max-width : 480px) {\n  .Toastify__toast-container {\n    width: 100vw;\n    padding: 0;\n    left: 0;\n    margin: 0;\n  }\n  .Toastify__toast-container--top-left, .Toastify__toast-container--top-center, .Toastify__toast-container--top-right {\n    top: 0;\n    transform: translateX(0);\n  }\n  .Toastify__toast-container--bottom-left, .Toastify__toast-container--bottom-center, .Toastify__toast-container--bottom-right {\n    bottom: 0;\n    transform: translateX(0);\n  }\n  .Toastify__toast-container--rtl {\n    right: 0;\n    left: initial;\n  }\n}\n.Toastify__toast {\n  position: relative;\n  min-height: var(--toastify-toast-min-height);\n  box-sizing: border-box;\n  margin-bottom: 1rem;\n  padding: var(--toastify-toast-top-bottom-padding) var(--toastify-toast-left-right-padding);\n  border-radius: var(--toastify-toast-border-radius);\n  box-shadow: 0 1px 10px 0 rgba(0, 0, 0, 0.1), 0 2px 15px 0 rgba(0, 0, 0, 0.05);\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  max-height: var(--toastify-toast-max-height);\n  overflow: hidden;\n  font-family: var(--toastify-font-family);\n  cursor: default;\n  direction: ltr;\n  /* webkit only issue #791 */\n  z-index: 0;\n}\n.Toastify__toast--rtl {\n  direction: rtl;\n}\n.Toastify__toast--close-on-click {\n  cursor: pointer;\n}\n.Toastify__toast-body {\n  margin: auto 0;\n  -ms-flex: 1 1 auto;\n      flex: 1 1 auto;\n  padding: 6px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n}\n.Toastify__toast-body > div:last-child {\n  word-break: break-word;\n  -ms-flex: 1;\n      flex: 1;\n}\n.Toastify__toast-icon {\n  -webkit-margin-end: 10px;\n          margin-inline-end: 10px;\n  width: 20px;\n  -ms-flex-negative: 0;\n      flex-shrink: 0;\n  display: -ms-flexbox;\n  display: flex;\n}\n\n.Toastify--animate {\n  animation-fill-mode: both;\n  animation-duration: 0.7s;\n}\n\n.Toastify--animate-icon {\n  animation-fill-mode: both;\n  animation-duration: 0.3s;\n}\n\n@media only screen and (max-width : 480px) {\n  .Toastify__toast {\n    margin: 0 3px 3px;\n  }\n}\n.Toastify__toast-theme--dark {\n  background: var(--toastify-color-dark);\n  color: var(--toastify-text-color-dark);\n}\n.Toastify__toast-theme--light {\n  background: var(--toastify-color-light);\n  color: var(--toastify-text-color-light);\n}\n.Toastify__toast-theme--colored.Toastify__toast--default {\n  background: var(--toastify-color-light);\n  color: var(--toastify-text-color-light);\n}\n.Toastify__toast-theme--colored.Toastify__toast--info {\n  color: var(--toastify-text-color-info);\n  background: var(--toastify-color-info);\n}\n.Toastify__toast-theme--colored.Toastify__toast--success {\n  color: var(--toastify-text-color-success);\n  background: var(--toastify-color-success);\n}\n.Toastify__toast-theme--colored.Toastify__toast--warning {\n  color: var(--toastify-text-color-warning);\n  background: var(--toastify-color-warning);\n}\n.Toastify__toast-theme--colored.Toastify__toast--error {\n  color: var(--toastify-text-color-error);\n  background: var(--toastify-color-error);\n}\n\n.Toastify__progress-bar-theme--light {\n  background: var(--toastify-color-progress-light);\n}\n.Toastify__progress-bar-theme--dark {\n  background: var(--toastify-color-progress-dark);\n}\n.Toastify__progress-bar--info {\n  background: var(--toastify-color-progress-info);\n}\n.Toastify__progress-bar--success {\n  background: var(--toastify-color-progress-success);\n}\n.Toastify__progress-bar--warning {\n  background: var(--toastify-color-progress-warning);\n}\n.Toastify__progress-bar--error {\n  background: var(--toastify-color-progress-error);\n}\n.Toastify__progress-bar-theme--colored.Toastify__progress-bar--info, .Toastify__progress-bar-theme--colored.Toastify__progress-bar--success, .Toastify__progress-bar-theme--colored.Toastify__progress-bar--warning, .Toastify__progress-bar-theme--colored.Toastify__progress-bar--error {\n  background: var(--toastify-color-transparent);\n}\n\n.Toastify__close-button {\n  color: #fff;\n  background: transparent;\n  outline: none;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n  opacity: 0.7;\n  transition: 0.3s ease;\n  -ms-flex-item-align: center;\n      -ms-grid-row-align: center;\n      align-self: center;\n}\n.Toastify__close-button--light {\n  color: #000;\n  opacity: 0.3;\n}\n.Toastify__close-button > svg {\n  fill: currentColor;\n  height: 16px;\n  width: 14px;\n}\n.Toastify__close-button:hover, .Toastify__close-button:focus {\n  opacity: 1;\n}\n\n@keyframes Toastify__trackProgress {\n  0% {\n    transform: scaleX(1);\n  }\n  100% {\n    transform: scaleX(0);\n  }\n}\n.Toastify__progress-bar {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 5px;\n  z-index: var(--toastify-z-index);\n  opacity: 0.7;\n  transform-origin: left;\n}\n.Toastify__progress-bar--animated {\n  animation: Toastify__trackProgress linear 1 forwards;\n}\n.Toastify__progress-bar--controlled {\n  transition: transform 0.2s;\n}\n.Toastify__progress-bar--rtl {\n  right: 0;\n  left: initial;\n  transform-origin: right;\n}\n\n.Toastify__spinner {\n  width: 20px;\n  height: 20px;\n  box-sizing: border-box;\n  border: 2px solid;\n  border-radius: 100%;\n  border-color: var(--toastify-spinner-color-empty-area);\n  border-right-color: var(--toastify-spinner-color);\n  animation: Toastify__spin 0.65s linear infinite;\n}\n\n@keyframes Toastify__bounceInRight {\n  from, 60%, 75%, 90%, to {\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n  }\n  from {\n    opacity: 0;\n    transform: translate3d(3000px, 0, 0);\n  }\n  60% {\n    opacity: 1;\n    transform: translate3d(-25px, 0, 0);\n  }\n  75% {\n    transform: translate3d(10px, 0, 0);\n  }\n  90% {\n    transform: translate3d(-5px, 0, 0);\n  }\n  to {\n    transform: none;\n  }\n}\n@keyframes Toastify__bounceOutRight {\n  20% {\n    opacity: 1;\n    transform: translate3d(-20px, 0, 0);\n  }\n  to {\n    opacity: 0;\n    transform: translate3d(2000px, 0, 0);\n  }\n}\n@keyframes Toastify__bounceInLeft {\n  from, 60%, 75%, 90%, to {\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n  }\n  0% {\n    opacity: 0;\n    transform: translate3d(-3000px, 0, 0);\n  }\n  60% {\n    opacity: 1;\n    transform: translate3d(25px, 0, 0);\n  }\n  75% {\n    transform: translate3d(-10px, 0, 0);\n  }\n  90% {\n    transform: translate3d(5px, 0, 0);\n  }\n  to {\n    transform: none;\n  }\n}\n@keyframes Toastify__bounceOutLeft {\n  20% {\n    opacity: 1;\n    transform: translate3d(20px, 0, 0);\n  }\n  to {\n    opacity: 0;\n    transform: translate3d(-2000px, 0, 0);\n  }\n}\n@keyframes Toastify__bounceInUp {\n  from, 60%, 75%, 90%, to {\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n  }\n  from {\n    opacity: 0;\n    transform: translate3d(0, 3000px, 0);\n  }\n  60% {\n    opacity: 1;\n    transform: translate3d(0, -20px, 0);\n  }\n  75% {\n    transform: translate3d(0, 10px, 0);\n  }\n  90% {\n    transform: translate3d(0, -5px, 0);\n  }\n  to {\n    transform: translate3d(0, 0, 0);\n  }\n}\n@keyframes Toastify__bounceOutUp {\n  20% {\n    transform: translate3d(0, -10px, 0);\n  }\n  40%, 45% {\n    opacity: 1;\n    transform: translate3d(0, 20px, 0);\n  }\n  to {\n    opacity: 0;\n    transform: translate3d(0, -2000px, 0);\n  }\n}\n@keyframes Toastify__bounceInDown {\n  from, 60%, 75%, 90%, to {\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n  }\n  0% {\n    opacity: 0;\n    transform: translate3d(0, -3000px, 0);\n  }\n  60% {\n    opacity: 1;\n    transform: translate3d(0, 25px, 0);\n  }\n  75% {\n    transform: translate3d(0, -10px, 0);\n  }\n  90% {\n    transform: translate3d(0, 5px, 0);\n  }\n  to {\n    transform: none;\n  }\n}\n@keyframes Toastify__bounceOutDown {\n  20% {\n    transform: translate3d(0, 10px, 0);\n  }\n  40%, 45% {\n    opacity: 1;\n    transform: translate3d(0, -20px, 0);\n  }\n  to {\n    opacity: 0;\n    transform: translate3d(0, 2000px, 0);\n  }\n}\n.Toastify__bounce-enter--top-left, .Toastify__bounce-enter--bottom-left {\n  animation-name: Toastify__bounceInLeft;\n}\n.Toastify__bounce-enter--top-right, .Toastify__bounce-enter--bottom-right {\n  animation-name: Toastify__bounceInRight;\n}\n.Toastify__bounce-enter--top-center {\n  animation-name: Toastify__bounceInDown;\n}\n.Toastify__bounce-enter--bottom-center {\n  animation-name: Toastify__bounceInUp;\n}\n\n.Toastify__bounce-exit--top-left, .Toastify__bounce-exit--bottom-left {\n  animation-name: Toastify__bounceOutLeft;\n}\n.Toastify__bounce-exit--top-right, .Toastify__bounce-exit--bottom-right {\n  animation-name: Toastify__bounceOutRight;\n}\n.Toastify__bounce-exit--top-center {\n  animation-name: Toastify__bounceOutUp;\n}\n.Toastify__bounce-exit--bottom-center {\n  animation-name: Toastify__bounceOutDown;\n}\n\n@keyframes Toastify__zoomIn {\n  from {\n    opacity: 0;\n    transform: scale3d(0.3, 0.3, 0.3);\n  }\n  50% {\n    opacity: 1;\n  }\n}\n@keyframes Toastify__zoomOut {\n  from {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0;\n    transform: scale3d(0.3, 0.3, 0.3);\n  }\n  to {\n    opacity: 0;\n  }\n}\n.Toastify__zoom-enter {\n  animation-name: Toastify__zoomIn;\n}\n\n.Toastify__zoom-exit {\n  animation-name: Toastify__zoomOut;\n}\n\n@keyframes Toastify__flipIn {\n  from {\n    transform: perspective(400px) rotate3d(1, 0, 0, 90deg);\n    animation-timing-function: ease-in;\n    opacity: 0;\n  }\n  40% {\n    transform: perspective(400px) rotate3d(1, 0, 0, -20deg);\n    animation-timing-function: ease-in;\n  }\n  60% {\n    transform: perspective(400px) rotate3d(1, 0, 0, 10deg);\n    opacity: 1;\n  }\n  80% {\n    transform: perspective(400px) rotate3d(1, 0, 0, -5deg);\n  }\n  to {\n    transform: perspective(400px);\n  }\n}\n@keyframes Toastify__flipOut {\n  from {\n    transform: perspective(400px);\n  }\n  30% {\n    transform: perspective(400px) rotate3d(1, 0, 0, -20deg);\n    opacity: 1;\n  }\n  to {\n    transform: perspective(400px) rotate3d(1, 0, 0, 90deg);\n    opacity: 0;\n  }\n}\n.Toastify__flip-enter {\n  animation-name: Toastify__flipIn;\n}\n\n.Toastify__flip-exit {\n  animation-name: Toastify__flipOut;\n}\n\n@keyframes Toastify__slideInRight {\n  from {\n    transform: translate3d(110%, 0, 0);\n    visibility: visible;\n  }\n  to {\n    transform: translate3d(0, 0, 0);\n  }\n}\n@keyframes Toastify__slideInLeft {\n  from {\n    transform: translate3d(-110%, 0, 0);\n    visibility: visible;\n  }\n  to {\n    transform: translate3d(0, 0, 0);\n  }\n}\n@keyframes Toastify__slideInUp {\n  from {\n    transform: translate3d(0, 110%, 0);\n    visibility: visible;\n  }\n  to {\n    transform: translate3d(0, 0, 0);\n  }\n}\n@keyframes Toastify__slideInDown {\n  from {\n    transform: translate3d(0, -110%, 0);\n    visibility: visible;\n  }\n  to {\n    transform: translate3d(0, 0, 0);\n  }\n}\n@keyframes Toastify__slideOutRight {\n  from {\n    transform: translate3d(0, 0, 0);\n  }\n  to {\n    visibility: hidden;\n    transform: translate3d(110%, 0, 0);\n  }\n}\n@keyframes Toastify__slideOutLeft {\n  from {\n    transform: translate3d(0, 0, 0);\n  }\n  to {\n    visibility: hidden;\n    transform: translate3d(-110%, 0, 0);\n  }\n}\n@keyframes Toastify__slideOutDown {\n  from {\n    transform: translate3d(0, 0, 0);\n  }\n  to {\n    visibility: hidden;\n    transform: translate3d(0, 500px, 0);\n  }\n}\n@keyframes Toastify__slideOutUp {\n  from {\n    transform: translate3d(0, 0, 0);\n  }\n  to {\n    visibility: hidden;\n    transform: translate3d(0, -500px, 0);\n  }\n}\n.Toastify__slide-enter--top-left, .Toastify__slide-enter--bottom-left {\n  animation-name: Toastify__slideInLeft;\n}\n.Toastify__slide-enter--top-right, .Toastify__slide-enter--bottom-right {\n  animation-name: Toastify__slideInRight;\n}\n.Toastify__slide-enter--top-center {\n  animation-name: Toastify__slideInDown;\n}\n.Toastify__slide-enter--bottom-center {\n  animation-name: Toastify__slideInUp;\n}\n\n.Toastify__slide-exit--top-left, .Toastify__slide-exit--bottom-left {\n  animation-name: Toastify__slideOutLeft;\n}\n.Toastify__slide-exit--top-right, .Toastify__slide-exit--bottom-right {\n  animation-name: Toastify__slideOutRight;\n}\n.Toastify__slide-exit--top-center {\n  animation-name: Toastify__slideOutUp;\n}\n.Toastify__slide-exit--bottom-center {\n  animation-name: Toastify__slideOutDown;\n}\n\n@keyframes Toastify__spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}";
styleInject(css_248z);

var useStyles$1 = makeStyles(function (theme) { return ({
    card: {
        width: '280px',
        minHeight: '100px',
        maxHeight: '150px',
        border: '5px solid #DC0028',
        '& .MuiCardContent-root': {
            padding: '0px 16px 0px 16px'
        }
    },
    header: {
        display: "flex",
        color: theme.palette.secondary.main,
        borderBottom: "1px solid #919191",
        padding: '12px 0px 8px 0px'
    },
    iconoCerrar: {
        color: "#505050", fontSize: "12px"
    },
    titulo: {
        flexGrow: 1,
        fontWeight: "bold",
        fontFamily: 'CO-Bold',
    },
    body: {
        display: "flex",
        flexDirection: "row",
        padding: '12px 0px 12px 0px'
    },
    textWrapper: {
        display: "flex",
        flexDirection: "column",
        color: theme.palette.secondary.main,
        fontSize: '14px'
    },
    iconoBombilla: {
        color: "#DC0028",
        fontSize: '48px',
        margin: '-4px 0px 0px -4px'
    },
    enlace: {
        color: '#DC0028',
        borderRadius: '0',
        textDecoration: 'underline',
        '&:hover': {
            color: '#b7788f',
        },
    }
}); });
var NotificacionCard = function (props) {
    var classes = useStyles$1(props);
    return (React__default.createElement(Card$1, { elevation: 0, className: props.className + ' ' + classes.card },
        React__default.createElement(CardContent$1, null,
            React__default.createElement("div", { className: classes.header },
                React__default.createElement("span", { className: classes.titulo }, props.titulo),
                React__default.createElement(IconCerrar, { className: classes.iconoCerrar, onClick: function (e) {
                        e.stopPropagation();
                        props.onClose && props.onClose();
                    } })),
            React__default.createElement("div", { className: classes.body },
                React__default.createElement(IconBombilla, { className: classes.iconoBombilla }),
                React__default.createElement("div", { className: classes.textWrapper },
                    React__default.createElement("div", null,
                        " ",
                        props.descripcion),
                    React__default.createElement(Enlace, { to: props.enlace, className: classes.enlace }, "Ver"))))));
};

//const envIsDev = process.env.NODE_ENV === 'development'
//const vapidKey = "BKn2BzW8rKZ0jzbn3lf126xqC-H6Cpl-IRAvGA7P_w38fy0HA-dV2PTBXgYpyP1g9FISIAq89IWLKEL1gDzeA-A";
var NotificacionesPushProvider = function (props) {
    var firebaseApp = initializeApp(props.config.options);
    var messaging = getMessagingInWindow(firebaseApp);
    var _a = useState(false), modalOpen = _a[0], setModalOpen = _a[1];
    var handleClose = function () {
        setModalOpen(false);
    };
    function requestPermission() {
        return __awaiter$2(this, void 0, void 0, function () {
            var supported, permission, newSw, suscription, token;
            return __generator$2(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, isWindowSupported()];
                    case 1:
                        supported = _a.sent();
                        console.log("supported", supported);
                        if (!supported) return [3 /*break*/, 8];
                        if (!(Notification.permission != "denied")) return [3 /*break*/, 8];
                        return [4 /*yield*/, Notification.requestPermission()];
                    case 2:
                        permission = _a.sent();
                        console.log("perm", permission);
                        if (!(permission === "granted")) return [3 /*break*/, 7];
                        return [4 /*yield*/, navigator.serviceWorker.register('/firebase-messaging-sw.js')];
                    case 3:
                        newSw = _a.sent();
                        console.log("newSw", newSw);
                        return [4 /*yield*/, newSw.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: props.config.options.vapidKey })];
                    case 4:
                        suscription = _a.sent();
                        console.log("susc", suscription);
                        return [4 /*yield*/, getToken(messaging, {
                                vapidKey: props.config.options.vapidKey,
                                serviceWorkerRegistration: newSw
                            })];
                    case 5:
                        token = _a.sent();
                        //We can send token to server
                        console.log("Token generated : ", token);
                        sessionStorage.setItem("fcm_token", token);
                        return [4 /*yield*/, api.post("/BE/push_add_disp/", { "Entrada": { "Token": token, "Aplicacion": props.config.push.app, "Cia": props.config.push.cia, "TipoDispositivo": "WEB" } })];
                    case 6:
                        _a.sent();
                        onMessage(messaging, function (payload) {
                            var _a, _b, _c;
                            console.log(payload);
                            var toastId = toast(React__default.createElement(NotificacionCard, { titulo: (_a = payload.notification) === null || _a === void 0 ? void 0 : _a.title, descripcion: (_b = payload.notification) === null || _b === void 0 ? void 0 : _b.body, enlace: (_c = payload.fcmOptions) === null || _c === void 0 ? void 0 : _c.link, onClose: function () { return toast.dismiss(toastId); } }), {
                                closeButton: false,
                                closeOnClick: false,
                                style: {
                                    padding: 0,
                                    border: "none",
                                    boxShadow: "none",
                                    background: "none",
                                },
                            });
                            //toast({ children: <div><b>{payload.notification?.title}</b><br />{payload.notification?.body}</div> });
                            //const notification = new Notification(payload.notification?.title ?? "", { body: payload.notification?.body, icon: payload.notification?.icon });
                            //console.log(notification);
                        });
                        return [3 /*break*/, 8];
                    case 7:
                        if (permission === "denied") {
                            //notifications are blocked
                            alert("You denied for the notification");
                        }
                        _a.label = 8;
                    case 8: return [2 /*return*/];
                }
            });
        });
    }
    useEffect(function () {
        setTimeout(function () {
            console.log("nots", Notification.permission);
            if (Notification.permission == "default") {
                setModalOpen(true);
            }
            else {
                requestPermission();
            }
        }, 50);
    }, []);
    return React__default.createElement(React__default.Fragment, null,
        props.children,
        ")",
        React__default.createElement(ToastContainer, { position: "top-right", theme: "light", autoClose: false, newestOnTop: true, closeOnClick: true, rtl: false, pauseOnFocusLoss: true, draggable: false }),
        React__default.createElement(CustomModal, { open: modalOpen, "aria-labelledby": "Permisos Notificaciones", "aria-describedby": "parent-modal-description", handleClose: handleClose },
            React__default.createElement(Box, { sx: { width: 400 } },
                React__default.createElement("h2", { id: "parent-modal-title" }, "Text in a modal"),
                React__default.createElement("p", { id: "parent-modal-description" }, "Duis mollis, est non commodo luctus, nisi erat porttitor ligula."),
                React__default.createElement(Button$1, { onClick: function () { setModalOpen(false); requestPermission(); } }, "Aceptar"))));
};

function Portal(props) {
    var _a, _b, _c, _d, _e, _f, _g;
    var app = (_b = (_a = process === null || process === void 0 ? void 0 : process.env) === null || _a === void 0 ? void 0 : _a.REACT_APP_NAME) !== null && _b !== void 0 ? _b : "-";
    var ver = (_d = (_c = process === null || process === void 0 ? void 0 : process.env) === null || _c === void 0 ? void 0 : _c.REACT_APP_VERSION) !== null && _d !== void 0 ? _d : "-";
    var _h = useState(null), user = _h[0], setUser = _h[1];
    var _j = useState(null), menu = _j[0], setMenu = _j[1];
    var _k = useState(null), menuIds = _k[0], setMenuIds = _k[1];
    var _l = useState(null), msal = _l[0], setMsal = _l[1];
    var _m = useState(null), contexto = _m[0], setContexto = _m[1];
    var _o = useState(null), mensaje = _o[0], setMensaje = _o[1];
    var _p = useState(0), paso = _p[0], setPaso = _p[1];
    var _q = useState(""), codigoUsuario = _q[0], setCodigoUsuario = _q[1];
    var _r = useState(""), nombreUsuario = _r[0], setNombreUsuario = _r[1];
    var _s = useState(""), dominio = _s[0], setDominio = _s[1];
    var _t = useState(""), ciaGestiona = _t[0], setCiaGestiona = _t[1];
    var _u = useState(false), mostrarSimulado = _u[0], setMostrarSimulado = _u[1];
    var _v = useState(true), mostrarBuscador = _v[0], setMostrarBuscador = _v[1];
    var _w = useState(true), mostrarMeInteresa = _w[0], setMostrarMeInteresa = _w[1];
    var _x = useState(true), mostrarConfigurarMiEspacio = _x[0], setMostrarConfigurarMiEspacio = _x[1];
    var _y = useState(true), mostrarEventos = _y[0], setMostrarEventos = _y[1];
    var _z = useState(false), mostrarEnlacePortalAntiguo = _z[0], setMostrarEnlacePortalAntiguo = _z[1];
    var _0 = useState(true), mostrarResultadosFinancieros = _0[0], setMostrarResultadosFinancieros = _0[1];
    var _1 = useState(false), mostrarGestionBuzon = _1[0], setMostrarGestionBuzon = _1[1];
    var _2 = useState(false), mostrarBotRRHHMenuEmpleados = _2[0], setMostrarBotRRHHMenuEmpleados = _2[1];
    var _3 = useState(false), mostrarBotVIDAFISCALMenuVidaSalud = _3[0], setMostrarBotVIDAFISCALMenuVidaSalud = _3[1];
    var _4 = useState(false), mostrarContactoDigital = _4[0], setMostrarContactoDigital = _4[1];
    var _5 = useState(false), mostrarBotLegalCorporativaMenuUtilidades = _5[0], setMostrarBotLegalCorporativaMenuUtilidades = _5[1];
    var _6 = useState(false), mostrarBotContactCenterMenu = _6[0], setMostrarBotContactCenterMenu = _6[1];
    var _7 = useState(false), mostrarUserCodeAppBarUser = _7[0], setMostrarUserCodeAppBarUser = _7[1];
    var _8 = useState(false), deshabilitarMSAL = _8[0], setDeshabilitarMSAL = _8[1];
    var session = useState(guid.Guid.raw())[0];
    var useStyles = makeStyles({
        gcoSimUsu: {
            paddingBottom: "38px",
            '@media screen and (max-width: 767px)': {
                paddingBottom: "56px",
            },
            '&:before': {
                content: "''",
                border: "5px solid #35516d",
                position: "fixed",
                width: "100vw",
                height: "100vh",
                left: "0px",
                top: "0px",
                boxSizing: "border-box",
                zIndex: "10000",
                display: "inherit",
                pointerEvents: "none",
            }
        },
        gcoSimMensaje: {
            color: "#fff",
            fontSize: "14px",
            backgroundColor: "#35516d",
            position: "fixed",
            bottom: "0px",
            width: "100%",
            paddingTop: "10px",
            paddingBottom: "10px",
            textAlign: "center",
            zIndex: 9999,
            '& a ': {
                color: "#fff",
                textDecoration: "underline",
                '&:hover': {
                    opacity: "0.8",
                }
            }
        }
    });
    var theme = createTheme({
        palette: {
            primary: {
                main: "#DC0028"
            },
            secondary: {
                main: "#505050",
                dark: "#333"
            },
        },
        typography: {
            fontFamily: "Catalana-sans, Arial, sans-serif",
            button: {
                textTransform: 'none',
                "case": 'sentence'
            },
            h1: {
                fontFamily: "CO-Medium",
            },
            h2: {
                fontFamily: "CO-Medium",
            },
            h3: {
                fontFamily: "CO-Medium",
            },
            h4: {
                fontFamily: "CO-Medium",
            },
            h5: {
                fontFamily: "CO-Medium",
            },
            h6: {
                fontFamily: "CO-Medium",
                fontSize: "1.1rem"
            }
        },
        overrides: {
            MuiButton: {
                root: {
                    textTransform: 'none'
                }
            },
            MuiTooltip: {
                tooltip: {
                    color: "#505050",
                    backgroundColor: "#fff",
                    border: "1px solid #505050",
                    fontSize: "12px",
                    fontFamily: "Catalana-sans",
                    borderRadius: "0px",
                }
            }
        },
        gcoPalette: {
            primary: '#D90028',
            neutral: {
                'neutral-01': '#ffffff',
                'neutral-02': '#F4F4F4',
                'neutral-03': '#D6D8D8',
                'neutral-04': '#919191',
                'neutral-05': '#505050',
                'neutral-06': '#000000',
            },
            terciary: {
                'terciary-01': '#E87E61',
                'terciary-02': '#B59492',
                'terciary-03': '#B36561',
                'terciary-04': '#B9B2A5',
                'terciary-05': '#F9C5B6',
                'terciary-06': '#E77387',
                'terciary-07': '#8C8C8C',
                'terciary-08': '#E3C07B',
                'terciary-09': '#C7C7C7'
            },
            priority: {
                high: '#B91E1E',
                medium: '#D17F32',
                low: '#3D7417'
            },
            alerts: {
                'info': '#5B5C43',
                'info-bg': '#E0DFCE',
                'success': '#3D7417',
                'success-bg': '#E6EFD8',
                'error': '#B91E1E',
                'error-bg': '#F1D4D4',
                'warning': '#AA4813',
                'warning-text': '#FFE7CA'
            }
        }
    });
    var instance = useMsal$1().instance;
    function parseQuery() {
        var queryString = window.location.search;
        var query = {};
        var pairs = (queryString[0] === '?' ? queryString.substr(1) : queryString).split('&');
        for (var i = 0; i < pairs.length; i++) {
            var pair = pairs[i].split('=');
            query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '');
        }
        return query;
    }
    var getUser = function () {
        try {
            var noredirect = false;
            if (window.location.search.indexOf("opt=noredir") > 0) {
                noredirect = true;
                document.cookie = "PortalNoRedirect=true;Domain=.gco.global;Path=/;Expires=Fri, 31 Dec 9999 23:59:59 GMT";
            }
            else {
                noredirect = (document.cookie.indexOf("PortalNoRedirect=true") >= 0);
            }
            api.makeLogin("/user/", noredirect).then(function (x) {
                if (x != null || x != undefined) {
                    if (x.Retorno != null && x.Retorno.Codigo !== 0) {
                        setMensaje({
                            titulo: "Error de acceso",
                            subtitulo: x.Retorno.Descripcion,
                            tipo: "error"
                        });
                    }
                    else if (x.Salida != null) {
                        var query = parseQuery();
                        var url = "/ctx/";
                        if (query["_cia"]) {
                            url = url + query["_cia"];
                        }
                        var contexto_1 = getBackendContext();
                        setContexto(contexto_1.Propiedades);
                        var ciaGestiona_1 = x.Salida.CiaGestiona;
                        var mostrar = x.Salida.MostrarSimulado;
                        var mostrarBuscador_1 = x.Salida.MostrarBuscador;
                        var mostrarMeInteresa_1 = x.Salida.MostrarMeInteresa;
                        var mostrarConfigurarMiEspacio_1 = x.Salida.MostrarConfigurarMiEspacio;
                        var mostrarEventos_1 = x.Salida.MostrarEventos;
                        var mostrarEnlacePortalAntiguo_1 = x.Salida.MostrarEnlacePortalAntiguo;
                        var mostrarResultadosFinancieros_1 = x.Salida.MostrarResultadosFinancieros;
                        var mostrarGestionBuzon_1 = x.Salida.MostrarGestionBuzon;
                        var mostrarBotRRHHMenuEmpleados_1 = x.Salida.MostrarBotRRHHMenuEmpleados ? x.Salida.MostrarBotRRHHMenuEmpleados : false;
                        var mostrarBotVIDAFISCALMenuVidaSalud_1 = x.Salida.MostrarBotVIDAFISCALMenuVidaSalud ? x.Salida.MostrarBotVIDAFISCALMenuVidaSalud : false;
                        var mostrarContactoDigital_1 = x.Salida.MostrarContactoDigital ? x.Salida.MostrarContactoDigital : false;
                        var mostrarBotLegalCorporativaMenuUtilidades_1 = x.Salida.MostrarBotLegalCorporativaMenuUtilidades ? x.Salida.MostrarBotLegalCorporativaMenuUtilidades : false;
                        var mostrarBotContactCenterMenu_1 = x.Salida.MostrarBotContactCenterMenu ? x.Salida.MostrarBotContactCenterMenu : false;
                        var mostrarUserCodeAppBarUser_1 = x.Salida.MostrarUserCodeAppBarUser ? x.Salida.MostrarUserCodeAppBarUser : false;
                        var usuario = x.Salida.usuario;
                        usuario.admin = x.Salida.Admin;
                        var codUsuario = x.Salida.CodigoUsuario;
                        var nomUsuario = x.Salida.NombreUsuario;
                        var dom = x.Salida.Dominio;
                        var noMSAL = x.Salida.DeshabilitarMSAL;
                        var simulatedUser = {
                            codigoUsuario: codUsuario,
                            deshabilitarMSAL: noMSAL,
                            dominio: dom,
                            mostrarSimulado: mostrar,
                            nombreUsuario: nomUsuario
                        };
                        usuario = __assign$2(__assign$2({}, usuario), { simulatedUser: simulatedUser });
                        setUser(usuario);
                        setCodigoUsuario(codUsuario);
                        setNombreUsuario(nomUsuario);
                        setDominio(dom);
                        setMostrarSimulado(mostrar);
                        setMostrarBuscador(mostrarBuscador_1);
                        setMostrarMeInteresa(mostrarMeInteresa_1);
                        setMostrarConfigurarMiEspacio(mostrarConfigurarMiEspacio_1);
                        setMostrarEventos(mostrarEventos_1);
                        setMostrarEnlacePortalAntiguo(mostrarEnlacePortalAntiguo_1);
                        setMostrarResultadosFinancieros(mostrarResultadosFinancieros_1);
                        setMostrarGestionBuzon(mostrarGestionBuzon_1);
                        setMostrarBotRRHHMenuEmpleados(mostrarBotRRHHMenuEmpleados_1);
                        setMostrarBotVIDAFISCALMenuVidaSalud(mostrarBotVIDAFISCALMenuVidaSalud_1);
                        setMostrarContactoDigital(mostrarContactoDigital_1);
                        setMostrarBotLegalCorporativaMenuUtilidades(mostrarBotLegalCorporativaMenuUtilidades_1);
                        setMostrarBotContactCenterMenu(mostrarBotContactCenterMenu_1);
                        setMostrarUserCodeAppBarUser(mostrarUserCodeAppBarUser_1);
                        setDeshabilitarMSAL(noMSAL);
                        setCiaGestiona(ciaGestiona_1);
                        if (x.Salida.UrlRedireccion) {
                            window.location = x.Salida.UrlRedireccion;
                            setMensaje({
                                titulo: "Redirección",
                                subtitulo: React__default.createElement("div", null,
                                    React__default.createElement("p", null,
                                        "Se va a redirigir a ",
                                        x.Salida.UrlRedireccion,
                                        ", si no se realiza la redirecci\u00F3n:"),
                                    React__default.createElement("p", null,
                                        React__default.createElement("a", { href: x.Salida.UrlRedireccion }, "Pulsa aqu\u00ED para continuar"))),
                                tipo: "error"
                            });
                        }
                        else {
                            if (usuario == null || usuario.portal == null || usuario.portal == "") { //Cambiar por distinto de para ver el mensaje de alerta usuario.user.substr(usuario.user.indexOf("\\")+1)
                                setMensaje({
                                    titulo: "No se puede acceder al portal con este usuario " + usuario.user.substr(usuario.user.indexOf("\\") + 1),
                                    subtitulo: "Ponte en contacto con soporte",
                                    tipo: "error"
                                });
                            }
                            else {
                                setPaso(paso + 1);
                            }
                        }
                    }
                }
                else {
                    setUser({});
                    setMensaje({
                        titulo: "No existen datos disponibles",
                        subtitulo: "Ponte en contacto con soporte",
                        tipo: "error"
                    });
                }
            })["catch"](function () {
                setUser({});
                setMensaje({
                    titulo: "Se ha producido un error al recuperar el perfil del usuario",
                    subtitulo: "Si el problema persiste ponte en contacto con soporte",
                    tipo: "error"
                });
            });
        }
        catch (error) {
            console.log(error);
            setUser({});
            setMensaje({
                titulo: "No existen datos disponibles",
                subtitulo: "Ponte en contacto con soporte",
                tipo: "error"
            });
        }
    };
    var setMsalToken = function (msalToken) {
        setMsal(msalToken);
        var cookie = "MSAL_TOK=" + msalToken + "; domain=.gco.global; path=/MeInteresa";
        document.cookie = cookie;
    };
    var getMSAL = function () {
        if (!props.msal || deshabilitarMSAL) {
            setPaso(paso + 1);
        }
        else {
            var domain = "";
            if ((user === null || user === void 0 ? void 0 : user.upn) != null) {
                var iarroba = user.upn.indexOf("@");
                if (iarroba)
                    domain = user.upn.substring(iarroba + 1);
            }
            var silentRequest_1 = { account: instance.getAllAccounts()[0], scopes: loginRequest.scopes, loginHint: user.upn, domainHint: domain, extraQueryParameters: { login_hint: user.upn, domain_hint: domain } };
            instance.acquireTokenSilent(silentRequest_1).then(function (accessTokenResponse) {
                setMsalToken(accessTokenResponse.accessToken);
                setPaso(paso + 1);
            })["catch"](function () {
                //Acquire token silent failure, and send an interactive request
                setMensaje({
                    titulo: "Verificando usuario, espera un momento...",
                    subtitulo: "Finaliza la verificación en la pantalla emergente.",
                    tipo: "info"
                });
                instance.acquireTokenPopup(silentRequest_1).then(function (accessTokenResponse) {
                    // Acquire token interactive success
                    setMensaje(null);
                    setMsalToken(accessTokenResponse.accessToken);
                    setPaso(paso + 1);
                })["catch"](function (error) {
                    // Acquire token interactive failure
                    if (error.errorCode === "popup_window_error") {
                        setMensaje({
                            titulo: "El navegador ha bloqueado la ventana de verificación de usuario",
                            subtitulo: React__default.createElement("div", null,
                                React__default.createElement("p", null, "Aseg\u00FArate de no tener las ventanas emergentes bloqueadas y vuelve a intentarlo. Es necesario finalizar la verificaci\u00F3n para poder acceder a todas las funciones."),
                                React__default.createElement("p", null,
                                    React__default.createElement(Link$1, { onClick: function () { setPaso(paso + 1); setMensaje(null); } }, "Pulsa aqu\u00ED para continuar sin verificar"))),
                            tipo: "error"
                        });
                    }
                    else {
                        setMensaje({
                            titulo: "Ha ocurrido un error al verificar el usuario",
                            subtitulo: React__default.createElement("div", null,
                                React__default.createElement("p", null, "Es necesario finalizar la verificaci\u00F3n para poder acceder a todas las funciones."),
                                React__default.createElement("p", null,
                                    React__default.createElement(Link$1, { onClick: function () { setPaso(paso + 1); setMensaje(null); } }, "Pulsa aqu\u00ED para continuar sin verificar"))),
                            tipo: "error"
                        });
                    }
                });
            });
        }
    };
    var hasMultipleInstances = function (enlace, enlaces) {
        var found = false;
        var title = enlace.origen === "" ? enlace.titulo : enlace.titulo.replace(" " + enlace.origen, "");
        enlaces.forEach(function (item) {
            var titulo = item.origen === "" ? item.titulo : item.titulo.replace(" " + item.origen, "");
            if (item.url != enlace.url && titulo == title)
                found = true;
        });
        return found;
    };
    var simplificarCIA = function (titulo) {
        titulo = titulo.replaceAll("SPU", "PU");
        titulo = titulo.replaceAll("SBI", "SB");
        return titulo;
    };
    var getGroupParent = function (enlace) {
        if (enlace.origen == "")
            return enlace.titulo;
        return enlace.titulo.replace(" " + enlace.origen, "");
    };
    var groupMenuMultiCIA = function (enlaces) {
        var puntosMenu = [];
        var puntosCreados = [];
        enlaces.forEach(function (item) {
            var _a, _b;
            var puntoMenu = __assign$2(__assign$2({}, item), { titulo: simplificarCIA(item.titulo) });
            if (hasMultipleInstances(item, enlaces)) {
                if (puntosCreados.indexOf(getGroupParent(item)) == -1) {
                    var titulo = getGroupParent(item);
                    puntosMenu.push({
                        "id": titulo + "agrupado",
                        "url": "/" + titulo.replaceAll(" ", "").normalize("NFD").replace(/[\u0300-\u036f]/g, "") + "agrupado",
                        "titulo": titulo,
                        "plantilla": "GCONAV",
                        "tipo": "",
                        "origen": "GRUPO",
                        "urlApp": "",
                        "oculto": false,
                        "popup": false,
                        "enlaces": [],
                        "icono": ""
                    });
                    puntosCreados.push(titulo);
                    var punto = puntosMenu[puntosMenu.length - 1];
                    (_a = punto === null || punto === void 0 ? void 0 : punto.enlaces) === null || _a === void 0 ? void 0 : _a.push(puntoMenu);
                }
                else {
                    var punto = puntosMenu[puntosMenu.length - 1];
                    (_b = punto === null || punto === void 0 ? void 0 : punto.enlaces) === null || _b === void 0 ? void 0 : _b.push(puntoMenu);
                }
            }
            else {
                puntosMenu.push(puntoMenu);
            }
        });
        return puntosMenu;
    };
    var getMenu = function () {
        if (typeof props.menuSvc == "string") {
            var cia = getCiaFromUrl();
            var aplicacion = getAplicacionFromUrl();
            if (codigoUsuario != null && codigoUsuario != "" && codigoUsuario !== undefined) {
                api.post(props.menuSvc + dominio + "/" + codigoUsuario, { app: aplicacion + cia }).then(function (x) {
                    if (esGestiona()) {
                        x = groupMenuMultiCIA(x.enlaces);
                        // console.log({enlaces: x})
                        setMenu({ enlaces: x });
                    }
                    else
                        setMenu(x);
                    setPaso(-1);
                })["catch"](function (error) {
                    api.traceError(session, props.menuSvc + dominio + "/" + codigoUsuario, error.message, error.stack.replaceAll("\n", ""), app, ver, getAplicacionFromUrl(), getCiaFromUrl());
                    setMensaje({
                        titulo: "No se ha podido recuperar el menú del usuario " + nombreUsuario,
                        subtitulo: "Ponte en contacto con soporte",
                        tipo: "error"
                    });
                });
            }
            else {
                api.post(props.menuSvc, { app: aplicacion + cia }).then(function (x) {
                    var _a;
                    var qs = new URLSearchParams(window.location.search);
                    if (window.location.pathname.toLowerCase().startsWith("/aplicacion") && window.location.search.indexOf("marco=false") > 0) {
                        var menuOption = { titulo: "Aplicación", tipo: (_a = qs.get("aplicacion")) !== null && _a !== void 0 ? _a : qs.get("Aplicacion"), urlApp: menuHelper.getUrlTransaccion(window.location.search), plantilla: "GCOAPP" };
                        var url = menuHelper.getUrl(menuOption);
                        window.location.href = url;
                    }
                    else {
                        if (esGestiona()) {
                            x = groupMenuMultiCIA(x.enlaces);
                            // console.log({enlaces: x})
                            setMenu({ enlaces: x });
                        }
                        else
                            setMenu(x);
                        setPaso(-1);
                    }
                }, function (error) {
                    api.traceError(session, props.menuSvc, error.message, error.stack.replaceAll("\n", ""), app, ver, getAplicacionFromUrl(), getCiaFromUrl());
                    setMensaje({
                        titulo: "Se ha producido un error al recuperar el menú del portal para el usuario " + codigoUsuario,
                        subtitulo: "Si el problema persiste, ponte en contacto con soporte",
                        tipo: "error"
                    });
                });
            }
        }
        else {
            var x = props.menuSvc;
            if (esGestiona() && x) {
                x = groupMenuMultiCIA(x);
                // console.log({enlaces: x})
                setMenu({ enlaces: x });
            }
            setPaso(-1);
        }
    };
    React__default.useEffect(function () {
        setMenuIds(menuHelper.buildMenuDictionary(menu));
    }, [menu]);
    React__default.useEffect(function () {
        switch (paso) {
            case 0:
                getUser();
                break;
            case 1:
                getMSAL();
                break;
            case 2:
                getMenu();
                break;
        }
    }, [paso]);
    var msalAccount = msal != null ? instance.getAllAccounts()[0] : undefined;
    var layout = props.firebase ?
        React__default.createElement(NotificacionesPushProvider, { config: props.firebase },
            React__default.createElement(PortalLayout, __assign$2({}, props, { mostrarSimulado: mostrarSimulado, mostrarBuscador: mostrarBuscador, session: session, mostrarBotRRHHMenuEmpleados: mostrarBotRRHHMenuEmpleados, mostrarBotVIDAFISCALMenuVidaSalud: mostrarBotVIDAFISCALMenuVidaSalud, mostrarContactoDigital: mostrarContactoDigital, mostrarBotLegalCorporativaMenuUtilidades: mostrarBotLegalCorporativaMenuUtilidades, mostrarBotContactCenterMenu: mostrarBotContactCenterMenu })))
        :
            React__default.createElement(PortalLayout, __assign$2({}, props, { mostrarSimulado: mostrarSimulado, mostrarBuscador: mostrarBuscador, session: session, mostrarBotRRHHMenuEmpleados: mostrarBotRRHHMenuEmpleados, mostrarBotVIDAFISCALMenuVidaSalud: mostrarBotVIDAFISCALMenuVidaSalud, mostrarContactoDigital: mostrarContactoDigital, mostrarBotLegalCorporativaMenuUtilidades: mostrarBotLegalCorporativaMenuUtilidades, mostrarBotContactCenterMenu: mostrarBotContactCenterMenu }));
    var classes = useStyles();
    return (React__default.createElement("div", { className: "App" },
        React__default.createElement(BrowserRouter, null,
            React__default.createElement(ScrollToTop$1, null,
                React__default.createElement(ThemeProvider, { theme: theme }, paso >= 0 ?
                    React__default.createElement(PortalSplash, { titulo: props.title, mensaje: mensaje })
                    :
                        React__default.createElement(PortalContext.Provider, { value: {
                                user: user, menu: menu,
                                cia: (_e = props.cia) !== null && _e !== void 0 ? _e : null,
                                session: session,
                                app: { name: props.title, package: (_f = process === null || process === void 0 ? void 0 : process.env) === null || _f === void 0 ? void 0 : _f.REACT_APP_NAME, version: (_g = process === null || process === void 0 ? void 0 : process.env) === null || _g === void 0 ? void 0 : _g.REACT_APP_VERSION },
                                msal: msal,
                                msalAccount: msalAccount,
                                contexto: contexto,
                                historial: props.historial,
                                menuIds: menuIds,
                                mostrarMeInteresa: mostrarMeInteresa,
                                mostrarConfigurarMiEspacio: mostrarConfigurarMiEspacio,
                                mostrarEventos: mostrarEventos,
                                mostrarEnlacePortalAntiguo: mostrarEnlacePortalAntiguo,
                                mostrarResultadosFinancieros: mostrarResultadosFinancieros,
                                mostrarGestionBuzon: mostrarGestionBuzon,
                                mostrarUserCodeAppBarUser: mostrarUserCodeAppBarUser,
                                ciaGestiona: ciaGestiona
                            } }, codigoUsuario ?
                            React__default.createElement("div", { className: classes.gcoSimUsu },
                                React__default.createElement("div", { className: classes.gcoSimMensaje },
                                    " Sesi\u00F3n iniciada con los permisos de ",
                                    React__default.createElement("strong", null, nombreUsuario),
                                    ". Para desconectarse pulse ",
                                    React__default.createElement(Enlace, { to: "/aplicacion/?aplicacion=AplicacionesSCO&urlTransaccion=FE/TPG.Seguridad.Web.FE.Tssu/" }, "aqu\u00ED")),
                                layout)
                            :
                                [layout]))))));
}

var msalInstance = new PublicClientApplication(getMsalConfig());
// Account selection logic is app dependent. Adjust as needed for different use cases.
var accounts = msalInstance.getAllAccounts();
if (accounts.length > 0) {
    msalInstance.setActiveAccount(accounts[0]);
}
msalInstance.addEventCallback(function (event) {
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
        var payload = event.payload;
        var account = payload.account;
        msalInstance.setActiveAccount(account);
    }
});
function PortalMsal(props) {
    return (React__default.createElement(MsalProvider, { instance: msalInstance },
        React__default.createElement(Portal, __assign$2({}, props, { msal: true }))));
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function usePagination() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  // keep default values in sync with @default tags in Pagination.propTypes
  var _props$boundaryCount = props.boundaryCount,
      boundaryCount = _props$boundaryCount === void 0 ? 1 : _props$boundaryCount,
      _props$componentName = props.componentName,
      componentName = _props$componentName === void 0 ? 'usePagination' : _props$componentName,
      _props$count = props.count,
      count = _props$count === void 0 ? 1 : _props$count,
      _props$defaultPage = props.defaultPage,
      defaultPage = _props$defaultPage === void 0 ? 1 : _props$defaultPage,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$hideNextButton = props.hideNextButton,
      hideNextButton = _props$hideNextButton === void 0 ? false : _props$hideNextButton,
      _props$hidePrevButton = props.hidePrevButton,
      hidePrevButton = _props$hidePrevButton === void 0 ? false : _props$hidePrevButton,
      handleChange = props.onChange,
      pageProp = props.page,
      _props$showFirstButto = props.showFirstButton,
      showFirstButton = _props$showFirstButto === void 0 ? false : _props$showFirstButto,
      _props$showLastButton = props.showLastButton,
      showLastButton = _props$showLastButton === void 0 ? false : _props$showLastButton,
      _props$siblingCount = props.siblingCount,
      siblingCount = _props$siblingCount === void 0 ? 1 : _props$siblingCount,
      other = _objectWithoutProperties(props, ["boundaryCount", "componentName", "count", "defaultPage", "disabled", "hideNextButton", "hidePrevButton", "onChange", "page", "showFirstButton", "showLastButton", "siblingCount"]);

  var _useControlled = useControlled({
    controlled: pageProp,
    default: defaultPage,
    name: componentName,
    state: 'page'
  }),
      _useControlled2 = _slicedToArray(_useControlled, 2),
      page = _useControlled2[0],
      setPageState = _useControlled2[1];

  var handleClick = function handleClick(event, value) {
    if (!pageProp) {
      setPageState(value);
    }

    if (handleChange) {
      handleChange(event, value);
    }
  }; // https://dev.to/namirsab/comment/2050


  var range = function range(start, end) {
    var length = end - start + 1;
    return Array.from({
      length: length
    }, function (_, i) {
      return start + i;
    });
  };

  var startPages = range(1, Math.min(boundaryCount, count));
  var endPages = range(Math.max(count - boundaryCount + 1, boundaryCount + 1), count);
  var siblingsStart = Math.max(Math.min( // Natural start
  page - siblingCount, // Lower boundary when page is high
  count - boundaryCount - siblingCount * 2 - 1), // Greater than startPages
  boundaryCount + 2);
  var siblingsEnd = Math.min(Math.max( // Natural end
  page + siblingCount, // Upper boundary when page is low
  boundaryCount + siblingCount * 2 + 2), // Less than endPages
  endPages[0] - 2); // Basic list of items to render
  // e.g. itemList = ['first', 'previous', 1, 'ellipsis', 4, 5, 6, 'ellipsis', 10, 'next', 'last']

  var itemList = [].concat(_toConsumableArray(showFirstButton ? ['first'] : []), _toConsumableArray(hidePrevButton ? [] : ['previous']), _toConsumableArray(startPages), _toConsumableArray(siblingsStart > boundaryCount + 2 ? ['start-ellipsis'] : boundaryCount + 1 < count - boundaryCount ? [boundaryCount + 1] : []), _toConsumableArray(range(siblingsStart, siblingsEnd)), _toConsumableArray(siblingsEnd < count - boundaryCount - 1 ? ['end-ellipsis'] : count - boundaryCount > boundaryCount ? [count - boundaryCount] : []), _toConsumableArray(endPages), _toConsumableArray(hideNextButton ? [] : ['next']), _toConsumableArray(showLastButton ? ['last'] : [])); // Map the button type to its page number

  var buttonPage = function buttonPage(type) {
    switch (type) {
      case 'first':
        return 1;

      case 'previous':
        return page - 1;

      case 'next':
        return page + 1;

      case 'last':
        return count;

      default:
        return null;
    }
  }; // Convert the basic item list to PaginationItem props objects


  var items = itemList.map(function (item) {
    return typeof item === 'number' ? {
      onClick: function onClick(event) {
        handleClick(event, item);
      },
      type: 'page',
      page: item,
      selected: item === page,
      disabled: disabled,
      'aria-current': item === page ? 'true' : undefined
    } : {
      onClick: function onClick(event) {
        handleClick(event, buttonPage(item));
      },
      type: item,
      page: buttonPage(item),
      selected: false,
      disabled: disabled || item.indexOf('ellipsis') === -1 && (item === 'next' || item === 'last' ? page >= count : page <= 1)
    };
  });
  return _extends({
    items: items
  }, other);
}

/**
 * @ignore - internal component.
 */

var FirstPageIcon = createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z"
}), 'FirstPage');

/**
 * @ignore - internal component.
 */

var LastPageIcon = createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z"
}), 'LastPage');

/**
 * @ignore - internal component.
 */

var NavigateBeforeIcon = createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
}), 'NavigateBefore');

/**
 * @ignore - internal component.
 */

var NavigateNextIcon = createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}), 'NavigateNext');

var styles$1 = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: _extends({}, theme.typography.body2, {
      borderRadius: 32 / 2,
      textAlign: 'center',
      boxSizing: 'border-box',
      minWidth: 32,
      height: 32,
      padding: '0 6px',
      margin: '0 3px',
      color: theme.palette.text.primary
    }),

    /* Styles applied to the root element if `type="page"`. */
    page: {
      transition: theme.transitions.create(['color', 'background-color'], {
        duration: theme.transitions.duration.short
      }),
      '&:hover': {
        backgroundColor: theme.palette.action.hover,
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      },
      '&$focusVisible': {
        backgroundColor: theme.palette.action.focus
      },
      '&$selected': {
        backgroundColor: theme.palette.action.selected,
        '&:hover, &$focusVisible': {
          backgroundColor: alpha$1(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
          // Reset on touch devices, it doesn't add specificity
          '@media (hover: none)': {
            backgroundColor: theme.palette.action.selected
          }
        },
        '&$disabled': {
          opacity: 1,
          color: theme.palette.action.disabled,
          backgroundColor: theme.palette.action.selected
        }
      },
      '&$disabled': {
        opacity: theme.palette.action.disabledOpacity
      }
    },

    /* Styles applied applied to the root element if `size="small"`. */
    sizeSmall: {
      minWidth: 26,
      height: 26,
      borderRadius: 26 / 2,
      margin: '0 1px',
      padding: '0 4px',
      '& $icon': {
        fontSize: theme.typography.pxToRem(18)
      }
    },

    /* Styles applied applied to the root element if `size="large"`. */
    sizeLarge: {
      minWidth: 40,
      height: 40,
      borderRadius: 40 / 2,
      padding: '0 10px',
      fontSize: theme.typography.pxToRem(15),
      '& $icon': {
        fontSize: theme.typography.pxToRem(22)
      }
    },

    /* Styles applied to the root element if `variant="text"` and `color="primary"`. */
    textPrimary: {
      '&$selected': {
        color: theme.palette.primary.contrastText,
        backgroundColor: theme.palette.primary.main,
        '&:hover, &$focusVisible': {
          backgroundColor: theme.palette.primary.dark,
          // Reset on touch devices, it doesn't add specificity
          '@media (hover: none)': {
            backgroundColor: theme.palette.primary.main
          }
        },
        '&$disabled': {
          color: theme.palette.action.disabled
        }
      }
    },

    /* Styles applied to the root element if `variant="text"` and `color="secondary"`. */
    textSecondary: {
      '&$selected': {
        color: theme.palette.secondary.contrastText,
        backgroundColor: theme.palette.secondary.main,
        '&:hover, &$focusVisible': {
          backgroundColor: theme.palette.secondary.dark,
          // Reset on touch devices, it doesn't add specificity
          '@media (hover: none)': {
            backgroundColor: theme.palette.secondary.main
          }
        },
        '&$disabled': {
          color: theme.palette.action.disabled
        }
      }
    },

    /* Styles applied to the root element if `outlined="true"`. */
    outlined: {
      border: "1px solid ".concat(theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)'),
      '&$selected': {
        '&$disabled': {
          border: "1px solid ".concat(theme.palette.action.disabledBackground)
        }
      }
    },

    /* Styles applied to the root element if `variant="outlined"` and `color="primary"`. */
    outlinedPrimary: {
      '&$selected': {
        color: theme.palette.primary.main,
        border: "1px solid ".concat(alpha$1(theme.palette.primary.main, 0.5)),
        backgroundColor: alpha$1(theme.palette.primary.main, theme.palette.action.activatedOpacity),
        '&:hover, &$focusVisible': {
          backgroundColor: alpha$1(theme.palette.primary.main, theme.palette.action.activatedOpacity + theme.palette.action.hoverOpacity),
          // Reset on touch devices, it doesn't add specificity
          '@media (hover: none)': {
            backgroundColor: 'transparent'
          }
        },
        '&$disabled': {
          color: theme.palette.action.disabled
        }
      }
    },

    /* Styles applied to the root element if `variant="outlined"` and `color="secondary"`. */
    outlinedSecondary: {
      '&$selected': {
        color: theme.palette.secondary.main,
        border: "1px solid ".concat(alpha$1(theme.palette.secondary.main, 0.5)),
        backgroundColor: alpha$1(theme.palette.secondary.main, theme.palette.action.activatedOpacity),
        '&:hover, &$focusVisible': {
          backgroundColor: alpha$1(theme.palette.secondary.main, theme.palette.action.activatedOpacity + theme.palette.action.hoverOpacity),
          // Reset on touch devices, it doesn't add specificity
          '@media (hover: none)': {
            backgroundColor: 'transparent'
          }
        },
        '&$disabled': {
          color: theme.palette.action.disabled
        }
      }
    },

    /* Styles applied to the root element if `rounded="true"`. */
    rounded: {
      borderRadius: theme.shape.borderRadius
    },

    /* Styles applied to the root element if `type="start-ellipsis"` or `type="end-ellipsis"`. */
    ellipsis: {
      height: 'auto',
      '&$disabled': {
        opacity: theme.palette.action.disabledOpacity
      }
    },

    /* Pseudo-class applied to the root element if keyboard focused. */
    focusVisible: {},

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Pseudo-class applied to the root element if `selected={true}`. */
    selected: {},

    /* Styles applied to the icon element. */
    icon: {
      fontSize: theme.typography.pxToRem(20),
      margin: '0 -8px'
    }
  };
};
var PaginationItem = /*#__PURE__*/React.forwardRef(function PaginationItem(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'standard' : _props$color,
      component = props.component,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      page = props.page,
      _props$selected = props.selected,
      selected = _props$selected === void 0 ? false : _props$selected,
      _props$shape = props.shape,
      shape = _props$shape === void 0 ? 'round' : _props$shape,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      _props$type = props.type,
      type = _props$type === void 0 ? 'page' : _props$type,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'text' : _props$variant,
      other = _objectWithoutProperties(props, ["classes", "className", "color", "component", "disabled", "page", "selected", "shape", "size", "type", "variant"]);

  var theme = useTheme();
  var normalizedIcons = theme.direction === 'rtl' ? {
    previous: NavigateNextIcon,
    next: NavigateBeforeIcon,
    last: FirstPageIcon,
    first: LastPageIcon
  } : {
    previous: NavigateBeforeIcon,
    next: NavigateNextIcon,
    first: FirstPageIcon,
    last: LastPageIcon
  };
  var Icon = normalizedIcons[type];
  return type === 'start-ellipsis' || type === 'end-ellipsis' ? /*#__PURE__*/React.createElement("div", {
    ref: ref,
    className: clsx(classes.root, classes.ellipsis, disabled && classes.disabled, size !== 'medium' && classes["size".concat(capitalize(size))])
  }, "\u2026") : /*#__PURE__*/React.createElement(ButtonBase, _extends({
    ref: ref,
    component: component,
    disabled: disabled,
    focusVisibleClassName: classes.focusVisible,
    className: clsx(classes.root, classes.page, classes[variant], classes[shape], className, color !== 'standard' && classes["".concat(variant).concat(capitalize(color))], disabled && classes.disabled, selected && classes.selected, size !== 'medium' && classes["size".concat(capitalize(size))])
  }, other), type === 'page' && page, Icon ? /*#__PURE__*/React.createElement(Icon, {
    className: classes.icon
  }) : null);
});
process.env.NODE_ENV !== "production" ? PaginationItem.propTypes = {
  /**
   * @ignore
   */
  classes: propTypes.object.isRequired,

  /**
   * @ignore
   */
  className: propTypes.string,

  /**
   * The active color.
   */
  color: propTypes.oneOf(['standard', 'primary', 'secondary']),

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: propTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * If `true`, the item will be disabled.
   */
  disabled: propTypes.bool,

  /**
   * The current page number.
   */
  page: propTypes.number,

  /**
   * If `true` the pagination item is selected.
   */
  selected: propTypes.bool,

  /**
   * The shape of the pagination item.
   */
  shape: propTypes.oneOf(['round', 'rounded']),

  /**
   * The size of the pagination item.
   */
  size: propTypes.oneOf(['small', 'medium', 'large']),

  /**
   * The type of pagination item.
   */
  type: propTypes.oneOf(['page', 'first', 'last', 'next', 'previous', 'start-ellipsis', 'end-ellipsis']),

  /**
   * The pagination item variant.
   */
  variant: propTypes.oneOf(['text', 'outlined'])
} : void 0;
var PaginationItem$1 = withStyles(styles$1, {
  name: 'MuiPaginationItem'
})(PaginationItem);

var styles = {
  /* Styles applied to the root element. */
  root: {},

  /* Styles applied to the ul element. */
  ul: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    padding: 0,
    margin: 0,
    listStyle: 'none'
  }
};

function defaultGetAriaLabel(type, page, selected) {
  if (type === 'page') {
    return "".concat(selected ? '' : 'Go to ', "page ").concat(page);
  }

  return "Go to ".concat(type, " page");
}

var Pagination = /*#__PURE__*/React.forwardRef(function Pagination(props, ref) {
  props.boundaryCount;
      var classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'standard' : _props$color;
      props.count;
      props.defaultPage;
      props.disabled;
      var _props$getItemAriaLab = props.getItemAriaLabel,
      getItemAriaLabel = _props$getItemAriaLab === void 0 ? defaultGetAriaLabel : _props$getItemAriaLab;
      props.hideNextButton;
      props.hidePrevButton;
      props.onChange;
      props.page;
      var _props$renderItem = props.renderItem,
      renderItem = _props$renderItem === void 0 ? function (item) {
    return /*#__PURE__*/React.createElement(PaginationItem$1, item);
  } : _props$renderItem,
      _props$shape = props.shape,
      shape = _props$shape === void 0 ? 'round' : _props$shape;
      props.showFirstButton;
      props.showLastButton;
      props.siblingCount;
      var _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'text' : _props$variant,
      other = _objectWithoutProperties(props, ["boundaryCount", "classes", "className", "color", "count", "defaultPage", "disabled", "getItemAriaLabel", "hideNextButton", "hidePrevButton", "onChange", "page", "renderItem", "shape", "showFirstButton", "showLastButton", "siblingCount", "size", "variant"]);

  var _usePagination = usePagination(_extends({}, props, {
    componentName: 'Pagination'
  })),
      items = _usePagination.items;

  return /*#__PURE__*/React.createElement("nav", _extends({
    "aria-label": "pagination navigation",
    className: clsx(classes.root, className),
    ref: ref
  }, other), /*#__PURE__*/React.createElement("ul", {
    className: classes.ul
  }, items.map(function (item, index) {
    return /*#__PURE__*/React.createElement("li", {
      key: index
    }, renderItem(_extends({}, item, {
      color: color,
      'aria-label': getItemAriaLabel(item.type, item.page, item.selected),
      shape: shape,
      size: size,
      variant: variant
    })));
  })));
}); // @default tags synced with default values from usePagination

process.env.NODE_ENV !== "production" ? Pagination.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * Number of always visible pages at the beginning and end.
   * @default 1
   */
  boundaryCount: propTypes.number,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: propTypes.object,

  /**
   * @ignore
   */
  className: propTypes.string,

  /**
   * The active color.
   */
  color: propTypes.oneOf(['primary', 'secondary', 'standard']),

  /**
   * The total number of pages.
   * @default 1
   */
  count: propTypes.number,

  /**
   * The page selected by default when the component is uncontrolled.
   * @default 1
   */
  defaultPage: propTypes.number,

  /**
   * If `true`, the pagination component will be disabled.
   * @default false
   */
  disabled: propTypes.bool,

  /**
   * Accepts a function which returns a string value that provides a user-friendly name for the current page.
   *
   * For localization purposes, you can use the provided [translations](/guides/localization/).
   *
   * @param {string} type The link or button type to format ('page' | 'first' | 'last' | 'next' | 'previous'). Defaults to 'page'.
   * @param {number} page The page number to format.
   * @param {bool} selected If true, the current page is selected.
   * @returns {string}
   */
  getItemAriaLabel: propTypes.func,

  /**
   * If `true`, hide the next-page button.
   * @default false
   */
  hideNextButton: propTypes.bool,

  /**
   * If `true`, hide the previous-page button.
   * @default false
   */
  hidePrevButton: propTypes.bool,

  /**
   * Callback fired when the page is changed.
   *
   * @param {object} event The event source of the callback.
   * @param {number} page The page selected.
   */
  onChange: propTypes.func,

  /**
   * The current page.
   */
  page: propTypes.number,

  /**
   * Render the item.
   *
   * @param {PaginationRenderItemParams} params The props to spread on a PaginationItem.
   * @returns {ReactNode}
   */
  renderItem: propTypes.func,

  /**
   * The shape of the pagination items.
   */
  shape: propTypes.oneOf(['round', 'rounded']),

  /**
   * If `true`, show the first-page button.
   * @default false
   */
  showFirstButton: propTypes.bool,

  /**
   * If `true`, show the last-page button.
   * @default false
   */
  showLastButton: propTypes.bool,

  /**
   * Number of always visible pages before and after the current page.
   * @default 1
   */
  siblingCount: propTypes.number,

  /**
   * The size of the pagination component.
   */
  size: propTypes.oneOf(['large', 'medium', 'small']),

  /**
   * The variant to use.
   */
  variant: propTypes.oneOf(['outlined', 'text'])
} : void 0;
var Pagination$1 = withStyles(styles, {
  name: 'MuiPagination'
})(Pagination);

var useStyles = makeStyles(function () { return ({
    raiz: {
        position: 'relative'
    },
    paginacion: {
        position: 'absolute',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        bottom: '0',
        left: '50%',
        transform: 'translate(-50%, -50%)'
    }
}); });
var withPagination = function (ComponenteEnvuelto, tamano) {
    return function (props) {
        var classes = useStyles(props);
        var resultados = props.data;
        var verMas = props.verMas;
        var tamanoActual;
        if (typeof tamano == 'function') {
            tamanoActual = tamano(resultados);
        }
        else {
            tamanoActual = tamano;
        }
        var _a = useState([]), resultadosPorPagina = _a[0], setResultadosPorPagina = _a[1];
        var tamanoPagina = useState(tamanoActual)[0];
        var _b = useState(1), pagina = _b[0], setPagina = _b[1];
        var manejarCambioDePagina = function (paginaActual) {
            setPagina(paginaActual);
            if (Array.isArray(tamanoPagina)) {
                setResultadosPorPagina(tamanoPagina[paginaActual - 1]);
            }
            else {
                setResultadosPorPagina(resultados === null || resultados === void 0 ? void 0 : resultados.slice((paginaActual - 1) * tamanoPagina, ((paginaActual - 1) * tamanoPagina) + tamanoPagina));
            }
        };
        var numeroDePaginas = function () {
            if (Array.isArray(tamanoPagina)) {
                return tamanoPagina.length;
            }
            else {
                return Math.ceil(((resultados === null || resultados === void 0 ? void 0 : resultados.length) / tamanoPagina));
            }
        };
        React__default.useEffect(function () {
            if (Array.isArray(tamanoPagina)) {
                setResultadosPorPagina(tamanoPagina[pagina - 1]);
            }
            else {
                var resultadosPaginaInicial = resultados === null || resultados === void 0 ? void 0 : resultados.slice((pagina - 1) * tamanoPagina, ((pagina - 1) * tamanoPagina) + tamanoPagina);
                setResultadosPorPagina(resultadosPaginaInicial);
            }
        }, [resultados]);
        return (React__default.createElement("div", { className: classes.raiz },
            React__default.createElement(ComponenteEnvuelto, __assign$2({ resultadosPorPagina: resultadosPorPagina, verMas: verMas }, props)),
            numeroDePaginas() > 1 && (resultadosPorPagina === null || resultadosPorPagina === void 0 ? void 0 : resultadosPorPagina.length) > 0 &&
                React__default.createElement(Pagination$1, { className: classes.paginacion, count: numeroDePaginas(), defaultPage: 1, page: pagina, shape: "rounded", size: "small", 
                    // @ts-ignore
                    onChange: function (e, value) { return manejarCambioDePagina(value); } })));
    };
};

var componentError = {
    title: "Error",
    body: "Ha ocurrido un error en el componente, si el problema persiste póngase en contacto con el servicio informático"
};

var checkInputsIsInvalid = function (message, target) {
    if (!(target && typeof target.postMessage === 'function')) {
        return new Error('Error! Invalid target.');
    }
    if (!message) {
        return new Error('Error! Invalid message.');
    }
    return null;
};
var send = function (message, target, timeout, origin) {
    if (timeout === void 0) { timeout = 500; }
    if (origin === void 0) { origin = '*'; }
    return Promise.race([sendMessage(message, target, origin), timeoutPromise(timeout)]);
};
var timeoutPromise = function (timeout) { return new Promise(function (_resolve, reject) { setTimeout(function () { return reject(new Error('Timeout')); }, timeout); }); };
var sendMessage = function (message, target, origin) { return (new Promise(function (resolve, reject) {
    var error = checkInputsIsInvalid(message, target);
    if (error) {
        reject(error);
    }
    var _a = new MessageChannel(), port1 = _a.port1, port2 = _a.port2;
    port1.onmessage = function (event) {
        port1.close();
        resolve(event.data);
    };
    target.postMessage(message, origin, [port2]);
})); };
var channelMessage = { send: send };

function MessageSplash(props) {
    var titulo = props.titulo, descripcion = props.descripcion, _a = props.tipo, tipo = _a === void 0 ? "warning" : _a;
    var mensaje = {
        titulo: titulo,
        subtitulo: descripcion,
        tipo: tipo,
    };
    return React__default.createElement(Splash, { mensaje: mensaje });
}

export { Alert, App365Container, AppContainer, CustomizedDialog as Dialog, ErrorBoundary, Home, HomeWidget, HomeWidgetError, HomeWidgetVacio, IconAbajo, IconActualizar, IconAdd, IconAlertError, IconAlertInfo, IconAlertSuccess, IconAlertWarning, IconAlertas, IconArriba, IconAvisoInfo, IconBombilla, IconBuscar, IconCaja, IconCerrar, IconDerecha, IconEditar, IconEnlace, IconEnlaceExt, IconError, IconEstrella, IconExclamation, IconFlechaDerecha, IconIzquierda, IconLlaveInglesa, IconMensaje, IconMenu, IconMenuReducido, IconNovedad, IconOpciones, IconPapelera, IconPin, IconReloj, IconUnpin, Enlace as Link, MessageSplash, CustomModal as Modal, NotificacionCard, Portal, PortalContext, PortalMsal, PortalSplash, Splash, api, channelMessage, componentError, createCiaOrigenCookie, esGestiona, getAplicacionFromUrl, getCiaFromUrl, menuHelper, useMsal, withPagination };
//# sourceMappingURL=index.modern.js.map
